import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string | number; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

/** Account for a particular product */
export type Account = {
  __typename?: 'Account';
  /** Account Number */
  accountNumber?: Maybe<Scalars['String']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  allowInternalOnly?: Maybe<Scalars['Boolean']['output']>;
  autosaveBeneficiaries?: Maybe<Scalars['Boolean']['output']>;
  /** Account's indicative balance */
  balance?: Maybe<AccountBalance>;
  bannedPaymentRails?: Maybe<Array<Maybe<PaymentRail>>>;
  /** Account Bundle */
  bundle?: Maybe<AccountBundle>;
  cardTopupSupported?: Maybe<Scalars['Boolean']['output']>;
  closureReason?: Maybe<AccountClosureReason>;
  closureReasonDescription?: Maybe<Scalars['String']['output']>;
  /** Account Contract */
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cryptoTopupSupported?: Maybe<Scalars['Boolean']['output']>;
  cryptoWithdrawalSupported?: Maybe<Scalars['Boolean']['output']>;
  /** Currency in which account is lead */
  currency?: Maybe<Currency>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Direct Debit Mandates */
  directDebitMandates?: Maybe<Array<Maybe<DirectDebitMandate>>>;
  /** Direct Debit Mandates count */
  directDebitMandatesCount?: Maybe<Scalars['Int']['output']>;
  /** Documents associated with this contract */
  documents?: Maybe<Array<Maybe<Document>>>;
  dueRemindersCount?: Maybe<Scalars['Int']['output']>;
  enableDailyStatement?: Maybe<Scalars['Boolean']['output']>;
  /** actionType */
  executionAction?: Maybe<Action>;
  executionActions?: Maybe<Array<Maybe<Action>>>;
  externalOutboundDisabled?: Maybe<Scalars['Boolean']['output']>;
  feeGroup?: Maybe<FeeGroup>;
  fundsType?: Maybe<FundsType>;
  /** Alternative Account (Beneficiary) - only for Deposit Guaranteed accounts */
  guaranteedAccountBeneficiary?: Maybe<ContractPaymentRecipient>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** IBAN */
  iban?: Maybe<Scalars['String']['output']>;
  /** Account ID */
  id?: Maybe<Scalars['ID']['output']>;
  isPendingDeactivated?: Maybe<Scalars['Boolean']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  /** Is Account Client Safe Guarding */
  isSafeGuarding?: Maybe<Scalars['Boolean']['output']>;
  /** Is Account Virtual */
  isVirtual?: Maybe<Scalars['Boolean']['output']>;
  /** Alias for alias -_- */
  name?: Maybe<Scalars['String']['output']>;
  /** Next Re-Calculation Date - only for Deposit Guaranteed accounts */
  nextRecalculationDate?: Maybe<Scalars['Date']['output']>;
  oursChargesSupportedCurrencies?: Maybe<Array<Maybe<Currency>>>;
  /** Parent Account ID */
  parentId?: Maybe<Scalars['ID']['output']>;
  paymentRecipients?: Maybe<Array<Maybe<ContractPaymentRecipient>>>;
  preferredFxPaymentRails?: Maybe<Scalars['JSON']['output']>;
  preferredPaymentRail?: Maybe<PaymentRail>;
  qrrSupported?: Maybe<Scalars['Boolean']['output']>;
  restrictedTo?: Maybe<Array<Maybe<ContractAuthorizedPersonType>>>;
  settlementSweepRule?: Maybe<AccountSettlementSweepRule>;
  showFullInfo?: Maybe<Scalars['Boolean']['output']>;
  spendingLimits?: Maybe<Array<SpendingLimitType>>;
  standingOrders?: Maybe<Array<Maybe<StandingOrder>>>;
  standingOrdersCount: Scalars['Int']['output'];
  status?: Maybe<AccountStatus>;
  swiftBIC?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Account Transactions */
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  type?: Maybe<AccountType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  useDirectInboundRoute?: Maybe<Scalars['Boolean']['output']>;
  useFItoFI?: Maybe<Scalars['Boolean']['output']>;
  virtualDetails?: Maybe<VirtualAccountDetails>;
  /** @deprecated deprecated, use balance field */
  withheldBalance?: Maybe<Scalars['Float']['output']>;
};


/** Account for a particular product */
export type AccountBalanceArgs = {
  withVirtual?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Account for a particular product */
export type AccountDirectDebitMandatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  status?: InputMaybe<Array<InputMaybe<DirectDebitMandateStatus>>>;
  type?: InputMaybe<Array<InputMaybe<TransactionEntryType>>>;
};


/** Account for a particular product */
export type AccountDirectDebitMandatesCountArgs = {
  status?: InputMaybe<Array<InputMaybe<DirectDebitMandateStatus>>>;
  type?: InputMaybe<Array<InputMaybe<TransactionEntryType>>>;
};


/** Account for a particular product */
export type AccountDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/** Account for a particular product */
export type AccountPaymentRecipientsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/** Account for a particular product */
export type AccountSpendingLimitsArgs = {
  status?: InputMaybe<Array<SpendingLimitStatusType>>;
  type?: InputMaybe<SpendingLimitTypeType>;
};


/** Account for a particular product */
export type AccountStandingOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/** Account for a particular product */
export type AccountTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/** Account for a particular product */
export type AccountTransactionsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  batchId?: InputMaybe<Scalars['ID']['input']>;
  cardFilter?: InputMaybe<TransactionCardFilter>;
  cardId?: InputMaybe<Scalars['ID']['input']>;
  clientReference?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  cumulativeReviewStatuses?: InputMaybe<Array<InputMaybe<TransactionCumulativeReviewStatus>>>;
  currencies?: InputMaybe<Array<InputMaybe<Currency>>>;
  entryTypes?: InputMaybe<Array<InputMaybe<TransactionEntryType>>>;
  executedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  executedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  hasSar?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupportingDocument?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeSubAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  internalTransferType?: InputMaybe<InternalTransferType>;
  isReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notContractIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notInternalTransferTypes?: InputMaybe<Array<InputMaybe<InternalTransferType>>>;
  notStatuses?: InputMaybe<Array<InputMaybe<TransactionStatus>>>;
  notTypes?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  paymentRails?: InputMaybe<Array<InputMaybe<PaymentRail>>>;
  payoutCurrencies?: InputMaybe<Array<InputMaybe<Currency>>>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  pendingPostReview?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<TransactionStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  valueFrom?: InputMaybe<Scalars['Float']['input']>;
  valueTo?: InputMaybe<Scalars['Float']['input']>;
  walletId?: InputMaybe<Scalars['String']['input']>;
};

export type AccountAction = BaseAction & {
  __typename?: 'AccountAction';
  account?: Maybe<Account>;
  alternativeAccountDetails?: Maybe<SwiftTransferIndividualPartyDetails>;
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type AccountActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export type AccountBalance = {
  __typename?: 'AccountBalance';
  amlFrozen?: Maybe<Scalars['Float']['output']>;
  available?: Maybe<Scalars['Float']['output']>;
  guaranteed?: Maybe<Scalars['Float']['output']>;
  indicative?: Maybe<Scalars['Float']['output']>;
  reserves?: Maybe<AccountBalanceReserves>;
  virtual?: Maybe<AccountBalance>;
};

export type AccountBalanceReserves = {
  __typename?: 'AccountBalanceReserves';
  directDebit?: Maybe<Scalars['Float']['output']>;
};

export type AccountBalanceSnapshot = {
  __typename?: 'AccountBalanceSnapshot';
  /** account */
  account?: Maybe<Account>;
  asAt?: Maybe<Scalars['DateTime']['output']>;
  /** balanceSnapshot */
  balanceSnapshot?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Guaranteed balance snapshot */
  guaranteedBalanceSnapshot?: Maybe<Scalars['Float']['output']>;
  /** id */
  id: Scalars['ID']['output'];
  /** Eod reporting date */
  reportingDate?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountBundle = {
  __typename?: 'AccountBundle';
  /** accounts */
  accounts?: Maybe<Array<Maybe<Account>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** id */
  id: Scalars['ID']['output'];
  /** name */
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Account Check log */
export type AccountCheckLog = BaseLogInterface & {
  __typename?: 'AccountCheckLog';
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** GBGCheckResult */
  gbgCheckResult?: Maybe<Scalars['String']['output']>;
  /** GBGCheckStatus */
  gbgStatus?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** SkrillVerificationResult */
  skrillVerificationResult?: Maybe<Scalars['String']['output']>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

export type AccountClosureFundRemittanceApprovalRequest = BaseApprovalRequest & {
  __typename?: 'AccountClosureFundRemittanceApprovalRequest';
  account?: Maybe<Account>;
  affectedEntity?: Maybe<Scalars['String']['output']>;
  affectedEntityId?: Maybe<Scalars['ID']['output']>;
  approvals?: Maybe<Array<Maybe<UserRequestApprovalType>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  executionError?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  requestType?: Maybe<ApprovalRequestType>;
  setting?: Maybe<ApprovalRequestSetting>;
  status?: Maybe<ApprovalRequestStatus>;
  transactionInfo?: Maybe<FundRemittanceInfo>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum AccountClosureReason {
  ClientRequest = 'clientRequest',
  DeclaredPep = 'declaredPep',
  DuplicateAccount = 'duplicateAccount',
  DuplicateProfile = 'duplicateProfile',
  Fraud = 'fraud',
  MissingKycDoc = 'missingKycDoc',
  MissingProofAddress = 'missingProofAddress',
  MissingProofOfId = 'missingProofOfId',
  MissingProofOfPayment = 'missingProofOfPayment',
  NonAcceptableCountry = 'nonAcceptableCountry',
  NonCompliance = 'nonCompliance',
  Other = 'other',
  ThirdPartyTransaction = 'thirdPartyTransaction',
  UnderagedClient = 'underagedClient'
}

export type AccountLog = BaseLogInterface & {
  __typename?: 'AccountLog';
  /** Account linked with ActivityLog */
  account?: Maybe<Account>;
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

export type AccountManualBookingApprovalRequest = BaseApprovalRequest & {
  __typename?: 'AccountManualBookingApprovalRequest';
  account?: Maybe<Account>;
  affectedEntity?: Maybe<Scalars['String']['output']>;
  affectedEntityId?: Maybe<Scalars['ID']['output']>;
  approvals?: Maybe<Array<Maybe<UserRequestApprovalType>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  executionError?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  manualBookingInfo?: Maybe<ManualBookingInfo>;
  requestType?: Maybe<ApprovalRequestType>;
  setting?: Maybe<ApprovalRequestSetting>;
  status?: Maybe<ApprovalRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum AccountNoType {
  AccountNumber = 'accountNumber',
  CardNo = 'cardNo',
  Checking = 'checking',
  Iban = 'iban',
  Saving = 'saving',
  WalletId = 'walletId'
}

/** Account QR Bill Types */
export enum AccountQrBillType {
  Pdf = 'pdf',
  Svg = 'svg'
}

export type AccountSettlementSweepRule = {
  __typename?: 'AccountSettlementSweepRule';
  matchTransactionAccountId?: Maybe<Scalars['String']['output']>;
  referenceMatch?: Maybe<Scalars['String']['output']>;
  settlementLedger?: Maybe<Ledger>;
};

export type AccountStatement = {
  __typename?: 'AccountStatement';
  async?: Maybe<Scalars['Boolean']['output']>;
  result?: Maybe<Scalars['String']['output']>;
};

export enum AccountStatementType {
  Csv = 'csv',
  Mt940 = 'mt940',
  Mt940Download = 'mt940Download',
  Pdf = 'pdf'
}

export enum AccountStatus {
  Active = 'active',
  Closed = 'closed',
  Frozen = 'frozen',
  Monitoring = 'monitoring',
  PendingApproval = 'pendingApproval',
  PendingClosureSignatures = 'pendingClosureSignatures',
  PendingIncomingPayment = 'pendingIncomingPayment',
  PendingOpeningSignatures = 'pendingOpeningSignatures',
  Rejected = 'rejected',
  Suspended = 'suspended',
  TechnicalMonitoring = 'technicalMonitoring'
}

export enum AccountType {
  DepositGuaranteed = 'depositGuaranteed',
  IntroducerReference = 'introducerReference',
  StandardCurrent = 'standardCurrent'
}

export type Action = AccountAction | AddContractAuthorizedPersonRequestAction | BatchPaymentActionType | CardIssueRequestAction | ContractAuthorizedPersonDeactivationAction | ContractChangeAction | ContractTerminationAction | CryptoTransactionSigningAction | DirectDebitAction | DirectDebitBatchRequestActionType | DirectDebitDisputeAction | DirectDebitRevertRequestAction | DocumentAction | RefundPaymentRequestAction | SpendingLimitRequestAction | StandingOrderActionType | TermsAndConditionsSigningAction | TransactionAction | TwoFaOperationActionLike | UpdateSpendingLimitAction | VibanNameMismatchAction | WalletAction;

/** Action Initiator (User/Individual/ApiUser) */
export type ActionInitiator = ApiUser | Individual | User;

export type ActionLog = BaseLogInterface & {
  __typename?: 'ActionLog';
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

export enum ActionRejectionReason {
  Cancelled = 'cancelled',
  Inactivity = 'inactivity',
  NoSignatories = 'noSignatories',
  NotEnoughSignatures = 'notEnoughSignatures',
  Other = 'other',
  Rejected = 'rejected'
}

export type ActionSignature = {
  __typename?: 'ActionSignature';
  action: Action;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isMine?: Maybe<Scalars['Boolean']['output']>;
  signatory?: Maybe<ContractAuthorizedPersonType>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  signingMethod?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ActionSignatureStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Which field to order the query results by */
export enum ActionSignatureRequestsOrderBy {
  CreatedAt = 'createdAt',
  Id = 'id',
  SignedAt = 'signedAt'
}

export enum ActionSignatureStatus {
  Accept = 'accept',
  Expired = 'expired',
  Pending = 'pending',
  Reject = 'reject'
}

export enum ActionStatus {
  Executed = 'executed',
  PendingSignatures = 'pendingSignatures',
  Rejected = 'rejected',
  SignaturesQuorumReached = 'signaturesQuorumReached'
}

export enum ActionType {
  AccountClosureSigning = 'accountClosureSigning',
  AccountOpeningSigning = 'accountOpeningSigning',
  ActivateStandingOrder = 'activateStandingOrder',
  ApproveDirectDebitB2BDebitMandate = 'approveDirectDebitB2BDebitMandate',
  ApproveDirectDebitCreditMandate = 'approveDirectDebitCreditMandate',
  BatchPayment = 'batchPayment',
  CancelStandingOrder = 'cancelStandingOrder',
  CardIssueRequest = 'cardIssueRequest',
  ChangeAccountAlternativeAccountDetailsRequest = 'changeAccountAlternativeAccountDetailsRequest',
  ContractAuthorizedPersonDeactivation = 'contractAuthorizedPersonDeactivation',
  ContractAuthorizedPersonRequest = 'contractAuthorizedPersonRequest',
  ContractDetailChangeSigning = 'contractDetailChangeSigning',
  ContractTerminationRequest = 'contractTerminationRequest',
  CryptoTransactionSigning = 'cryptoTransactionSigning',
  DirectDebitBatchRequest = 'directDebitBatchRequest',
  DisputeDirectDebit = 'disputeDirectDebit',
  DocumentSigning = 'documentSigning',
  PaymentRefundRequest = 'paymentRefundRequest',
  PreapproveDirectDebit = 'preapproveDirectDebit',
  RejectDirectDebit = 'rejectDirectDebit',
  RevertDirectDebitRequest = 'revertDirectDebitRequest',
  SpendingLimitRequest = 'spendingLimitRequest',
  TermsAndConditionsSigning = 'termsAndConditionsSigning',
  TransactionSigning = 'transactionSigning',
  TwoFa = 'twoFA',
  UpdateSpendingLimit = 'updateSpendingLimit',
  VibanNameMismatch = 'vibanNameMismatch',
  WalletSigning = 'walletSigning'
}

/** Which field to order the query results by */
export enum ActionsOrderBy {
  CreatedAt = 'createdAt',
  Id = 'id',
  Status = 'status',
  Type = 'type'
}

/** Log of an actions made either by a user or a client */
export type ActivityLog = AccountCheckLog | AccountLog | ActionLog | AgentLog | ComplianceLog | ContractLog | DiffLog | FeeGroupLog | GenericLog | KycStatusLog | LedgerLog | LedgerTransactionLog | Note | TransactionLog | UnderMonitoringLog | UserActionLog | WithReasonLog;

/** Possible types of ActivityLog objects */
export enum ActivityLogObjectType {
  Account = 'account',
  Blacklist = 'blacklist',
  ContractInformationRequest = 'contractInformationRequest',
  DirectDebitMandate = 'directDebitMandate',
  Document = 'document',
  DueDiligence = 'dueDiligence',
  FeeGroup = 'feeGroup',
  Individual = 'individual',
  Ledger = 'ledger',
  LedgerTransaction = 'ledgerTransaction',
  PaymentRailConfig = 'paymentRailConfig',
  PaymentRailRouteConfig = 'paymentRailRouteConfig',
  ProfileChange = 'profileChange',
  StandingOrder = 'standingOrder',
  Transaction = 'transaction',
  TransactionRequest = 'transactionRequest',
  User = 'user'
}

/** Possible ActivityLog origins */
export enum ActivityLogOrigin {
  ApiUser = 'apiUser',
  Individual = 'individual',
  User = 'user'
}

/** Possible ActivityLog types */
export enum ActivityLogType {
  AcceptApprovalRequest = 'acceptApprovalRequest',
  AcceptedAction = 'acceptedAction',
  AcceptedIncomingTransactionCreditorNameMismatch = 'acceptedIncomingTransactionCreditorNameMismatch',
  ActivatedCard = 'activatedCard',
  AddCard = 'addCard',
  AddContractTechnicalProperties = 'addContractTechnicalProperties',
  AddContractToGroup = 'addContractToGroup',
  AddEntityReminder = 'addEntityReminder',
  AddIssueForAmlo = 'addIssueForAMLO',
  AddIssueForPeriodicReview = 'addIssueForPeriodicReview',
  AddUser = 'addUser',
  AddedAccountBundle = 'addedAccountBundle',
  AddedAccountToBundle = 'addedAccountToBundle',
  AddedBankableEntityAuthControllingPerson = 'addedBankableEntityAuthControllingPerson',
  AddedBankableEntityUbo = 'addedBankableEntityUbo',
  AddedContractAuthorizedPersonRequest = 'addedContractAuthorizedPersonRequest',
  AddedContractCorrespondenceEmail = 'addedContractCorrespondenceEmail',
  AddedContractGroup = 'addedContractGroup',
  AddedContractPaymentRecipient = 'addedContractPaymentRecipient',
  AddedContractPeriodicReview = 'addedContractPeriodicReview',
  AddedLegalEntityDirector = 'addedLegalEntityDirector',
  AddedSignatureSpecimen = 'addedSignatureSpecimen',
  AddedTransactionSupportingDocument = 'addedTransactionSupportingDocument',
  AddedUboOwner = 'addedUboOwner',
  AllowVbanCreation = 'allowVbanCreation',
  ApprovalRequestRejected = 'approvalRequestRejected',
  ApproveCardTransaction = 'approveCardTransaction',
  ApproveDocument = 'approveDocument',
  ApproveProfileChange = 'approveProfileChange',
  ApprovedAccountClosureFinalRemittanceApprovalRequest = 'approvedAccountClosureFinalRemittanceApprovalRequest',
  ApprovedDirectDebitDispute = 'approvedDirectDebitDispute',
  ApprovedManualAccountBookingApprovalRequest = 'approvedManualAccountBookingApprovalRequest',
  AssignClientAgent = 'assignClientAgent',
  AssigneeDocument = 'assigneeDocument',
  AssociateContracts = 'associateContracts',
  AssociateIndividuals = 'associateIndividuals',
  BatchPaymentCreated = 'batchPaymentCreated',
  BatchPaymentExecuted = 'batchPaymentExecuted',
  BookedIncomingSwiftToLedger = 'bookedIncomingSwiftToLedger',
  BookedLedgerTransaction = 'bookedLedgerTransaction',
  Call = 'call',
  CancelStandingOrder = 'cancelStandingOrder',
  CancelStandingOrderRejected = 'cancelStandingOrderRejected',
  CancelledTransaction = 'cancelledTransaction',
  CardCreditVoucherTransaction = 'cardCreditVoucherTransaction',
  CardTerminated = 'cardTerminated',
  CardTransactionCancellationReverted = 'cardTransactionCancellationReverted',
  CardTransactionCancelled = 'cardTransactionCancelled',
  CardTransactionCleared = 'cardTransactionCleared',
  CardTransactionReturned = 'cardTransactionReturned',
  CardUpdated = 'cardUpdated',
  ChangeContractGeneralNote = 'changeContractGeneralNote',
  ChangeHasProfessionalTreasuryDepartment = 'changeHasProfessionalTreasuryDepartment',
  ChangeIndividualGeneralNote = 'changeIndividualGeneralNote',
  ChangeIsSubjectToPrudentialRegulation = 'changeIsSubjectToPrudentialRegulation',
  ChangePin = 'changePin',
  ChangeSettings = 'changeSettings',
  ChangeSwiftConversationGeneralNote = 'changeSwiftConversationGeneralNote',
  ChangeTransactionRecurringMarker = 'changeTransactionRecurringMarker',
  ChangeVerifiedEmail = 'changeVerifiedEmail',
  ChangeVerifiedPhone = 'changeVerifiedPhone',
  ChangedContracKycMeasures = 'changedContracKycMeasures',
  ChangedContractAuthPersonStatus = 'changedContractAuthPersonStatus',
  ChangedContractFeeGroup = 'changedContractFeeGroup',
  ChangedContractFinancialStatements = 'changedContractFinancialStatements',
  ChangedContractFundFlowDescription = 'changedContractFundFlowDescription',
  ChangedContractProducts = 'changedContractProducts',
  ChangedContractRiskCategory = 'changedContractRiskCategory',
  ChangedPrimary2FaMethod = 'changedPrimary2FAMethod',
  ChangedTransactionCumulativeReviewStatus = 'changedTransactionCumulativeReviewStatus',
  ChargeFee = 'chargeFee',
  ChargeManualFee = 'chargeManualFee',
  ClaimClientAgent = 'claimClientAgent',
  ClientHasDifferentIpCountry = 'clientHasDifferentIpCountry',
  ClientHasSameLastnameAndDob = 'clientHasSameLastnameAndDob',
  ClientHasSamePhoneNumber = 'clientHasSamePhoneNumber',
  ClientLoginSuccess = 'clientLoginSuccess',
  ClientVideoVerificationCompleted = 'clientVideoVerificationCompleted',
  ClonedFeeGroup = 'clonedFeeGroup',
  ClosedAccount = 'closedAccount',
  CommunicationStatusChanged = 'communicationStatusChanged',
  CompletedSuccessFeePayout = 'completedSuccessFeePayout',
  ConfirmOwnEmail = 'confirmOwnEmail',
  ContractChangeRequested = 'contractChangeRequested',
  ContractSuspiciousActivityReported = 'contractSuspiciousActivityReported',
  ContractTerminated = 'contractTerminated',
  ContractTerminationPending = 'contractTerminationPending',
  ContractTerminationRequest = 'contractTerminationRequest',
  ContractTerminationRequestRejected = 'contractTerminationRequestRejected',
  CoveredNegativeBalance = 'coveredNegativeBalance',
  CreateContractDocument = 'createContractDocument',
  CreateCustomerRequestForAccountOpening = 'createCustomerRequestForAccountOpening',
  CreateCustomerRequestForPendingInvitation = 'createCustomerRequestForPendingInvitation',
  CreateCustomerRequestForSwiftThread = 'createCustomerRequestForSwiftThread',
  CreateCustomerRequestForTransaction = 'createCustomerRequestForTransaction',
  CreateCustomerRequestForWallet = 'createCustomerRequestForWallet',
  CreateDocument = 'createDocument',
  CreateNewContractInformationRequest = 'createNewContractInformationRequest',
  CreateOwnDocument = 'createOwnDocument',
  CreatePaymentRailConfig = 'createPaymentRailConfig',
  CreateStandingOrder = 'createStandingOrder',
  CreatedAccount = 'createdAccount',
  CreatedAccountClosureFinalRemittanceApprovalRequest = 'createdAccountClosureFinalRemittanceApprovalRequest',
  CreatedApiUser = 'createdApiUser',
  CreatedBankableEntityContract = 'createdBankableEntityContract',
  CreatedCardAdjustmentTransactionApprovalRequest = 'createdCardAdjustmentTransactionApprovalRequest',
  CreatedCustomerSupportRequest = 'createdCustomerSupportRequest',
  CreatedFeeReversalApprovalRequest = 'createdFeeReversalApprovalRequest',
  CreatedIntroducerReferenceContract = 'createdIntroducerReferenceContract',
  CreatedManualAccountBookingApprovalRequest = 'createdManualAccountBookingApprovalRequest',
  CreatedPaymentRailRouteConfig = 'createdPaymentRailRouteConfig',
  CreatedQrBill = 'createdQRBill',
  CreatedSwiftMessage = 'createdSwiftMessage',
  CreatedTransaction = 'createdTransaction',
  CreatedVoidTransactionApprovalRequest = 'createdVoidTransactionApprovalRequest',
  CreditedIncomingSwiftTransactionToAccount = 'creditedIncomingSwiftTransactionToAccount',
  CryptoTransactionConfirmed = 'cryptoTransactionConfirmed',
  CryptoWalletLinkedToContract = 'cryptoWalletLinkedToContract',
  DeactivateAuthorizedPerson = 'deactivateAuthorizedPerson',
  DeactivateAuthorizedPersonRequest = 'deactivateAuthorizedPersonRequest',
  DeclineCardTransaction = 'declineCardTransaction',
  DeleteContractContact = 'deleteContractContact',
  DeleteEntityReminder = 'deleteEntityReminder',
  DeletedAccount = 'deletedAccount',
  DeletedPaymentRailRouteConfig = 'deletedPaymentRailRouteConfig',
  DirectDebitBatchPaymentCreated = 'directDebitBatchPaymentCreated',
  DirectDebitBaymentExecuted = 'directDebitBaymentExecuted',
  DirectDebitRevertRequest = 'directDebitRevertRequest',
  DisputeDirectDebit = 'disputeDirectDebit',
  DissociateContracts = 'dissociateContracts',
  DissociateIndividuals = 'dissociateIndividuals',
  DocumentSigningComplete = 'documentSigningComplete',
  DownloadIbanCertificate = 'downloadIbanCertificate',
  DrainLedgerOnDemandDrain = 'drainLedgerOnDemandDrain',
  EditContractTechnicalProperties = 'editContractTechnicalProperties',
  EditDocumentDetails = 'editDocumentDetails',
  EditPaymentCredentials = 'editPaymentCredentials',
  EditUserInfo = 'editUserInfo',
  EditedAccount = 'editedAccount',
  EditedFeeGroup = 'editedFeeGroup',
  ErroneousCancelledCardTransactionCleared = 'erroneousCancelledCardTransactionCleared',
  ExchangedCryptoTransaction = 'exchangedCryptoTransaction',
  ExecutedAction = 'executedAction',
  ExecutedCardAdjustmentTransactionApprovalRequest = 'executedCardAdjustmentTransactionApprovalRequest',
  ExecutedCryptoTransaction = 'executedCryptoTransaction',
  ExecutedFeeReversalApprovalRequest = 'executedFeeReversalApprovalRequest',
  ExecutedSuccessFeePayout = 'executedSuccessFeePayout',
  ExecutedTransaction = 'executedTransaction',
  ExecutedVoidTransactionApprovalRequest = 'executedVoidTransactionApprovalRequest',
  FinalizedTotpSetup = 'finalizedTOTPSetup',
  FreezeCard = 'freezeCard',
  GenerateContractAccountsConfirmation = 'generateContractAccountsConfirmation',
  GetAccountCancellationReport = 'getAccountCancellationReport',
  GetAccountStatement = 'getAccountStatement',
  Handle3dsAuthentication = 'handle3dsAuthentication',
  IncomingTransactionCreditorNameMismatch = 'incomingTransactionCreditorNameMismatch',
  IncomingTransactionFlaggedForAmlReview = 'incomingTransactionFlaggedForAMLReview',
  IncomingTransactionNameMismatch = 'incomingTransactionNameMismatch',
  InitiatedAction = 'initiatedAction',
  InitiatedTotpSetup = 'initiatedTOTPSetup',
  IpSrcTrackingInformation = 'ipSrcTrackingInformation',
  LedgerDrained = 'ledgerDrained',
  LockUnlockDocument = 'lockUnlockDocument',
  LogUserLoggedIn = 'logUserLoggedIn',
  MarkDocumentAsInternal = 'markDocumentAsInternal',
  MarkedUnMarkedContractAsKey = 'markedUnMarkedContractAsKey',
  MobileActivateDevice = 'mobileActivateDevice',
  MobileDeleteDevice = 'mobileDeleteDevice',
  MobileLogin = 'mobileLogin',
  ModifiedFileBasedPainAccess = 'modifiedFileBasedPainAccess',
  ModifyAuthorizedCardTransaction = 'modifyAuthorizedCardTransaction',
  Note = 'note',
  PasswordResetSuccessfully = 'passwordResetSuccessfully',
  PayCashback = 'payCashback',
  PayCommission = 'payCommission',
  PinDocument = 'pinDocument',
  PinnedAccount = 'pinnedAccount',
  Process2FaOperation = 'process2FAOperation',
  ProcessedTransferContractOwnership = 'processedTransferContractOwnership',
  RanElectronicIdVerificationCheck = 'ranElectronicIdVerificationCheck',
  RecalculateContractSuccessFees = 'recalculateContractSuccessFees',
  Registered = 'registered',
  RejectApprovalRequest = 'rejectApprovalRequest',
  RejectDirectDebit = 'rejectDirectDebit',
  RejectDocument = 'rejectDocument',
  RejectProfileChange = 'rejectProfileChange',
  RejectedAccountClosureFinalRemittanceApprovalRequest = 'rejectedAccountClosureFinalRemittanceApprovalRequest',
  RejectedAction = 'rejectedAction',
  RejectedDirectDebitDispute = 'rejectedDirectDebitDispute',
  RejectedFeeReversalApprovalRequest = 'rejectedFeeReversalApprovalRequest',
  RejectedManualAccountBookingApprovalRequest = 'rejectedManualAccountBookingApprovalRequest',
  RejectedSuccessFeePayout = 'rejectedSuccessFeePayout',
  RemoveDocument = 'removeDocument',
  RemoveMinimumTurnover = 'removeMinimumTurnover',
  RemoveRestrictAuthorizedPersonToAccounts = 'removeRestrictAuthorizedPersonToAccounts',
  RemoveTag = 'removeTag',
  RemovedAccountBundle = 'removedAccountBundle',
  RemovedAccountFromBundle = 'removedAccountFromBundle',
  RemovedBankableEntityAuthControllingPerson = 'removedBankableEntityAuthControllingPerson',
  RemovedBankableEntityContract = 'removedBankableEntityContract',
  RemovedBankableEntityUbo = 'removedBankableEntityUbo',
  RemovedContractFromGroup = 'removedContractFromGroup',
  RemovedContractGroup = 'removedContractGroup',
  RemovedContractInformationRequest = 'removedContractInformationRequest',
  RemovedContractPaymentRecipient = 'removedContractPaymentRecipient',
  RemovedLegalEntityDirector = 'removedLegalEntityDirector',
  RemovedUboOwner = 'removedUboOwner',
  RenamedAccountBundle = 'renamedAccountBundle',
  ReplacedSignatureSpecimen = 'replacedSignatureSpecimen',
  RequestCard = 'requestCard',
  RequestedAccountClosure = 'requestedAccountClosure',
  RequestedActionSigningCode = 'requestedActionSigningCode',
  RequestedPhoneVerificationCode = 'requestedPhoneVerificationCode',
  RequestedTransferContractOwnership = 'requestedTransferContractOwnership',
  RequestedVideoVerificationUrl = 'requestedVideoVerificationUrl',
  ResendReturnLedgerTransactionMessage = 'resendReturnLedgerTransactionMessage',
  Reset2FaAttempts = 'reset2FaAttempts',
  ResetClientPassword = 'resetClientPassword',
  ResolveIncomingTransactionNameMismatch = 'resolveIncomingTransactionNameMismatch',
  ResolvedTransactionDestination = 'resolvedTransactionDestination',
  RestrictAuthorizedPersonToAccounts = 'restrictAuthorizedPersonToAccounts',
  ReturnLedgerTransaction = 'returnLedgerTransaction',
  ReturnedTransaction = 'returnedTransaction',
  RevertDocument = 'revertDocument',
  RevertedLedgerTransaction = 'revertedLedgerTransaction',
  SendClientSecurityCode = 'sendClientSecurityCode',
  SendVerificationInvitation = 'sendVerificationInvitation',
  SentSepaClaimNoReceiptMessage = 'sentSEPAClaimNoReceiptMessage',
  SetAccountDailyStatement = 'setAccountDailyStatement',
  SetActionSignaturesToExpired = 'setActionSignaturesToExpired',
  SetCardLimits = 'setCardLimits',
  SetClientKycStatus = 'setClientKycStatus',
  SetContractAutoApprovalCheckStatuses = 'setContractAutoApprovalCheckStatuses',
  SetContractRiskProfile = 'setContractRiskProfile',
  SetContractStatementDeliveryBic = 'setContractStatementDeliveryBic',
  SetContractStatus = 'setContractStatus',
  SetDesignatedFeeAccount = 'setDesignatedFeeAccount',
  SetDesignatedNbcAccount = 'setDesignatedNbcAccount',
  SetFeeGroupForAccount = 'setFeeGroupForAccount',
  SetHasPendingInvestigation = 'setHasPendingInvestigation',
  SetOptInSms = 'setOptInSms',
  SetOptinMarketing = 'setOptinMarketing',
  SetUpLedgerDrain = 'setUpLedgerDrain',
  SetupFileBasedPainAccess = 'setupFileBasedPainAccess',
  SignedAction = 'signedAction',
  SpendingLimitRequest = 'spendingLimitRequest',
  SubmitForPreAssessment = 'submitForPreAssessment',
  SubmittedBankableEntityContract = 'submittedBankableEntityContract',
  ToggleAccountHidden = 'toggleAccountHidden',
  ToggleAccountUseFItoFi = 'toggleAccountUseFItoFI',
  ToggleAllowInternalOnly = 'toggleAllowInternalOnly',
  ToggleAuthorizedPersonSignNewUserActions = 'toggleAuthorizedPersonSignNewUserActions',
  ToggleAuthorizedPersonSignOwnActions = 'toggleAuthorizedPersonSignOwnActions',
  ToggleCcDedicatedAcm = 'toggleCcDedicatedAcm',
  ToggleClientSafeguardAccount = 'toggleClientSafeguardAccount',
  ToggleCrsReportable = 'toggleCrsReportable',
  ToggleCryptoPayments = 'toggleCryptoPayments',
  ToggleEconomicProfile = 'toggleEconomicProfile',
  ToggleEmailConfirmed = 'toggleEmailConfirmed',
  ToggleEntityPublicInfo = 'toggleEntityPublicInfo',
  ToggleEntityReputationalRisk = 'toggleEntityReputationalRisk',
  ToggleExemptFromNbc = 'toggleExemptFromNbc',
  ToggleFatcaReportable = 'toggleFatcaReportable',
  ToggleForceHold = 'toggleForceHold',
  ToggleIndividualVerified = 'toggleIndividualVerified',
  ToggleIntroducingPartner = 'toggleIntroducingPartner',
  ToggleIsPhoneVerified = 'toggleIsPhoneVerified',
  ToggleMobilePreferences = 'toggleMobilePreferences',
  ToggleOtpViaApi = 'toggleOTPViaApi',
  ToggleTransactionReview = 'toggleTransactionReview',
  ToogleAcknowledgedExpiredDocument = 'toogleAcknowledgedExpiredDocument',
  ToogleIsPep = 'toogleIsPep',
  TransactionAdditionalInfoUpdated = 'transactionAdditionalInfoUpdated',
  TransactionAuthorizedForFx = 'transactionAuthorizedForFX',
  TransactionCancellationRejected = 'transactionCancellationRejected',
  TransactionCancelled = 'transactionCancelled',
  TransactionClearedForAml = 'transactionClearedForAML',
  TransactionCorrespondentInfoUpdated = 'transactionCorrespondentInfoUpdated',
  TransactionCounterPartyAddressModified = 'transactionCounterPartyAddressModified',
  TransactionFxExecuted = 'transactionFXExecuted',
  TransactionFlaggedForAmlReview = 'transactionFlaggedForAMLReview',
  TransactionMessageAccepted = 'transactionMessageAccepted',
  TransactionMessageRejected = 'transactionMessageRejected',
  TransactionMessageReturned = 'transactionMessageReturned',
  TransactionMessageSent = 'transactionMessageSent',
  TransactionPayoutStatusChanged = 'transactionPayoutStatusChanged',
  TransactionPendingPayout = 'transactionPendingPayout',
  TransactionRequestClearedForAml = 'transactionRequestClearedForAML',
  TransactionRequestRejected = 'transactionRequestRejected',
  TransactionReturnProcessed = 'transactionReturnProcessed',
  TransactionReturnRequestProcessed = 'transactionReturnRequestProcessed',
  TransactionReturned = 'transactionReturned',
  TransactionReturnedRequested = 'transactionReturnedRequested',
  TransactionReverted = 'transactionReverted',
  TransactionSentForAml = 'transactionSentForAML',
  TransactionValueUpdated = 'transactionValueUpdated',
  TrustedDevice = 'trustedDevice',
  UnFreezeCard = 'unFreezeCard',
  UnMarkDocumentAsInternal = 'unMarkDocumentAsInternal',
  UnPinDocument = 'unPinDocument',
  UnassignClientAgent = 'unassignClientAgent',
  UnclaimClientAgent = 'unclaimClientAgent',
  UnderReviewProfileChange = 'underReviewProfileChange',
  UnpinnedAccount = 'unpinnedAccount',
  UpdateAccountStatus = 'updateAccountStatus',
  UpdateClientDetails = 'updateClientDetails',
  UpdateDedicatedAccountManager = 'updateDedicatedAccountManager',
  UpdateDocument = 'updateDocument',
  UpdateFcmToken = 'updateFCMToken',
  UpdateFundsType = 'updateFundsType',
  UpdateOwnDetails = 'updateOwnDetails',
  UpdateOwnEmail = 'updateOwnEmail',
  UpdateOwnPassword = 'updateOwnPassword',
  UpdateProfileEmailCategoriesSettings = 'updateProfileEmailCategoriesSettings',
  UpdateProfileSmsCategoriesSettings = 'updateProfileSMSCategoriesSettings',
  UpdateSpendingLimit = 'updateSpendingLimit',
  UpdateSwiftMessageAckStatus = 'updateSwiftMessageAckStatus',
  UpdatedApiUserAllowedIps = 'updatedApiUserAllowedIps',
  UpdatedApiUserSecret = 'updatedApiUserSecret',
  UpdatedApiUserStatus = 'updatedApiUserStatus',
  UpdatedBankableEntityAuthControllingPerson = 'updatedBankableEntityAuthControllingPerson',
  UpdatedBankableEntityContract = 'updatedBankableEntityContract',
  UpdatedBankableEntityUbo = 'updatedBankableEntityUbo',
  UpdatedCard3DsSetting = 'updatedCard3DSSetting',
  UpdatedCheckResult = 'updatedCheckResult',
  UpdatedContractCommisionSettings = 'updatedContractCommisionSettings',
  UpdatedContractGroup = 'updatedContractGroup',
  UpdatedContractInformationRequest = 'updatedContractInformationRequest',
  UpdatedContractKeyInformation = 'updatedContractKeyInformation',
  UpdatedContractPaymentRecipient = 'updatedContractPaymentRecipient',
  UpdatedCryptoWallet = 'updatedCryptoWallet',
  UpdatedFeeGroupSetting = 'updatedFeeGroupSetting',
  UpdatedLegalEntityDirector = 'updatedLegalEntityDirector',
  UpdatedPaymentRailConfig = 'updatedPaymentRailConfig',
  UpdatedPaymentRailRouteConfig = 'updatedPaymentRailRouteConfig',
  UpdatedPreassessment = 'updatedPreassessment',
  UpdatedReferrer = 'updatedReferrer',
  UpdatedSuccessFeePayout = 'updatedSuccessFeePayout',
  UpdatedUboOwner = 'updatedUboOwner',
  UpsertContractContact = 'upsertContractContact',
  UpsertMinimumTurnover = 'upsertMinimumTurnover',
  UpsertTag = 'upsertTag',
  User2FaEnabled = 'user2FaEnabled',
  UserAddedCheck = 'userAddedCheck',
  UserCreatedAccount = 'userCreatedAccount',
  UserDeletedCheck = 'userDeletedCheck',
  UserPerformedCheck = 'userPerformedCheck',
  UserUpdatedCheck = 'userUpdatedCheck',
  UserUpdatedCryptoWallet = 'userUpdatedCryptoWallet',
  VerifiedPhone = 'verifiedPhone',
  VibanNameMismatchResolved = 'vibanNameMismatchResolved',
  ViewCard3dsPassword = 'viewCard3dsPassword',
  ViewCardSensitiveInfo = 'viewCardSensitiveInfo'
}

export enum ActivityLogTypeType {
  AcceptApprovalRequest = 'acceptApprovalRequest',
  AcceptedAction = 'acceptedAction',
  AcceptedIncomingTransactionCreditorNameMismatch = 'acceptedIncomingTransactionCreditorNameMismatch',
  ActivatedCard = 'activatedCard',
  AddCard = 'addCard',
  AddContractTechnicalProperties = 'addContractTechnicalProperties',
  AddContractToGroup = 'addContractToGroup',
  AddEntityReminder = 'addEntityReminder',
  AddIssueForAmlo = 'addIssueForAMLO',
  AddIssueForPeriodicReview = 'addIssueForPeriodicReview',
  AddUser = 'addUser',
  AddedAccountBundle = 'addedAccountBundle',
  AddedAccountToBundle = 'addedAccountToBundle',
  AddedBankableEntityAuthControllingPerson = 'addedBankableEntityAuthControllingPerson',
  AddedBankableEntityUbo = 'addedBankableEntityUbo',
  AddedContractAuthorizedPersonRequest = 'addedContractAuthorizedPersonRequest',
  AddedContractCorrespondenceEmail = 'addedContractCorrespondenceEmail',
  AddedContractGroup = 'addedContractGroup',
  AddedContractPaymentRecipient = 'addedContractPaymentRecipient',
  AddedContractPeriodicReview = 'addedContractPeriodicReview',
  AddedLegalEntityDirector = 'addedLegalEntityDirector',
  AddedSignatureSpecimen = 'addedSignatureSpecimen',
  AddedTransactionSupportingDocument = 'addedTransactionSupportingDocument',
  AddedUboOwner = 'addedUboOwner',
  AllowVbanCreation = 'allowVbanCreation',
  ApprovalRequestRejected = 'approvalRequestRejected',
  ApproveCardTransaction = 'approveCardTransaction',
  ApproveDocument = 'approveDocument',
  ApproveProfileChange = 'approveProfileChange',
  ApprovedAccountClosureFinalRemittanceApprovalRequest = 'approvedAccountClosureFinalRemittanceApprovalRequest',
  ApprovedDirectDebitDispute = 'approvedDirectDebitDispute',
  ApprovedManualAccountBookingApprovalRequest = 'approvedManualAccountBookingApprovalRequest',
  AssignClientAgent = 'assignClientAgent',
  AssigneeDocument = 'assigneeDocument',
  AssociateContracts = 'associateContracts',
  AssociateIndividuals = 'associateIndividuals',
  BatchPaymentCreated = 'batchPaymentCreated',
  BatchPaymentExecuted = 'batchPaymentExecuted',
  BookedIncomingSwiftToLedger = 'bookedIncomingSwiftToLedger',
  BookedLedgerTransaction = 'bookedLedgerTransaction',
  Call = 'call',
  CancelStandingOrder = 'cancelStandingOrder',
  CancelStandingOrderRejected = 'cancelStandingOrderRejected',
  CancelledTransaction = 'cancelledTransaction',
  CardCreditVoucherTransaction = 'cardCreditVoucherTransaction',
  CardTerminated = 'cardTerminated',
  CardTransactionCancellationReverted = 'cardTransactionCancellationReverted',
  CardTransactionCancelled = 'cardTransactionCancelled',
  CardTransactionCleared = 'cardTransactionCleared',
  CardTransactionReturned = 'cardTransactionReturned',
  CardUpdated = 'cardUpdated',
  ChangeContractGeneralNote = 'changeContractGeneralNote',
  ChangeHasProfessionalTreasuryDepartment = 'changeHasProfessionalTreasuryDepartment',
  ChangeIndividualGeneralNote = 'changeIndividualGeneralNote',
  ChangeIsSubjectToPrudentialRegulation = 'changeIsSubjectToPrudentialRegulation',
  ChangePin = 'changePin',
  ChangeSettings = 'changeSettings',
  ChangeSwiftConversationGeneralNote = 'changeSwiftConversationGeneralNote',
  ChangeTransactionRecurringMarker = 'changeTransactionRecurringMarker',
  ChangeVerifiedEmail = 'changeVerifiedEmail',
  ChangeVerifiedPhone = 'changeVerifiedPhone',
  ChangedContracKycMeasures = 'changedContracKycMeasures',
  ChangedContractAuthPersonStatus = 'changedContractAuthPersonStatus',
  ChangedContractFeeGroup = 'changedContractFeeGroup',
  ChangedContractFinancialStatements = 'changedContractFinancialStatements',
  ChangedContractFundFlowDescription = 'changedContractFundFlowDescription',
  ChangedContractProducts = 'changedContractProducts',
  ChangedContractRiskCategory = 'changedContractRiskCategory',
  ChangedPrimary2FaMethod = 'changedPrimary2FAMethod',
  ChangedTransactionCumulativeReviewStatus = 'changedTransactionCumulativeReviewStatus',
  ChargeFee = 'chargeFee',
  ChargeManualFee = 'chargeManualFee',
  ClaimClientAgent = 'claimClientAgent',
  ClientHasDifferentIpCountry = 'clientHasDifferentIpCountry',
  ClientHasSameLastnameAndDob = 'clientHasSameLastnameAndDob',
  ClientHasSamePhoneNumber = 'clientHasSamePhoneNumber',
  ClientLoginSuccess = 'clientLoginSuccess',
  ClientVideoVerificationCompleted = 'clientVideoVerificationCompleted',
  ClonedFeeGroup = 'clonedFeeGroup',
  ClosedAccount = 'closedAccount',
  CommunicationStatusChanged = 'communicationStatusChanged',
  CompletedSuccessFeePayout = 'completedSuccessFeePayout',
  ConfirmOwnEmail = 'confirmOwnEmail',
  ContractChangeRequested = 'contractChangeRequested',
  ContractSuspiciousActivityReported = 'contractSuspiciousActivityReported',
  ContractTerminated = 'contractTerminated',
  ContractTerminationPending = 'contractTerminationPending',
  ContractTerminationRequest = 'contractTerminationRequest',
  ContractTerminationRequestRejected = 'contractTerminationRequestRejected',
  CoveredNegativeBalance = 'coveredNegativeBalance',
  CreateContractDocument = 'createContractDocument',
  CreateCustomerRequestForAccountOpening = 'createCustomerRequestForAccountOpening',
  CreateCustomerRequestForPendingInvitation = 'createCustomerRequestForPendingInvitation',
  CreateCustomerRequestForSwiftThread = 'createCustomerRequestForSwiftThread',
  CreateCustomerRequestForTransaction = 'createCustomerRequestForTransaction',
  CreateCustomerRequestForWallet = 'createCustomerRequestForWallet',
  CreateDocument = 'createDocument',
  CreateNewContractInformationRequest = 'createNewContractInformationRequest',
  CreateOwnDocument = 'createOwnDocument',
  CreatePaymentRailConfig = 'createPaymentRailConfig',
  CreateStandingOrder = 'createStandingOrder',
  CreatedAccount = 'createdAccount',
  CreatedAccountClosureFinalRemittanceApprovalRequest = 'createdAccountClosureFinalRemittanceApprovalRequest',
  CreatedApiUser = 'createdApiUser',
  CreatedBankableEntityContract = 'createdBankableEntityContract',
  CreatedCardAdjustmentTransactionApprovalRequest = 'createdCardAdjustmentTransactionApprovalRequest',
  CreatedCustomerSupportRequest = 'createdCustomerSupportRequest',
  CreatedFeeReversalApprovalRequest = 'createdFeeReversalApprovalRequest',
  CreatedIntroducerReferenceContract = 'createdIntroducerReferenceContract',
  CreatedManualAccountBookingApprovalRequest = 'createdManualAccountBookingApprovalRequest',
  CreatedPaymentRailRouteConfig = 'createdPaymentRailRouteConfig',
  CreatedQrBill = 'createdQRBill',
  CreatedSwiftMessage = 'createdSwiftMessage',
  CreatedTransaction = 'createdTransaction',
  CreatedVoidTransactionApprovalRequest = 'createdVoidTransactionApprovalRequest',
  CreditedIncomingSwiftTransactionToAccount = 'creditedIncomingSwiftTransactionToAccount',
  CryptoTransactionConfirmed = 'cryptoTransactionConfirmed',
  CryptoWalletLinkedToContract = 'cryptoWalletLinkedToContract',
  DeactivateAuthorizedPerson = 'deactivateAuthorizedPerson',
  DeactivateAuthorizedPersonRequest = 'deactivateAuthorizedPersonRequest',
  DeclineCardTransaction = 'declineCardTransaction',
  DeleteContractContact = 'deleteContractContact',
  DeleteEntityReminder = 'deleteEntityReminder',
  DeletedAccount = 'deletedAccount',
  DeletedPaymentRailRouteConfig = 'deletedPaymentRailRouteConfig',
  DirectDebitBatchPaymentCreated = 'directDebitBatchPaymentCreated',
  DirectDebitBaymentExecuted = 'directDebitBaymentExecuted',
  DirectDebitRevertRequest = 'directDebitRevertRequest',
  DisputeDirectDebit = 'disputeDirectDebit',
  DissociateContracts = 'dissociateContracts',
  DissociateIndividuals = 'dissociateIndividuals',
  DocumentSigningComplete = 'documentSigningComplete',
  DownloadIbanCertificate = 'downloadIbanCertificate',
  DrainLedgerOnDemandDrain = 'drainLedgerOnDemandDrain',
  EditContractTechnicalProperties = 'editContractTechnicalProperties',
  EditDocumentDetails = 'editDocumentDetails',
  EditPaymentCredentials = 'editPaymentCredentials',
  EditUserInfo = 'editUserInfo',
  EditedAccount = 'editedAccount',
  EditedFeeGroup = 'editedFeeGroup',
  ErroneousCancelledCardTransactionCleared = 'erroneousCancelledCardTransactionCleared',
  ExchangedCryptoTransaction = 'exchangedCryptoTransaction',
  ExecutedAction = 'executedAction',
  ExecutedCardAdjustmentTransactionApprovalRequest = 'executedCardAdjustmentTransactionApprovalRequest',
  ExecutedCryptoTransaction = 'executedCryptoTransaction',
  ExecutedFeeReversalApprovalRequest = 'executedFeeReversalApprovalRequest',
  ExecutedSuccessFeePayout = 'executedSuccessFeePayout',
  ExecutedTransaction = 'executedTransaction',
  ExecutedVoidTransactionApprovalRequest = 'executedVoidTransactionApprovalRequest',
  FinalizedTotpSetup = 'finalizedTOTPSetup',
  FreezeCard = 'freezeCard',
  GenerateContractAccountsConfirmation = 'generateContractAccountsConfirmation',
  GetAccountCancellationReport = 'getAccountCancellationReport',
  GetAccountStatement = 'getAccountStatement',
  Handle3dsAuthentication = 'handle3dsAuthentication',
  IncomingTransactionCreditorNameMismatch = 'incomingTransactionCreditorNameMismatch',
  IncomingTransactionFlaggedForAmlReview = 'incomingTransactionFlaggedForAMLReview',
  IncomingTransactionNameMismatch = 'incomingTransactionNameMismatch',
  InitiatedAction = 'initiatedAction',
  InitiatedTotpSetup = 'initiatedTOTPSetup',
  IpSrcTrackingInformation = 'ipSrcTrackingInformation',
  LedgerDrained = 'ledgerDrained',
  LockUnlockDocument = 'lockUnlockDocument',
  LogUserLoggedIn = 'logUserLoggedIn',
  MarkDocumentAsInternal = 'markDocumentAsInternal',
  MarkedUnMarkedContractAsKey = 'markedUnMarkedContractAsKey',
  MobileActivateDevice = 'mobileActivateDevice',
  MobileDeleteDevice = 'mobileDeleteDevice',
  MobileLogin = 'mobileLogin',
  ModifiedFileBasedPainAccess = 'modifiedFileBasedPainAccess',
  ModifyAuthorizedCardTransaction = 'modifyAuthorizedCardTransaction',
  Note = 'note',
  PasswordResetSuccessfully = 'passwordResetSuccessfully',
  PayCashback = 'payCashback',
  PayCommission = 'payCommission',
  PinDocument = 'pinDocument',
  PinnedAccount = 'pinnedAccount',
  Process2FaOperation = 'process2FAOperation',
  ProcessedTransferContractOwnership = 'processedTransferContractOwnership',
  RanElectronicIdVerificationCheck = 'ranElectronicIdVerificationCheck',
  RecalculateContractSuccessFees = 'recalculateContractSuccessFees',
  Registered = 'registered',
  RejectApprovalRequest = 'rejectApprovalRequest',
  RejectDirectDebit = 'rejectDirectDebit',
  RejectDocument = 'rejectDocument',
  RejectProfileChange = 'rejectProfileChange',
  RejectedAccountClosureFinalRemittanceApprovalRequest = 'rejectedAccountClosureFinalRemittanceApprovalRequest',
  RejectedAction = 'rejectedAction',
  RejectedDirectDebitDispute = 'rejectedDirectDebitDispute',
  RejectedFeeReversalApprovalRequest = 'rejectedFeeReversalApprovalRequest',
  RejectedManualAccountBookingApprovalRequest = 'rejectedManualAccountBookingApprovalRequest',
  RejectedSuccessFeePayout = 'rejectedSuccessFeePayout',
  RemoveDocument = 'removeDocument',
  RemoveMinimumTurnover = 'removeMinimumTurnover',
  RemoveRestrictAuthorizedPersonToAccounts = 'removeRestrictAuthorizedPersonToAccounts',
  RemoveTag = 'removeTag',
  RemovedAccountBundle = 'removedAccountBundle',
  RemovedAccountFromBundle = 'removedAccountFromBundle',
  RemovedBankableEntityAuthControllingPerson = 'removedBankableEntityAuthControllingPerson',
  RemovedBankableEntityContract = 'removedBankableEntityContract',
  RemovedBankableEntityUbo = 'removedBankableEntityUbo',
  RemovedContractFromGroup = 'removedContractFromGroup',
  RemovedContractGroup = 'removedContractGroup',
  RemovedContractInformationRequest = 'removedContractInformationRequest',
  RemovedContractPaymentRecipient = 'removedContractPaymentRecipient',
  RemovedLegalEntityDirector = 'removedLegalEntityDirector',
  RemovedUboOwner = 'removedUboOwner',
  RenamedAccountBundle = 'renamedAccountBundle',
  ReplacedSignatureSpecimen = 'replacedSignatureSpecimen',
  RequestCard = 'requestCard',
  RequestedAccountClosure = 'requestedAccountClosure',
  RequestedActionSigningCode = 'requestedActionSigningCode',
  RequestedPhoneVerificationCode = 'requestedPhoneVerificationCode',
  RequestedTransferContractOwnership = 'requestedTransferContractOwnership',
  RequestedVideoVerificationUrl = 'requestedVideoVerificationUrl',
  ResendReturnLedgerTransactionMessage = 'resendReturnLedgerTransactionMessage',
  Reset2FaAttempts = 'reset2FaAttempts',
  ResetClientPassword = 'resetClientPassword',
  ResolveIncomingTransactionNameMismatch = 'resolveIncomingTransactionNameMismatch',
  ResolvedTransactionDestination = 'resolvedTransactionDestination',
  RestrictAuthorizedPersonToAccounts = 'restrictAuthorizedPersonToAccounts',
  ReturnLedgerTransaction = 'returnLedgerTransaction',
  ReturnedTransaction = 'returnedTransaction',
  RevertDocument = 'revertDocument',
  RevertedLedgerTransaction = 'revertedLedgerTransaction',
  SendClientSecurityCode = 'sendClientSecurityCode',
  SendVerificationInvitation = 'sendVerificationInvitation',
  SentSepaClaimNoReceiptMessage = 'sentSEPAClaimNoReceiptMessage',
  SetAccountDailyStatement = 'setAccountDailyStatement',
  SetActionSignaturesToExpired = 'setActionSignaturesToExpired',
  SetCardLimits = 'setCardLimits',
  SetClientKycStatus = 'setClientKycStatus',
  SetContractAutoApprovalCheckStatuses = 'setContractAutoApprovalCheckStatuses',
  SetContractRiskProfile = 'setContractRiskProfile',
  SetContractStatementDeliveryBic = 'setContractStatementDeliveryBic',
  SetContractStatus = 'setContractStatus',
  SetDesignatedFeeAccount = 'setDesignatedFeeAccount',
  SetDesignatedNbcAccount = 'setDesignatedNbcAccount',
  SetFeeGroupForAccount = 'setFeeGroupForAccount',
  SetHasPendingInvestigation = 'setHasPendingInvestigation',
  SetOptInSms = 'setOptInSms',
  SetOptinMarketing = 'setOptinMarketing',
  SetUpLedgerDrain = 'setUpLedgerDrain',
  SetupFileBasedPainAccess = 'setupFileBasedPainAccess',
  SignedAction = 'signedAction',
  SpendingLimitRequest = 'spendingLimitRequest',
  SubmitForPreAssessment = 'submitForPreAssessment',
  SubmittedBankableEntityContract = 'submittedBankableEntityContract',
  ToggleAccountHidden = 'toggleAccountHidden',
  ToggleAccountUseFItoFi = 'toggleAccountUseFItoFI',
  ToggleAllowInternalOnly = 'toggleAllowInternalOnly',
  ToggleAuthorizedPersonSignNewUserActions = 'toggleAuthorizedPersonSignNewUserActions',
  ToggleAuthorizedPersonSignOwnActions = 'toggleAuthorizedPersonSignOwnActions',
  ToggleCcDedicatedAcm = 'toggleCcDedicatedAcm',
  ToggleClientSafeguardAccount = 'toggleClientSafeguardAccount',
  ToggleCrsReportable = 'toggleCrsReportable',
  ToggleCryptoPayments = 'toggleCryptoPayments',
  ToggleEconomicProfile = 'toggleEconomicProfile',
  ToggleEmailConfirmed = 'toggleEmailConfirmed',
  ToggleEntityPublicInfo = 'toggleEntityPublicInfo',
  ToggleEntityReputationalRisk = 'toggleEntityReputationalRisk',
  ToggleExemptFromNbc = 'toggleExemptFromNbc',
  ToggleFatcaReportable = 'toggleFatcaReportable',
  ToggleForceHold = 'toggleForceHold',
  ToggleIndividualVerified = 'toggleIndividualVerified',
  ToggleIntroducingPartner = 'toggleIntroducingPartner',
  ToggleIsPhoneVerified = 'toggleIsPhoneVerified',
  ToggleMobilePreferences = 'toggleMobilePreferences',
  ToggleOtpViaApi = 'toggleOTPViaApi',
  ToggleTransactionReview = 'toggleTransactionReview',
  ToogleAcknowledgedExpiredDocument = 'toogleAcknowledgedExpiredDocument',
  ToogleIsPep = 'toogleIsPep',
  TransactionAdditionalInfoUpdated = 'transactionAdditionalInfoUpdated',
  TransactionAuthorizedForFx = 'transactionAuthorizedForFX',
  TransactionCancellationRejected = 'transactionCancellationRejected',
  TransactionCancelled = 'transactionCancelled',
  TransactionClearedForAml = 'transactionClearedForAML',
  TransactionCorrespondentInfoUpdated = 'transactionCorrespondentInfoUpdated',
  TransactionCounterPartyAddressModified = 'transactionCounterPartyAddressModified',
  TransactionFxExecuted = 'transactionFXExecuted',
  TransactionFlaggedForAmlReview = 'transactionFlaggedForAMLReview',
  TransactionMessageAccepted = 'transactionMessageAccepted',
  TransactionMessageRejected = 'transactionMessageRejected',
  TransactionMessageReturned = 'transactionMessageReturned',
  TransactionMessageSent = 'transactionMessageSent',
  TransactionPayoutStatusChanged = 'transactionPayoutStatusChanged',
  TransactionPendingPayout = 'transactionPendingPayout',
  TransactionRequestClearedForAml = 'transactionRequestClearedForAML',
  TransactionRequestRejected = 'transactionRequestRejected',
  TransactionReturnProcessed = 'transactionReturnProcessed',
  TransactionReturnRequestProcessed = 'transactionReturnRequestProcessed',
  TransactionReturned = 'transactionReturned',
  TransactionReturnedRequested = 'transactionReturnedRequested',
  TransactionReverted = 'transactionReverted',
  TransactionSentForAml = 'transactionSentForAML',
  TransactionValueUpdated = 'transactionValueUpdated',
  TrustedDevice = 'trustedDevice',
  UnFreezeCard = 'unFreezeCard',
  UnMarkDocumentAsInternal = 'unMarkDocumentAsInternal',
  UnPinDocument = 'unPinDocument',
  UnassignClientAgent = 'unassignClientAgent',
  UnclaimClientAgent = 'unclaimClientAgent',
  UnderReviewProfileChange = 'underReviewProfileChange',
  UnpinnedAccount = 'unpinnedAccount',
  UpdateAccountStatus = 'updateAccountStatus',
  UpdateClientDetails = 'updateClientDetails',
  UpdateDedicatedAccountManager = 'updateDedicatedAccountManager',
  UpdateDocument = 'updateDocument',
  UpdateFcmToken = 'updateFCMToken',
  UpdateFundsType = 'updateFundsType',
  UpdateOwnDetails = 'updateOwnDetails',
  UpdateOwnEmail = 'updateOwnEmail',
  UpdateOwnPassword = 'updateOwnPassword',
  UpdateProfileEmailCategoriesSettings = 'updateProfileEmailCategoriesSettings',
  UpdateProfileSmsCategoriesSettings = 'updateProfileSMSCategoriesSettings',
  UpdateSpendingLimit = 'updateSpendingLimit',
  UpdateSwiftMessageAckStatus = 'updateSwiftMessageAckStatus',
  UpdatedApiUserAllowedIps = 'updatedApiUserAllowedIps',
  UpdatedApiUserSecret = 'updatedApiUserSecret',
  UpdatedApiUserStatus = 'updatedApiUserStatus',
  UpdatedBankableEntityAuthControllingPerson = 'updatedBankableEntityAuthControllingPerson',
  UpdatedBankableEntityContract = 'updatedBankableEntityContract',
  UpdatedBankableEntityUbo = 'updatedBankableEntityUbo',
  UpdatedCard3DsSetting = 'updatedCard3DSSetting',
  UpdatedCheckResult = 'updatedCheckResult',
  UpdatedContractCommisionSettings = 'updatedContractCommisionSettings',
  UpdatedContractGroup = 'updatedContractGroup',
  UpdatedContractInformationRequest = 'updatedContractInformationRequest',
  UpdatedContractKeyInformation = 'updatedContractKeyInformation',
  UpdatedContractPaymentRecipient = 'updatedContractPaymentRecipient',
  UpdatedCryptoWallet = 'updatedCryptoWallet',
  UpdatedFeeGroupSetting = 'updatedFeeGroupSetting',
  UpdatedLegalEntityDirector = 'updatedLegalEntityDirector',
  UpdatedPaymentRailConfig = 'updatedPaymentRailConfig',
  UpdatedPaymentRailRouteConfig = 'updatedPaymentRailRouteConfig',
  UpdatedPreassessment = 'updatedPreassessment',
  UpdatedReferrer = 'updatedReferrer',
  UpdatedSuccessFeePayout = 'updatedSuccessFeePayout',
  UpdatedUboOwner = 'updatedUboOwner',
  UpsertContractContact = 'upsertContractContact',
  UpsertMinimumTurnover = 'upsertMinimumTurnover',
  UpsertTag = 'upsertTag',
  User2FaEnabled = 'user2FaEnabled',
  UserAddedCheck = 'userAddedCheck',
  UserCreatedAccount = 'userCreatedAccount',
  UserDeletedCheck = 'userDeletedCheck',
  UserPerformedCheck = 'userPerformedCheck',
  UserUpdatedCheck = 'userUpdatedCheck',
  UserUpdatedCryptoWallet = 'userUpdatedCryptoWallet',
  VerifiedPhone = 'verifiedPhone',
  VibanNameMismatchResolved = 'vibanNameMismatchResolved',
  ViewCard3dsPassword = 'viewCard3dsPassword',
  ViewCardSensitiveInfo = 'viewCardSensitiveInfo'
}

export type AddAuthorizedPersonInputType = {
  authorizationSetting: AuthorizationSettingInputType;
  person?: InputMaybe<AuthorizedPersonInputType>;
};

export type AddContractAuthorizedPersonRequestAction = BaseAction & {
  __typename?: 'AddContractAuthorizedPersonRequestAction';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  newAuthorizedPerson?: Maybe<ContractAuthorizedPersonType>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type AddContractAuthorizedPersonRequestActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export type AddContractPaymentRecipientInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  accountNoType?: InputMaybe<AccountNoType>;
  address: AddressInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  bankBic?: InputMaybe<Scalars['String']['input']>;
  bankCountry?: InputMaybe<Country>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  commentTemplate?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  type: SwiftTransferRecipientType;
};

export type AddContractUboInputType = {
  ubo: UboInputType;
  uboOwners?: InputMaybe<Array<InputMaybe<UboInputType>>>;
};

export type Address = {
  __typename?: 'Address';
  /** Address: Additional Details */
  additionalDetails?: Maybe<Scalars['String']['output']>;
  /** Address: City */
  city?: Maybe<Scalars['String']['output']>;
  /** Country */
  country?: Maybe<Country>;
  countryDescription?: Maybe<Scalars['String']['output']>;
  /** Address: Street */
  line1?: Maybe<Scalars['String']['output']>;
  /** Region */
  region?: Maybe<Scalars['String']['output']>;
  /** Postcode/ZIP code */
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  /** Address: Additional Details */
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  /** Address: City */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country */
  country?: InputMaybe<Country>;
  /** Address: Street */
  line1?: InputMaybe<Scalars['String']['input']>;
  /** Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Postcode/ZIP code */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Agent log */
export type AgentLog = BaseLogInterface & {
  __typename?: 'AgentLog';
  /** Agent Type */
  agentType?: Maybe<AgentType>;
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

/** Agent Type */
export enum AgentType {
  ExternalAgent = 'externalAgent',
  SalesAgent = 'salesAgent',
  SupportAgent = 'supportAgent'
}

/** All currencies (including supported crypto) */
export enum AllCurrencies {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eth = 'ETH',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mru = 'MRU',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Std = 'STD',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Usdc = 'USDC',
  Usdt = 'USDT',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vef = 'VEF',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xcd = 'XCD',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
  Zwl = 'ZWL'
}

export enum AllowedCryptoPayments {
  All = 'all',
  None = 'none',
  OffRamp = 'offRamp',
  OnRamp = 'onRamp'
}

export type AmountCurrency = {
  __typename?: 'AmountCurrency';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type AmpInUse = {
  __typename?: 'AmpInUse';
  ampInUseTypeCurrentlyInUse?: Maybe<Scalars['String']['output']>;
  monthlyVolumeInEuro?: Maybe<Scalars['String']['output']>;
};

export type AmpInUseInput = {
  ampInUseTypeCurrentlyInUse?: InputMaybe<Scalars['String']['input']>;
  monthlyVolumeInEuro?: InputMaybe<Scalars['String']['input']>;
};

export enum AnticipatedAccountActivities {
  B2B = 'B2B',
  B2B2C = 'B2B2C',
  B2BB2C = 'B2B_B2C',
  B2C = 'B2C',
  C2B = 'C2B',
  C2B2B = 'C2B2B',
  CorporateExpenses = 'corporateExpenses',
  Crypto2Fiat2Crypto = 'crypto2Fiat2Crypto'
}

export enum ApiCard3DSecureLanguageCode {
  Eng = 'Eng'
}

export enum ApiCard3DSecureTypes {
  SmsotpAndStaticPassword = 'SmsotpAndStaticPassword'
}

export enum ApiCardTypes {
  ChipAndPin = 'ChipAndPin',
  ChipAndPinAnonymous = 'ChipAndPinAnonymous',
  Virtual = 'Virtual'
}

export type ApiUser = {
  __typename?: 'ApiUser';
  /** allowedIps */
  allowedIps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** ID / Api Key */
  apiKey: Scalars['ID']['output'];
  apiSecret: Scalars['ID']['output'];
  /** Associated Contract */
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID / Api Key */
  id: Scalars['ID']['output'];
  /** Application Name */
  name: Scalars['String']['output'];
  /** Scopes */
  scopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Status */
  status?: Maybe<ApiUserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ApiUserStatus {
  Active = 'active',
  Deactivated = 'deactivated'
}

export type AppFieldItem = {
  __typename?: 'AppFieldItem';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AppFields = {
  __typename?: 'AppFields';
  items?: Maybe<Array<Maybe<AppFieldItem>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ApprovalRequest = AccountClosureFundRemittanceApprovalRequest | AccountManualBookingApprovalRequest | CardAdjustmentTransactionRequestRequest | FeeReversalRequest | VoidTransactionRequest;

export type ApprovalRequestSetting = {
  __typename?: 'ApprovalRequestSetting';
  approvalRequired?: Maybe<Scalars['Int']['output']>;
  approverPermissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  requestType?: Maybe<Scalars['String']['output']>;
};

export enum ApprovalRequestStatus {
  Accept = 'accept',
  Draft = 'draft',
  Failed = 'failed',
  Pending = 'pending',
  Reject = 'reject'
}

export enum ApprovalRequestType {
  AccountClosureFundRemittance = 'accountClosureFundRemittance',
  CardTransactionAdjustment = 'cardTransactionAdjustment',
  FeeReversal = 'feeReversal',
  ManualAccountBooking = 'manualAccountBooking',
  VoidTransaction = 'voidTransaction'
}

export type Article = {
  __typename?: 'Article';
  /** body */
  body: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Article id */
  id: Scalars['Int']['output'];
  /** title */
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who created this article */
  user?: Maybe<User>;
};

/** Bankable Entity Authorization Setting */
export type AuthorizationSettingInputType = {
  /** Group Size, case when signatoryRight is group */
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  isAuthorizedSignatory: Scalars['Boolean']['input'];
  isLimitedAccess: Scalars['Boolean']['input'];
  /** Limited Access Right */
  limitedAccessRight?: InputMaybe<LimitedAccessRight>;
  /** Signatory Right */
  signatoryRight?: InputMaybe<SignatoryRight>;
};

/** Bankable Entity Authorized Person */
export type AuthorizedPersonInputType = {
  /** Auth/Controlling Person Address */
  address?: InputMaybe<AddressInput>;
  /** Auth/Controlling Person Birth Day */
  birthday?: InputMaybe<Scalars['Date']['input']>;
  /** Auth/Controlling Person Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Auth/Controlling Person First Name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Is politically exposed person */
  isPep?: InputMaybe<Scalars['Boolean']['input']>;
  /** Auth/Controlling Person Last Name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Auth/Controlling Person Nationality */
  nationality?: InputMaybe<Nationality>;
  /** Auth/Controlling Person Phone */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Tax ID */
  taxId?: InputMaybe<Scalars['String']['input']>;
  /** Is US reportable person */
  usReportablePerson?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AuthorizedPersonRights {
  CardHolder = 'cardHolder',
  Group = 'group',
  Joint = 'joint',
  PaymentFacilitationView = 'paymentFacilitationView',
  Sole = 'sole',
  ViewDataEntry = 'viewDataEntry',
  ViewOnly = 'viewOnly'
}

export enum AuthorizedPersonStatuses {
  Activated = 'activated',
  Deactivated = 'deactivated',
  Invited = 'invited',
  PendingInvitation = 'pendingInvitation',
  PendingSignature = 'pendingSignature',
  PendingVerification = 'pendingVerification',
  Rejected = 'rejected'
}

export type B2BDirectDebitPreapprovalCounterpartyInputType = {
  name: Scalars['String']['input'];
};

export type B2BDirectDebitPreapprovalInput = {
  account: Scalars['ID']['input'];
  counterpartyDetails: B2BDirectDebitPreapprovalCounterpartyInputType;
  creditorId: Scalars['String']['input'];
  document: Scalars['ID']['input'];
  recurring: Scalars['Boolean']['input'];
};

export type BicInfo = {
  __typename?: 'BICInfo';
  address?: Maybe<Address>;
  bankName?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  isTracker?: Maybe<Scalars['Boolean']['output']>;
  nationalId?: Maybe<Scalars['String']['output']>;
};

/** Correspondent bank info by passed iban */
export type BankInfoType = {
  __typename?: 'BankInfoType';
  address?: Maybe<Scalars['String']['output']>;
  /** Name of bank */
  bankName: Scalars['String']['output'];
  /** Business Identifier Codes */
  bic: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  countryISO: Scalars['String']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type BankType = {
  __typename?: 'BankType';
  bankCode?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  providerCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Bankable Entity */
export type BankableEntityContractInputType = {
  /** Legal Entity Address */
  address?: InputMaybe<AddressInput>;
  /** Legal Entity Business Description */
  businessDescription?: InputMaybe<Scalars['String']['input']>;
  /** Legal Entity Business Sector */
  businessSector?: InputMaybe<Scalars['String']['input']>;
  /** Countries the company’s clients are based in */
  companyClientsCountries?: InputMaybe<Array<InputMaybe<CountriesAndRegionsType>>>;
  /** Legal Entity Company Name */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Legal Entity Company Reg Date */
  companyRegistrationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Legal Entity Company Reg ID */
  companyRegistrationId?: InputMaybe<Scalars['String']['input']>;
  /** Legal Entity Company Type */
  companyType?: InputMaybe<CompanyType>;
  /** Correspondence Address */
  correspondenceAddress?: InputMaybe<AddressInput>;
  /** Countries Of Operating And Conducting Business */
  countriesOfOperatingAndConductingBusiness?: InputMaybe<Array<InputMaybe<CountriesAndRegionsType>>>;
  /** Economic profile fields */
  economicProfile?: InputMaybe<EconomicProfileInputType>;
  /** Has professional treasury department */
  hasProfessionalTreasuryDepartment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Immediate Previous Company Name */
  immediatePreviousCompanyName?: InputMaybe<Scalars['String']['input']>;
  /** Whether the new client is introducer or not */
  isIntroducer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Legal Entity Company Type */
  legalEntityType?: InputMaybe<UboLegalEntityType>;
  /** Legal Entity Phone Number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Pre-assessment */
  preAssessment?: InputMaybe<PreAssessmentContractInputType>;
  /** Potential Sanctioned Industry */
  sanctionedIndustry?: InputMaybe<SanctionedIndustry>;
  /** What industries does the company serve */
  servingIndustries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Subject to prudential regulation */
  subjectToPrudentialRegulation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tax ID */
  taxId?: InputMaybe<Scalars['String']['input']>;
  /** Legal Entity Trading Name */
  tradingName?: InputMaybe<Scalars['String']['input']>;
  /** Transactional Partners */
  transactionalPartners?: InputMaybe<Array<InputMaybe<TransactionalPartnerInput>>>;
  /** Legal Entity Website */
  website?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Bankable Entity */
export type BankableEntityContractType = {
  __typename?: 'BankableEntityContractType';
  /** Account Opening Service Desk Requests */
  accountOpeningTickets?: Maybe<Array<Maybe<ServiceDeskRequest>>>;
  actions?: Maybe<Array<Maybe<Action>>>;
  activatedOn?: Maybe<Scalars['DateTime']['output']>;
  allowLocalPay?: Maybe<Scalars['Boolean']['output']>;
  allowVbanCreation?: Maybe<Scalars['Boolean']['output']>;
  allowVbanThirdPartyDeposits?: Maybe<Scalars['Boolean']['output']>;
  allowedCryptoPayments?: Maybe<AllowedCryptoPayments>;
  authorizedPersons?: Maybe<Array<Maybe<ContractAuthorizedPersonType>>>;
  autoApproveCryptoCheckStatuses?: Maybe<Array<Maybe<WalletCheckStatus>>>;
  ccDedicatedAcm?: Maybe<Scalars['Boolean']['output']>;
  chargeCardTrxOnAuth?: Maybe<Scalars['Boolean']['output']>;
  commissionSettings?: Maybe<ContractCommissionSetting>;
  communicationStatus?: Maybe<CommunicationStatus>;
  communicationStatusChangedAt?: Maybe<Scalars['DateTime']['output']>;
  contacts?: Maybe<Array<Maybe<ContractContact>>>;
  contractGroup?: Maybe<ContractGroup>;
  contractInformationRequestsCount?: Maybe<Scalars['Int']['output']>;
  contractTermAction?: Maybe<Action>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Individual>;
  createdByEntity?: Maybe<UserOrIndividual>;
  crsReportable?: Maybe<Scalars['Boolean']['output']>;
  dedicatedAcm?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Account */
  designatedFeeAccount?: Maybe<Account>;
  /**
   * SEPA Direct Debit Creditor ID
   * @deprecated Use directDebitSettings field now
   */
  directDebitCreditorId?: Maybe<Scalars['String']['output']>;
  directDebitSettings?: Maybe<DirectDebitSettings>;
  /** Director IDs of the Legal Entity */
  directorIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Documents associated with this contract */
  documents?: Maybe<Array<Maybe<Document>>>;
  dueRemindersCount?: Maybe<Scalars['Int']['output']>;
  exemptFromNbc?: Maybe<Scalars['Boolean']['output']>;
  fatcaReportable?: Maybe<Scalars['Boolean']['output']>;
  feeGroup?: Maybe<FeeGroup>;
  fileBasedPainAccess?: Maybe<FileBasedPainAccess>;
  fundFlowDescription?: Maybe<Scalars['String']['output']>;
  /** FX Markup */
  fxMarkup?: Maybe<Scalars['Float']['output']>;
  generalNote?: Maybe<Scalars['String']['output']>;
  generalNoteImportant?: Maybe<Scalars['Boolean']['output']>;
  handlesPhysicalCash?: Maybe<Scalars['Boolean']['output']>;
  hasCardPayment?: Maybe<Scalars['Boolean']['output']>;
  hasProfessionalTreasuryDepartment?: Maybe<Scalars['Boolean']['output']>;
  hasSarDoc?: Maybe<Scalars['Boolean']['output']>;
  /** Contract ID */
  id: Scalars['Int']['output'];
  /** Individual Ids of All Linked UBO */
  individualUboIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  individualViewerOnboardingRequiredChecks?: Maybe<Array<Maybe<IndividualContractOnboardingRequiredCheck>>>;
  individualViewerRoles?: Maybe<Array<Maybe<IndividualContractRole>>>;
  /** Introducer's Payout Info */
  introducerPayoutInfo?: Maybe<IntroducerPayoutInfo>;
  isHouseOwned?: Maybe<Scalars['Boolean']['output']>;
  isIntroducingPartner?: Maybe<Scalars['Boolean']['output']>;
  isKey?: Maybe<Scalars['Boolean']['output']>;
  isPep?: Maybe<Scalars['Boolean']['output']>;
  isSigned?: Maybe<Scalars['Boolean']['output']>;
  isSubjectToPrudentialRegulation?: Maybe<Scalars['Boolean']['output']>;
  /** Legal Entity Ids of All Linked UBO */
  legalEntityUboIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  minimumTurnovers?: Maybe<Scalars['JSON']['output']>;
  missingInfoDetails?: Maybe<MissingInfoDetailsType>;
  nextReviewDate?: Maybe<Scalars['DateTime']['output']>;
  nextReviewDateAsOfToday?: Maybe<Scalars['DateTime']['output']>;
  /** Onboarding Jira Requests */
  onboardingJiraIssues?: Maybe<Array<Maybe<ServiceDeskRequest>>>;
  onboardingStatus?: Maybe<ContractOnboardProgressType>;
  /** Contract Owner */
  owner: LegalEntityOrIndividual;
  /** Contract Owner Type */
  ownerType?: Maybe<UboType>;
  /** Ownership Transfer */
  ownershipTransfer?: Maybe<ContractOwnershipTransfer>;
  /** Contract ownership transfer initiated */
  ownershipTransferInitiated?: Maybe<Scalars['Boolean']['output']>;
  paymentCredentials?: Maybe<PaymentCredentialsType>;
  paymentRecipients?: Maybe<Array<Maybe<ContractPaymentRecipient>>>;
  /** Periodic Reviews Service Desk Requests */
  periodicReviewsTickets?: Maybe<Array<Maybe<ServiceDeskRequest>>>;
  /** Pre-assessment */
  preAssessment?: Maybe<PreAssessment>;
  referralCode?: Maybe<Scalars['String']['output']>;
  referralLink?: Maybe<Scalars['String']['output']>;
  referringContract?: Maybe<BankableEntityContractType>;
  referringContractName?: Maybe<Scalars['String']['output']>;
  /** Risk Classifications */
  riskClassifications?: Maybe<Array<Maybe<RiskClassification>>>;
  sarDocDate?: Maybe<Scalars['DateTime']['output']>;
  /** Contract's settlement balance for PF */
  settlementBalance?: Maybe<Array<Maybe<SettlementBalance>>>;
  showEconomicProfile?: Maybe<Scalars['Boolean']['output']>;
  signatories?: Maybe<Array<Maybe<ContractAuthorizedPersonType>>>;
  signatoriesCount?: Maybe<Scalars['Int']['output']>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  statementDeliveryBic?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ContractStatusType>;
  statusLastChangedAt?: Maybe<Scalars['DateTime']['output']>;
  structureCategory?: Maybe<ContractRiskCategories>;
  structureComplexity?: Maybe<Scalars['Int']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  type?: Maybe<ContractType>;
  ubos?: Maybe<Array<Maybe<ContractUbo>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  whitelabel?: Maybe<Whitelabel>;
};


/** Bankable Entity */
export type BankableEntityContractTypeAccountOpeningTicketsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/** Bankable Entity */
export type BankableEntityContractTypeActionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/** Bankable Entity */
export type BankableEntityContractTypeAuthorizedPersonsArgs = {
  isLimitedAccessHolder?: InputMaybe<Scalars['Boolean']['input']>;
  isSignatory?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyMe?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/** Bankable Entity */
export type BankableEntityContractTypeContractInformationRequestsCountArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  documentType?: InputMaybe<DocumentType>;
  status?: InputMaybe<ContractInformationRequestStatus>;
  statuses?: InputMaybe<Array<InputMaybe<ContractInformationRequestStatus>>>;
  type?: InputMaybe<ContractInformationRequestType>;
};


/** Bankable Entity */
export type BankableEntityContractTypeDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/** Bankable Entity */
export type BankableEntityContractTypeOnboardingJiraIssuesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/** Bankable Entity */
export type BankableEntityContractTypePaymentRecipientsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/** Bankable Entity */
export type BankableEntityContractTypePeriodicReviewsTicketsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/** Bankable Entity */
export type BankableEntityContractTypeSignatoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/** Bankable Entity */
export type BankableEntityContractTypeTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/** Bankable Entity */
export type BankableEntityContractTypeUbosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};

export type BaseAction = {
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type BaseActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

/** Base ApprovalRequest */
export type BaseApprovalRequest = {
  affectedEntity?: Maybe<Scalars['String']['output']>;
  affectedEntityId?: Maybe<Scalars['ID']['output']>;
  approvals?: Maybe<Array<Maybe<UserRequestApprovalType>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  executionError?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  requestType?: Maybe<ApprovalRequestType>;
  setting?: Maybe<ApprovalRequestSetting>;
  status?: Maybe<ApprovalRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BaseLogInterface = {
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

export type BaseTransaction = {
  account?: Maybe<Account>;
  accountCurrency?: Maybe<Currency>;
  additionalComment?: Maybe<Scalars['String']['output']>;
  balanceAfter?: Maybe<Scalars['Float']['output']>;
  batchId?: Maybe<Scalars['ID']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  card?: Maybe<CardType>;
  cardTransactionDetails?: Maybe<CardTransactionDetails>;
  cashbackDetail?: Maybe<CashbackDetail>;
  chargeBearer?: Maybe<SwiftTransferChargeBearer>;
  clientReference?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commissionDetail?: Maybe<CommissionDetail>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use Account/Payout Currency */
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directDebitExecution?: Maybe<DirectDebitExecution>;
  dueRemindersCount?: Maybe<Scalars['Int']['output']>;
  entryType?: Maybe<TransactionEntryType>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  executionAction?: Maybe<Action>;
  executionType?: Maybe<TransactionExecutionType>;
  feeDetail?: Maybe<FeeDetail>;
  forceHold?: Maybe<Scalars['Boolean']['output']>;
  guaranteeEvent?: Maybe<GuaranteeEvent>;
  hasSupportingDocument?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  internalFields?: Maybe<TransactionInternalFields>;
  isConfirmationAvailable?: Maybe<Scalars['Boolean']['output']>;
  isInterContract?: Maybe<Scalars['Boolean']['output']>;
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  isReturn?: Maybe<Scalars['Boolean']['output']>;
  isReverted?: Maybe<Scalars['Boolean']['output']>;
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use payment rail */
  isSEPA?: Maybe<Scalars['Boolean']['output']>;
  isSwift?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use Account/Payout Currency */
  originalCurrency?: Maybe<Currency>;
  paymentRail?: Maybe<PaymentRail>;
  paymentRailBranch?: Maybe<Scalars['String']['output']>;
  payoutCurrency?: Maybe<Scalars['String']['output']>;
  payoutValue?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<TransactionPriorityType>;
  purposeCode?: Maybe<Scalars['String']['output']>;
  purposeCode2?: Maybe<Scalars['String']['output']>;
  quotedXRate?: Maybe<Scalars['Float']['output']>;
  returnedTransactionId?: Maybe<Scalars['ID']['output']>;
  revertedBy?: Maybe<Transaction>;
  status?: Maybe<TransactionStatus>;
  supportingDocuments?: Maybe<Array<Maybe<Document>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  trxHash?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueDate?: Maybe<Scalars['DateTime']['output']>;
  walletCheckStatus?: Maybe<WalletCheckStatus>;
  xRate?: Maybe<Scalars['Float']['output']>;
};


export type BaseTransactionTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};

export type BatchPayment = {
  __typename?: 'BatchPayment';
  account?: Maybe<Account>;
  calculatedValidTotal?: Maybe<Scalars['Float']['output']>;
  /** Cancellation Reason */
  cancellationReason?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Currency */
  currency?: Maybe<Currency>;
  /** actionType */
  executionAction?: Maybe<Action>;
  /** File Url */
  fileUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  paymentRecords?: Maybe<Array<Maybe<BatchPaymentRecord>>>;
  status?: Maybe<BatchPaymentStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type BatchPaymentPaymentRecordsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};

export type BatchPaymentActionType = BaseAction & {
  __typename?: 'BatchPaymentActionType';
  appFields?: Maybe<AppFields>;
  batchPayment?: Maybe<BatchPayment>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type BatchPaymentActionTypeSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export type BatchPaymentFileValidation = {
  __typename?: 'BatchPaymentFileValidation';
  calculatedTotal?: Maybe<Scalars['Float']['output']>;
  calculatedValidTotal?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  /** @deprecated Get Error From Payment Records */
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  oversized?: Maybe<Scalars['Boolean']['output']>;
  paymentRecords?: Maybe<Array<Maybe<BatchPaymentRecord>>>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type BatchPaymentRecord = {
  __typename?: 'BatchPaymentRecord';
  amount?: Maybe<Scalars['Float']['output']>;
  bankBic?: Maybe<Scalars['String']['output']>;
  bankBranchId?: Maybe<Scalars['String']['output']>;
  bankBranchName?: Maybe<Scalars['String']['output']>;
  bankClearingMemberId?: Maybe<Scalars['String']['output']>;
  beneficiaryAccountId?: Maybe<Scalars['String']['output']>;
  beneficiaryAccountIdType?: Maybe<Scalars['String']['output']>;
  beneficiaryEmail?: Maybe<Scalars['String']['output']>;
  beneficiaryName?: Maybe<Scalars['String']['output']>;
  beneficiaryPhone?: Maybe<Scalars['String']['output']>;
  beneficiaryType?: Maybe<Scalars['String']['output']>;
  chargeBearer?: Maybe<SwiftTransferChargeBearer>;
  city?: Maybe<Scalars['String']['output']>;
  clientReference?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  fixedPayoutAmount?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  payoutAmount?: Maybe<Scalars['Float']['output']>;
  payoutCurrency?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  purposeCode?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BatchPaymentRecordStatus>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  useLocalAchPayout?: Maybe<Scalars['Boolean']['output']>;
};

export type BatchPaymentRecordInput = {
  amount: Scalars['Float']['input'];
  bankBic: Scalars['String']['input'];
  bankBranchId?: InputMaybe<Scalars['String']['input']>;
  bankBranchName?: InputMaybe<Scalars['String']['input']>;
  bankClearingMemberId?: InputMaybe<Scalars['String']['input']>;
  beneficiaryAccountId: Scalars['String']['input'];
  beneficiaryAccountIdType: BeneficiaryAccountIdType;
  beneficiaryEmail?: InputMaybe<Scalars['String']['input']>;
  beneficiaryName: Scalars['String']['input'];
  beneficiaryPhone?: InputMaybe<Scalars['String']['input']>;
  beneficiaryType: SwiftTransferRecipientType;
  chargeBearer?: InputMaybe<SwiftTransferChargeBearer>;
  city: Scalars['String']['input'];
  clientReference?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  currency?: InputMaybe<Currency>;
  fixedPayoutAmount?: InputMaybe<Scalars['Boolean']['input']>;
  payoutAmount?: InputMaybe<Scalars['Float']['input']>;
  payoutCurrency?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  priority: TransactionPriorityType;
  purposeCode?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  useLocalAchPayout?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BatchPaymentRecordStatus {
  Cancelled = 'cancelled',
  Invalid = 'invalid',
  Pending = 'pending',
  Processed = 'processed'
}

export enum BatchPaymentStatusType {
  Cancelled = 'cancelled',
  Executed = 'executed',
  ExecutedWithFailure = 'executedWithFailure',
  PendingExecutionSignatures = 'pendingExecutionSignatures',
  Signed = 'signed'
}

export enum BeneficiaryAccountIdType {
  AccountNumber = 'accountNumber',
  AccountNumberChecking = 'accountNumberChecking',
  AccountNumberCurrent = 'accountNumberCurrent',
  AccountNumberSavings = 'accountNumberSavings',
  Iban = 'iban'
}

export enum BusinessCategories {
  AcRefrigerationRepair = 'AcRefrigerationRepair',
  AccountingBookkeepingServices = 'AccountingBookkeepingServices',
  AdultContent = 'AdultContent',
  AdvertisingBinaryOptions = 'AdvertisingBinaryOptions',
  AdvertisingServices = 'AdvertisingServices',
  AffiliateMarketing = 'AffiliateMarketing',
  AgriculturalCooperative = 'AgriculturalCooperative',
  AirlinesAirCarriers = 'AirlinesAirCarriers',
  AirportsFlyingFields = 'AirportsFlyingFields',
  AmbulanceServices = 'AmbulanceServices',
  AmusementParksCarnivals = 'AmusementParksCarnivals',
  AntiqueReproductions = 'AntiqueReproductions',
  AntiqueShops = 'AntiqueShops',
  Aquariums = 'Aquariums',
  ArchitecturalSurveyingServices = 'ArchitecturalSurveyingServices',
  ArtDealersAndGalleries = 'ArtDealersAndGalleries',
  ArtistsSupplyAndCraftShops = 'ArtistsSupplyAndCraftShops',
  AutoAndHomeSupplyStores = 'AutoAndHomeSupplyStores',
  AutoBodyRepairShops = 'AutoBodyRepairShops',
  AutoPaintShops = 'AutoPaintShops',
  AutoServiceShops = 'AutoServiceShops',
  AutomatedCashDisburse = 'AutomatedCashDisburse',
  AutomatedFuelDispensers = 'AutomatedFuelDispensers',
  AutomobileAssociations = 'AutomobileAssociations',
  AutomotivePartsAndAccessoriesStores = 'AutomotivePartsAndAccessoriesStores',
  AutomotiveTireStores = 'AutomotiveTireStores',
  BailAndBondPayments = 'BailAndBondPayments',
  Bakeries = 'Bakeries',
  BandsOrchestras = 'BandsOrchestras',
  BarberAndBeautyShops = 'BarberAndBeautyShops',
  BettingCasinoGambling = 'BettingCasinoGambling',
  BicycleShops = 'BicycleShops',
  BiddingFeeAuction = 'BiddingFeeAuction',
  BilliardPoolEstablishments = 'BilliardPoolEstablishments',
  BinaryOptionsBrokers = 'BinaryOptionsBrokers',
  BoatDealers = 'BoatDealers',
  BoatRentalsAndLeases = 'BoatRentalsAndLeases',
  BookStores = 'BookStores',
  BooksPeriodicalsAndNewspapers = 'BooksPeriodicalsAndNewspapers',
  BowlingAlleys = 'BowlingAlleys',
  BusLines = 'BusLines',
  BusinessConsulting = 'BusinessConsulting',
  BusinessSecretarialSchools = 'BusinessSecretarialSchools',
  BuyingShoppingServices = 'BuyingShoppingServices',
  CableSatelliteAndOtherPayTelevisionAndRadio = 'CableSatelliteAndOtherPayTelevisionAndRadio',
  CameraAndPhotographicSupplyStores = 'CameraAndPhotographicSupplyStores',
  CandyNutAndConfectioneryStores = 'CandyNutAndConfectioneryStores',
  CarAndTruckDealersNewUsed = 'CarAndTruckDealersNewUsed',
  CarAndTruckDealersUsedOnly = 'CarAndTruckDealersUsedOnly',
  CarRentalAgencies = 'CarRentalAgencies',
  CarWashes = 'CarWashes',
  CarpentryServices = 'CarpentryServices',
  CarpetUpholsteryCleaning = 'CarpetUpholsteryCleaning',
  CashOnDeliveryCourierServices = 'CashOnDeliveryCourierServices',
  Caterers = 'Caterers',
  CharitableAndSocialServiceOrganizationsFundraising = 'CharitableAndSocialServiceOrganizationsFundraising',
  ChemicalsAndAlliedProducts = 'ChemicalsAndAlliedProducts',
  ChildCareServices = 'ChildCareServices',
  ChildrensAndInfantsWearStores = 'ChildrensAndInfantsWearStores',
  ChiropodistsPodiatrists = 'ChiropodistsPodiatrists',
  Chiropractors = 'Chiropractors',
  CigarStoresAndStands = 'CigarStoresAndStands',
  CivicSocialFraternalAssociations = 'CivicSocialFraternalAssociations',
  CleaningAndMaintenance = 'CleaningAndMaintenance',
  ClothingRental = 'ClothingRental',
  CollegesUniversities = 'CollegesUniversities',
  CommercialEquipment = 'CommercialEquipment',
  CommercialFootwear = 'CommercialFootwear',
  CommercialPhotographyArtAndGraphics = 'CommercialPhotographyArtAndGraphics',
  CommuterTransportAndFerries = 'CommuterTransportAndFerries',
  CompanyFormation = 'CompanyFormation',
  ComputerNetworkServices = 'ComputerNetworkServices',
  ComputerProgramming = 'ComputerProgramming',
  ComputerRepair = 'ComputerRepair',
  ComputerSoftwareStores = 'ComputerSoftwareStores',
  ComputersPeripheralsAndSoftware = 'ComputersPeripheralsAndSoftware',
  ConcreteWorkServices = 'ConcreteWorkServices',
  ConstructionMaterials = 'ConstructionMaterials',
  ConsultancyServicesExternal = 'ConsultancyServicesExternal',
  ConsultancyServicesIntragroup = 'ConsultancyServicesIntragroup',
  ConsultingPublicRelations = 'ConsultingPublicRelations',
  ConsumerLoanCompanies = 'ConsumerLoanCompanies',
  CorrespondenceSchools = 'CorrespondenceSchools',
  CosmeticStores = 'CosmeticStores',
  CounselingServices = 'CounselingServices',
  CounterfeitGoods = 'CounterfeitGoods',
  CountryClubs = 'CountryClubs',
  CourierServices = 'CourierServices',
  CourtCosts = 'CourtCosts',
  CreditReportingAgencies = 'CreditReportingAgencies',
  CrowdFunding = 'CrowdFunding',
  CruiseLines = 'CruiseLines',
  CryptoCurrencyInfrastructureProviders = 'CryptoCurrencyInfrastructureProviders',
  DairyProductsStores = 'DairyProductsStores',
  DanceHallStudiosSchools = 'DanceHallStudiosSchools',
  DatingEscortServices = 'DatingEscortServices',
  DatingNetworks = 'DatingNetworks',
  DentistsOrthodontists = 'DentistsOrthodontists',
  DepartmentStores = 'DepartmentStores',
  DetectiveAgencies = 'DetectiveAgencies',
  DigitalArt = 'DigitalArt',
  DigitalGoods = 'DigitalGoods',
  DigitalGoodsApplications = 'DigitalGoodsApplications',
  DigitalGoodsGames = 'DigitalGoodsGames',
  DigitalGoodsLargeVolume = 'DigitalGoodsLargeVolume',
  DigitalGoodsMedia = 'DigitalGoodsMedia',
  DirectMarketingCatalogMerchant = 'DirectMarketingCatalogMerchant',
  DirectMarketingCombinationCatalogAndRetailMerchant = 'DirectMarketingCombinationCatalogAndRetailMerchant',
  DirectMarketingInboundTelemarketing = 'DirectMarketingInboundTelemarketing',
  DirectMarketingInsuranceServices = 'DirectMarketingInsuranceServices',
  DirectMarketingOther = 'DirectMarketingOther',
  DirectMarketingOutboundTelemarketing = 'DirectMarketingOutboundTelemarketing',
  DirectMarketingSubscription = 'DirectMarketingSubscription',
  DirectMarketingTravel = 'DirectMarketingTravel',
  DiscountStores = 'DiscountStores',
  Doctors = 'Doctors',
  DoorToDoorSales = 'DoorToDoorSales',
  DraperyWindowCoveringAndUpholsteryStores = 'DraperyWindowCoveringAndUpholsteryStores',
  DrinkingPlaces = 'DrinkingPlaces',
  DrugStoresAndPharmacies = 'DrugStoresAndPharmacies',
  DrugsDrugProprietariesAndDruggistSundries = 'DrugsDrugProprietariesAndDruggistSundries',
  DryCleaners = 'DryCleaners',
  DurableGoods = 'DurableGoods',
  DutyFreeStores = 'DutyFreeStores',
  ESports = 'ESports',
  EWallet = 'EWallet',
  EatingPlacesRestaurants = 'EatingPlacesRestaurants',
  EducationalServices = 'EducationalServices',
  ElectricRazorStores = 'ElectricRazorStores',
  ElectricalPartsAndEquipment = 'ElectricalPartsAndEquipment',
  ElectricalServices = 'ElectricalServices',
  ElectronicsRepairShops = 'ElectronicsRepairShops',
  ElectronicsStores = 'ElectronicsStores',
  ElementarySecondarySchools = 'ElementarySecondarySchools',
  EmploymentTempAgencies = 'EmploymentTempAgencies',
  EquipmentRental = 'EquipmentRental',
  EscortServices = 'EscortServices',
  EventPlanning = 'EventPlanning',
  ExterminatingServices = 'ExterminatingServices',
  FactoringCompany = 'FactoringCompany',
  FamilyClothingStores = 'FamilyClothingStores',
  FantasySports = 'FantasySports',
  FastFoodRestaurants = 'FastFoodRestaurants',
  FinancialInstitutions = 'FinancialInstitutions',
  FinesGovernmentAdministrativeEntities = 'FinesGovernmentAdministrativeEntities',
  FireplaceFireplaceScreensAndAccessoriesStores = 'FireplaceFireplaceScreensAndAccessoriesStores',
  FloorCoveringStores = 'FloorCoveringStores',
  Florists = 'Florists',
  FloristsSuppliesNurseryStockAndFlowers = 'FloristsSuppliesNurseryStockAndFlowers',
  ForexBrokers = 'ForexBrokers',
  FreezerAndLockerMeatProvisioners = 'FreezerAndLockerMeatProvisioners',
  FuelDealersNonAutomotive = 'FuelDealersNonAutomotive',
  FuneralServicesCrematories = 'FuneralServicesCrematories',
  FurnitureHomeFurnishingsAndEquipmentStoresExceptAppliances = 'FurnitureHomeFurnishingsAndEquipmentStoresExceptAppliances',
  FurnitureRepairRefinishing = 'FurnitureRepairRefinishing',
  FurriersAndFurShops = 'FurriersAndFurShops',
  GameSkinProviders = 'GameSkinProviders',
  GamingWebsites = 'GamingWebsites',
  GeneralServices = 'GeneralServices',
  GetRichQuickSchemes = 'GetRichQuickSchemes',
  GiftCardNoveltyAndSouvenirShops = 'GiftCardNoveltyAndSouvenirShops',
  GlassPaintAndWallpaperStores = 'GlassPaintAndWallpaperStores',
  GlasswareCrystalStores = 'GlasswareCrystalStores',
  GolfCoursesPublic = 'GolfCoursesPublic',
  GovernmentServices = 'GovernmentServices',
  GroceryStoresSupermarkets = 'GroceryStoresSupermarkets',
  HardwareEquipmentAndSupplies = 'HardwareEquipmentAndSupplies',
  HardwareStores = 'HardwareStores',
  Hawala = 'Hawala',
  HealthAndBeautySpas = 'HealthAndBeautySpas',
  HearingAidsSalesAndSupplies = 'HearingAidsSalesAndSupplies',
  HeatingPlumbingAc = 'HeatingPlumbingAC',
  HighValueGoods = 'HighValueGoods',
  HobbyToyAndGameShops = 'HobbyToyAndGameShops',
  HoldingCompanies = 'HoldingCompanies',
  HomeSupplyWarehouseStores = 'HomeSupplyWarehouseStores',
  Hospitals = 'Hospitals',
  HotelsMotelsAndResorts = 'HotelsMotelsAndResorts',
  HouseholdApplianceStores = 'HouseholdApplianceStores',
  ItDevelopers = 'ITDevelopers',
  ItOnlineGamblingBetting = 'ITOnlineGamblingBetting',
  ItProductPublishers = 'ITProductPublishers',
  ItVirtualCurrencyBlockchain = 'ITVirtualCurrencyBlockchain',
  IndustrialSupplies = 'IndustrialSupplies',
  InformationRetrievalServices = 'InformationRetrievalServices',
  InsuranceDefault = 'InsuranceDefault',
  InsuranceUnderwritingPremiums = 'InsuranceUnderwritingPremiums',
  InternetBusinessBackuppers = 'InternetBusinessBackuppers',
  IntraCompanyPurchases = 'IntraCompanyPurchases',
  InvestmentActivity = 'InvestmentActivity',
  JewelryStoresWatchesClocksAndSilverwareStores = 'JewelryStoresWatchesClocksAndSilverwareStores',
  LandscapingServices = 'LandscapingServices',
  Laundries = 'Laundries',
  LaundryCleaningServices = 'LaundryCleaningServices',
  LegalServicesAttorneys = 'LegalServicesAttorneys',
  LicensedCannabidiolRelatedProducts = 'LicensedCannabidiolRelatedProducts',
  LiquidityProvider = 'LiquidityProvider',
  LuggageAndLeatherGoodsStores = 'LuggageAndLeatherGoodsStores',
  LumberBuildingMaterialsStores = 'LumberBuildingMaterialsStores',
  ManualCashDisburse = 'ManualCashDisburse',
  MarinasServiceAndSupplies = 'MarinasServiceAndSupplies',
  MasonryStoneworkAndPlaster = 'MasonryStoneworkAndPlaster',
  MassageParlors = 'MassageParlors',
  MedicalAndDentalLabs = 'MedicalAndDentalLabs',
  MedicalDentalOphthalmicAndHospitalEquipmentAndSupplies = 'MedicalDentalOphthalmicAndHospitalEquipmentAndSupplies',
  MedicalServices = 'MedicalServices',
  MembershipOrganizations = 'MembershipOrganizations',
  MensAndBoysClothingAndAccessoriesStores = 'MensAndBoysClothingAndAccessoriesStores',
  MensWomensClothingStores = 'MensWomensClothingStores',
  MetalServiceCenters = 'MetalServiceCenters',
  MiscellaneousApparelAndAccessoryShops = 'MiscellaneousApparelAndAccessoryShops',
  MiscellaneousAutoDealers = 'MiscellaneousAutoDealers',
  MiscellaneousBusinessServices = 'MiscellaneousBusinessServices',
  MiscellaneousFoodStores = 'MiscellaneousFoodStores',
  MiscellaneousGeneralMerchandise = 'MiscellaneousGeneralMerchandise',
  MiscellaneousGeneralServices = 'MiscellaneousGeneralServices',
  MiscellaneousHomeFurnishingSpecialtyStores = 'MiscellaneousHomeFurnishingSpecialtyStores',
  MiscellaneousPublishingAndPrinting = 'MiscellaneousPublishingAndPrinting',
  MiscellaneousRecreationServices = 'MiscellaneousRecreationServices',
  MiscellaneousRepairShops = 'MiscellaneousRepairShops',
  MiscellaneousSpecialtyRetail = 'MiscellaneousSpecialtyRetail',
  MobileAppDeveloper = 'MobileAppDeveloper',
  MobileHomeDealers = 'MobileHomeDealers',
  MotionPictureTheaters = 'MotionPictureTheaters',
  MotorFreightCarriersAndTrucking = 'MotorFreightCarriersAndTrucking',
  MotorHomesDealers = 'MotorHomesDealers',
  MotorVehicleSuppliesAndNewParts = 'MotorVehicleSuppliesAndNewParts',
  MotorcycleShopsAndDealers = 'MotorcycleShopsAndDealers',
  MotorcycleShopsDealers = 'MotorcycleShopsDealers',
  MultiLevelMarketing = 'MultiLevelMarketing',
  MultimediaRental = 'MultimediaRental',
  MusicStoresMusicalInstrumentsPianosAndSheetMusic = 'MusicStoresMusicalInstrumentsPianosAndSheetMusic',
  NewsDealersAndNewsstands = 'NewsDealersAndNewsstands',
  NonFiMoneyOrders = 'NonFiMoneyOrders',
  NonFiStoredValueCardPurchaseLoad = 'NonFiStoredValueCardPurchaseLoad',
  NonGovernmentalOrganisation = 'NonGovernmentalOrganisation',
  NonProfit = 'NonProfit',
  NondurableGoods = 'NondurableGoods',
  NurseriesLawnAndGardenSupplyStores = 'NurseriesLawnAndGardenSupplyStores',
  NursingPersonalCare = 'NursingPersonalCare',
  OfficeAndCommercialFurniture = 'OfficeAndCommercialFurniture',
  OnlineBetting = 'OnlineBetting',
  OnlineCasinos = 'OnlineCasinos',
  OnlineCharities = 'OnlineCharities',
  OnlineEducationalServices = 'OnlineEducationalServices',
  OnlineLotteries = 'OnlineLotteries',
  OnlineMarketingCampaigns = 'OnlineMarketingCampaigns',
  OnlineMarketplaces = 'OnlineMarketplaces',
  OnlineMediaArticles = 'OnlineMediaArticles',
  OnlineMembership = 'OnlineMembership',
  OnlinePropertyRental = 'OnlinePropertyRental',
  OnlineResourcesForScholars = 'OnlineResourcesForScholars',
  OnlineSlotMachines = 'OnlineSlotMachines',
  OnlineTrainingEducation = 'OnlineTrainingEducation',
  OpticiansEyeglasses = 'OpticiansEyeglasses',
  OptometristsOphthalmologist = 'OptometristsOphthalmologist',
  OrthopedicGoodsProstheticDevices = 'OrthopedicGoodsProstheticDevices',
  Osteopaths = 'Osteopaths',
  Other = 'Other',
  OtherCfdMarginTradingBrokers = 'OtherCFDMarginTradingBrokers',
  OtherFinancialIntermediaries = 'OtherFinancialIntermediaries',
  PackageStoresBeerWineAndLiquor = 'PackageStoresBeerWineAndLiquor',
  PaintsVarnishesAndSupplies = 'PaintsVarnishesAndSupplies',
  ParkingLotsGarages = 'ParkingLotsGarages',
  PassengerRailways = 'PassengerRailways',
  PawnShops = 'PawnShops',
  PaymentFacilitatorServiceProvider = 'PaymentFacilitatorServiceProvider',
  PaymentInfrastructureProviders = 'PaymentInfrastructureProviders',
  PaymentInstitution = 'PaymentInstitution',
  PaymentManagementServices = 'PaymentManagementServices',
  PaymentManagementServicesAdult = 'PaymentManagementServicesAdult',
  PaymentManagementServicesForex = 'PaymentManagementServicesForex',
  PaymentManagementServicesOnlineGambling = 'PaymentManagementServicesOnlineGambling',
  PaymentManagementServicesPsp = 'PaymentManagementServicesPsp',
  PaymentServiceProviders = 'PaymentServiceProviders',
  PetShopsPetFoodAndSupplies = 'PetShopsPetFoodAndSupplies',
  PetroleumAndPetroleumProducts = 'PetroleumAndPetroleumProducts',
  Pharmaceuticals = 'Pharmaceuticals',
  PhotoDeveloping = 'PhotoDeveloping',
  PhotographicPhotocopyMicrofilmEquipmentAndSupplies = 'PhotographicPhotocopyMicrofilmEquipmentAndSupplies',
  PhotographicStudios = 'PhotographicStudios',
  PhysicalGoods = 'PhysicalGoods',
  PhysicallyPresentServices = 'PhysicallyPresentServices',
  PictureVideoProduction = 'PictureVideoProduction',
  PieceGoodsNotionsAndOtherDryGoods = 'PieceGoodsNotionsAndOtherDryGoods',
  PiracyOrIllegalStreaming = 'PiracyOrIllegalStreaming',
  PlumbingHeatingEquipmentAndSupplies = 'PlumbingHeatingEquipmentAndSupplies',
  PoliticalOrganizations = 'PoliticalOrganizations',
  PostalServicesGovernmentOnly = 'PostalServicesGovernmentOnly',
  PreciousStonesAndMetalsWatchesAndJewelry = 'PreciousStonesAndMetalsWatchesAndJewelry',
  ProfessionalServices = 'ProfessionalServices',
  PublicWarehousingAndStorage = 'PublicWarehousingAndStorage',
  QuasiCash = 'QuasiCash',
  QuickCopyReproAndBlueprint = 'QuickCopyReproAndBlueprint',
  Railroads = 'Railroads',
  RealEstateAgentsAndManagersRentals = 'RealEstateAgentsAndManagersRentals',
  RecordStores = 'RecordStores',
  RecreationalVehicleRentals = 'RecreationalVehicleRentals',
  RecruitmentServices = 'RecruitmentServices',
  ReligiousGoodsStores = 'ReligiousGoodsStores',
  ReligiousOrganizations = 'ReligiousOrganizations',
  RoofingSidingSheetMetal = 'RoofingSidingSheetMetal',
  SecretarialSupportServices = 'SecretarialSupportServices',
  SecurityBrokersDealers = 'SecurityBrokersDealers',
  ServiceStations = 'ServiceStations',
  SewingNeedleworkFabricAndPieceGoodsStores = 'SewingNeedleworkFabricAndPieceGoodsStores',
  ShellBanks = 'ShellBanks',
  ShoeRepairHatCleaning = 'ShoeRepairHatCleaning',
  ShoeStores = 'ShoeStores',
  SkillGames = 'SkillGames',
  SmallApplianceRepair = 'SmallApplianceRepair',
  SnowmobileDealers = 'SnowmobileDealers',
  SocialMediaInfluencers = 'SocialMediaInfluencers',
  SpecialTradeServices = 'SpecialTradeServices',
  SpecialtyCleaning = 'SpecialtyCleaning',
  SportingGoodsStores = 'SportingGoodsStores',
  SportingRecreationCamps = 'SportingRecreationCamps',
  SportsAndRidingApparelStores = 'SportsAndRidingApparelStores',
  SportsClubsFields = 'SportsClubsFields',
  StampAndCoinStores = 'StampAndCoinStores',
  StationaryOfficeSuppliesPrintingAndWritingPaper = 'StationaryOfficeSuppliesPrintingAndWritingPaper',
  StationeryStoresOfficeAndSchoolSupplyStores = 'StationeryStoresOfficeAndSchoolSupplyStores',
  Sweepstakes = 'Sweepstakes',
  SwimmingPoolsSales = 'SwimmingPoolsSales',
  TUiTravelGermany = 'TUiTravelGermany',
  TailorsAlterations = 'TailorsAlterations',
  TaxPaymentsGovernmentAgencies = 'TaxPaymentsGovernmentAgencies',
  TaxPreparationServices = 'TaxPreparationServices',
  TaxicabsLimousines = 'TaxicabsLimousines',
  TelecommunicationEquipmentAndTelephoneSales = 'TelecommunicationEquipmentAndTelephoneSales',
  TelecommunicationServices = 'TelecommunicationServices',
  TelegraphServices = 'TelegraphServices',
  TentAndAwningShops = 'TentAndAwningShops',
  TestingLaboratories = 'TestingLaboratories',
  TheatricalTicketAgencies = 'TheatricalTicketAgencies',
  Timeshares = 'Timeshares',
  TireRetreadingAndRepair = 'TireRetreadingAndRepair',
  TollsBridgeFees = 'TollsBridgeFees',
  TouristAttractionsAndExhibits = 'TouristAttractionsAndExhibits',
  TowingServices = 'TowingServices',
  TrafficOptimization = 'TrafficOptimization',
  TrailerParksCampgrounds = 'TrailerParksCampgrounds',
  TransportationServices = 'TransportationServices',
  TravelAgenciesTourOperators = 'TravelAgenciesTourOperators',
  TruckStopIteration = 'TruckStopIteration',
  TruckUtilityTrailerRentals = 'TruckUtilityTrailerRentals',
  TypesettingPlateMakingAndRelatedServices = 'TypesettingPlateMakingAndRelatedServices',
  TypewriterStores = 'TypewriterStores',
  UsFederalGovernmentAgenciesOrDepartments = 'USFederalGovernmentAgenciesOrDepartments',
  UniformsCommercialClothing = 'UniformsCommercialClothing',
  UnlicensedCannabidiolRelatedProducts = 'UnlicensedCannabidiolRelatedProducts',
  UsedMerchandiseAndSecondhandStores = 'UsedMerchandiseAndSecondhandStores',
  Utilities = 'Utilities',
  VarietyStores = 'VarietyStores',
  VeterinaryServices = 'VeterinaryServices',
  VideoAmusementGameSupplies = 'VideoAmusementGameSupplies',
  VideoGameArcades = 'VideoGameArcades',
  VideoTapeRentalStores = 'VideoTapeRentalStores',
  VirtualAssetsCryptoCurrencies = 'VirtualAssetsCryptoCurrencies',
  VocationalTradeSchools = 'VocationalTradeSchools',
  WatchJewelryRepair = 'WatchJewelryRepair',
  Weapons = 'Weapons',
  WebpageAdministrators = 'WebpageAdministrators',
  WeldingRepair = 'WeldingRepair',
  WholesaleClubs = 'WholesaleClubs',
  WigAndToupeeStores = 'WigAndToupeeStores',
  WiresMoneyOrders = 'WiresMoneyOrders',
  WomensAccessoryAndSpecialtyShops = 'WomensAccessoryAndSpecialtyShops',
  WomensReadyToWearStores = 'WomensReadyToWearStores',
  WreckingAndSalvageYards = 'WreckingAndSalvageYards'
}

export enum BusinessRegion {
  Africa = 'Africa',
  Asia = 'Asia',
  Australia = 'Australia',
  Cis = 'Cis',
  Eea = 'Eea',
  NorthAmerica = 'NorthAmerica',
  SouthAmerica = 'SouthAmerica',
  Uk = 'UK'
}

export enum Camt056CancellationReasonCode {
  Cust = 'CUST',
  Dupl = 'DUPL',
  Frad = 'FRAD',
  Tech = 'TECH'
}

export type Card3DSecureSettings = {
  __typename?: 'Card3DSecureSettings';
  languageCode?: Maybe<ApiCard3DSecureLanguageCode>;
  mobile?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ApiCard3DSecureTypes>;
};

export type CardAdjustmentTransactionRequestInfoInput = {
  amount: Scalars['Float']['input'];
  comments: Scalars['String']['input'];
  entryType: TransactionEntryType;
  internalComments: Scalars['String']['input'];
  refTransactionId: Scalars['ID']['input'];
};

export type CardAdjustmentTransactionRequestRequest = BaseApprovalRequest & {
  __typename?: 'CardAdjustmentTransactionRequestRequest';
  account?: Maybe<Account>;
  adjustmentDetails?: Maybe<CardTransactionAdjustmentInfo>;
  affectedEntity?: Maybe<Scalars['String']['output']>;
  affectedEntityId?: Maybe<Scalars['ID']['output']>;
  approvals?: Maybe<Array<Maybe<UserRequestApprovalType>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  executionError?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  requestType?: Maybe<ApprovalRequestType>;
  setting?: Maybe<ApprovalRequestSetting>;
  status?: Maybe<ApprovalRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** CardAllowedLimitsType */
export type CardAllowedLimitsType = {
  __typename?: 'CardAllowedLimitsType';
  defaults?: Maybe<DefaultCardAllowedLimitsType>;
  maxes?: Maybe<MaxCardAllowedLimitsType>;
  weeklyLimitsEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type CardIssueRequestAction = BaseAction & {
  __typename?: 'CardIssueRequestAction';
  appFields?: Maybe<AppFields>;
  cardRequest?: Maybe<CardRequestType>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CardIssueRequestActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export type CardLimitInputType = {
  amount: Scalars['Float']['input'];
  limitType: CardSpendingLimitTypes;
};

export type CardLimitWithUsage = {
  __typename?: 'CardLimitWithUsage';
  amount: Scalars['Float']['output'];
  available: Scalars['Float']['output'];
  limitType: CardSpendingLimitTypes;
  used: Scalars['Float']['output'];
};

export type CardPaymentsAndAmp = {
  __typename?: 'CardPaymentsAndAMP';
  ampCurrentlyInUse?: Maybe<Array<Maybe<AmpInUse>>>;
  ampRequiredCurrentlyInUse?: Maybe<Array<Maybe<AmpInUse>>>;
  cardPaymentsTransactionalDataRegion?: Maybe<Array<Maybe<CardPaymentsTransactionalDataRegion>>>;
  isCardPayment?: Maybe<Scalars['Boolean']['output']>;
  merchantWebsites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pciDssCompliance?: Maybe<PciDssCompliance>;
  processingHistory?: Maybe<CardProcessingHistory>;
  requiredSettlementCurrencies?: Maybe<Array<Maybe<Currency>>>;
  riskManagement?: Maybe<CardProcessingRiskManagement>;
  totalPredictedMonthlyVolumesMasterCard?: Maybe<TotalPredictedMonthlyVolumes>;
  totalPredictedMonthlyVolumesVisa?: Maybe<TotalPredictedMonthlyVolumes>;
  transactionalCurrencies?: Maybe<Array<Maybe<Currency>>>;
};

export type CardPaymentsAndAmpInput = {
  ampCurrentlyInUse?: InputMaybe<Array<InputMaybe<AmpInUseInput>>>;
  ampRequiredCurrentlyInUse?: InputMaybe<Array<InputMaybe<AmpInUseInput>>>;
  cardPaymentsTransactionalDataRegion?: InputMaybe<Array<InputMaybe<CardPaymentsTransactionalDataRegionInput>>>;
  isCardPayment?: InputMaybe<Scalars['Boolean']['input']>;
  merchantWebsites?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pciDssCompliance?: InputMaybe<PciDssComplianceInput>;
  processingHistory?: InputMaybe<CardProcessingHistoryInput>;
  requiredSettlementCurrencies?: InputMaybe<Array<InputMaybe<Currency>>>;
  riskManagement?: InputMaybe<CardProcessingRiskManagementInput>;
  totalPredictedMonthlyVolumesMasterCard?: InputMaybe<TotalPredictedMonthlyVolumesInput>;
  totalPredictedMonthlyVolumesVisa?: InputMaybe<TotalPredictedMonthlyVolumesInput>;
  transactionalCurrencies?: InputMaybe<Array<InputMaybe<Currency>>>;
};

export type CardPaymentsTransactionalDataRegion = {
  __typename?: 'CardPaymentsTransactionalDataRegion';
  businessCategoryPercentage?: Maybe<Scalars['Float']['output']>;
  businessCategoryRegion?: Maybe<BusinessRegion>;
};

export type CardPaymentsTransactionalDataRegionInput = {
  businessCategoryPercentage?: InputMaybe<Scalars['Float']['input']>;
  businessCategoryRegion?: InputMaybe<BusinessRegion>;
};

export type CardProcessingHistory = {
  __typename?: 'CardProcessingHistory';
  nameOfCurrentFormerProcessor?: Maybe<Scalars['String']['output']>;
  periodOfTimeWithCurrentFormerProcessor?: Maybe<Scalars['String']['output']>;
  processPaymentCardsBefore?: Maybe<Scalars['Boolean']['output']>;
  processingHistoryStatement?: Maybe<Document>;
  reasonForLeavingCurrentProcessor?: Maybe<Scalars['String']['output']>;
};

export type CardProcessingHistoryInput = {
  nameOfCurrentFormerProcessor?: InputMaybe<Scalars['String']['input']>;
  periodOfTimeWithCurrentFormerProcessor?: InputMaybe<Scalars['String']['input']>;
  processPaymentCardsBefore?: InputMaybe<Scalars['Boolean']['input']>;
  processingHistoryStatement?: InputMaybe<DocumentInput>;
  reasonForLeavingCurrentProcessor?: InputMaybe<Scalars['String']['input']>;
};

export type CardProcessingRiskManagement = {
  __typename?: 'CardProcessingRiskManagement';
  affiliatesUsed?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  credentialDetailsExplanation?: Maybe<Scalars['String']['output']>;
  relevantCredentialOnFilesBillingSalesMethod?: Maybe<RelevantCredentialOnFilesBillingSalesMethod>;
  useAffiliateForGeneratingTraffic?: Maybe<Scalars['Boolean']['output']>;
  useCredentialOnFilesBillingSalesMethod?: Maybe<Scalars['Boolean']['output']>;
};

export type CardProcessingRiskManagementInput = {
  affiliatesUsed?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  credentialDetailsExplanation?: InputMaybe<Scalars['String']['input']>;
  relevantCredentialOnFilesBillingSalesMethod?: InputMaybe<RelevantCredentialOnFilesBillingSalesMethod>;
  useAffiliateForGeneratingTraffic?: InputMaybe<Scalars['Boolean']['input']>;
  useCredentialOnFilesBillingSalesMethod?: InputMaybe<Scalars['Boolean']['input']>;
};

/** card request type */
export type CardRequestType = {
  __typename?: 'CardRequestType';
  /** Account */
  account?: Maybe<Account>;
  /** cardType */
  card?: Maybe<CardType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** actionType */
  executionAction?: Maybe<Action>;
  /** contractAuthorizedPerson */
  holder?: Maybe<ContractAuthorizedPersonType>;
  /** Issue Card ID */
  id: Scalars['Int']['output'];
  lastError?: Maybe<Scalars['JSON']['output']>;
  /** limits */
  limits?: Maybe<Array<Maybe<LimitObjectType>>>;
  requestedBy?: Maybe<Individual>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CardSecurityType = {
  __typename?: 'CardSecurityType';
  contactlessEnabled?: Maybe<Scalars['Boolean']['output']>;
  internetPurchaseEnabled?: Maybe<Scalars['Boolean']['output']>;
  overallLimitsEnabled?: Maybe<Scalars['Boolean']['output']>;
  withdrawalEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** CardSensitiveInfoRef */
export type CardSensitiveInfoRef = {
  __typename?: 'CardSensitiveInfoRef';
  token?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** CardSensitiveInfoType */
export type CardSensitiveInfoType = {
  __typename?: 'CardSensitiveInfoType';
  cardNumber?: Maybe<Scalars['String']['output']>;
  cvv?: Maybe<Scalars['String']['output']>;
};

export enum CardSpendingLimitTypes {
  DailyContactlessPurchase = 'dailyContactlessPurchase',
  DailyInternetPurchase = 'dailyInternetPurchase',
  DailyPurchase = 'dailyPurchase',
  DailyWithdrawal = 'dailyWithdrawal',
  MonthlyContactlessPurchase = 'monthlyContactlessPurchase',
  MonthlyInternetPurchase = 'monthlyInternetPurchase',
  MonthlyPurchase = 'monthlyPurchase',
  MonthlyWithdrawal = 'monthlyWithdrawal',
  TransactionContactlessPurchase = 'transactionContactlessPurchase',
  TransactionInternetPurchase = 'transactionInternetPurchase',
  TransactionPurchase = 'transactionPurchase',
  TransactionWithdrawal = 'transactionWithdrawal',
  WeeklyContactlessPurchase = 'weeklyContactlessPurchase',
  WeeklyInternetPurchase = 'weeklyInternetPurchase',
  WeeklyPurchase = 'weeklyPurchase',
  WeeklyWithdrawal = 'weeklyWithdrawal'
}

export enum CardStatuses {
  Active = 'active',
  AwaitingRenewal = 'awaitingRenewal',
  Blocked = 'blocked',
  Closed = 'closed',
  Closing = 'closing',
  Created = 'created',
  Dispatched = 'dispatched',
  Expired = 'expired',
  InActive = 'inActive',
  Ordered = 'ordered',
  Pending = 'pending',
  Personalized = 'personalized',
  Rejected = 'rejected'
}

export type CardTransactionAdjustmentInfo = {
  __typename?: 'CardTransactionAdjustmentInfo';
  amount: Scalars['Float']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  entryType?: Maybe<TransactionEntryType>;
  internalComments?: Maybe<Scalars['String']['output']>;
  refTransactionId?: Maybe<Scalars['ID']['output']>;
};

export type CardTransactionAuthorization = {
  __typename?: 'CardTransactionAuthorization';
  accountAmount?: Maybe<Scalars['Float']['output']>;
  accountCurrency?: Maybe<Scalars['String']['output']>;
  acquiringInstitutionCountry?: Maybe<Scalars['String']['output']>;
  acquiringInstitutionId?: Maybe<Scalars['ID']['output']>;
  authorizationDate?: Maybe<Scalars['DateTime']['output']>;
  card?: Maybe<CardType>;
  card3dsAuthenticationType?: Maybe<Scalars['String']['output']>;
  card3dsCavvValidationResult?: Maybe<Scalars['String']['output']>;
  card3dsIndicator?: Maybe<Scalars['String']['output']>;
  clearedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isContactless?: Maybe<Scalars['Boolean']['output']>;
  isMassTransit?: Maybe<Scalars['Boolean']['output']>;
  isReversed?: Maybe<Scalars['Boolean']['output']>;
  merchantCategoryCode?: Maybe<Scalars['String']['output']>;
  merchantCity?: Maybe<Scalars['String']['output']>;
  merchantCountry?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
  originalAuthorizationId?: Maybe<Scalars['String']['output']>;
  releasedAt?: Maybe<Scalars['DateTime']['output']>;
  responseCode?: Maybe<Scalars['String']['output']>;
  retrievalReferenceNumber?: Maybe<Scalars['String']['output']>;
  terminalId?: Maybe<Scalars['String']['output']>;
  terminalSupportsPartialApprovals?: Maybe<Scalars['Boolean']['output']>;
  transactionAmount?: Maybe<Scalars['Float']['output']>;
  transactionCurrency?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CardTransactionClearingWorkerLog = {
  __typename?: 'CardTransactionClearingWorkerLog';
  error?: Maybe<Scalars['JSON']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  runTime?: Maybe<Scalars['DateTime']['output']>;
  s3URL?: Maybe<Scalars['String']['output']>;
  submittedBy?: Maybe<User>;
};

export type CardTransactionDetails = {
  __typename?: 'CardTransactionDetails';
  cardholderName?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  maskedCardNumber?: Maybe<Scalars['String']['output']>;
};

/** card */
export type CardType = {
  __typename?: 'CardType';
  /** Card3DSecureSettings */
  _3dSecureSettings?: Maybe<Card3DSecureSettings>;
  /** Account */
  account?: Maybe<Account>;
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  apiDeliveryAddress?: Maybe<Address>;
  apiEmbossingName?: Maybe<Scalars['String']['output']>;
  apiMaskedCardNumber?: Maybe<Scalars['String']['output']>;
  apiPersonalizationProductCode?: Maybe<Scalars['String']['output']>;
  /** cardHolder */
  cardHolder?: Maybe<ContractAuthorizedPersonType>;
  /** cardRequestType */
  cardRequest?: Maybe<CardRequestType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Currency associated with account */
  currency?: Maybe<Currency>;
  expiryDate?: Maybe<Scalars['Date']['output']>;
  /** Card Account Limits With Usage */
  extAccountLimitsWithUsage?: Maybe<Array<Maybe<CardLimitWithUsage>>>;
  /** Freeze Activity logs */
  freezeLog?: Maybe<Array<Maybe<FreezeLog>>>;
  /** Card ID */
  id: Scalars['ID']['output'];
  isCard3dSecureActivated?: Maybe<Scalars['Boolean']['output']>;
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** limitsWithUsage */
  limitsWithUsage?: Maybe<Array<Maybe<CardLimitWithUsage>>>;
  otpDeliveryMethod?: Maybe<Scalars['String']['output']>;
  /** cardSecurityType */
  settings?: Maybe<CardSecurityType>;
  status?: Maybe<CardStatuses>;
  type?: Maybe<ApiCardTypes>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** card */
export type CardTypeFreezeLogArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  company?: InputMaybe<Company>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Country>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  excludePinned?: InputMaybe<Scalars['Boolean']['input']>;
  feeGroupId?: InputMaybe<Scalars['ID']['input']>;
  includeNullClientId?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerId?: InputMaybe<Scalars['ID']['input']>;
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyPinned?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  origins?: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  standingOrderId?: InputMaybe<Scalars['ID']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ActivityLogTypeType>;
  types?: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Which field to order the query results by */
export enum CardsOrderBy {
  AccountId = 'accountId',
  Alias = 'alias',
  CardNumber = 'cardNumber',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  Id = 'id',
  IssuedAt = 'issuedAt',
  Owner = 'owner',
  Status = 'status',
  Type = 'type'
}

/** Cashback Detail */
export type CashbackDetail = {
  __typename?: 'CashbackDetail';
  cashbackName?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  internalFields?: Maybe<CashbackDetailInternalField>;
  /** Source Transaction */
  sourceTransaction?: Maybe<Transaction>;
};

/** Cashback Detail Internal Field */
export type CashbackDetailInternalField = {
  __typename?: 'CashbackDetailInternalField';
  /** Cashback Transaction */
  cashbackTransaction: Transaction;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  /** Fee Group to Fee */
  feeGroupToFee?: Maybe<FeeGroupToFee>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ChargesInformation = {
  __typename?: 'ChargesInformation';
  agent?: Maybe<ChargesInformationAgent>;
  amount?: Maybe<AmountCurrency>;
};

export type ChargesInformationAgent = {
  __typename?: 'ChargesInformationAgent';
  bicfi?: Maybe<Scalars['String']['output']>;
};

/** Check */
export type Check = {
  __typename?: 'Check';
  applicableTo?: Maybe<Array<Maybe<CheckableEntityType>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<CheckItem>>>;
  lastUpdatedBy?: Maybe<User>;
  name?: Maybe<Scalars['String']['output']>;
  processorKey?: Maybe<CheckKey>;
  type?: Maybe<CheckType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CheckItem = {
  __typename?: 'CheckItem';
  name?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CheckItemInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CheckItemResult = {
  __typename?: 'CheckItemResult';
  item?: Maybe<CheckItem>;
  result?: Maybe<YesNo>;
};

export type CheckItemResultInput = {
  item?: InputMaybe<CheckItemInput>;
  result?: InputMaybe<YesNo>;
};

/** Check keys */
export enum CheckKey {
  ChainalysisWalletChecking = 'chainalysisWalletChecking',
  KompanyPepSanctions = 'kompanyPepSanctions',
  KompanyUbo = 'kompanyUbo',
  KompanyVerifyEntity = 'kompanyVerifyEntity',
  SalvCounterParty = 'salvCounterParty',
  SalvMonitoring = 'salvMonitoring'
}

export type CheckResult = {
  __typename?: 'CheckResult';
  check?: Maybe<Check>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  documents?: Maybe<Array<Maybe<Document>>>;
  externalResults?: Maybe<Scalars['JSON']['output']>;
  failureReason?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  itemResults?: Maybe<Array<Maybe<CheckItemResult>>>;
  lastUpdatedBy?: Maybe<User>;
  notes?: Maybe<Array<Maybe<CheckResultNote>>>;
  performedBy?: Maybe<User>;
  status?: Maybe<CheckResultStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CheckResultNote = {
  __typename?: 'CheckResultNote';
  addedAt?: Maybe<Scalars['DateTime']['output']>;
  addedBy?: Maybe<User>;
  content?: Maybe<Scalars['String']['output']>;
};

/** Status of Check Result */
export enum CheckResultStatus {
  AwaitingResponse = 'awaitingResponse',
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending'
}

/** Type of Checks */
export enum CheckType {
  Automated = 'automated',
  AutomatedThirdParty = 'automatedThirdParty',
  Manual = 'manual',
  ManualThirdParty = 'manualThirdParty'
}

/** Type of Entities That Checks Can Be Performed On */
export enum CheckableEntityType {
  Contract = 'contract',
  Individual = 'individual',
  LegalEntity = 'legalEntity',
  Transaction = 'transaction',
  Wallet = 'wallet'
}

/** Which field to order the query results by */
export enum ChecksOrderBy {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name'
}

export enum ClaimsRecallRequestsStatus {
  Accepted = 'accepted',
  Cancelled = 'cancelled',
  PendingProcessing = 'pendingProcessing',
  PendingResponse = 'pendingResponse',
  Rejected = 'rejected',
  ResponseFailed = 'responseFailed'
}

export enum ClaimsRecallRequestsType {
  ClaimNonReceipt = 'claimNonReceipt',
  RecallRequest = 'recallRequest'
}

export enum ClassificationsType {
  Clarifications = 'clarifications',
  ComplianceRfi = 'complianceRFI',
  GeneralQuery = 'generalQuery'
}

/** Client result type */
export type ClientResult = {
  __typename?: 'ClientResult';
  /** Client */
  client?: Maybe<Individual>;
  /** Status */
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Which field to order the query results by */
export enum ClientsOrderBy {
  CreatedAt = 'createdAt',
  Id = 'id',
  LastLogin = 'lastLogin',
  LastNote = 'lastNote',
  NextAppointment = 'nextAppointment',
  Registration = 'registration'
}

export enum CloseReason {
  ClosedByCardholder = 'ClosedByCardholder',
  ClosedByClient = 'ClosedByClient',
  ClosedByIssuer = 'ClosedByIssuer',
  ClosedByReplace = 'ClosedByReplace',
  ClosedBySystem = 'ClosedBySystem'
}

/** Supported coins */
export type Coin = {
  __typename?: 'Coin';
  /** Chain of the coin */
  chain?: Maybe<Scalars['String']['output']>;
  /** Name of the coin */
  name?: Maybe<Scalars['String']['output']>;
};

/** Commission Detail */
export type CommissionDetail = {
  __typename?: 'CommissionDetail';
  commissionName?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  internalFields?: Maybe<CommissionDetailInternalField>;
  /** Source Transaction */
  sourceTransaction?: Maybe<Transaction>;
};

/** Commission Detail Internal Field */
export type CommissionDetailInternalField = {
  __typename?: 'CommissionDetailInternalField';
  /** Commission Transaction */
  commissionTransaction: Transaction;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  /** Fee Group to Fee */
  feeGroupToFee?: Maybe<FeeGroupToFee>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Contract Comm. Status */
export enum CommunicationStatus {
  Active = 'active',
  Closed = 'closed',
  EscalatedToAcm = 'escalatedToACM',
  Hold = 'hold',
  Inactive = 'inactive',
  WaitingForClarifications = 'waitingForClarifications'
}

/** Klarpay Holdings child companies */
export enum Company {
  Bivial = 'bivial'
}

/** Company Type */
export enum CompanyType {
  JointStockCompany = 'jointStockCompany',
  LimitedLiabilityCompany = 'limitedLiabilityCompany',
  PublicLimitedCompany = 'publicLimitedCompany'
}

/** Compliance log */
export type ComplianceLog = BaseLogInterface & {
  __typename?: 'ComplianceLog';
  /** Account Name */
  accountName?: Maybe<Scalars['String']['output']>;
  /** Alert Type */
  alertType?: Maybe<Scalars['String']['output']>;
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  /** Edit account fields */
  args?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Marketing in/out status */
  marketingInOut?: Maybe<Scalars['String']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** Other affected user ids */
  otherUsers?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Other affected users */
  otherUsersCount?: Maybe<Scalars['String']['output']>;
  /** Reason */
  reason?: Maybe<Scalars['String']['output']>;
  /** Rejection Reason Code */
  rejectionReasonCode?: Maybe<Scalars['String']['output']>;
  /** Account Name */
  remoteId?: Maybe<Scalars['String']['output']>;
  /** SMS in/out status */
  smsInOut?: Maybe<Scalars['Boolean']['output']>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ContactInfoInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Which field to order the query results by */
export enum ContractAuthPersonOrderBy {
  CreatedAt = 'createdAt',
  FirstName = 'firstName',
  Id = 'id',
  InvitedAt = 'invitedAt',
  LastName = 'lastName',
  LastSeen = 'lastSeen',
  SignatoryRight = 'signatoryRight',
  Status = 'status'
}

export type ContractAuthorizedPersonDeactivationAction = BaseAction & {
  __typename?: 'ContractAuthorizedPersonDeactivationAction';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedAuthorizedPerson?: Maybe<ContractAuthorizedPersonType>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ContractAuthorizedPersonDeactivationActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

/** Contract Authorized Person Request Response */
export type ContractAuthorizedPersonRequestResponse = {
  __typename?: 'ContractAuthorizedPersonRequestResponse';
  /** ContractAuthorizedPersonType */
  contractAuthPerson?: Maybe<ContractAuthorizedPersonType>;
  /** actionType */
  executionAction?: Maybe<Action>;
};

/** Bankable Entity Authorized Person */
export type ContractAuthorizedPersonType = {
  __typename?: 'ContractAuthorizedPersonType';
  balanceCurrency?: Maybe<NewAccountCurrency>;
  cannotSignOwnActions?: Maybe<Scalars['Boolean']['output']>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  groupSize?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Date when the invitation was sent */
  invitationDate?: Maybe<Scalars['DateTime']['output']>;
  isAuthorizedSignatory?: Maybe<Scalars['Boolean']['output']>;
  isLimitedAccessHolder?: Maybe<Scalars['Boolean']['output']>;
  isPendingDeactivated?: Maybe<Scalars['Boolean']['output']>;
  limitedAccessRight?: Maybe<LimitedAccessRight>;
  person?: Maybe<Individual>;
  restrictedToAccounts?: Maybe<Array<Maybe<Account>>>;
  signatoryRight?: Maybe<SignatoryRight>;
  status?: Maybe<AuthorizedPersonStatuses>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractChangeAction = BaseAction & {
  __typename?: 'ContractChangeAction';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  contractChange?: Maybe<ProfileChange>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ContractChangeActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

/** Contract Commission Setting Type */
export type ContractCommissionSetting = {
  __typename?: 'ContractCommissionSetting';
  commissionFeeGroup?: Maybe<FeeGroup>;
  /** Contract */
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalPayoutAccount?: Maybe<ExternalPayoutAccount>;
  fixedFee?: Maybe<FixedFee>;
  generatePayouts?: Maybe<Scalars['Boolean']['output']>;
  masterSuccessFeePercentage?: Maybe<Scalars['Float']['output']>;
  nextPayoutDate?: Maybe<Scalars['DateTime']['output']>;
  /** Account */
  payoutAccount?: Maybe<Account>;
  perpetualSuccessFeePeriod?: Maybe<Scalars['Boolean']['output']>;
  schedule?: Maybe<PayoutSchedule>;
  successFeePercentage?: Maybe<Scalars['Float']['output']>;
  successFeePeriod?: Maybe<Scalars['Int']['output']>;
  successFeeVat?: Maybe<Scalars['Float']['output']>;
  tieredCommissionsDetails?: Maybe<TieredCommissions>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractContact = {
  __typename?: 'ContractContact';
  accounts?: Maybe<Array<Maybe<Account>>>;
  canDirectlyUpdateContactInfo?: Maybe<Scalars['Boolean']['output']>;
  contactInfo?: Maybe<ContactInfo>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Contact ID */
  id: Scalars['ID']['output'];
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<ContractContactType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Contract Contact Types */
export enum ContractContactType {
  ContractChanges = 'contractChanges',
  General = 'general',
  Transactions = 'transactions'
}

export type ContractGroup = {
  __typename?: 'ContractGroup';
  attachedContracts?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Contract Requests */
export type ContractInformationRequest = {
  __typename?: 'ContractInformationRequest';
  attachments?: Maybe<Array<Maybe<DocumentSide>>>;
  clientNote?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  documentType?: Maybe<DocumentType>;
  documents?: Maybe<Array<Maybe<Document>>>;
  filledAt?: Maybe<Scalars['DateTime']['output']>;
  filledBy?: Maybe<Individual>;
  id: Scalars['ID']['output'];
  internal?: Maybe<Scalars['Boolean']['output']>;
  internalNote?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  rejectReason?: Maybe<Scalars['String']['output']>;
  requestedBy?: Maybe<User>;
  status?: Maybe<ContractInformationRequestStatus>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ContractInformationRequestType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ContractInformationRequestStatus {
  Completed = 'completed',
  Draft = 'draft',
  Open = 'open',
  Rejected = 'rejected',
  UnderReview = 'underReview'
}

export enum ContractInformationRequestType {
  DocumentRequest = 'documentRequest',
  FreeText = 'freeText'
}

/** Bankable Entity for Individual */
export type ContractInputForIndividualType = {
  /** Economic profile fields */
  economicProfile?: InputMaybe<EconomicProfileInputType>;
  /** Invitation Code for Individual Contracts */
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  person?: InputMaybe<AuthorizedPersonInputType>;
};

export type ContractLog = BaseLogInterface & {
  __typename?: 'ContractLog';
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  /** Contract linked with ActivityLog */
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

export type ContractOnboardProgressType = {
  __typename?: 'ContractOnboardProgressType';
  /** Average client response time (in seconds) */
  avgClientResponseTime?: Maybe<Scalars['Int']['output']>;
  /** Average Klarpay response time (in seconds) */
  avgKlarpayResponseTime?: Maybe<Scalars['Int']['output']>;
  /** Completion percentage */
  completion: Scalars['Float']['output'];
  /** Current action */
  currentAction?: Maybe<Scalars['String']['output']>;
  /** Number of days spent in AMLO */
  daysInAMLO?: Maybe<Scalars['Int']['output']>;
  /** Number of days spent in first line */
  daysInFirstLine?: Maybe<Scalars['Int']['output']>;
  /** Key information provided by account management */
  keyInformation: Scalars['String']['output'];
  /** Last activity date */
  lastActivityDate: Scalars['DateTime']['output'];
  /** Summary synced from Pipe Drive */
  pipeDriveSummary: Scalars['String']['output'];
};

/** Contract Ownership Transfers */
export type ContractOwnershipTransfer = {
  __typename?: 'ContractOwnershipTransfer';
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fromIndividual?: Maybe<Individual>;
  id: Scalars['ID']['output'];
  status?: Maybe<ContractOwnershipTransferStatus>;
  toIndividual?: Maybe<Individual>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ContractOwnershipTransferStatus {
  Completed = 'completed',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type ContractPaymentRecipient = {
  __typename?: 'ContractPaymentRecipient';
  accountNo?: Maybe<Scalars['String']['output']>;
  accountNoType?: Maybe<AccountNoType>;
  address?: Maybe<Address>;
  alias?: Maybe<Scalars['String']['output']>;
  bankBic?: Maybe<Scalars['String']['output']>;
  bankBranchId?: Maybe<Scalars['String']['output']>;
  bankBranchName?: Maybe<Scalars['String']['output']>;
  bankClearingMemberId?: Maybe<Scalars['String']['output']>;
  bankCountry?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  commentTemplate?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Currency>;
  firstName?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kyc?: Maybe<PaymentTransferRecipientKyc>;
  lastName?: Maybe<Scalars['String']['output']>;
  pan?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SwiftTransferRecipientType>;
};

/** Which field to order the query results by */
export enum ContractPaymentRecipientOrderByType {
  AccountNumber = 'accountNumber',
  BankBic = 'bankBic',
  BankName = 'bankName',
  CompanyName = 'companyName',
  ContractId = 'contractId',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  FirstName = 'firstName',
  Iban = 'iban',
  Id = 'id',
  LastName = 'lastName',
  RecipientName = 'recipientName',
  Type = 'type'
}

/** Contract Periodic Review Type */
export type ContractPeriodicReview = {
  __typename?: 'ContractPeriodicReview';
  /** Contract */
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  /** Contract Periodic Review ID */
  id: Scalars['Int']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractProfileChangeAnswers = {
  __typename?: 'ContractProfileChangeAnswers';
  address?: Maybe<Address>;
  /** Legal Entity Business Description */
  businessDescription?: Maybe<Scalars['String']['output']>;
  /** Legal Entity Business Sector */
  businessSector?: Maybe<Scalars['String']['output']>;
  /** Countries the company’s clients are based in */
  companyClientsCountries?: Maybe<Array<Maybe<CountriesAndRegionsType>>>;
  /** Legal Entity Company Name */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Legal Entity Company Reg Date */
  companyRegistrationDate?: Maybe<Scalars['Date']['output']>;
  /** Legal Entity Company Reg ID */
  companyRegistrationId?: Maybe<Scalars['String']['output']>;
  /** Legal Entity Company Type */
  companyType?: Maybe<CompanyType>;
  correspondenceAddress?: Maybe<Address>;
  /** Countries Of Operating And Conducting Business */
  countriesOfOperatingAndConductingBusiness?: Maybe<Array<Maybe<CountriesAndRegionsType>>>;
  economicProfile?: Maybe<EconomicProfile>;
  /** Has professional treasury department */
  hasProfessionalTreasuryDepartment?: Maybe<Scalars['Boolean']['output']>;
  /** Immediate Previous Company Name */
  immediatePreviousCompanyName?: Maybe<Scalars['String']['output']>;
  /** Whether the new client is introducer or not */
  isIntroducer?: Maybe<Scalars['Boolean']['output']>;
  /** Legal Entity Company Type */
  legalEntityType?: Maybe<UboLegalEntityType>;
  /** Legal Entity Phone Number */
  phone?: Maybe<Scalars['String']['output']>;
  preAssessment?: Maybe<PreAssessment>;
  /** Potential Sanctioned Industry */
  sanctionedIndustry?: Maybe<SanctionedIndustry>;
  /** What industries does the company serve */
  servingIndustries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Subject to prudential regulation */
  subjectToPrudentialRegulation?: Maybe<Scalars['Boolean']['output']>;
  /** Tax ID */
  taxId?: Maybe<Scalars['String']['output']>;
  /** Legal Entity Trading Name */
  tradingName?: Maybe<Scalars['String']['output']>;
  transactionalPartners?: Maybe<Array<Maybe<TransactionalPartner>>>;
  /** @deprecated use websites */
  website?: Maybe<Scalars['String']['output']>;
  websites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum ContractRiskCategories {
  DirectOwnershipByNpsMultipleShUbo = 'direct_ownership_by_nps_multiple_sh_ubo',
  DirectOwnershipByNpsSingleShUbo = 'direct_ownership_by_nps_single_sh_ubo',
  HorizontalGroupStructure_3_4Entities = 'horizontal_group_structure_3_4_entities',
  HorizontalGroupStructure_3Entities = 'horizontal_group_structure_3_entities',
  HorizontalGroupStructureMoreThan_5Entities = 'horizontal_group_structure_more_than_5_entities',
  HybridGroupStructure_4Entities = 'hybrid_group_structure_4_entities',
  HybridGroupStructureMoreThan_5Entities = 'hybrid_group_structure_more_than_5_entities',
  NomineeTrusteeOwnershipUboIdentifiable = 'nominee_trustee_ownership_ubo_identifiable',
  NomineeTrusteeOwnershipUboNotIdentifiable = 'nominee_trustee_ownership_ubo_not_identifiable',
  VerticalGroupStructure_2_3Entities = 'vertical_group_structure_2_3_entities',
  VerticalGroupStructure_3_4Entities = 'vertical_group_structure_3_4_entities',
  VerticalGroupStructureMoreThan_5Entities = 'vertical_group_structure_more_than_5_entities'
}

/** Contract Status */
export enum ContractStatusType {
  Active = 'active',
  AmloPending = 'amloPending',
  ChangeRequest = 'changeRequest',
  Draft = 'draft',
  FirstLinePending = 'firstLinePending',
  ManagementConsideration = 'managementConsideration',
  ManagementPending = 'managementPending',
  Monitoring = 'monitoring',
  OnboardingClosed = 'onboardingClosed',
  PreAssessment = 'preAssessment',
  PreAssessmentDraft = 'preAssessmentDraft',
  Rejected = 'rejected',
  SignaturesPending = 'signaturesPending',
  Suspended = 'suspended',
  Terminated = 'terminated',
  TerminationPending = 'terminationPending'
}

/** Contract Technical Details Type */
export type ContractTechnicalDetailsType = {
  __typename?: 'ContractTechnicalDetailsType';
  accessKey?: Maybe<Scalars['String']['output']>;
  contractId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Contract Technical Details ID */
  id: Scalars['ID']['output'];
  paymentWebhook?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  webhookSignatureKey?: Maybe<Scalars['String']['output']>;
};

export enum ContractTermStatus {
  Accepted = 'accepted',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type ContractTerminationAction = BaseAction & {
  __typename?: 'ContractTerminationAction';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ContractTerminationActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

/** Contract Terms */
export type ContractTerms = {
  __typename?: 'ContractTerms';
  approveRejectTime?: Maybe<Scalars['DateTime']['output']>;
  contract: BankableEntityContractType;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  status: ContractTermStatus;
  term: TermsAndCondition;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ContractType {
  Corporate = 'corporate',
  Individual = 'individual',
  IntroducerReference = 'introducerReference',
  Regular = 'regular'
}

/** Contract Ultimate Beneficial Owner */
export type ContractUbo = {
  __typename?: 'ContractUBO';
  addedFromExistingUbo?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ownershipType?: Maybe<UboStakeType>;
  shareSize?: Maybe<Scalars['Float']['output']>;
  ubo?: Maybe<Ubo>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Which field to order the query results by */
export enum ContractsOrderBy {
  ActivatedOn = 'activatedOn',
  CreatedAt = 'createdAt',
  DedicatedAcm = 'dedicatedAcm',
  Id = 'id',
  NextReviewDate = 'nextReviewDate',
  Status = 'status',
  StatusLastChangedAt = 'statusLastChangedAt',
  SubmittedAt = 'submittedAt',
  UpdatedAt = 'updatedAt'
}

export type CorrespondentBankInfo = {
  __typename?: 'CorrespondentBankInfo';
  accountNo?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  instructionForCreditor?: Maybe<Scalars['String']['output']>;
};

export type CorrespondentBankInfoInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  bic: Scalars['String']['input'];
  corr?: InputMaybe<Scalars['String']['input']>;
  ffc?: InputMaybe<Scalars['String']['input']>;
  instructionForCreditor?: InputMaybe<Scalars['String']['input']>;
};

/** CountriesAndRegionsType */
export enum CountriesAndRegionsType {
  Ad = 'ad',
  Ae = 'ae',
  Af = 'af',
  Africa = 'africa',
  Ag = 'ag',
  Ai = 'ai',
  Al = 'al',
  Am = 'am',
  An = 'an',
  Ao = 'ao',
  Aq = 'aq',
  Ar = 'ar',
  As = 'as',
  AsiaPacific = 'asiaPacific',
  At = 'at',
  Au = 'au',
  Aw = 'aw',
  Ax = 'ax',
  Az = 'az',
  Ba = 'ba',
  Bb = 'bb',
  Bd = 'bd',
  Be = 'be',
  Bf = 'bf',
  Bg = 'bg',
  Bh = 'bh',
  Bi = 'bi',
  Bj = 'bj',
  Bl = 'bl',
  Bm = 'bm',
  Bn = 'bn',
  Bo = 'bo',
  Bq = 'bq',
  Br = 'br',
  Bs = 'bs',
  Bt = 'bt',
  Bv = 'bv',
  Bw = 'bw',
  By = 'by',
  Bz = 'bz',
  Ca = 'ca',
  Cc = 'cc',
  Cd = 'cd',
  Cf = 'cf',
  Cg = 'cg',
  Ch = 'ch',
  Ci = 'ci',
  Ck = 'ck',
  Cl = 'cl',
  Cm = 'cm',
  Cn = 'cn',
  Co = 'co',
  Cr = 'cr',
  Cu = 'cu',
  Cv = 'cv',
  Cw = 'cw',
  Cx = 'cx',
  Cy = 'cy',
  Cz = 'cz',
  De = 'de',
  Dj = 'dj',
  Dk = 'dk',
  Dm = 'dm',
  Do = 'do',
  Dz = 'dz',
  Ec = 'ec',
  Ee = 'ee',
  Eg = 'eg',
  Eh = 'eh',
  Er = 'er',
  Es = 'es',
  Et = 'et',
  Europe = 'europe',
  Fi = 'fi',
  Fj = 'fj',
  Fk = 'fk',
  Fm = 'fm',
  Fo = 'fo',
  Fr = 'fr',
  Ga = 'ga',
  Gb = 'gb',
  Gd = 'gd',
  Ge = 'ge',
  Gf = 'gf',
  Gg = 'gg',
  Gh = 'gh',
  Gi = 'gi',
  Gl = 'gl',
  Gm = 'gm',
  Gn = 'gn',
  Gp = 'gp',
  Gq = 'gq',
  Gr = 'gr',
  Gs = 'gs',
  Gt = 'gt',
  Gu = 'gu',
  Gw = 'gw',
  Gy = 'gy',
  Hk = 'hk',
  Hm = 'hm',
  Hn = 'hn',
  Hr = 'hr',
  Ht = 'ht',
  Hu = 'hu',
  Id = 'id',
  Ie = 'ie',
  Il = 'il',
  Im = 'im',
  In = 'in',
  Io = 'io',
  Iq = 'iq',
  Ir = 'ir',
  Is = 'is',
  It = 'it',
  Je = 'je',
  Jm = 'jm',
  Jo = 'jo',
  Jp = 'jp',
  Ke = 'ke',
  Kg = 'kg',
  Kh = 'kh',
  Ki = 'ki',
  Km = 'km',
  Kn = 'kn',
  Kp = 'kp',
  Kr = 'kr',
  Kv = 'kv',
  Kw = 'kw',
  Ky = 'ky',
  Kz = 'kz',
  La = 'la',
  LatinAmerica = 'latinAmerica',
  Lb = 'lb',
  Lc = 'lc',
  Li = 'li',
  Lk = 'lk',
  Lr = 'lr',
  Ls = 'ls',
  Lt = 'lt',
  Lu = 'lu',
  Lv = 'lv',
  Ly = 'ly',
  Ma = 'ma',
  Mc = 'mc',
  Md = 'md',
  Me = 'me',
  Mf = 'mf',
  Mg = 'mg',
  Mh = 'mh',
  MiddleEast = 'middleEast',
  Mk = 'mk',
  Ml = 'ml',
  Mm = 'mm',
  Mn = 'mn',
  Mo = 'mo',
  Mp = 'mp',
  Mq = 'mq',
  Mr = 'mr',
  Ms = 'ms',
  Mt = 'mt',
  Mu = 'mu',
  Mv = 'mv',
  Mw = 'mw',
  Mx = 'mx',
  My = 'my',
  Mz = 'mz',
  Na = 'na',
  Nc = 'nc',
  Ne = 'ne',
  Nf = 'nf',
  Ng = 'ng',
  Ni = 'ni',
  Nl = 'nl',
  No = 'no',
  NorthAmerica = 'northAmerica',
  Np = 'np',
  Nr = 'nr',
  Nu = 'nu',
  Nz = 'nz',
  Om = 'om',
  Pa = 'pa',
  Pe = 'pe',
  Pf = 'pf',
  Pg = 'pg',
  Ph = 'ph',
  Pk = 'pk',
  Pl = 'pl',
  Pm = 'pm',
  Pn = 'pn',
  Pr = 'pr',
  Ps = 'ps',
  Pt = 'pt',
  Pw = 'pw',
  Py = 'py',
  Qa = 'qa',
  Re = 're',
  Ro = 'ro',
  Rs = 'rs',
  Ru = 'ru',
  Rw = 'rw',
  Sa = 'sa',
  Sb = 'sb',
  Sc = 'sc',
  Sd = 'sd',
  Se = 'se',
  Sg = 'sg',
  Sh = 'sh',
  Si = 'si',
  Sj = 'sj',
  Sk = 'sk',
  Sl = 'sl',
  Sm = 'sm',
  Sn = 'sn',
  So = 'so',
  Sr = 'sr',
  Ss = 'ss',
  St = 'st',
  Sv = 'sv',
  Sx = 'sx',
  Sy = 'sy',
  Sz = 'sz',
  Tc = 'tc',
  Td = 'td',
  Tf = 'tf',
  Tg = 'tg',
  Th = 'th',
  Tj = 'tj',
  Tk = 'tk',
  Tl = 'tl',
  Tm = 'tm',
  Tn = 'tn',
  To = 'to',
  Tr = 'tr',
  Tt = 'tt',
  Tv = 'tv',
  Tw = 'tw',
  Tz = 'tz',
  Ua = 'ua',
  Ug = 'ug',
  Um = 'um',
  Us = 'us',
  Uy = 'uy',
  Uz = 'uz',
  Va = 'va',
  Vc = 'vc',
  Ve = 've',
  Vg = 'vg',
  Vi = 'vi',
  Vn = 'vn',
  Vu = 'vu',
  Wf = 'wf',
  Worldwide = 'worldwide',
  Ws = 'ws',
  Ye = 'ye',
  Yt = 'yt',
  Za = 'za',
  Zm = 'zm',
  Zw = 'zw'
}

export enum Country {
  Ad = 'ad',
  Ae = 'ae',
  Af = 'af',
  Ag = 'ag',
  Ai = 'ai',
  Al = 'al',
  Am = 'am',
  An = 'an',
  Ao = 'ao',
  Aq = 'aq',
  Ar = 'ar',
  As = 'as',
  At = 'at',
  Au = 'au',
  Aw = 'aw',
  Ax = 'ax',
  Az = 'az',
  Ba = 'ba',
  Bb = 'bb',
  Bd = 'bd',
  Be = 'be',
  Bf = 'bf',
  Bg = 'bg',
  Bh = 'bh',
  Bi = 'bi',
  Bj = 'bj',
  Bl = 'bl',
  Bm = 'bm',
  Bn = 'bn',
  Bo = 'bo',
  Bq = 'bq',
  Br = 'br',
  Bs = 'bs',
  Bt = 'bt',
  Bv = 'bv',
  Bw = 'bw',
  By = 'by',
  Bz = 'bz',
  Ca = 'ca',
  Cc = 'cc',
  Cd = 'cd',
  Cf = 'cf',
  Cg = 'cg',
  Ch = 'ch',
  Ci = 'ci',
  Ck = 'ck',
  Cl = 'cl',
  Cm = 'cm',
  Cn = 'cn',
  Co = 'co',
  Cr = 'cr',
  Cu = 'cu',
  Cv = 'cv',
  Cw = 'cw',
  Cx = 'cx',
  Cy = 'cy',
  Cz = 'cz',
  De = 'de',
  Dj = 'dj',
  Dk = 'dk',
  Dm = 'dm',
  Do = 'do',
  Dz = 'dz',
  Ec = 'ec',
  Ee = 'ee',
  Eg = 'eg',
  Eh = 'eh',
  Er = 'er',
  Es = 'es',
  Et = 'et',
  Fi = 'fi',
  Fj = 'fj',
  Fk = 'fk',
  Fm = 'fm',
  Fo = 'fo',
  Fr = 'fr',
  Ga = 'ga',
  Gb = 'gb',
  Gd = 'gd',
  Ge = 'ge',
  Gf = 'gf',
  Gg = 'gg',
  Gh = 'gh',
  Gi = 'gi',
  Gl = 'gl',
  Gm = 'gm',
  Gn = 'gn',
  Gp = 'gp',
  Gq = 'gq',
  Gr = 'gr',
  Gs = 'gs',
  Gt = 'gt',
  Gu = 'gu',
  Gw = 'gw',
  Gy = 'gy',
  Hk = 'hk',
  Hm = 'hm',
  Hn = 'hn',
  Hr = 'hr',
  Ht = 'ht',
  Hu = 'hu',
  Id = 'id',
  Ie = 'ie',
  Il = 'il',
  Im = 'im',
  In = 'in',
  Io = 'io',
  Iq = 'iq',
  Ir = 'ir',
  Is = 'is',
  It = 'it',
  Je = 'je',
  Jm = 'jm',
  Jo = 'jo',
  Jp = 'jp',
  Ke = 'ke',
  Kg = 'kg',
  Kh = 'kh',
  Ki = 'ki',
  Km = 'km',
  Kn = 'kn',
  Kp = 'kp',
  Kr = 'kr',
  Kv = 'kv',
  Kw = 'kw',
  Ky = 'ky',
  Kz = 'kz',
  La = 'la',
  Lb = 'lb',
  Lc = 'lc',
  Li = 'li',
  Lk = 'lk',
  Lr = 'lr',
  Ls = 'ls',
  Lt = 'lt',
  Lu = 'lu',
  Lv = 'lv',
  Ly = 'ly',
  Ma = 'ma',
  Mc = 'mc',
  Md = 'md',
  Me = 'me',
  Mf = 'mf',
  Mg = 'mg',
  Mh = 'mh',
  Mk = 'mk',
  Ml = 'ml',
  Mm = 'mm',
  Mn = 'mn',
  Mo = 'mo',
  Mp = 'mp',
  Mq = 'mq',
  Mr = 'mr',
  Ms = 'ms',
  Mt = 'mt',
  Mu = 'mu',
  Mv = 'mv',
  Mw = 'mw',
  Mx = 'mx',
  My = 'my',
  Mz = 'mz',
  Na = 'na',
  Nc = 'nc',
  Ne = 'ne',
  Nf = 'nf',
  Ng = 'ng',
  Ni = 'ni',
  Nl = 'nl',
  No = 'no',
  Np = 'np',
  Nr = 'nr',
  Nu = 'nu',
  Nz = 'nz',
  Om = 'om',
  Pa = 'pa',
  Pe = 'pe',
  Pf = 'pf',
  Pg = 'pg',
  Ph = 'ph',
  Pk = 'pk',
  Pl = 'pl',
  Pm = 'pm',
  Pn = 'pn',
  Pr = 'pr',
  Ps = 'ps',
  Pt = 'pt',
  Pw = 'pw',
  Py = 'py',
  Qa = 'qa',
  Re = 're',
  Ro = 'ro',
  Rs = 'rs',
  Ru = 'ru',
  Rw = 'rw',
  Sa = 'sa',
  Sb = 'sb',
  Sc = 'sc',
  Sd = 'sd',
  Se = 'se',
  Sg = 'sg',
  Sh = 'sh',
  Si = 'si',
  Sj = 'sj',
  Sk = 'sk',
  Sl = 'sl',
  Sm = 'sm',
  Sn = 'sn',
  So = 'so',
  Sr = 'sr',
  Ss = 'ss',
  St = 'st',
  Sv = 'sv',
  Sx = 'sx',
  Sy = 'sy',
  Sz = 'sz',
  Tc = 'tc',
  Td = 'td',
  Tf = 'tf',
  Tg = 'tg',
  Th = 'th',
  Tj = 'tj',
  Tk = 'tk',
  Tl = 'tl',
  Tm = 'tm',
  Tn = 'tn',
  To = 'to',
  Tr = 'tr',
  Tt = 'tt',
  Tv = 'tv',
  Tw = 'tw',
  Tz = 'tz',
  Ua = 'ua',
  Ug = 'ug',
  Um = 'um',
  Us = 'us',
  Uy = 'uy',
  Uz = 'uz',
  Va = 'va',
  Vc = 'vc',
  Ve = 've',
  Vg = 'vg',
  Vi = 'vi',
  Vn = 'vn',
  Vu = 'vu',
  Wf = 'wf',
  Ws = 'ws',
  Ye = 'ye',
  Yt = 'yt',
  Za = 'za',
  Zm = 'zm',
  Zw = 'zw'
}

/** Check if card terms and conditions are signed. If not, return the actionId for signing them */
export type CreateCardTermsActionType = {
  __typename?: 'CreateCardTermsActionType';
  actionId?: Maybe<Scalars['ID']['output']>;
  signed: Scalars['Boolean']['output'];
};

export type CredentialsType = {
  __typename?: 'CredentialsType';
  merchantId?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<Scalars['String']['output']>;
};

/** Credit Transactions for an account */
export type CreditTransaction = BaseTransaction & {
  __typename?: 'CreditTransaction';
  account?: Maybe<Account>;
  accountCurrency?: Maybe<Currency>;
  additionalComment?: Maybe<Scalars['String']['output']>;
  balanceAfter?: Maybe<Scalars['Float']['output']>;
  batchId?: Maybe<Scalars['ID']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  card?: Maybe<CardType>;
  cardTransactionDetails?: Maybe<CardTransactionDetails>;
  cashbackDetail?: Maybe<CashbackDetail>;
  chargeBearer?: Maybe<SwiftTransferChargeBearer>;
  clientReference?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commissionDetail?: Maybe<CommissionDetail>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use Account/Payout Currency */
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directDebitExecution?: Maybe<DirectDebitExecution>;
  dueRemindersCount?: Maybe<Scalars['Int']['output']>;
  entryType?: Maybe<TransactionEntryType>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  executionAction?: Maybe<Action>;
  executionType?: Maybe<TransactionExecutionType>;
  feeDetail?: Maybe<FeeDetail>;
  forceHold?: Maybe<Scalars['Boolean']['output']>;
  from?: Maybe<TransactionParty>;
  guaranteeEvent?: Maybe<GuaranteeEvent>;
  hasPendingInvestigation?: Maybe<Scalars['Boolean']['output']>;
  hasSupportingDocument?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  internalFields?: Maybe<TransactionInternalFields>;
  isConfirmationAvailable?: Maybe<Scalars['Boolean']['output']>;
  isInterContract?: Maybe<Scalars['Boolean']['output']>;
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  isReturn?: Maybe<Scalars['Boolean']['output']>;
  isReverted?: Maybe<Scalars['Boolean']['output']>;
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use payment rail */
  isSEPA?: Maybe<Scalars['Boolean']['output']>;
  isSwift?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use Account/Payout Currency */
  originalCurrency?: Maybe<Currency>;
  paymentRail?: Maybe<PaymentRail>;
  paymentRailBranch?: Maybe<Scalars['String']['output']>;
  payoutCurrency?: Maybe<Scalars['String']['output']>;
  payoutValue?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<TransactionPriorityType>;
  purposeCode?: Maybe<Scalars['String']['output']>;
  purposeCode2?: Maybe<Scalars['String']['output']>;
  quotedXRate?: Maybe<Scalars['Float']['output']>;
  reserves?: Maybe<Array<CreditTransactionReserves>>;
  returnedTransactionId?: Maybe<Scalars['ID']['output']>;
  revertedBy?: Maybe<Transaction>;
  status?: Maybe<TransactionStatus>;
  supportingDocuments?: Maybe<Array<Maybe<Document>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  trxHash?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueDate?: Maybe<Scalars['DateTime']['output']>;
  walletCheckStatus?: Maybe<WalletCheckStatus>;
  xRate?: Maybe<Scalars['Float']['output']>;
};


/** Credit Transactions for an account */
export type CreditTransactionTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};

export type CreditTransactionReserves = {
  __typename?: 'CreditTransactionReserves';
  amount: Scalars['Float']['output'];
  releaseDate: Scalars['DateTime']['output'];
  released: Scalars['Boolean']['output'];
  reserveType: CreditTransactionReservesType;
};

export enum CreditTransactionReservesType {
  DirectDebit = 'directDebit'
}

/** All supported crypto currencies */
export enum CryptoCurrency {
  Eth = 'ETH',
  Usdc = 'USDC',
  Usdt = 'USDT'
}

export type CryptoFilesInput = {
  fileName: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CryptoRate = {
  __typename?: 'CryptoRate';
  effectiveRate?: Maybe<Scalars['Float']['output']>;
  networkFee?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  slippageTolerance?: Maybe<Array<Maybe<SlippaceTolerance>>>;
  transferFee?: Maybe<WalletFee>;
};

export type CryptoTransactionSigningAction = BaseAction & {
  __typename?: 'CryptoTransactionSigningAction';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  transactionRequest?: Maybe<TransactionRequest>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CryptoTransactionSigningActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export enum Currency {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mru = 'MRU',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Std = 'STD',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vef = 'VEF',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xcd = 'XCD',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
  Zwl = 'ZWL'
}

export enum CurrencyMismatchResolutionStrategy {
  ChangeDestination = 'ChangeDestination',
  Fx = 'FX',
  FxExternal = 'FXExternal'
}

/** Debit Transactions for an account */
export type DebitTransaction = BaseTransaction & {
  __typename?: 'DebitTransaction';
  account?: Maybe<Account>;
  accountCurrency?: Maybe<Currency>;
  additionalComment?: Maybe<Scalars['String']['output']>;
  balanceAfter?: Maybe<Scalars['Float']['output']>;
  batchId?: Maybe<Scalars['ID']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  card?: Maybe<CardType>;
  cardTransactionDetails?: Maybe<CardTransactionDetails>;
  cashbackDetail?: Maybe<CashbackDetail>;
  chargeBearer?: Maybe<SwiftTransferChargeBearer>;
  clientReference?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commissionDetail?: Maybe<CommissionDetail>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use Account/Payout Currency */
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directDebitExecution?: Maybe<DirectDebitExecution>;
  dueRemindersCount?: Maybe<Scalars['Int']['output']>;
  entryType?: Maybe<TransactionEntryType>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  executionAction?: Maybe<Action>;
  executionType?: Maybe<TransactionExecutionType>;
  feeDetail?: Maybe<FeeDetail>;
  forceHold?: Maybe<Scalars['Boolean']['output']>;
  guaranteeEvent?: Maybe<GuaranteeEvent>;
  hasSupportingDocument?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  internalFields?: Maybe<TransactionInternalFields>;
  isConfirmationAvailable?: Maybe<Scalars['Boolean']['output']>;
  isInterContract?: Maybe<Scalars['Boolean']['output']>;
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  isReturn?: Maybe<Scalars['Boolean']['output']>;
  isReverted?: Maybe<Scalars['Boolean']['output']>;
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use payment rail */
  isSEPA?: Maybe<Scalars['Boolean']['output']>;
  isSwift?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use Account/Payout Currency */
  originalCurrency?: Maybe<Currency>;
  paymentRail?: Maybe<PaymentRail>;
  paymentRailBranch?: Maybe<Scalars['String']['output']>;
  payoutCurrency?: Maybe<Scalars['String']['output']>;
  payoutValue?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<TransactionPriorityType>;
  purposeCode?: Maybe<Scalars['String']['output']>;
  purposeCode2?: Maybe<Scalars['String']['output']>;
  quotedXRate?: Maybe<Scalars['Float']['output']>;
  returnedTransactionId?: Maybe<Scalars['ID']['output']>;
  revertedBy?: Maybe<Transaction>;
  standingOrder?: Maybe<StandingOrder>;
  status?: Maybe<TransactionStatus>;
  supportingDocuments?: Maybe<Array<Maybe<Document>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  to?: Maybe<TransactionParty>;
  trxHash?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueDate?: Maybe<Scalars['DateTime']['output']>;
  walletCheckStatus?: Maybe<WalletCheckStatus>;
  xRate?: Maybe<Scalars['Float']['output']>;
};


/** Debit Transactions for an account */
export type DebitTransactionTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};

/** DefaultCardAllowedLimitsType */
export type DefaultCardAllowedLimitsType = {
  __typename?: 'DefaultCardAllowedLimitsType';
  defaultCardDailyContactlessPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardDailyInternetPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardDailyOverallPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardDailyPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardDailyWithdrawalLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardMonthlyContactlessPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardMonthlyInternetPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardMonthlyOverallPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardMonthlyPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardMonthlyWithdrawalLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardTransactionContactlessPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardTransactionInternetPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardTransactionPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardTransactionWithdrawalLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardWeeklyContactlessPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardWeeklyInternetPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardWeeklyOverallPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardWeeklyPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  defaultCardWeeklyWithdrawalLimit?: Maybe<Scalars['Int']['output']>;
};

export type DeviceInformation = {
  __typename?: 'DeviceInformation';
  appBuildNumber?: Maybe<Scalars['String']['output']>;
  appVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deviceBrand?: Maybe<Scalars['String']['output']>;
  deviceCountry?: Maybe<Country>;
  deviceIsEmulator?: Maybe<Scalars['Boolean']['output']>;
  deviceLocale?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceSystemName?: Maybe<Scalars['String']['output']>;
  deviceSystemVersion?: Maybe<Scalars['String']['output']>;
  deviceTimezone?: Maybe<Scalars['String']['output']>;
  deviceUniqueId?: Maybe<Scalars['String']['output']>;
  fcmToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  individual: Individual;
  status?: Maybe<MobileStatuses>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Diff log */
export type DiffLog = BaseLogInterface & {
  __typename?: 'DiffLog';
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Metadata */
  meta?: Maybe<Scalars['String']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

export type DirectDebitAction = BaseAction & {
  __typename?: 'DirectDebitAction';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  directDebit?: Maybe<DirectDebitMandate>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type DirectDebitActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export type DirectDebitBatchPaymentRecord = {
  __typename?: 'DirectDebitBatchPaymentRecord';
  errors?: Maybe<Scalars['JSON']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  mandate?: Maybe<DirectDebitMandate>;
  reference?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type DirectDebitBatchRequestActionType = BaseAction & {
  __typename?: 'DirectDebitBatchRequestActionType';
  appFields?: Maybe<AppFields>;
  batch: DirectDebitBatchType;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type DirectDebitBatchRequestActionTypeSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export type DirectDebitBatchType = {
  __typename?: 'DirectDebitBatchType';
  account: Account;
  /** Cancellation Reason */
  cancellationReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** actionType */
  executionAction: Action;
  /** File Url */
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  records: Array<DirectDebitExecution>;
  status: BatchPaymentStatusType;
  total: Scalars['Float']['output'];
};


export type DirectDebitBatchTypeRecordsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};

export type DirectDebitBatchValidationType = {
  __typename?: 'DirectDebitBatchValidationType';
  account: Account;
  count: Scalars['Int']['output'];
  records: Array<DirectDebitBatchPaymentRecord>;
  total: Scalars['Float']['output'];
  valid: Scalars['Boolean']['output'];
  validTotal: Scalars['Float']['output'];
};

export type DirectDebitDispute = {
  __typename?: 'DirectDebitDispute';
  action: Action;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  execution: DirectDebitExecution;
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  status: DirectDebitDisputeStatus;
  swiftMessage?: Maybe<RawSwiftMessage>;
};

export type DirectDebitDisputeAction = BaseAction & {
  __typename?: 'DirectDebitDisputeAction';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  directDebitDispute?: Maybe<DirectDebitDispute>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type DirectDebitDisputeActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export enum DirectDebitDisputeStatus {
  New = 'new',
  PendingBackOffice = 'pendingBackOffice',
  RejectedByBackOffice = 'rejectedByBackOffice',
  Sent = 'sent'
}

export type DirectDebitExecution = {
  __typename?: 'DirectDebitExecution';
  account: Account;
  batch?: Maybe<DirectDebitBatchType>;
  canBeDisputed: Scalars['Boolean']['output'];
  canBeReverted: Scalars['Boolean']['output'];
  clientReference?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dispute?: Maybe<DirectDebitDispute>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRecalled?: Maybe<Scalars['Boolean']['output']>;
  mandate: DirectDebitMandate;
  recallSwiftMessageId?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  rejectionCancellationSwiftMessageId?: Maybe<Scalars['String']['output']>;
  requestSwiftMessageId?: Maybe<Scalars['String']['output']>;
  revertAction?: Maybe<Action>;
  status: DirectDebitExecutionStatus;
  /** @deprecated Use requestSwiftMessageId */
  swiftMessage?: Maybe<RawSwiftMessage>;
  transaction?: Maybe<Transaction>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum DirectDebitExecutionStatus {
  Dispatched = 'dispatched',
  Executed = 'executed',
  New = 'new',
  Pending = 'pending',
  PendingDispatch = 'pendingDispatch',
  Rejected = 'rejected',
  Reverted = 'reverted',
  Signed = 'signed'
}

export type DirectDebitMandate = {
  __typename?: 'DirectDebitMandate';
  account?: Maybe<Account>;
  approvalAction?: Maybe<Action>;
  contract: BankableEntityContractType;
  counterpartyDetails?: Maybe<DirectDebitMandateCounterparty>;
  createdAt: Scalars['DateTime']['output'];
  creditorId?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Document>;
  executions: Array<DirectDebitExecution>;
  executionsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  mandateId?: Maybe<Scalars['String']['output']>;
  recurring: Scalars['Boolean']['output'];
  rejectReason?: Maybe<Scalars['String']['output']>;
  rejectionAction?: Maybe<Action>;
  service?: Maybe<DirectDebitService>;
  status: DirectDebitMandateStatus;
  type: TransactionEntryType;
};


export type DirectDebitMandateExecutionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};

export type DirectDebitMandateCounterparty = {
  __typename?: 'DirectDebitMandateCounterparty';
  address?: Maybe<Address>;
  bic?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type DirectDebitMandateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  bic: Scalars['String']['input'];
  documentId?: InputMaybe<Scalars['ID']['input']>;
  iban: Scalars['String']['input'];
  name: Scalars['String']['input'];
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  service?: InputMaybe<DirectDebitService>;
};

export enum DirectDebitMandateStatus {
  Approved = 'approved',
  New = 'new',
  OneOfExecuted = 'oneOfExecuted',
  Pending = 'pending',
  Rejected = 'rejected',
  RejectedByAgent = 'rejectedByAgent'
}

export type DirectDebitRequestRecordInput = {
  clientReference?: InputMaybe<Scalars['String']['input']>;
  executionDate: Scalars['Date']['input'];
  mandate: Scalars['ID']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
};

export type DirectDebitRevertRequestAction = BaseAction & {
  __typename?: 'DirectDebitRevertRequestAction';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  directDebitExecution?: Maybe<DirectDebitExecution>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type DirectDebitRevertRequestActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export enum DirectDebitService {
  B2b = 'b2b',
  Core = 'core'
}

export type DirectDebitSettings = {
  __typename?: 'DirectDebitSettings';
  reserveHoldDays?: Maybe<Scalars['Int']['output']>;
  reservePercentage?: Maybe<Scalars['Float']['output']>;
  sepaCreditorId?: Maybe<Scalars['ID']['output']>;
};

/** Roles for Legal Entity Directors */
export enum DirectorRole {
  Executive = 'executive',
  ManagingDirector = 'managingDirector',
  NonExecutive = 'nonExecutive'
}

/** Signing rights for Legal Entity Directors */
export enum DirectorSigningRights {
  Group = 'group',
  Joint = 'joint',
  NoSigningRights = 'noSigningRights',
  Sole = 'sole'
}

/** Documents */
export type Document = {
  __typename?: 'Document';
  account?: Maybe<Account>;
  action?: Maybe<Action>;
  alias?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<BankableEntityContractType>;
  contractId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  documentOrigin?: Maybe<DocumentOrigin>;
  dueRemindersCount?: Maybe<Scalars['Int']['output']>;
  expiration?: Maybe<Scalars['Date']['output']>;
  /** Description of document */
  fileDescription?: Maybe<Scalars['String']['output']>;
  /** @deprecated use field firstSide now */
  fileName?: Maybe<Scalars['String']['output']>;
  firstSide?: Maybe<DocumentSide>;
  /** Document ID */
  id: Scalars['Int']['output'];
  individual?: Maybe<Individual>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  /** Internal Description of document */
  internalDescription?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isDoubleSided?: Maybe<Scalars['Boolean']['output']>;
  isExpAcknowledged?: Maybe<Scalars['Boolean']['output']>;
  isRead?: Maybe<Scalars['Boolean']['output']>;
  legalEntity?: Maybe<LegalEntity>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use field firstSide now */
  mimeType?: Maybe<Scalars['String']['output']>;
  pinMeta?: Maybe<DocumentPinMeta>;
  profileChange?: Maybe<Individual>;
  /** Rejection reason */
  rejectionReason?: Maybe<Scalars['String']['output']>;
  /** Rejection reason code */
  rejectionReasonCode?: Maybe<DocumentRejectionReasonCode>;
  rejectionReasonDescription?: Maybe<Scalars['String']['output']>;
  secondSide?: Maybe<DocumentSide>;
  signable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use field firstSide now */
  size?: Maybe<Scalars['Float']['output']>;
  standingOrder?: Maybe<StandingOrder>;
  standingOrderId?: Maybe<Scalars['ID']['output']>;
  /** Status of this document */
  status?: Maybe<DocumentStatus>;
  statusDescription?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  transaction?: Maybe<Transaction>;
  transactionId?: Maybe<Scalars['ID']['output']>;
  /** Type of document */
  type?: Maybe<DocumentType>;
  typeDescription?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedByApiUser?: Maybe<ApiUser>;
  uploadedByIndividual?: Maybe<Individual>;
  uploadedByUser?: Maybe<User>;
  /**
   * URL where document is stored
   * @deprecated use field firstSide now
   */
  url?: Maybe<Scalars['String']['output']>;
  wallet?: Maybe<Wallet>;
};


/** Documents */
export type DocumentTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};

export type DocumentAction = BaseAction & {
  __typename?: 'DocumentAction';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  document?: Maybe<Document>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type DocumentActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

/** Description of document fields */
export type DocumentDescription = {
  __typename?: 'DocumentDescription';
  /** Document Label */
  label?: Maybe<Scalars['String']['output']>;
  /** Document Value */
  value?: Maybe<Scalars['String']['output']>;
};

export type DocumentInput = {
  expiration?: InputMaybe<Scalars['Date']['input']>;
  fileDescription?: InputMaybe<Scalars['String']['input']>;
  firstSide?: InputMaybe<DocumentSideInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  internalTag?: InputMaybe<Scalars['String']['input']>;
  secondSide?: InputMaybe<DocumentSideInput>;
  type?: InputMaybe<DocumentType>;
};

/** Which field to order the query results by */
export enum DocumentOrderBy {
  CreatedAt = 'createdAt',
  ExpiresAt = 'expiresAt',
  FileDescription = 'fileDescription',
  FileName = 'fileName',
  Id = 'id',
  Status = 'status',
  Type = 'type'
}

/** Document origin */
export enum DocumentOrigin {
  Api = 'api',
  Crm = 'crm',
  Dashboard = 'dashboard'
}

/** Document Pin Meta */
export type DocumentPinMeta = {
  __typename?: 'DocumentPinMeta';
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  pinnedBy?: Maybe<Scalars['String']['output']>;
  pinnedOn?: Maybe<Scalars['DateTime']['output']>;
};

/** One of the possible document rejection reason codes */
export enum DocumentRejectionReasonCode {
  DuplicateDocument = 'duplicateDocument',
  ExpiredDoc = 'expiredDoc',
  FailedVerification = 'failedVerification',
  NameMismatch = 'nameMismatch',
  NotAcceptableDocType = 'notAcceptableDocType',
  NotAcceptableInfo = 'notAcceptableInfo',
  NotFullPageOfDoc = 'notFullPageOfDoc',
  Other = 'other',
  UnclearDoc = 'unclearDoc'
}

export type DocumentRelatedEntityInput = {
  otherRelatedEntityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  relatedEntityId?: InputMaybe<Scalars['ID']['input']>;
  relatedEntityType?: InputMaybe<DocumentRelatedEntityType>;
};

export enum DocumentRelatedEntityType {
  Account = 'account',
  Individual = 'individual',
  LegalEntity = 'legalEntity',
  Mandate = 'mandate',
  StandingOrder = 'standingOrder',
  Transaction = 'transaction',
  TransactionRequest = 'transactionRequest',
  Wallet = 'wallet'
}

export type DocumentSide = {
  __typename?: 'DocumentSide';
  fileName?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  /** URL where document is stored */
  url?: Maybe<Scalars['String']['output']>;
};

export type DocumentSideInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  plainUrl?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

/** One of the possible document statuses */
export enum DocumentStatus {
  Accepted = 'accepted',
  AutoVerificationAccepted = 'autoVerificationAccepted',
  AutoVerificationError = 'autoVerificationError',
  AutoVerificationReceived = 'autoVerificationReceived',
  AutoVerificationRejected = 'autoVerificationRejected',
  AutoVerificationSent = 'autoVerificationSent',
  NotProcessed = 'notProcessed',
  Pending = 'pending',
  PendingSignatures = 'pendingSignatures',
  PendingTranslation = 'pendingTranslation',
  Rejected = 'rejected',
  Signed = 'signed'
}

export enum DocumentType {
  AccountDetailsConfirmationRequest = 'accountDetailsConfirmationRequest',
  Address = 'address',
  Aeoi = 'aeoi',
  AggreementsContracts = 'aggreementsContracts',
  AmlManual = 'amlManual',
  AnnualReport = 'annualReport',
  ApprovalRejectionForm = 'approvalRejectionForm',
  AuditedFinancialStatements = 'auditedFinancialStatements',
  AuthorizationToDiscloseDataToUsTaxAuthorities = 'authorization_to_disclose_data_to_us_tax_authorities',
  BalanceConfirmationLetter = 'balance_confirmation_letter',
  BankAccountStatements = 'bankAccountStatements',
  BankCard = 'bankCard',
  BankConfirmationLetterOnAuditorsRequest = 'bankConfirmationLetterOnAuditorsRequest',
  BankOfficeAnnualReview = 'bankOfficeAnnualReview',
  BankOfficeOnboardingReviewForm = 'bankOfficeOnboardingReviewForm',
  BankOrStateSupervisionAssessment = 'bankOrStateSupervisionAssessment',
  BankPaymentDetails = 'bankPaymentDetails',
  BankStatement = 'bankStatement',
  BankStatementPof = 'bankStatementPOF',
  BankStatementPor = 'bankStatementPOR',
  BoardOfDirectorsResolution = 'boardOfDirectorsResolution',
  BusinessLicense = 'businessLicense',
  BusinessPlan = 'businessPlan',
  CardCopies = 'cardCopies',
  CardStatement = 'cardStatement',
  CerticateOfDirectors = 'certicateOfDirectors',
  CertificateOfGoodStanding = 'certificateOfGoodStanding',
  CertificateOfIncorporation = 'certificateOfIncorporation',
  CertificateOfIncumbency = 'certificateOfIncumbency',
  CertificateOfShareholders = 'certificateOfShareholders',
  CheckListForReviewConclusion = 'checkListForReviewConclusion',
  CoinbasePop = 'coinbasePop',
  CompaniesRegistryExtract = 'companiesRegistryExtract',
  ContentModerationPolicy = 'contentModerationPolicy',
  Contract = 'contract',
  ContractTerminationLetter = 'contractTerminationLetter',
  ContractTerms = 'contractTerms',
  ContractTerminationNotice = 'contract_termination_notice',
  CorporateDocument = 'corporateDocument',
  CrsFacta = 'crsFacta',
  CvResume = 'cvResume',
  DateOfSignOff = 'dateOfSignOff',
  DebitCardTerms = 'debitCardTerms',
  DeclarationOfTrust = 'declarationOfTrust',
  DirectDebitMandate = 'directDebitMandate',
  DrivingLicense = 'drivingLicense',
  /** @deprecated deprecated use drivingLicenceType instead */
  DrivingLicenseBack = 'drivingLicenseBack',
  /** @deprecated deprecated use drivingLicenceType instead */
  DrivingLicenseFront = 'drivingLicenseFront',
  DueDiligence = 'dueDiligence',
  EddQuestionnaire = 'eddQuestionnaire',
  FeeGroupDocument = 'feeGroupDocument',
  FeeRefundRequest = 'feeRefundRequest',
  FeeSchedule = 'feeSchedule',
  FinancialServicesFirmsUseOfKlarpayAccounts = 'financialServicesFirmsUseOfKlarpayAccounts',
  FundFlowChart = 'fundFlowChart',
  FundFlowChanges = 'fund_flow_changes',
  GroupStructure = 'groupStructure',
  Id = 'id',
  /** @deprecated deprecated use id type instead */
  IdBack = 'idBack',
  /** @deprecated deprecated use id type instead */
  IdFront = 'idFront',
  /** @deprecated deprecated */
  IdTranslation = 'idTranslation',
  InstrumentOfTransfer = 'instrument_of_transfer',
  IntroducerAgreement = 'introducerAgreement',
  InvestmentCertificates = 'investmentCertificates',
  InvestmentStatementProofOfDividedPayment = 'investmentStatementProofOfDividedPayment',
  Invoice = 'invoice',
  InvoicesIssuedToCustomers = 'invoicesIssuedToCustomers',
  InvoicesIssuedToTheClient = 'invoicesIssuedToTheClient',
  JointAccountForm = 'jointAccountForm',
  KycPolicy = 'kycPolicy',
  LimitedPowerOfAttorney = 'limitedPowerOfAttorney',
  LoanAgreements = 'loanAgreements',
  ManagementAccounts = 'managementAccounts',
  MemorandumArticlesOfAssociation = 'memorandumArticlesOfAssociation',
  MerchantProcessingRequestForm = 'merchant_processing_request_form',
  Order = 'order',
  OrganisationalChart = 'organisationalChart',
  Other = 'other',
  OtherPof = 'otherPOF',
  Passport = 'passport',
  Payroll = 'payroll',
  Payslip = 'payslip',
  PreAssessmentQuestionnaire = 'preAssessmentQuestionnaire',
  PreassessmentHistoryStatementOfCurrentFormerProcessor = 'preassessmentHistoryStatementOfCurrentFormerProcessor',
  ProfessionalApplication = 'professionalApplication',
  ProfessionalTreasuryAssessment = 'professionalTreasuryAssessment',
  /** @deprecated deprecated */
  ProofOfAddressTranslation = 'proofOfAddressTranslation',
  ProofOfInheritance = 'proofOfInheritance',
  ProofOfPropertySale = 'proofOfPropertySale',
  ProofOfResidence = 'proofOfResidence',
  ProofOfSalary = 'proofOfSalary',
  ProofOfSignature = 'proofOfSignature',
  Questionnaire = 'questionnaire',
  ReferenceLetter = 'referenceLetter',
  ResidencePermitVisa = 'residencePermitVisa',
  ReviewerSignOff = 'reviewerSignOff',
  RevocationOfPoaSpoa = 'revocationOfPoaSpoa',
  Sar = 'sar',
  ServiceContracts = 'serviceContracts',
  SpecialPowerOfAttorney = 'specialPowerOfAttorney',
  SuccessFeePayoutStatement = 'successFeePayoutStatement',
  SupportAttachment = 'supportAttachment',
  SwiftConfirmation = 'swiftConfirmation',
  SwiftCopyPaymentAdvice = 'swiftCopyPaymentAdvice',
  TaxStatement = 'taxStatement',
  ThirdPartyAuthorizationLetter = 'thirdPartyAuthorizationLetter',
  ThirdPartyIdPassport = 'thirdPartyIdPassport',
  ThirdPartyWc = 'thirdPartyWc',
  TransactionIncludedInReview = 'transactionIncludedInReview',
  UboDeclarationFormA = 'uboDeclarationFormA',
  UboDeclarationFormK = 'uboDeclarationFormK',
  UboDeclarationFormS = 'uboDeclarationFormS',
  UboDeclarationFormT = 'uboDeclarationFormT',
  UnauditedFinancialStatements = 'unaudited_financial_statements',
  UtilityBill = 'utilityBill',
  VerificationDocuments = 'verificationDocuments',
  VirtualCard = 'virtualCard',
  W_8benE = 'w_8ben_e',
  WebshieldReport = 'webshield_report',
  WorldcheckResults = 'worldcheckResults'
}

export enum DocumentUserFilter {
  UploadedByApiUser = 'uploadedByApiUser',
  UploadedByIndividual = 'uploadedByIndividual',
  UploadedByUser = 'uploadedByUser'
}

export enum DssCompliance {
  From3rdParty = 'from3rdParty',
  Own = 'own'
}

export enum EconimicProfileAccountBalance {
  MoreThanHundrerdThousand = 'moreThanHundrerdThousand',
  TenToHundrerdThousand = 'tenToHundrerdThousand',
  UpToTenThousand = 'upToTenThousand'
}

export enum EconomicAverageSize {
  AboveFiveMillion = 'aboveFiveMillion',
  AboveMillion = 'aboveMillion',
  FiftyToHundredFiftyThousand = 'fiftyToHundredFiftyThousand',
  FiveHundredToSevenHundredFiftyThousand = 'fiveHundredToSevenHundredFiftyThousand',
  HundredFiftyToThreeHundredThousand = 'hundredFiftyToThreeHundredThousand',
  LessThanFiftyThousand = 'lessThanFiftyThousand',
  MoreThanTenThousand = 'moreThanTenThousand',
  OneToTwoMillion = 'oneToTwoMillion',
  SevenHundredFiftyThousandToOneMill = 'sevenHundredFiftyThousandToOneMill',
  ThreeHundredToFiveHundredThousand = 'threeHundredToFiveHundredThousand',
  ThreeToTenThousand = 'threeToTenThousand',
  TwoToFiveMillion = 'twoToFiveMillion',
  UpToFiveHundred = 'upToFiveHundred',
  UpToHundred = 'upToHundred',
  UpToMillion = 'upToMillion',
  UpToThreeThousand = 'upToThreeThousand'
}

export type EconomicProfile = {
  __typename?: 'EconomicProfile';
  /** Individual Account Balance */
  accountBalance?: Maybe<EconimicProfileAccountBalance>;
  /** Anticipated Account Activity */
  anticipatedAccountActivity?: Maybe<Array<Maybe<AnticipatedAccountActivities>>>;
  /** Average size of inbound transfer - Use incomingMonthlyTurnover from Pre-Assessment for Legal Entities */
  averageInbound?: Maybe<EconomicAverageSize>;
  /** Average size of outbound transfer - Use outgoingMonthlyTurnover from Pre-Assessment for Legal Entities */
  averageOutbound?: Maybe<EconomicAverageSize>;
  crossBorderPayments?: Maybe<Scalars['String']['output']>;
  /** Currencies of economic profile */
  currencies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Individual Employment Status */
  employmentStatus?: Maybe<EmploymentStatus>;
  /** Estimated number of inbound Transactions per month */
  estimateInbound?: Maybe<Scalars['Int']['output']>;
  /** Estimated number of outbound Transactions per month */
  estimateOutbound?: Maybe<Scalars['Int']['output']>;
  /** Inbound Transfers Sources */
  inboundSources?: Maybe<Array<Maybe<EconomicProfileInboundSource>>>;
  /** Other Inbound Transfers Sources */
  inboundSourcesOther?: Maybe<Scalars['String']['output']>;
  operatingInCashCryptoBusiness?: Maybe<Scalars['String']['output']>;
  /** Outbound Transfers destinations */
  outboundDestinations?: Maybe<Array<Maybe<EconomicProfileOutboundDestination>>>;
  /** Other Outbound Transfers destinations */
  outboundDestinationsOther?: Maybe<Scalars['String']['output']>;
  /** Products */
  products?: Maybe<Array<Maybe<Products>>>;
  /** Source of funds */
  sourceOfFunds?: Maybe<Array<Maybe<SourceOfFunds>>>;
  /** Source of funds other description */
  sourceOfFundsDescription?: Maybe<Scalars['String']['output']>;
  /** Estimated monthly turnover */
  turnover?: Maybe<EconomicAverageSize>;
};

/** List of Out/Inbound Sources */
export enum EconomicProfileInboundOutboundSource {
  AdministrationFees = 'administrationFees',
  CryptoOperations = 'cryptoOperations',
  FxOperations = 'fxOperations',
  Other = 'other',
  PaymentsGoods = 'paymentsGoods',
  Payroll = 'payroll'
}

/** List of Inbound Sources */
export enum EconomicProfileInboundSource {
  AdministrationFees = 'administrationFees',
  CryptoOperations = 'cryptoOperations',
  FxOperations = 'fxOperations',
  Other = 'other',
  PaymentsGoods = 'paymentsGoods'
}

/** Economic Profile */
export type EconomicProfileInputType = {
  /** Individual Account Balance */
  accountBalance?: InputMaybe<EconimicProfileAccountBalance>;
  /** Anticipated Account Activity */
  anticipatedAccountActivity?: InputMaybe<Array<InputMaybe<AnticipatedAccountActivities>>>;
  /** Average size of inbound transfer - Use incomingMonthlyTurnover from Pre-Assessment for Legal Entities */
  averageInbound?: InputMaybe<EconomicAverageSize>;
  /** Average size of outbound transfer - Use outgoingMonthlyTurnover from Pre-Assessment for Legal Entities */
  averageOutbound?: InputMaybe<EconomicAverageSize>;
  crossBorderPayments?: InputMaybe<Scalars['String']['input']>;
  /** Currencies of economic profile */
  currencies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Individual Employment Status */
  employmentStatus?: InputMaybe<EmploymentStatus>;
  /** Estimated number of inbound Transactions per month */
  estimateInbound?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated number of outbound Transactions per month */
  estimateOutbound?: InputMaybe<Scalars['Int']['input']>;
  /** Inbound Transfers Sources */
  inboundSources?: InputMaybe<Array<InputMaybe<EconomicProfileInboundSource>>>;
  /** Other Inbound Transfers Sources */
  inboundSourcesOther?: InputMaybe<Scalars['String']['input']>;
  operatingInCashCryptoBusiness?: InputMaybe<Scalars['String']['input']>;
  /** Outbound Transfers destinations */
  outboundDestinations?: InputMaybe<Array<InputMaybe<EconomicProfileOutboundDestination>>>;
  /** Other Outbound Transfers destinations */
  outboundDestinationsOther?: InputMaybe<Scalars['String']['input']>;
  /** Products */
  products?: InputMaybe<Array<InputMaybe<Products>>>;
  /** Source of funds */
  sourceOfFunds?: InputMaybe<Array<InputMaybe<SourceOfFunds>>>;
  /** Source of funds other description */
  sourceOfFundsDescription?: InputMaybe<Scalars['String']['input']>;
  /** Estimated monthly turnover */
  turnover?: InputMaybe<EconomicAverageSize>;
};

/** List of Outbound Destination */
export enum EconomicProfileOutboundDestination {
  AdministrationFees = 'administrationFees',
  CryptoOperations = 'cryptoOperations',
  FxOperations = 'fxOperations',
  Other = 'other',
  PaymentsGoods = 'paymentsGoods',
  Payroll = 'payroll'
}

/** Email Category */
export type EmailCategory = {
  __typename?: 'EmailCategory';
  /** Description of email category */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Mandatory field */
  mandatory: Scalars['Boolean']['output'];
  /** Name of email category */
  name: Scalars['String']['output'];
};

export enum EmploymentStatus {
  BusinessOwner = 'businessOwner',
  ContractorFreelancer = 'contractorFreelancer',
  Employee = 'employee',
  SelfEmployedSoleTrader = 'selfEmployedSoleTrader',
  Unemployed = 'unemployed'
}

/** Entity Reminder Type */
export type EntityReminder = {
  __typename?: 'EntityReminder';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  entityType?: Maybe<EntityReminderEntityType>;
  id: Scalars['ID']['output'];
  isDone?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  notificationChannel?: Maybe<Scalars['String']['output']>;
  notificationType?: Maybe<EntityReminderNotificationType>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  triggerTime?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Reminder Entity Type */
export enum EntityReminderEntityType {
  Account = 'account',
  Contract = 'contract',
  Document = 'document',
  Individual = 'individual',
  Transaction = 'transaction'
}

/** Notification Entity Type */
export enum EntityReminderNotificationType {
  Email = 'email',
  Slack = 'slack'
}

/** Which field to order the query results by */
export enum EntityReminderOrderBy {
  CreatedAt = 'createdAt',
  Id = 'id',
  TriggerTime = 'triggerTime'
}

/** External Payout Account */
export type ExternalPayoutAccount = {
  __typename?: 'ExternalPayoutAccount';
  accountNo?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Address>;
  bankAddress?: Maybe<Address>;
  bankBic?: Maybe<Scalars['String']['output']>;
  bankBranchId?: Maybe<Scalars['String']['output']>;
  bankBranchName?: Maybe<Scalars['String']['output']>;
  bankClearingMemberId?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Currency>;
  iban?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SwiftTransferRecipientType>;
};

/** Fees that belong to a group */
export type Fee = {
  __typename?: 'Fee';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Fee ID */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<FeeSubcategory>;
  type?: Maybe<FeeType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Fee Category */
export type FeeCategory = {
  __typename?: 'FeeCategory';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Fee Category ID */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Fee Detail */
export type FeeDetail = {
  __typename?: 'FeeDetail';
  feeName?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  internalFields?: Maybe<FeeDetailInternalField>;
  /** Source Transaction */
  sourceTransaction?: Maybe<Transaction>;
};

/** Fee Detail Internal Field */
export type FeeDetailInternalField = {
  __typename?: 'FeeDetailInternalField';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  /** Fee Group to Fee */
  feeGroupToFee?: Maybe<FeeGroupToFee>;
  /** Fee Transaction */
  feeTransaction?: Maybe<Transaction>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Which field to order the query results by */
export enum FeeDetailsOrderBy {
  CreatedAt = 'createdAt'
}

/** Fee Group */
export type FeeGroup = {
  __typename?: 'FeeGroup';
  attachedContractsCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Fee Group ID */
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum FeeGroupFeeStatus {
  Current = 'current',
  Obsolete = 'obsolete'
}

export enum FeeGroupFeeUnit {
  Action = 'action',
  Document = 'document',
  Page = 'page',
  Sms = 'sms',
  Timeframe = 'timeframe'
}

/** Fee Group Log */
export type FeeGroupLog = BaseLogInterface & {
  __typename?: 'FeeGroupLog';
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

/** Fee Group To Fee */
export type FeeGroupToFee = {
  __typename?: 'FeeGroupToFee';
  amount?: Maybe<Scalars['Float']['output']>;
  baseAmount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Currency>;
  fee?: Maybe<Fee>;
  fixedAmount?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<FeeGroup>;
  /** Fee Group To Fee ID */
  id: Scalars['ID']['output'];
  isAmountPercentage?: Maybe<Scalars['Boolean']['output']>;
  isMaximumPercentage?: Maybe<Scalars['Boolean']['output']>;
  isMinimumPercentage?: Maybe<Scalars['Boolean']['output']>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  maximum?: Maybe<Scalars['Float']['output']>;
  minimum?: Maybe<Scalars['Float']['output']>;
  recurringRule?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FeeGroupFeeStatus>;
  unit?: Maybe<FeeGroupFeeUnit>;
};

export type FeeReversalRequest = BaseApprovalRequest & {
  __typename?: 'FeeReversalRequest';
  affectedEntity?: Maybe<Scalars['String']['output']>;
  affectedEntityId?: Maybe<Scalars['ID']['output']>;
  approvals?: Maybe<Array<Maybe<UserRequestApprovalType>>>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  executionError?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  requestType?: Maybe<ApprovalRequestType>;
  setting?: Maybe<ApprovalRequestSetting>;
  status?: Maybe<ApprovalRequestStatus>;
  transactionIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Fee Subcategory */
export type FeeSubcategory = {
  __typename?: 'FeeSubcategory';
  category?: Maybe<FeeCategory>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Fee Subcategory ID */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Fee Type */
export type FeeType = {
  __typename?: 'FeeType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Fee Type ID */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FileBasedPainAccess = {
  __typename?: 'FileBasedPainAccess';
  allowedChannels?: Maybe<Array<Maybe<FileBasedPainAccessChannel>>>;
  contractId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  originatingBic?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FileBasedPainAccessStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum FileBasedPainAccessChannel {
  Sftp = 'sftp',
  Swift = 'swift'
}

export enum FileBasedPainAccessStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export type FixedFee = {
  __typename?: 'FixedFee';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Currency>;
};

export type FixedFeeInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Currency>;
};

/** Freeze Log */
export type FreezeLog = {
  __typename?: 'FreezeLog';
  action?: Maybe<Scalars['String']['output']>;
  /** Action By */
  actionBy?: Maybe<Scalars['String']['output']>;
  /** Method is Enabled For Individual */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FundRemittanceInfo = {
  __typename?: 'FundRemittanceInfo';
  amount: Scalars['Float']['output'];
  beneficiary: TransactionParty;
  comments: Scalars['String']['output'];
  payoutCurrency?: Maybe<Currency>;
};

export type FundRemittanceInfoInput = {
  amount: Scalars['Float']['input'];
  beneficiary: SwiftTransferIndividualPartyDetailsInput;
  comments: Scalars['String']['input'];
  payoutCurrency?: InputMaybe<Currency>;
};

export enum FundsType {
  ClientFunds = 'clientFunds',
  Crypto = 'crypto',
  DepositGuaranteed = 'depositGuaranteed',
  Operational = 'operational'
}

/** Fx Quote */
export type FxQuote = {
  __typename?: 'FxQuote';
  /** Аsk Price */
  ask: Scalars['Float']['output'];
  /** Bid Price */
  bid: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Quote Time */
  quoteTime: Scalars['DateTime']['output'];
  /** Spread */
  spread: Scalars['Float']['output'];
  /** Symbol */
  symbol: Scalars['String']['output'];
};

export enum GpiTransactionStatus {
  Accc = 'ACCC',
  Acsp = 'ACSP',
  Rjct = 'RJCT'
}

export enum Gender {
  Female = 'female',
  Male = 'male',
  Other = 'other',
  PreferNotToSay = 'preferNotToSay'
}

/** Generic activity log */
export type GenericLog = BaseLogInterface & {
  __typename?: 'GenericLog';
  accountName?: Maybe<Scalars['String']['output']>;
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  assignee?: Maybe<User>;
  automaticAffiliateCommissions?: Maybe<Scalars['Boolean']['output']>;
  /** Toggle IB Can Transfer */
  canIbTransfer?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  differences?: Maybe<Scalars['String']['output']>;
  dormantReactivation?: Maybe<Scalars['Boolean']['output']>;
  dueDiligenceStatus?: Maybe<Scalars['String']['output']>;
  emailConfirmed?: Maybe<Scalars['Boolean']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPhoneVerified?: Maybe<Scalars['Boolean']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  lastActiveDate?: Maybe<Scalars['String']['output']>;
  manualWithdrawals?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  newPlan?: Maybe<Scalars['String']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  potentialType?: Maybe<Scalars['String']['output']>;
  remoteId?: Maybe<Scalars['String']['output']>;
  toggleHideWDMethods?: Maybe<Scalars['Boolean']['output']>;
  topVip?: Maybe<Scalars['Boolean']['output']>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

export type GetSignedUrlType = {
  __typename?: 'GetSignedUrlType';
  key?: Maybe<Scalars['String']['output']>;
  plainUrl?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type GuaranteeEvent = {
  __typename?: 'GuaranteeEvent';
  account?: Maybe<Account>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentBalance?: Maybe<Scalars['Float']['output']>;
  currentGuaranteedBalance?: Maybe<Scalars['Float']['output']>;
  transaction?: Maybe<Transaction>;
};

export type IdValue = {
  __typename?: 'IdValue';
  id?: Maybe<Scalars['ID']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** An Individual Client */
export type Individual = {
  __typename?: 'Individual';
  /** ID for this client */
  IDNumber?: Maybe<Scalars['String']['output']>;
  /** ID Type for this client */
  IDType?: Maybe<Scalars['String']['output']>;
  accessDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Action Signatures */
  actionSignatories?: Maybe<Array<Maybe<ActionSignature>>>;
  /** Activity logs concerning this client */
  activityLogs?: Maybe<Array<Maybe<ActivityLog>>>;
  /** Count of activity logs concerning this client */
  activityLogsCount?: Maybe<Scalars['Int']['output']>;
  /** Client's address of residence */
  address?: Maybe<Address>;
  /** Acceptance of Minimum Age Limit */
  ageAcceptance?: Maybe<YesNo>;
  /** Date of acceptance of Minimum Age Limit */
  ageAcceptanceDate?: Maybe<Scalars['DateTime']['output']>;
  /** Alert logs concerning this client */
  alerts?: Maybe<Array<Maybe<MonitoringAlert>>>;
  /** Count of alerts concerning this client */
  alertsCount?: Maybe<Scalars['Int']['output']>;
  allowTransfers?: Maybe<Scalars['Boolean']['output']>;
  /** Scheduled Appointments for Video Verification */
  appointments?: Maybe<Array<IndividualAppointment>>;
  autogeneratedPassword?: Maybe<Scalars['Boolean']['output']>;
  /** List of Available Two FA Methods With Settings */
  availableTwoFAMethods?: Maybe<Array<Maybe<IndividualTwoFaMethod>>>;
  /** Date of birth */
  birthday?: Maybe<Scalars['Date']['output']>;
  /** Company client belongs to */
  company?: Maybe<Scalars['String']['output']>;
  /** Company frontend url */
  companyFrontEndUrl?: Maybe<Scalars['String']['output']>;
  /** Authorized Contracts */
  contracts?: Maybe<Array<Maybe<BankableEntityContractType>>>;
  /** JSON array with campaign cookie entries */
  cookiePath?: Maybe<Scalars['String']['output']>;
  /** Created at */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** KYC documents uploaded for this client */
  documents?: Maybe<Array<Maybe<Document>>>;
  /** Count of KYC documents uploaded for this client */
  documentsCount?: Maybe<Scalars['Int']['output']>;
  dueRemindersCount?: Maybe<Scalars['Int']['output']>;
  /** Economic profile fields */
  economicProfile?: Maybe<EconomicProfile>;
  /** Email address */
  email?: Maybe<Scalars['String']['output']>;
  emailCategoryPreferences?: Maybe<Array<Maybe<IndividualEmailCategoryPreference>>>;
  /** Whether the client confirmed his email */
  emailConfirmed?: Maybe<Scalars['Boolean']['output']>;
  /** Pending email change waiting for a confirmation */
  emailPendingChange?: Maybe<Scalars['String']['output']>;
  /** Acceptance of Customer Agreement */
  eulaAcceptance?: Maybe<YesNo>;
  /** Date of acceptance of Customer Agreement */
  eulaAcceptanceDate?: Maybe<Scalars['DateTime']['output']>;
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** full name */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Client's gender */
  gender?: Maybe<Gender>;
  /** General client note */
  generalNote?: Maybe<Scalars['String']['output']>;
  generalNoteImportant?: Maybe<Scalars['Boolean']['output']>;
  /** Has Adverse Media */
  hasReputationalRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Client ID */
  id: Scalars['Int']['output'];
  /** Should campaign require email verification */
  isEmailVerificationRequired?: Maybe<Scalars['Boolean']['output']>;
  isIntroducer?: Maybe<Scalars['Boolean']['output']>;
  /** User's online status */
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  /** Client is Politically Exposed */
  isPep?: Maybe<Scalars['Boolean']['output']>;
  /** Should mobile app require phone verification */
  isPhoneVerificationRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Flag to Check telephone number is verified */
  isPhoneVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Whether user is in Agent Pool */
  isPool?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the client is verified */
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  /** KYC Deadline Date */
  kycDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** Client's language */
  language?: Maybe<Language>;
  /** Last successful login be current session */
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Date of the last note for the client */
  lastNote?: Maybe<Scalars['DateTime']['output']>;
  /** Date and time of the last session activity */
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  /** Client locale - used to set currency, language, timezone */
  locale?: Maybe<Locale>;
  /** Mobile Preferences */
  mobilePreferences?: Maybe<Array<Maybe<IndividualMobilePreference>>>;
  /** Client's nationality */
  nationality?: Maybe<Nationality>;
  nationalityDescription?: Maybe<Scalars['String']['output']>;
  /** Date of the next appointment of the client */
  nextAppointment?: Maybe<Scalars['DateTime']['output']>;
  /** Notes about this client */
  notes?: Maybe<Array<Maybe<Note>>>;
  /** Count of notes about this client */
  notesCount?: Maybe<Scalars['Int']['output']>;
  /** Notices */
  notices?: Maybe<Array<Maybe<Notice>>>;
  /** GDPR Opt In SMS */
  optInSms?: Maybe<Scalars['Boolean']['output']>;
  /** Client originated from Mobile App */
  originatedFromMobile?: Maybe<Scalars['Boolean']['output']>;
  /** Contract ownership transfer requests */
  pendingContractOwnershipTransfers?: Maybe<Array<ContractOwnershipTransfer>>;
  performedChecks?: Maybe<Array<Maybe<CheckResult>>>;
  /** Personal Id Detail */
  personalIdDetails?: Maybe<Array<Maybe<IndividualPersonalIdDetail>>>;
  /** Contact telephone number */
  phone?: Maybe<Scalars['String']['output']>;
  /** Primary TwoFA Method */
  primaryTwoFAMethod?: Maybe<TwoFaMethod>;
  /** Acceptance of Privacy Policy */
  privacyAcceptance?: Maybe<YesNo>;
  /** Date of acceptance of Privacy Policy */
  privacyAcceptanceDate?: Maybe<Scalars['DateTime']['output']>;
  /** Profile changes submitted by client */
  profileChanges?: Maybe<Array<Maybe<ProfileChange>>>;
  /** Count of profile changes submitted by client */
  profileChangesCount?: Maybe<Scalars['Int']['output']>;
  /** Registration date - but no earlier than 2/2/2016 */
  registration?: Maybe<Scalars['DateTime']['output']>;
  requireAccount?: Maybe<Scalars['String']['output']>;
  /** Acceptance of Risk Disclaimer */
  riskAcceptance?: Maybe<YesNo>;
  /** Date of acceptance of Risk Disclaimer */
  riskAcceptanceDate?: Maybe<Scalars['DateTime']['output']>;
  /** Risk Profile */
  riskProfile?: Maybe<RiskProfile>;
  /** Status on Salv */
  salvStatus?: Maybe<SalvStatus>;
  /** Secondary Emails */
  secondaryEmails?: Maybe<SecondaryEmails>;
  /** Secondary Phones */
  secondaryPhones?: Maybe<SecondaryPhones>;
  /** Signature Specimen */
  signatureSpecimen?: Maybe<IndividualSignatureSpecimen>;
  /** History of Signature Specimens */
  signatureSpecimenHistory?: Maybe<Array<Maybe<IndividualSignatureSpecimen>>>;
  /**
   * Signup reason: private use/corporate
   * @deprecated not used anymore
   */
  signupReason?: Maybe<Scalars['String']['output']>;
  smsCategoryPreferences?: Maybe<Array<Maybe<IndividualSmsCategoryPreference>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Tax Id/ TIN */
  taxId?: Maybe<Scalars['String']['output']>;
  /** Timestamp of last change to client record */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Client is US Reportable */
  usReportablePerson?: Maybe<Scalars['Boolean']['output']>;
  /** Medium used to verify client */
  verificationMedium?: Maybe<VerificationMedium>;
  /** Last Verification OCR Data */
  videoVerificationOCRData?: Maybe<Scalars['JSON']['output']>;
  /** Status of Video Verification */
  videoVerificationStatus?: Maybe<VideoVerificationStatus>;
  /** Whether the client is verified, (legacy) should use isVerified instead */
  videoVerified?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Website
   * @deprecated Use websites instead
   */
  website?: Maybe<Scalars['String']['output']>;
  /** Websites */
  websites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Whitelabel */
  whitelabel?: Maybe<Whitelabel>;
};


/** An Individual Client */
export type IndividualActivityLogsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  company?: InputMaybe<Company>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Country>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  excludePinned?: InputMaybe<Scalars['Boolean']['input']>;
  feeGroupId?: InputMaybe<Scalars['ID']['input']>;
  includeNullClientId?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerId?: InputMaybe<Scalars['ID']['input']>;
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyPinned?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  origins?: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  standingOrderId?: InputMaybe<Scalars['ID']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ActivityLogTypeType>;
  types?: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


/** An Individual Client */
export type IndividualActivityLogsCountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  company?: InputMaybe<Company>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Country>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  excludePinned?: InputMaybe<Scalars['Boolean']['input']>;
  feeGroupId?: InputMaybe<Scalars['ID']['input']>;
  ignoreCache?: InputMaybe<Scalars['Boolean']['input']>;
  includeNullClientId?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerId?: InputMaybe<Scalars['ID']['input']>;
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  onlyPinned?: InputMaybe<Scalars['Boolean']['input']>;
  origins?: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  standingOrderId?: InputMaybe<Scalars['ID']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ActivityLogTypeType>;
  types?: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


/** An Individual Client */
export type IndividualAlertsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  legalEntityId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  priorities?: InputMaybe<Array<InputMaybe<MonitoringAlertPriority>>>;
  sanctionType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scenarios?: InputMaybe<Array<InputMaybe<MonitoringAlertScenario>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};


/** An Individual Client */
export type IndividualAppointmentsArgs = {
  status?: InputMaybe<IndividualAppointmentStatus>;
};


/** An Individual Client */
export type IndividualDocumentsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['Int']['input']>;
  contractStatuses?: InputMaybe<Array<InputMaybe<ContractStatusType>>>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  expirationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  expirationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['Int']['input']>;
  isExpAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyFromSystem?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<DocumentOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  origin?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  profileChangeId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  standingOrderId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<DocumentStatus>;
  statuses?: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  transactionRequestId?: InputMaybe<Scalars['ID']['input']>;
  types?: InputMaybe<Array<InputMaybe<DocumentType>>>;
  userFilter?: InputMaybe<DocumentUserFilter>;
  walletId?: InputMaybe<Scalars['ID']['input']>;
};


/** An Individual Client */
export type IndividualDocumentsCountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['Int']['input']>;
  contractStatuses?: InputMaybe<Array<InputMaybe<ContractStatusType>>>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  expirationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  expirationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['Int']['input']>;
  isExpAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  onlyFromSystem?: InputMaybe<Scalars['Boolean']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  profileChangeId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  standingOrderId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<DocumentStatus>;
  statuses?: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  transactionRequestId?: InputMaybe<Scalars['ID']['input']>;
  types?: InputMaybe<Array<InputMaybe<DocumentType>>>;
  userFilter?: InputMaybe<DocumentUserFilter>;
  walletId?: InputMaybe<Scalars['ID']['input']>;
};


/** An Individual Client */
export type IndividualNotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/** An Individual Client */
export type IndividualProfileChangesArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<ProfileChangeStatus>>>;
  type?: InputMaybe<ProfileChangeType>;
};


/** An Individual Client */
export type IndividualProfileChangesCountArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<ProfileChangeStatus>>>;
  type?: InputMaybe<ProfileChangeType>;
};


/** An Individual Client */
export type IndividualTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};

/** Individual Appointments */
export type IndividualAppointment = {
  __typename?: 'IndividualAppointment';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  individual: Individual;
  startTime: Scalars['DateTime']['output'];
  status: IndividualAppointmentStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum IndividualAppointmentStatus {
  Canceled = 'canceled',
  Completed = 'completed',
  Missed = 'missed',
  Rescheduled = 'rescheduled',
  Scheduled = 'scheduled'
}

export enum IndividualContractOnboardingRequiredCheck {
  EmailConfirmation = 'emailConfirmation',
  PhoneVerification = 'phoneVerification',
  VideoVerification = 'videoVerification'
}

export enum IndividualContractRole {
  AuthorizedLimitedAccess = 'authorizedLimitedAccess',
  AuthorizedSignatory = 'authorizedSignatory',
  Creator = 'creator',
  Ubo = 'ubo'
}

/** Individual Email Category Preference */
export type IndividualEmailCategoryPreference = {
  __typename?: 'IndividualEmailCategoryPreference';
  /** Name of email category */
  active: Scalars['Boolean']['output'];
  /** Description of email category */
  category: EmailCategory;
  categoryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

/** Which field to order the query results by */
export enum IndividualEmailCategoryPreferenceOrderBy {
  IndividualId = 'individualId'
}

/** Individual Mobile Preference */
export type IndividualMobilePreference = {
  __typename?: 'IndividualMobilePreference';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  notificationSettings?: Maybe<NotificationSettingsType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Individual Personal Id Detail */
export type IndividualPersonalIdDetail = {
  __typename?: 'IndividualPersonalIdDetail';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  documents?: Maybe<Array<Maybe<Document>>>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  idNumber?: Maybe<Scalars['String']['output']>;
  individual: Individual;
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  issuingCountry?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Individual SMS Category Preference */
export type IndividualSmsCategoryPreference = {
  __typename?: 'IndividualSMSCategoryPreference';
  /** Name of SMS category */
  active: Scalars['Boolean']['output'];
  /** Description of SMS category */
  category: SmsCategory;
  categoryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

/** Which field to order the query results by */
export enum IndividualSmsCategoryPreferenceOrderBy {
  IndividualId = 'individualId'
}

/** Individual Signature Specimen */
export type IndividualSignatureSpecimen = {
  __typename?: 'IndividualSignatureSpecimen';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** 2FA Method Setting */
export type IndividualTwoFaMethod = {
  __typename?: 'IndividualTwoFAMethod';
  /** Method is Enabled For Individual */
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Method is Primary For Individual */
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  method: TwoFaMethod;
};

export enum IntegrationTypeRequired {
  Gateway = 'gateway',
  Payabl = 'payabl'
}

export enum InternalTransferType {
  BetweenClients = 'betweenClients',
  OwnAccounts = 'ownAccounts'
}

export type IntroducerPayoutInfo = {
  __typename?: 'IntroducerPayoutInfo';
  currency?: Maybe<Currency>;
  lastFetched?: Maybe<Scalars['DateTime']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  payable?: Maybe<Scalars['Float']['output']>;
  pending?: Maybe<Scalars['Float']['output']>;
  qualifyingRevenue?: Maybe<Scalars['Float']['output']>;
};

export type IssueCardApiResponse = {
  __typename?: 'IssueCardApiResponse';
  card?: Maybe<CardType>;
  sensitiveInfo?: Maybe<CardSensitiveInfoType>;
};

export type IssueCardApiResponseV2 = {
  __typename?: 'IssueCardApiResponseV2';
  card?: Maybe<CardType>;
  sensitiveInfo?: Maybe<CardSensitiveInfoRef>;
};

/** KYC Measures */
export enum KycMeasuresType {
  NoTool = 'noTool',
  NotAvailable = 'notAvailable',
  Pep = 'pep',
  PepSanctions = 'pepSanctions',
  PepSanctionsAdverseMedia = 'pepSanctionsAdverseMedia',
  PepSanctionsAdverseMediaOther = 'pepSanctionsAdverseMediaOther'
}

/** List of KYC statuses */
export enum KycStatus {
  Amlo = 'amlo',
  Approved = 'approved',
  Draft = 'draft',
  FirstLine = 'firstLine',
  Management = 'management',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** KYC status log */
export type KycStatusLog = BaseLogInterface & {
  __typename?: 'KycStatusLog';
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** KYC status */
  kycStatus?: Maybe<KycStatus>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** KYC rejection reason */
  statusReason?: Maybe<Scalars['String']['output']>;
  /** KYC rejection reason code */
  statusReasonCode?: Maybe<Scalars['String']['output']>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

export enum Language {
  Aa = 'aa',
  Ab = 'ab',
  Af = 'af',
  Ak = 'ak',
  Am = 'am',
  An = 'an',
  Ar = 'ar',
  As = 'as',
  Av = 'av',
  Ay = 'ay',
  Az = 'az',
  Ba = 'ba',
  Be = 'be',
  Bg = 'bg',
  Bh = 'bh',
  Bi = 'bi',
  Bm = 'bm',
  Bn = 'bn',
  Br = 'br',
  Bs = 'bs',
  Ca = 'ca',
  Ce = 'ce',
  Ch = 'ch',
  Co = 'co',
  Cr = 'cr',
  Cs = 'cs',
  Cv = 'cv',
  Cy = 'cy',
  Da = 'da',
  De = 'de',
  Dv = 'dv',
  Dz = 'dz',
  Ee = 'ee',
  El = 'el',
  En = 'en',
  EnAu = 'enAU',
  EnCa = 'enCA',
  EnGb = 'enGB',
  EnUs = 'enUS',
  Eo = 'eo',
  Es = 'es',
  Et = 'et',
  Eu = 'eu',
  Fa = 'fa',
  Ff = 'ff',
  Fi = 'fi',
  Fj = 'fj',
  Fo = 'fo',
  Fr = 'fr',
  Fy = 'fy',
  Ga = 'ga',
  Gd = 'gd',
  Gl = 'gl',
  Gn = 'gn',
  Gu = 'gu',
  Gv = 'gv',
  Ha = 'ha',
  He = 'he',
  Hi = 'hi',
  Ho = 'ho',
  Hr = 'hr',
  Ht = 'ht',
  Hu = 'hu',
  Hy = 'hy',
  Hz = 'hz',
  Id = 'id',
  Ig = 'ig',
  Ii = 'ii',
  Ik = 'ik',
  Io = 'io',
  Is = 'is',
  It = 'it',
  Iu = 'iu',
  Ja = 'ja',
  Jv = 'jv',
  Ka = 'ka',
  Kg = 'kg',
  Ki = 'ki',
  Kj = 'kj',
  Kk = 'kk',
  Kl = 'kl',
  Km = 'km',
  Kn = 'kn',
  Ko = 'ko',
  Kr = 'kr',
  Ks = 'ks',
  Ku = 'ku',
  Kv = 'kv',
  Kw = 'kw',
  Ky = 'ky',
  La = 'la',
  Lb = 'lb',
  Lg = 'lg',
  Li = 'li',
  Ln = 'ln',
  Lo = 'lo',
  Lt = 'lt',
  Lv = 'lv',
  Mg = 'mg',
  Mh = 'mh',
  Mi = 'mi',
  Mk = 'mk',
  Ml = 'ml',
  Mn = 'mn',
  Mo = 'mo',
  Mr = 'mr',
  Ms = 'ms',
  Mt = 'mt',
  My = 'my',
  Na = 'na',
  Nb = 'nb',
  Nd = 'nd',
  Ne = 'ne',
  Ng = 'ng',
  Nl = 'nl',
  No = 'no',
  Nr = 'nr',
  Nv = 'nv',
  Ny = 'ny',
  Oc = 'oc',
  Oj = 'oj',
  Om = 'om',
  Or = 'or',
  Os = 'os',
  Pa = 'pa',
  Ph = 'ph',
  Pi = 'pi',
  Pl = 'pl',
  Ps = 'ps',
  Pt = 'pt',
  Qu = 'qu',
  Rn = 'rn',
  Ro = 'ro',
  Ru = 'ru',
  Rw = 'rw',
  Sa = 'sa',
  Sc = 'sc',
  Sd = 'sd',
  Se = 'se',
  Sg = 'sg',
  Sh = 'sh',
  Si = 'si',
  Sk = 'sk',
  Sl = 'sl',
  Sm = 'sm',
  Sn = 'sn',
  So = 'so',
  Sq = 'sq',
  Sr = 'sr',
  Ss = 'ss',
  St = 'st',
  Su = 'su',
  Sv = 'sv',
  Sw = 'sw',
  Ta = 'ta',
  Tg = 'tg',
  Th = 'th',
  Ti = 'ti',
  Tk = 'tk',
  Tn = 'tn',
  To = 'to',
  Tr = 'tr',
  Ts = 'ts',
  Tt = 'tt',
  Tw = 'tw',
  Ty = 'ty',
  Ug = 'ug',
  Uk = 'uk',
  Ur = 'ur',
  Uz = 'uz',
  Ve = 've',
  Vi = 'vi',
  Vo = 'vo',
  Wa = 'wa',
  Wo = 'wo',
  Xh = 'xh',
  Yi = 'yi',
  Yo = 'yo',
  Za = 'za',
  Zh = 'zh',
  Zu = 'zu'
}

export type Ledger = {
  __typename?: 'Ledger';
  balance?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  drainSettings?: Maybe<LedgerDrainSetting>;
  id?: Maybe<Scalars['ID']['output']>;
  isDrainable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<LedgerType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LedgerDrainExternalDestination = {
  __typename?: 'LedgerDrainExternalDestination';
  accountNo?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Address>;
  bankAddress?: Maybe<Address>;
  bankBic: Scalars['String']['output'];
  bankBranchId?: Maybe<Scalars['String']['output']>;
  bankBranchName?: Maybe<Scalars['String']['output']>;
  bankClearingMemberId?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type LedgerDrainSetting = {
  __typename?: 'LedgerDrainSetting';
  /** Destination Details */
  destinationDetails?: Maybe<LedgerDrainExternalDestination>;
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  /** Pass Through Account */
  passThroughAccount?: Maybe<Account>;
  referenceMessageTemplate?: Maybe<Scalars['String']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

export type LedgerLog = BaseLogInterface & {
  __typename?: 'LedgerLog';
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Ledger linked with ActivityLog */
  objectLedger?: Maybe<Ledger>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

export type LedgerTransaction = {
  __typename?: 'LedgerTransaction';
  comment?: Maybe<Scalars['String']['output']>;
  correspondentBankInfo?: Maybe<CorrespondentBankInfo>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  debitAuthorizationStarted?: Maybe<Scalars['Boolean']['output']>;
  destination?: Maybe<LedgerTransactionParty>;
  entryType?: Maybe<TransactionEntryType>;
  externalRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isAuthorizedForFX?: Maybe<Scalars['Boolean']['output']>;
  ledger?: Maybe<Ledger>;
  legsId?: Maybe<Scalars['ID']['output']>;
  nameMisMatchInfo?: Maybe<NameMismatchInfo>;
  paymentRail?: Maybe<PaymentRail>;
  paymentRailBranch?: Maybe<Scalars['String']['output']>;
  relatedTransaction?: Maybe<Transaction>;
  returnedWithId?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<LedgerTransactionParty>;
  status?: Maybe<LedgerTransactionStatus>;
  swiftMessage?: Maybe<RawSwiftMessage>;
  transactionReference?: Maybe<Scalars['String']['output']>;
  type?: Maybe<LedgerTransactionType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type LedgerTransactionLog = BaseLogInterface & {
  __typename?: 'LedgerTransactionLog';
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Ledger Transaction linked with ActivityLog */
  objectLedgerTransaction?: Maybe<LedgerTransaction>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

/** Which field to order the query results by */
export enum LedgerTransactionOrderBy {
  CreatedAt = 'createdAt',
  Id = 'id',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export type LedgerTransactionParty = {
  __typename?: 'LedgerTransactionParty';
  accountId?: Maybe<Scalars['ID']['output']>;
  accountNo?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['ID']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  walletAddress?: Maybe<Scalars['String']['output']>;
};

export enum LedgerTransactionStatus {
  Completed = 'completed',
  CompletedManually = 'completedManually',
  DestinationCurrencyMismatch = 'destinationCurrencyMismatch',
  DestinationNotResolved = 'destinationNotResolved',
  IncomingCreditorNameMismatch = 'incomingCreditorNameMismatch',
  OutboundDestinationNotResolved = 'outboundDestinationNotResolved',
  PayoutFailed = 'payoutFailed',
  PayoutInfoMissing = 'payoutInfoMissing',
  Pending = 'pending',
  PendingNostroCheck = 'pendingNostroCheck',
  PendingPayoutAck = 'pendingPayoutAck',
  QueuedForPayout = 'queuedForPayout'
}

export enum LedgerTransactionType {
  Cashback = 'cashback',
  Commission = 'commission',
  CrossLedgerTransfer = 'crossLedgerTransfer',
  Fee = 'fee',
  Fx = 'fx',
  ManualBooking = 'manualBooking',
  Swift = 'swift',
  SwiftInstitutional = 'swiftInstitutional',
  Transfer = 'transfer'
}

export enum LedgerType {
  CardAuth = 'cardAuth',
  CardAuthIndividual = 'cardAuthIndividual',
  CardCleared = 'cardCleared',
  CardClearedIndividual = 'cardClearedIndividual',
  CardTopUp = 'cardTopUp',
  Cashback = 'cashback',
  Commission = 'commission',
  Crypto = 'crypto',
  DirectDebit = 'directDebit',
  DirectDebitRefunds = 'directDebitRefunds',
  Fee = 'fee',
  Fx = 'fx',
  FxSettlement = 'fxSettlement',
  GuaranteedAccounts = 'guaranteedAccounts',
  Holding = 'holding',
  Interest = 'interest',
  MiscGains = 'miscGains',
  Terrapay = 'terrapay',
  VisaB2B = 'visaB2B',
  VisaDa = 'visaDA'
}

/** Legacy Pre-Assessment */
export type LegacyPreAssessment = {
  __typename?: 'LegacyPreAssessment';
  /** Pre-Assessment companyAnnualIncome */
  companyAnnualIncome?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment companyAnnualIncomeCurrency */
  companyAnnualIncomeCurrency?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment companyInfoCountryOfRegistration */
  companyInfoCountryOfRegistration?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment companyInfoRegisteredName */
  companyInfoRegisteredName?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment companyInfoTradingNamesAndUrls */
  companyInfoTradingNamesAndUrls?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment contactPersonEmail */
  contactPersonEmail?: Maybe<Scalars['String']['output']>;
  /** PreAssessment contactPersonFullName */
  contactPersonFullName?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment contactPersonPhoneNumber */
  contactPersonPhoneNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Pre-Assessment currencyAndVolume */
  currencyAndVolume?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Pre-Assessment generalQuestionsBusinessActivities */
  generalQuestionsBusinessActivities?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment generalQuestionsMainUsage */
  generalQuestionsMainUsage?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment generalQuestionsOperatingCountries */
  generalQuestionsOperatingCountries?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment generalQuestionsPaymentProviders */
  generalQuestionsPaymentProviders?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Pre-Assessment incomingAverage */
  incomingAverage?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment incomingAverageCurrency */
  incomingAverageCurrency?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment incomingClients */
  incomingClients?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment incomingEstimatedMonthlyAmount */
  incomingEstimatedMonthlyAmount?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment incomingMonthlyTurnover */
  incomingMonthlyTurnover?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment incomingMonthlyTurnoverCurrency */
  incomingMonthlyTurnoverCurrency?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment introducedBy */
  introducedBy?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment noPartnersIncomingRequired */
  noPartnersIncomingRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Pre-Assessment noPartnersOutgoingRequired */
  noPartnersOutgoingRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Pre-Assessment outgoingAverage */
  outgoingAverage?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment outgoingAverageCurrency */
  outgoingAverageCurrency?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment outgoingClients */
  outgoingClients?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment outgoingEstimatedMonthlyAmount */
  outgoingEstimatedMonthlyAmount?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment outgoingMonthlyTurnover */
  outgoingMonthlyTurnover?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment outgoingMonthlyTurnoverCurrency */
  outgoingMonthlyTurnoverCurrency?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment referralCode */
  referralCode?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment regulatoryInfoLicenseNumber */
  regulatoryInfoLicenseNumber?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment regulatoryInfoName */
  regulatoryInfoName?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment status */
  status?: Maybe<PreAssessmentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LegalEntity = {
  __typename?: 'LegalEntity';
  /** Legal Entity Address */
  address?: Maybe<Address>;
  /** Legal Entity Business Description */
  businessDescription?: Maybe<Scalars['String']['output']>;
  /** Legal Entity Business Sector */
  businessSector?: Maybe<Scalars['String']['output']>;
  /** Countries the company’s clients are based in */
  companyClientsCountries?: Maybe<Array<Maybe<CountriesAndRegionsType>>>;
  /** Legal Entity Company Name */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Legal Entity Company Reg Date */
  companyRegistrationDate?: Maybe<Scalars['Date']['output']>;
  /** Legal Entity Company Reg ID */
  companyRegistrationId?: Maybe<Scalars['String']['output']>;
  /** Legal Entity Company Type */
  companyType?: Maybe<CompanyType>;
  /** Correspondence Address */
  correspondenceAddress?: Maybe<Address>;
  /** Countries Of Operating And Conducting Business */
  countriesOfOperatingAndConductingBusiness?: Maybe<Array<Maybe<CountriesAndRegionsType>>>;
  /** Economic profile fields */
  economicProfile?: Maybe<EconomicProfile>;
  /** Has Adverse Media */
  hasReputationalRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Contract ID */
  id: Scalars['Int']['output'];
  immediatePreviousCompanyName?: Maybe<Scalars['String']['output']>;
  legalEntityDirectors?: Maybe<Array<Maybe<LegalEntityDirector>>>;
  /** Legal Entity Company Type */
  legalEntityType?: Maybe<UboLegalEntityType>;
  /** Legal Entity Phone Number */
  phone?: Maybe<Scalars['String']['output']>;
  /** Has Public Info */
  publicInfo?: Maybe<Scalars['Boolean']['output']>;
  /** Risk Profile */
  riskProfile?: Maybe<RiskProfile>;
  /** Status on Salv */
  salvStatus?: Maybe<SalvStatus>;
  sanctionedIndustry?: Maybe<SanctionedIndustry>;
  /** What industries does the company serve */
  servingIndustries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Tax ID */
  taxId?: Maybe<Scalars['String']['output']>;
  /** Legal Entity Trading Name */
  tradingName?: Maybe<Scalars['String']['output']>;
  /** Transactional Partners */
  transactionalPartners?: Maybe<Array<Maybe<TransactionalPartner>>>;
  /**
   * Legal Entity Website
   * @deprecated Use websites instead
   */
  website?: Maybe<Scalars['String']['output']>;
  /** Legal Entity Websites */
  websites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LegalEntityLegalEntityDirectorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};

/** LegalEntityDirector */
export type LegalEntityDirector = {
  __typename?: 'LegalEntityDirector';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Legal Entity Director ID */
  id: Scalars['ID']['output'];
  /** Legal Entity Director Individual */
  individual?: Maybe<Individual>;
  /** Director Entity */
  legalEntity?: Maybe<LegalEntity>;
  role?: Maybe<DirectorRole>;
  signingRight?: Maybe<DirectorSigningRights>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LegalEntityDirectorInput = {
  contractId: Scalars['ID']['input'];
  naturalPerson?: InputMaybe<AuthorizedPersonInputType>;
  role?: InputMaybe<DirectorRole>;
  signingRight?: InputMaybe<DirectorSigningRights>;
};

/** Legal Entity / Individual Union Type */
export type LegalEntityOrIndividual = Individual | LegalEntity;

export type LimitObjectType = {
  __typename?: 'LimitObjectType';
  amount: Scalars['Float']['output'];
  limitType: CardSpendingLimitTypes;
};

export enum LimitedAccessRight {
  CardHolder = 'cardHolder',
  PaymentFacilitationView = 'paymentFacilitationView',
  ViewDataEntry = 'viewDataEntry',
  ViewOnly = 'viewOnly'
}

export enum Locale {
  Ar = 'ar',
  Cs = 'cs',
  Da = 'da',
  De = 'de',
  El = 'el',
  En = 'en',
  Es = 'es',
  Fi = 'fi',
  Fr = 'fr',
  Hi = 'hi',
  Id = 'id',
  It = 'it',
  Ko = 'ko',
  Ms = 'ms',
  Nl = 'nl',
  No = 'no',
  Ph = 'ph',
  Pl = 'pl',
  Pt = 'pt',
  Ro = 'ro',
  Ru = 'ru',
  Sv = 'sv',
  Th = 'th',
  Tr = 'tr',
  Vi = 'vi',
  Zh = 'zh'
}

/** A staff member location */
export type Location = {
  __typename?: 'Location';
  /** Address of location */
  address?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Location ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Name of location */
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ManualBookingInfo = {
  __typename?: 'ManualBookingInfo';
  accountId?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['Float']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  counterParty: TransactionParty;
  currency?: Maybe<Scalars['String']['output']>;
  entryType: TransactionEntryType;
  externalRefId: Scalars['ID']['output'];
  internalComments?: Maybe<Scalars['String']['output']>;
  paymentRail?: Maybe<PaymentRail>;
  swiftMessageId?: Maybe<Scalars['ID']['output']>;
};

export type ManualBookingRequestInfoInput = {
  accountId: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  comments: Scalars['String']['input'];
  counterParty: SwiftTransferIndividualPartyDetailsInput;
  currency: Scalars['String']['input'];
  entryType: TransactionEntryType;
  externalRefId: Scalars['ID']['input'];
  internalComments: Scalars['String']['input'];
  paymentRail?: InputMaybe<PaymentRail>;
  swiftMessageId?: InputMaybe<Scalars['String']['input']>;
};

export type ManualBookingRequestInfoUpdateInput = {
  accountId: Scalars['ID']['input'];
  bankBic?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  senderAddress?: InputMaybe<AddressInput>;
  senderName?: InputMaybe<Scalars['String']['input']>;
};

/** Manual Type of Checks */
export enum ManualCheckType {
  Manual = 'manual',
  ManualThirdParty = 'manualThirdParty'
}

/** MaxCardAllowedLimitsType */
export type MaxCardAllowedLimitsType = {
  __typename?: 'MaxCardAllowedLimitsType';
  maxCardDailyContactlessPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  maxCardDailyInternetPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  maxCardDailyOverallPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  maxCardDailyPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  maxCardDailyWithdrawalLimit?: Maybe<Scalars['Int']['output']>;
  maxCardMonthlyContactlessPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  maxCardMonthlyInternetPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  maxCardMonthlyOverallPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  maxCardMonthlyPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  maxCardMonthlyWithdrawalLimit?: Maybe<Scalars['Int']['output']>;
  maxCardTransactionContactlessPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  maxCardTransactionInternetPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  maxCardTransactionPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  maxCardTransactionWithdrawalLimit?: Maybe<Scalars['Int']['output']>;
  maxCardWeeklyContactlessPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  maxCardWeeklyInternetPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  maxCardWeeklyOverallPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  maxCardWeeklyPurchaseLimit?: Maybe<Scalars['Int']['output']>;
  maxCardWeeklyWithdrawalLimit?: Maybe<Scalars['Int']['output']>;
};

export enum MinimumTurnOverFeeTypes {
  MinimumTurnover = 'minimum_turnover',
  MinimumTurnoverMonth_1 = 'minimum_turnover_month_1',
  MinimumTurnoverMonth_2 = 'minimum_turnover_month_2',
  MinimumTurnoverMonth_3 = 'minimum_turnover_month_3'
}

export type MinimumTurnoverInput = {
  code: MinimumTurnOverFeeTypes;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum MobileStatuses {
  Activated = 'activated',
  NotActivated = 'notActivated'
}

export type MobileTwoFa = {
  __typename?: 'MobileTwoFA';
  challengeId: Scalars['String']['output'];
  code?: Maybe<Scalars['String']['output']>;
  status: TwoFaMobileProgressStatus;
};

/** Monitoring Alerts for compliance/backoffice */
export type MonitoringAlert = {
  __typename?: 'MonitoringAlert';
  contracts?: Maybe<Array<Maybe<BankableEntityContractType>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  detail?: Maybe<Scalars['JSON']['output']>;
  externalId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  individual?: Maybe<Individual>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  isScreeningAlert?: Maybe<Scalars['Boolean']['output']>;
  legalEntity?: Maybe<LegalEntity>;
  meta?: Maybe<Scalars['JSON']['output']>;
  priority?: Maybe<MonitoringAlertPriority>;
  sanctionType?: Maybe<Scalars['String']['output']>;
  scenario?: Maybe<MonitoringAlertScenario>;
  source?: Maybe<MonitoringAlertSource>;
  status?: Maybe<Scalars['String']['output']>;
  transaction?: Maybe<Transaction>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum MonitoringAlertPriority {
  High = 'high',
  Low = 'low',
  None = 'none',
  Normal = 'normal'
}

export enum MonitoringAlertScenario {
  Offline = 'offline',
  Online = 'online',
  Periodic = 'periodic'
}

export enum MonitoringAlertSource {
  Chainalysis = 'chainalysis',
  Salv = 'salv',
  Sumsub = 'sumsub'
}

export type MultipleActionSignaturesReturnType = {
  __typename?: 'MultipleActionSignaturesReturnType';
  failed?: Maybe<Array<Maybe<IdValue>>>;
  signed?: Maybe<Array<Maybe<ActionSignature>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptContractAuthorizedPersonInvitation?: Maybe<Scalars['Boolean']['output']>;
  acceptIncomingTransactionCreditorNameMismatch?: Maybe<LedgerTransaction>;
  acceptRejectApprovalRequest?: Maybe<ApprovalRequest>;
  /** Ack Failed Swift Message With No Processing */
  ackFailedMessageWithNoProcessing?: Maybe<RawSwiftMessage>;
  /** Acknowledge Swift Messages By Thread Id */
  ackSwiftConversationByThreadId?: Maybe<Scalars['Boolean']['output']>;
  activateCard?: Maybe<CardType>;
  addAccountToBundle?: Maybe<Account>;
  addAccountToContract?: Maybe<Account>;
  addAccountToOwnContract?: Maybe<Account>;
  addAuthorizedPersonToPendingActions?: Maybe<Scalars['Boolean']['output']>;
  addContractAuthorizedPerson?: Maybe<ContractAuthorizedPersonType>;
  addContractAuthorizedPersonRequest?: Maybe<ContractAuthorizedPersonRequestResponse>;
  addContractExistingUbo?: Maybe<ContractUbo>;
  addContractGeneralNote?: Maybe<BankableEntityContractType>;
  addContractPaymentRecipient?: Maybe<ContractPaymentRecipient>;
  addContractToGroup?: Maybe<BankableEntityContractType>;
  addContractUbo?: Maybe<ContractUbo>;
  addEntityReminder?: Maybe<EntityReminder>;
  addFeeSettingGroup?: Maybe<FeeGroupToFee>;
  addLegalEntityDirector?: Maybe<LegalEntityDirector>;
  addNoteToSwiftConversationThread?: Maybe<SwiftConversationThread>;
  addProductsToContract?: Maybe<BankableEntityContractType>;
  /** Add Individual Signature Specimen */
  addSignatureSpecimen?: Maybe<Individual>;
  addSuspiciousReport?: Maybe<Scalars['Boolean']['output']>;
  addUboOwner?: Maybe<UboOwner>;
  addVirtualAccount?: Maybe<Account>;
  addVirtualAccountFromAPI?: Maybe<Account>;
  approveDirectDebit?: Maybe<DirectDebitMandate>;
  approveDirectDebitDispute?: Maybe<DirectDebitDispute>;
  associateContracts?: Maybe<BankableEntityContractType>;
  associateDocumentWithEntity?: Maybe<Document>;
  associateIndividuals?: Maybe<Individual>;
  beginDebitAuthorization?: Maybe<LedgerTransaction>;
  bookManualLedgerTransaction?: Maybe<LedgerTransaction>;
  cancelOutgoingTransaction?: Maybe<Transaction>;
  /** Cancel a Standing Order */
  cancelStandingOrder?: Maybe<StandingOrder>;
  /** Cancels Unsigned or Delayed Transaction */
  cancelTransaction?: Maybe<Transaction>;
  change2faMethod?: Maybe<Individual>;
  changeCardPin?: Maybe<CardSensitiveInfoRef>;
  changeContractFeeGroup?: Maybe<BankableEntityContractType>;
  changeContractPeriodicReviewDate?: Maybe<BankableEntityContractType>;
  changeIndividualPrimary2FAMethod?: Maybe<Individual>;
  changeVerifiedEmailPhone?: Maybe<Individual>;
  changeWalletAlias?: Maybe<Wallet>;
  changeWalletStatus?: Maybe<Wallet>;
  chargeManualFee?: Maybe<Transaction>;
  clearSettlementSweepRule?: Maybe<Account>;
  clearTransactionAML?: Maybe<Transaction>;
  clearTransactionRequestAML?: Maybe<TransactionRequest>;
  clearWallesterTransactionFiles?: Maybe<Scalars['Boolean']['output']>;
  cloneFeeGroup?: Maybe<FeeGroup>;
  closeAccount?: Maybe<Account>;
  closeVirtualAccount?: Maybe<Account>;
  completeDebitAuthorization?: Maybe<LedgerTransaction>;
  completePayout?: Maybe<SuccessFeePayout>;
  confirmEnableUser2fa?: Maybe<Scalars['Boolean']['output']>;
  confirmOwnEmail?: Maybe<Individual>;
  contractChangeRequest?: Maybe<ProfileChange>;
  contractTerminationRequest?: Maybe<Action>;
  coverAccountNegativeBalanceWithSiblingAccount?: Maybe<Array<Maybe<Account>>>;
  createAccountBundle: AccountBundle;
  createAccountClosureFinalRemittanceApprovalRequest?: Maybe<ApprovalRequest>;
  createAccountOpeningTicket?: Maybe<Scalars['Boolean']['output']>;
  createApiUser?: Maybe<ApiUser>;
  createCardAdjustmentTransactionApprovalRequest?: Maybe<ApprovalRequest>;
  createCardTermsAction?: Maybe<CreateCardTermsActionType>;
  createContract?: Maybe<BankableEntityContractType>;
  createContractDocument?: Maybe<Document>;
  createCustomerSupportRequest?: Maybe<Scalars['Boolean']['output']>;
  createDirectDebitCreditMandate?: Maybe<DirectDebitMandate>;
  createFeeReversalApprovalRequest?: Maybe<ApprovalRequest>;
  createIndividualContract?: Maybe<BankableEntityContractType>;
  /** Create an Internal Transfer Between Own Accounts */
  createInternalTransfer?: Maybe<Transaction>;
  createIntroducerReferenceContract?: Maybe<BankableEntityContractType>;
  createIssueAMLO?: Maybe<Scalars['Boolean']['output']>;
  createManualAccountBookingApprovalRequest?: Maybe<ApprovalRequest>;
  createNewContractInformationRequest?: Maybe<ContractInformationRequest>;
  createNote?: Maybe<Note>;
  /** Create an Outbound Crypto Payment */
  createOutboundCryptoPayment?: Maybe<Transaction>;
  /** Create an Outbound Payment */
  createOutboundPayment?: Maybe<Transaction>;
  createOwnDocument?: Maybe<Document>;
  createPaymentRailRouteConfig: PaymentRailRouteConfig;
  createPeriodicReviewTicket?: Maybe<Scalars['Boolean']['output']>;
  createQRBill?: Maybe<QrBillType>;
  createRFITicket?: Maybe<Scalars['Boolean']['output']>;
  /** Sepa Non Receipt Message */
  createSepaNonReceiptMessageMessage?: Maybe<TransactionClaimsRecallRequest>;
  /** Create a Standing Order */
  createStandingOrder?: Maybe<StandingOrder>;
  createSwiftThreadTicket?: Maybe<Scalars['Boolean']['output']>;
  /** Create a Swift Transfer */
  createSwiftTransfer?: Maybe<Transaction>;
  createTermsAndCondition?: Maybe<TermsAndCondition>;
  createTransactionServiceDeskRequest?: Maybe<Scalars['Boolean']['output']>;
  createVoidTransactionApprovalRequest?: Maybe<ApprovalRequest>;
  createWallet?: Maybe<Wallet>;
  createWalletServiceDeskRequest?: Maybe<Scalars['Boolean']['output']>;
  cryptoDepositAddress?: Maybe<Scalars['String']['output']>;
  deactivateApiUser?: Maybe<ApiUser>;
  deactivateAuthorizedPersonRequest?: Maybe<ContractAuthorizedPersonType>;
  deleteAccountBundle?: Maybe<Scalars['Boolean']['output']>;
  /** Delete Check */
  deleteCheck?: Maybe<Scalars['Boolean']['output']>;
  deleteContractContact?: Maybe<Scalars['Boolean']['output']>;
  deleteContractGroup?: Maybe<Scalars['Boolean']['output']>;
  deleteEntityReminder?: Maybe<EntityReminder>;
  deleteNotice?: Maybe<Notice>;
  deletePaymentRailRouteConfig: Scalars['Boolean']['output'];
  deleteProduct?: Maybe<Product>;
  deleteTermsAndCondition?: Maybe<TermsAndCondition>;
  disconnectCryptoWalletFromContract?: Maybe<Scalars['Boolean']['output']>;
  dismissIndividualNotice?: Maybe<Scalars['Boolean']['output']>;
  disputeDirectDebit?: Maybe<DirectDebitDispute>;
  dissociateContracts?: Maybe<BankableEntityContractType>;
  dissociateIndividuals?: Maybe<Individual>;
  downloadSuccessFeesExcel?: Maybe<Scalars['String']['output']>;
  downloadSuccessFeesPdf?: Maybe<Scalars['String']['output']>;
  drainLedgerOnDemand?: Maybe<Scalars['Boolean']['output']>;
  duplicateClassification?: Maybe<Scalars['Boolean']['output']>;
  editLegalEntityDirector?: Maybe<LegalEntityDirector>;
  enableUser2fa?: Maybe<Scalars['String']['output']>;
  executeAction?: Maybe<Action>;
  executeOutgoingCrypto?: Maybe<TransactionRequest>;
  executePayout?: Maybe<SuccessFeePayout>;
  executePayouts?: Maybe<Scalars['String']['output']>;
  exportContractPayouts?: Maybe<Scalars['String']['output']>;
  exportPayoutSuccessFees?: Maybe<Scalars['String']['output']>;
  finishSetupMobileTwoFaForIndividual?: Maybe<Scalars['Boolean']['output']>;
  finishSetupTwoFaForIndividual?: Maybe<Scalars['Boolean']['output']>;
  freezeCard?: Maybe<CardType>;
  freezeCardApi?: Maybe<CardType>;
  generateAeoiDocument?: Maybe<Scalars['Boolean']['output']>;
  generateContractAccountsConfirmation?: Maybe<Document>;
  generateFeeGroupDocument?: Maybe<Scalars['String']['output']>;
  generatePayoutStatement?: Maybe<Document>;
  generatePayoutStatements?: Maybe<Scalars['String']['output']>;
  generateSecurityCode?: Maybe<NewSecurityCode>;
  get2FACode?: Maybe<TwoFaCodeResponse>;
  getBatchPaymentFileSignedUrl?: Maybe<GetSignedUrlType>;
  getIndividualVideoVerificationUrl?: Maybe<Scalars['String']['output']>;
  getSignedUrl?: Maybe<GetSignedUrlType>;
  getSupportAttachmentSignedUrl?: Maybe<GetSignedUrlType>;
  importFeeGroupWithFeeFromCSV?: Maybe<Scalars['Boolean']['output']>;
  initiateReport?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use issueCardApiV2 */
  issueCardApi?: Maybe<IssueCardApiResponse>;
  issueCardApiV2?: Maybe<IssueCardApiResponseV2>;
  issueCardRequest?: Maybe<CardRequestType>;
  ledgerTransferTransaction?: Maybe<Array<Maybe<LedgerTransaction>>>;
  lockUnlockDocuments?: Maybe<Array<Maybe<Document>>>;
  logPeriodicReview?: Maybe<ContractPeriodicReview>;
  makeFeeGroupDefault?: Maybe<FeeGroup>;
  makeTermsAndConditionLatestVersion?: Maybe<TermsAndCondition>;
  manualAccountBooking?: Maybe<Transaction>;
  /** Manually respond to transaction claim recall request */
  manuallyRespondToTransactionClaimNonReceipt?: Maybe<TransactionClaimsRecallRequest>;
  markDocumentsAsRead?: Maybe<Scalars['Boolean']['output']>;
  modifyEntityReminder?: Maybe<EntityReminder>;
  modifyPaymentRailConfig: PaymentRailConfig;
  modifyPaymentRailRouteConfig: PaymentRailRouteConfig;
  modifyTransactionAdditionalComment?: Maybe<Transaction>;
  modifyTransactionCounterPartyAddress?: Maybe<Transaction>;
  newClassification?: Maybe<RiskClassification>;
  /** Records [Manual]/Performs and Records [Automated] Entity Check Results */
  performEntityCheck?: Maybe<CheckResult>;
  pinActivityLog?: Maybe<ActivityLog>;
  pinUnpinAccount?: Maybe<Scalars['Boolean']['output']>;
  pinUnpinDocument?: Maybe<Scalars['Boolean']['output']>;
  preapproveB2BDirectDebitMandate?: Maybe<DirectDebitMandate>;
  prepareBatchPaymentFromRecords?: Maybe<BatchPayment>;
  /** Prepare an Outbound Payment */
  prepareOutboundPayment?: Maybe<Transaction>;
  previewPayoutStatement?: Maybe<Scalars['String']['output']>;
  previewPayoutStatements?: Maybe<Scalars['String']['output']>;
  process2FAOperation?: Maybe<Scalars['Boolean']['output']>;
  processContractProfileChange?: Maybe<ProfileChange>;
  processDocument?: Maybe<Document>;
  processProfileChange?: Maybe<ProfileChange>;
  processTransferContractOwnership?: Maybe<BankableEntityContractType>;
  processVideoVerificationArtifacts?: Maybe<Scalars['Boolean']['output']>;
  publishFeeGroupDocument?: Maybe<Scalars['Boolean']['output']>;
  reCalculateContractSuccessFees?: Maybe<Scalars['Boolean']['output']>;
  recallDirectDebitExecution?: Maybe<DirectDebitExecution>;
  refundPayment?: Maybe<RefundPayment>;
  regenerateAllClassifications?: Maybe<Scalars['String']['output']>;
  rejectAction?: Maybe<Action>;
  rejectCreditDirectDebitExecution?: Maybe<DirectDebitExecution>;
  rejectDirectDebit?: Maybe<DirectDebitMandate>;
  rejectDirectDebitDispute?: Maybe<DirectDebitDispute>;
  rejectIncomingTransactionRecallRequest?: Maybe<TransactionClaimsRecallRequest>;
  rejectPayout?: Maybe<SuccessFeePayout>;
  rejectTransactionRequest?: Maybe<TransactionRequest>;
  removeAccountFromBundle?: Maybe<Account>;
  removeAuthorizedPersonAccountsRestriction?: Maybe<ContractAuthorizedPersonType>;
  removeContract?: Maybe<Scalars['Boolean']['output']>;
  removeContractAuthorizedPerson?: Maybe<Scalars['Boolean']['output']>;
  removeContractFromGroup?: Maybe<BankableEntityContractType>;
  removeContractInformationRequest?: Maybe<Scalars['Boolean']['output']>;
  removeContractPaymentRecipient?: Maybe<Scalars['Boolean']['output']>;
  removeContractUbo?: Maybe<Scalars['Boolean']['output']>;
  removeDeviceInformation?: Maybe<DeviceInformation>;
  removeDocument?: Maybe<Document>;
  removeLegalEntityDirector?: Maybe<LegalEntityDirector>;
  removeTags?: Maybe<Scalars['Boolean']['output']>;
  removeTransactionAsApprovedRecurring?: Maybe<Transaction>;
  removeUBOOwner?: Maybe<Scalars['Boolean']['output']>;
  removeUnsavedDocument?: Maybe<Scalars['Boolean']['output']>;
  renameAccountBundle: AccountBundle;
  renameCard?: Maybe<CardType>;
  repairPaymentInformation?: Maybe<LedgerTransaction>;
  requestAccountClosure?: Maybe<Account>;
  requestTansferContractOwnership?: Maybe<ContractOwnershipTransfer>;
  /** Re-queues Swift Message For Processing */
  requeueSwiftForProcessing?: Maybe<RawSwiftMessage>;
  rescreenWallet?: Maybe<Wallet>;
  resendContractAuthorizedPersonInvitation?: Maybe<Scalars['Boolean']['output']>;
  resendTransactionPayoutMessage?: Maybe<Scalars['Boolean']['output']>;
  resetApiUserSecret: Scalars['String']['output'];
  resetIndividual2FaAttempts?: Maybe<Scalars['Boolean']['output']>;
  resetIndividualPassword?: Maybe<Scalars['Boolean']['output']>;
  resetUserPassword?: Maybe<Scalars['Boolean']['output']>;
  resolveTransactionCurrencyMismatch?: Maybe<LedgerTransaction>;
  resolveTransactionDestination?: Maybe<LedgerTransaction>;
  resolveVibanNameMismatch?: Maybe<Scalars['Boolean']['output']>;
  resolveVibanNameMismatchFromTransaction?: Maybe<Scalars['Boolean']['output']>;
  restrictAccountToAuthorizedPersons?: Maybe<Account>;
  restrictAuthorizedPersonToAccounts?: Maybe<ContractAuthorizedPersonType>;
  returnFailedOutgoingTransactionFromLedger?: Maybe<LedgerTransaction>;
  returnIncomingLedgerTransaction?: Maybe<Array<Maybe<LedgerTransaction>>>;
  returnIncomingTransaction?: Maybe<Transaction>;
  reverseLedgerTransaction?: Maybe<LedgerTransaction>;
  revertDirectDebitRequest?: Maybe<DirectDebitExecution>;
  revertDocument?: Maybe<Document>;
  revertFeeTransaction?: Maybe<Transaction>;
  saveBalanceCurrency?: Maybe<ContractAuthorizedPersonType>;
  saveWalletBaseCurrency?: Maybe<Wallet>;
  scheduleUnderlyingVirtualAccountClosure?: Maybe<Scalars['Boolean']['output']>;
  /** Create and sends MT199/MT999 */
  sendMT199Message?: Maybe<RawSwiftMessage>;
  sendSmsVerification?: Maybe<PhoneVerificationRequest>;
  setAccountBannedPaymentRails?: Maybe<Account>;
  setAccountDefaultTransactionPurposeCode?: Maybe<Account>;
  setAccountPreferredFXPaymentRails?: Maybe<Account>;
  setAccountPreferredPaymentRail?: Maybe<Account>;
  setAutoApproveCryptoCheckStatuses?: Maybe<BankableEntityContractType>;
  setCardPendingLimits?: Maybe<CardType>;
  setCardPendingLimitsApi?: Maybe<CardType>;
  setContractAuthorizedPersonStatus?: Maybe<Array<Maybe<ContractAuthorizedPersonType>>>;
  setContractCommStatus?: Maybe<BankableEntityContractType>;
  setContractDesignatedFeeAccount?: Maybe<BankableEntityContractType>;
  setContractFundFlowDescription?: Maybe<BankableEntityContractType>;
  setContractIsIntroducingPartner?: Maybe<BankableEntityContractType>;
  setContractRiskProfile?: Maybe<BankableEntityContractType>;
  setContractStatementDeliveryBic?: Maybe<BankableEntityContractType>;
  setContractStatus?: Maybe<BankableEntityContractType>;
  setFeeGroupForAccount?: Maybe<Account>;
  setFinancialStatementsOfContract?: Maybe<BankableEntityContractType>;
  setHasPendingInvestigation?: Maybe<Transaction>;
  setIndividualVerification?: Maybe<Individual>;
  setKycMeasuresOfContract?: Maybe<BankableEntityContractType>;
  setPaymentCredentialsStatus?: Maybe<PaymentCredentialsType>;
  setTransactionAsApprovedRecurring?: Maybe<Transaction>;
  setUpLedgerDrain?: Maybe<Ledger>;
  setupSettlementSweepRule?: Maybe<Account>;
  showEconomicProfile?: Maybe<BankableEntityContractType>;
  signActionWithChallengeCode?: Maybe<ActionSignature>;
  /** custom notice client signature and sign date */
  signIndividualNotice?: Maybe<ClientResult>;
  signMultipleActionsWithChallengeCode?: Maybe<MultipleActionSignaturesReturnType>;
  signUploadUrl?: Maybe<SignedUrl>;
  smartAddContractAuthorizedPerson?: Maybe<Scalars['Boolean']['output']>;
  spendingLimitRequest?: Maybe<SpendingLimitRequestType>;
  startBatchPayment?: Maybe<BatchPayment>;
  startBatchPaymentFromRecords?: Maybe<BatchPayment>;
  startClassification?: Maybe<Scalars['String']['output']>;
  startDirectDebitBatchFromPain008Request?: Maybe<DirectDebitBatchType>;
  startDirectDebitBatchRequest?: Maybe<DirectDebitBatchType>;
  startSetupTwoFaForIndividual?: Maybe<TotpSetupData>;
  startVideoVerification?: Maybe<Scalars['String']['output']>;
  submitContractForApproval?: Maybe<BankableEntityContractType>;
  submitContractForPreAssessment?: Maybe<BankableEntityContractType>;
  switchPayoutRouteFromSepaToTarget2?: Maybe<LedgerTransaction>;
  syncContractOnboardingPipeDriveSummary?: Maybe<BankableEntityContractType>;
  syncVideoVerificationArtifacts?: Maybe<Scalars['Boolean']['output']>;
  terminateCard?: Maybe<CardType>;
  terminateCardApi?: Maybe<CardType>;
  toggleAccountAllowOnlyInternalTransactions?: Maybe<Account>;
  toggleAccountAutoSaveBeneficiary?: Maybe<Account>;
  toggleAccountDailyStatement?: Maybe<Account>;
  toggleAccountHidden?: Maybe<Account>;
  toggleAccountUseDirectInboundRoute?: Maybe<Account>;
  toggleAcknowledgeExpiredDocument?: Maybe<Document>;
  toggleAllowLocalPay?: Maybe<BankableEntityContractType>;
  toggleAllowVbanAllowThirdPartyDeposits?: Maybe<BankableEntityContractType>;
  toggleAllowVbanCreation?: Maybe<BankableEntityContractType>;
  toggleCCDedicatedAcMMutation?: Maybe<BankableEntityContractType>;
  toggleCardTransactionOTPViaApi?: Maybe<CardType>;
  toggleContractAuthorizedPersonSignOwnAction?: Maybe<ContractAuthorizedPersonType>;
  toggleContractCardTrxChargeMode?: Maybe<BankableEntityContractType>;
  toggleContractFlags?: Maybe<BankableEntityContractType>;
  toggleContractHandlesPhysicalCash?: Maybe<BankableEntityContractType>;
  toggleContractOwnerPublicInfo?: Maybe<BankableEntityContractType>;
  toggleContractOwnerReputationRisk?: Maybe<BankableEntityContractType>;
  toggleContractPep?: Maybe<BankableEntityContractType>;
  toggleCrsReportable?: Maybe<BankableEntityContractType>;
  toggleCryptoPayments?: Maybe<BankableEntityContractType>;
  toggleDisableIndividualAccess?: Maybe<Individual>;
  toggleEmailConfirmed?: Maybe<Individual>;
  toggleExemptFromNbc?: Maybe<BankableEntityContractType>;
  toggleFatcaReportable?: Maybe<BankableEntityContractType>;
  toggleHouseAccountUseFItoFI?: Maybe<Account>;
  toggleIndividualReputationalRisk?: Maybe<Individual>;
  toggleIsArchivedDocument?: Maybe<Document>;
  toggleIsInternalDocument?: Maybe<Document>;
  toggleIsPep?: Maybe<Individual>;
  toggleLegalEntityPublicInfo?: Maybe<LegalEntity>;
  toggleLegalEntityReputationalRisk?: Maybe<LegalEntity>;
  toggleSafeGuardingAccount?: Maybe<Account>;
  toggleSwiftConversationThreadForFollowUp?: Maybe<SwiftConversationThread>;
  toggleTransactionAsReviewed?: Maybe<Array<Maybe<Transaction>>>;
  toggleTransactionForceHold?: Maybe<Transaction>;
  topUpWithCard?: Maybe<Scalars['String']['output']>;
  topUpWithCrypto?: Maybe<TransactionRequest>;
  /** Create and Send Trx Return Request Message */
  transactionReturnRequest?: Maybe<Transaction>;
  tryClearErroneouslyCancelledCardTransaction?: Maybe<Transaction>;
  tryCorrectBeneficiaryBICOnFailedPayout?: Maybe<LedgerTransaction>;
  tryManuallyAcknowledgePendingJpmPayoutWithExtRef?: Maybe<Scalars['Boolean']['output']>;
  tryRevertCompletedJPMOutgoingTransaction?: Maybe<Scalars['Boolean']['output']>;
  trySwitchPaymentRail?: Maybe<LedgerTransaction>;
  unFreezeCard?: Maybe<CardType>;
  unFreezeCardApi?: Maybe<CardType>;
  updateAccount?: Maybe<Account>;
  updateAccountAlias?: Maybe<Account>;
  updateAccountAlternativeAccountDetails?: Maybe<Account>;
  updateAccountFundsType?: Maybe<Account>;
  updateAccountStatus?: Maybe<Account>;
  updateApiUserAllowedIps?: Maybe<ApiUser>;
  updateCard3DSecureSetting?: Maybe<CardType>;
  /** Updates Manual Entity Check Results */
  updateCheckResult?: Maybe<CheckResult>;
  updateClassification?: Maybe<RiskClassification>;
  updateContract?: Maybe<BankableEntityContractType>;
  updateContractAuthorizedPerson?: Maybe<ContractAuthorizedPersonType>;
  updateContractAuthorizedPersonSettings?: Maybe<ContractAuthorizedPersonType>;
  updateContractCommissionSettingAccount?: Maybe<BankableEntityContractType>;
  updateContractDirectDebitSettings?: Maybe<BankableEntityContractType>;
  updateContractInformationRequest?: Maybe<ContractInformationRequest>;
  updateContractInformationRequestIndividual?: Maybe<ContractInformationRequest>;
  updateContractOnboardingInfo?: Maybe<BankableEntityContractType>;
  updateContractPaymentRecipient?: Maybe<ContractPaymentRecipient>;
  updateContractRiskStructure?: Maybe<BankableEntityContractType>;
  updateContractUbo?: Maybe<ContractUbo>;
  updateDedicatedManagerContract?: Maybe<BankableEntityContractType>;
  updateFcmToken?: Maybe<Scalars['Boolean']['output']>;
  updateIndividualDetails?: Maybe<Individual>;
  updateIndividualEmailCategoryPreference?: Maybe<IndividualEmailCategoryPreference>;
  updateIndividualPhones?: Maybe<Individual>;
  updateIndividualSMSCategoryPreference?: Maybe<IndividualSmsCategoryPreference>;
  updateManualAccountBookingApprovalRequest?: Maybe<ApprovalRequest>;
  updateMobileNotificationSettings?: Maybe<IndividualMobilePreference>;
  updateOwnDetails?: Maybe<ProfileChange>;
  updateOwnEmail?: Maybe<Individual>;
  updateOwnLocale?: Maybe<Individual>;
  /** Change account passwords for the viewer */
  updateOwnPassword: Scalars['Boolean']['output'];
  updatePayoutSuccessFees?: Maybe<SuccessFeePayout>;
  updatePreAssessmentStatus?: Maybe<LegacyPreAssessment>;
  updateReferringContract?: Maybe<BankableEntityContractType>;
  updateRiskLevels?: Maybe<Scalars['String']['output']>;
  /** Update spending limit */
  updateSpendingLimit?: Maybe<SpendingLimitType>;
  updateTransactionAdditionalInfo?: Maybe<LedgerTransaction>;
  updateTransactionCorrespondentBankInfo?: Maybe<LedgerTransaction>;
  updateTransactionPaymentRailBranch?: Maybe<Transaction>;
  updateUboOwner?: Maybe<UboOwner>;
  updateWalletStatus?: Maybe<Wallet>;
  uploadNewCryptoStatement?: Maybe<Scalars['Boolean']['output']>;
  upsertArticle: Article;
  /** Edit/Create Manual Check */
  upsertCheck?: Maybe<Check>;
  upsertContractCommissionSettings?: Maybe<BankableEntityContractType>;
  upsertContractContact?: Maybe<ContractContact>;
  upsertContractGroup?: Maybe<ContractGroup>;
  upsertContractMinimumTurnoverFees?: Maybe<BankableEntityContractType>;
  upsertContractTechnicalProperties?: Maybe<ContractTechnicalDetailsType>;
  upsertDocument?: Maybe<Document>;
  upsertFee?: Maybe<Fee>;
  upsertFeeCategory?: Maybe<FeeCategory>;
  upsertFeeGroup?: Maybe<FeeGroup>;
  upsertFeeSubcategory?: Maybe<FeeSubcategory>;
  upsertFileBasedPainAccess?: Maybe<FileBasedPainAccessStatus>;
  upsertGeneralIndividualNote?: Maybe<Individual>;
  upsertNotice?: Maybe<Notice>;
  upsertPaymentCredentials?: Maybe<PaymentCredentialsType>;
  upsertPermission?: Maybe<Permission>;
  upsertProduct?: Maybe<Product>;
  upsertRole?: Maybe<Role>;
  upsertTags?: Maybe<Array<Maybe<Tag>>>;
  upsertUser?: Maybe<User>;
  userChangeOwnPassword?: Maybe<Scalars['Boolean']['output']>;
  validateBatchPaymentFile?: Maybe<BatchPaymentFileValidation>;
  validateDirectDebitBatchPaymentFile?: Maybe<DirectDebitBatchValidationType>;
  verifyPhone?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAcceptContractAuthorizedPersonInvitationArgs = {
  contractId: Scalars['ID']['input'];
};


export type MutationAcceptIncomingTransactionCreditorNameMismatchArgs = {
  addToApprovedAliases?: InputMaybe<Scalars['Boolean']['input']>;
  authorizationCode: Scalars['ID']['input'];
  ledgerTransactionId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationAcceptRejectApprovalRequestArgs = {
  authorizationCode: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  status: UserApprovalRequestStatus;
};


export type MutationAckFailedMessageWithNoProcessingArgs = {
  authorizationCode: Scalars['String']['input'];
  messageId: Scalars['ID']['input'];
};


export type MutationAckSwiftConversationByThreadIdArgs = {
  threadId: Scalars['ID']['input'];
};


export type MutationActivateCardArgs = {
  cardId: Scalars['ID']['input'];
  challengeId: Scalars['String']['input'];
  code: Scalars['ID']['input'];
  password: Scalars['ID']['input'];
};


export type MutationAddAccountToBundleArgs = {
  accountId: Scalars['ID']['input'];
  bundleId: Scalars['ID']['input'];
};


export type MutationAddAccountToContractArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  currency?: InputMaybe<NewAccountCurrency>;
  fundsType?: InputMaybe<FundsType>;
  ignoreAction?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  qrrSupported?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAddAccountToOwnContractArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  alternativeAccountDetails?: InputMaybe<SwiftTransferIndividualPartyDetailsWithCurrencyInput>;
  contractId: Scalars['ID']['input'];
  currency: NewAccountCurrency;
  fundsType?: InputMaybe<FundsType>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  qrrSupported?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAddAuthorizedPersonToPendingActionsArgs = {
  authorizationCode: Scalars['ID']['input'];
  authorizedPersonId: Scalars['ID']['input'];
};


export type MutationAddContractAuthorizedPersonArgs = {
  contractId: Scalars['ID']['input'];
  input?: InputMaybe<AddAuthorizedPersonInputType>;
};


export type MutationAddContractAuthorizedPersonRequestArgs = {
  contractId: Scalars['ID']['input'];
  input?: InputMaybe<AddAuthorizedPersonInputType>;
};


export type MutationAddContractExistingUboArgs = {
  contractId: Scalars['ID']['input'];
  ownershipType: UboStakeType;
  shareSize: Scalars['Float']['input'];
  uboId: Scalars['ID']['input'];
};


export type MutationAddContractGeneralNoteArgs = {
  contractId: Scalars['ID']['input'];
  generalNote?: InputMaybe<Scalars['String']['input']>;
  generalNoteImportant?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAddContractPaymentRecipientArgs = {
  bankBranchId?: InputMaybe<Scalars['String']['input']>;
  bankBranchName?: InputMaybe<Scalars['String']['input']>;
  bankClearingMemberId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  pan?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  recipient: AddContractPaymentRecipientInput;
  taxId?: InputMaybe<Scalars['String']['input']>;
  throwOnExisting?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAddContractToGroupArgs = {
  contractId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAddContractUboArgs = {
  contractId: Scalars['ID']['input'];
  input: AddContractUboInputType;
};


export type MutationAddEntityReminderArgs = {
  entityId: Scalars['ID']['input'];
  entityType: EntityReminderEntityType;
  isPrivate: Scalars['Boolean']['input'];
  notificationChannel?: InputMaybe<Scalars['String']['input']>;
  notificationType?: InputMaybe<EntityReminderNotificationType>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  triggerTime: Scalars['DateTime']['input'];
};


export type MutationAddFeeSettingGroupArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  baseAmount?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Currency>;
  feeId: Scalars['ID']['input'];
  fixedAmount?: InputMaybe<Scalars['Float']['input']>;
  groupId: Scalars['ID']['input'];
  isAmountPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  isMaximumPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  isMinimumPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  maximum?: InputMaybe<Scalars['Float']['input']>;
  minimum?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<FeeGroupFeeUnit>;
};


export type MutationAddLegalEntityDirectorArgs = {
  input: LegalEntityDirectorInput;
};


export type MutationAddNoteToSwiftConversationThreadArgs = {
  id: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
};


export type MutationAddProductsToContractArgs = {
  contractId: Scalars['ID']['input'];
  products?: InputMaybe<Array<InputMaybe<RiskCalculatorProducts>>>;
};


export type MutationAddSignatureSpecimenArgs = {
  fileUrl: Scalars['String']['input'];
};


export type MutationAddSuspiciousReportArgs = {
  authorizationCode: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAddUboOwnerArgs = {
  contractId: Scalars['ID']['input'];
  ubo: UboInputType;
  uboId: Scalars['ID']['input'];
};


export type MutationAddVirtualAccountArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  companyRegistrationDate?: InputMaybe<Scalars['Date']['input']>;
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  entityType?: InputMaybe<UboType>;
  nationality?: InputMaybe<Nationality>;
  parentId: Scalars['ID']['input'];
  registeredAddress: AddressInput;
};


export type MutationAddVirtualAccountFromApiArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  clientAccountUniqueIdentifier?: InputMaybe<Scalars['String']['input']>;
  companyRegistrationDate?: InputMaybe<Scalars['Date']['input']>;
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  entityType?: InputMaybe<UboType>;
  gender?: InputMaybe<Gender>;
  nationality?: InputMaybe<Nationality>;
  parentId: Scalars['ID']['input'];
  registeredAddress: AddressInput;
};


export type MutationApproveDirectDebitArgs = {
  action: Scalars['String']['input'];
  authorizationCode: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  rejectReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApproveDirectDebitDisputeArgs = {
  authorizationCode: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAssociateContractsArgs = {
  contractId_1: Scalars['ID']['input'];
  contractId_2: Scalars['ID']['input'];
};


export type MutationAssociateDocumentWithEntityArgs = {
  dissociate?: InputMaybe<Scalars['Boolean']['input']>;
  documentId: Scalars['ID']['input'];
  relatesTo?: InputMaybe<Array<InputMaybe<DocumentRelatedEntityInput>>>;
};


export type MutationAssociateIndividualsArgs = {
  individualId_1: Scalars['ID']['input'];
  individualId_2: Scalars['ID']['input'];
};


export type MutationBeginDebitAuthorizationArgs = {
  authorizationCode: Scalars['ID']['input'];
  ledgerTransactionId: Scalars['ID']['input'];
};


export type MutationBookManualLedgerTransactionArgs = {
  amount: Scalars['Float']['input'];
  authorizationCode: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  entryType: TransactionEntryType;
  ledgerId: Scalars['ID']['input'];
  swiftMessageId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelOutgoingTransactionArgs = {
  authorizationCode: Scalars['ID']['input'];
  returnReasonCode: Scalars['String']['input'];
  transactionId: Scalars['ID']['input'];
};


export type MutationCancelStandingOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelTransactionArgs = {
  authorizationCode?: InputMaybe<Scalars['ID']['input']>;
  reason: Scalars['String']['input'];
  transactionId: Scalars['ID']['input'];
};


export type MutationChange2faMethodArgs = {
  individualId: Scalars['ID']['input'];
  method: TwoFaMethod;
};


export type MutationChangeCardPinArgs = {
  cardId: Scalars['ID']['input'];
  challengeId: Scalars['String']['input'];
  code: Scalars['ID']['input'];
};


export type MutationChangeContractFeeGroupArgs = {
  authorizationCode: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  newFeeGroupId: Scalars['ID']['input'];
};


export type MutationChangeContractPeriodicReviewDateArgs = {
  contractId: Scalars['ID']['input'];
  nextReviewDate: Scalars['DateTime']['input'];
};


export type MutationChangeIndividualPrimary2FaMethodArgs = {
  challengeId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  method: TwoFaMethod;
};


export type MutationChangeVerifiedEmailPhoneArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  individualId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangeWalletAliasArgs = {
  alias: Scalars['String']['input'];
  walletId: Scalars['ID']['input'];
};


export type MutationChangeWalletStatusArgs = {
  action: WalletFlowAction;
  alias?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<Currency>;
  personalSign?: InputMaybe<Scalars['String']['input']>;
  walletId: Scalars['ID']['input'];
};


export type MutationChargeManualFeeArgs = {
  accountId: Scalars['ID']['input'];
  amount?: InputMaybe<Scalars['Float']['input']>;
  authorizationCode: Scalars['ID']['input'];
  feeId: Scalars['ID']['input'];
  ignoreDesignatedFeeAccount?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
};


export type MutationClearSettlementSweepRuleArgs = {
  accountId: Scalars['ID']['input'];
};


export type MutationClearTransactionAmlArgs = {
  additionalComment?: InputMaybe<Scalars['String']['input']>;
  authorizationCode: Scalars['ID']['input'];
  note: Scalars['String']['input'];
  transactionId: Scalars['ID']['input'];
};


export type MutationClearTransactionRequestAmlArgs = {
  authorizationCode: Scalars['ID']['input'];
  note: Scalars['String']['input'];
  transactionRequestId: Scalars['ID']['input'];
};


export type MutationClearWallesterTransactionFilesArgs = {
  authorizationCode: Scalars['ID']['input'];
  filesFromS3?: InputMaybe<Array<InputMaybe<WallesterFilesInput>>>;
};


export type MutationCloneFeeGroupArgs = {
  feeGroupId: Scalars['ID']['input'];
  newGroupDescription?: InputMaybe<Scalars['String']['input']>;
  newGroupName: Scalars['String']['input'];
};


export type MutationCloseAccountArgs = {
  accountId: Scalars['ID']['input'];
  closureReasonCode: AccountClosureReason;
  closureReasonDescription: Scalars['String']['input'];
};


export type MutationCloseVirtualAccountArgs = {
  accountId: Scalars['ID']['input'];
};


export type MutationCompleteDebitAuthorizationArgs = {
  authorizationCode: Scalars['ID']['input'];
  ledgerTransactionId: Scalars['ID']['input'];
};


export type MutationCompletePayoutArgs = {
  authorizationCode?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['String']['input'];
};


export type MutationConfirmEnableUser2faArgs = {
  token: Scalars['String']['input'];
};


export type MutationConfirmOwnEmailArgs = {
  token: Scalars['String']['input'];
};


export type MutationContractChangeRequestArgs = {
  id: Scalars['ID']['input'];
  missingInfoId?: InputMaybe<Scalars['String']['input']>;
  supportingDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  updates: BankableEntityContractInputType;
};


export type MutationContractTerminationRequestArgs = {
  contractId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCoverAccountNegativeBalanceWithSiblingAccountArgs = {
  allowPartialCover?: InputMaybe<Scalars['Boolean']['input']>;
  authorizationCode: Scalars['ID']['input'];
  coveringAccountId: Scalars['ID']['input'];
  negativeAccountId: Scalars['ID']['input'];
};


export type MutationCreateAccountBundleArgs = {
  contractId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateAccountClosureFinalRemittanceApprovalRequestArgs = {
  accountId: Scalars['ID']['input'];
  authorizationCode: Scalars['ID']['input'];
  transactionInfo: FundRemittanceInfoInput;
};


export type MutationCreateAccountOpeningTicketArgs = {
  authorizationCode: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
  type?: InputMaybe<ServiceDeskRequestType>;
};


export type MutationCreateApiUserArgs = {
  allowedIps: Array<InputMaybe<Scalars['String']['input']>>;
  challengeId: Scalars['ID']['input'];
  code: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCardAdjustmentTransactionApprovalRequestArgs = {
  adjustmentDetails: CardAdjustmentTransactionRequestInfoInput;
  authorizationCode: Scalars['ID']['input'];
};


export type MutationCreateCardTermsActionArgs = {
  contractId: Scalars['ID']['input'];
};


export type MutationCreateContractArgs = {
  input: BankableEntityContractInputType;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateContractDocumentArgs = {
  contractId: Scalars['ID']['input'];
  expiration?: InputMaybe<Scalars['Date']['input']>;
  fileDescription?: InputMaybe<Scalars['String']['input']>;
  firstSide: DocumentSideInput;
  internalTag?: InputMaybe<Scalars['String']['input']>;
  relatedAccountId?: InputMaybe<Scalars['ID']['input']>;
  relatedIndividualId?: InputMaybe<Scalars['ID']['input']>;
  relatedTransactionId?: InputMaybe<Scalars['ID']['input']>;
  relatesTo?: InputMaybe<Array<InputMaybe<DocumentRelatedEntityInput>>>;
  secondSide?: InputMaybe<DocumentSideInput>;
  type: DocumentType;
};


export type MutationCreateCustomerSupportRequestArgs = {
  attachmentUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  details: Scalars['String']['input'];
  title: Scalars['String']['input'];
  topic?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDirectDebitCreditMandateArgs = {
  contractId: Scalars['ID']['input'];
  mandate: DirectDebitMandateInput;
};


export type MutationCreateFeeReversalApprovalRequestArgs = {
  authorizationCode: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
  fileUrl: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationCreateIndividualContractArgs = {
  input: ContractInputForIndividualType;
};


export type MutationCreateInternalTransferArgs = {
  amount: Scalars['Float']['input'];
  comments: Scalars['String']['input'];
  executionType: TransactionExecutionType;
  fromAccountNo: Scalars['ID']['input'];
  priority?: InputMaybe<TransactionPriorityType>;
  quotedXRate?: InputMaybe<Scalars['Float']['input']>;
  toAccountNo: Scalars['ID']['input'];
  valueDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationCreateIntroducerReferenceContractArgs = {
  commissionFeeGroupId?: InputMaybe<Scalars['ID']['input']>;
  contractInput: BankableEntityContractInputType;
};


export type MutationCreateIssueAmloArgs = {
  authorizationCode: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  isAnnual?: InputMaybe<Scalars['Boolean']['input']>;
  isWallet?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<PrioritiesType>;
  walletId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateManualAccountBookingApprovalRequestArgs = {
  authorizationCode: Scalars['ID']['input'];
  manualBookingInfo: ManualBookingRequestInfoInput;
};


export type MutationCreateNewContractInformationRequestArgs = {
  allowDuplicate: Scalars['Boolean']['input'];
  attachments?: InputMaybe<Scalars['JSON']['input']>;
  contractId: Scalars['ID']['input'];
  documentType?: InputMaybe<DocumentType>;
  internal: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ContractInformationRequestType;
};


export type MutationCreateNoteArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  feeGroupId?: InputMaybe<Scalars['ID']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateOutboundCryptoPaymentArgs = {
  amount: Scalars['Float']['input'];
  coin: CryptoCurrency;
  effectiveRate?: InputMaybe<Scalars['Float']['input']>;
  estimatedAmount?: InputMaybe<Scalars['Float']['input']>;
  fromAccountNo: Scalars['ID']['input'];
  rate: Scalars['Float']['input'];
  slippageTolerance: Scalars['Float']['input'];
  walletId: Scalars['String']['input'];
};


export type MutationCreateOutboundPaymentArgs = {
  amount: Scalars['Float']['input'];
  beneficiary: SwiftTransferIndividualPartyDetailsInput;
  beneficiaryType?: InputMaybe<SwiftTransferRecipientType>;
  chargeBearer?: InputMaybe<SwiftTransferChargeBearer>;
  clientReference?: InputMaybe<Scalars['ID']['input']>;
  comments: Scalars['String']['input'];
  executionType: TransactionExecutionType;
  fromAccountNo: Scalars['ID']['input'];
  payoutAmount?: InputMaybe<Scalars['Float']['input']>;
  payoutCurrency?: InputMaybe<Currency>;
  priority?: InputMaybe<TransactionPriorityType>;
  purposeCode?: InputMaybe<Scalars['String']['input']>;
  purposeCode2?: InputMaybe<Scalars['String']['input']>;
  quotedXRate?: InputMaybe<Scalars['Float']['input']>;
  quotedXRateId?: InputMaybe<Scalars['ID']['input']>;
  useLocalPay?: InputMaybe<Scalars['Boolean']['input']>;
  useTLDR?: InputMaybe<Scalars['Boolean']['input']>;
  valueDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationCreateOwnDocumentArgs = {
  contractId?: InputMaybe<Scalars['Int']['input']>;
  contractInformationRequestId?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['Date']['input']>;
  fileDescription?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  firstSide?: InputMaybe<DocumentSideInput>;
  internalTag?: InputMaybe<Scalars['String']['input']>;
  legalEntityId?: InputMaybe<Scalars['Int']['input']>;
  plainUrl?: InputMaybe<Scalars['String']['input']>;
  profileChangeId?: InputMaybe<Scalars['ID']['input']>;
  relatedAccountId?: InputMaybe<Scalars['ID']['input']>;
  relatedIndividualId?: InputMaybe<Scalars['ID']['input']>;
  relatedStandingOrderId?: InputMaybe<Scalars['ID']['input']>;
  relatedTransactionId?: InputMaybe<Scalars['ID']['input']>;
  relatedTransactionRequestId?: InputMaybe<Scalars['ID']['input']>;
  relatedWalletId?: InputMaybe<Scalars['String']['input']>;
  relatesTo?: InputMaybe<DocumentRelatedEntityInput>;
  secondSide?: InputMaybe<DocumentSideInput>;
  size?: InputMaybe<Scalars['Float']['input']>;
  type: DocumentType;
};


export type MutationCreatePaymentRailRouteConfigArgs = {
  baseCurrency: Scalars['String']['input'];
  flowPercentage: Scalars['Int']['input'];
  instantConfig?: InputMaybe<PaymentRouteAdditionalConfigInput>;
  localPayoutsConfig?: InputMaybe<PaymentRouteAdditionalConfigInput>;
  localPayoutsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  paymentRailConfigId: Scalars['ID']['input'];
  payoutCurrency: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  supportsInstant: Scalars['Boolean']['input'];
  supportsLocalPayouts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreatePeriodicReviewTicketArgs = {
  authorizationCode: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
  type?: InputMaybe<ServiceDeskRequestType>;
};


export type MutationCreateQrBillArgs = {
  accountId: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  debtor: QrrDebtorInputType;
  format?: InputMaybe<AccountQrBillType>;
  language?: InputMaybe<QrrLanguage>;
  logoSvg?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateRfiTicketArgs = {
  authorizationCode: Scalars['ID']['input'];
  classification?: InputMaybe<ClassificationsType>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<PrioritiesType>;
  sender?: InputMaybe<SendersType>;
  severity?: InputMaybe<SeverityType>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateSepaNonReceiptMessageMessageArgs = {
  additionalInstruction?: InputMaybe<Scalars['String']['input']>;
  authorizationCode: Scalars['String']['input'];
  transactionId: Scalars['ID']['input'];
};


export type MutationCreateStandingOrderArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  beneficiary: SwiftTransferIndividualPartyDetailsInput;
  beneficiaryType?: InputMaybe<SwiftTransferRecipientType>;
  chargeBearer?: InputMaybe<SwiftTransferChargeBearer>;
  clientReference?: InputMaybe<Scalars['ID']['input']>;
  comments: Scalars['String']['input'];
  executionDate?: InputMaybe<Scalars['String']['input']>;
  fromAccountNo: Scalars['ID']['input'];
  lowerThreshold?: InputMaybe<Scalars['Float']['input']>;
  minRemainingBalance?: InputMaybe<Scalars['Float']['input']>;
  payoutAmount?: InputMaybe<Scalars['Float']['input']>;
  payoutCurrency?: InputMaybe<Currency>;
  periodicity?: InputMaybe<StandingOrderPeriodicity>;
  purposeCode?: InputMaybe<Scalars['String']['input']>;
  purposeCode2?: InputMaybe<Scalars['String']['input']>;
  useLocalPay?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateSwiftThreadTicketArgs = {
  authorizationCode?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  proceedWithoutTrxReference?: InputMaybe<Scalars['Boolean']['input']>;
  threadId: Scalars['String']['input'];
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateSwiftTransferArgs = {
  amount: Scalars['Float']['input'];
  beneficiary: SwiftTransferIndividualPartyDetailsInput;
  beneficiaryType?: InputMaybe<SwiftTransferRecipientType>;
  chargeBearer?: InputMaybe<SwiftTransferChargeBearer>;
  comments: Scalars['String']['input'];
  executionType: TransactionExecutionType;
  fromAccountNo: Scalars['ID']['input'];
  priority?: InputMaybe<TransactionPriorityType>;
  valueDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationCreateTermsAndConditionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
  version: Scalars['ID']['input'];
};


export type MutationCreateTransactionServiceDeskRequestArgs = {
  attachmentUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorizationCode: Scalars['ID']['input'];
  details?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<TransactionServiceDeskSources>;
  title?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['ID']['input'];
};


export type MutationCreateVoidTransactionApprovalRequestArgs = {
  authorizationCode: Scalars['ID']['input'];
  internalReason?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  toLedgerId?: InputMaybe<Scalars['ID']['input']>;
  transactionId: Scalars['ID']['input'];
};


export type MutationCreateWalletArgs = {
  address: Scalars['String']['input'];
  chainId: Scalars['Int']['input'];
  contractId: Scalars['ID']['input'];
};


export type MutationCreateWalletServiceDeskRequestArgs = {
  attachmentUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorizationCode: Scalars['ID']['input'];
  details?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<TransactionServiceDeskSources>;
  title?: InputMaybe<Scalars['String']['input']>;
  walletId: Scalars['String']['input'];
};


export type MutationCryptoDepositAddressArgs = {
  coin: CryptoCurrency;
  contractId: Scalars['ID']['input'];
  network: SupportedCryptoNetwork;
  transactionRequestId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeactivateApiUserArgs = {
  apiKey: Scalars['ID']['input'];
  challengeId: Scalars['ID']['input'];
  code: Scalars['ID']['input'];
};


export type MutationDeactivateAuthorizedPersonRequestArgs = {
  authorizedPersonId: Scalars['ID']['input'];
};


export type MutationDeleteAccountBundleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCheckArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteContractContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContractGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEntityReminderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNoticeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePaymentRailRouteConfigArgs = {
  baseCurrency: Scalars['String']['input'];
  paymentRailConfigId: Scalars['ID']['input'];
  payoutCurrency: Scalars['String']['input'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTermsAndConditionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisconnectCryptoWalletFromContractArgs = {
  walletId: Scalars['ID']['input'];
};


export type MutationDismissIndividualNoticeArgs = {
  noticeId: Scalars['ID']['input'];
};


export type MutationDisputeDirectDebitArgs = {
  executionId: Scalars['ID']['input'];
};


export type MutationDissociateContractsArgs = {
  contractId_1: Scalars['ID']['input'];
  contractId_2: Scalars['ID']['input'];
};


export type MutationDissociateIndividualsArgs = {
  individualId_1: Scalars['ID']['input'];
  individualId_2: Scalars['ID']['input'];
};


export type MutationDownloadSuccessFeesExcelArgs = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
  toDate: Scalars['Date']['input'];
};


export type MutationDownloadSuccessFeesPdfArgs = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationDrainLedgerOnDemandArgs = {
  authorizationCode: Scalars['ID']['input'];
  ledgerId: Scalars['ID']['input'];
};


export type MutationDuplicateClassificationArgs = {
  id: Scalars['String']['input'];
};


export type MutationEditLegalEntityDirectorArgs = {
  contractId: Scalars['ID']['input'];
  individualId: Scalars['ID']['input'];
  legalEntityId: Scalars['ID']['input'];
  naturalPerson?: InputMaybe<AuthorizedPersonInputType>;
  role?: InputMaybe<DirectorRole>;
  signingRight?: InputMaybe<DirectorSigningRights>;
};


export type MutationExecuteActionArgs = {
  actionId: Scalars['ID']['input'];
};


export type MutationExecuteOutgoingCryptoArgs = {
  transactionRequestId: Scalars['ID']['input'];
  trxHash: Scalars['String']['input'];
};


export type MutationExecutePayoutArgs = {
  authorizationCode?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['String']['input'];
};


export type MutationExecutePayoutsArgs = {
  authorizationCode?: InputMaybe<Scalars['ID']['input']>;
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationExportContractPayoutsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExportPayoutSuccessFeesArgs = {
  id: Scalars['String']['input'];
};


export type MutationFinishSetupTwoFaForIndividualArgs = {
  token: Scalars['String']['input'];
};


export type MutationFreezeCardArgs = {
  cardId: Scalars['ID']['input'];
};


export type MutationFreezeCardApiArgs = {
  cardId: Scalars['ID']['input'];
};


export type MutationGenerateAeoiDocumentArgs = {
  contractId: Scalars['ID']['input'];
};


export type MutationGenerateContractAccountsConfirmationArgs = {
  chargeFee?: InputMaybe<Scalars['Boolean']['input']>;
  contractId: Scalars['ID']['input'];
};


export type MutationGenerateFeeGroupDocumentArgs = {
  feeGroupId: Scalars['ID']['input'];
};


export type MutationGeneratePayoutStatementArgs = {
  id: Scalars['String']['input'];
};


export type MutationGeneratePayoutStatementsArgs = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationGenerateSecurityCodeArgs = {
  clientId: Scalars['Int']['input'];
};


export type MutationGet2FaCodeArgs = {
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  fields?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<TwoFaCodeDispatchMode>;
  status?: InputMaybe<ActionSignatureStatus>;
  type?: InputMaybe<TwoFaOperationType>;
};


export type MutationGetIndividualVideoVerificationUrlArgs = {
  individualId: Scalars['ID']['input'];
  isSelfVerification?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationGetSignedUrlArgs = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationImportFeeGroupWithFeeFromCsvArgs = {
  fileUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationInitiateReportArgs = {
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  type: ReportType;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationIssueCardApiArgs = {
  accountId: Scalars['ID']['input'];
  alias?: InputMaybe<Scalars['String']['input']>;
  contractAuthorizedPersonId: Scalars['ID']['input'];
  limits?: InputMaybe<Array<InputMaybe<CardLimitInputType>>>;
  otpViaApi?: InputMaybe<Scalars['Boolean']['input']>;
  secure3DPassword: Scalars['String']['input'];
  type?: InputMaybe<ApiCardTypes>;
};


export type MutationIssueCardApiV2Args = {
  accountId: Scalars['ID']['input'];
  alias?: InputMaybe<Scalars['String']['input']>;
  contractAuthorizedPersonId: Scalars['ID']['input'];
  limits?: InputMaybe<Array<InputMaybe<CardLimitInputType>>>;
  otpViaApi?: InputMaybe<Scalars['Boolean']['input']>;
  secure3DPassword: Scalars['String']['input'];
  type?: InputMaybe<ApiCardTypes>;
};


export type MutationIssueCardRequestArgs = {
  accountId: Scalars['ID']['input'];
  alias?: InputMaybe<Scalars['String']['input']>;
  contractAuthorizedPersonId: Scalars['ID']['input'];
  deliveryAddress?: InputMaybe<AddressInput>;
  embossingName?: InputMaybe<Scalars['String']['input']>;
  limits?: InputMaybe<Array<InputMaybe<CardLimitInputType>>>;
  otpViaApi?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ApiCardTypes>;
};


export type MutationLedgerTransferTransactionArgs = {
  amount: Scalars['Float']['input'];
  authorizationCode: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  fromLedgerId: Scalars['ID']['input'];
  toLedgerId: Scalars['ID']['input'];
};


export type MutationLockUnlockDocumentsArgs = {
  documentIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationLogPeriodicReviewArgs = {
  contractId: Scalars['ID']['input'];
  nextReviewDate: Scalars['DateTime']['input'];
  summary: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationMakeFeeGroupDefaultArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationMakeTermsAndConditionLatestVersionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationManualAccountBookingArgs = {
  accountNo: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  authorizationCode: Scalars['ID']['input'];
  entryType: TransactionEntryType;
  fromLedgerId: Scalars['ID']['input'];
  messageReference: Scalars['String']['input'];
};


export type MutationManuallyRespondToTransactionClaimNonReceiptArgs = {
  authorizationCode: Scalars['ID']['input'];
  claimRecallRequestId: Scalars['ID']['input'];
  positiveResponse: Scalars['Boolean']['input'];
  reasonCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkDocumentsAsReadArgs = {
  documentIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationModifyEntityReminderArgs = {
  id: Scalars['ID']['input'];
  isDone?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  notificationChannel?: InputMaybe<Scalars['String']['input']>;
  notificationType?: InputMaybe<EntityReminderNotificationType>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  triggerTime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationModifyPaymentRailConfigArgs = {
  exclusiveContractTypes?: InputMaybe<Array<ContractType>>;
  exclusiveDestinations?: InputMaybe<Array<Country>>;
  id: Scalars['ID']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
  supportsFx?: InputMaybe<Scalars['Boolean']['input']>;
  unsupportedDestinations?: InputMaybe<Array<Country>>;
  unsupportedIndustries?: InputMaybe<Array<BusinessCategories>>;
};


export type MutationModifyPaymentRailRouteConfigArgs = {
  baseCurrency: Scalars['String']['input'];
  flowPercentage?: InputMaybe<Scalars['Int']['input']>;
  instantConfig?: InputMaybe<PaymentRouteAdditionalConfigInput>;
  localPayoutsConfig?: InputMaybe<PaymentRouteAdditionalConfigInput>;
  localPayoutsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  paymentRailConfigId: Scalars['ID']['input'];
  payoutCurrency: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  supportsInstant?: InputMaybe<Scalars['Boolean']['input']>;
  supportsLocalPayouts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationModifyTransactionAdditionalCommentArgs = {
  additionalComment: Scalars['String']['input'];
  authorizationCode: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
};


export type MutationModifyTransactionCounterPartyAddressArgs = {
  authorizationCode: Scalars['ID']['input'];
  newAddress: AddressInput;
  transactionId: Scalars['ID']['input'];
};


export type MutationNewClassificationArgs = {
  contractId: Scalars['ID']['input'];
};


export type MutationPerformEntityCheckArgs = {
  checkId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  entityType: CheckableEntityType;
  itemResults?: InputMaybe<Array<InputMaybe<CheckItemResultInput>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  relatedDocuments?: InputMaybe<Array<InputMaybe<DocumentInput>>>;
  status?: InputMaybe<CheckResultStatus>;
};


export type MutationPinActivityLogArgs = {
  id: Scalars['ID']['input'];
  pin: Scalars['Boolean']['input'];
};


export type MutationPinUnpinAccountArgs = {
  accountIds: Array<InputMaybe<Scalars['ID']['input']>>;
  pin: Scalars['Boolean']['input'];
};


export type MutationPinUnpinDocumentArgs = {
  documentIds: Array<InputMaybe<Scalars['ID']['input']>>;
  pin: Scalars['Boolean']['input'];
};


export type MutationPreapproveB2BDirectDebitMandateArgs = {
  mandate: B2BDirectDebitPreapprovalInput;
};


export type MutationPrepareBatchPaymentFromRecordsArgs = {
  accountId: Scalars['ID']['input'];
  batchRecords: Array<InputMaybe<BatchPaymentRecordInput>>;
};


export type MutationPrepareOutboundPaymentArgs = {
  amount: Scalars['Float']['input'];
  beneficiary: SwiftTransferIndividualPartyDetailsInput;
  beneficiaryType?: InputMaybe<SwiftTransferRecipientType>;
  chargeBearer?: InputMaybe<SwiftTransferChargeBearer>;
  clientReference?: InputMaybe<Scalars['ID']['input']>;
  comments: Scalars['String']['input'];
  executionType: TransactionExecutionType;
  fromAccountNo: Scalars['ID']['input'];
  payoutAmount?: InputMaybe<Scalars['Float']['input']>;
  payoutCurrency?: InputMaybe<Currency>;
  priority?: InputMaybe<TransactionPriorityType>;
  purposeCode?: InputMaybe<Scalars['String']['input']>;
  purposeCode2?: InputMaybe<Scalars['String']['input']>;
  quotedXRate?: InputMaybe<Scalars['Float']['input']>;
  quotedXRateId?: InputMaybe<Scalars['ID']['input']>;
  useLocalPay?: InputMaybe<Scalars['Boolean']['input']>;
  useTLDR?: InputMaybe<Scalars['Boolean']['input']>;
  valueDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationPreviewPayoutStatementArgs = {
  id: Scalars['String']['input'];
};


export type MutationPreviewPayoutStatementsArgs = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationProcess2FaOperationArgs = {
  challengeId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  requestId?: InputMaybe<Scalars['String']['input']>;
  twoFAStatus: TwoFaStatus;
  type?: InputMaybe<TwoFaOperationType>;
};


export type MutationProcessContractProfileChangeArgs = {
  comments?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  result: ProcessProfileChangeResult;
};


export type MutationProcessDocumentArgs = {
  id: Scalars['Int']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonCode?: InputMaybe<DocumentRejectionReasonCode>;
  result: ProcessDocumentResult;
};


export type MutationProcessProfileChangeArgs = {
  comments?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  result: ProcessProfileChangeResult;
};


export type MutationProcessTransferContractOwnershipArgs = {
  contractOwnershipTransferId: Scalars['String']['input'];
  status: ContractOwnershipTransferStatus;
};


export type MutationProcessVideoVerificationArtifactsArgs = {
  individualId: Scalars['ID']['input'];
  videoVerificationId: Scalars['ID']['input'];
};


export type MutationPublishFeeGroupDocumentArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  feeGroupId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type MutationReCalculateContractSuccessFeesArgs = {
  authCode: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationRecallDirectDebitExecutionArgs = {
  authorizationCode: Scalars['String']['input'];
  executionId: Scalars['ID']['input'];
  recallReasonCode: Scalars['String']['input'];
};


export type MutationRefundPaymentArgs = {
  amount: Scalars['Float']['input'];
  contractId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
};


export type MutationRegenerateAllClassificationsArgs = {
  authorizationCode: Scalars['ID']['input'];
};


export type MutationRejectActionArgs = {
  actionId: Scalars['ID']['input'];
  rejectionReason: ActionRejectionReason;
};


export type MutationRejectCreditDirectDebitExecutionArgs = {
  authorizationCode: Scalars['String']['input'];
  executionId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRejectDirectDebitArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRejectDirectDebitDisputeArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectIncomingTransactionRecallRequestArgs = {
  authorizationCode: Scalars['ID']['input'];
  claimRecallRequestId: Scalars['ID']['input'];
  reasonCode: Scalars['String']['input'];
  reasonDetail: Scalars['String']['input'];
};


export type MutationRejectPayoutArgs = {
  authorizationCode?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['String']['input'];
};


export type MutationRejectTransactionRequestArgs = {
  transactionRequestId: Scalars['ID']['input'];
};


export type MutationRemoveAccountFromBundleArgs = {
  accountId: Scalars['ID']['input'];
};


export type MutationRemoveAuthorizedPersonAccountsRestrictionArgs = {
  accountIds: Array<InputMaybe<Scalars['ID']['input']>>;
  authorizationCode: Scalars['ID']['input'];
  contractAuthPersonId: Scalars['ID']['input'];
};


export type MutationRemoveContractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveContractAuthorizedPersonArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveContractFromGroupArgs = {
  contractId: Scalars['ID']['input'];
};


export type MutationRemoveContractInformationRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveContractPaymentRecipientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveContractUboArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveDeviceInformationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLegalEntityDirectorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveTagsArgs = {
  input: TagInput;
};


export type MutationRemoveTransactionAsApprovedRecurringArgs = {
  authorizationCode: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
};


export type MutationRemoveUboOwnerArgs = {
  contractId: Scalars['ID']['input'];
  uboId: Scalars['ID']['input'];
  uboOwnerId: Scalars['ID']['input'];
};


export type MutationRemoveUnsavedDocumentArgs = {
  plainUrl: Scalars['String']['input'];
};


export type MutationRenameAccountBundleArgs = {
  bundleId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationRenameCardArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  cardId: Scalars['ID']['input'];
};


export type MutationRepairPaymentInformationArgs = {
  authorizationCode: Scalars['ID']['input'];
  ledgerTransactionId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
  sender: TransactionPartyTypesInput;
  transactionReference?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestAccountClosureArgs = {
  accountId: Scalars['ID']['input'];
  closureReasonCode: AccountClosureReason;
  closureReasonDescription: Scalars['String']['input'];
};


export type MutationRequestTansferContractOwnershipArgs = {
  contractId: Scalars['ID']['input'];
  toEmail: Scalars['String']['input'];
  toName: Scalars['String']['input'];
};


export type MutationRequeueSwiftForProcessingArgs = {
  authorizationCode: Scalars['String']['input'];
  messageId: Scalars['ID']['input'];
};


export type MutationRescreenWalletArgs = {
  walletId: Scalars['ID']['input'];
};


export type MutationResendContractAuthorizedPersonInvitationArgs = {
  authorizedPersonId: Scalars['ID']['input'];
};


export type MutationResendTransactionPayoutMessageArgs = {
  authorizationCode: Scalars['ID']['input'];
  ledgerTransactionId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};


export type MutationResetApiUserSecretArgs = {
  apiKey: Scalars['ID']['input'];
  challengeId: Scalars['ID']['input'];
  code: Scalars['ID']['input'];
};


export type MutationResetIndividual2FaAttemptsArgs = {
  authorizationCode: Scalars['String']['input'];
  individualId: Scalars['ID']['input'];
};


export type MutationResetIndividualPasswordArgs = {
  individualId: Scalars['ID']['input'];
};


export type MutationResetUserPasswordArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationResolveTransactionCurrencyMismatchArgs = {
  authorizationCode: Scalars['ID']['input'];
  destinationAccountId?: InputMaybe<Scalars['ID']['input']>;
  ledgerTransactionId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
  strategy: CurrencyMismatchResolutionStrategy;
};


export type MutationResolveTransactionDestinationArgs = {
  authorizationCode: Scalars['ID']['input'];
  destinationAccountId: Scalars['ID']['input'];
  isReturn?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerTransactionId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
  originalTransactionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationResolveVibanNameMismatchArgs = {
  authorizationCode: Scalars['ID']['input'];
  challengeId?: InputMaybe<Scalars['ID']['input']>;
  resolution: VibanNameMismatchResolution;
  vibanNameMismatchIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationResolveVibanNameMismatchFromTransactionArgs = {
  authorizationCode: Scalars['ID']['input'];
  resolution: VibanNameMismatchResolution;
  transactionId: Scalars['ID']['input'];
};


export type MutationRestrictAccountToAuthorizedPersonsArgs = {
  accountId: Scalars['ID']['input'];
  authorizationCode: Scalars['ID']['input'];
  contractAuthPersonIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationRestrictAuthorizedPersonToAccountsArgs = {
  accountIds: Array<InputMaybe<Scalars['ID']['input']>>;
  authorizationCode: Scalars['ID']['input'];
  contractAuthPersonId: Scalars['ID']['input'];
};


export type MutationReturnFailedOutgoingTransactionFromLedgerArgs = {
  authorizationCode: Scalars['ID']['input'];
  internalReason?: InputMaybe<Scalars['String']['input']>;
  ledgerTransactionId: Scalars['ID']['input'];
};


export type MutationReturnIncomingLedgerTransactionArgs = {
  authorizationCode: Scalars['ID']['input'];
  chargeCorrectionFee?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerTransactionId: Scalars['ID']['input'];
  returnReasonCode: Scalars['String']['input'];
  returnReasonDescription?: InputMaybe<Scalars['String']['input']>;
  returnRequestId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReturnIncomingTransactionArgs = {
  authorizationCode: Scalars['ID']['input'];
  chargeReturnFee?: InputMaybe<Scalars['Boolean']['input']>;
  returnAmountLessCharge?: InputMaybe<Scalars['Boolean']['input']>;
  returnReasonCode: Scalars['String']['input'];
  returnReasonCodeDescription?: InputMaybe<Scalars['String']['input']>;
  returnRequestMessageId?: InputMaybe<Scalars['ID']['input']>;
  transactionId: Scalars['ID']['input'];
};


export type MutationReverseLedgerTransactionArgs = {
  authorizationCode: Scalars['ID']['input'];
  ledgerTransactionId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRevertDirectDebitRequestArgs = {
  executionId: Scalars['ID']['input'];
};


export type MutationRevertDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRevertFeeTransactionArgs = {
  authorizationCode: Scalars['ID']['input'];
  feeTransactionId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationSaveBalanceCurrencyArgs = {
  contractId: Scalars['ID']['input'];
  currency: NewAccountCurrency;
};


export type MutationSaveWalletBaseCurrencyArgs = {
  baseCurrency: Currency;
  walletId: Scalars['ID']['input'];
};


export type MutationScheduleUnderlyingVirtualAccountClosureArgs = {
  accountId: Scalars['ID']['input'];
  authorizationCode: Scalars['ID']['input'];
  closureReasonDescription: Scalars['String']['input'];
};


export type MutationSendMt199MessageArgs = {
  answer?: InputMaybe<Scalars['String']['input']>;
  answerNarrative?: InputMaybe<Scalars['String']['input']>;
  authorizationCode: Scalars['ID']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
  narrative: Scalars['String']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  recipientBIC: Scalars['String']['input'];
  relatedReference?: InputMaybe<Scalars['ID']['input']>;
  transactionReference: Scalars['ID']['input'];
};


export type MutationSendSmsVerificationArgs = {
  phone: Scalars['String']['input'];
  type?: InputMaybe<TwoFaCodeDispatchMode>;
};


export type MutationSetAccountBannedPaymentRailsArgs = {
  accountId: Scalars['ID']['input'];
  authorizationCode: Scalars['ID']['input'];
  paymentRails?: InputMaybe<Array<InputMaybe<PaymentRail>>>;
};


export type MutationSetAccountDefaultTransactionPurposeCodeArgs = {
  accountId: Scalars['ID']['input'];
  country: Country;
  purposeCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetAccountPreferredFxPaymentRailsArgs = {
  accountId: Scalars['ID']['input'];
  authorizationCode: Scalars['ID']['input'];
  railsConfig: Array<InputMaybe<RailsConfigInput>>;
};


export type MutationSetAccountPreferredPaymentRailArgs = {
  accountId: Scalars['ID']['input'];
  authorizationCode: Scalars['ID']['input'];
  paymentRail?: InputMaybe<PaymentRail>;
};


export type MutationSetAutoApproveCryptoCheckStatusesArgs = {
  checkStatuses: Array<InputMaybe<WalletCheckStatus>>;
  contractId: Scalars['ID']['input'];
};


export type MutationSetCardPendingLimitsArgs = {
  cardId: Scalars['ID']['input'];
  code: Scalars['ID']['input'];
  limits?: InputMaybe<Array<InputMaybe<CardLimitInputType>>>;
};


export type MutationSetCardPendingLimitsApiArgs = {
  cardId: Scalars['ID']['input'];
  limits?: InputMaybe<Array<InputMaybe<CardLimitInputType>>>;
};


export type MutationSetContractAuthorizedPersonStatusArgs = {
  authorizedPersonIds: Array<InputMaybe<Scalars['ID']['input']>>;
  status: AuthorizedPersonStatuses;
};


export type MutationSetContractCommStatusArgs = {
  communicationStatus: CommunicationStatus;
  contractId: Scalars['ID']['input'];
};


export type MutationSetContractDesignatedFeeAccountArgs = {
  contractId: Scalars['ID']['input'];
  designatedFeeAccountId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetContractFundFlowDescriptionArgs = {
  contractId: Scalars['ID']['input'];
  fundFlowDescription: Scalars['String']['input'];
};


export type MutationSetContractIsIntroducingPartnerArgs = {
  contractId: Scalars['ID']['input'];
  isIntroducingPartner: Scalars['Boolean']['input'];
};


export type MutationSetContractRiskProfileArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  riskProfile: RiskProfile;
};


export type MutationSetContractStatementDeliveryBicArgs = {
  id: Scalars['ID']['input'];
  statementDeliveryBic: Scalars['String']['input'];
};


export type MutationSetContractStatusArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  status: ContractStatusType;
};


export type MutationSetFeeGroupForAccountArgs = {
  accountId: Scalars['ID']['input'];
  authorizationCode: Scalars['ID']['input'];
  feeGroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetFinancialStatementsOfContractArgs = {
  contractId: Scalars['ID']['input'];
  financialStatements: RiskCalculatorFinancialStatements;
};


export type MutationSetHasPendingInvestigationArgs = {
  authorizationCode: Scalars['ID']['input'];
  hasPendingInvestigation: Scalars['Boolean']['input'];
  transactionId: Scalars['ID']['input'];
};


export type MutationSetIndividualVerificationArgs = {
  authorizationCode: Scalars['String']['input'];
  individualId: Scalars['ID']['input'];
  isVerified: Scalars['Boolean']['input'];
  verificationMedium?: InputMaybe<VerificationMedium>;
};


export type MutationSetKycMeasuresOfContractArgs = {
  contractId: Scalars['ID']['input'];
  kycMeasures: KycMeasuresType;
};


export type MutationSetPaymentCredentialsStatusArgs = {
  authorizationCode: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
  status: PaymentCredentialsStatus;
};


export type MutationSetTransactionAsApprovedRecurringArgs = {
  authorizationCode: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
};


export type MutationSetUpLedgerDrainArgs = {
  authorizationCode: Scalars['ID']['input'];
  destinationDetails?: InputMaybe<OutboundTransactionInput>;
  isExternal: Scalars['Boolean']['input'];
  ledgerId: Scalars['ID']['input'];
  passThroughAccountId: Scalars['ID']['input'];
  referenceMessageTemplate?: InputMaybe<Scalars['String']['input']>;
  threshold: Scalars['Float']['input'];
};


export type MutationSetupSettlementSweepRuleArgs = {
  accountId: Scalars['ID']['input'];
  matchTransactionAccountId?: InputMaybe<Scalars['String']['input']>;
  referenceMatch?: InputMaybe<Scalars['String']['input']>;
  settlementLedgerId: Scalars['ID']['input'];
};


export type MutationShowEconomicProfileArgs = {
  contractId: Scalars['ID']['input'];
  showEconomicProfile: Scalars['Boolean']['input'];
};


export type MutationSignActionWithChallengeCodeArgs = {
  actionSignatureId: Scalars['ID']['input'];
  challengeId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  status: ActionSignatureStatus;
};


export type MutationSignIndividualNoticeArgs = {
  noticeId: Scalars['String']['input'];
  signDate: Scalars['DateTime']['input'];
  signature: Scalars['String']['input'];
};


export type MutationSignMultipleActionsWithChallengeCodeArgs = {
  actionSignatureIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  challengeId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  status: ActionSignatureStatus;
};


export type MutationSignUploadUrlArgs = {
  clientId: Scalars['Int']['input'];
};


export type MutationSmartAddContractAuthorizedPersonArgs = {
  contractId: Scalars['ID']['input'];
  input?: InputMaybe<AddAuthorizedPersonInputType>;
};


export type MutationSpendingLimitRequestArgs = {
  cardId: Scalars['ID']['input'];
  limits?: InputMaybe<Array<InputMaybe<CardLimitInputType>>>;
};


export type MutationStartBatchPaymentArgs = {
  accountId: Scalars['ID']['input'];
  fileUrl: Scalars['String']['input'];
};


export type MutationStartBatchPaymentFromRecordsArgs = {
  accountId: Scalars['ID']['input'];
  batchRecords: Array<InputMaybe<BatchPaymentRecordInput>>;
};


export type MutationStartClassificationArgs = {
  classificationId: Scalars['String']['input'];
  contractId: Scalars['ID']['input'];
};


export type MutationStartDirectDebitBatchFromPain008RequestArgs = {
  fileUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStartDirectDebitBatchRequestArgs = {
  accountId: Scalars['ID']['input'];
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  records?: InputMaybe<Array<InputMaybe<DirectDebitRequestRecordInput>>>;
};


export type MutationStartSetupTwoFaForIndividualArgs = {
  challengeId: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type MutationStartVideoVerificationArgs = {
  callbackUrl: Scalars['String']['input'];
};


export type MutationSubmitContractForApprovalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitContractForPreAssessmentArgs = {
  contractId: Scalars['ID']['input'];
};


export type MutationSwitchPayoutRouteFromSepaToTarget2Args = {
  authorizationCode: Scalars['ID']['input'];
  ledgerTransactionId: Scalars['ID']['input'];
};


export type MutationSyncContractOnboardingPipeDriveSummaryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSyncVideoVerificationArtifactsArgs = {
  individualId: Scalars['ID']['input'];
};


export type MutationTerminateCardArgs = {
  cardId: Scalars['ID']['input'];
  challengeId: Scalars['String']['input'];
  closeReason?: InputMaybe<CloseReason>;
  code: Scalars['Int']['input'];
};


export type MutationTerminateCardApiArgs = {
  cardId: Scalars['ID']['input'];
  closeReason?: InputMaybe<CloseReason>;
};


export type MutationToggleAccountAllowOnlyInternalTransactionsArgs = {
  accountId: Scalars['ID']['input'];
  isInternal: Scalars['Boolean']['input'];
};


export type MutationToggleAccountAutoSaveBeneficiaryArgs = {
  accountId: Scalars['ID']['input'];
  autosaveBeneficiaries: Scalars['Boolean']['input'];
};


export type MutationToggleAccountDailyStatementArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationToggleAccountHiddenArgs = {
  accountId: Scalars['ID']['input'];
  hidden: Scalars['Boolean']['input'];
};


export type MutationToggleAccountUseDirectInboundRouteArgs = {
  accountId: Scalars['ID']['input'];
  useDirect: Scalars['Boolean']['input'];
};


export type MutationToggleAcknowledgeExpiredDocumentArgs = {
  id: Scalars['ID']['input'];
  isAcknowledged: Scalars['Boolean']['input'];
};


export type MutationToggleAllowLocalPayArgs = {
  allowLocalPay: Scalars['Boolean']['input'];
  contractId: Scalars['ID']['input'];
};


export type MutationToggleAllowVbanAllowThirdPartyDepositsArgs = {
  allowThirdPartyDeposits: Scalars['Boolean']['input'];
  contractId: Scalars['ID']['input'];
};


export type MutationToggleAllowVbanCreationArgs = {
  allowVbanCreation: Scalars['Boolean']['input'];
  contractId: Scalars['ID']['input'];
};


export type MutationToggleCcDedicatedAcMMutationArgs = {
  ccDedicatedAcm: Scalars['Boolean']['input'];
  contractId: Scalars['ID']['input'];
};


export type MutationToggleCardTransactionOtpViaApiArgs = {
  cardId: Scalars['ID']['input'];
  otpViaApi: Scalars['Boolean']['input'];
};


export type MutationToggleContractAuthorizedPersonSignOwnActionArgs = {
  authorizedPersonId: Scalars['ID']['input'];
  cannotSignOwnActions: Scalars['Boolean']['input'];
};


export type MutationToggleContractCardTrxChargeModeArgs = {
  chargeCardTransactionOnAuthorization: Scalars['Boolean']['input'];
  contractId: Scalars['ID']['input'];
};


export type MutationToggleContractFlagsArgs = {
  contractId: Scalars['ID']['input'];
  hasProfessionalTreasuryDepartment?: InputMaybe<Scalars['Boolean']['input']>;
  subjectToPrudentialRegulation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationToggleContractHandlesPhysicalCashArgs = {
  contractId: Scalars['ID']['input'];
  handlesPhysicalCash: Scalars['Boolean']['input'];
};


export type MutationToggleContractOwnerPublicInfoArgs = {
  contractId: Scalars['ID']['input'];
  publicInfo: Scalars['Boolean']['input'];
};


export type MutationToggleContractOwnerReputationRiskArgs = {
  contractId: Scalars['ID']['input'];
  reputationalRisk: Scalars['Boolean']['input'];
};


export type MutationToggleContractPepArgs = {
  contractId: Scalars['ID']['input'];
  isPep: Scalars['Boolean']['input'];
};


export type MutationToggleCrsReportableArgs = {
  contractId: Scalars['ID']['input'];
  crsReportable: Scalars['Boolean']['input'];
};


export type MutationToggleCryptoPaymentsArgs = {
  allowedCryptoPayment: AllowedCryptoPayments;
  contractId: Scalars['ID']['input'];
};


export type MutationToggleDisableIndividualAccessArgs = {
  accessDisabled: Scalars['Boolean']['input'];
  individualId: Scalars['ID']['input'];
};


export type MutationToggleEmailConfirmedArgs = {
  clientId: Scalars['Int']['input'];
  emailConfirmed: Scalars['Boolean']['input'];
};


export type MutationToggleExemptFromNbcArgs = {
  contractId: Scalars['ID']['input'];
  exemptFromNbc: Scalars['Boolean']['input'];
};


export type MutationToggleFatcaReportableArgs = {
  contractId: Scalars['ID']['input'];
  fatcaReportable: Scalars['Boolean']['input'];
};


export type MutationToggleHouseAccountUseFItoFiArgs = {
  accountId: Scalars['ID']['input'];
  useFItoFI: Scalars['Boolean']['input'];
};


export type MutationToggleIndividualReputationalRiskArgs = {
  individualId: Scalars['ID']['input'];
  reputationalRisk: Scalars['Boolean']['input'];
};


export type MutationToggleIsArchivedDocumentArgs = {
  id: Scalars['ID']['input'];
  isArchived: Scalars['Boolean']['input'];
};


export type MutationToggleIsInternalDocumentArgs = {
  documentId: Scalars['ID']['input'];
  isInternal: Scalars['Boolean']['input'];
};


export type MutationToggleIsPepArgs = {
  individualId: Scalars['ID']['input'];
  isPep: Scalars['Boolean']['input'];
};


export type MutationToggleLegalEntityPublicInfoArgs = {
  contractId: Scalars['ID']['input'];
  legalEntityId: Scalars['ID']['input'];
  publicInfo: Scalars['Boolean']['input'];
};


export type MutationToggleLegalEntityReputationalRiskArgs = {
  contractId: Scalars['ID']['input'];
  legalEntityId: Scalars['ID']['input'];
  reputationalRisk: Scalars['Boolean']['input'];
};


export type MutationToggleSafeGuardingAccountArgs = {
  accountId: Scalars['ID']['input'];
  isClientSafeguard: Scalars['Boolean']['input'];
};


export type MutationToggleSwiftConversationThreadForFollowUpArgs = {
  followUp: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationToggleTransactionAsReviewedArgs = {
  authorizationCode: Scalars['ID']['input'];
  isReviewed: Scalars['Boolean']['input'];
  transactionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationToggleTransactionForceHoldArgs = {
  authorizationCode: Scalars['ID']['input'];
  forceHold: Scalars['Boolean']['input'];
  transactionId: Scalars['ID']['input'];
};


export type MutationTopUpWithCardArgs = {
  accountId: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  page?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTopUpWithCryptoArgs = {
  accountId: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  coin: CryptoCurrency;
  effectiveRate?: InputMaybe<Scalars['Float']['input']>;
  estimatedAmount?: InputMaybe<Scalars['Float']['input']>;
  rate: Scalars['Float']['input'];
  slippageTolerance: Scalars['Float']['input'];
  walletId: Scalars['String']['input'];
};


export type MutationTransactionReturnRequestArgs = {
  authorizationCode: Scalars['String']['input'];
  cancellationReasonCode: Camt056CancellationReasonCode;
  transactionId: Scalars['ID']['input'];
};


export type MutationTryClearErroneouslyCancelledCardTransactionArgs = {
  allowPartialClearing?: InputMaybe<Scalars['Boolean']['input']>;
  authorizationCode: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
};


export type MutationTryCorrectBeneficiaryBicOnFailedPayoutArgs = {
  authorizationCode: Scalars['ID']['input'];
  ledgerTransactionId: Scalars['ID']['input'];
};


export type MutationTryManuallyAcknowledgePendingJpmPayoutWithExtRefArgs = {
  externalTransactionReference: Scalars['ID']['input'];
  ledgerTransactionId: Scalars['ID']['input'];
};


export type MutationTryRevertCompletedJpmOutgoingTransactionArgs = {
  authorizationCode: Scalars['ID']['input'];
  returnReasonCode?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['ID']['input'];
};


export type MutationTrySwitchPaymentRailArgs = {
  authorizationCode: Scalars['ID']['input'];
  ledgerTransactionId: Scalars['ID']['input'];
  newPaymentRail?: InputMaybe<PaymentRail>;
};


export type MutationUnFreezeCardArgs = {
  cardId: Scalars['ID']['input'];
};


export type MutationUnFreezeCardApiArgs = {
  cardId: Scalars['ID']['input'];
};


export type MutationUpdateAccountArgs = {
  accountId: Scalars['ID']['input'];
  alias?: InputMaybe<Scalars['String']['input']>;
  clientAccountUniqueIdentifier?: InputMaybe<Scalars['String']['input']>;
  companyRegistrationDate?: InputMaybe<Scalars['Date']['input']>;
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<Gender>;
  nationality?: InputMaybe<Nationality>;
  registeredAddress?: InputMaybe<AddressInput>;
};


export type MutationUpdateAccountAliasArgs = {
  accountId: Scalars['ID']['input'];
  alias: Scalars['String']['input'];
};


export type MutationUpdateAccountAlternativeAccountDetailsArgs = {
  accountId: Scalars['ID']['input'];
  alternativeAccountDetails: SwiftTransferIndividualPartyDetailsWithCurrencyInput;
};


export type MutationUpdateAccountFundsTypeArgs = {
  accountId: Scalars['ID']['input'];
  fundsType: FundsType;
};


export type MutationUpdateAccountStatusArgs = {
  accountId: Scalars['ID']['input'];
  reason?: InputMaybe<AccountClosureReason>;
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
  status: AccountStatus;
};


export type MutationUpdateApiUserAllowedIpsArgs = {
  allowedIps: Array<InputMaybe<Scalars['String']['input']>>;
  apiKey: Scalars['ID']['input'];
  challengeId: Scalars['ID']['input'];
  code: Scalars['ID']['input'];
};


export type MutationUpdateCard3DSecureSettingArgs = {
  cardId: Scalars['ID']['input'];
  challengeId: Scalars['String']['input'];
  code: Scalars['ID']['input'];
  password: Scalars['ID']['input'];
};


export type MutationUpdateCheckResultArgs = {
  checkResultId: Scalars['ID']['input'];
  itemResults?: InputMaybe<Array<InputMaybe<CheckItemResultInput>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  relatedDocuments?: InputMaybe<Array<InputMaybe<DocumentInput>>>;
  status?: InputMaybe<CheckResultStatus>;
};


export type MutationUpdateClassificationArgs = {
  id: Scalars['String']['input'];
  status: RiskClassificationStatus;
};


export type MutationUpdateContractArgs = {
  id: Scalars['ID']['input'];
  updates: BankableEntityContractInputType;
};


export type MutationUpdateContractAuthorizedPersonArgs = {
  authPersonId: Scalars['ID']['input'];
  authorizationSetting?: InputMaybe<AuthorizationSettingInputType>;
  person?: InputMaybe<AuthorizedPersonInputType>;
};


export type MutationUpdateContractAuthorizedPersonSettingsArgs = {
  authPersonId: Scalars['ID']['input'];
  authorizationCode: Scalars['ID']['input'];
  authorizationSetting: AuthorizationSettingInputType;
};


export type MutationUpdateContractCommissionSettingAccountArgs = {
  commissionPayoutAccountId?: InputMaybe<Scalars['ID']['input']>;
  contractId: Scalars['ID']['input'];
  currency?: InputMaybe<Currency>;
  payoutAccountDetails?: InputMaybe<SwiftTransferIndividualPartyDetailsInput>;
};


export type MutationUpdateContractDirectDebitSettingsArgs = {
  authorizationCode: Scalars['String']['input'];
  contractId: Scalars['ID']['input'];
  creditorId?: InputMaybe<Scalars['String']['input']>;
  reserveHoldDays?: InputMaybe<Scalars['Int']['input']>;
  reservePercentage?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateContractInformationRequestArgs = {
  id: Scalars['String']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  rejectReason?: InputMaybe<Scalars['String']['input']>;
  status: ContractInformationRequestStatus;
};


export type MutationUpdateContractInformationRequestIndividualArgs = {
  clientNote?: InputMaybe<Scalars['String']['input']>;
  documentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateContractOnboardingInfoArgs = {
  id: Scalars['ID']['input'];
  onboarding?: InputMaybe<OnboardingInputType>;
};


export type MutationUpdateContractPaymentRecipientArgs = {
  bankBranchId?: InputMaybe<Scalars['String']['input']>;
  bankBranchName?: InputMaybe<Scalars['String']['input']>;
  bankClearingMemberId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  input: UpdateContractPaymentRecipientInput;
  phone?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateContractRiskStructureArgs = {
  contractId: Scalars['ID']['input'];
  structureCategory?: InputMaybe<ContractRiskCategories>;
  structureComplexity?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateContractUboArgs = {
  contractUboId: Scalars['ID']['input'];
  input: UpdateContractUboInputType;
};


export type MutationUpdateDedicatedManagerContractArgs = {
  authorizationCode: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
  dedicatedAcm?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateFcmTokenArgs = {
  fcmToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateIndividualDetailsArgs = {
  address?: InputMaybe<AddressInput>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  economicProfile?: InputMaybe<EconomicProfileInputType>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['Int']['input'];
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Locale>;
  nationality?: InputMaybe<Nationality>;
  phone?: InputMaybe<Scalars['String']['input']>;
  secondaryEmails?: InputMaybe<SecondaryEmailInput>;
  secondaryPhones?: InputMaybe<SecondaryPhoneInput>;
  skypeId?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateIndividualEmailCategoryPreferenceArgs = {
  active: Scalars['Boolean']['input'];
  emailCategoryId: Scalars['ID']['input'];
  individualId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateIndividualPhonesArgs = {
  id: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  secondaryPhones?: InputMaybe<SecondaryPhoneInput>;
};


export type MutationUpdateIndividualSmsCategoryPreferenceArgs = {
  active: Scalars['Boolean']['input'];
  individualId?: InputMaybe<Scalars['ID']['input']>;
  smsCategoryId: Scalars['ID']['input'];
};


export type MutationUpdateManualAccountBookingApprovalRequestArgs = {
  authorizationCode: Scalars['ID']['input'];
  isFinal: Scalars['Boolean']['input'];
  isRejection: Scalars['Boolean']['input'];
  requestId: Scalars['ID']['input'];
  updates?: InputMaybe<ManualBookingRequestInfoUpdateInput>;
};


export type MutationUpdateMobileNotificationSettingsArgs = {
  notificationSettings?: InputMaybe<NotificationSettingsInputType>;
};


export type MutationUpdateOwnDetailsArgs = {
  address?: InputMaybe<AddressInput>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  economicProfile?: InputMaybe<EconomicProfileInputType>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Nationality>;
  phone?: InputMaybe<Scalars['String']['input']>;
  secondaryEmails?: InputMaybe<SecondaryEmailInput>;
  secondaryPhones?: InputMaybe<SecondaryPhoneInput>;
  skypeId?: InputMaybe<Scalars['String']['input']>;
  supportingDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateOwnEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateOwnLocaleArgs = {
  locale: Locale;
};


export type MutationUpdateOwnPasswordArgs = {
  challengeId: Scalars['String']['input'];
  code: Scalars['Int']['input'];
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationUpdatePayoutSuccessFeesArgs = {
  authorizationCode?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['String']['input'];
  successFeeIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationUpdatePreAssessmentStatusArgs = {
  id: Scalars['ID']['input'];
  status: PreAssessmentStatus;
};


export type MutationUpdateReferringContractArgs = {
  authorizationCode: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
  referringContractId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateRiskLevelsArgs = {
  authorizationCode: Scalars['ID']['input'];
  fileUrl: Scalars['String']['input'];
};


export type MutationUpdateSpendingLimitArgs = {
  account?: InputMaybe<Scalars['ID']['input']>;
  amount: Scalars['Float']['input'];
  contract?: InputMaybe<Scalars['ID']['input']>;
  interval: SpendingLimitIntervalType;
  type?: SpendingLimitTypeType;
};


export type MutationUpdateTransactionAdditionalInfoArgs = {
  additionalInfoInput: TransactionAdditionalInfoInput;
  authorizationCode: Scalars['ID']['input'];
  ledgerTransactionId: Scalars['ID']['input'];
};


export type MutationUpdateTransactionCorrespondentBankInfoArgs = {
  authorizationCode: Scalars['ID']['input'];
  correspondentBankInfo: CorrespondentBankInfoInput;
  ledgerTransactionId: Scalars['ID']['input'];
};


export type MutationUpdateTransactionPaymentRailBranchArgs = {
  authorizationCode: Scalars['ID']['input'];
  ledgerTransactionId: Scalars['ID']['input'];
  railBranch: Scalars['String']['input'];
};


export type MutationUpdateUboOwnerArgs = {
  contractId: Scalars['ID']['input'];
  ownedUboId: Scalars['ID']['input'];
  ubo: UpdateUboInputType;
  uboOwnerId: Scalars['ID']['input'];
};


export type MutationUpdateWalletStatusArgs = {
  action: WalletFlowAction;
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
  walletId: Scalars['ID']['input'];
};


export type MutationUploadNewCryptoStatementArgs = {
  authorizationCode: Scalars['ID']['input'];
  filesFromS3?: InputMaybe<Array<InputMaybe<CryptoFilesInput>>>;
};


export type MutationUpsertArticleArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertCheckArgs = {
  applicableTo?: InputMaybe<Array<InputMaybe<CheckableEntityType>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<InputMaybe<CheckItemInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ManualCheckType>;
};


export type MutationUpsertContractCommissionSettingsArgs = {
  authCode: Scalars['ID']['input'];
  commissionFeeGroupId?: InputMaybe<Scalars['ID']['input']>;
  commissionPayoutAccountId?: InputMaybe<Scalars['ID']['input']>;
  contractId: Scalars['ID']['input'];
  currency?: InputMaybe<Currency>;
  fixedFee?: InputMaybe<FixedFeeInput>;
  generatePayouts?: InputMaybe<Scalars['Boolean']['input']>;
  masterSuccessFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  payoutAccountDetails?: InputMaybe<SwiftTransferIndividualPartyDetailsInput>;
  perpetualSuccessFeePeriod?: InputMaybe<Scalars['Boolean']['input']>;
  successFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  successFeePeriod?: InputMaybe<Scalars['Int']['input']>;
  successFeeVat?: InputMaybe<Scalars['Float']['input']>;
  tieredCommissions?: InputMaybe<TieredCommissionsInput>;
};


export type MutationUpsertContractContactArgs = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contactInfo?: InputMaybe<ContactInfoInput>;
  contractAuthorizedPersonId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ContractContactType>;
};


export type MutationUpsertContractGroupArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};


export type MutationUpsertContractMinimumTurnoverFeesArgs = {
  contractId: Scalars['ID']['input'];
  minimumTurnovers: Array<InputMaybe<MinimumTurnoverInput>>;
};


export type MutationUpsertContractTechnicalPropertiesArgs = {
  contractId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  paymentWebhook?: InputMaybe<Scalars['String']['input']>;
  webhookSignatureKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertDocumentArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  archivePrevious?: InputMaybe<Scalars['Boolean']['input']>;
  contractId?: InputMaybe<Scalars['Int']['input']>;
  expiration?: InputMaybe<Scalars['Date']['input']>;
  fileDescription?: InputMaybe<Scalars['String']['input']>;
  firstSide?: InputMaybe<DocumentSideInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  individualId?: InputMaybe<Scalars['Int']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  internalTag?: InputMaybe<Scalars['String']['input']>;
  legalEntityId?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  relatesTo?: InputMaybe<Array<InputMaybe<DocumentRelatedEntityInput>>>;
  secondSide?: InputMaybe<DocumentSideInput>;
  signable?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DocumentStatus>;
  type?: InputMaybe<DocumentType>;
};


export type MutationUpsertFeeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subcategoryId?: InputMaybe<Scalars['ID']['input']>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpsertFeeCategoryArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertFeeGroupArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertFeeSubcategoryArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertFileBasedPainAccessArgs = {
  allowedChannels?: InputMaybe<Array<InputMaybe<FileBasedPainAccessChannel>>>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  originatingBic?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FileBasedPainAccessStatus>;
};


export type MutationUpsertGeneralIndividualNoteArgs = {
  generalNote?: InputMaybe<Scalars['String']['input']>;
  generalNoteImportant?: InputMaybe<Scalars['Boolean']['input']>;
  individualId: Scalars['ID']['input'];
};


export type MutationUpsertNoticeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  type?: InputMaybe<NoticeType>;
  url?: InputMaybe<Scalars['String']['input']>;
  validFrom: Scalars['DateTime']['input'];
  validTo: Scalars['DateTime']['input'];
};


export type MutationUpsertPaymentCredentialsArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertPermissionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationUpsertProductArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};


export type MutationUpsertRoleArgs = {
  defaultPermissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpsertTagsArgs = {
  input: TagInput;
};


export type MutationUpsertUserArgs = {
  allowedIps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  companies?: InputMaybe<Array<InputMaybe<Company>>>;
  contracts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  department?: InputMaybe<UserDepartmentType>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<InputMaybe<Language>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  managerId?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skype?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserChangeOwnPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationValidateBatchPaymentFileArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  fileUrl: Scalars['String']['input'];
};


export type MutationValidateDirectDebitBatchPaymentFileArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  records?: InputMaybe<Array<InputMaybe<DirectDebitRequestRecordInput>>>;
};


export type MutationVerifyPhoneArgs = {
  code: Scalars['String']['input'];
  phoneVerificationId: Scalars['Int']['input'];
};

export type NameMismatchInfo = {
  __typename?: 'NameMismatchInfo';
  actual?: Maybe<Scalars['String']['output']>;
  incoming?: Maybe<Scalars['String']['output']>;
  similarityScore?: Maybe<Scalars['Float']['output']>;
};

export enum Nationality {
  Faroese = 'Faroese',
  Afghan = 'afghan',
  Alandish = 'alandish',
  Albanian = 'albanian',
  Algerian = 'algerian',
  American = 'american',
  AmericanSamoan = 'americanSamoan',
  Andorran = 'andorran',
  Angolan = 'angolan',
  Anguillan = 'anguillan',
  Antarctic = 'antarctic',
  AntiguanBarbudan = 'antiguanBarbudan',
  Argentinean = 'argentinean',
  Armenian = 'armenian',
  Aruban = 'aruban',
  Australian = 'australian',
  Austrian = 'austrian',
  Azerbaijani = 'azerbaijani',
  Bahamian = 'bahamian',
  Bahraini = 'bahraini',
  Bangladeshi = 'bangladeshi',
  Barbadian = 'barbadian',
  Belarusian = 'belarusian',
  Belgian = 'belgian',
  Belizean = 'belizean',
  Beninese = 'beninese',
  Bermudan = 'bermudan',
  Bhutanese = 'bhutanese',
  Bolivian = 'bolivian',
  BosnianHerzegovinian = 'bosnianHerzegovinian',
  Brazilian = 'brazilian',
  British = 'british',
  Bruneian = 'bruneian',
  Bulgarian = 'bulgarian',
  Burkinabe = 'burkinabe',
  Burundian = 'burundian',
  Cambodian = 'cambodian',
  Cameroonian = 'cameroonian',
  Canadian = 'canadian',
  CapeVerdian = 'capeVerdian',
  Caymanian = 'caymanian',
  CentralAfrican = 'centralAfrican',
  Chadian = 'chadian',
  Chilean = 'chilean',
  Chinese = 'chinese',
  ChristmasIsland = 'christmasIsland',
  Cocossian = 'cocossian',
  Colombian = 'colombian',
  Comoran = 'comoran',
  Congolese = 'congolese',
  CookIslander = 'cookIslander',
  CostaRican = 'costaRican',
  Croatian = 'croatian',
  Cuban = 'cuban',
  Curacaoan = 'curacaoan',
  Cypriot = 'cypriot',
  Czech = 'czech',
  Danish = 'danish',
  Djibouti = 'djibouti',
  Dominican = 'dominican',
  Dutch = 'dutch',
  Ecuadorean = 'ecuadorean',
  Egyptian = 'egyptian',
  Emirian = 'emirian',
  EquatorialGuinean = 'equatorialGuinean',
  Eritrean = 'eritrean',
  Estonian = 'estonian',
  Ethiopian = 'ethiopian',
  FalklandIslander = 'falklandIslander',
  Fijian = 'fijian',
  Filipino = 'filipino',
  Finnish = 'finnish',
  French = 'french',
  FrenchGuianese = 'frenchGuianese',
  FrenchPolynesian = 'frenchPolynesian',
  Gabonese = 'gabonese',
  Gambian = 'gambian',
  Georgian = 'georgian',
  German = 'german',
  Ghanaian = 'ghanaian',
  Greek = 'greek',
  Greenlander = 'greenlander',
  Grenadian = 'grenadian',
  Guadeloupean = 'guadeloupean',
  Guamanian = 'guamanian',
  Guatemalan = 'guatemalan',
  Guyanese = 'guyanese',
  Haitian = 'haitian',
  HeardAndMcDonaldIslander = 'heardAndMcDonaldIslander',
  Honduran = 'honduran',
  HongKonger = 'hongKonger',
  Hungarian = 'hungarian',
  Icelander = 'icelander',
  Indian = 'indian',
  Indonesian = 'indonesian',
  Iranian = 'iranian',
  Iraqi = 'iraqi',
  Irish = 'irish',
  Israeli = 'israeli',
  Italian = 'italian',
  Ivorian = 'ivorian',
  Jamaican = 'jamaican',
  Japanese = 'japanese',
  Jordanian = 'jordanian',
  Kazakhstani = 'kazakhstani',
  Kenyan = 'kenyan',
  Kirghiz = 'kirghiz',
  Kiribati = 'kiribati',
  KittianNevisian = 'kittianNevisian',
  Kosovar = 'kosovar',
  Kuwaiti = 'kuwaiti',
  Laotian = 'laotian',
  Latvian = 'latvian',
  Lebanese = 'lebanese',
  Liberian = 'liberian',
  Libyan = 'libyan',
  Liechtensteiner = 'liechtensteiner',
  Lithuanian = 'lithuanian',
  Luxembourger = 'luxembourger',
  Macanese = 'macanese',
  Macedonian = 'macedonian',
  Mahoran = 'mahoran',
  Malagasy = 'malagasy',
  Malawian = 'malawian',
  Malaysian = 'malaysian',
  Maldivan = 'maldivan',
  Malian = 'malian',
  Maltese = 'maltese',
  Manx = 'manx',
  Mariana = 'mariana',
  Marshallese = 'marshallese',
  Martinican = 'martinican',
  Mauritanian = 'mauritanian',
  Mauritian = 'mauritian',
  Mexican = 'mexican',
  Micronesian = 'micronesian',
  Moldovan = 'moldovan',
  Monacan = 'monacan',
  Mongolian = 'mongolian',
  Montenegrin = 'montenegrin',
  Montserratian = 'montserratian',
  Moroccan = 'moroccan',
  Motswana = 'motswana',
  Mozambican = 'mozambican',
  Myanmarese = 'myanmarese',
  Namibian = 'namibian',
  Nauruan = 'nauruan',
  Nepalese = 'nepalese',
  NewCaledonian = 'newCaledonian',
  NewZealander = 'newZealander',
  Nicaraguan = 'nicaraguan',
  Nigerian = 'nigerian',
  Nigerien = 'nigerien',
  Niuean = 'niuean',
  NorfolkIslander = 'norfolkIslander',
  NorthKorean = 'northKorean',
  Norwegian = 'norwegian',
  Omani = 'omani',
  Pakistani = 'pakistani',
  Palauan = 'palauan',
  Palestinian = 'palestinian',
  Panamanian = 'panamanian',
  PapuaNewGuinean = 'papuaNewGuinean',
  Paraguayan = 'paraguayan',
  Peruvian = 'peruvian',
  PitcairnIslander = 'pitcairnIslander',
  Polish = 'polish',
  Portuguese = 'portuguese',
  PuertoRican = 'puertoRican',
  Qatari = 'qatari',
  Romanian = 'romanian',
  Russian = 'russian',
  Rwandan = 'rwandan',
  Sahrawi = 'sahrawi',
  SaintHelenian = 'saintHelenian',
  SaintLucian = 'saintLucian',
  SaintMartinIslander = 'saintMartinIslander',
  SaintPierrais = 'saintPierrais',
  SaintVincentian = 'saintVincentian',
  Salvadoran = 'salvadoran',
  Sammarinese = 'sammarinese',
  Samoan = 'samoan',
  SaoTomean = 'saoTomean',
  SaudiArabian = 'saudiArabian',
  Senegalese = 'senegalese',
  Serbian = 'serbian',
  Seychellois = 'seychellois',
  SierraLeonean = 'sierraLeonean',
  Singaporean = 'singaporean',
  Slovak = 'slovak',
  Slovene = 'slovene',
  SolomonIslander = 'solomonIslander',
  Somali = 'somali',
  SouthAfrican = 'southAfrican',
  SouthKorean = 'southKorean',
  SouthSudanese = 'southSudanese',
  Spanish = 'spanish',
  SriLankan = 'sriLankan',
  Sudanese = 'sudanese',
  Surinamer = 'surinamer',
  Swazi = 'swazi',
  Swedish = 'swedish',
  Swiss = 'swiss',
  Syrian = 'syrian',
  Taiwanese = 'taiwanese',
  Tajikistani = 'tajikistani',
  Tanzanian = 'tanzanian',
  Thai = 'thai',
  Timorese = 'timorese',
  Togolese = 'togolese',
  Tokelauan = 'tokelauan',
  Tongan = 'tongan',
  Trinidadian = 'trinidadian',
  Tunisian = 'tunisian',
  Turkish = 'turkish',
  Turkmen = 'turkmen',
  Tuvaluan = 'tuvaluan',
  Ugandan = 'ugandan',
  Ukrainian = 'ukrainian',
  Uruguayan = 'uruguayan',
  Uzbekistani = 'uzbekistani',
  Vanuatu = 'vanuatu',
  Vatican = 'vatican',
  Venezuelan = 'venezuelan',
  Vietnamese = 'vietnamese',
  WillisFutuna = 'willisFutuna',
  Yemeni = 'yemeni',
  Zambian = 'zambian',
  Zimbabwean = 'zimbabwean'
}

export enum NewAccountCurrency {
  Aed = 'AED',
  Aud = 'AUD',
  Cad = 'CAD',
  Chf = 'CHF',
  Czk = 'CZK',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Huf = 'HUF',
  Jpy = 'JPY',
  Mxn = 'MXN',
  Nok = 'NOK',
  Pln = 'PLN',
  Sek = 'SEK',
  Sgd = 'SGD',
  Try = 'TRY',
  Usd = 'USD',
  Zar = 'ZAR'
}

export type NewSecurityCode = {
  __typename?: 'NewSecurityCode';
  /** New security code */
  newSecurityCode?: Maybe<Scalars['String']['output']>;
};

/** Note about an individual / contract */
export type Note = BaseLogInterface & {
  __typename?: 'Note';
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  /** Note content */
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** Uploaded file name */
  fileName?: Maybe<Scalars['String']['output']>;
  /** Uploaded file url */
  fileUrl?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

export type Notice = {
  __typename?: 'Notice';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedBy?: Maybe<User>;
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<NoticeType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export enum NoticeType {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning'
}

/** Which field to order the query results by */
export enum NoticesOrderBy {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  ValidFrom = 'validFrom',
  ValidTo = 'validTo'
}

export type NotificationSettingsInputType = {
  genericNotification?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationSettingsType = {
  __typename?: 'NotificationSettingsType';
  genericNotification?: Maybe<Scalars['Boolean']['output']>;
};

/** Pre-Assessment fields */
export type OnboardingInputType = {
  /** Mark the contract as hight priority */
  isKey?: InputMaybe<Scalars['Boolean']['input']>;
  /** Key information to be displayed at the onboarding phase */
  keyInformation?: InputMaybe<Scalars['String']['input']>;
};

export type OperationsForMobile2Fa = {
  __typename?: 'OperationsForMobile2Fa';
  actions?: Maybe<Array<Maybe<Action>>>;
  challenge?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ActionSignatureStatus>;
  type?: Maybe<TwoFaOperationType>;
};

export enum OrderBy {
  CreatedAt = 'createdAt',
  Id = 'id'
}

export enum OrderDirection {
  Ascending = 'ascending',
  Descending = 'descending'
}

export type OutboundTransactionInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  address: AddressInput;
  bankAddress?: InputMaybe<AddressInput>;
  bankBic: Scalars['String']['input'];
  bankBranchId?: InputMaybe<Scalars['String']['input']>;
  bankBranchName?: InputMaybe<Scalars['String']['input']>;
  bankClearingMemberId?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export enum PaymentCapabilities {
  CrossBorder = 'CROSS_BORDER',
  InstantPayouts = 'INSTANT_PAYOUTS',
  LocalPayouts = 'LOCAL_PAYOUTS',
  Tldr = 'TLDR'
}

export enum PaymentCredentialsStatus {
  Active = 'active',
  Blocked = 'blocked',
  PendingActivation = 'pendingActivation',
  Suspended = 'suspended'
}

export type PaymentCredentialsType = {
  __typename?: 'PaymentCredentialsType';
  contract?: Maybe<BankableEntityContractType>;
  credentials?: Maybe<CredentialsType>;
  id?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PaymentCredentialsStatus>;
};

export type PaymentDailyVolumeDataType = {
  __typename?: 'PaymentDailyVolumeDataType';
  count?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['String']['output']>;
  hourlyVolumes?: Maybe<Array<Maybe<PaymentHourlyVolumeDataType>>>;
  payoutVolume?: Maybe<Scalars['Float']['output']>;
  refundVolume?: Maybe<Scalars['Float']['output']>;
  totalVolume?: Maybe<Scalars['Float']['output']>;
};

export type PaymentGraphDataType = {
  __typename?: 'PaymentGraphDataType';
  date?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type PaymentHourlyVolumeDataType = {
  __typename?: 'PaymentHourlyVolumeDataType';
  amount?: Maybe<Scalars['Float']['output']>;
  hour?: Maybe<Scalars['String']['output']>;
};

export enum PaymentMethod {
  Amex = 'amex',
  Bitcoin = 'bitcoin',
  Card = 'card',
  DirectBankTransfer = 'directBankTransfer',
  EpsGiropay = 'epsGiropay',
  LocalPaymentMethods = 'localPaymentMethods',
  Oct = 'oct',
  Paypal = 'paypal',
  Przelewy24 = 'przelewy24',
  Refund = 'refund',
  Trustly = 'trustly'
}

export enum PaymentRail {
  Bacs = 'bacs',
  BankFrick = 'bankFrick',
  CardTopUp = 'cardTopUp',
  Crypto = 'crypto',
  DebitCard = 'debitCard',
  EuroSic = 'euroSic',
  FasterPayment = 'fasterPayment',
  Internal = 'internal',
  JpmEu = 'jpmEU',
  JpmIntl = 'jpmIntl',
  JpmLocalPay = 'jpmLocalPay',
  JpmUk = 'jpmUK',
  JpmUs = 'jpmUS',
  JpmWireCross = 'jpmWireCross',
  KlarXCurrency = 'klarXCurrency',
  Pagonxt = 'pagonxt',
  PagonxtCross = 'pagonxtCross',
  Sepa = 'sepa',
  SepaDirectDebit = 'sepaDirectDebit',
  SepaInstant = 'sepaInstant',
  Sic = 'sic',
  Signature = 'signature',
  SwiftGeneric = 'swiftGeneric',
  Target2 = 'target2',
  Terrapay = 'terrapay',
  Tldr = 'tldr',
  VisaB2B = 'visaB2B',
  VisaDa = 'visaDA'
}

export type PaymentRailConfig = {
  __typename?: 'PaymentRailConfig';
  /** Rail Branch Code */
  branchCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: User;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  exclusiveContractTypes?: Maybe<Array<ContractType>>;
  exclusiveDestinations?: Maybe<Array<Country>>;
  /** Payment Rail ID */
  id: Scalars['ID']['output'];
  lastUpdatedBy: User;
  /** Rail Provider Name */
  provider: Scalars['String']['output'];
  /** Rail Name */
  rail: Scalars['String']['output'];
  supportsFx: Scalars['Boolean']['output'];
  unsupportedDestinations?: Maybe<Array<Country>>;
  unsupportedIndustries?: Maybe<Array<BusinessCategories>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum PaymentRailConfigOrderBy {
  CreatedAt = 'createdAt',
  Priority = 'priority'
}

export type PaymentRailRouteConfig = {
  __typename?: 'PaymentRailRouteConfig';
  baseCurrency: NewAccountCurrency;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: User;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  flowPercentage: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  instantConfig?: Maybe<Scalars['JSON']['output']>;
  lastUpdatedBy: User;
  localPayoutsConfig?: Maybe<Scalars['JSON']['output']>;
  localPayoutsOnly: Scalars['Boolean']['output'];
  paymentRail: PaymentRailConfig;
  paymentRailId: Scalars['ID']['output'];
  payoutCurrency: Currency;
  priority: Scalars['Int']['output'];
  supportsInstant: Scalars['Boolean']['output'];
  supportsLocalPayouts: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentRailRouteTallyModel = {
  __typename?: 'PaymentRailRouteTallyModel';
  count: Scalars['Float']['output'];
  currencyPair: Scalars['String']['output'];
  paymentRail: PaymentRailConfig;
  paymentRailId: Scalars['ID']['output'];
};

export type PaymentRejectionReasonsDataType = {
  __typename?: 'PaymentRejectionReasonsDataType';
  count?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type PaymentRouteAdditionalConfigInput = {
  maxAmount: Scalars['Float']['input'];
};

export enum PaymentStatus {
  Completed = 'completed',
  Failed = 'failed',
  New = 'new',
  Pending = 'pending'
}

export type PaymentTransferCompanyRecipientKyc = {
  __typename?: 'PaymentTransferCompanyRecipientKyc';
  registrationDate?: Maybe<Scalars['Date']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  registrationType?: Maybe<Scalars['String']['output']>;
};

export type PaymentTransferCompanyRecipientKycInput = {
  registrationDate?: InputMaybe<Scalars['Date']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  registrationType?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentTransferIndividualRecipientKyc = {
  __typename?: 'PaymentTransferIndividualRecipientKyc';
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  idExpiryDate?: Maybe<Scalars['Date']['output']>;
  idIssueCountry?: Maybe<Country>;
  idIssueDate?: Maybe<Scalars['Date']['output']>;
  idNumber?: Maybe<Scalars['String']['output']>;
  idType?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Nationality>;
};

export type PaymentTransferIndividualRecipientKycInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  idExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  idIssueCountry?: InputMaybe<Country>;
  idIssueDate?: InputMaybe<Scalars['Date']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Nationality>;
};

export type PaymentTransferRecipientKyc = {
  __typename?: 'PaymentTransferRecipientKyc';
  company?: Maybe<PaymentTransferCompanyRecipientKyc>;
  individual?: Maybe<PaymentTransferIndividualRecipientKyc>;
};

export type PaymentTransferRecipientKycInput = {
  company?: InputMaybe<PaymentTransferCompanyRecipientKycInput>;
  individual?: InputMaybe<PaymentTransferIndividualRecipientKycInput>;
};

export type PaymentType = {
  __typename?: 'PaymentType';
  amount?: Maybe<Scalars['Float']['output']>;
  cardholderName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Currency>;
  email?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maskedCardNumber?: Maybe<Scalars['String']['output']>;
  method?: Maybe<PaymentMethod>;
  refunds?: Maybe<Array<Maybe<PaymentType>>>;
  serviceErrorMessage?: Maybe<Scalars['String']['output']>;
  serviceStatus?: Maybe<Scalars['String']['output']>;
  sourcePayment?: Maybe<PaymentType>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PaymentStatus>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Which field to order the query results by */
export enum PaymentsOrderBy {
  Amount = 'amount',
  CardNumber = 'cardNumber',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  ExecutedAt = 'executedAt',
  ExternalId = 'externalId',
  Id = 'id',
  Method = 'method',
  Status = 'status'
}

export enum PayoutSchedule {
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export type PciDssCompliance = {
  __typename?: 'PciDssCompliance';
  dssCompliance?: Maybe<Array<Maybe<DssCompliance>>>;
  integrationTypeRequired?: Maybe<Array<Maybe<IntegrationTypeRequired>>>;
  pciProviderName?: Maybe<Scalars['String']['output']>;
};

export type PciDssComplianceInput = {
  dssCompliance?: InputMaybe<Array<InputMaybe<DssCompliance>>>;
  integrationTypeRequired?: InputMaybe<Array<InputMaybe<IntegrationTypeRequired>>>;
  pciProviderName?: InputMaybe<Scalars['String']['input']>;
};

/** ACL Permission string - eg. clients_r (user can see client records) */
export type Permission = {
  __typename?: 'Permission';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Describe this permission */
  description?: Maybe<Scalars['String']['output']>;
  /** Permission ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** Name of this permission */
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Clients' phone verifications */
export type PhoneVerification = {
  __typename?: 'PhoneVerification';
  /** Client */
  client?: Maybe<Individual>;
  /** Code used to verify phone */
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Phone to be verified */
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Did the client verify the phone? */
  verified?: Maybe<Scalars['Boolean']['output']>;
  /** Datet of verification */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PhoneVerificationRequest = {
  __typename?: 'PhoneVerificationRequest';
  attemptsLeft?: Maybe<Scalars['Int']['output']>;
  expectedDigits?: Maybe<Scalars['Int']['output']>;
  phoneLastFourDigits?: Maybe<Scalars['String']['output']>;
  phoneVerificationId?: Maybe<Scalars['ID']['output']>;
  retryAttemptsTimeout?: Maybe<Scalars['Int']['output']>;
  timeout?: Maybe<Scalars['Int']['output']>;
};

/** Pre-Assessment */
export type PreAssessment = {
  __typename?: 'PreAssessment';
  /**
   * Countries Of Operating And Conducting Business
   * @deprecated Not used anymore
   */
  blockedCountries?: Maybe<Array<Maybe<CountriesAndRegionsType>>>;
  businessRelationshipWithCompany?: Maybe<Scalars['String']['output']>;
  businessRelationshipWithCompanyExplanation?: Maybe<Scalars['String']['output']>;
  /**
   * C2B Payments - Question based on Business Sector
   * @deprecated Not used anymore
   */
  c2BPayments?: Maybe<Scalars['String']['output']>;
  /** Card Payment and AMP */
  cardPayment?: Maybe<CardPaymentsAndAmp>;
  /** Clients You Work With - Question based on Business Sector */
  clientsYouWorkWith?: Maybe<Scalars['String']['output']>;
  /** Company Annual Income */
  companyAnnualIncome?: Maybe<Scalars['String']['output']>;
  /** Pre-Assessment companyInfoCountryOfRegistration */
  companyInfoCountryOfRegistration?: Maybe<Scalars['String']['output']>;
  /** Conduct Publisher Content Monitoring - Question based on Business Sector */
  conductPublisherContentMonitoring?: Maybe<Scalars['String']['output']>;
  /** Conducting Client KYC - Question based on Business Sector */
  conductingClientKYC?: Maybe<Scalars['String']['output']>;
  /** Conducting KYC - Question based on Business Sector */
  conductingKYC?: Maybe<Scalars['String']['output']>;
  /** Email of Contact Person */
  contactPersonEmail?: Maybe<Scalars['String']['output']>;
  /** Full Name of Contact Person */
  contactPersonFullName?: Maybe<Scalars['String']['output']>;
  /** Phone number of Contact Person */
  contactPersonPhoneNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Countries of operation not accepted by license
   * @deprecated Not used anymore
   */
  countriesNotAcceptedByLicense?: Maybe<Scalars['String']['output']>;
  /** Country of Tax Residence */
  countryOfTaxResidence?: Maybe<Scalars['String']['output']>;
  /** Currency and Volume */
  currencyAndVolume?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Financial Statements */
  financialStatements?: Maybe<RiskCalculatorFinancialStatements>;
  /**
   * Incoming Clients
   * @deprecated Use partnersIncoming instead
   */
  incomingClients?: Maybe<Scalars['String']['output']>;
  /** Incoming Monthly Turnover */
  incomingMonthlyTurnover?: Maybe<Scalars['String']['output']>;
  /** Country of Tax Residence */
  isUSReportable?: Maybe<Scalars['String']['output']>;
  /**
   * KYC MEasures
   * @deprecated Not used anymore
   */
  kycMeasures?: Maybe<KycMeasuresType>;
  /** License country */
  licenseCountry?: Maybe<Scalars['String']['output']>;
  /** License required */
  licenseRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Pre-Assessment noPartnersIncomingRequired */
  noPartnersIncomingRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Pre-Assessment noPartnersOutgoingRequired */
  noPartnersOutgoingRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Outgoing Clients
   * @deprecated Use partnersOutgoing instead
   */
  outgoingClients?: Maybe<Scalars['String']['output']>;
  /** Outgoing Monthly Turnover */
  outgoingMonthlyTurnover?: Maybe<Scalars['String']['output']>;
  /**
   * Partners Bank Jurisdictions
   * @deprecated
   */
  partnersBankJurisdictions?: Maybe<Array<Maybe<CountriesAndRegionsType>>>;
  /** Partners for Incoming Transactions */
  partnersIncoming?: Maybe<Array<Maybe<PreAssessmentPartner>>>;
  /**
   * Partners Jurisdictions
   * @deprecated Use partnersIncoming and partnersOutgoing instead
   */
  partnersJurisdictions?: Maybe<Array<Maybe<CountriesAndRegionsType>>>;
  /** Partners for Outgoing Transactions */
  partnersOutgoing?: Maybe<Array<Maybe<PreAssessmentPartner>>>;
  /** Payment Providers */
  paymentProviders?: Maybe<Scalars['String']['output']>;
  /** Products */
  products?: Maybe<Array<Maybe<RiskCalculatorProducts>>>;
  /** Regulatory License Number */
  regulatoryInfoLicenseNumber?: Maybe<Scalars['String']['output']>;
  /** Regulatory Info Name */
  regulatoryInfoName?: Maybe<Scalars['String']['output']>;
  /** UBO Residencies */
  uboResidencies?: Maybe<Array<Maybe<Array<Maybe<CountriesAndRegionsType>>>>>;
};

/** Pre-Assessment fields */
export type PreAssessmentContractInputType = {
  businessRelationshipWithCompany?: InputMaybe<Scalars['String']['input']>;
  businessRelationshipWithCompanyExplanation?: InputMaybe<Scalars['String']['input']>;
  /** Card Payment and AMP */
  cardPayment?: InputMaybe<CardPaymentsAndAmpInput>;
  /** Clients You Work With - Question based on Business Sector */
  clientsYouWorkWith?: InputMaybe<Scalars['String']['input']>;
  /** Company Annual Income */
  companyAnnualIncome?: InputMaybe<Scalars['String']['input']>;
  /** companyInfoCountryOfRegistration */
  companyInfoCountryOfRegistration?: InputMaybe<Scalars['String']['input']>;
  /** Conduct Publisher Content Monitoring - Question based on Business Sector */
  conductPublisherContentMonitoring?: InputMaybe<Scalars['String']['input']>;
  /** Conducting Client KYC - Question based on Business Sector */
  conductingClientKYC?: InputMaybe<Scalars['String']['input']>;
  /** Conducting KYC - Question based on Business Sector */
  conductingKYC?: InputMaybe<Scalars['String']['input']>;
  /** Email of Contact Person */
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  /** Full Name of Contact Person */
  contactPersonFullName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of Contact Person */
  contactPersonPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Country of Tax Residence */
  countryOfTaxResidence?: InputMaybe<Scalars['String']['input']>;
  /** Currency and Volume */
  currencyAndVolume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Incoming Monthly Turnover */
  incomingMonthlyTurnover?: InputMaybe<Scalars['String']['input']>;
  /** License country */
  licenseCountry?: InputMaybe<CountriesAndRegionsType>;
  /** License required */
  licenseRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** No partners incoming required */
  noPartnersIncomingRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** No partners outgoing required */
  noPartnersOutgoingRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Outgoing Monthly Turnover */
  outgoingMonthlyTurnover?: InputMaybe<Scalars['String']['input']>;
  /** Partners for Incoming Transactions */
  partnersIncoming?: InputMaybe<Array<InputMaybe<PreAssessmentPartnerInput>>>;
  /** Partners for Outgoing Transactions */
  partnersOutgoing?: InputMaybe<Array<InputMaybe<PreAssessmentPartnerInput>>>;
  /** Payment Providers */
  paymentProviders?: InputMaybe<Scalars['String']['input']>;
  /** Regulatory License Number */
  regulatoryInfoLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  /** Regulatory Info Name */
  regulatoryInfoName?: InputMaybe<Scalars['String']['input']>;
  /** UBO Residencies */
  uboResidencies?: InputMaybe<Array<InputMaybe<Array<InputMaybe<CountriesAndRegionsType>>>>>;
};

/** Pre-Assessment Partner */
export type PreAssessmentPartner = {
  __typename?: 'PreAssessmentPartner';
  bankCountry?: Maybe<Scalars['String']['output']>;
  businessSector?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentPurpose?: Maybe<Array<Maybe<EconomicProfileInboundOutboundSource>>>;
  paymentPurposeOther?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type PreAssessmentPartnerInput = {
  bankCountry?: InputMaybe<Scalars['String']['input']>;
  businessSector?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentPurpose?: InputMaybe<Array<InputMaybe<EconomicProfileInboundOutboundSource>>>;
  paymentPurposeOther?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export enum PreAssessmentStatus {
  Duplicate = 'duplicate',
  Handled = 'handled',
  New = 'new',
  Pending = 'pending'
}

export enum PrioritiesType {
  High = 'high',
  Highest = 'highest',
  Low = 'low',
  Lowest = 'lowest',
  Medium = 'medium'
}

export enum ProcessDocumentResult {
  Approve = 'approve',
  Reject = 'reject'
}

export enum ProcessProfileChangeResult {
  Approve = 'approve',
  Reject = 'reject',
  UnderReview = 'underReview'
}

export type Product = {
  __typename?: 'Product';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum Products {
  CorporateCards = 'corporateCards',
  CryptocurrencyWallet = 'cryptocurrencyWallet',
  Iban = 'iban',
  PaymentProcessing = 'paymentProcessing',
  VirtualIban = 'virtualIban'
}

export type ProfileChange = {
  __typename?: 'ProfileChange';
  /** @deprecated use changeAnswers */
  answers?: Maybe<ProfileChangeAnswers>;
  changeAnswers?: Maybe<ProfileChangeAnswer>;
  comments?: Maybe<Scalars['String']['output']>;
  /** Contract To Apply The Change */
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** actionType */
  executionAction?: Maybe<Action>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual who submitted this change change */
  individual?: Maybe<Individual>;
  oldMeta?: Maybe<ProfileChangeAnswer>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ProfileChangeStatus>;
  supportingDocuments?: Maybe<Array<Maybe<Document>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProfileChangeAnswer = ContractProfileChangeAnswers | ProfileChangeAnswers;

export type ProfileChangeAnswers = {
  __typename?: 'ProfileChangeAnswers';
  address?: Maybe<Address>;
  birthday?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  language?: Maybe<Language>;
  lastName?: Maybe<Scalars['String']['output']>;
  mifirId?: Maybe<Scalars['String']['output']>;
  mifirType?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Nationality>;
  phone?: Maybe<Scalars['String']['output']>;
  secondaryEmails?: Maybe<SecondaryEmails>;
  secondaryPhones?: Maybe<SecondaryPhones>;
};

export enum ProfileChangeStatus {
  Approved = 'approved',
  Pending = 'pending',
  PendingExecutionSignature = 'pendingExecutionSignature',
  Rejected = 'rejected',
  UnderReview = 'underReview'
}

export enum ProfileChangeType {
  Contract = 'contract',
  Individual = 'individual'
}

export type QrrDebtorInputType = {
  address: AddressInput;
  name: Scalars['String']['input'];
};

export enum QrrLanguage {
  De = 'DE',
  En = 'EN',
  Fr = 'FR',
  It = 'IT'
}

export type QrBillType = {
  __typename?: 'QrBillType';
  format?: Maybe<AccountQrBillType>;
  result?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  accountBalanceSnapshot?: Maybe<AccountBalanceSnapshot>;
  accountBalanceSnapshots?: Maybe<Array<Maybe<AccountBalanceSnapshot>>>;
  accountBalanceSnapshotsCount?: Maybe<Scalars['Int']['output']>;
  accountBundle?: Maybe<AccountBundle>;
  accountBundles?: Maybe<Array<Maybe<AccountBundle>>>;
  accountBundlesCount?: Maybe<Scalars['Int']['output']>;
  accountCancellationReturnsReport?: Maybe<AccountStatement>;
  accountStatement?: Maybe<AccountStatement>;
  accountTransactions?: Maybe<Array<Maybe<Transaction>>>;
  accountTransactionsCount?: Maybe<Scalars['Int']['output']>;
  accounts?: Maybe<Array<Maybe<Account>>>;
  accountsCount?: Maybe<Scalars['Int']['output']>;
  action?: Maybe<Action>;
  actionSignatureRequest?: Maybe<ActionSignature>;
  actionSignatureRequests?: Maybe<Array<Maybe<ActionSignature>>>;
  actionSignatureRequestsCount?: Maybe<Scalars['Int']['output']>;
  actions?: Maybe<Array<Maybe<Action>>>;
  actionsCount?: Maybe<Scalars['Int']['output']>;
  actionsForMobile2Fa?: Maybe<Array<Maybe<OperationsForMobile2Fa>>>;
  activityLog?: Maybe<ActivityLog>;
  activityLogs?: Maybe<Array<Maybe<ActivityLog>>>;
  activityLogsCount?: Maybe<Scalars['Int']['output']>;
  apiUser?: Maybe<ApiUser>;
  apiUsers?: Maybe<Array<Maybe<ApiUser>>>;
  apiUsersCount?: Maybe<Scalars['Int']['output']>;
  approvalRequest?: Maybe<ApprovalRequest>;
  approvalRequests?: Maybe<Array<Maybe<ApprovalRequest>>>;
  approvalRequestsCount?: Maybe<Scalars['Int']['output']>;
  article?: Maybe<Article>;
  articles: Array<Article>;
  articlesCount: Scalars['Int']['output'];
  bankInfo?: Maybe<BankInfoType>;
  batchPayment?: Maybe<BatchPayment>;
  batchPaymentRecord?: Maybe<BatchPaymentRecord>;
  batchPaymentRecords?: Maybe<Array<Maybe<BatchPaymentRecord>>>;
  batchPaymentRecordsCount?: Maybe<Scalars['Int']['output']>;
  batchPayments?: Maybe<Array<Maybe<BatchPayment>>>;
  batchPaymentsCount?: Maybe<Scalars['Int']['output']>;
  card?: Maybe<CardType>;
  cardIssueRequest?: Maybe<CardRequestType>;
  cardIssueRequestCount?: Maybe<Scalars['Int']['output']>;
  cardIssueRequests?: Maybe<Array<Maybe<CardRequestType>>>;
  cardTransactionClearingWorkerLog?: Maybe<CardTransactionClearingWorkerLog>;
  cardTransactionClearingWorkerLogs?: Maybe<Array<Maybe<CardTransactionClearingWorkerLog>>>;
  cardTransactionClearingWorkerLogsCount?: Maybe<Scalars['Int']['output']>;
  cards?: Maybe<Array<Maybe<CardType>>>;
  cardsAllowedLimitsAndMaxes?: Maybe<CardAllowedLimitsType>;
  cardsCount?: Maybe<Scalars['Int']['output']>;
  checkResult?: Maybe<CheckResult>;
  checkResults?: Maybe<Array<Maybe<CheckResult>>>;
  checkResultsCount?: Maybe<Scalars['Int']['output']>;
  checks?: Maybe<Array<Maybe<Check>>>;
  checksCount?: Maybe<Scalars['Int']['output']>;
  classificationReport?: Maybe<Scalars['String']['output']>;
  classifications?: Maybe<RiskClassificationReturn>;
  classificationsCount?: Maybe<Scalars['Int']['output']>;
  contract?: Maybe<BankableEntityContractType>;
  contractAuthorizedPerson?: Maybe<ContractAuthorizedPersonType>;
  contractAuthorizedPersons?: Maybe<Array<Maybe<ContractAuthorizedPersonType>>>;
  contractAuthorizedPersonsCount?: Maybe<Scalars['Int']['output']>;
  contractCard?: Maybe<CardType>;
  contractCards?: Maybe<Array<Maybe<CardType>>>;
  contractCardsCount?: Maybe<Scalars['Int']['output']>;
  contractContact?: Maybe<ContractContact>;
  contractContacts?: Maybe<Array<Maybe<ContractContact>>>;
  contractContactsCount?: Maybe<Scalars['Int']['output']>;
  contractDailyVolumeData?: Maybe<PaymentDailyVolumeDataType>;
  contractGroups?: Maybe<Array<Maybe<ContractGroup>>>;
  contractGroupsCount?: Maybe<Scalars['Int']['output']>;
  contractInformationRequest?: Maybe<ContractInformationRequest>;
  contractInformationRequests: Array<ContractInformationRequest>;
  contractInformationRequestsCount?: Maybe<Scalars['Int']['output']>;
  contractPaymentApprovalRatesData?: Maybe<Array<Maybe<PaymentGraphDataType>>>;
  contractPaymentRecipient?: Maybe<ContractPaymentRecipient>;
  contractPaymentRecipients?: Maybe<Array<Maybe<ContractPaymentRecipient>>>;
  contractPaymentRecipientsCount?: Maybe<Scalars['Int']['output']>;
  contractPaymentTopRejectionReasonsData?: Maybe<Array<Maybe<PaymentRejectionReasonsDataType>>>;
  contractPeriodicReview?: Maybe<ContractPeriodicReview>;
  contractPeriodicReviews?: Maybe<Array<Maybe<ContractPeriodicReview>>>;
  contractPeriodicReviewsCount?: Maybe<Scalars['Int']['output']>;
  contractProfileChanges?: Maybe<Array<Maybe<ProfileChange>>>;
  contractProfileChangesCount?: Maybe<Scalars['Int']['output']>;
  contractTransactions?: Maybe<Array<Maybe<Transaction>>>;
  contractTransactionsCount?: Maybe<Scalars['Int']['output']>;
  contracts?: Maybe<Array<Maybe<BankableEntityContractType>>>;
  contractsCount?: Maybe<Scalars['Int']['output']>;
  cryptoRate?: Maybe<CryptoRate>;
  deviceInformation?: Maybe<DeviceInformation>;
  devicesInformation?: Maybe<Array<Maybe<DeviceInformation>>>;
  devicesInformationCount?: Maybe<Scalars['Int']['output']>;
  directDebitDisputes: Array<DirectDebitDispute>;
  directDebitDisputesCount?: Maybe<Scalars['Int']['output']>;
  directDebitExecution?: Maybe<DirectDebitExecution>;
  directDebitExecutions: Array<DirectDebitExecution>;
  directDebitExecutionsCount: Scalars['Int']['output'];
  directDebitMandate?: Maybe<DirectDebitMandate>;
  directDebitMandates: Array<DirectDebitMandate>;
  directDebitMandatesCount: Scalars['Int']['output'];
  document?: Maybe<Document>;
  documents?: Maybe<Array<Maybe<Document>>>;
  documentsCount?: Maybe<Scalars['Int']['output']>;
  documentsForVideo?: Maybe<Array<Maybe<DocumentDescription>>>;
  entityReminder?: Maybe<EntityReminder>;
  entityReminders?: Maybe<Array<Maybe<EntityReminder>>>;
  entityRemindersCount?: Maybe<Scalars['Int']['output']>;
  feeCategories?: Maybe<Array<Maybe<FeeCategory>>>;
  feeDetails?: Maybe<Array<Maybe<FeeDetail>>>;
  feeDetailsCount?: Maybe<Scalars['Int']['output']>;
  feeGroups?: Maybe<Array<Maybe<FeeGroup>>>;
  feeSettingsForGroup?: Maybe<Array<Maybe<FeeGroupToFee>>>;
  feeSubcategories?: Maybe<Array<Maybe<FeeSubcategory>>>;
  feeTypes?: Maybe<Array<Maybe<FeeType>>>;
  feesForContract?: Maybe<Array<Maybe<Fee>>>;
  feesForGroup?: Maybe<Array<Maybe<Fee>>>;
  getAutomatedFormA?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use getCardSensitiveInfoV2 */
  getCardSensitiveInfo?: Maybe<CardSensitiveInfoType>;
  getCardSensitiveInfoV2?: Maybe<CardSensitiveInfoRef>;
  getCardTransactionAuthorizations?: Maybe<Array<Maybe<CardTransactionAuthorization>>>;
  getCardTransactionAuthorizationsCount?: Maybe<Scalars['Int']['output']>;
  getContractRelatedIndividuals?: Maybe<Array<Maybe<Individual>>>;
  getContractTechnicalProperties?: Maybe<ContractTechnicalDetailsType>;
  getContractUbo?: Maybe<ContractUbo>;
  getContractUboByUboId?: Maybe<ContractUbo>;
  /** @deprecated Use getEncrypted3DSPasswordV2 */
  getEncrypted3DSPassword?: Maybe<Scalars['String']['output']>;
  getEncrypted3DSPasswordV2?: Maybe<CardSensitiveInfoRef>;
  getExternalTransferFXCurrencies?: Maybe<Array<Maybe<TransferFxCurrency>>>;
  getLegalEntityDirector?: Maybe<LegalEntityDirector>;
  getLegalEntityDirectors?: Maybe<Array<Maybe<LegalEntityDirector>>>;
  getReservedFXRate?: Maybe<ReservedFxRateDetails>;
  getStaticFXRates?: Maybe<Array<Maybe<StaticFxRate>>>;
  getTransactionConfirmation?: Maybe<AccountStatement>;
  getUbo?: Maybe<Ubo>;
  getUboOwners?: Maybe<Array<Maybe<UboOwner>>>;
  getUbos?: Maybe<Array<Maybe<Ubo>>>;
  getVideoVerificationStatus?: Maybe<Scalars['String']['output']>;
  guaranteeEvent?: Maybe<GuaranteeEvent>;
  guaranteeEvents?: Maybe<Array<Maybe<GuaranteeEvent>>>;
  guaranteeEventsCount?: Maybe<Scalars['Int']['output']>;
  guaranteedWithdrawalWithinLimits?: Maybe<Scalars['Boolean']['output']>;
  ibanCertificate?: Maybe<Scalars['String']['output']>;
  iframeUrlForCardNo?: Maybe<CardSensitiveInfoRef>;
  individual?: Maybe<Individual>;
  individualEmailCategoryPreferences?: Maybe<Array<Maybe<IndividualEmailCategoryPreference>>>;
  individualEmailCategoryPreferencesCount?: Maybe<Scalars['Int']['output']>;
  individualSMSCategoryPreferences?: Maybe<Array<Maybe<IndividualSmsCategoryPreference>>>;
  individualSMSCategoryPreferencesCount?: Maybe<Scalars['Int']['output']>;
  individuals?: Maybe<Array<Maybe<Individual>>>;
  individualsCount?: Maybe<Scalars['Int']['output']>;
  internationalRemittanceBanks?: Maybe<TerrapayBankType>;
  internationalRemittanceWallets?: Maybe<TerrapayWalletType>;
  isProductTermsSignedOrPending?: Maybe<Scalars['Boolean']['output']>;
  ledger?: Maybe<Ledger>;
  ledgerTransaction?: Maybe<LedgerTransaction>;
  ledgerTransactions?: Maybe<Array<Maybe<LedgerTransaction>>>;
  ledgerTransactionsCount?: Maybe<Scalars['Int']['output']>;
  ledgers?: Maybe<Array<Maybe<Ledger>>>;
  ledgersCount?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Location>;
  locations?: Maybe<Array<Maybe<Location>>>;
  locationsCount?: Maybe<Scalars['Int']['output']>;
  monitoringAlert?: Maybe<MonitoringAlert>;
  monitoringAlerts?: Maybe<Array<Maybe<MonitoringAlert>>>;
  monitoringAlertsCount?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Note>;
  notes?: Maybe<Array<Maybe<Note>>>;
  notesCount?: Maybe<Scalars['Int']['output']>;
  notice?: Maybe<Notice>;
  notices?: Maybe<Array<Maybe<Notice>>>;
  noticesCount?: Maybe<Scalars['Int']['output']>;
  outboundPaymentCapabilities?: Maybe<Array<Maybe<PaymentCapabilities>>>;
  payment?: Maybe<PaymentType>;
  paymentRail?: Maybe<PaymentRailConfig>;
  paymentRailConfigs: Array<PaymentRailConfig>;
  paymentRailConfigsCount: Scalars['Int']['output'];
  paymentRailRouteConfig?: Maybe<PaymentRailRouteConfig>;
  paymentRailRouteConfigs: Array<PaymentRailRouteConfig>;
  paymentRailRouteConfigsCount: Scalars['Int']['output'];
  paymentRailRouteConfiguredPayoutCurrencies?: Maybe<Array<Currency>>;
  paymentRoutesDistributionTally?: Maybe<Array<PaymentRailRouteTallyModel>>;
  payments?: Maybe<Array<Maybe<PaymentType>>>;
  paymentsCount?: Maybe<Scalars['Int']['output']>;
  permission?: Maybe<Permission>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  permissionsCount?: Maybe<Scalars['Int']['output']>;
  phoneVerification?: Maybe<PhoneVerification>;
  phoneVerifications?: Maybe<Array<Maybe<PhoneVerification>>>;
  preAssessments?: Maybe<Array<Maybe<LegacyPreAssessment>>>;
  product?: Maybe<Product>;
  products?: Maybe<Array<Maybe<Product>>>;
  productsCount?: Maybe<Scalars['Int']['output']>;
  profileChange?: Maybe<ProfileChange>;
  profileChanges?: Maybe<Array<Maybe<ProfileChange>>>;
  profileChangesCount?: Maybe<Scalars['Int']['output']>;
  recapitulationReportsCrypto?: Maybe<Array<Maybe<RecapitulationReportCrypto>>>;
  recapitulationReportsCryptoCount?: Maybe<Scalars['Int']['output']>;
  riskCalculatorConfig?: Maybe<Scalars['String']['output']>;
  riskLevelsHistory?: Maybe<RiskLevelChangesReturn>;
  riskLevelsReport?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  roles?: Maybe<Array<Maybe<Role>>>;
  rolesCount?: Maybe<Scalars['Int']['output']>;
  spendingLimitRequest?: Maybe<SpendingLimitRequestType>;
  spendingLimitRequests?: Maybe<Array<Maybe<SpendingLimitRequestType>>>;
  spendingLimitRequestsCount?: Maybe<Scalars['Int']['output']>;
  standingOrder?: Maybe<StandingOrder>;
  successFee?: Maybe<SuccessFee>;
  successFeePayout?: Maybe<SuccessFeePayout>;
  successFeePayouts?: Maybe<Array<Maybe<SuccessFeePayout>>>;
  successFeePayoutsCount?: Maybe<Scalars['Int']['output']>;
  successFees?: Maybe<Array<Maybe<SuccessFee>>>;
  successFeesCount?: Maybe<Scalars['Int']['output']>;
  swiftConversations?: Maybe<Array<Maybe<SwiftConversation>>>;
  swiftConversationsCount?: Maybe<Scalars['Int']['output']>;
  swiftMessage?: Maybe<RawSwiftMessage>;
  swiftMessageFileLog?: Maybe<RawSwiftMessageFileLog>;
  swiftMessageFileLogs?: Maybe<Array<Maybe<RawSwiftMessageFileLog>>>;
  swiftMessageFileLogsCount?: Maybe<Scalars['Int']['output']>;
  swiftMessageStats?: Maybe<SwiftMessageStats>;
  swiftMessageTransactionInfo?: Maybe<Scalars['String']['output']>;
  swiftMessageTypeIdentifiers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  swiftMessages?: Maybe<Array<Maybe<RawSwiftMessage>>>;
  swiftMessagesCount?: Maybe<Scalars['Int']['output']>;
  tag?: Maybe<Tag>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  tagsCount?: Maybe<Scalars['Int']['output']>;
  termsAndCondition?: Maybe<TermsAndCondition>;
  termsAndConditions?: Maybe<Array<Maybe<TermsAndCondition>>>;
  termsAndConditionsCount?: Maybe<Scalars['Int']['output']>;
  transaction?: Maybe<Transaction>;
  transactionClaimsRecallRequest?: Maybe<TransactionClaimsRecallRequest>;
  transactionClaimsRecallRequests?: Maybe<Array<Maybe<TransactionClaimsRecallRequest>>>;
  transactionClaimsRecallRequestsCount?: Maybe<Scalars['Int']['output']>;
  transactionForbiddenCountries?: Maybe<Array<Maybe<Country>>>;
  transactionGpiStatus?: Maybe<SwiftGpiTransactionStatus>;
  transactionRequest?: Maybe<TransactionRequest>;
  transactionRequests?: Maybe<Array<Maybe<TransactionRequest>>>;
  transactionRequestsCount?: Maybe<Scalars['Int']['output']>;
  transactionTrackingInfo?: Maybe<TransactionTrackingInfo>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  transactionsCount?: Maybe<Scalars['Int']['output']>;
  unreadDocuments?: Maybe<Array<Maybe<Document>>>;
  unreadDocumentsCount?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  users?: Maybe<Array<Maybe<User>>>;
  usersCount?: Maybe<Scalars['Int']['output']>;
  validateInternationalRemittanceBeneficiaryDetails?: Maybe<ValidateBeneficiaryDetailsType>;
  vibanNameMismatches?: Maybe<Array<Maybe<VibanNameMismatch>>>;
  vibanNameMismatchesCount?: Maybe<Scalars['Int']['output']>;
  viewPin?: Maybe<CardSensitiveInfoRef>;
  viewer?: Maybe<Viewer>;
  wallet?: Maybe<Wallet>;
  walletTransactions?: Maybe<Array<Maybe<TransactionRequest>>>;
  walletTransactionsCount?: Maybe<Scalars['Int']['output']>;
  wallets?: Maybe<Array<Maybe<Wallet>>>;
  walletsCount?: Maybe<Scalars['Int']['output']>;
};


export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountBalanceSnapshotArgs = {
  accountId: Scalars['ID']['input'];
  reportingDate: Scalars['Date']['input'];
};


export type QueryAccountBalanceSnapshotsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  reportingDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAccountBalanceSnapshotsCountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  reportingDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAccountBundleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountBundlesArgs = {
  contractId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryAccountBundlesCountArgs = {
  contractId: Scalars['ID']['input'];
};


export type QueryAccountCancellationReturnsReportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAccountStatementArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<AccountStatementType>;
};


export type QueryAccountTransactionsArgs = {
  accountId: Scalars['ID']['input'];
  batchId?: InputMaybe<Scalars['ID']['input']>;
  cardFilter?: InputMaybe<TransactionCardFilter>;
  cardId?: InputMaybe<Scalars['ID']['input']>;
  clientReference?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  cumulativeReviewStatuses?: InputMaybe<Array<InputMaybe<TransactionCumulativeReviewStatus>>>;
  currencies?: InputMaybe<Array<InputMaybe<Currency>>>;
  entryTypes?: InputMaybe<Array<InputMaybe<TransactionEntryType>>>;
  executedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  executedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  hasSar?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupportingDocument?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeSubAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  internalTransferType?: InputMaybe<InternalTransferType>;
  isReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notContractIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notInternalTransferTypes?: InputMaybe<Array<InputMaybe<InternalTransferType>>>;
  notStatuses?: InputMaybe<Array<InputMaybe<TransactionStatus>>>;
  notTypes?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  paymentRails?: InputMaybe<Array<InputMaybe<PaymentRail>>>;
  payoutCurrencies?: InputMaybe<Array<InputMaybe<Currency>>>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  pendingPostReview?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<TransactionStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  valueFrom?: InputMaybe<Scalars['Float']['input']>;
  valueTo?: InputMaybe<Scalars['Float']['input']>;
  walletId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAccountTransactionsCountArgs = {
  accountId: Scalars['ID']['input'];
  cardId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAccountsArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  contractStatuses?: InputMaybe<Array<InputMaybe<ContractStatusType>>>;
  currencies?: InputMaybe<Array<InputMaybe<Currency>>>;
  entityType?: InputMaybe<UboType>;
  excludeVirtual?: InputMaybe<Scalars['Boolean']['input']>;
  fundsType?: InputMaybe<FundsType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  isPendingDeactivation?: InputMaybe<Scalars['Boolean']['input']>;
  isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notStatuses?: InputMaybe<Array<InputMaybe<AccountStatus>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  qrrSupported?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<AccountStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<AccountType>>>;
};


export type QueryAccountsCountArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  contractStatuses?: InputMaybe<Array<InputMaybe<ContractStatusType>>>;
  currencies?: InputMaybe<Array<InputMaybe<Currency>>>;
  entityType?: InputMaybe<UboType>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  excludeVirtual?: InputMaybe<Scalars['Boolean']['input']>;
  fundsType?: InputMaybe<FundsType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  isPendingDeactivation?: InputMaybe<Scalars['Boolean']['input']>;
  isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
  notStatuses?: InputMaybe<Array<InputMaybe<AccountStatus>>>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  qrrSupported?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<AccountStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<AccountType>>>;
};


export type QueryActionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActionSignatureRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActionSignatureRequestsArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};


export type QueryActionSignatureRequestsCountArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};


export type QueryActionsArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeAllUsers?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ActionStatus>;
  statuses?: InputMaybe<Array<InputMaybe<ActionStatus>>>;
  types?: InputMaybe<Array<InputMaybe<ActionType>>>;
};


export type QueryActionsCountArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeAllUsers?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActionStatus>;
  statuses?: InputMaybe<Array<InputMaybe<ActionStatus>>>;
  types?: InputMaybe<Array<InputMaybe<ActionType>>>;
};


export type QueryActionsForMobile2FaArgs = {
  challenge?: InputMaybe<Scalars['String']['input']>;
};


export type QueryActivityLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActivityLogsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  company?: InputMaybe<Company>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Country>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  excludePinned?: InputMaybe<Scalars['Boolean']['input']>;
  feeGroupId?: InputMaybe<Scalars['ID']['input']>;
  includeNullClientId?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerId?: InputMaybe<Scalars['ID']['input']>;
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyPinned?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  origins?: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  standingOrderId?: InputMaybe<Scalars['ID']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ActivityLogTypeType>;
  types?: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryActivityLogsCountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  company?: InputMaybe<Company>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Country>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  excludePinned?: InputMaybe<Scalars['Boolean']['input']>;
  feeGroupId?: InputMaybe<Scalars['ID']['input']>;
  ignoreCache?: InputMaybe<Scalars['Boolean']['input']>;
  includeNullClientId?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerId?: InputMaybe<Scalars['ID']['input']>;
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  onlyPinned?: InputMaybe<Scalars['Boolean']['input']>;
  origins?: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  standingOrderId?: InputMaybe<Scalars['ID']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ActivityLogTypeType>;
  types?: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryApiUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApiUsersArgs = {
  contractId: Scalars['ID']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  statuses?: InputMaybe<Array<InputMaybe<ApiUserStatus>>>;
};


export type QueryApiUsersCountArgs = {
  contractId: Scalars['ID']['input'];
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ApiUserStatus>>>;
};


export type QueryApprovalRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApprovalRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  statuses?: InputMaybe<Array<InputMaybe<ApprovalRequestStatus>>>;
};


export type QueryApprovalRequestsCountArgs = {
  statuses?: InputMaybe<Array<InputMaybe<ApprovalRequestStatus>>>;
};


export type QueryArticleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryArticlesArgs = {
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  orderBy?: OrderBy;
  orderDirection?: OrderDirection;
};


export type QueryArticlesCountArgs = {
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryBankInfoArgs = {
  iban: Scalars['String']['input'];
};


export type QueryBatchPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBatchPaymentRecordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBatchPaymentRecordsArgs = {
  batchPaymentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryBatchPaymentRecordsCountArgs = {
  batchPaymentId: Scalars['ID']['input'];
};


export type QueryBatchPaymentsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryBatchPaymentsCountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCardIssueRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCardTransactionClearingWorkerLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCardTransactionClearingWorkerLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  submittedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCardTransactionClearingWorkerLogsCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  submittedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCardsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notStatuses?: InputMaybe<Array<InputMaybe<CardStatuses>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CardsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<CardStatuses>>>;
  type?: InputMaybe<ApiCardTypes>;
};


export type QueryCardsAllowedLimitsAndMaxesArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Currency>;
};


export type QueryCardsCountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  notStatuses?: InputMaybe<Array<InputMaybe<CardStatuses>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<CardStatuses>>>;
  type?: InputMaybe<ApiCardTypes>;
};


export type QueryCheckResultArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCheckResultsArgs = {
  checkIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  checkKeys?: InputMaybe<Array<InputMaybe<CheckKey>>>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  legalEntityId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notCheckKeys?: InputMaybe<Array<InputMaybe<CheckKey>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  walletId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckResultsCountArgs = {
  checkIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  checkKeys?: InputMaybe<Array<InputMaybe<CheckKey>>>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  legalEntityId?: InputMaybe<Scalars['ID']['input']>;
  notCheckKeys?: InputMaybe<Array<InputMaybe<CheckKey>>>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  walletId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChecksArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ChecksOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  type?: InputMaybe<CheckType>;
};


export type QueryChecksCountArgs = {
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<CheckType>;
};


export type QueryClassificationReportArgs = {
  id: Scalars['String']['input'];
};


export type QueryClassificationsArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  status?: InputMaybe<RiskClassificationStatus>;
};


export type QueryClassificationsCountArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<RiskClassificationStatus>;
};


export type QueryContractArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractAuthorizedPersonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractAuthorizedPersonsArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  contractStatuses?: InputMaybe<Array<InputMaybe<ContractStatusType>>>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  isPendingDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notContractStatuses?: InputMaybe<Array<InputMaybe<ContractStatusType>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContractAuthPersonOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  role?: InputMaybe<AuthorizedPersonRights>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<AuthorizedPersonStatuses>>>;
};


export type QueryContractAuthorizedPersonsCountArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  contractStatuses?: InputMaybe<Array<InputMaybe<ContractStatusType>>>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  isPendingDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  notContractStatuses?: InputMaybe<Array<InputMaybe<ContractStatusType>>>;
  role?: InputMaybe<AuthorizedPersonRights>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<AuthorizedPersonStatuses>>>;
};


export type QueryContractCardArgs = {
  contractId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type QueryContractCardsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  notStatuses?: InputMaybe<Array<InputMaybe<CardStatuses>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CardsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<CardStatuses>>>;
  type?: InputMaybe<ApiCardTypes>;
};


export type QueryContractCardsCountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId: Scalars['ID']['input'];
  notStatuses?: InputMaybe<Array<InputMaybe<CardStatuses>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<CardStatuses>>>;
  type?: InputMaybe<ApiCardTypes>;
};


export type QueryContractContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractContactsArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<ContractContactType>>>;
};


export type QueryContractContactsCountArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<ContractContactType>>>;
};


export type QueryContractDailyVolumeDataArgs = {
  contractId: Scalars['ID']['input'];
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
};


export type QueryContractGroupsArgs = {
  hasNoContract?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContractGroupsCountArgs = {
  hasNoContract?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContractInformationRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractInformationRequestsArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  documentType?: InputMaybe<DocumentType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  status?: InputMaybe<ContractInformationRequestStatus>;
  statuses?: InputMaybe<Array<InputMaybe<ContractInformationRequestStatus>>>;
  type?: InputMaybe<ContractInformationRequestType>;
};


export type QueryContractInformationRequestsCountArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  documentType?: InputMaybe<DocumentType>;
  status?: InputMaybe<ContractInformationRequestStatus>;
  statuses?: InputMaybe<Array<InputMaybe<ContractInformationRequestStatus>>>;
  type?: InputMaybe<ContractInformationRequestType>;
};


export type QueryContractPaymentApprovalRatesDataArgs = {
  contractId: Scalars['ID']['input'];
};


export type QueryContractPaymentRecipientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractPaymentRecipientsArgs = {
  contractId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContractPaymentRecipientOrderByType>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContractPaymentRecipientsCountArgs = {
  contractId: Scalars['ID']['input'];
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContractPaymentTopRejectionReasonsDataArgs = {
  contractId: Scalars['ID']['input'];
};


export type QueryContractPeriodicReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractPeriodicReviewsArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryContractPeriodicReviewsCountArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContractProfileChangesArgs = {
  contractId: Scalars['ID']['input'];
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<ProfileChangeStatus>>>;
};


export type QueryContractProfileChangesCountArgs = {
  contractId: Scalars['ID']['input'];
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<ProfileChangeStatus>>>;
};


export type QueryContractTransactionsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  batchId?: InputMaybe<Scalars['ID']['input']>;
  cardFilter?: InputMaybe<TransactionCardFilter>;
  cardId?: InputMaybe<Scalars['ID']['input']>;
  clientReference?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  cumulativeReviewStatuses?: InputMaybe<Array<InputMaybe<TransactionCumulativeReviewStatus>>>;
  currencies?: InputMaybe<Array<InputMaybe<Currency>>>;
  entryTypes?: InputMaybe<Array<InputMaybe<TransactionEntryType>>>;
  executedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  executedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  hasSar?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupportingDocument?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeSubAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  internalTransferType?: InputMaybe<InternalTransferType>;
  isReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notContractIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notInternalTransferTypes?: InputMaybe<Array<InputMaybe<InternalTransferType>>>;
  notStatuses?: InputMaybe<Array<InputMaybe<TransactionStatus>>>;
  notTypes?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  paymentRails?: InputMaybe<Array<InputMaybe<PaymentRail>>>;
  payoutCurrencies?: InputMaybe<Array<InputMaybe<Currency>>>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  pendingPostReview?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<TransactionStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  valueFrom?: InputMaybe<Scalars['Float']['input']>;
  valueTo?: InputMaybe<Scalars['Float']['input']>;
  walletId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContractTransactionsCountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  batchId?: InputMaybe<Scalars['ID']['input']>;
  cardFilter?: InputMaybe<TransactionCardFilter>;
  cardId?: InputMaybe<Scalars['ID']['input']>;
  clientReference?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  cumulativeReviewStatuses?: InputMaybe<Array<InputMaybe<TransactionCumulativeReviewStatus>>>;
  currencies?: InputMaybe<Array<InputMaybe<Currency>>>;
  entryTypes?: InputMaybe<Array<InputMaybe<TransactionEntryType>>>;
  executedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  executedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  hasSar?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupportingDocument?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeSubAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  internalTransferType?: InputMaybe<InternalTransferType>;
  isReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  notContractIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notInternalTransferTypes?: InputMaybe<Array<InputMaybe<InternalTransferType>>>;
  notStatuses?: InputMaybe<Array<InputMaybe<TransactionStatus>>>;
  notTypes?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  paymentRails?: InputMaybe<Array<InputMaybe<PaymentRail>>>;
  payoutCurrencies?: InputMaybe<Array<InputMaybe<Currency>>>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  pendingPostReview?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<TransactionStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  valueFrom?: InputMaybe<Scalars['Float']['input']>;
  valueTo?: InputMaybe<Scalars['Float']['input']>;
  walletId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContractsArgs = {
  activatedOnRange?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  businessSectors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communicationStatuses?: InputMaybe<Array<InputMaybe<CommunicationStatus>>>;
  contractIndividualId?: InputMaybe<Scalars['ID']['input']>;
  countries?: InputMaybe<Array<InputMaybe<Country>>>;
  createdAtRange?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  dedicatedAcm?: InputMaybe<Scalars['ID']['input']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hasPerpetualSuccessFeePeriod?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfessionalTreasuryDepartment?: InputMaybe<Scalars['Boolean']['input']>;
  hasSar?: InputMaybe<Scalars['Boolean']['input']>;
  houseOwned?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  isDueForReview?: InputMaybe<Scalars['Boolean']['input']>;
  isKey?: InputMaybe<Scalars['Boolean']['input']>;
  isSubjectToPrudentialRegulation?: InputMaybe<Scalars['Boolean']['input']>;
  keyContractFirst?: InputMaybe<Scalars['Boolean']['input']>;
  legalEntityId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notStatuses?: InputMaybe<Array<InputMaybe<ContractStatusType>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyActivated?: InputMaybe<Scalars['Boolean']['input']>;
  onlyNonActivated?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<ContractsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  salvStatuses?: InputMaybe<Array<InputMaybe<SalvStatus>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ContractStatusType>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<ContractType>>>;
};


export type QueryContractsCountArgs = {
  activatedOnRange?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  businessSectors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communicationStatuses?: InputMaybe<Array<InputMaybe<CommunicationStatus>>>;
  contractIndividualId?: InputMaybe<Scalars['ID']['input']>;
  countries?: InputMaybe<Array<InputMaybe<Country>>>;
  createdAtRange?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  dedicatedAcm?: InputMaybe<Scalars['ID']['input']>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hasPerpetualSuccessFeePeriod?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfessionalTreasuryDepartment?: InputMaybe<Scalars['Boolean']['input']>;
  hasSar?: InputMaybe<Scalars['Boolean']['input']>;
  houseOwned?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  isDueForReview?: InputMaybe<Scalars['Boolean']['input']>;
  isKey?: InputMaybe<Scalars['Boolean']['input']>;
  isSubjectToPrudentialRegulation?: InputMaybe<Scalars['Boolean']['input']>;
  legalEntityId?: InputMaybe<Scalars['ID']['input']>;
  notStatuses?: InputMaybe<Array<InputMaybe<ContractStatusType>>>;
  onlyActivated?: InputMaybe<Scalars['Boolean']['input']>;
  onlyNonActivated?: InputMaybe<Scalars['Boolean']['input']>;
  salvStatuses?: InputMaybe<Array<InputMaybe<SalvStatus>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ContractStatusType>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<ContractType>>>;
};


export type QueryCryptoRateArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  amount: Scalars['Float']['input'];
  fromCurrency: AllCurrencies;
  network: SupportedCryptoNetwork;
  toCurrency: AllCurrencies;
  transferType?: InputMaybe<WalletTransferType>;
  walletId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDeviceInformationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDevicesInformationArgs = {
  individualId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDevicesInformationCountArgs = {
  individualId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDirectDebitDisputesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  status?: InputMaybe<DirectDebitDisputeStatus>;
};


export type QueryDirectDebitDisputesCountArgs = {
  status?: InputMaybe<DirectDebitDisputeStatus>;
};


export type QueryDirectDebitExecutionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDirectDebitExecutionsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  batchId?: InputMaybe<Scalars['ID']['input']>;
  directDebitMandateId?: InputMaybe<Scalars['ID']['input']>;
  executionDateFrom?: InputMaybe<Scalars['Date']['input']>;
  executionDateTo?: InputMaybe<Scalars['Date']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  status?: InputMaybe<DirectDebitExecutionStatus>;
  statuses?: InputMaybe<Array<InputMaybe<DirectDebitExecutionStatus>>>;
  type?: InputMaybe<TransactionEntryType>;
};


export type QueryDirectDebitExecutionsCountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  batchId?: InputMaybe<Scalars['ID']['input']>;
  directDebitMandateId?: InputMaybe<Scalars['ID']['input']>;
  executionDateFrom?: InputMaybe<Scalars['Date']['input']>;
  executionDateTo?: InputMaybe<Scalars['Date']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status?: InputMaybe<DirectDebitExecutionStatus>;
  statuses?: InputMaybe<Array<InputMaybe<DirectDebitExecutionStatus>>>;
  type?: InputMaybe<TransactionEntryType>;
};


export type QueryDirectDebitMandateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDirectDebitMandatesArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  status?: InputMaybe<Array<InputMaybe<DirectDebitMandateStatus>>>;
  type?: InputMaybe<TransactionEntryType>;
};


export type QueryDirectDebitMandatesCountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Array<InputMaybe<DirectDebitMandateStatus>>>;
  type?: InputMaybe<TransactionEntryType>;
};


export type QueryDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDocumentsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['Int']['input']>;
  contractStatuses?: InputMaybe<Array<InputMaybe<ContractStatusType>>>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  expirationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  expirationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['Int']['input']>;
  isExpAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyFromSystem?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<DocumentOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  origin?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  profileChangeId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  standingOrderId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<DocumentStatus>;
  statuses?: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  transactionRequestId?: InputMaybe<Scalars['ID']['input']>;
  types?: InputMaybe<Array<InputMaybe<DocumentType>>>;
  userFilter?: InputMaybe<DocumentUserFilter>;
  walletId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDocumentsCountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['Int']['input']>;
  contractStatuses?: InputMaybe<Array<InputMaybe<ContractStatusType>>>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  expirationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  expirationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['Int']['input']>;
  isExpAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  onlyFromSystem?: InputMaybe<Scalars['Boolean']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  profileChangeId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  standingOrderId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<DocumentStatus>;
  statuses?: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  transactionRequestId?: InputMaybe<Scalars['ID']['input']>;
  types?: InputMaybe<Array<InputMaybe<DocumentType>>>;
  userFilter?: InputMaybe<DocumentUserFilter>;
  walletId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEntityReminderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEntityRemindersArgs = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  isDone?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EntityReminderOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryEntityRemindersCountArgs = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  isDone?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFeeDetailsArgs = {
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  feeCode?: InputMaybe<Scalars['String']['input']>;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FeeDetailsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFeeDetailsCountArgs = {
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  feeCode?: InputMaybe<Scalars['String']['input']>;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFeeGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFeeSettingsForGroupArgs = {
  groupId: Scalars['ID']['input'];
  status?: InputMaybe<FeeGroupFeeStatus>;
};


export type QueryFeesForContractArgs = {
  contractId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  typeCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFeesForGroupArgs = {
  groupId: Scalars['ID']['input'];
};


export type QueryGetAutomatedFormAArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  ownedUboId?: InputMaybe<Scalars['ID']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  uboId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetCardSensitiveInfoArgs = {
  cardId: Scalars['ID']['input'];
  challengeId: Scalars['String']['input'];
  code: Scalars['Int']['input'];
};


export type QueryGetCardSensitiveInfoV2Args = {
  cardId: Scalars['ID']['input'];
  challengeId: Scalars['String']['input'];
  code: Scalars['Int']['input'];
};


export type QueryGetCardTransactionAuthorizationsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  cardId?: InputMaybe<Scalars['ID']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryGetCardTransactionAuthorizationsCountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  cardId?: InputMaybe<Scalars['ID']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetContractRelatedIndividualsArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  onlyAuthPersons?: InputMaybe<Scalars['Boolean']['input']>;
  onlyUBOs?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetContractTechnicalPropertiesArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetContractUboArgs = {
  contractUboId: Scalars['ID']['input'];
};


export type QueryGetContractUboByUboIdArgs = {
  contractId: Scalars['ID']['input'];
  uboId: Scalars['ID']['input'];
};


export type QueryGetEncrypted3DsPasswordArgs = {
  cardId: Scalars['ID']['input'];
  challengeId: Scalars['String']['input'];
  code: Scalars['Int']['input'];
};


export type QueryGetEncrypted3DsPasswordV2Args = {
  cardId: Scalars['ID']['input'];
  challengeId: Scalars['String']['input'];
  code: Scalars['Int']['input'];
};


export type QueryGetExternalTransferFxCurrenciesArgs = {
  fromCurrency?: InputMaybe<Currency>;
};


export type QueryGetLegalEntityDirectorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLegalEntityDirectorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryGetReservedFxRateArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  forLocalPay?: InputMaybe<Scalars['Boolean']['input']>;
  forTldr?: InputMaybe<Scalars['Boolean']['input']>;
  from: Currency;
  to: Currency;
};


export type QueryGetStaticFxRatesArgs = {
  from: Currency;
};


export type QueryGetTransactionConfirmationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUboArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUboOwnersArgs = {
  uboId: Scalars['ID']['input'];
};


export type QueryGetUbosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<UboType>;
};


export type QueryGuaranteeEventArgs = {
  id: Scalars['String']['input'];
};


export type QueryGuaranteeEventsArgs = {
  accountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyNewGuarantee?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGuaranteeEventsCountArgs = {
  accountId: Scalars['String']['input'];
  onlyNewGuarantee?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGuaranteedWithdrawalWithinLimitsArgs = {
  accountId: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
};


export type QueryIbanCertificateArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryIndividualArgs = {
  id: Scalars['Int']['input'];
};


export type QueryIndividualEmailCategoryPreferencesArgs = {
  emailCategoryId?: InputMaybe<Scalars['ID']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IndividualEmailCategoryPreferenceOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryIndividualEmailCategoryPreferencesCountArgs = {
  emailCategoryId?: InputMaybe<Scalars['ID']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIndividualSmsCategoryPreferencesArgs = {
  individualId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IndividualSmsCategoryPreferenceOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  smsCategoryId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIndividualSmsCategoryPreferencesCountArgs = {
  individualId?: InputMaybe<Scalars['ID']['input']>;
  smsCategoryId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIndividualsArgs = {
  companies?: InputMaybe<Array<InputMaybe<Company>>>;
  countries?: InputMaybe<Array<InputMaybe<Country>>>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nationalities?: InputMaybe<Array<InputMaybe<Nationality>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClientsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationMedia?: InputMaybe<Array<InputMaybe<VerificationMedium>>>;
  verifiedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryIndividualsCountArgs = {
  companies?: InputMaybe<Array<InputMaybe<Company>>>;
  countries?: InputMaybe<Array<InputMaybe<Country>>>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  nationalities?: InputMaybe<Array<InputMaybe<Nationality>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationMedia?: InputMaybe<Array<InputMaybe<VerificationMedium>>>;
  verifiedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInternationalRemittanceBanksArgs = {
  countryCode: Country;
};


export type QueryInternationalRemittanceWalletsArgs = {
  countryCode: Country;
};


export type QueryIsProductTermsSignedOrPendingArgs = {
  contractId: Scalars['ID']['input'];
  productKey: Scalars['String']['input'];
};


export type QueryLedgerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLedgerTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLedgerTransactionsArgs = {
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  entryTypes?: InputMaybe<Array<InputMaybe<TransactionEntryType>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ledgerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  legsId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LedgerTransactionOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<LedgerTransactionStatus>>>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  types?: InputMaybe<Array<InputMaybe<LedgerTransactionType>>>;
  valueFrom?: InputMaybe<Scalars['Float']['input']>;
  valueTo?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryLedgerTransactionsCountArgs = {
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  entryTypes?: InputMaybe<Array<InputMaybe<TransactionEntryType>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ledgerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  legsId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<LedgerTransactionStatus>>>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  types?: InputMaybe<Array<InputMaybe<LedgerTransactionType>>>;
  valueFrom?: InputMaybe<Scalars['Float']['input']>;
  valueTo?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryLedgersArgs = {
  currencies?: InputMaybe<Array<InputMaybe<AllCurrencies>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notTypes?: InputMaybe<Array<InputMaybe<LedgerType>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<LedgerType>>>;
};


export type QueryLedgersCountArgs = {
  currencies?: InputMaybe<Array<InputMaybe<AllCurrencies>>>;
  notTypes?: InputMaybe<Array<InputMaybe<LedgerType>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<LedgerType>>>;
};


export type QueryLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryMonitoringAlertArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMonitoringAlertsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  legalEntityId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  priorities?: InputMaybe<Array<InputMaybe<MonitoringAlertPriority>>>;
  sanctionType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scenarios?: InputMaybe<Array<InputMaybe<MonitoringAlertScenario>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMonitoringAlertsCountArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  legalEntityId?: InputMaybe<Scalars['ID']['input']>;
  priorities?: InputMaybe<Array<InputMaybe<MonitoringAlertPriority>>>;
  sanctionType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scenarios?: InputMaybe<Array<InputMaybe<MonitoringAlertScenario>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNoteArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryNoticesArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isValidNow?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NoticesOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryNoticesCountArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isValidNow?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOutboundPaymentCapabilitiesArgs = {
  accountId: Scalars['ID']['input'];
  destinationCountry: Country;
  payoutCurrency: AllCurrencies;
};


export type QueryPaymentArgs = {
  id: Scalars['String']['input'];
};


export type QueryPaymentRailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentRailConfigsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  orderBy?: OrderBy;
  orderDirection?: OrderDirection;
  provider?: InputMaybe<Scalars['String']['input']>;
  rail?: InputMaybe<Scalars['String']['input']>;
  supportsFx?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaymentRailConfigsCountArgs = {
  provider?: InputMaybe<Scalars['String']['input']>;
  rail?: InputMaybe<Scalars['String']['input']>;
  supportsFx?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaymentRailRouteConfigArgs = {
  baseCurrency: NewAccountCurrency;
  paymentRailConfigId: Scalars['ID']['input'];
  payoutCurrency: Currency;
};


export type QueryPaymentRailRouteConfigsArgs = {
  baseCurrency?: InputMaybe<NewAccountCurrency>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  orderBy?: InputMaybe<PaymentRailConfigOrderBy>;
  orderDirection?: OrderDirection;
  paymentRailConfigId?: InputMaybe<Scalars['ID']['input']>;
  payoutCurrency?: InputMaybe<Currency>;
  search?: InputMaybe<Scalars['String']['input']>;
  supportsInstant?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaymentRailRouteConfigsCountArgs = {
  baseCurrency?: InputMaybe<NewAccountCurrency>;
  paymentRailConfigId?: InputMaybe<Scalars['ID']['input']>;
  payoutCurrency?: InputMaybe<Currency>;
  search?: InputMaybe<Scalars['String']['input']>;
  supportsInstant?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaymentRailRouteConfiguredPayoutCurrenciesArgs = {
  baseCurrency: NewAccountCurrency;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaymentRoutesDistributionTallyArgs = {
  baseCurrency: NewAccountCurrency;
  fromDate: Scalars['Date']['input'];
  payoutCurrency: Currency;
  toDate: Scalars['Date']['input'];
};


export type QueryPaymentsArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  methods?: InputMaybe<Array<InputMaybe<PaymentMethod>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PaymentsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<PaymentStatus>>>;
};


export type QueryPaymentsCountArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  methods?: InputMaybe<Array<InputMaybe<PaymentMethod>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<PaymentStatus>>>;
};


export type QueryPermissionArgs = {
  id: Scalars['String']['input'];
};


export type QueryPermissionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryPhoneVerificationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPhoneVerificationsArgs = {
  clientId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryPreAssessmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  status?: InputMaybe<PreAssessmentStatus>;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryProfileChangeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfileChangesArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<ProfileChangeStatus>>>;
  type?: InputMaybe<ProfileChangeType>;
};


export type QueryProfileChangesCountArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<ProfileChangeStatus>>>;
  type?: InputMaybe<ProfileChangeType>;
};


export type QueryRecapitulationReportsCryptoArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryRiskLevelsReportArgs = {
  id: Scalars['String']['input'];
};


export type QueryRoleArgs = {
  id: Scalars['String']['input'];
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRolesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QuerySpendingLimitRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStandingOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySuccessFeeArgs = {
  id: Scalars['String']['input'];
};


export type QuerySuccessFeePayoutArgs = {
  id: Scalars['String']['input'];
};


export type QuerySuccessFeePayoutsArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SuccessFeePayoutOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  statuses?: InputMaybe<Array<InputMaybe<SuccessFeePayoutStatus>>>;
};


export type QuerySuccessFeePayoutsCountArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySuccessFeesArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SuccessFeeOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  referringContractId?: InputMaybe<Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<SuccessFeeStatus>>>;
  successFeePayoutId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySuccessFeesCountArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  referringContractId?: InputMaybe<Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<SuccessFeeStatus>>>;
  successFeePayoutId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySwiftConversationsArgs = {
  ackStatus?: InputMaybe<SwiftMessageAckStatus>;
  hasServiceDeskRequest?: InputMaybe<Scalars['Boolean']['input']>;
  lastMessageOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwiftConversationOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceDeskRequestStatus?: InputMaybe<Scalars['String']['input']>;
  serviceDeskRequestStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  swiftMessageId?: InputMaybe<Scalars['String']['input']>;
  swiftMessageStatus?: InputMaybe<SwiftMessageStatus>;
  swiftMessageStatuses?: InputMaybe<Array<InputMaybe<SwiftMessageStatus>>>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySwiftConversationsCountArgs = {
  ackStatus?: InputMaybe<SwiftMessageAckStatus>;
  hasServiceDeskRequest?: InputMaybe<Scalars['Boolean']['input']>;
  lastMessageOnly?: InputMaybe<Scalars['Boolean']['input']>;
  pendingFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceDeskRequestStatus?: InputMaybe<Scalars['String']['input']>;
  serviceDeskRequestStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  swiftMessageId?: InputMaybe<Scalars['String']['input']>;
  swiftMessageStatus?: InputMaybe<SwiftMessageStatus>;
  swiftMessageStatuses?: InputMaybe<Array<InputMaybe<SwiftMessageStatus>>>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySwiftMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySwiftMessageFileLogArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySwiftMessageFileLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwiftMessageFileLogsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySwiftMessageFileLogsCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySwiftMessageTransactionInfoArgs = {
  swiftConversationThreadId: Scalars['String']['input'];
  transactionId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySwiftMessagesArgs = {
  createDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  directions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  messageFormat?: InputMaybe<Scalars['String']['input']>;
  messageIdentifier?: InputMaybe<Scalars['String']['input']>;
  messageType?: InputMaybe<Scalars['String']['input']>;
  messageTypeIdentifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notMessageTypeIdentifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwiftMessagesOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySwiftMessagesCountArgs = {
  createDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  directions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  messageFormat?: InputMaybe<Scalars['String']['input']>;
  messageIdentifier?: InputMaybe<Scalars['String']['input']>;
  messageType?: InputMaybe<Scalars['String']['input']>;
  messageTypeIdentifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notMessageTypeIdentifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTagArgs = {
  name: Scalars['String']['input'];
};


export type QueryTagsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TagsOrderByType>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTagsCountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTermsAndConditionArgs = {
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryTermsAndConditionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransactionClaimsRecallRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransactionClaimsRecallRequestsArgs = {
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ClaimsRecallRequestsStatus>>>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  types?: InputMaybe<Array<InputMaybe<ClaimsRecallRequestsType>>>;
};


export type QueryTransactionClaimsRecallRequestsCountArgs = {
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ClaimsRecallRequestsStatus>>>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  types?: InputMaybe<Array<InputMaybe<ClaimsRecallRequestsType>>>;
};


export type QueryTransactionGpiStatusArgs = {
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  uetr?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTransactionRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransactionRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  status?: InputMaybe<Array<InputMaybe<TransactionRequestStatus>>>;
};


export type QueryTransactionRequestsCountArgs = {
  status?: InputMaybe<Array<InputMaybe<TransactionRequestStatus>>>;
};


export type QueryTransactionTrackingInfoArgs = {
  transactionId: Scalars['ID']['input'];
};


export type QueryTransactionsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  batchId?: InputMaybe<Scalars['ID']['input']>;
  cardFilter?: InputMaybe<TransactionCardFilter>;
  cardId?: InputMaybe<Scalars['ID']['input']>;
  clientReference?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  cumulativeReviewStatuses?: InputMaybe<Array<InputMaybe<TransactionCumulativeReviewStatus>>>;
  currencies?: InputMaybe<Array<InputMaybe<Currency>>>;
  entryTypes?: InputMaybe<Array<InputMaybe<TransactionEntryType>>>;
  executedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  executedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  hasSar?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupportingDocument?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeSubAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  internalTransferType?: InputMaybe<InternalTransferType>;
  isReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notContractIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notInternalTransferTypes?: InputMaybe<Array<InputMaybe<InternalTransferType>>>;
  notStatuses?: InputMaybe<Array<InputMaybe<TransactionStatus>>>;
  notTypes?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  paymentRails?: InputMaybe<Array<InputMaybe<PaymentRail>>>;
  payoutCurrencies?: InputMaybe<Array<InputMaybe<Currency>>>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  pendingPostReview?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<TransactionStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  valueFrom?: InputMaybe<Scalars['Float']['input']>;
  valueTo?: InputMaybe<Scalars['Float']['input']>;
  walletId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTransactionsCountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  batchId?: InputMaybe<Scalars['ID']['input']>;
  cardFilter?: InputMaybe<TransactionCardFilter>;
  cardId?: InputMaybe<Scalars['ID']['input']>;
  clientReference?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  cumulativeReviewStatuses?: InputMaybe<Array<InputMaybe<TransactionCumulativeReviewStatus>>>;
  currencies?: InputMaybe<Array<InputMaybe<Currency>>>;
  entryTypes?: InputMaybe<Array<InputMaybe<TransactionEntryType>>>;
  executedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  executedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  hasSar?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupportingDocument?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeSubAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  internalTransferType?: InputMaybe<InternalTransferType>;
  isReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  notContractIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notInternalTransferTypes?: InputMaybe<Array<InputMaybe<InternalTransferType>>>;
  notStatuses?: InputMaybe<Array<InputMaybe<TransactionStatus>>>;
  notTypes?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  paymentRails?: InputMaybe<Array<InputMaybe<PaymentRail>>>;
  payoutCurrencies?: InputMaybe<Array<InputMaybe<Currency>>>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  pendingPostReview?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<TransactionStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  valueFrom?: InputMaybe<Scalars['Float']['input']>;
  valueTo?: InputMaybe<Scalars['Float']['input']>;
  walletId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUnreadDocumentsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['Int']['input']>;
  contractStatuses?: InputMaybe<Array<InputMaybe<ContractStatusType>>>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  expirationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  expirationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['Int']['input']>;
  isExpAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyFromSystem?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  origin?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  profileChangeId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  standingOrderId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<DocumentStatus>;
  statuses?: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  transactionRequestId?: InputMaybe<Scalars['ID']['input']>;
  types?: InputMaybe<Array<InputMaybe<DocumentType>>>;
  userFilter?: InputMaybe<DocumentUserFilter>;
  walletId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUnreadDocumentsCountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['Int']['input']>;
  contractStatuses?: InputMaybe<Array<InputMaybe<ContractStatusType>>>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  expirationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  expirationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['Int']['input']>;
  isExpAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  onlyFromSystem?: InputMaybe<Scalars['Boolean']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  profileChangeId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  standingOrderId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<DocumentStatus>;
  statuses?: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  transactionRequestId?: InputMaybe<Scalars['ID']['input']>;
  types?: InputMaybe<Array<InputMaybe<DocumentType>>>;
  userFilter?: InputMaybe<DocumentUserFilter>;
  walletId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUsersArgs = {
  companies?: InputMaybe<Array<InputMaybe<Company>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsersCountArgs = {
  companies?: InputMaybe<Array<InputMaybe<Company>>>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateInternationalRemittanceBeneficiaryDetailsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  beneficiaryCountry: Country;
  beneficiaryMsisdn?: InputMaybe<Scalars['String']['input']>;
  beneficiaryName: Scalars['String']['input'];
  pan?: InputMaybe<Scalars['String']['input']>;
  paymentMode: Scalars['String']['input'];
};


export type QueryVibanNameMismatchesArgs = {
  contractId: Scalars['ID']['input'];
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<VibanNameMismatchResolution>>>;
};


export type QueryVibanNameMismatchesCountArgs = {
  contractId: Scalars['ID']['input'];
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<VibanNameMismatchResolution>>>;
};


export type QueryViewPinArgs = {
  cardId: Scalars['ID']['input'];
  challengeId: Scalars['String']['input'];
  code: Scalars['Int']['input'];
};


export type QueryViewerArgs = {
  applyPendingChanges?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWalletArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWalletTransactionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  status?: InputMaybe<Array<InputMaybe<TransactionRequestStatus>>>;
  walletId: Scalars['String']['input'];
};


export type QueryWalletTransactionsCountArgs = {
  status?: InputMaybe<Array<InputMaybe<TransactionRequestStatus>>>;
  walletId: Scalars['String']['input'];
};


export type QueryWalletsArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  contractIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  includeDisconnected?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  network?: InputMaybe<SupportedCryptoNetwork>;
  notContractId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  statuses?: InputMaybe<Array<InputMaybe<WalletStatus>>>;
};


export type QueryWalletsCountArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  contractIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  includeDisconnected?: InputMaybe<Scalars['Boolean']['input']>;
  network?: InputMaybe<SupportedCryptoNetwork>;
  notContractId?: InputMaybe<Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<WalletStatus>>>;
};

export type RailsConfigInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  paymentRail?: InputMaybe<PaymentRail>;
};

/** Raw Swift Message */
export type RawSwiftMessage = {
  __typename?: 'RawSwiftMessage';
  bizMessageIdentifier?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastFailureResult?: Maybe<Scalars['JSON']['output']>;
  ledgerTransactionId?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  messageContentFormat?: Maybe<Scalars['String']['output']>;
  messageCreateDate?: Maybe<Scalars['DateTime']['output']>;
  messageDescription?: Maybe<Scalars['String']['output']>;
  messageFormat?: Maybe<Scalars['String']['output']>;
  messageIdentifier?: Maybe<Scalars['String']['output']>;
  messageType?: Maybe<Scalars['String']['output']>;
  messageTypeIdentifier?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Raw Swift Message File Log */
export type RawSwiftMessageFileLog = {
  __typename?: 'RawSwiftMessageFileLog';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  fileCreationTimeMs?: Maybe<Scalars['Float']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  rawMessage?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RecapitulationReportCrypto = {
  __typename?: 'RecapitulationReportCrypto';
  error?: Maybe<Scalars['JSON']['output']>;
  fileLink?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  runTime?: Maybe<Scalars['DateTime']['output']>;
  submittedBy?: Maybe<User>;
};

export type RefundPayment = {
  __typename?: 'RefundPayment';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  executionAction?: Maybe<Action>;
  externalId?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type RefundPaymentRequestAction = BaseAction & {
  __typename?: 'RefundPaymentRequestAction';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  refundPayment?: Maybe<RefundPayment>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type RefundPaymentRequestActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export enum RelevantCredentialOnFilesBillingSalesMethod {
  CardHolderInitiated = 'cardHolderInitiated',
  Recurring = 'recurring',
  Unscheduled = 'unscheduled'
}

export enum ReportType {
  Crs = 'crs',
  DepositGuaranteed = 'depositGuaranteed',
  Fatca = 'fatca'
}

export type ReservedFxRateDetails = {
  __typename?: 'ReservedFxRateDetails';
  expirationTime: Scalars['DateTime']['output'];
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rate: Scalars['Float']['output'];
  to: Scalars['String']['output'];
};

export enum RiskCalculatorFinancialStatements {
  NotProvided = 'notProvided',
  ProvidedAudited = 'providedAudited',
  ProvidedUnaudited = 'providedUnaudited',
  WillBeProvidedAudited = 'willBeProvidedAudited',
  WillBeProvidedUnaudited = 'willBeProvidedUnaudited'
}

export enum RiskCalculatorProducts {
  CorporateCards = 'corporateCards',
  CryptocurrencyWallets = 'cryptocurrencyWallets',
  IbanCorporateOnly = 'ibanCorporateOnly',
  IbanRetailB2B = 'ibanRetailB2B',
  IbanRetailB2C = 'ibanRetailB2C',
  PaymentProcessing = 'paymentProcessing',
  VirtualIbansB2B = 'virtualIbansB2B',
  VirtualIbansB2C = 'virtualIbansB2C',
  VirtualIbansCorporateOnly = 'virtualIbansCorporateOnly'
}

export type RiskClassification = {
  __typename?: 'RiskClassification';
  classificationBlocks?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  filledInBy?: Maybe<Scalars['String']['output']>;
  finalApprovalLevel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  results?: Maybe<RiskClassificationResultsType>;
  riskLevel?: Maybe<Scalars['String']['output']>;
  status?: Maybe<RiskClassificationStatus>;
  type?: Maybe<RiskClassificationType>;
};

export type RiskClassificationResultsType = {
  __typename?: 'RiskClassificationResultsType';
  hasUhReject?: Maybe<Scalars['Boolean']['output']>;
  hasVeryHigh?: Maybe<Scalars['Boolean']['output']>;
  percentage?: Maybe<RiskClassificationScore>;
  sum?: Maybe<RiskClassificationScore>;
};

export type RiskClassificationReturn = {
  __typename?: 'RiskClassificationReturn';
  classifications?: Maybe<Array<Maybe<RiskClassification>>>;
  count?: Maybe<Scalars['Int']['output']>;
};

export type RiskClassificationScore = {
  __typename?: 'RiskClassificationScore';
  high?: Maybe<Scalars['Float']['output']>;
  low?: Maybe<Scalars['Float']['output']>;
  normal?: Maybe<Scalars['Float']['output']>;
};

export enum RiskClassificationStatus {
  Final = 'final',
  Pending = 'pending',
  Reviewed = 'reviewed'
}

export enum RiskClassificationType {
  Entity = 'entity',
  Individual = 'individual',
  PreAssessmentEntity = 'pre_assessment_entity'
}

export type RiskLevelChanges = {
  __typename?: 'RiskLevelChanges';
  changed?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  same?: Maybe<Scalars['Int']['output']>;
};

export type RiskLevelChangesReturn = {
  __typename?: 'RiskLevelChangesReturn';
  changes?: Maybe<Array<Maybe<RiskLevelChanges>>>;
  count?: Maybe<Scalars['Int']['output']>;
};

export enum RiskProfile {
  ElevatedRisk = 'elevatedRisk',
  IncreasedRisk = 'increasedRisk',
  Normal = 'normal',
  Reduced = 'reduced'
}

/** ACL Roles, with an array of allowed permissions */
export type Role = {
  __typename?: 'Role';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Permissions assigned to this role */
  defaultPermissions?: Maybe<Array<Maybe<Permission>>>;
  /** Description of this role */
  description?: Maybe<Scalars['String']['output']>;
  /** Role ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** Name of role */
  name?: Maybe<Scalars['String']['output']>;
  restrictedTo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** ACL Roles, with an array of allowed permissions */
export type RoleDefaultPermissionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};

/** SMS Category */
export type SmsCategory = {
  __typename?: 'SMSCategory';
  /** Description of SMS category */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Mandatory field */
  mandatory: Scalars['Boolean']['output'];
  /** Name of SMS category */
  name: Scalars['String']['output'];
};

export enum SalvStatus {
  Monitoring = 'monitoring',
  New = 'new',
  None = 'none',
  Reviewed = 'reviewed',
  Suspended = 'suspended',
  SuspendedAndReported = 'suspendedAndReported',
  Terminated = 'terminated',
  TerminatedAndReported = 'terminatedAndReported'
}

export enum SanctionedIndustry {
  AdvancedIct = 'advancedICT',
  AirAndSpace = 'airAndSpace',
  CryptocurrencyAndVirtualAssets = 'cryptocurrencyAndVirtualAssets',
  CulturalHistoricalAndArchaeologicalArtifacts = 'culturalHistoricalAndArchaeologicalArtifacts',
  FinancialInstruments = 'financialInstruments',
  HighSeaNavigation = 'highSeaNavigation',
  IntellectualProperty = 'intellectualProperty',
  LuxuryAndHighValueGoods = 'luxuryAndHighValueGoods',
  Marketing = 'marketing',
  MilitarySecurityAndPoliceRelatedBusinesses = 'militarySecurityAndPoliceRelatedBusinesses',
  NotApplicable = 'notApplicable',
  OilAndEnergy = 'oilAndEnergy',
  WeaponsAndDefense = 'weaponsAndDefense'
}

export type SecondaryEmailInput = {
  /** Secondary Emails: Secondary Email 1 */
  secondaryEmail1?: InputMaybe<Scalars['String']['input']>;
  /** Secondary Emails: Secondary Email 2 */
  secondaryEmail2?: InputMaybe<Scalars['String']['input']>;
  /** Secondary Emails: Secondary Email 3 */
  secondaryEmail3?: InputMaybe<Scalars['String']['input']>;
};

export type SecondaryEmails = {
  __typename?: 'SecondaryEmails';
  /** Secondary Emails: Secondary Email 1 */
  secondaryEmail1?: Maybe<Scalars['String']['output']>;
  /** Secondary Emails: Secondary Email 2 */
  secondaryEmail2?: Maybe<Scalars['String']['output']>;
  /** Secondary Emails: Secondary Email 3 */
  secondaryEmail3?: Maybe<Scalars['String']['output']>;
};

export type SecondaryPhoneInput = {
  /** Secondary Phones: Secondary Phone 1 */
  secondaryPhone1?: InputMaybe<Scalars['String']['input']>;
};

export type SecondaryPhones = {
  __typename?: 'SecondaryPhones';
  /** Secondary Phones: Secondary Phone 1 */
  secondaryPhone1?: Maybe<Scalars['String']['output']>;
};

export type SenderInfoAddress = {
  __typename?: 'SenderInfoAddress';
  /** Currency */
  currency?: Maybe<Currency>;
  /** VBAN */
  vban?: Maybe<Scalars['String']['output']>;
};

export enum SendersType {
  IntermediariesBeneficiaryBanksSwift = 'intermediariesBeneficiaryBanksSwift',
  JpMorgan = 'jpMorgan',
  SecbSnbSwift = 'secbSnbSwift',
  VisaConnectVisaSupport = 'visaConnectVisaSupport',
  VisaDirect = 'visaDirect'
}

export type ServiceDeskRequest = {
  __typename?: 'ServiceDeskRequest';
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  issueId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<TransactionServiceDeskSources>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  transaction?: Maybe<Transaction>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wallet?: Maybe<Wallet>;
};

export enum ServiceDeskRequestType {
  AccountOpening = 'accountOpening',
  Onboarding = 'onboarding',
  PeriodicReview = 'periodicReview',
  RfiRequest = 'rfiRequest',
  SwiftThread = 'swiftThread',
  Transaction = 'transaction',
  Wallet = 'wallet'
}

export type SettlementBalance = {
  __typename?: 'SettlementBalance';
  currency?: Maybe<Currency>;
  locked?: Maybe<Scalars['Float']['output']>;
  settlement?: Maybe<Scalars['Float']['output']>;
};

export enum SeverityType {
  StandardSla = 'standardSla',
  Urgent = 'urgent'
}

export enum SignatoryRight {
  Group = 'group',
  Joint = 'joint',
  Sole = 'sole'
}

export type SignedUrl = {
  __typename?: 'SignedUrl';
  clientId?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  plainUrl?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type SlippaceTolerance = {
  __typename?: 'SlippaceTolerance';
  key?: Maybe<Scalars['Float']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export enum SourceOfFunds {
  BorrowedFunds = 'borrowedFunds',
  BusinessIncome = 'businessIncome',
  Dividends = 'dividends',
  GamblingWinnings = 'gamblingWinnings',
  Gifts = 'gifts',
  Inheritances = 'inheritances',
  InvoicedWork = 'invoicedWork',
  Loans = 'loans',
  LotteryWinnings = 'lotteryWinnings',
  NotOwnDividends = 'notOwnDividends',
  OnlinePlatforms = 'onlinePlatforms',
  Other = 'other',
  OtherInvestmentActivity = 'otherInvestmentActivity',
  RentalIncome = 'rentalIncome',
  RetirementFunds = 'retirementFunds',
  Salary = 'salary',
  SellingPersonalAssets = 'sellingPersonalAssets',
  UboInvestments = 'uboInvestments'
}

export enum SpendingLimitIntervalType {
  Daily = 'daily',
  Monthly = 'monthly',
  Single = 'single'
}

export type SpendingLimitRequestAction = BaseAction & {
  __typename?: 'SpendingLimitRequestAction';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  spendingLimitRequest?: Maybe<SpendingLimitRequestType>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SpendingLimitRequestActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

/** spendingLimitRequestType */
export type SpendingLimitRequestType = {
  __typename?: 'SpendingLimitRequestType';
  /** cardType */
  card?: Maybe<CardType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** actionType */
  executionAction?: Maybe<Action>;
  /** Card ID */
  id: Scalars['ID']['output'];
  /** limits */
  limits?: Maybe<Array<Maybe<LimitObjectType>>>;
  /** limits */
  oldLimits?: Maybe<Array<Maybe<LimitObjectType>>>;
  requestedBy?: Maybe<Individual>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum SpendingLimitStatusType {
  Active = 'active',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** Spending Limit */
export type SpendingLimitType = {
  __typename?: 'SpendingLimitType';
  /** Account */
  account?: Maybe<Account>;
  amount: Scalars['Float']['output'];
  /** Contract */
  contract: BankableEntityContractType;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Currency>;
  /** actionType */
  executionAction?: Maybe<Action>;
  id: Scalars['ID']['output'];
  interval: SpendingLimitIntervalType;
  oldLimit?: Maybe<Scalars['Float']['output']>;
  requestedBy?: Maybe<Individual>;
  status: SpendingLimitStatusType;
  type: SpendingLimitTypeType;
  updatedAt: Scalars['DateTime']['output'];
  usedAmount: Scalars['Float']['output'];
};

export enum SpendingLimitTypeType {
  Sdd = 'sdd',
  SddCredit = 'sddCredit'
}

export type StandingOrder = {
  __typename?: 'StandingOrder';
  account: Account;
  activationAction?: Maybe<Action>;
  active?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  cancellationAction?: Maybe<Action>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cron?: Maybe<Scalars['String']['output']>;
  cronDescription?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lowerThreshold?: Maybe<Scalars['Float']['output']>;
  minRemainingBalance?: Maybe<Scalars['Float']['output']>;
  nextExecutionAt?: Maybe<Scalars['Date']['output']>;
  payoutAmount?: Maybe<Scalars['Float']['output']>;
  payoutCurrency?: Maybe<Currency>;
  runs?: Maybe<Array<StandingOrderRun>>;
  runsCount: Scalars['Int']['output'];
  template?: Maybe<StandingOrderTransactionTemplate>;
};


export type StandingOrderRunsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};

export type StandingOrderActionType = BaseAction & {
  __typename?: 'StandingOrderActionType';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  standingOrder?: Maybe<StandingOrder>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type StandingOrderActionTypeSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export enum StandingOrderPeriodicity {
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export type StandingOrderRun = {
  __typename?: 'StandingOrderRun';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  standingOrder: StandingOrder;
  transaction?: Maybe<Transaction>;
};

export type StandingOrderTransactionTemplate = {
  __typename?: 'StandingOrderTransactionTemplate';
  beneficiary: SwiftTransferIndividualPartyDetails;
  beneficiaryType?: Maybe<SwiftTransferRecipientType>;
  clientReference?: Maybe<Scalars['ID']['output']>;
  comments: Scalars['String']['output'];
  purposeCode?: Maybe<Scalars['String']['output']>;
  purposeCode2?: Maybe<Scalars['String']['output']>;
  useLocalPay?: Maybe<Scalars['Boolean']['output']>;
};

export type StaticFxRate = {
  __typename?: 'StaticFxRate';
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rate: Scalars['Float']['output'];
  to: Scalars['String']['output'];
  ttl?: Maybe<Scalars['Float']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  newFXQuote: FxQuote;
  twoFaMobileProgress: MobileTwoFa;
};


export type SubscriptionNewFxQuoteArgs = {
  contractId: Scalars['ID']['input'];
};


export type SubscriptionTwoFaMobileProgressArgs = {
  challengeId: Scalars['String']['input'];
};

export type SuccessFee = {
  __typename?: 'SuccessFee';
  adjustment?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amountAccountCurrency?: Maybe<Scalars['Float']['output']>;
  applicableBuyRate?: Maybe<Scalars['Float']['output']>;
  buyRateValue?: Maybe<Scalars['Float']['output']>;
  chfRate?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<BankableEntityContractType>;
  contractId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Currency>;
  deductions?: Maybe<Scalars['Float']['output']>;
  feeRevenueChf?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  input?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nonRecoverableRevenue?: Maybe<Scalars['Float']['output']>;
  payout?: Maybe<SuccessFeePayout>;
  percentage?: Maybe<Scalars['Float']['output']>;
  qualifyingRevenue?: Maybe<Scalars['Float']['output']>;
  referringContract?: Maybe<BankableEntityContractType>;
  referringCurrency?: Maybe<Currency>;
  relatedSuccessFee?: Maybe<SuccessFee>;
  relatedSuccessFeeId?: Maybe<Scalars['String']['output']>;
  relatedTransaction?: Maybe<Transaction>;
  relatedTransactionId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<SuccessFeeStatus>;
  value?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
  xRate?: Maybe<Scalars['Float']['output']>;
};

/** Which field to order the query results by */
export enum SuccessFeeOrderBy {
  CreatedAt = 'createdAt',
  ExecutedAt = 'executedAt',
  Id = 'id',
  Status = 'status',
  Value = 'value'
}

export type SuccessFeePayout = {
  __typename?: 'SuccessFeePayout';
  account?: Maybe<Account>;
  contract?: Maybe<BankableEntityContractType>;
  currency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  finalValue?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoiceReference?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SuccessFeePayoutStatus>;
  successFees?: Maybe<Array<Maybe<SuccessFee>>>;
  to?: Maybe<TransactionParty>;
  value?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** Which field to order the query results by */
export enum SuccessFeePayoutOrderBy {
  CreatedAt = 'createdAt',
  ExecutedAt = 'executedAt',
  Id = 'id',
  Status = 'status',
  Value = 'value'
}

export enum SuccessFeePayoutStatus {
  Completed = 'completed',
  Pending = 'pending',
  PendingExecution = 'pendingExecution',
  Rejected = 'rejected'
}

export enum SuccessFeeStatus {
  NotPayable = 'notPayable',
  Paid = 'paid',
  Payable = 'payable',
  Pending = 'pending'
}

export enum SupportedCryptoNetwork {
  Mainnet = 'mainnet',
  Sepolia = 'sepolia'
}

export type SwiftBroadcastStats = {
  __typename?: 'SwiftBroadcastStats';
  totalAllTime?: Maybe<Scalars['Float']['output']>;
  totalPast24H?: Maybe<Scalars['Float']['output']>;
};

export type SwiftConversation = {
  __typename?: 'SwiftConversation';
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  acknowledgedBy?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  from?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  relatedRef?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  swiftMessage?: Maybe<RawSwiftMessage>;
  thread?: Maybe<SwiftConversationThread>;
  threadId?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  transactionRef?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Which field to order the query results by */
export enum SwiftConversationOrderBy {
  AcknowledgedAt = 'acknowledgedAt',
  CreatedAt = 'createdAt',
  Id = 'id'
}

export type SwiftConversationStats = {
  __typename?: 'SwiftConversationStats';
  total?: Maybe<Scalars['Float']['output']>;
  totalPendingAck?: Maybe<Scalars['Float']['output']>;
  totalPendingFollowUp?: Maybe<Scalars['Float']['output']>;
};

export type SwiftConversationThread = {
  __typename?: 'SwiftConversationThread';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  followUp?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notesLastEditedBy?: Maybe<User>;
  serviceDeskRequests?: Maybe<Array<Maybe<ServiceDeskRequest>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SwiftGpiTransactionStatus = {
  __typename?: 'SwiftGpiTransactionStatus';
  initiationDateTime?: Maybe<Scalars['String']['output']>;
  lastUpdateDateTime?: Maybe<Scalars['String']['output']>;
  paymentEvent?: Maybe<Array<Maybe<SwiftGpiTransactionStatusPaymentEvent>>>;
  rejectReturnReason?: Maybe<Scalars['String']['output']>;
  transactionStatus?: Maybe<Scalars['String']['output']>;
  uetr?: Maybe<Scalars['String']['output']>;
};

export type SwiftGpiTransactionStatusPaymentEvent = {
  __typename?: 'SwiftGpiTransactionStatusPaymentEvent';
  amountInconsistency?: Maybe<Scalars['String']['output']>;
  chargeBearer?: Maybe<Scalars['String']['output']>;
  chargesInformation?: Maybe<Array<Maybe<ChargesInformation>>>;
  confirmedAmount?: Maybe<AmountCurrency>;
  confirmedDate?: Maybe<Scalars['String']['output']>;
  creditorAgent?: Maybe<Scalars['String']['output']>;
  debtorAgent?: Maybe<Scalars['String']['output']>;
  from?: Maybe<BicInfo>;
  instructedAmount?: Maybe<AmountCurrency>;
  instructionIdentification?: Maybe<Scalars['String']['output']>;
  interbankSettlementAmount?: Maybe<AmountCurrency>;
  interbankSettlementDate?: Maybe<Scalars['String']['output']>;
  lastUpdateDateTime?: Maybe<Scalars['String']['output']>;
  messageNameIdentification?: Maybe<Scalars['String']['output']>;
  networkReference?: Maybe<Scalars['String']['output']>;
  previouslyConfirmedAmount?: Maybe<AmountCurrency>;
  receivedDateTime?: Maybe<Scalars['String']['output']>;
  remainingToBeConfirmedAmount?: Maybe<AmountCurrency>;
  senderAcknowledgementReceiptDateTime?: Maybe<Scalars['String']['output']>;
  serviceLevel?: Maybe<Scalars['String']['output']>;
  settlementMethod?: Maybe<Scalars['String']['output']>;
  to?: Maybe<BicInfo>;
  trackerEventType?: Maybe<Scalars['String']['output']>;
  transactionStatus?: Maybe<GpiTransactionStatus>;
  transactionStatusDate?: Maybe<Scalars['String']['output']>;
  transactionStatusReason?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export enum SwiftMessageAckStatus {
  Acknowledged = 'acknowledged',
  NotAcknowledged = 'notAcknowledged'
}

/** Which field to order the query results by */
export enum SwiftMessageFileLogsOrderBy {
  CreatedAt = 'createdAt',
  Id = 'id',
  Key = 'key'
}

export type SwiftMessageStats = {
  __typename?: 'SwiftMessageStats';
  broadcastStats?: Maybe<SwiftBroadcastStats>;
  conversationStats?: Maybe<SwiftConversationStats>;
};

export enum SwiftMessageStatus {
  AcceptedByReceiver = 'acceptedByReceiver',
  AutoProcessingFailed = 'autoProcessingFailed',
  CancellationPending = 'cancellationPending',
  CancellationRejected = 'cancellationRejected',
  CancellationRequested = 'cancellationRequested',
  Cancelled = 'cancelled',
  DeliveredToAutoClient = 'deliveredToAutoClient',
  DeliveredToReceiver = 'deliveredToReceiver',
  DeliveryIssues = 'deliveryIssues',
  NetworkAcknowledged = 'networkAcknowledged',
  NetworkRejected = 'networkRejected',
  PendingReview = 'pendingReview',
  PossibleDuplicate = 'possibleDuplicate',
  Processed = 'processed',
  QueuedForEmission = 'queuedForEmission',
  RejectedByAutoClient = 'rejectedByAutoClient',
  RejectedByReceiver = 'rejectedByReceiver',
  ReturnPending = 'returnPending',
  ReturnRejected = 'returnRejected',
  Returned = 'returned',
  SentByAutoClient = 'sentByAutoClient',
  SentToAutoClient = 'sentToAutoClient',
  System = 'system'
}

/** Which field to order the query results by */
export enum SwiftMessagesOrderBy {
  CreatedAt = 'createdAt',
  Direction = 'direction',
  Id = 'id',
  MessageCreateDate = 'messageCreateDate',
  MessageFormat = 'messageFormat',
  MessageIdentifier = 'messageIdentifier',
  MessageType = 'messageType',
  Status = 'status'
}

export enum SwiftTransferChargeBearer {
  Our = 'our',
  Shared = 'shared',
  Theirs = 'theirs'
}

export type SwiftTransferIndividualPartyDetails = {
  __typename?: 'SwiftTransferIndividualPartyDetails';
  accountNo?: Maybe<Scalars['String']['output']>;
  accountNoType?: Maybe<AccountNoType>;
  address: Address;
  bankAddress?: Maybe<Address>;
  bankBic?: Maybe<Scalars['String']['output']>;
  bankBranchId?: Maybe<Scalars['String']['output']>;
  bankBranchName?: Maybe<Scalars['String']['output']>;
  bankClearingMemberId?: Maybe<Scalars['String']['output']>;
  bankCountry?: Maybe<Country>;
  bankName?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  kyc?: Maybe<PaymentTransferRecipientKyc>;
  name: Scalars['String']['output'];
  pan?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  relationshipToSender?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SwiftTransferRecipientType>;
};

export type SwiftTransferIndividualPartyDetailsInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  accountNoType?: InputMaybe<AccountNoType>;
  address: AddressInput;
  bankAddress?: InputMaybe<AddressInput>;
  bankBic?: InputMaybe<Scalars['String']['input']>;
  bankBranchId?: InputMaybe<Scalars['String']['input']>;
  bankBranchName?: InputMaybe<Scalars['String']['input']>;
  bankClearingMemberId?: InputMaybe<Scalars['String']['input']>;
  bankCountry?: InputMaybe<Country>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  kyc?: InputMaybe<PaymentTransferRecipientKycInput>;
  name: Scalars['String']['input'];
  pan?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  relationshipToSender?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SwiftTransferRecipientType>;
};

export type SwiftTransferIndividualPartyDetailsWithCurrencyInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  accountNoType?: InputMaybe<AccountNoType>;
  address: AddressInput;
  bankAddress?: InputMaybe<AddressInput>;
  bankBic?: InputMaybe<Scalars['String']['input']>;
  bankBranchId?: InputMaybe<Scalars['String']['input']>;
  bankBranchName?: InputMaybe<Scalars['String']['input']>;
  bankClearingMemberId?: InputMaybe<Scalars['String']['input']>;
  bankCountry?: InputMaybe<Country>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  iban?: InputMaybe<Scalars['String']['input']>;
  kyc?: InputMaybe<PaymentTransferRecipientKycInput>;
  name: Scalars['String']['input'];
  pan?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  qrrSupported?: InputMaybe<Scalars['Boolean']['input']>;
  relationshipToSender?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SwiftTransferRecipientType>;
};

export enum SwiftTransferRecipientType {
  Company = 'company',
  Individual = 'individual'
}

export type TotpSetupData = {
  __typename?: 'TOTPSetupData';
  /** This is an alternative code */
  alternativeCode: Scalars['String']['output'];
  /** This is an image for QR code */
  qrCode: Scalars['String']['output'];
};

export type Tag = {
  __typename?: 'Tag';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Tag ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** Display Name */
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TagInput = {
  relatedEntityId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: TagType;
};

export enum TagType {
  Account = 'account',
  Contract = 'contract',
  Document = 'document',
  Individual = 'individual',
  Transaction = 'transaction'
}

/** Which field to order the query results by */
export enum TagsOrderByType {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name'
}

export type TermsAndCondition = {
  __typename?: 'TermsAndCondition';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<Product>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['ID']['output']>;
};

export type TermsAndConditionsSigningAction = BaseAction & {
  __typename?: 'TermsAndConditionsSigningAction';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  contractTerm?: Maybe<ContractTerms>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TermsAndConditionsSigningActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export type TerrapayBankType = {
  __typename?: 'TerrapayBankType';
  banks?: Maybe<Array<Maybe<BankType>>>;
  /** Country Code Name */
  countryCode?: Maybe<Scalars['String']['output']>;
  lastUpdatedOn?: Maybe<Scalars['DateTime']['output']>;
};

export type TerrapayWalletType = {
  __typename?: 'TerrapayWalletType';
  /** Country Code Name */
  countryCode?: Maybe<Scalars['String']['output']>;
  wallets?: Maybe<Array<Maybe<WalletType>>>;
};

export type TieredCommissions = {
  __typename?: 'TieredCommissions';
  fifthTier?: Maybe<Scalars['Float']['output']>;
  firstTier?: Maybe<Scalars['Float']['output']>;
  fourthTier?: Maybe<Scalars['Float']['output']>;
  secondTier?: Maybe<Scalars['Float']['output']>;
  thirdTier?: Maybe<Scalars['Float']['output']>;
};

export type TieredCommissionsInput = {
  fifthTier?: InputMaybe<Scalars['Float']['input']>;
  firstTier?: InputMaybe<Scalars['Float']['input']>;
  fourthTier?: InputMaybe<Scalars['Float']['input']>;
  secondTier?: InputMaybe<Scalars['Float']['input']>;
  thirdTier?: InputMaybe<Scalars['Float']['input']>;
};

export type TotalPredictedMonthlyVolumes = {
  __typename?: 'TotalPredictedMonthlyVolumes';
  domestic?: Maybe<Scalars['Float']['output']>;
  eea?: Maybe<Scalars['Float']['output']>;
  nonEea?: Maybe<Scalars['Float']['output']>;
};

export type TotalPredictedMonthlyVolumesInput = {
  domestic?: InputMaybe<Scalars['Float']['input']>;
  eea?: InputMaybe<Scalars['Float']['input']>;
  nonEea?: InputMaybe<Scalars['Float']['input']>;
};

export type Transaction = CreditTransaction | DebitTransaction;

export type TransactionAction = BaseAction & {
  __typename?: 'TransactionAction';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  transaction?: Maybe<Transaction>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TransactionActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export type TransactionAdditionalInfoInput = {
  beneficiaryBankBranchId?: InputMaybe<Scalars['String']['input']>;
  beneficiaryBankBranchName?: InputMaybe<Scalars['String']['input']>;
  beneficiaryBankClearingMemberId?: InputMaybe<Scalars['String']['input']>;
  beneficiaryPhone?: InputMaybe<Scalars['String']['input']>;
  beneficiaryTaxId?: InputMaybe<Scalars['String']['input']>;
  purposeCode?: InputMaybe<Scalars['String']['input']>;
  purposeCode2?: InputMaybe<Scalars['String']['input']>;
};

export enum TransactionCardFilter {
  ExcludeCards = 'excludeCards',
  OnlyCards = 'onlyCards'
}

export type TransactionClaimsRecallRequest = {
  __typename?: 'TransactionClaimsRecallRequest';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  direction?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ledgerTransactionId?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  requestSwiftMessageId?: Maybe<Scalars['String']['output']>;
  responseSwiftMessageId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ClaimsRecallRequestsStatus>;
  transactionId?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<ClaimsRecallRequestsType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum TransactionCumulativeReviewStatus {
  None = 'none',
  Pending = 'pending',
  Reviewed = 'reviewed'
}

export enum TransactionEntryType {
  Credit = 'credit',
  Debit = 'debit'
}

export enum TransactionExecutionType {
  Delayed = 'delayed',
  Instant = 'instant',
  Recurring = 'recurring'
}

export type TransactionInternalFields = {
  __typename?: 'TransactionInternalFields';
  correspondentBankInfo?: Maybe<CorrespondentBankInfo>;
  destinationTransactionId?: Maybe<Scalars['ID']['output']>;
  internalInstruction?: Maybe<Scalars['String']['output']>;
  /** @deprecated Now available on transaction root field */
  isReturn?: Maybe<Scalars['Boolean']['output']>;
  ledgerTransactions?: Maybe<Array<Maybe<LedgerTransaction>>>;
  markedAsRecurring?: Maybe<Scalars['Boolean']['output']>;
  queuedForAMLResolution?: Maybe<Scalars['Boolean']['output']>;
  recallStatus?: Maybe<TransactionRecallStatus>;
  /** @deprecated Now available on transaction root field */
  returnedTransactionId?: Maybe<Scalars['ID']['output']>;
  serviceDeskRequests?: Maybe<Array<Maybe<ServiceDeskRequest>>>;
  sourceTransactionId?: Maybe<Scalars['ID']['output']>;
  transactionRequest?: Maybe<TransactionRequest>;
  unmarkedXRate?: Maybe<Scalars['Float']['output']>;
};

export type TransactionLog = BaseLogInterface & {
  __typename?: 'TransactionLog';
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Transaction linked with ActivityLog */
  objectTransaction?: Maybe<Transaction>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

/** Which field to order the query results by */
export enum TransactionOrderBy {
  CreatedAt = 'createdAt',
  ExecutedAt = 'executedAt',
  Id = 'id',
  Status = 'status',
  Type = 'type',
  Value = 'value'
}

export type TransactionParty = {
  __typename?: 'TransactionParty';
  accountNo?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Address>;
  bankAddress?: Maybe<Address>;
  bankBic?: Maybe<Scalars['String']['output']>;
  bankBranchId?: Maybe<Scalars['String']['output']>;
  bankBranchName?: Maybe<Scalars['String']['output']>;
  bankClearingMemberId?: Maybe<Scalars['String']['output']>;
  bankClearingMemberIdNotation?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  merchantCategoryCode?: Maybe<Scalars['String']['output']>;
  merchantCountry?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SwiftTransferRecipientType>;
  walletAddress?: Maybe<Scalars['String']['output']>;
};

export type TransactionPartyTypesInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressInput>;
  bankAddress?: InputMaybe<AddressInput>;
  bankBic?: InputMaybe<Scalars['String']['input']>;
  bankBranchId?: InputMaybe<Scalars['String']['input']>;
  bankBranchName?: InputMaybe<Scalars['String']['input']>;
  bankClearingMemberId?: InputMaybe<Scalars['String']['input']>;
  bankClearingMemberIdNotation?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  merchantCategoryCode?: InputMaybe<Scalars['String']['input']>;
  merchantCountry?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SwiftTransferRecipientType>;
  walletAddress?: InputMaybe<Scalars['String']['input']>;
};

export enum TransactionPriorityType {
  Express = 'express',
  Standard = 'standard'
}

export enum TransactionRecallStatus {
  Accepted = 'accepted',
  Rejected = 'rejected',
  Requested = 'requested'
}

export type TransactionRequest = {
  __typename?: 'TransactionRequest';
  account?: Maybe<Account>;
  amount?: Maybe<Scalars['Float']['output']>;
  checkResult?: Maybe<CheckResult>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<AllCurrencies>;
  effectiveRate?: Maybe<Scalars['Float']['output']>;
  estimatedAmount?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Not used anymore */
  executionAction?: Maybe<Action>;
  id?: Maybe<Scalars['ID']['output']>;
  slippageTolerance?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<TransactionRequestStatus>;
  trxHash?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  wallet?: Maybe<Wallet>;
};

export enum TransactionRequestStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Pending = 'pending',
  PendingAml = 'pendingAml',
  PendingExecutionSignatures = 'pendingExecutionSignatures',
  Processing = 'processing',
  ReadyForSending = 'readyForSending',
  Rejected = 'rejected'
}

export enum TransactionServiceDeskSources {
  FreshDesk = 'freshDesk',
  Jira = 'jira'
}

export enum TransactionStatus {
  Authorized = 'authorized',
  AuthorizedFx = 'authorizedFX',
  BeneficiaryNameMismatch = 'beneficiaryNameMismatch',
  Cancelled = 'cancelled',
  Completed = 'completed',
  CompletedManually = 'completedManually',
  Declined = 'declined',
  PendingAml = 'pendingAml',
  PendingCancellationSignatures = 'pendingCancellationSignatures',
  PendingExecutionSignatures = 'pendingExecutionSignatures',
  Reverted = 'reverted',
  Scheduled = 'scheduled'
}

export type TransactionTrackingInfo = {
  __typename?: 'TransactionTrackingInfo';
  events?: Maybe<Array<Maybe<TransactionTrackingInfoEvent>>>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TransactionTrackingInfoEvent = {
  __typename?: 'TransactionTrackingInfoEvent';
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<TransactionTrackingInfoStatus>;
};

export enum TransactionTrackingInfoStatus {
  Pending = 'pending',
  ReceivedByBank = 'receivedByBank',
  SendingToBank = 'sendingToBank',
  SentToBank = 'sentToBank',
  Verified = 'verified'
}

export enum TransactionType {
  Card = 'card',
  CardReversal = 'cardReversal',
  Cashback = 'cashback',
  Commission = 'commission',
  Fee = 'fee',
  Fx = 'fx',
  ManualBooking = 'manualBooking',
  NegativeBalanceCover = 'negativeBalanceCover',
  TransferCrypto = 'transferCrypto',
  TransferInternal = 'transferInternal',
  TransferSwift = 'transferSwift'
}

export type TransactionalPartner = {
  __typename?: 'TransactionalPartner';
  country?: Maybe<Country>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TransactionalPartnerInput = {
  country?: InputMaybe<Country>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TransferFxCurrency = {
  __typename?: 'TransferFXCurrency';
  currency: Scalars['String']['output'];
  decimalPositions: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rails: Array<Maybe<Scalars['String']['output']>>;
};

export enum TwoFaCodeDispatchMode {
  Sms = 'sms',
  TextToSpeech = 'textToSpeech'
}

export type TwoFaCodeResponse = {
  __typename?: 'TwoFACodeResponse';
  attemptsLeft?: Maybe<Scalars['Int']['output']>;
  challengeId: Scalars['String']['output'];
  expectedDigits?: Maybe<Scalars['Int']['output']>;
  phoneLastFourDigits?: Maybe<Scalars['String']['output']>;
  /** @deprecated use retryAttemptsTimeout */
  reAttemptTimeout?: Maybe<Scalars['Float']['output']>;
  resendTimeout?: Maybe<Scalars['Float']['output']>;
  retryAttemptsTimeout?: Maybe<Scalars['Float']['output']>;
};

export enum TwoFaMethod {
  Mobile = 'mobile',
  Sms = 'sms',
  Totp = 'totp'
}

export enum TwoFaMobileProgressStatus {
  Error = 'error',
  Pending = 'pending',
  Success = 'success'
}

export type TwoFaOperationActionLike = BaseAction & {
  __typename?: 'TwoFAOperationActionLike';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TwoFaOperationActionLikeSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export enum TwoFaOperationType {
  ActivateCard = 'activateCard',
  ChangeCardPassword = 'changeCardPassword',
  ChangeCardPin = 'changeCardPin',
  ChangePrimary2FaMethod = 'changePrimary2FAMethod',
  CreateApiUser = 'createApiUser',
  DeactivateApiUser = 'deactivateApiUser',
  GetCardSensitiveInfo = 'getCardSensitiveInfo',
  GetEncrypted3DsPassword = 'getEncrypted3DSPassword',
  Handle3DsAuthentication = 'handle3DSAuthentication',
  Login = 'login',
  PendingActions = 'pendingActions',
  ResetApiUserSecret = 'resetApiUserSecret',
  ResolveVibanNameMismatch = 'resolveVibanNameMismatch',
  StartSetupOrResetIndividualTotp = 'startSetupOrResetIndividualTOTP',
  TerminateCard = 'terminateCard',
  Update3DSecureSettings = 'update3DSecureSettings',
  UpdateApiUser = 'updateApiUser',
  UpdateOwnPassword = 'updateOwnPassword',
  ViewCardPin = 'viewCardPin'
}

export enum TwoFaStatus {
  Reject = 'reject',
  Verify = 'verify'
}

/** Ultimate Beneficial Owner */
export type Ubo = {
  __typename?: 'UBO';
  contracts?: Maybe<Array<Maybe<BankableEntityContractType>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** UBO Entity */
  entity?: Maybe<LegalEntityOrIndividual>;
  /** UBO ID */
  id: Scalars['ID']['output'];
  owners?: Maybe<Array<Maybe<UboOwner>>>;
  ownersFlatList?: Maybe<Array<Maybe<UboOwner>>>;
  ownersTotalShareSize?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UboInputType = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legalEntity?: InputMaybe<UboLegalEntityInputType>;
  naturalPerson?: InputMaybe<AuthorizedPersonInputType>;
  ownershipType: UboStakeType;
  shareSize: Scalars['Float']['input'];
  uboType: UboType;
};

/** Ultimate Beneficial Owner, Owner Details */
export type UboOwner = {
  __typename?: 'UBOOwner';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  ownedUbo?: Maybe<Ubo>;
  ownedUboId?: Maybe<Scalars['ID']['output']>;
  ownershipType?: Maybe<UboStakeType>;
  shareSize?: Maybe<Scalars['Float']['output']>;
  ubo?: Maybe<Ubo>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated not needed anymore, detected from ownershipType now */
  viaPoA?: Maybe<Scalars['Boolean']['output']>;
};

/** UBO Legal Entity */
export type UboLegalEntityInputType = {
  /** Legal Entity Address */
  address?: InputMaybe<AddressInput>;
  /** Legal Entity Business Description */
  businessDescription?: InputMaybe<Scalars['String']['input']>;
  /** Legal Entity Business Sector */
  businessSector?: InputMaybe<Scalars['String']['input']>;
  /** Countries the company’s clients are based in */
  companyClientsCountries?: InputMaybe<Array<InputMaybe<CountriesAndRegionsType>>>;
  /** Legal Entity Company Name */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Legal Entity Company Reg Date */
  companyRegistrationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Legal Entity Company Reg ID */
  companyRegistrationId?: InputMaybe<Scalars['String']['input']>;
  /** Legal Entity Company Type */
  companyType?: InputMaybe<CompanyType>;
  /** Correspondence Address */
  correspondenceAddress?: InputMaybe<AddressInput>;
  /** Countries Of Operating And Conducting Business */
  countriesOfOperatingAndConductingBusiness?: InputMaybe<Array<InputMaybe<CountriesAndRegionsType>>>;
  /** Economic profile fields */
  economicProfile?: InputMaybe<EconomicProfileInputType>;
  /** Has professional treasury department */
  hasProfessionalTreasuryDepartment?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Immediate Previous Company Name */
  immediatePreviousCompanyName?: InputMaybe<Scalars['String']['input']>;
  /** Whether the new client is introducer or not */
  isIntroducer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Legal Entity Company Type */
  legalEntityType?: InputMaybe<UboLegalEntityType>;
  /** Legal Entity Phone Number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Pre-assessment */
  preAssessment?: InputMaybe<PreAssessmentContractInputType>;
  /** Potential Sanctioned Industry */
  sanctionedIndustry?: InputMaybe<SanctionedIndustry>;
  /** What industries does the company serve */
  servingIndustries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Subject to prudential regulation */
  subjectToPrudentialRegulation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tax ID */
  taxId?: InputMaybe<Scalars['String']['input']>;
  /** Legal Entity Trading Name */
  tradingName?: InputMaybe<Scalars['String']['input']>;
  /** Transactional Partners */
  transactionalPartners?: InputMaybe<Array<InputMaybe<TransactionalPartnerInput>>>;
  /** Legal Entity Website */
  website?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum UboLegalEntityType {
  ActiveHolding = 'activeHolding',
  AssociationCharity = 'associationCharity',
  Bank = 'bank',
  DomiciliaryHolding = 'domiciliaryHolding',
  Foundation = 'foundation',
  OperatingNotQuotedStockExchange = 'operatingNotQuotedStockExchange',
  OperatingQuotedStockExchange = 'operatingQuotedStockExchange',
  SoleProprietor = 'soleProprietor',
  Trust = 'trust',
  Unknown = 'unknown'
}

export enum UboStakeType {
  ManagingDirector = 'managingDirector',
  MinorityShareHolders = 'minorityShareHolders',
  Nominee = 'nominee',
  Other = 'other',
  Percent25OrMore = 'percent25OrMore',
  Percent25OrMoreViaPoA = 'percent25OrMoreViaPoA'
}

export enum UboType {
  LegalEntity = 'legalEntity',
  NaturalPerson = 'naturalPerson'
}

/** Toggle Under Monitoring log */
export type UnderMonitoringLog = BaseLogInterface & {
  __typename?: 'UnderMonitoringLog';
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** Toggle Under Monitoring */
  underMonitoring?: Maybe<Scalars['Boolean']['output']>;
  /** Under Monitoring reason */
  underMonitoringReason?: Maybe<Scalars['String']['output']>;
  /** Under Monitoring reason code */
  underMonitoringReasonCode?: Maybe<Scalars['String']['output']>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

export type UpdateContractPaymentRecipientInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  accountNoType?: InputMaybe<AccountNoType>;
  address?: InputMaybe<AddressInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  bankBic?: InputMaybe<Scalars['String']['input']>;
  bankCountry?: InputMaybe<Country>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  commentTemplate?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SwiftTransferRecipientType>;
};

export type UpdateContractUboInputType = {
  ubo: UpdateUboInputType;
};

export type UpdateSpendingLimitAction = BaseAction & {
  __typename?: 'UpdateSpendingLimitAction';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  spendingLimit?: Maybe<SpendingLimitType>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UpdateSpendingLimitActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export type UpdateUboInputType = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legalEntity?: InputMaybe<UboLegalEntityInputType>;
  naturalPerson?: InputMaybe<AuthorizedPersonInputType>;
  ownershipType?: InputMaybe<UboStakeType>;
  shareSize?: InputMaybe<Scalars['Float']['input']>;
  uboType?: InputMaybe<UboType>;
};

export type User = {
  __typename?: 'User';
  /** Activity logs concerning this user */
  activityLogs?: Maybe<Array<Maybe<ActivityLog>>>;
  /** Count of activity logs concerning this user */
  activityLogsCount?: Maybe<Scalars['Int']['output']>;
  /** User's Allowed IPs For Password Auth */
  allowedIps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Sales Agent's Associated Campaigns */
  associatedCampaigns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Sales Agent's Associated Campaigns */
  associatedSubCampaigns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  avatar?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  /** User associated companies */
  companies?: Maybe<Array<Maybe<Company>>>;
  contracts?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User's Department */
  department?: Maybe<UserDepartmentType>;
  /** Document Distribution Weight */
  documentDistributionWeight?: Maybe<Scalars['Int']['output']>;
  /** Document Total Weight */
  documentTotalWeight?: Maybe<Scalars['Int']['output']>;
  /** Last document assignment timestamp */
  documentlastAssignedTimestamp?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is2FAEnabled?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isAuditor?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** User languages */
  languages?: Maybe<Array<Maybe<Language>>>;
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  /** Last lead assignment timestamp */
  lastLeadAssignedTimestamp?: Maybe<Scalars['Float']['output']>;
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Lead Distribution Weight */
  leadDistributionWeight?: Maybe<Scalars['Int']['output']>;
  /** User's location */
  location?: Maybe<Location>;
  /** User's Manager */
  manager?: Maybe<User>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Roles assigned to this user */
  roles?: Maybe<Array<Maybe<Role>>>;
  /** Count of roles assigned to this user */
  rolesCount?: Maybe<Scalars['Int']['output']>;
  /** Selected Pools */
  selectedPools?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  skype?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userRequestsApprovals?: Maybe<Array<Maybe<UserRequestApprovalType>>>;
};


export type UserActivityLogsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  company?: InputMaybe<Company>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Country>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  excludePinned?: InputMaybe<Scalars['Boolean']['input']>;
  feeGroupId?: InputMaybe<Scalars['ID']['input']>;
  includeNullClientId?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerId?: InputMaybe<Scalars['ID']['input']>;
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyPinned?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  origins?: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  standingOrderId?: InputMaybe<Scalars['ID']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ActivityLogTypeType>;
  types?: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserActivityLogsCountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  company?: InputMaybe<Company>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Country>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  estimated?: InputMaybe<Scalars['Boolean']['input']>;
  excludePinned?: InputMaybe<Scalars['Boolean']['input']>;
  feeGroupId?: InputMaybe<Scalars['ID']['input']>;
  ignoreCache?: InputMaybe<Scalars['Boolean']['input']>;
  includeNullClientId?: InputMaybe<Scalars['Boolean']['input']>;
  individualId?: InputMaybe<Scalars['ID']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerId?: InputMaybe<Scalars['ID']['input']>;
  ledgerTransactionId?: InputMaybe<Scalars['ID']['input']>;
  onlyPinned?: InputMaybe<Scalars['Boolean']['input']>;
  origins?: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  standingOrderId?: InputMaybe<Scalars['ID']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ActivityLogTypeType>;
  types?: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserRolesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};

/** User Action Log */
export type UserActionLog = BaseLogInterface & {
  __typename?: 'UserActionLog';
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

export enum UserApprovalRequestStatus {
  Accept = 'accept',
  Reject = 'reject'
}

/** List of user departments */
export enum UserDepartmentType {
  Accounting = 'accounting',
  Administration = 'administration',
  Affiliate = 'affiliate',
  BackOffice = 'backOffice',
  BusinessDevelopment = 'businessDevelopment',
  BusinessIntelligence = 'businessIntelligence',
  CallMonitoring = 'callMonitoring',
  ClientRelationsTraining = 'clientRelationsTraining',
  Compliance = 'compliance',
  Contractor = 'contractor',
  CustomerRelations = 'customerRelations',
  Development = 'development',
  DirectorOfOperations = 'directorOfOperations',
  HumanResources = 'humanResources',
  Investment = 'investment',
  It = 'it',
  Management = 'management',
  Marketing = 'marketing',
  Office = 'office',
  PaymentSolutions = 'paymentSolutions',
  Portfolio = 'portfolio',
  ProjectManagement = 'projectManagement',
  Reception = 'reception',
  Retention = 'retention',
  Risk = 'risk',
  Sales = 'sales',
  SeniorManagement = 'seniorManagement',
  Shareholder = 'shareholder',
  Support = 'support',
  System = 'system'
}

/** User / Individual Union Type */
export type UserOrIndividual = Individual | User;

/** UserRequestApprovalType */
export type UserRequestApprovalType = {
  __typename?: 'UserRequestApprovalType';
  /** Approval Request */
  approvalRequest?: Maybe<BaseApprovalRequest>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<UserApprovalRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type ValidateBeneficiaryDetailsType = {
  __typename?: 'ValidateBeneficiaryDetailsType';
  /** Error Description */
  errorDescription?: Maybe<Scalars['String']['output']>;
  /** lei */
  lei?: Maybe<Scalars['String']['output']>;
  /** Status */
  status?: Maybe<Scalars['String']['output']>;
  /** Sub Status */
  subStatus?: Maybe<Scalars['String']['output']>;
};

/** Verification Medium */
export enum VerificationMedium {
  Correspondence = 'correspondence',
  InPerson = 'inPerson',
  VideoLink = 'videoLink'
}

/** VibanNameMismatch */
export type VibanNameMismatch = {
  __typename?: 'VibanNameMismatch';
  amount?: Maybe<Scalars['Float']['output']>;
  beneficiaryNameOnFile?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['ID']['output']>;
  incomingBeneficiaryName?: Maybe<Scalars['String']['output']>;
  isResolved?: Maybe<Scalars['Boolean']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  resolvedDate?: Maybe<Scalars['DateTime']['output']>;
  senderInfo?: Maybe<TransactionParty>;
  status?: Maybe<VibanNameMismatchResolution>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  virtualAccount?: Maybe<Account>;
};

export type VibanNameMismatchAction = BaseAction & {
  __typename?: 'VibanNameMismatchAction';
  accountInfo?: Maybe<SenderInfoAddress>;
  amount?: Maybe<Scalars['Float']['output']>;
  appFields?: Maybe<AppFields>;
  beneficiaryNameOnFile?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  incomingBeneficiaryName?: Maybe<Scalars['String']['output']>;
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  senderInfo?: Maybe<TransactionParty>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  virtualAccountId?: Maybe<Scalars['ID']['output']>;
};


export type VibanNameMismatchActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export enum VibanNameMismatchResolution {
  Accept = 'accept',
  Pending = 'pending',
  Reject = 'reject'
}

export enum VideoVerificationStatus {
  CollectingDataFinished = 'collectingDataFinished',
  DataRetrievedStatus = 'dataRetrievedStatus',
  MediaOrdered = 'mediaOrdered',
  MediaRemoteFailed = 'mediaRemoteFailed',
  MediaRemoteInProgress = 'mediaRemoteInProgress',
  MediaRemoteReady = 'mediaRemoteReady',
  Pending = 'pending',
  QueuedStatus = 'queuedStatus',
  RejectedStatus = 'rejectedStatus',
  StartedStatus = 'startedStatus',
  UnverifiedStatus = 'unverifiedStatus',
  VerifiedStatus = 'verifiedStatus'
}

/** Authenticated individual - either a user or a client  */
export type Viewer = ApiUser | Individual | User;

export type VirtualAccountDetails = {
  __typename?: 'VirtualAccountDetails';
  /** Approved Aliases for Virtual Account */
  approvedAliases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  clientAccountUniqueIdentifier?: Maybe<Scalars['String']['output']>;
  /** Company Registration Date */
  companyRegistrationDate?: Maybe<Scalars['Date']['output']>;
  /** Company Registration Number */
  companyRegistrationNumber?: Maybe<Scalars['String']['output']>;
  /** DOB Of Account Holder, Available only for Virtual Accounts */
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** Either natural person or legal entity */
  entityType?: Maybe<UboType>;
  gender?: Maybe<Gender>;
  /** Alias for alias -_- */
  name?: Maybe<Scalars['String']['output']>;
  /** Nationality Of Account Holder, Available only for Virtual Accounts */
  nationality?: Maybe<Nationality>;
  /** Registered Address Of Account Holder, Available only for Virtual Accounts */
  registeredAddress?: Maybe<Address>;
};

export type VoidTransactionRequest = BaseApprovalRequest & {
  __typename?: 'VoidTransactionRequest';
  affectedEntity?: Maybe<Scalars['String']['output']>;
  affectedEntityId?: Maybe<Scalars['ID']['output']>;
  approvals?: Maybe<Array<Maybe<UserRequestApprovalType>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  executionError?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  internalReason?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  requestType?: Maybe<ApprovalRequestType>;
  setting?: Maybe<ApprovalRequestSetting>;
  status?: Maybe<ApprovalRequestStatus>;
  toLedger?: Maybe<Ledger>;
  transaction: Transaction;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WallesterFilesInput = {
  fileName: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** Crypto wallet */
export type Wallet = {
  __typename?: 'Wallet';
  /** Wallet Address */
  address?: Maybe<Scalars['String']['output']>;
  /** Wallet Alias */
  alias?: Maybe<Scalars['String']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  /** Base (display) currency */
  baseCurrency?: Maybe<Currency>;
  /** Wallet check status */
  checkStatus?: Maybe<WalletCheckStatus>;
  /** Associated Contract */
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  executionAction?: Maybe<Action>;
  /** Wallet ID */
  id?: Maybe<Scalars['ID']['output']>;
  incomingTransferFee?: Maybe<WalletFee>;
  /** Disconnected flag */
  isDisconnected?: Maybe<Scalars['Boolean']['output']>;
  /** Last wallet check result */
  lastCheckResult?: Maybe<CheckResult>;
  /** Individual who linked the wallet to the contract */
  linkedBy?: Maybe<Individual>;
  meta?: Maybe<Scalars['String']['output']>;
  /** Chain ID of the connected wallet */
  network?: Maybe<SupportedCryptoNetwork>;
  outgoingTransferFee?: Maybe<WalletFee>;
  /** Rejection reason */
  rejectionReasonDescription?: Maybe<Scalars['String']['output']>;
  serviceDeskRequests?: Maybe<Array<Maybe<ServiceDeskRequest>>>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  /** Wallet status */
  status?: Maybe<WalletStatus>;
  supportedCoins?: Maybe<Array<Maybe<Coin>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type WalletAction = BaseAction & {
  __typename?: 'WalletAction';
  appFields?: Maybe<AppFields>;
  contract?: Maybe<BankableEntityContractType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated query initiator instead */
  initiatedByIndividual?: Maybe<Individual>;
  /** @deprecated query initiator instead */
  initiatedByUser?: Maybe<User>;
  initiator?: Maybe<ActionInitiator>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isApiAction?: Maybe<Scalars['Boolean']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<ActionRejectionReason>;
  signatures?: Maybe<Array<Maybe<ActionSignature>>>;
  signedCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionStatus>;
  totalSignatureCount?: Maybe<Scalars['Int']['output']>;
  type: ActionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wallet?: Maybe<Wallet>;
};


export type WalletActionSignaturesArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  signatoryId?: InputMaybe<Scalars['ID']['input']>;
  signedRejectFirst?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>>>;
};

export enum WalletCheckStatus {
  High = 'high',
  Low = 'low',
  Medium = 'medium',
  Severe = 'severe'
}

/** Fee details for incoming/outgoing transactions to/from wallet */
export type WalletFee = {
  __typename?: 'WalletFee';
  amountPercentage?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Currency>;
  feeCurrency?: Maybe<Currency>;
  fixedAmount?: Maybe<Scalars['Float']['output']>;
  isPercentage?: Maybe<Scalars['Boolean']['output']>;
  minAmount?: Maybe<Scalars['Float']['output']>;
};

export enum WalletFlowAction {
  Activate = 'activate',
  Approve = 'approve',
  Connect = 'connect',
  Create = 'create',
  Disconnect = 'disconnect',
  Reactivate = 'reactivate',
  Reject = 'reject',
  Revert = 'revert',
  Sign = 'sign',
  Suspend = 'suspend',
  Verify = 'verify'
}

export enum WalletStatus {
  Active = 'active',
  Disconnected = 'disconnected',
  PendingApproval = 'pendingApproval',
  PendingConfirmation = 'pendingConfirmation',
  PendingReConfirmation = 'pendingReConfirmation',
  PendingSignatures = 'pendingSignatures',
  Rejected = 'rejected',
  Suspended = 'suspended',
  Verified = 'verified'
}

export enum WalletTransferType {
  Incoming = 'incoming',
  Outgoing = 'outgoing'
}

export type WalletType = {
  __typename?: 'WalletType';
  providerCode?: Maybe<Scalars['String']['output']>;
  walletName?: Maybe<Scalars['String']['output']>;
};

export enum Whitelabel {
  Cxpay = 'cxpay'
}

/** Activity log with a reason */
export type WithReasonLog = BaseLogInterface & {
  __typename?: 'WithReasonLog';
  /** Api User who created ActivityLog */
  apiUser?: Maybe<ApiUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Default Message of ActivityLog */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Individual linked with ActivityLog */
  individual?: Maybe<Individual>;
  ip?: Maybe<Scalars['String']['output']>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Document linked with ActivityLog */
  objectDocument?: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange?: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType?: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser?: Maybe<User>;
  /** Origin of ActivityLog */
  origin?: Maybe<ActivityLogOrigin>;
  /** Reason */
  reason?: Maybe<Scalars['String']['output']>;
  /** Rejection Reason Code */
  rejectionCode?: Maybe<Scalars['String']['output']>;
  /** Type of ActivityLog */
  type?: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user?: Maybe<User>;
};

export enum YesNo {
  No = 'no',
  Yes = 'yes'
}

export type MissingInfoDetailsType = {
  __typename?: 'missingInfoDetailsType';
  hasMissingInfo?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type ClientBasicInfoFragment = { __typename?: 'Individual', firstName?: string | null, lastName?: string | null, birthday?: any | null, nationality?: Nationality | null, phone?: string | null };

export type AddressFragment = { __typename?: 'Individual', address?: { __typename?: 'Address', line1?: string | null, city?: string | null, zip?: string | null, region?: string | null, country?: Country | null } | null };

export type SecondaryPhonesFragment = { __typename?: 'Individual', secondaryPhones?: { __typename?: 'SecondaryPhones', secondaryPhone1?: string | null } | null };

export type SecondaryEmailsFragment = { __typename?: 'Individual', secondaryEmails?: { __typename?: 'SecondaryEmails', secondaryEmail1?: string | null, secondaryEmail2?: string | null, secondaryEmail3?: string | null } | null };

export type CardPaymentsFragment = { __typename?: 'PreAssessment', cardPayment?: { __typename?: 'CardPaymentsAndAMP', isCardPayment?: boolean | null, transactionalCurrencies?: Array<Currency | null> | null, requiredSettlementCurrencies?: Array<Currency | null> | null, merchantWebsites?: Array<string | null> | null, cardPaymentsTransactionalDataRegion?: Array<{ __typename?: 'CardPaymentsTransactionalDataRegion', businessCategoryRegion?: BusinessRegion | null, businessCategoryPercentage?: number | null } | null> | null, totalPredictedMonthlyVolumesVisa?: { __typename?: 'TotalPredictedMonthlyVolumes', domestic?: number | null, eea?: number | null, nonEea?: number | null } | null, totalPredictedMonthlyVolumesMasterCard?: { __typename?: 'TotalPredictedMonthlyVolumes', domestic?: number | null, eea?: number | null, nonEea?: number | null } | null, ampCurrentlyInUse?: Array<{ __typename?: 'AmpInUse', ampInUseTypeCurrentlyInUse?: string | null, monthlyVolumeInEuro?: string | null } | null> | null, ampRequiredCurrentlyInUse?: Array<{ __typename?: 'AmpInUse', ampInUseTypeCurrentlyInUse?: string | null, monthlyVolumeInEuro?: string | null } | null> | null, riskManagement?: { __typename?: 'CardProcessingRiskManagement', useAffiliateForGeneratingTraffic?: boolean | null, affiliatesUsed?: Array<string | null> | null, useCredentialOnFilesBillingSalesMethod?: boolean | null, relevantCredentialOnFilesBillingSalesMethod?: RelevantCredentialOnFilesBillingSalesMethod | null, credentialDetailsExplanation?: string | null } | null, pciDssCompliance?: { __typename?: 'PciDssCompliance', integrationTypeRequired?: Array<IntegrationTypeRequired | null> | null, dssCompliance?: Array<DssCompliance | null> | null, pciProviderName?: string | null } | null, processingHistory?: { __typename?: 'CardProcessingHistory', processPaymentCardsBefore?: boolean | null, nameOfCurrentFormerProcessor?: string | null, reasonForLeavingCurrentProcessor?: string | null, periodOfTimeWithCurrentFormerProcessor?: string | null, processingHistoryStatement?: { __typename?: 'Document', id: number, type?: DocumentType | null, contractId?: string | number | null, firstSide?: { __typename?: 'DocumentSide', fileName?: string | null, url?: string | null, size?: number | null, mimeType?: string | null } | null } | null } | null } | null };

export type UpdateOwnPasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  challengeId: Scalars['String']['input'];
  code: Scalars['Int']['input'];
}>;


export type UpdateOwnPasswordMutation = { __typename?: 'Mutation', updateOwnPassword: boolean };

export type ConfirmOwnEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ConfirmOwnEmailMutation = { __typename?: 'Mutation', confirmOwnEmail?: { __typename?: 'Individual', email?: string | null, emailConfirmed?: boolean | null, emailPendingChange?: string | null } | null };

export type SendSmsVerificationMutationVariables = Exact<{
  phone: Scalars['String']['input'];
  type?: InputMaybe<TwoFaCodeDispatchMode>;
}>;


export type SendSmsVerificationMutation = { __typename?: 'Mutation', sendSmsVerification?: { __typename?: 'PhoneVerificationRequest', phoneVerificationId?: string | number | null, timeout?: number | null, attemptsLeft?: number | null, expectedDigits?: number | null, retryAttemptsTimeout?: number | null } | null };

export type VerifyPhoneMutationVariables = Exact<{
  phoneVerificationId: Scalars['Int']['input'];
  code: Scalars['String']['input'];
}>;


export type VerifyPhoneMutation = { __typename?: 'Mutation', verifyPhone?: boolean | null };

export type GetSignedUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type GetSignedUrlMutation = { __typename?: 'Mutation', getSignedUrl?: { __typename?: 'GetSignedUrlType', key?: string | null, plainUrl?: string | null, signedUrl?: string | null } | null };

export type CreateContractMutationVariables = Exact<{
  input: BankableEntityContractInputType;
  version?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateContractMutation = { __typename?: 'Mutation', createContract?: { __typename?: 'BankableEntityContractType', id: number } | null };

export type CreateIntroducerReferenceContractMutationVariables = Exact<{
  input: BankableEntityContractInputType;
}>;


export type CreateIntroducerReferenceContractMutation = { __typename?: 'Mutation', createIntroducerReferenceContract?: { __typename?: 'BankableEntityContractType', id: number } | null };

export type DeleteContractMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContractMutation = { __typename?: 'Mutation', removeContract?: boolean | null };

export type AddContractAuthorizedPersonMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  input: AddAuthorizedPersonInputType;
}>;


export type AddContractAuthorizedPersonMutation = { __typename?: 'Mutation', addContractAuthorizedPerson?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, groupSize?: number | null, isAuthorizedSignatory?: boolean | null, isLimitedAccessHolder?: boolean | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, status?: AuthorizedPersonStatuses | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null, email?: string | null, birthday?: any | null, nationality?: Nationality | null, phone?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, zip?: string | null, country?: Country | null, countryDescription?: string | null, additionalDetails?: string | null } | null } | null } | null };

export type AddLegalEntityDirectorMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  role: DirectorRole;
  signingRight: DirectorSigningRights;
  person: AuthorizedPersonInputType;
}>;


export type AddLegalEntityDirectorMutation = { __typename?: 'Mutation', addLegalEntityDirector?: { __typename?: 'LegalEntityDirector', id: string | number, role?: DirectorRole | null, signingRight?: DirectorSigningRights | null, individual?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null, email?: string | null, birthday?: any | null, nationality?: Nationality | null, phone?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, zip?: string | null, country?: Country | null, countryDescription?: string | null, additionalDetails?: string | null } | null } | null } | null };

export type EditLegalEntityDirectorMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  individualId: Scalars['ID']['input'];
  legalEntityId: Scalars['ID']['input'];
  naturalPerson: AuthorizedPersonInputType;
  role?: InputMaybe<DirectorRole>;
  signingRight?: InputMaybe<DirectorSigningRights>;
}>;


export type EditLegalEntityDirectorMutation = { __typename?: 'Mutation', editLegalEntityDirector?: { __typename?: 'LegalEntityDirector', id: string | number, individual?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null, email?: string | null, birthday?: any | null, nationality?: Nationality | null, phone?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, zip?: string | null, country?: Country | null, countryDescription?: string | null, additionalDetails?: string | null } | null } | null } | null };

export type DeleteContractAuthorizedPersonMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContractAuthorizedPersonMutation = { __typename?: 'Mutation', removeContractAuthorizedPerson?: boolean | null };

export type RemoveLegalEntityDirectorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveLegalEntityDirectorMutation = { __typename?: 'Mutation', removeLegalEntityDirector?: { __typename?: 'LegalEntityDirector', id: string | number } | null };

export type UpdateContractDetailsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updates: BankableEntityContractInputType;
}>;


export type UpdateContractDetailsMutation = { __typename?: 'Mutation', updateContract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null } | null };

export type CreateOwnDocumentMutationVariables = Exact<{
  type: DocumentType;
  fileName: Scalars['String']['input'];
  plainUrl: Scalars['String']['input'];
  contractId: Scalars['Int']['input'];
  size: Scalars['Float']['input'];
  relatedEntityId?: InputMaybe<Scalars['ID']['input']>;
  relatedEntityType?: InputMaybe<DocumentRelatedEntityType>;
  fileDescription?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['Date']['input']>;
  profileChangeId?: InputMaybe<Scalars['ID']['input']>;
  contractInformationRequestId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOwnDocumentMutation = { __typename?: 'Mutation', createOwnDocument?: { __typename?: 'Document', id: number } | null };

export type CreateOwnDocumentTwoSidedMutationVariables = Exact<{
  type: DocumentType;
  firstFileName: Scalars['String']['input'];
  secondFileName?: InputMaybe<Scalars['String']['input']>;
  firstPlainUrl: Scalars['String']['input'];
  secondPlainUrl?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['Int']['input']>;
  firstSize: Scalars['Float']['input'];
  secondSize?: InputMaybe<Scalars['Float']['input']>;
  relatedEntityId?: InputMaybe<Scalars['ID']['input']>;
  relatedEntityType?: InputMaybe<DocumentRelatedEntityType>;
  expiration?: InputMaybe<Scalars['Date']['input']>;
}>;


export type CreateOwnDocumentTwoSidedMutation = { __typename?: 'Mutation', createOwnDocument?: { __typename?: 'Document', id: number } | null };

export type RemoveDocumentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveDocumentMutation = { __typename?: 'Mutation', removeDocument?: { __typename?: 'Document', id: number, type?: DocumentType | null } | null };

export type AddContractUboMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AddContractUboInputType;
}>;


export type AddContractUboMutation = { __typename?: 'Mutation', addContractUbo?: { __typename?: 'ContractUBO', addedFromExistingUbo?: boolean | null, id?: string | number | null, ubo?: { __typename?: 'UBO', id: string | number, entity?: { __typename?: 'Individual', id: number } | { __typename?: 'LegalEntity' } | null } | null } | null };

export type StartVideoVerificationMutationVariables = Exact<{
  callbackUrl: Scalars['String']['input'];
}>;


export type StartVideoVerificationMutation = { __typename?: 'Mutation', startVideoVerification?: string | null };

export type AddUboOwnerMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  uboId: Scalars['ID']['input'];
  ubo: UboInputType;
}>;


export type AddUboOwnerMutation = { __typename?: 'Mutation', addUboOwner?: { __typename?: 'UBOOwner', id?: string | number | null, ubo?: { __typename?: 'UBO', id: string | number, entity?: { __typename?: 'Individual', id: number } | { __typename?: 'LegalEntity' } | null } | null } | null };

export type UpdateUboOwnerMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  uboOwnerId: Scalars['ID']['input'];
  ownedUboId: Scalars['ID']['input'];
  ubo: UpdateUboInputType;
}>;


export type UpdateUboOwnerMutation = { __typename?: 'Mutation', updateUboOwner?: { __typename?: 'UBOOwner', id?: string | number | null, ubo?: { __typename?: 'UBO', id: string | number, entity?: { __typename?: 'Individual', id: number } | { __typename?: 'LegalEntity' } | null } | null } | null };

export type DeleteUboOwnerMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  uboId: Scalars['ID']['input'];
  uboOwnerId: Scalars['ID']['input'];
}>;


export type DeleteUboOwnerMutation = { __typename?: 'Mutation', removeUBOOwner?: boolean | null };

export type DeleteContractUboMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContractUboMutation = { __typename?: 'Mutation', removeContractUbo?: boolean | null };

export type UpdateContractUboMutationVariables = Exact<{
  contractUboId: Scalars['ID']['input'];
  input: UpdateContractUboInputType;
}>;


export type UpdateContractUboMutation = { __typename?: 'Mutation', updateContractUbo?: { __typename?: 'ContractUBO', addedFromExistingUbo?: boolean | null, ubo?: { __typename?: 'UBO', id: string | number, entity?: { __typename?: 'Individual', id: number } | { __typename?: 'LegalEntity' } | null } | null } | null };

export type UpdateOwnDetailsMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  country?: InputMaybe<Country>;
  nationality?: InputMaybe<Nationality>;
  line1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  supportingDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  taxId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOwnDetailsMutation = { __typename?: 'Mutation', updateOwnDetails?: { __typename?: 'ProfileChange', id?: number | null, status?: ProfileChangeStatus | null } | null };

export type UpdateContractAuthPersonMutationVariables = Exact<{
  authPersonId: Scalars['ID']['input'];
  authorizationSetting?: InputMaybe<AuthorizationSettingInputType>;
  person?: InputMaybe<AuthorizedPersonInputType>;
}>;


export type UpdateContractAuthPersonMutation = { __typename?: 'Mutation', updateContractAuthorizedPerson?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, groupSize?: number | null, isAuthorizedSignatory?: boolean | null, isLimitedAccessHolder?: boolean | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, status?: AuthorizedPersonStatuses | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null, email?: string | null, birthday?: any | null, nationality?: Nationality | null, phone?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, zip?: string | null, country?: Country | null, countryDescription?: string | null, additionalDetails?: string | null } | null } | null } | null };

export type SubmitContractForApprovalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SubmitContractForApprovalMutation = { __typename?: 'Mutation', submitContractForApproval?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, submittedAt?: any | null } | null };

export type GetActionSigningCodeMutationVariables = Exact<{
  mode?: InputMaybe<TwoFaCodeDispatchMode>;
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  status?: InputMaybe<ActionSignatureStatus>;
  type?: InputMaybe<TwoFaOperationType>;
  fields?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetActionSigningCodeMutation = { __typename?: 'Mutation', getActionSigningCode?: { __typename?: 'TwoFACodeResponse', challengeId: string, reAttemptTimeout?: number | null, resendTimeout?: number | null, attemptsLeft?: number | null, phoneLastFourDigits?: string | null } | null };

export type SignActionWithChallengeCodeMutationVariables = Exact<{
  actionSignatureId: Scalars['ID']['input'];
  status: ActionSignatureStatus;
  challengeId: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type SignActionWithChallengeCodeMutation = { __typename?: 'Mutation', signActionWithChallengeCode?: { __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, id: string | number, action: { __typename?: 'AccountAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'BatchPaymentActionType', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'CardIssueRequestAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'ContractChangeAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'ContractTerminationAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'DirectDebitAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'DirectDebitDisputeAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'DocumentAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType, document?: { __typename?: 'Document', fileDescription?: string | null } | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'SpendingLimitRequestAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'StandingOrderActionType', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType, standingOrder?: { __typename?: 'StandingOrder', id: string | number, activationAction?: { __typename?: 'AccountAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'BatchPaymentActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'CardIssueRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'ContractChangeAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DirectDebitAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DocumentAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'StandingOrderActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'TransactionAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'WalletAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | null } | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'TransactionAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'TwoFAOperationActionLike', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'VibanNameMismatchAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } | { __typename?: 'WalletAction', id: string | number, executedAt?: any | null, status?: ActionStatus | null, type: ActionType } } | null };

export type SignMultipleActionsWithChallengeCodeMutationVariables = Exact<{
  actionSignatureIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  status: ActionSignatureStatus;
  challengeId: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type SignMultipleActionsWithChallengeCodeMutation = { __typename?: 'Mutation', signMultipleActionsWithChallengeCode?: { __typename?: 'MultipleActionSignaturesReturnType', failed?: Array<{ __typename?: 'IdValue', id?: string | number | null, value?: string | null } | null> | null, signed?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null } | null> | null } | null };

export type CreateOwnDocumentIndividualMutationVariables = Exact<{
  type: DocumentType;
  fileName: Scalars['String']['input'];
  plainUrl: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  relatedEntityId?: InputMaybe<Scalars['ID']['input']>;
  relatedEntityType?: InputMaybe<DocumentRelatedEntityType>;
  fileDescription?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['Date']['input']>;
}>;


export type CreateOwnDocumentIndividualMutation = { __typename?: 'Mutation', createOwnDocument?: { __typename?: 'Document', id: number } | null };

export type UpdateOwnEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UpdateOwnEmailMutation = { __typename?: 'Mutation', updateOwnEmail?: { __typename?: 'Individual', id: number } | null };

export type AddAccountToOwnContractMutationVariables = Exact<{
  currency: NewAccountCurrency;
  qrrSupported?: InputMaybe<Scalars['Boolean']['input']>;
  contractId: Scalars['ID']['input'];
  alias?: InputMaybe<Scalars['String']['input']>;
  fundsType?: InputMaybe<FundsType>;
  alternativeAccountDetails?: InputMaybe<SwiftTransferIndividualPartyDetailsWithCurrencyInput>;
}>;


export type AddAccountToOwnContractMutation = { __typename?: 'Mutation', addAccountToOwnContract?: { __typename?: 'Account', id?: string | number | null, name?: string | null, executionAction?: { __typename?: 'AccountAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null } | null };

export type UpdateAccountAliasMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  alias: Scalars['String']['input'];
}>;


export type UpdateAccountAliasMutation = { __typename?: 'Mutation', updateAccountAlias?: { __typename?: 'Account', id?: string | number | null } | null };

export type CreateSwiftTransferMutationVariables = Exact<{
  fromAccountNo: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  bankBic: Scalars['String']['input'];
  line1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country>;
  beneficiaryType: SwiftTransferRecipientType;
  amount: Scalars['Float']['input'];
  comments: Scalars['String']['input'];
  executionType: TransactionExecutionType;
  chargeBearer?: InputMaybe<SwiftTransferChargeBearer>;
}>;


export type CreateSwiftTransferMutation = { __typename?: 'Mutation', createSwiftTransfer?: { __typename?: 'CreditTransaction' } | { __typename?: 'DebitTransaction' } | null };

export type CreateOutboundPaymentMutationVariables = Exact<{
  fromAccountNo: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  accountNo?: InputMaybe<Scalars['String']['input']>;
  bankBic?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country>;
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  beneficiaryType: SwiftTransferRecipientType;
  amount: Scalars['Float']['input'];
  payoutAmount?: InputMaybe<Scalars['Float']['input']>;
  comments: Scalars['String']['input'];
  executionType: TransactionExecutionType;
  chargeBearer?: InputMaybe<SwiftTransferChargeBearer>;
  payoutCurrency?: InputMaybe<Currency>;
  quotedXRate?: InputMaybe<Scalars['Float']['input']>;
  quotedXRateId?: InputMaybe<Scalars['ID']['input']>;
  clientReference?: InputMaybe<Scalars['ID']['input']>;
  purposeCode?: InputMaybe<Scalars['String']['input']>;
  purposeCode2?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  bankClearingMemberId?: InputMaybe<Scalars['String']['input']>;
  bankBranchId?: InputMaybe<Scalars['String']['input']>;
  bankBranchName?: InputMaybe<Scalars['String']['input']>;
  useLocalPay?: InputMaybe<Scalars['Boolean']['input']>;
  executionDate?: InputMaybe<Scalars['Date']['input']>;
  priority?: InputMaybe<TransactionPriorityType>;
  useTLDR?: InputMaybe<Scalars['Boolean']['input']>;
  accountNoType?: InputMaybe<AccountNoType>;
  kyc?: InputMaybe<PaymentTransferRecipientKycInput>;
  pan?: InputMaybe<Scalars['String']['input']>;
  bankCountry?: InputMaybe<Country>;
}>;


export type CreateOutboundPaymentMutation = { __typename?: 'Mutation', createOutboundPayment?: { __typename?: 'CreditTransaction' } | { __typename?: 'DebitTransaction' } | null };

export type CreateStandingOrderMutationVariables = Exact<{
  fromAccountNo: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  accountNo?: InputMaybe<Scalars['String']['input']>;
  bankBic: Scalars['String']['input'];
  line1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country>;
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  beneficiaryType: SwiftTransferRecipientType;
  amount: Scalars['Float']['input'];
  payoutAmount?: InputMaybe<Scalars['Float']['input']>;
  comments: Scalars['String']['input'];
  chargeBearer?: InputMaybe<SwiftTransferChargeBearer>;
  payoutCurrency?: InputMaybe<Currency>;
  clientReference?: InputMaybe<Scalars['ID']['input']>;
  purposeCode?: InputMaybe<Scalars['String']['input']>;
  purposeCode2?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  bankClearingMemberId?: InputMaybe<Scalars['String']['input']>;
  bankBranchId?: InputMaybe<Scalars['String']['input']>;
  bankBranchName?: InputMaybe<Scalars['String']['input']>;
  useLocalPay?: InputMaybe<Scalars['Boolean']['input']>;
  executionDate?: InputMaybe<Scalars['String']['input']>;
  periodicity?: InputMaybe<StandingOrderPeriodicity>;
  lowerThreshold?: InputMaybe<Scalars['Float']['input']>;
  minRemainingBalance?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CreateStandingOrderMutation = { __typename?: 'Mutation', createStandingOrder?: { __typename?: 'StandingOrder', id: string | number, executionAction?: { __typename?: 'AccountAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'BatchPaymentActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractChangeAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DocumentAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'StandingOrderActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TransactionAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'WalletAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | null } | null };

export type InternalTransferMutationVariables = Exact<{
  fromAccountNo: Scalars['ID']['input'];
  toAccountNo: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  executionType: TransactionExecutionType;
  valueDate?: InputMaybe<Scalars['Date']['input']>;
  comments: Scalars['String']['input'];
  quotedXRate?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<TransactionPriorityType>;
}>;


export type InternalTransferMutation = { __typename?: 'Mutation', createInternalTransfer?: { __typename?: 'CreditTransaction', id?: string | number | null, value?: number | null, account?: { __typename?: 'Account', balance?: { __typename?: 'AccountBalance', available?: number | null } | null } | null } | { __typename?: 'DebitTransaction', id?: string | number | null, value?: number | null, account?: { __typename?: 'Account', balance?: { __typename?: 'AccountBalance', available?: number | null } | null } | null, executionAction?: { __typename?: 'AccountAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'BatchPaymentActionType', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractChangeAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DocumentAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'StandingOrderActionType', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TransactionAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'WalletAction', id: string | number, totalSignatureCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | null } | null };

export type AddContractPaymentRecipientMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  type: SwiftTransferRecipientType;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  iban?: InputMaybe<Scalars['String']['input']>;
  accountNo?: InputMaybe<Scalars['String']['input']>;
  bankBic?: InputMaybe<Scalars['String']['input']>;
  bankName: Scalars['String']['input'];
  country: Country;
  city: Scalars['String']['input'];
  zip: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  additionalDetailsOptional?: InputMaybe<Scalars['String']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  commentTemplate?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  bankClearingMemberId?: InputMaybe<Scalars['String']['input']>;
  bankBranchId?: InputMaybe<Scalars['String']['input']>;
  bankBranchName?: InputMaybe<Scalars['String']['input']>;
  accountNoType?: InputMaybe<AccountNoType>;
  bankCountry?: InputMaybe<Country>;
}>;


export type AddContractPaymentRecipientMutation = { __typename?: 'Mutation', addContractPaymentRecipient?: { __typename?: 'ContractPaymentRecipient', id: string | number, type?: SwiftTransferRecipientType | null, firstName?: string | null, lastName?: string | null, companyName?: string | null, iban?: string | null, accountNo?: string | null, currency?: Currency | null, bankBic?: string | null, bankBranchId?: string | null, bankClearingMemberId?: string | null, accountNoType?: AccountNoType | null, taxId?: string | null, phone?: string | null, alias?: string | null, commentTemplate?: string | null, pan?: string | null, address?: { __typename?: 'Address', country?: Country | null, city?: string | null, zip?: string | null, line1?: string | null } | null, kyc?: { __typename?: 'PaymentTransferRecipientKyc', individual?: { __typename?: 'PaymentTransferIndividualRecipientKyc', dateOfBirth?: any | null, nationality?: Nationality | null, idType?: string | null, idNumber?: string | null, idIssueDate?: any | null, idExpiryDate?: any | null, idIssueCountry?: Country | null } | null, company?: { __typename?: 'PaymentTransferCompanyRecipientKyc', registrationNumber?: string | null, registrationType?: string | null, registrationDate?: any | null } | null } | null } | null };

export type UpdateContractPaymentRecipientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  type: SwiftTransferRecipientType;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  iban?: InputMaybe<Scalars['String']['input']>;
  accountNo?: InputMaybe<Scalars['String']['input']>;
  bankBic?: InputMaybe<Scalars['String']['input']>;
  bankName: Scalars['String']['input'];
  country: Country;
  city: Scalars['String']['input'];
  zip: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  additionalDetailsOptional?: InputMaybe<Scalars['String']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  commentTemplate?: InputMaybe<Scalars['String']['input']>;
  bankBranchName?: InputMaybe<Scalars['String']['input']>;
  bankBranchId?: InputMaybe<Scalars['String']['input']>;
  bankClearingMemberId?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  accountNoType?: InputMaybe<AccountNoType>;
  bankCountry?: InputMaybe<Country>;
}>;


export type UpdateContractPaymentRecipientMutation = { __typename?: 'Mutation', updateContractPaymentRecipient?: { __typename?: 'ContractPaymentRecipient', id: string | number } | null };

export type RemoveContractPaymentRecipientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveContractPaymentRecipientMutation = { __typename?: 'Mutation', removeContractPaymentRecipient?: boolean | null };

export type Get2FaCodeChangePasswordMutationVariables = Exact<{
  type?: InputMaybe<TwoFaOperationType>;
}>;


export type Get2FaCodeChangePasswordMutation = { __typename?: 'Mutation', get2FACode?: { __typename?: 'TwoFACodeResponse', challengeId: string, resendTimeout?: number | null, attemptsLeft?: number | null, expectedDigits?: number | null, phoneLastFourDigits?: string | null } | null };

export type AddTeamMateMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  input?: InputMaybe<AddAuthorizedPersonInputType>;
}>;


export type AddTeamMateMutation = { __typename?: 'Mutation', addContractAuthorizedPersonRequest?: { __typename?: 'ContractAuthorizedPersonRequestResponse', contractAuthPerson?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, person?: { __typename?: 'Individual', firstName?: string | null, lastName?: string | null } | null } | null, executionAction?: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signingMethod?: string | null, createdAt?: any | null, updatedAt?: any | null, signedAt?: any | null, action: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, type: ActionType, status?: ActionStatus | null } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' }, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, signatoryRight?: SignatoryRight | null } | null } | null> | null } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null } | null };

export type IssueCardRequestMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  contractAuthorizedPersonId: Scalars['ID']['input'];
  type?: InputMaybe<ApiCardTypes>;
  limits?: InputMaybe<Array<InputMaybe<CardLimitInputType>> | InputMaybe<CardLimitInputType>>;
  alias?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<AddressInput>;
}>;


export type IssueCardRequestMutation = { __typename?: 'Mutation', issueCardRequest?: { __typename?: 'CardRequestType', id: number, card?: { __typename?: 'CardType', id: string | number, alias?: string | null, cardHolder?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number, fullName?: string | null } | null } | null } | null, executionAction?: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signingMethod?: string | null, createdAt?: any | null, updatedAt?: any | null, signedAt?: any | null, action: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction', id: string | number, type: ActionType, status?: ActionStatus | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' }, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, signatoryRight?: SignatoryRight | null } | null } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null } | null };

export type RenameCardMutationVariables = Exact<{
  alias?: InputMaybe<Scalars['String']['input']>;
  cardId: Scalars['ID']['input'];
}>;


export type RenameCardMutation = { __typename?: 'Mutation', renameCard?: { __typename?: 'CardType', id: string | number } | null };

export type FreezeCardMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type FreezeCardMutation = { __typename?: 'Mutation', freezeCard?: { __typename?: 'CardType', id: string | number, status?: CardStatuses | null } | null };

export type UnFreezeCardMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;


export type UnFreezeCardMutation = { __typename?: 'Mutation', unFreezeCard?: { __typename?: 'CardType', id: string | number, status?: CardStatuses | null } | null };

export type TerminateCardMutationVariables = Exact<{
  challengeId: Scalars['String']['input'];
  code: Scalars['Int']['input'];
  cardId: Scalars['ID']['input'];
}>;


export type TerminateCardMutation = { __typename?: 'Mutation', terminateCard?: { __typename?: 'CardType', id: string | number, status?: CardStatuses | null } | null };

export type ChangeCardLimitsMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
  limits?: InputMaybe<Array<InputMaybe<CardLimitInputType>> | InputMaybe<CardLimitInputType>>;
}>;


export type ChangeCardLimitsMutation = { __typename?: 'Mutation', spendingLimitRequest?: { __typename?: 'SpendingLimitRequestType', updatedAt?: any | null, executionAction?: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null } | null };

export type ActivateCardMutationVariables = Exact<{
  challengeId: Scalars['String']['input'];
  code: Scalars['ID']['input'];
  cardId: Scalars['ID']['input'];
  password: Scalars['ID']['input'];
}>;


export type ActivateCardMutation = { __typename?: 'Mutation', activateCard?: { __typename?: 'CardType', id: string | number, status?: CardStatuses | null } | null };

export type ContractDetailsChangeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updates: BankableEntityContractInputType;
  supportingDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  missingInfoId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContractDetailsChangeMutation = { __typename?: 'Mutation', contractChangeRequest?: { __typename?: 'ProfileChange', id?: number | null, executionAction?: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null } | null };

export type CreateOwnDocumentRelatedMutationVariables = Exact<{
  type: DocumentType;
  fileName: Scalars['String']['input'];
  plainUrl: Scalars['String']['input'];
  contractId: Scalars['Int']['input'];
  size: Scalars['Float']['input'];
  relatedAccountId?: InputMaybe<Scalars['ID']['input']>;
  relatedStandingOrderId?: InputMaybe<Scalars['ID']['input']>;
  relatedTransactionId?: InputMaybe<Scalars['ID']['input']>;
  relatedIndividualId?: InputMaybe<Scalars['ID']['input']>;
  fileDescription?: InputMaybe<Scalars['String']['input']>;
  relatesTo?: InputMaybe<DocumentRelatedEntityInput>;
  relatedWalletId?: InputMaybe<Scalars['String']['input']>;
  relatedTransactionRequestId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateOwnDocumentRelatedMutation = { __typename?: 'Mutation', createOwnDocument?: { __typename?: 'Document', id: number } | null };

export type CreateCustomerSupportRequestMutationVariables = Exact<{
  title: Scalars['String']['input'];
  contractId?: InputMaybe<Scalars['ID']['input']>;
  details: Scalars['String']['input'];
  attachmentUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  topic?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCustomerSupportRequestMutation = { __typename?: 'Mutation', createCustomerSupportRequest?: boolean | null };

export type GetBatchFileUploadUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type GetBatchFileUploadUrlMutation = { __typename?: 'Mutation', getBatchPaymentFileSignedUrl?: { __typename?: 'GetSignedUrlType', key?: string | null, plainUrl?: string | null, signedUrl?: string | null } | null };

export type ValidateBatchFileMutationVariables = Exact<{
  fileUrl: Scalars['String']['input'];
  accountId: Scalars['ID']['input'];
}>;


export type ValidateBatchFileMutation = { __typename?: 'Mutation', validateBatchPaymentFile?: { __typename?: 'BatchPaymentFileValidation', valid?: boolean | null, currency?: string | null, calculatedTotal?: number | null, calculatedValidTotal?: number | null, count?: number | null, oversized?: boolean | null, paymentRecords?: Array<{ __typename?: 'BatchPaymentRecord', id?: string | number | null, amount?: number | null, currency?: string | null, beneficiaryType?: string | null, beneficiaryName?: string | null, beneficiaryAccountId?: string | null, beneficiaryAccountIdType?: string | null, bankBic?: string | null, reference?: string | null, priority?: string | null, street1?: string | null, street2?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, isValid?: boolean | null, status?: BatchPaymentRecordStatus | null, errors?: any | null, payoutAmount?: number | null, payoutCurrency?: string | null, useLocalAchPayout?: boolean | null, fixedPayoutAmount?: boolean | null, bankClearingMemberId?: string | null, bankBranchId?: string | null, bankBranchName?: string | null, beneficiaryPhone?: string | null, beneficiaryEmail?: string | null, purposeCode?: string | null, chargeBearer?: SwiftTransferChargeBearer | null } | null> | null } | null };

export type StartBatchPaymentMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  fileUrl: Scalars['String']['input'];
}>;


export type StartBatchPaymentMutation = { __typename?: 'Mutation', startBatchPayment?: { __typename?: 'BatchPayment', id?: string | number | null, fileUrl?: string | null, status?: BatchPaymentStatusType | null, cancellationReason?: string | null, createdAt?: any | null, updatedAt?: any | null, executionAction?: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signingMethod?: string | null, createdAt?: any | null, updatedAt?: any | null, signedAt?: any | null, action: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType', id: string | number, type: ActionType, status?: ActionStatus | null } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' }, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, signatoryRight?: SignatoryRight | null } | null } | null> | null } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null } | null };

export type MarkDocumentsAsReadMutationVariables = Exact<{
  documentIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type MarkDocumentsAsReadMutation = { __typename?: 'Mutation', markDocumentsAsRead?: boolean | null };

export type UpsertContractTechnicalPropertiesMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  contractId: Scalars['ID']['input'];
  paymentWebhook: Scalars['String']['input'];
  webhookSignatureKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertContractTechnicalPropertiesMutation = { __typename?: 'Mutation', upsertContractTechnicalProperties?: { __typename?: 'ContractTechnicalDetailsType', id: string | number, paymentWebhook?: string | null, webhookSignatureKey?: string | null } | null };

export type CloseVirtualAccountMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type CloseVirtualAccountMutation = { __typename?: 'Mutation', closeVirtualAccount?: { __typename?: 'Account', id?: string | number | null } | null };

export type CreateApiUserMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  code: Scalars['ID']['input'];
  challengeId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  allowedIps: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type CreateApiUserMutation = { __typename?: 'Mutation', createApiUser?: { __typename?: 'ApiUser', id: string | number, name: string, apiKey: string | number, apiSecret: string | number, allowedIps?: Array<string | null> | null, status?: ApiUserStatus | null } | null };

export type DeactivateApiUserMutationVariables = Exact<{
  apiKey: Scalars['ID']['input'];
  code: Scalars['ID']['input'];
  challengeId: Scalars['ID']['input'];
}>;


export type DeactivateApiUserMutation = { __typename?: 'Mutation', deactivateApiUser?: { __typename?: 'ApiUser', id: string | number, name: string, apiKey: string | number, apiSecret: string | number, allowedIps?: Array<string | null> | null, status?: ApiUserStatus | null } | null };

export type ResetApiUserSecretMutationVariables = Exact<{
  apiKey: Scalars['ID']['input'];
  code: Scalars['ID']['input'];
  challengeId: Scalars['ID']['input'];
}>;


export type ResetApiUserSecretMutation = { __typename?: 'Mutation', resetApiUserSecret: string };

export type UpdateApiUserAllowedIpsMutationVariables = Exact<{
  apiKey: Scalars['ID']['input'];
  code: Scalars['ID']['input'];
  challengeId: Scalars['ID']['input'];
  allowedIps: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateApiUserAllowedIpsMutation = { __typename?: 'Mutation', updateApiUserAllowedIps?: { __typename?: 'ApiUser', id: string | number, name: string, apiKey: string | number, apiSecret: string | number, allowedIps?: Array<string | null> | null, status?: ApiUserStatus | null } | null };

export type AddVirtualAccountMutationVariables = Exact<{
  alias?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<UboType>;
  parentId: Scalars['ID']['input'];
  nationality?: InputMaybe<Nationality>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  registeredAddress: AddressInput;
  companyRegistrationDate?: InputMaybe<Scalars['Date']['input']>;
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddVirtualAccountMutation = { __typename?: 'Mutation', addVirtualAccount?: { __typename?: 'Account', parentId?: string | number | null, alias?: string | null, createdAt?: any | null, id?: string | number | null, isVirtual?: boolean | null, iban?: string | null, executionAction?: { __typename?: 'AccountAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signingMethod?: string | null, createdAt?: any | null, updatedAt?: any | null, signedAt?: any | null, action: { __typename?: 'AccountAction', id: string | number, type: ActionType, status?: ActionStatus | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' }, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, signatoryRight?: SignatoryRight | null } | null } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null } | null };

export type UpdateIndividualEmailCategoryPreferenceMutationVariables = Exact<{
  emailCategoryId: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type UpdateIndividualEmailCategoryPreferenceMutation = { __typename?: 'Mutation', updateIndividualEmailCategoryPreference?: { __typename?: 'IndividualEmailCategoryPreference', id: string | number, active: boolean, category: { __typename?: 'EmailCategory', id: string | number, name: string, description: string, mandatory: boolean } } | null };

export type ContractTerminationRequestMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContractTerminationRequestMutation = { __typename?: 'Mutation', contractTerminationRequest?: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null } | null> | null } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null };

export type StartSetupTwoFaForIndividualMutationVariables = Exact<{
  challengeId: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type StartSetupTwoFaForIndividualMutation = { __typename?: 'Mutation', startSetupTwoFaForIndividual?: { __typename?: 'TOTPSetupData', qrCode: string, alternativeCode: string } | null };

export type FinishSetupTwoFaForIndividualMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type FinishSetupTwoFaForIndividualMutation = { __typename?: 'Mutation', finishSetupTwoFaForIndividual?: boolean | null };

export type ChangeIndividualPrimary2FaMethodMutationVariables = Exact<{
  method: TwoFaMethod;
  challengeId: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type ChangeIndividualPrimary2FaMethodMutation = { __typename?: 'Mutation', changeIndividualPrimary2FAMethod?: { __typename?: 'Individual', primaryTwoFAMethod?: TwoFaMethod | null } | null };

export type ResolveVibanNameMismatchMutationVariables = Exact<{
  vibanNameMismatchIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  resolution: VibanNameMismatchResolution;
  authorizationCode: Scalars['ID']['input'];
  challengeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ResolveVibanNameMismatchMutation = { __typename?: 'Mutation', resolveVibanNameMismatch?: boolean | null };

export type DeactivateUserMutationVariables = Exact<{
  authorizedPersonId: Scalars['ID']['input'];
}>;


export type DeactivateUserMutation = { __typename?: 'Mutation', deactivateAuthorizedPersonRequest?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, status?: AuthorizedPersonStatuses | null } | null };

export type UpdateContractInformationRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  clientNote: Scalars['String']['input'];
  documentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type UpdateContractInformationRequestMutation = { __typename?: 'Mutation', updateContractInformationRequestIndividual?: { __typename?: 'ContractInformationRequest', id: string | number, note?: string | null, clientNote?: string | null, filledAt?: any | null, status?: ContractInformationRequestStatus | null, attachments?: Array<{ __typename?: 'DocumentSide', fileName?: string | null, url?: string | null } | null> | null, documents?: Array<{ __typename?: 'Document', id: number, type?: DocumentType | null, firstSide?: { __typename?: 'DocumentSide', fileName?: string | null, url?: string | null } | null, secondSide?: { __typename?: 'DocumentSide', fileName?: string | null, url?: string | null } | null } | null> | null } | null };

export type RequestTansferContractOwnershipMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  toEmail: Scalars['String']['input'];
  toName: Scalars['String']['input'];
}>;


export type RequestTansferContractOwnershipMutation = { __typename?: 'Mutation', requestTansferContractOwnership?: { __typename?: 'ContractOwnershipTransfer', id: string | number } | null };

export type ProcessTransferContractOwnershipMutationVariables = Exact<{
  contractOwnershipTransferId: Scalars['String']['input'];
}>;


export type ProcessTransferContractOwnershipMutation = { __typename?: 'Mutation', processTransferContractOwnership?: { __typename?: 'BankableEntityContractType', id: number, createdBy?: { __typename?: 'Individual', id: number, email?: string | null } | null } | null };

export type CreateIndividualContractMutationVariables = Exact<{
  input: ContractInputForIndividualType;
}>;


export type CreateIndividualContractMutation = { __typename?: 'Mutation', createIndividualContract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null } | null };

export type CancelStandingOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelStandingOrderMutation = { __typename?: 'Mutation', cancelStandingOrder?: { __typename?: 'StandingOrder', id: string | number, cancellationAction?: { __typename?: 'AccountAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'BatchPaymentActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'CardIssueRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'ContractChangeAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DirectDebitAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DocumentAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'StandingOrderActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'TransactionAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'WalletAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | null } | null };

export type CancelTransactionMutationVariables = Exact<{
  transactionId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  authorizationCode?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CancelTransactionMutation = { __typename?: 'Mutation', cancelTransaction?: { __typename?: 'CreditTransaction' } | { __typename?: 'DebitTransaction', id?: string | number | null } | null };

export type RejectDirectDebitMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RejectDirectDebitMutation = { __typename?: 'Mutation', rejectDirectDebit?: { __typename?: 'DirectDebitMandate', id: string | number, rejectionAction?: { __typename?: 'AccountAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'BatchPaymentActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'CardIssueRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'ContractChangeAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DirectDebitAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DocumentAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'StandingOrderActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'TransactionAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'WalletAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | null } | null };

export type UpdateContractCommissionSettingAccountMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  commissionPayoutAccountId?: InputMaybe<Scalars['ID']['input']>;
  payoutAccountDetails?: InputMaybe<SwiftTransferIndividualPartyDetailsInput>;
  currency?: InputMaybe<Currency>;
}>;


export type UpdateContractCommissionSettingAccountMutation = { __typename?: 'Mutation', updateContractCommissionSettingAccount?: { __typename?: 'BankableEntityContractType', id: number } | null };

export type ExportContractPayoutsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ExportContractPayoutsMutation = { __typename?: 'Mutation', exportContractPayouts?: string | null };

export type ExportPayoutSuccessFeesMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ExportPayoutSuccessFeesMutation = { __typename?: 'Mutation', exportPayoutSuccessFees?: string | null };

export type UpdateAccountAlternativeAccountDetailsMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  alternativeAccountDetails: SwiftTransferIndividualPartyDetailsWithCurrencyInput;
}>;


export type UpdateAccountAlternativeAccountDetailsMutation = { __typename?: 'Mutation', updateAccountAlternativeAccountDetails?: { __typename?: 'Account', id?: string | number | null, executionAction?: { __typename?: 'AccountAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null } | null };

export type SaveBalanceCurrencyMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  currency: NewAccountCurrency;
}>;


export type SaveBalanceCurrencyMutation = { __typename?: 'Mutation', saveBalanceCurrency?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, balanceCurrency?: NewAccountCurrency | null } | null };

export type TogglePinAccountMutationVariables = Exact<{
  accountIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  pin: Scalars['Boolean']['input'];
}>;


export type TogglePinAccountMutation = { __typename?: 'Mutation', pinUnpinAccount?: boolean | null };

export type CreateCardTermsActionMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type CreateCardTermsActionMutation = { __typename?: 'Mutation', createCardTermsAction?: { __typename?: 'CreateCardTermsActionType', signed: boolean, actionId?: string | number | null } | null };

export type PreapproveB2BDirectDebitMandateMutationVariables = Exact<{
  mandate: B2BDirectDebitPreapprovalInput;
}>;


export type PreapproveB2BDirectDebitMandateMutation = { __typename?: 'Mutation', preapproveB2BDirectDebitMandate?: { __typename?: 'DirectDebitMandate', id: string | number, status: DirectDebitMandateStatus, approvalAction?: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null } | null };

export type RefundPaymentMutationVariables = Exact<{
  contractId: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  externalId: Scalars['String']['input'];
}>;


export type RefundPaymentMutation = { __typename?: 'Mutation', refundPayment?: { __typename?: 'RefundPayment', amount?: number | null, currency?: string | null, status?: string | null, errorMessage?: string | null, executionAction?: { __typename?: 'AccountAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'BatchPaymentActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractChangeAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DocumentAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'StandingOrderActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TransactionAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'WalletAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | null } | null };

export type DismissIndividualNoticeMutationVariables = Exact<{
  noticeId: Scalars['ID']['input'];
}>;


export type DismissIndividualNoticeMutation = { __typename?: 'Mutation', dismissIndividualNotice?: boolean | null };

export type UpsertContractContactMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  contactInfo?: InputMaybe<ContactInfoInput>;
  type?: InputMaybe<ContractContactType>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  contractAuthorizedPersonId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpsertContractContactMutation = { __typename?: 'Mutation', upsertContractContact?: { __typename?: 'ContractContact', id: string | number } | null };

export type DeleteContractContactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContractContactMutation = { __typename?: 'Mutation', deleteContractContact?: boolean | null };

export type UpdateDirectDebitSpendingLimitsMutationVariables = Exact<{
  amount: Scalars['Float']['input'];
  account: Scalars['ID']['input'];
  interval: SpendingLimitIntervalType;
}>;


export type UpdateDirectDebitSpendingLimitsMutation = { __typename?: 'Mutation', updateSpendingLimit?: { __typename?: 'SpendingLimitType', id: string | number, status: SpendingLimitStatusType, interval: SpendingLimitIntervalType, executionAction?: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, type: ActionType, status?: ActionStatus | null } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } } | null> | null } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null } | null };

export type DisputeDirectDebitMutationVariables = Exact<{
  executionId: Scalars['ID']['input'];
}>;


export type DisputeDirectDebitMutation = { __typename?: 'Mutation', disputeDirectDebit?: { __typename?: 'DirectDebitDispute', id: string | number, action: { __typename?: 'AccountAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'BatchPaymentActionType', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'CardIssueRequestAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'ContractChangeAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'ContractTerminationAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DirectDebitAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DirectDebitDisputeAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'DocumentAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'RefundPaymentRequestAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'SpendingLimitRequestAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'StandingOrderActionType', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'TransactionAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'TwoFAOperationActionLike', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'VibanNameMismatchAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } | { __typename?: 'WalletAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null } | null> | null } } | null };

export type AddContractExistingUboMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  uboId: Scalars['ID']['input'];
  ownershipType: UboStakeType;
  shareSize: Scalars['Float']['input'];
}>;


export type AddContractExistingUboMutation = { __typename?: 'Mutation', addContractExistingUbo?: { __typename?: 'ContractUBO', id?: string | number | null, addedFromExistingUbo?: boolean | null, ubo?: { __typename?: 'UBO', id: string | number, entity?: { __typename?: 'Individual', id: number } | { __typename?: 'LegalEntity' } | null } | null } | null };

export type CreateDirectDebitCreditMandateMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  mandate: DirectDebitMandateInput;
}>;


export type CreateDirectDebitCreditMandateMutation = { __typename?: 'Mutation', createDirectDebitCreditMandate?: { __typename?: 'DirectDebitMandate', id: string | number, status: DirectDebitMandateStatus, approvalAction?: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction', signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null } | null };

export type ValidateDirectDebitBatchPaymentFileMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  fileUrl: Scalars['String']['input'];
}>;


export type ValidateDirectDebitBatchPaymentFileMutation = { __typename?: 'Mutation', validateDirectDebitBatchPaymentFile?: { __typename?: 'DirectDebitBatchValidationType', valid: boolean, total: number, validTotal: number, count: number, account: { __typename?: 'Account', id?: string | number | null, currency?: Currency | null }, records: Array<{ __typename?: 'DirectDebitBatchPaymentRecord', value?: number | null, executionDate?: any | null, isValid?: boolean | null, reference?: string | null, errors?: any | null, mandate?: { __typename?: 'DirectDebitMandate', id: string | number, account?: { __typename?: 'Account', currency?: Currency | null } | null, counterpartyDetails?: { __typename?: 'DirectDebitMandateCounterparty', name: string, iban?: string | null } | null } | null }> } | null };

export type StartDirectDebitBatchRequestMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  fileUrl: Scalars['String']['input'];
}>;


export type StartDirectDebitBatchRequestMutation = { __typename?: 'Mutation', startDirectDebitBatchRequest?: { __typename?: 'DirectDebitBatchType', id: string | number, fileUrl: string, status: BatchPaymentStatusType, cancellationReason?: string | null, createdAt: any, account: { __typename?: 'Account', id?: string | number | null, currency?: Currency | null }, executionAction: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signingMethod?: string | null, createdAt?: any | null, updatedAt?: any | null, signedAt?: any | null, action: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType', id: string | number, type: ActionType, status?: ActionStatus | null } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' }, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, signatoryRight?: SignatoryRight | null } | null } | null> | null } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } } | null };

export type TopUpWithCardMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  page: Scalars['String']['input'];
}>;


export type TopUpWithCardMutation = { __typename?: 'Mutation', topUpWithCard?: string | null };

export type SubmitContractForPreAssessmentMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type SubmitContractForPreAssessmentMutation = { __typename?: 'Mutation', submitContractForPreAssessment?: { __typename?: 'BankableEntityContractType', id: number } | null };

export type RequestAccountClosureMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  closureReasonCode: AccountClosureReason;
  closureReasonDescription: Scalars['String']['input'];
}>;


export type RequestAccountClosureMutation = { __typename?: 'Mutation', requestAccountClosure?: { __typename?: 'Account', id?: string | number | null, status?: AccountStatus | null, executionAction?: { __typename?: 'AccountAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signingMethod?: string | null, createdAt?: any | null, updatedAt?: any | null, signedAt?: any | null, action: { __typename?: 'AccountAction', id: string | number, type: ActionType, status?: ActionStatus | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' }, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, signatoryRight?: SignatoryRight | null } | null } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null, executionActions?: Array<{ __typename?: 'AccountAction', id: string | number, status?: ActionStatus | null, type: ActionType, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signingMethod?: string | null, createdAt?: any | null, updatedAt?: any | null, signedAt?: any | null, action: { __typename?: 'AccountAction', id: string | number, type: ActionType, status?: ActionStatus | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' }, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, signatoryRight?: SignatoryRight | null } | null } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null> | null } | null };

export type CreateWalletMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  address: Scalars['String']['input'];
  chainId: Scalars['Int']['input'];
}>;


export type CreateWalletMutation = { __typename?: 'Mutation', createWallet?: { __typename?: 'Wallet', id?: string | number | null, address?: string | null, network?: SupportedCryptoNetwork | null, status?: WalletStatus | null, linkedBy?: { __typename?: 'Individual', id: number } | null, contract?: { __typename?: 'BankableEntityContractType', id: number } | null } | null };

export type ChangeWalletStatusMutationVariables = Exact<{
  walletId: Scalars['ID']['input'];
  action: WalletFlowAction;
  personalSign?: InputMaybe<Scalars['String']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  baseCurrency?: InputMaybe<Currency>;
}>;


export type ChangeWalletStatusMutation = { __typename?: 'Mutation', changeWalletStatus?: { __typename?: 'Wallet', id?: string | number | null, address?: string | null, network?: SupportedCryptoNetwork | null, status?: WalletStatus | null, alias?: string | null, baseCurrency?: Currency | null, linkedBy?: { __typename?: 'Individual', id: number } | null, executionAction?: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | null } | null };

export type DisconnectCryptoWalletFromContractMutationVariables = Exact<{
  walletId: Scalars['ID']['input'];
}>;


export type DisconnectCryptoWalletFromContractMutation = { __typename?: 'Mutation', disconnectCryptoWalletFromContract?: boolean | null };

export type TopUpWithCryptoMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  walletId: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  coin: CryptoCurrency;
  rate: Scalars['Float']['input'];
  slippageTolerance: Scalars['Float']['input'];
  estimatedAmount?: InputMaybe<Scalars['Float']['input']>;
  effectiveRate?: InputMaybe<Scalars['Float']['input']>;
}>;


export type TopUpWithCryptoMutation = { __typename?: 'Mutation', topUpWithCrypto?: { __typename?: 'TransactionRequest', id?: string | number | null, amount?: number | null, status?: TransactionRequestStatus | null } | null };

export type ExecuteOutgoingCryptoMutationVariables = Exact<{
  transactionRequestId: Scalars['ID']['input'];
  trxHash: Scalars['String']['input'];
}>;


export type ExecuteOutgoingCryptoMutation = { __typename?: 'Mutation', executeOutgoingCrypto?: { __typename?: 'TransactionRequest', id?: string | number | null, amount?: number | null, status?: TransactionRequestStatus | null, trxHash?: string | null } | null };

export type SaveWalletBaseCurrencyMutationVariables = Exact<{
  walletId: Scalars['ID']['input'];
  baseCurrency: Currency;
}>;


export type SaveWalletBaseCurrencyMutation = { __typename?: 'Mutation', saveWalletBaseCurrency?: { __typename?: 'Wallet', id?: string | number | null, baseCurrency?: Currency | null, balance?: number | null } | null };

export type ChangeWalletAliasMutationVariables = Exact<{
  walletId: Scalars['ID']['input'];
  alias: Scalars['String']['input'];
}>;


export type ChangeWalletAliasMutation = { __typename?: 'Mutation', changeWalletAlias?: { __typename?: 'Wallet', id?: string | number | null, alias?: string | null } | null };

export type RejectTransactionRequestMutationVariables = Exact<{
  transactionRequestId: Scalars['ID']['input'];
}>;


export type RejectTransactionRequestMutation = { __typename?: 'Mutation', rejectTransactionRequest?: { __typename?: 'TransactionRequest', id?: string | number | null, status?: TransactionRequestStatus | null } | null };

export type CreateOutboundCryptoPaymentMutationVariables = Exact<{
  fromAccountNo: Scalars['ID']['input'];
  walletId: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  coin: CryptoCurrency;
  rate: Scalars['Float']['input'];
  slippageTolerance: Scalars['Float']['input'];
  estimatedAmount?: InputMaybe<Scalars['Float']['input']>;
  effectiveRate?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CreateOutboundCryptoPaymentMutation = { __typename?: 'Mutation', createOutboundCryptoPayment?: { __typename?: 'CreditTransaction' } | { __typename?: 'DebitTransaction' } | null };

export type DepositAddressMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  coin: CryptoCurrency;
  network: SupportedCryptoNetwork;
  transactionRequestId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DepositAddressMutation = { __typename?: 'Mutation', cryptoDepositAddress?: string | null };

export type ChangeCardPinMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
  challengeId: Scalars['String']['input'];
  code: Scalars['ID']['input'];
}>;


export type ChangeCardPinMutation = { __typename?: 'Mutation', changeCardPin?: { __typename?: 'CardSensitiveInfoRef', token?: string | null, url?: string | null } | null };

export type FinishSetupMobileTwoFaForIndividualMutationVariables = Exact<{ [key: string]: never; }>;


export type FinishSetupMobileTwoFaForIndividualMutation = { __typename?: 'Mutation', finishSetupMobileTwoFaForIndividual?: boolean | null };

export type GetViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewerQuery = { __typename?: 'Query', viewer?: { __typename?: 'ApiUser' } | { __typename?: 'Individual', id: number, email?: string | null, emailPendingChange?: string | null, videoVerificationStatus?: VideoVerificationStatus | null, videoVerified?: boolean | null, isVerified?: boolean | null, isPhoneVerified?: boolean | null, isPhoneVerificationRequired?: boolean | null, isEmailVerificationRequired?: boolean | null, isIntroducer?: boolean | null, requireAccount?: string | null, firstName?: string | null, lastName?: string | null, birthday?: any | null, nationality?: Nationality | null, phone?: string | null, secondaryPhones?: { __typename?: 'SecondaryPhones', secondaryPhone1?: string | null } | null, secondaryEmails?: { __typename?: 'SecondaryEmails', secondaryEmail1?: string | null, secondaryEmail2?: string | null, secondaryEmail3?: string | null } | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, zip?: string | null, region?: string | null, country?: Country | null } | null } | { __typename?: 'User' } | null };

export type GetContractApplicantQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContractApplicantQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', createdBy?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null, email?: string | null } | null } | null };

export type GetContractStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContractStatusQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, isSigned?: boolean | null, ownerType?: UboType | null, allowVbanCreation?: boolean | null, allowLocalPay?: boolean | null, type?: ContractType | null, ownershipTransferInitiated?: boolean | null, allowedCryptoPayments?: AllowedCryptoPayments | null, owner: { __typename?: 'Individual', address?: { __typename?: 'Address', country?: Country | null } | null } | { __typename?: 'LegalEntity', address?: { __typename?: 'Address', country?: Country | null } | null } } | null };

export type GetContractDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContractDetailsQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, type?: ContractType | null, directDebitCreditorId?: string | null, allowedCryptoPayments?: AllowedCryptoPayments | null, signatoriesCount?: number | null, isIntroducingPartner?: boolean | null, referralLink?: string | null, ownerType?: UboType | null, signatories?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, isLimitedAccessHolder?: boolean | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, status?: AuthorizedPersonStatuses | null } | null> | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, isLimitedAccessHolder?: boolean | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, invitationDate?: any | null, cannotSignOwnActions?: boolean | null, status?: AuthorizedPersonStatuses | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null, lastSeenAt?: any | null, lastLogin?: any | null } | null } | null> | null, ubos?: Array<{ __typename?: 'ContractUBO', id?: string | number | null, shareSize?: number | null, addedFromExistingUbo?: boolean | null } | null> | null, owner: { __typename?: 'Individual' } | { __typename?: 'LegalEntity', id: number, companyName?: string | null, tradingName?: string | null, companyType?: CompanyType | null, legalEntityType?: UboLegalEntityType | null, companyRegistrationId?: string | null, companyRegistrationDate?: any | null, phone?: string | null, websites?: Array<string | null> | null, website?: string | null, businessSector?: string | null, businessDescription?: string | null, countriesOfOperatingAndConductingBusiness?: Array<CountriesAndRegionsType | null> | null, taxId?: string | null, servingIndustries?: Array<string | null> | null, companyClientsCountries?: Array<CountriesAndRegionsType | null> | null, address?: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null, correspondenceAddress?: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null, transactionalPartners?: Array<{ __typename?: 'TransactionalPartner', name?: string | null, country?: Country | null } | null> | null, economicProfile?: { __typename?: 'EconomicProfile', sourceOfFunds?: Array<SourceOfFunds | null> | null, sourceOfFundsDescription?: string | null, currencies?: Array<string | null> | null, turnover?: EconomicAverageSize | null, averageInbound?: EconomicAverageSize | null, averageOutbound?: EconomicAverageSize | null, estimateInbound?: number | null, estimateOutbound?: number | null, inboundSources?: Array<EconomicProfileInboundSource | null> | null, inboundSourcesOther?: string | null, outboundDestinations?: Array<EconomicProfileOutboundDestination | null> | null, outboundDestinationsOther?: string | null, anticipatedAccountActivity?: Array<AnticipatedAccountActivities | null> | null, products?: Array<Products | null> | null } | null }, preAssessment?: { __typename?: 'PreAssessment', regulatoryInfoName?: string | null, regulatoryInfoLicenseNumber?: string | null, paymentProviders?: string | null, conductingKYC?: string | null, conductingClientKYC?: string | null, conductPublisherContentMonitoring?: string | null, clientsYouWorkWith?: string | null, companyAnnualIncome?: string | null, incomingMonthlyTurnover?: string | null, incomingClients?: string | null, outgoingMonthlyTurnover?: string | null, outgoingClients?: string | null, currencyAndVolume?: Array<string | null> | null, contactPersonFullName?: string | null, contactPersonEmail?: string | null, contactPersonPhoneNumber?: string | null, countryOfTaxResidence?: string | null, licenseRequired?: boolean | null, licenseCountry?: string | null, uboResidencies?: Array<Array<CountriesAndRegionsType | null> | null> | null, noPartnersIncomingRequired?: boolean | null, noPartnersOutgoingRequired?: boolean | null, businessRelationshipWithCompany?: string | null, businessRelationshipWithCompanyExplanation?: string | null, partnersIncoming?: Array<{ __typename?: 'PreAssessmentPartner', name?: string | null, country?: string | null, bankCountry?: string | null, businessSector?: string | null, paymentPurpose?: Array<EconomicProfileInboundOutboundSource | null> | null, paymentPurposeOther?: string | null, website?: string | null } | null> | null, partnersOutgoing?: Array<{ __typename?: 'PreAssessmentPartner', name?: string | null, country?: string | null, bankCountry?: string | null, businessSector?: string | null, paymentPurpose?: Array<EconomicProfileInboundOutboundSource | null> | null, paymentPurposeOther?: string | null, website?: string | null } | null> | null, cardPayment?: { __typename?: 'CardPaymentsAndAMP', isCardPayment?: boolean | null, transactionalCurrencies?: Array<Currency | null> | null, requiredSettlementCurrencies?: Array<Currency | null> | null, merchantWebsites?: Array<string | null> | null, cardPaymentsTransactionalDataRegion?: Array<{ __typename?: 'CardPaymentsTransactionalDataRegion', businessCategoryRegion?: BusinessRegion | null, businessCategoryPercentage?: number | null } | null> | null, totalPredictedMonthlyVolumesVisa?: { __typename?: 'TotalPredictedMonthlyVolumes', domestic?: number | null, eea?: number | null, nonEea?: number | null } | null, totalPredictedMonthlyVolumesMasterCard?: { __typename?: 'TotalPredictedMonthlyVolumes', domestic?: number | null, eea?: number | null, nonEea?: number | null } | null, ampCurrentlyInUse?: Array<{ __typename?: 'AmpInUse', ampInUseTypeCurrentlyInUse?: string | null, monthlyVolumeInEuro?: string | null } | null> | null, ampRequiredCurrentlyInUse?: Array<{ __typename?: 'AmpInUse', ampInUseTypeCurrentlyInUse?: string | null, monthlyVolumeInEuro?: string | null } | null> | null, riskManagement?: { __typename?: 'CardProcessingRiskManagement', useAffiliateForGeneratingTraffic?: boolean | null, affiliatesUsed?: Array<string | null> | null, useCredentialOnFilesBillingSalesMethod?: boolean | null, relevantCredentialOnFilesBillingSalesMethod?: RelevantCredentialOnFilesBillingSalesMethod | null, credentialDetailsExplanation?: string | null } | null, pciDssCompliance?: { __typename?: 'PciDssCompliance', integrationTypeRequired?: Array<IntegrationTypeRequired | null> | null, dssCompliance?: Array<DssCompliance | null> | null, pciProviderName?: string | null } | null, processingHistory?: { __typename?: 'CardProcessingHistory', processPaymentCardsBefore?: boolean | null, nameOfCurrentFormerProcessor?: string | null, reasonForLeavingCurrentProcessor?: string | null, periodOfTimeWithCurrentFormerProcessor?: string | null, processingHistoryStatement?: { __typename?: 'Document', id: number, type?: DocumentType | null, contractId?: string | number | null, firstSide?: { __typename?: 'DocumentSide', fileName?: string | null, url?: string | null, size?: number | null, mimeType?: string | null } | null } | null } | null } | null } | null } | null };

export type GetUserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserDataQuery = { __typename?: 'Query', viewer?: { __typename?: 'ApiUser' } | { __typename?: 'Individual', id: number, taxId?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, birthday?: any | null, nationality?: Nationality | null, phone?: string | null, lastSeenAt?: any | null, lastLogin?: any | null, isPhoneVerified?: boolean | null, isPhoneVerificationRequired?: boolean | null, videoVerified?: boolean | null, isVerified?: boolean | null, videoVerificationStatus?: VideoVerificationStatus | null, isEmailVerificationRequired?: boolean | null, emailConfirmed?: boolean | null, primaryTwoFAMethod?: TwoFaMethod | null, company?: string | null, isIntroducer?: boolean | null, requireAccount?: string | null, address?: { __typename?: 'Address', additionalDetails?: string | null, city?: string | null, country?: Country | null, line1?: string | null, zip?: string | null } | null, contracts?: Array<{ __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, type?: ContractType | null, isIntroducingPartner?: boolean | null, individualViewerRoles?: Array<IndividualContractRole | null> | null, individualViewerOnboardingRequiredChecks?: Array<IndividualContractOnboardingRequiredCheck | null> | null, ownerType?: UboType | null, createdBy?: { __typename?: 'Individual', id: number } | null, owner: { __typename?: 'Individual' } | { __typename?: 'LegalEntity', companyName?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, zip?: string | null, country?: Country | null, additionalDetails?: string | null } | null }, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, isAuthorizedSignatory?: boolean | null, isLimitedAccessHolder?: boolean | null, cannotSignOwnActions?: boolean | null, limitedAccessRight?: LimitedAccessRight | null, groupSize?: number | null, status?: AuthorizedPersonStatuses | null, balanceCurrency?: NewAccountCurrency | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null, preAssessment?: { __typename?: 'PreAssessment', cardPayment?: { __typename?: 'CardPaymentsAndAMP', isCardPayment?: boolean | null } | null } | null } | null> | null, pendingContractOwnershipTransfers?: Array<{ __typename?: 'ContractOwnershipTransfer', id: string | number, fromIndividual?: { __typename?: 'Individual', id: number, fullName?: string | null, email?: string | null } | null, contract?: { __typename?: 'BankableEntityContractType', id: number, owner: { __typename?: 'Individual' } | { __typename?: 'LegalEntity', companyName?: string | null } } | null }> | null, notices?: Array<{ __typename?: 'Notice', id?: string | number | null, message?: string | null, url?: string | null, type?: NoticeType | null } | null> | null } | { __typename?: 'User' } | null };

export type GetDefaultUserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultUserDataQuery = { __typename?: 'Query', viewer?: { __typename?: 'ApiUser' } | { __typename?: 'Individual', id: number, taxId?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, birthday?: any | null, nationality?: Nationality | null, phone?: string | null, lastSeenAt?: any | null, lastLogin?: any | null, isPhoneVerified?: boolean | null, isPhoneVerificationRequired?: boolean | null, videoVerified?: boolean | null, isVerified?: boolean | null, videoVerificationStatus?: VideoVerificationStatus | null, isEmailVerificationRequired?: boolean | null, emailConfirmed?: boolean | null, primaryTwoFAMethod?: TwoFaMethod | null, company?: string | null, isIntroducer?: boolean | null, requireAccount?: string | null, address?: { __typename?: 'Address', additionalDetails?: string | null, city?: string | null, country?: Country | null, line1?: string | null, zip?: string | null } | null, contracts?: Array<{ __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, type?: ContractType | null, isIntroducingPartner?: boolean | null, individualViewerRoles?: Array<IndividualContractRole | null> | null, individualViewerOnboardingRequiredChecks?: Array<IndividualContractOnboardingRequiredCheck | null> | null, ownerType?: UboType | null, createdBy?: { __typename?: 'Individual', id: number } | null, owner: { __typename?: 'Individual' } | { __typename?: 'LegalEntity', companyName?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, zip?: string | null, country?: Country | null, additionalDetails?: string | null } | null }, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, isAuthorizedSignatory?: boolean | null, isLimitedAccessHolder?: boolean | null, cannotSignOwnActions?: boolean | null, limitedAccessRight?: LimitedAccessRight | null, groupSize?: number | null, status?: AuthorizedPersonStatuses | null, balanceCurrency?: NewAccountCurrency | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null, preAssessment?: { __typename?: 'PreAssessment', cardPayment?: { __typename?: 'CardPaymentsAndAMP', isCardPayment?: boolean | null } | null } | null } | null> | null, pendingContractOwnershipTransfers?: Array<{ __typename?: 'ContractOwnershipTransfer', id: string | number, fromIndividual?: { __typename?: 'Individual', id: number, fullName?: string | null, email?: string | null } | null, contract?: { __typename?: 'BankableEntityContractType', id: number, owner: { __typename?: 'Individual' } | { __typename?: 'LegalEntity', companyName?: string | null } } | null }> | null, notices?: Array<{ __typename?: 'Notice', id?: string | number | null, message?: string | null, url?: string | null, type?: NoticeType | null } | null> | null } | { __typename?: 'User' } | null };

export type GetProfileChangesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileChangesQuery = { __typename?: 'Query', viewer?: { __typename?: 'ApiUser' } | { __typename?: 'Individual', id: number, email?: string | null, phone?: string | null, lastName?: string | null, firstName?: string | null, birthday?: any | null, nationality?: Nationality | null, taxId?: string | null, address?: { __typename?: 'Address', country?: Country | null, city?: string | null, line1?: string | null, zip?: string | null, additionalDetails?: string | null } | null, profileChanges?: Array<{ __typename?: 'ProfileChange', id?: number | null, status?: ProfileChangeStatus | null, answers?: { __typename?: 'ProfileChangeAnswers', lastName?: string | null, firstName?: string | null, birthday?: any | null, nationality?: Nationality | null, address?: { __typename?: 'Address', country?: Country | null, city?: string | null, line1?: string | null, zip?: string | null, additionalDetails?: string | null } | null } | null, individual?: { __typename?: 'Individual', id: number, email?: string | null, phone?: string | null, lastName?: string | null, firstName?: string | null, birthday?: any | null, nationality?: Nationality | null, taxId?: string | null, address?: { __typename?: 'Address', country?: Country | null, city?: string | null, line1?: string | null, zip?: string | null, additionalDetails?: string | null } | null } | null } | null> | null } | { __typename?: 'User' } | null };

export type GetUserContractsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserContractsQuery = { __typename?: 'Query', contracts?: Array<{ __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, type?: ContractType | null, ownerType?: UboType | null, activatedOn?: any | null, owner: { __typename?: 'Individual', id: number, fullName?: string | null, isVerified?: boolean | null, isPhoneVerified?: boolean | null, documentsCount?: number | null } | { __typename?: 'LegalEntity', id: number, companyName?: string | null, legalEntityType?: UboLegalEntityType | null, legalEntityDirectors?: Array<{ __typename?: 'LegalEntityDirector', id: string | number } | null> | null }, createdBy?: { __typename?: 'Individual', id: number } | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, status?: AuthorizedPersonStatuses | null, isAuthorizedSignatory?: boolean | null, isLimitedAccessHolder?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, invitationDate?: any | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null, registration?: any | null, lastSeenAt?: any | null, lastLogin?: any | null } | null } | null> | null, ubos?: Array<{ __typename?: 'ContractUBO', id?: string | number | null } | null> | null, contacts?: Array<{ __typename?: 'ContractContact', id: string | number } | null> | null } | null> | null };

export type GetDocumentsQueryQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type GetDocumentsQueryQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', id: number, documents?: Array<{ __typename?: 'Document', id: number, type?: DocumentType | null, fileName?: string | null, mimeType?: string | null, createdAt?: any | null, size?: number | null, fileDescription?: string | null, expiration?: any | null, individual?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null, legalEntity?: { __typename?: 'LegalEntity', id: number, companyName?: string | null } | null } | null> | null } | null };

export type GetAuthorizedPersonsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAuthorizedPersonsQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', id: number, ubos?: Array<{ __typename?: 'ContractUBO', id?: string | number | null, addedFromExistingUbo?: boolean | null, ubo?: { __typename?: 'UBO', id: string | number, entity?: { __typename?: 'Individual', id: number, email?: string | null } | { __typename?: 'LegalEntity' } | null } | null } | null> | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, status?: AuthorizedPersonStatuses | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null, isPhoneVerified?: boolean | null, videoVerified?: boolean | null, isVerified?: boolean | null, videoVerificationStatus?: VideoVerificationStatus | null } | null } | null> | null } | null };

export type GetDirectorsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDirectorsQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', id: number, owner: { __typename?: 'Individual' } | { __typename?: 'LegalEntity', id: number, legalEntityDirectors?: Array<{ __typename?: 'LegalEntityDirector', id: string | number, role?: DirectorRole | null, signingRight?: DirectorSigningRights | null, individual?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null, fullName?: string | null, email?: string | null, birthday?: any | null, nationality?: Nationality | null, phone?: string | null, taxId?: string | null, isPep?: boolean | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, zip?: string | null, country?: Country | null, countryDescription?: string | null, additionalDetails?: string | null } | null } | null } | null> | null } } | null };

export type GetDirectorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDirectorQuery = { __typename?: 'Query', getLegalEntityDirector?: { __typename?: 'LegalEntityDirector', id: string | number, role?: DirectorRole | null, signingRight?: DirectorSigningRights | null, individual?: { __typename?: 'Individual', fullName?: string | null, email?: string | null, phone?: string | null, birthday?: any | null, nationality?: Nationality | null, address?: { __typename?: 'Address', country?: Country | null, city?: string | null, line1?: string | null, zip?: string | null, additionalDetails?: string | null } | null } | null } | null };

export type GetContractRelatedIndividualsQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type GetContractRelatedIndividualsQuery = { __typename?: 'Query', getContractRelatedIndividuals?: Array<{ __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null> | null };

export type GetContractLegalEntityQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type GetContractLegalEntityQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', owner: { __typename?: 'Individual' } | { __typename?: 'LegalEntity', id: number, companyName?: string | null } } | null };

export type GetAuthorizedPersonsDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAuthorizedPersonsDataQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', id: number, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, groupSize?: number | null, isAuthorizedSignatory?: boolean | null, isLimitedAccessHolder?: boolean | null, cannotSignOwnActions?: boolean | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, status?: AuthorizedPersonStatuses | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null, email?: string | null, birthday?: any | null, nationality?: Nationality | null, phone?: string | null, taxId?: string | null, isPep?: boolean | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, zip?: string | null, country?: Country | null, countryDescription?: string | null, additionalDetails?: string | null } | null } | null } | null> | null } | null };

export type GetOwnerSizeTypeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOwnerSizeTypeQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, type?: ContractType | null, ubos?: Array<{ __typename?: 'ContractUBO', id?: string | number | null, shareSize?: number | null, ownershipType?: UboStakeType | null } | null> | null, owner: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | { __typename?: 'LegalEntity', id: number, companyRegistrationId?: string | null, companyName?: string | null, legalEntityType?: UboLegalEntityType | null } } | null };

export type GetUbosListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUbosListQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', id: number, owner: { __typename?: 'Individual' } | { __typename?: 'LegalEntity', id: number, companyName?: string | null, legalEntityType?: UboLegalEntityType | null }, ubos?: Array<{ __typename?: 'ContractUBO', id?: string | number | null, shareSize?: number | null, ownershipType?: UboStakeType | null, addedFromExistingUbo?: boolean | null, ubo?: { __typename?: 'UBO', id: string | number, ownersTotalShareSize?: number | null, entity?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | { __typename?: 'LegalEntity', id: number, companyName?: string | null, legalEntityType?: UboLegalEntityType | null } | null } | null } | null> | null } | null };

export type GetUboOwnersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUboOwnersQuery = { __typename?: 'Query', getUboOwners?: Array<{ __typename?: 'UBOOwner', id?: string | number | null, level?: number | null, ownedUboId?: string | number | null, shareSize?: number | null, ownershipType?: UboStakeType | null, ubo?: { __typename?: 'UBO', id: string | number, ownersTotalShareSize?: number | null, entity?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | { __typename?: 'LegalEntity', id: number, companyName?: string | null, legalEntityType?: UboLegalEntityType | null } | null, ownersFlatList?: Array<{ __typename?: 'UBOOwner', id?: string | number | null, level?: number | null, ownedUboId?: string | number | null, shareSize?: number | null, ownershipType?: UboStakeType | null, ubo?: { __typename?: 'UBO', id: string | number, ownersTotalShareSize?: number | null, entity?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | { __typename?: 'LegalEntity', id: number, companyName?: string | null, legalEntityType?: UboLegalEntityType | null } | null } | null } | null> | null } | null } | null> | null };

export type GetUboOwnersDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUboOwnersDetailsQuery = { __typename?: 'Query', getUboOwners?: Array<{ __typename?: 'UBOOwner', id?: string | number | null, ownedUboId?: string | number | null, shareSize?: number | null, ownershipType?: UboStakeType | null, ubo?: { __typename?: 'UBO', entity?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, birthday?: any | null, isPep?: boolean | null, usReportablePerson?: boolean | null, taxId?: string | null, nationality?: Nationality | null, address?: { __typename?: 'Address', country?: Country | null, line1?: string | null, additionalDetails?: string | null, zip?: string | null, city?: string | null } | null, documents?: Array<{ __typename?: 'Document', id: number, type?: DocumentType | null, expiration?: any | null, createdAt?: any | null, firstSide?: { __typename?: 'DocumentSide', fileName?: string | null, mimeType?: string | null, size?: number | null, url?: string | null } | null, secondSide?: { __typename?: 'DocumentSide', fileName?: string | null, mimeType?: string | null, size?: number | null, url?: string | null } | null } | null> | null } | { __typename?: 'LegalEntity', id: number, legalEntityType?: UboLegalEntityType | null, companyName?: string | null, companyRegistrationId?: string | null, companyRegistrationDate?: any | null, address?: { __typename?: 'Address', country?: Country | null, line1?: string | null, additionalDetails?: string | null, zip?: string | null, city?: string | null } | null } | null } | null } | null> | null };

export type GetUboDetailsQueryVariables = Exact<{
  contractUboId: Scalars['ID']['input'];
}>;


export type GetUboDetailsQuery = { __typename?: 'Query', getContractUbo?: { __typename?: 'ContractUBO', id?: string | number | null, shareSize?: number | null, ownershipType?: UboStakeType | null, ubo?: { __typename?: 'UBO', entity?: { __typename?: 'Individual', id: number, taxId?: string | null, firstName?: string | null, lastName?: string | null, birthday?: any | null, nationality?: Nationality | null, isPep?: boolean | null, usReportablePerson?: boolean | null, address?: { __typename?: 'Address', country?: Country | null, line1?: string | null, additionalDetails?: string | null, zip?: string | null, city?: string | null } | null, documents?: Array<{ __typename?: 'Document', id: number, type?: DocumentType | null, expiration?: any | null, createdAt?: any | null, firstSide?: { __typename?: 'DocumentSide', fileName?: string | null, mimeType?: string | null, size?: number | null, url?: string | null } | null, secondSide?: { __typename?: 'DocumentSide', fileName?: string | null, mimeType?: string | null, size?: number | null, url?: string | null } | null } | null> | null } | { __typename?: 'LegalEntity', id: number, companyName?: string | null, legalEntityType?: UboLegalEntityType | null, companyRegistrationId?: string | null, companyRegistrationDate?: any | null, address?: { __typename?: 'Address', country?: Country | null, line1?: string | null, additionalDetails?: string | null, zip?: string | null, city?: string | null } | null } | null } | null } | null };

export type ContractIndividualOwnersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContractIndividualOwnersQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', ubos?: Array<{ __typename?: 'ContractUBO', id?: string | number | null, addedFromExistingUbo?: boolean | null, ubo?: { __typename?: 'UBO', id: string | number, entity?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null, email?: string | null, birthday?: any | null, nationality?: Nationality | null, phone?: string | null, address?: { __typename?: 'Address', country?: Country | null, line1?: string | null, additionalDetails?: string | null, zip?: string | null, city?: string | null } | null } | { __typename?: 'LegalEntity' } | null } | null } | null> | null } | null };

export type GetVideoVerificationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVideoVerificationStatusQuery = { __typename?: 'Query', getVideoVerificationStatus?: string | null };

export type GetContractUboByUboIdQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
  uboId: Scalars['ID']['input'];
}>;


export type GetContractUboByUboIdQuery = { __typename?: 'Query', getContractUboByUboId?: { __typename?: 'ContractUBO', id?: string | number | null, shareSize?: number | null, ownershipType?: UboStakeType | null, ubo?: { __typename?: 'UBO', entity?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null, birthday?: any | null, nationality?: Nationality | null, address?: { __typename?: 'Address', country?: Country | null, line1?: string | null, additionalDetails?: string | null, zip?: string | null, city?: string | null } | null, documents?: Array<{ __typename?: 'Document', id: number, type?: DocumentType | null, fileName?: string | null, mimeType?: string | null, createdAt?: any | null, size?: number | null } | null> | null } | { __typename?: 'LegalEntity', id: number, companyName?: string | null, legalEntityType?: UboLegalEntityType | null, companyRegistrationId?: string | null, companyRegistrationDate?: any | null, address?: { __typename?: 'Address', country?: Country | null, line1?: string | null, additionalDetails?: string | null, zip?: string | null, city?: string | null } | null } | null } | null } | null };

export type GetUboQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUboQuery = { __typename?: 'Query', getUbo?: { __typename?: 'UBO', id: string | number, entity?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null, birthday?: any | null, nationality?: Nationality | null, address?: { __typename?: 'Address', country?: Country | null, line1?: string | null, additionalDetails?: string | null, zip?: string | null, city?: string | null } | null, documents?: Array<{ __typename?: 'Document', id: number, type?: DocumentType | null, fileName?: string | null, mimeType?: string | null, createdAt?: any | null, size?: number | null } | null> | null } | { __typename?: 'LegalEntity', id: number, companyName?: string | null, legalEntityType?: UboLegalEntityType | null, companyRegistrationId?: string | null, companyRegistrationDate?: any | null, address?: { __typename?: 'Address', country?: Country | null, line1?: string | null, additionalDetails?: string | null, zip?: string | null, city?: string | null } | null } | null } | null };

export type GetUboOwnersListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUboOwnersListQuery = { __typename?: 'Query', getUboOwners?: Array<{ __typename?: 'UBOOwner', id?: string | number | null, shareSize?: number | null, ownershipType?: UboStakeType | null, ubo?: { __typename?: 'UBO', id: string | number } | null } | null> | null };

export type GetActionsQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActionStatus>;
  statuses?: InputMaybe<Array<InputMaybe<ActionStatus>> | InputMaybe<ActionStatus>>;
  types?: InputMaybe<Array<InputMaybe<ActionType>> | InputMaybe<ActionType>>;
}>;


export type GetActionsQuery = { __typename?: 'Query', actions?: Array<{ __typename?: 'AccountAction', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null, account?: { __typename?: 'Account', id?: string | number | null, alias?: string | null, currency?: Currency | null, accountNumber?: string | null } | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, newAuthorizedPerson?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, isLimitedAccessHolder?: boolean | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', fullName?: string | null, firstName?: string | null, lastName?: string | null } | null } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'BatchPaymentActionType', id: string | number, initiatorName?: string | null, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, batchPayment?: { __typename?: 'BatchPayment', id?: string | number | null, status?: BatchPaymentStatusType | null, calculatedValidTotal?: number | null, account?: { __typename?: 'Account', id?: string | number | null, accountNumber?: string | null, alias?: string | null, currency?: Currency | null, iban?: string | null, swiftBIC?: string | null } | null, paymentRecords?: Array<{ __typename?: 'BatchPaymentRecord', id?: string | number | null, amount?: number | null, currency?: string | null, beneficiaryName?: string | null, beneficiaryAccountId?: string | null, bankBic?: string | null, priority?: string | null, reference?: string | null, status?: BatchPaymentRecordStatus | null, isValid?: boolean | null, payoutAmount?: number | null, payoutCurrency?: string | null, useLocalAchPayout?: boolean | null } | null> | null } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'CardIssueRequestAction', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, cardRequest?: { __typename?: 'CardRequestType', card?: { __typename?: 'CardType', type?: ApiCardTypes | null } | null } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'ContractChangeAction', id: string | number, type: ActionType, executedAt?: any | null, createdAt?: any | null, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'DirectDebitAction', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, directDebit?: { __typename?: 'DirectDebitMandate', id: string | number, status: DirectDebitMandateStatus, creditorId?: string | null, mandateId?: string | null, account?: { __typename?: 'Account', id?: string | number | null, alias?: string | null, iban?: string | null, currency?: Currency | null } | null, counterpartyDetails?: { __typename?: 'DirectDebitMandateCounterparty', name: string, bic?: string | null, iban?: string | null, address?: { __typename?: 'Address', line1?: string | null, country?: Country | null } | null } | null, document?: { __typename?: 'Document', url?: string | null } | null } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'DocumentAction', id: string | number, type: ActionType, executedAt?: any | null, createdAt?: any | null, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, document?: { __typename?: 'Document', id: number, type?: DocumentType | null, fileDescription?: string | null } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, refundPayment?: { __typename?: 'RefundPayment', paymentId?: string | null, externalId?: string | null, amount?: number | null, currency?: string | null } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'StandingOrderActionType', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, standingOrder?: { __typename?: 'StandingOrder', id: string | number } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, contractTerm?: { __typename?: 'ContractTerms', term: { __typename?: 'TermsAndCondition', id?: string | number | null, version?: string | number | null, url?: string | null } } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'TransactionAction', id: string | number, type: ActionType, executedAt?: any | null, createdAt?: any | null, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, transaction?: { __typename?: 'CreditTransaction', id?: string | number | null, value?: number | null, currency?: string | null, account?: { __typename?: 'Account', id?: string | number | null, alias?: string | null } | null } | { __typename?: 'DebitTransaction', id?: string | number | null, value?: number | null, currency?: string | null, isLocal?: boolean | null, isInterContract?: boolean | null, account?: { __typename?: 'Account', id?: string | number | null, alias?: string | null } | null, to?: { __typename?: 'TransactionParty', name?: string | null } | null } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, signedAt?: any | null, status?: ActionSignatureStatus | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number }, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, spendingLimit?: { __typename?: 'SpendingLimitType', interval: SpendingLimitIntervalType, type: SpendingLimitTypeType, amount: number, account?: { __typename?: 'Account', iban?: string | null, alias?: string | null, currency?: Currency | null } | null } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'WalletAction', id: string | number, executedAt?: any | null, createdAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | null> | null };

export type GetPendingSpendingLimitActionsQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetPendingSpendingLimitActionsQuery = { __typename?: 'Query', actions?: Array<{ __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction', id: string | number, spendingLimitRequest?: { __typename?: 'SpendingLimitRequestType', id: string | number, card?: { __typename?: 'CardType', id: string | number, currency?: Currency | null } | null, limits?: Array<{ __typename?: 'LimitObjectType', limitType: CardSpendingLimitTypes, amount: number } | null> | null, oldLimits?: Array<{ __typename?: 'LimitObjectType', limitType: CardSpendingLimitTypes, amount: number } | null> | null } | null } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null> | null };

export type GetActionsCountQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActionStatus>;
  statuses?: InputMaybe<Array<InputMaybe<ActionStatus>> | InputMaybe<ActionStatus>>;
  types?: InputMaybe<Array<InputMaybe<ActionType>> | InputMaybe<ActionType>>;
}>;


export type GetActionsCountQuery = { __typename?: 'Query', actionsCount?: number | null };

export type GetActionDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetActionDetailsQuery = { __typename?: 'Query', action?: { __typename?: 'AccountAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, account?: { __typename?: 'Account', id?: string | number | null, iban?: string | null, name?: string | null, isVirtual?: boolean | null, createdAt?: any | null, currency?: Currency | null, virtualDetails?: { __typename?: 'VirtualAccountDetails', entityType?: UboType | null, companyRegistrationNumber?: string | null, companyRegistrationDate?: any | null, name?: string | null, dateOfBirth?: any | null, nationality?: Nationality | null, registeredAddress?: { __typename?: 'Address', line1?: string | null, city?: string | null, zip?: string | null, country?: Country | null, additionalDetails?: string | null } | null } | null } | null, alternativeAccountDetails?: { __typename?: 'SwiftTransferIndividualPartyDetails', accountNo?: string | null, bankBic?: string | null, bankBranchId?: string | null, bankBranchName?: string | null, bankClearingMemberId?: string | null, bankName?: string | null, iban?: string | null, name: string, phone?: string | null, taxId?: string | null, type?: SwiftTransferRecipientType | null, address: { __typename?: 'Address', additionalDetails?: string | null, city?: string | null, country?: Country | null, line1?: string | null, region?: string | null, zip?: string | null } } | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, newAuthorizedPerson?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, isLimitedAccessHolder?: boolean | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number, fullName?: string | null, firstName?: string | null, lastName?: string | null } | null } | null } | { __typename?: 'BatchPaymentActionType', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, initiatorName?: string | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, batchPayment?: { __typename?: 'BatchPayment', id?: string | number | null, status?: BatchPaymentStatusType | null, calculatedValidTotal?: number | null, account?: { __typename?: 'Account', id?: string | number | null, accountNumber?: string | null, alias?: string | null, currency?: Currency | null, iban?: string | null, swiftBIC?: string | null } | null } | null } | { __typename?: 'CardIssueRequestAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, cardRequest?: { __typename?: 'CardRequestType', id: number, limits?: Array<{ __typename?: 'LimitObjectType', limitType: CardSpendingLimitTypes, amount: number } | null> | null, holder?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, person?: { __typename?: 'Individual', id: number, fullName?: string | null } | null } | null, card?: { __typename?: 'CardType', id: string | number, alias?: string | null, type?: ApiCardTypes | null, limitsWithUsage?: Array<{ __typename?: 'CardLimitWithUsage', limitType: CardSpendingLimitTypes, amount: number } | null> | null, account?: { __typename?: 'Account', id?: string | number | null, currency?: Currency | null } | null, apiDeliveryAddress?: { __typename?: 'Address', additionalDetails?: string | null, city?: string | null, country?: Country | null, line1?: string | null, zip?: string | null } | null } | null } | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, deactivatedAuthorizedPerson?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, isAuthorizedSignatory?: boolean | null, limitedAccessRight?: LimitedAccessRight | null, isLimitedAccessHolder?: boolean | null, id?: number | null, person?: { __typename?: 'Individual', id: number, fullName?: string | null } | null } | null } | { __typename?: 'ContractChangeAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null, owner: { __typename?: 'Individual' } | { __typename?: 'LegalEntity', id: number, companyName?: string | null, tradingName?: string | null, phone?: string | null, website?: string | null, address?: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null, correspondenceAddress?: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null } } | null, contractChange?: { __typename?: 'ProfileChange', id?: number | null, status?: ProfileChangeStatus | null, changeAnswers?: { __typename?: 'ContractProfileChangeAnswers', companyName?: string | null, tradingName?: string | null, taxId?: string | null, phone?: string | null, businessSector?: string | null, businessDescription?: string | null, websites?: Array<string | null> | null, countriesOfOperatingAndConductingBusiness?: Array<CountriesAndRegionsType | null> | null, transactionalPartners?: Array<{ __typename?: 'TransactionalPartner', name?: string | null, country?: Country | null } | null> | null, economicProfile?: { __typename?: 'EconomicProfile', sourceOfFunds?: Array<SourceOfFunds | null> | null, anticipatedAccountActivity?: Array<AnticipatedAccountActivities | null> | null, products?: Array<Products | null> | null, sourceOfFundsDescription?: string | null, inboundSources?: Array<EconomicProfileInboundSource | null> | null, inboundSourcesOther?: string | null, estimateInbound?: number | null, estimateOutbound?: number | null, outboundDestinations?: Array<EconomicProfileOutboundDestination | null> | null, outboundDestinationsOther?: string | null, turnover?: EconomicAverageSize | null, averageInbound?: EconomicAverageSize | null, averageOutbound?: EconomicAverageSize | null } | null, address?: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null, correspondenceAddress?: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null, preAssessment?: { __typename?: 'PreAssessment', regulatoryInfoName?: string | null, regulatoryInfoLicenseNumber?: string | null, paymentProviders?: string | null, conductingKYC?: string | null, conductingClientKYC?: string | null, conductPublisherContentMonitoring?: string | null, clientsYouWorkWith?: string | null, companyAnnualIncome?: string | null, incomingMonthlyTurnover?: string | null, incomingClients?: string | null, outgoingMonthlyTurnover?: string | null, outgoingClients?: string | null, currencyAndVolume?: Array<string | null> | null, contactPersonFullName?: string | null, contactPersonEmail?: string | null, contactPersonPhoneNumber?: string | null, countryOfTaxResidence?: string | null, licenseRequired?: boolean | null, licenseCountry?: string | null, uboResidencies?: Array<Array<CountriesAndRegionsType | null> | null> | null, businessRelationshipWithCompany?: string | null, businessRelationshipWithCompanyExplanation?: string | null, partnersIncoming?: Array<{ __typename?: 'PreAssessmentPartner', name?: string | null, country?: string | null, bankCountry?: string | null, businessSector?: string | null, paymentPurpose?: Array<EconomicProfileInboundOutboundSource | null> | null, paymentPurposeOther?: string | null, website?: string | null } | null> | null, partnersOutgoing?: Array<{ __typename?: 'PreAssessmentPartner', name?: string | null, country?: string | null, bankCountry?: string | null, businessSector?: string | null, paymentPurpose?: Array<EconomicProfileInboundOutboundSource | null> | null, paymentPurposeOther?: string | null, website?: string | null } | null> | null, cardPayment?: { __typename?: 'CardPaymentsAndAMP', isCardPayment?: boolean | null, transactionalCurrencies?: Array<Currency | null> | null, requiredSettlementCurrencies?: Array<Currency | null> | null, merchantWebsites?: Array<string | null> | null, cardPaymentsTransactionalDataRegion?: Array<{ __typename?: 'CardPaymentsTransactionalDataRegion', businessCategoryRegion?: BusinessRegion | null, businessCategoryPercentage?: number | null } | null> | null, totalPredictedMonthlyVolumesVisa?: { __typename?: 'TotalPredictedMonthlyVolumes', domestic?: number | null, eea?: number | null, nonEea?: number | null } | null, totalPredictedMonthlyVolumesMasterCard?: { __typename?: 'TotalPredictedMonthlyVolumes', domestic?: number | null, eea?: number | null, nonEea?: number | null } | null, ampCurrentlyInUse?: Array<{ __typename?: 'AmpInUse', ampInUseTypeCurrentlyInUse?: string | null, monthlyVolumeInEuro?: string | null } | null> | null, ampRequiredCurrentlyInUse?: Array<{ __typename?: 'AmpInUse', ampInUseTypeCurrentlyInUse?: string | null, monthlyVolumeInEuro?: string | null } | null> | null, riskManagement?: { __typename?: 'CardProcessingRiskManagement', useAffiliateForGeneratingTraffic?: boolean | null, affiliatesUsed?: Array<string | null> | null, useCredentialOnFilesBillingSalesMethod?: boolean | null, relevantCredentialOnFilesBillingSalesMethod?: RelevantCredentialOnFilesBillingSalesMethod | null, credentialDetailsExplanation?: string | null } | null, pciDssCompliance?: { __typename?: 'PciDssCompliance', integrationTypeRequired?: Array<IntegrationTypeRequired | null> | null, dssCompliance?: Array<DssCompliance | null> | null, pciProviderName?: string | null } | null, processingHistory?: { __typename?: 'CardProcessingHistory', processPaymentCardsBefore?: boolean | null, nameOfCurrentFormerProcessor?: string | null, reasonForLeavingCurrentProcessor?: string | null, periodOfTimeWithCurrentFormerProcessor?: string | null, processingHistoryStatement?: { __typename?: 'Document', id: number, type?: DocumentType | null, contractId?: string | number | null, firstSide?: { __typename?: 'DocumentSide', fileName?: string | null, url?: string | null, size?: number | null, mimeType?: string | null } | null } | null } | null } | null } | null } | { __typename?: 'ProfileChangeAnswers' } | null, oldMeta?: { __typename?: 'ContractProfileChangeAnswers', companyName?: string | null, companyType?: CompanyType | null, tradingName?: string | null, legalEntityType?: UboLegalEntityType | null, companyRegistrationId?: string | null, phone?: string | null, businessSector?: string | null, businessDescription?: string | null, countriesOfOperatingAndConductingBusiness?: Array<CountriesAndRegionsType | null> | null, websites?: Array<string | null> | null, taxId?: string | null, address?: { __typename?: 'Address', line1?: string | null, zip?: string | null, city?: string | null, region?: string | null, additionalDetails?: string | null, country?: Country | null } | null, correspondenceAddress?: { __typename?: 'Address', line1?: string | null, zip?: string | null, city?: string | null, region?: string | null, additionalDetails?: string | null, country?: Country | null, countryDescription?: string | null } | null, transactionalPartners?: Array<{ __typename?: 'TransactionalPartner', name?: string | null, country?: Country | null } | null> | null, economicProfile?: { __typename?: 'EconomicProfile', sourceOfFunds?: Array<SourceOfFunds | null> | null, anticipatedAccountActivity?: Array<AnticipatedAccountActivities | null> | null, products?: Array<Products | null> | null, sourceOfFundsDescription?: string | null, inboundSources?: Array<EconomicProfileInboundSource | null> | null, inboundSourcesOther?: string | null, estimateInbound?: number | null, estimateOutbound?: number | null, outboundDestinations?: Array<EconomicProfileOutboundDestination | null> | null, outboundDestinationsOther?: string | null, turnover?: EconomicAverageSize | null, averageInbound?: EconomicAverageSize | null, averageOutbound?: EconomicAverageSize | null } | null, preAssessment?: { __typename?: 'PreAssessment', regulatoryInfoName?: string | null, regulatoryInfoLicenseNumber?: string | null, paymentProviders?: string | null, conductingKYC?: string | null, conductingClientKYC?: string | null, conductPublisherContentMonitoring?: string | null, clientsYouWorkWith?: string | null, companyAnnualIncome?: string | null, incomingMonthlyTurnover?: string | null, incomingClients?: string | null, outgoingMonthlyTurnover?: string | null, outgoingClients?: string | null, currencyAndVolume?: Array<string | null> | null, contactPersonFullName?: string | null, contactPersonEmail?: string | null, contactPersonPhoneNumber?: string | null, countryOfTaxResidence?: string | null, licenseRequired?: boolean | null, licenseCountry?: string | null, uboResidencies?: Array<Array<CountriesAndRegionsType | null> | null> | null, businessRelationshipWithCompany?: string | null, businessRelationshipWithCompanyExplanation?: string | null, partnersIncoming?: Array<{ __typename?: 'PreAssessmentPartner', name?: string | null, country?: string | null, bankCountry?: string | null, businessSector?: string | null, paymentPurpose?: Array<EconomicProfileInboundOutboundSource | null> | null, paymentPurposeOther?: string | null, website?: string | null } | null> | null, partnersOutgoing?: Array<{ __typename?: 'PreAssessmentPartner', name?: string | null, country?: string | null, bankCountry?: string | null, businessSector?: string | null, paymentPurpose?: Array<EconomicProfileInboundOutboundSource | null> | null, paymentPurposeOther?: string | null, website?: string | null } | null> | null, cardPayment?: { __typename?: 'CardPaymentsAndAMP', isCardPayment?: boolean | null, transactionalCurrencies?: Array<Currency | null> | null, requiredSettlementCurrencies?: Array<Currency | null> | null, merchantWebsites?: Array<string | null> | null, cardPaymentsTransactionalDataRegion?: Array<{ __typename?: 'CardPaymentsTransactionalDataRegion', businessCategoryRegion?: BusinessRegion | null, businessCategoryPercentage?: number | null } | null> | null, totalPredictedMonthlyVolumesVisa?: { __typename?: 'TotalPredictedMonthlyVolumes', domestic?: number | null, eea?: number | null, nonEea?: number | null } | null, totalPredictedMonthlyVolumesMasterCard?: { __typename?: 'TotalPredictedMonthlyVolumes', domestic?: number | null, eea?: number | null, nonEea?: number | null } | null, ampCurrentlyInUse?: Array<{ __typename?: 'AmpInUse', ampInUseTypeCurrentlyInUse?: string | null, monthlyVolumeInEuro?: string | null } | null> | null, ampRequiredCurrentlyInUse?: Array<{ __typename?: 'AmpInUse', ampInUseTypeCurrentlyInUse?: string | null, monthlyVolumeInEuro?: string | null } | null> | null, riskManagement?: { __typename?: 'CardProcessingRiskManagement', useAffiliateForGeneratingTraffic?: boolean | null, affiliatesUsed?: Array<string | null> | null, useCredentialOnFilesBillingSalesMethod?: boolean | null, relevantCredentialOnFilesBillingSalesMethod?: RelevantCredentialOnFilesBillingSalesMethod | null, credentialDetailsExplanation?: string | null } | null, pciDssCompliance?: { __typename?: 'PciDssCompliance', integrationTypeRequired?: Array<IntegrationTypeRequired | null> | null, dssCompliance?: Array<DssCompliance | null> | null, pciProviderName?: string | null } | null, processingHistory?: { __typename?: 'CardProcessingHistory', processPaymentCardsBefore?: boolean | null, nameOfCurrentFormerProcessor?: string | null, reasonForLeavingCurrentProcessor?: string | null, periodOfTimeWithCurrentFormerProcessor?: string | null, processingHistoryStatement?: { __typename?: 'Document', id: number, type?: DocumentType | null, contractId?: string | number | null, firstSide?: { __typename?: 'DocumentSide', fileName?: string | null, url?: string | null, size?: number | null, mimeType?: string | null } | null } | null } | null } | null } | null } | { __typename?: 'ProfileChangeAnswers' } | null } | null } | { __typename?: 'ContractTerminationAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'DirectDebitAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, directDebit?: { __typename?: 'DirectDebitMandate', id: string | number, status: DirectDebitMandateStatus, type: TransactionEntryType, creditorId?: string | null, mandateId?: string | null, createdAt: any, account?: { __typename?: 'Account', id?: string | number | null, alias?: string | null, iban?: string | null, currency?: Currency | null } | null, counterpartyDetails?: { __typename?: 'DirectDebitMandateCounterparty', name: string, bic?: string | null, iban?: string | null, address?: { __typename?: 'Address', line1?: string | null, country?: Country | null } | null } | null, document?: { __typename?: 'Document', id: number, type?: DocumentType | null, expiration?: any | null, createdAt?: any | null, firstSide?: { __typename?: 'DocumentSide', fileName?: string | null, mimeType?: string | null, size?: number | null, url?: string | null } | null } | null, rejectionAction?: { __typename?: 'AccountAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'BatchPaymentActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractChangeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DocumentAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'StandingOrderActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TransactionAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'WalletAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | null, approvalAction?: { __typename?: 'AccountAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'BatchPaymentActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractChangeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DocumentAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'StandingOrderActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TransactionAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'WalletAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | null } | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, initiatorName?: string | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, batch: { __typename?: 'DirectDebitBatchType', id: string | number, status: BatchPaymentStatusType, total: number, account: { __typename?: 'Account', id?: string | number | null, accountNumber?: string | null, alias?: string | null, currency?: Currency | null, iban?: string | null, swiftBIC?: string | null }, records: Array<{ __typename?: 'DirectDebitExecution', id: string | number, value?: number | null, executionDate?: any | null, reference?: string | null, status: DirectDebitExecutionStatus, mandate: { __typename?: 'DirectDebitMandate', counterpartyDetails?: { __typename?: 'DirectDebitMandateCounterparty', name: string, iban?: string | null } | null } }> } } | { __typename?: 'DirectDebitDisputeAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'DocumentAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, document?: { __typename?: 'Document', id: number, type?: DocumentType | null, fileDescription?: string | null, url?: string | null } | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, refundPayment?: { __typename?: 'RefundPayment', paymentId?: string | null, externalId?: string | null, amount?: number | null, currency?: string | null } | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, spendingLimitRequest?: { __typename?: 'SpendingLimitRequestType', id: string | number, card?: { __typename?: 'CardType', id: string | number, alias?: string | null, apiMaskedCardNumber?: string | null, cardHolder?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, limitsWithUsage?: Array<{ __typename?: 'CardLimitWithUsage', limitType: CardSpendingLimitTypes, amount: number } | null> | null, account?: { __typename?: 'Account', id?: string | number | null, currency?: Currency | null } | null } | null, limits?: Array<{ __typename?: 'LimitObjectType', limitType: CardSpendingLimitTypes, amount: number } | null> | null, oldLimits?: Array<{ __typename?: 'LimitObjectType', limitType: CardSpendingLimitTypes, amount: number } | null> | null } | null } | { __typename?: 'StandingOrderActionType', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, standingOrder?: { __typename?: 'StandingOrder', id: string | number, cronDescription?: string | null, createdAt?: any | null, nextExecutionAt?: any | null, amount?: number | null, payoutAmount?: number | null, payoutCurrency?: Currency | null, template?: { __typename?: 'StandingOrderTransactionTemplate', useLocalPay?: boolean | null, comments: string, beneficiary: { __typename?: 'SwiftTransferIndividualPartyDetails', accountNo?: string | null, name: string, iban?: string | null, type?: SwiftTransferRecipientType | null, bankBic?: string | null, address: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } } } | null, account: { __typename?: 'Account', currency?: Currency | null } } | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, contractTerm?: { __typename?: 'ContractTerms', term: { __typename?: 'TermsAndCondition', id?: string | number | null, version?: string | number | null, url?: string | null } } | null } | { __typename?: 'TransactionAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, transaction?: { __typename?: 'CreditTransaction', id?: string | number | null, value?: number | null, valueDate?: any | null, currency?: string | null, type?: TransactionType | null, entryType?: TransactionEntryType | null, status?: TransactionStatus | null, createdAt?: any | null, updatedAt?: any | null, comment?: string | null, isLocal?: boolean | null, isSwift?: boolean | null, executedAt?: any | null, executionType?: TransactionExecutionType | null, priority?: TransactionPriorityType | null, account?: { __typename?: 'Account', id?: string | number | null, alias?: string | null } | null, executionAction?: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } | null, from?: { __typename?: 'TransactionParty', accountNo?: string | null, name?: string | null, bankName?: string | null, iban?: string | null, type?: SwiftTransferRecipientType | null, bankBic?: string | null, walletAddress?: string | null, address?: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null } | null } | { __typename?: 'DebitTransaction', id?: string | number | null, value?: number | null, valueDate?: any | null, currency?: string | null, type?: TransactionType | null, entryType?: TransactionEntryType | null, status?: TransactionStatus | null, createdAt?: any | null, updatedAt?: any | null, comment?: string | null, isLocal?: boolean | null, isSwift?: boolean | null, executedAt?: any | null, executionType?: TransactionExecutionType | null, priority?: TransactionPriorityType | null, account?: { __typename?: 'Account', id?: string | number | null, alias?: string | null } | null, executionAction?: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } | null, to?: { __typename?: 'TransactionParty', accountNo?: string | null, name?: string | null, bankName?: string | null, iban?: string | null, type?: SwiftTransferRecipientType | null, bankBic?: string | null, walletAddress?: string | null, address?: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null } | null } | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, initiatorName?: string | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, spendingLimit?: { __typename?: 'SpendingLimitType', interval: SpendingLimitIntervalType, type: SpendingLimitTypeType, amount: number, usedAmount: number, oldLimit?: number | null, createdAt: any, account?: { __typename?: 'Account', iban?: string | null, alias?: string | null, currency?: Currency | null } | null } | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, amount?: number | null, currency?: string | null, incomingBeneficiaryName?: string | null, reference?: string | null, beneficiaryNameOnFile?: string | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, accountInfo?: { __typename?: 'SenderInfoAddress', vban?: string | null, currency?: Currency | null } | null, senderInfo?: { __typename?: 'TransactionParty', accountNo?: string | null, iban?: string | null, name?: string | null, bankName?: string | null, bankBic?: string | null } | null } | { __typename?: 'WalletAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, wallet?: { __typename?: 'Wallet', address?: string | null, network?: SupportedCryptoNetwork | null, alias?: string | null, baseCurrency?: Currency | null, supportedCoins?: Array<{ __typename?: 'Coin', name?: string | null, chain?: string | null } | null> | null } | null } | null };

export type GetActionSignatureQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetActionSignatureQuery = { __typename?: 'Query', actionSignatureRequest?: { __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, account?: { __typename?: 'Account', id?: string | number | null, iban?: string | null, name?: string | null, isVirtual?: boolean | null, currency?: Currency | null, virtualDetails?: { __typename?: 'VirtualAccountDetails', dateOfBirth?: any | null, nationality?: Nationality | null, registeredAddress?: { __typename?: 'Address', line1?: string | null, city?: string | null, zip?: string | null, country?: Country | null, additionalDetails?: string | null } | null } | null } | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, newAuthorizedPerson?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, signatoryRight?: SignatoryRight | null, groupSize?: number | null, isLimitedAccessHolder?: boolean | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number, fullName?: string | null, firstName?: string | null, lastName?: string | null } | null } | null } | { __typename?: 'BatchPaymentActionType', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, initiatorName?: string | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, batchPayment?: { __typename?: 'BatchPayment', id?: string | number | null, status?: BatchPaymentStatusType | null, calculatedValidTotal?: number | null, account?: { __typename?: 'Account', id?: string | number | null, accountNumber?: string | null, alias?: string | null, currency?: Currency | null, iban?: string | null, swiftBIC?: string | null } | null, paymentRecords?: Array<{ __typename?: 'BatchPaymentRecord', id?: string | number | null, amount?: number | null, currency?: string | null, beneficiaryName?: string | null, beneficiaryAccountId?: string | null, bankBic?: string | null, priority?: string | null, reference?: string | null, status?: BatchPaymentRecordStatus | null, isValid?: boolean | null, payoutAmount?: number | null, payoutCurrency?: string | null, useLocalAchPayout?: boolean | null } | null> | null } | null } | { __typename?: 'CardIssueRequestAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, cardRequest?: { __typename?: 'CardRequestType', id: number, holder?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, person?: { __typename?: 'Individual', id: number, fullName?: string | null } | null } | null, card?: { __typename?: 'CardType', id: string | number, alias?: string | null, limitsWithUsage?: Array<{ __typename?: 'CardLimitWithUsage', limitType: CardSpendingLimitTypes, amount: number } | null> | null, account?: { __typename?: 'Account', currency?: Currency | null } | null } | null } | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'ContractChangeAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null, owner: { __typename?: 'Individual' } | { __typename?: 'LegalEntity', companyName?: string | null, tradingName?: string | null, phone?: string | null, website?: string | null, address?: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null, correspondenceAddress?: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null } } | null, contractChange?: { __typename?: 'ProfileChange', id?: number | null, status?: ProfileChangeStatus | null, changeAnswers?: { __typename?: 'ContractProfileChangeAnswers', companyName?: string | null, tradingName?: string | null, taxId?: string | null, phone?: string | null, website?: string | null, address?: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null, correspondenceAddress?: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null } | { __typename?: 'ProfileChangeAnswers' } | null, oldMeta?: { __typename?: 'ContractProfileChangeAnswers', companyName?: string | null, companyType?: CompanyType | null, legalEntityType?: UboLegalEntityType | null, companyRegistrationId?: string | null, phone?: string | null, businessSector?: string | null, businessDescription?: string | null, countriesOfOperatingAndConductingBusiness?: Array<CountriesAndRegionsType | null> | null, website?: string | null, taxId?: string | null, tradingName?: string | null, address?: { __typename?: 'Address', zip?: string | null, city?: string | null, region?: string | null, additionalDetails?: string | null, country?: Country | null } | null, correspondenceAddress?: { __typename?: 'Address', zip?: string | null, city?: string | null, region?: string | null, additionalDetails?: string | null, country?: Country | null } | null, transactionalPartners?: Array<{ __typename?: 'TransactionalPartner', name?: string | null, country?: Country | null } | null> | null, economicProfile?: { __typename?: 'EconomicProfile', sourceOfFunds?: Array<SourceOfFunds | null> | null, sourceOfFundsDescription?: string | null, currencies?: Array<string | null> | null, turnover?: EconomicAverageSize | null, averageInbound?: EconomicAverageSize | null, averageOutbound?: EconomicAverageSize | null, estimateInbound?: number | null, estimateOutbound?: number | null, inboundSources?: Array<EconomicProfileInboundSource | null> | null, inboundSourcesOther?: string | null, outboundDestinations?: Array<EconomicProfileOutboundDestination | null> | null, outboundDestinationsOther?: string | null } | null } | { __typename?: 'ProfileChangeAnswers' } | null } | null } | { __typename?: 'ContractTerminationAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'DirectDebitAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'DocumentAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, document?: { __typename?: 'Document', type?: DocumentType | null, fileDescription?: string | null, url?: string | null } | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, spendingLimitRequest?: { __typename?: 'SpendingLimitRequestType', id: string | number, card?: { __typename?: 'CardType', id: string | number, alias?: string | null, apiMaskedCardNumber?: string | null, cardHolder?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, limitsWithUsage?: Array<{ __typename?: 'CardLimitWithUsage', limitType: CardSpendingLimitTypes, amount: number } | null> | null, account?: { __typename?: 'Account', currency?: Currency | null } | null } | null, limits?: Array<{ __typename?: 'LimitObjectType', limitType: CardSpendingLimitTypes, amount: number } | null> | null } | null } | { __typename?: 'StandingOrderActionType', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'TransactionAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, transaction?: { __typename?: 'CreditTransaction', id?: string | number | null, value?: number | null, valueDate?: any | null, currency?: string | null, type?: TransactionType | null, entryType?: TransactionEntryType | null, status?: TransactionStatus | null, createdAt?: any | null, updatedAt?: any | null, comment?: string | null, isLocal?: boolean | null, isSwift?: boolean | null, executedAt?: any | null, executionType?: TransactionExecutionType | null, priority?: TransactionPriorityType | null, account?: { __typename?: 'Account', id?: string | number | null, alias?: string | null } | null, executionAction?: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } | null, from?: { __typename?: 'TransactionParty', accountNo?: string | null, name?: string | null, bankName?: string | null, iban?: string | null, type?: SwiftTransferRecipientType | null, bankBic?: string | null, walletAddress?: string | null, address?: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null } | null } | { __typename?: 'DebitTransaction', id?: string | number | null, value?: number | null, valueDate?: any | null, currency?: string | null, type?: TransactionType | null, entryType?: TransactionEntryType | null, status?: TransactionStatus | null, createdAt?: any | null, updatedAt?: any | null, comment?: string | null, isLocal?: boolean | null, isSwift?: boolean | null, executedAt?: any | null, executionType?: TransactionExecutionType | null, priority?: TransactionPriorityType | null, account?: { __typename?: 'Account', id?: string | number | null, alias?: string | null } | null, executionAction?: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } | null, to?: { __typename?: 'TransactionParty', accountNo?: string | null, name?: string | null, bankName?: string | null, iban?: string | null, type?: SwiftTransferRecipientType | null, bankBic?: string | null, walletAddress?: string | null, address?: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null } | null } | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, amount?: number | null, currency?: string | null, incomingBeneficiaryName?: string | null, reference?: string | null, beneficiaryNameOnFile?: string | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null, accountInfo?: { __typename?: 'SenderInfoAddress', vban?: string | null, currency?: Currency | null } | null, senderInfo?: { __typename?: 'TransactionParty', accountNo?: string | null, iban?: string | null, name?: string | null, bankName?: string | null, bankBic?: string | null } | null } | { __typename?: 'WalletAction', id: string | number, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, signatoriesCount?: number | null } | null } } | null };

export type GetContractSignRequestsQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>> | InputMaybe<ActionSignatureStatus>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionSignatureRequestsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContractSignRequestsQuery = { __typename?: 'Query', actionSignatureRequests?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, createdAt?: any | null, action: { __typename?: 'AccountAction', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null, account?: { __typename?: 'Account', id?: string | number | null, alias?: string | null, currency?: Currency | null, accountNumber?: string | null, balance?: { __typename?: 'AccountBalance', available?: number | null, indicative?: number | null, guaranteed?: number | null } | null } | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, newAuthorizedPerson?: { __typename?: 'ContractAuthorizedPersonType', id?: number | null, isLimitedAccessHolder?: boolean | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', fullName?: string | null, firstName?: string | null, lastName?: string | null } | null } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'BatchPaymentActionType', id: string | number, initiatorName?: string | null, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, batchPayment?: { __typename?: 'BatchPayment', id?: string | number | null, status?: BatchPaymentStatusType | null, calculatedValidTotal?: number | null, account?: { __typename?: 'Account', id?: string | number | null, accountNumber?: string | null, alias?: string | null, currency?: Currency | null, iban?: string | null, swiftBIC?: string | null } | null, paymentRecords?: Array<{ __typename?: 'BatchPaymentRecord', id?: string | number | null, amount?: number | null, currency?: string | null, beneficiaryName?: string | null, beneficiaryAccountId?: string | null, bankBic?: string | null, priority?: string | null, reference?: string | null, status?: BatchPaymentRecordStatus | null, isValid?: boolean | null, payoutAmount?: number | null, payoutCurrency?: string | null, useLocalAchPayout?: boolean | null } | null> | null } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'CardIssueRequestAction', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'ContractChangeAction', id: string | number, type: ActionType, executedAt?: any | null, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null, contractChange?: { __typename?: 'ProfileChange', id?: number | null, status?: ProfileChangeStatus | null, changeAnswers?: { __typename?: 'ContractProfileChangeAnswers', taxId?: string | null } | { __typename?: 'ProfileChangeAnswers' } | null } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'DirectDebitAction', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'DocumentAction', id: string | number, type: ActionType, executedAt?: any | null, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, document?: { __typename?: 'Document', id: number, type?: DocumentType | null, fileDescription?: string | null } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'StandingOrderActionType', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'TransactionAction', id: string | number, type: ActionType, executedAt?: any | null, createdAt?: any | null, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, transaction?: { __typename?: 'CreditTransaction', id?: string | number | null, value?: number | null, currency?: string | null, account?: { __typename?: 'Account', id?: string | number | null, alias?: string | null, balance?: { __typename?: 'AccountBalance', indicative?: number | null, available?: number | null, guaranteed?: number | null } | null } | null } | { __typename?: 'DebitTransaction', id?: string | number | null, value?: number | null, currency?: string | null, isLocal?: boolean | null, isInterContract?: boolean | null, account?: { __typename?: 'Account', id?: string | number | null, alias?: string | null, balance?: { __typename?: 'AccountBalance', indicative?: number | null, available?: number | null, guaranteed?: number | null } | null } | null, to?: { __typename?: 'TransactionParty', name?: string | null } | null } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, signedAt?: any | null, status?: ActionSignatureStatus | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number }, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | { __typename?: 'WalletAction', id: string | number, executedAt?: any | null, type: ActionType, status?: ActionStatus | null, rejectionReason?: ActionRejectionReason | null, totalSignatureCount?: number | null, signedCount?: number | null, wallet?: { __typename?: 'Wallet', address?: string | null, network?: SupportedCryptoNetwork | null, alias?: string | null, baseCurrency?: Currency | null, supportedCoins?: Array<{ __typename?: 'Coin', name?: string | null, chain?: string | null } | null> | null } | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, signedAt?: any | null, status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, signatoriesCount?: number | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } } | null> | null };

export type ActionSignatureRequestsCountQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ActionSignatureStatus>> | InputMaybe<ActionSignatureStatus>>;
}>;


export type ActionSignatureRequestsCountQuery = { __typename?: 'Query', actionSignatureRequestsCount?: number | null };

export type GetAccountsQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<AccountStatus>> | InputMaybe<AccountStatus>>;
  orderDirection?: InputMaybe<OrderDirection>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  currencies?: InputMaybe<Array<InputMaybe<Currency>> | InputMaybe<Currency>>;
  entityType?: InputMaybe<UboType>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<InputMaybe<AccountType>> | InputMaybe<AccountType>>;
  fundsType?: InputMaybe<FundsType>;
}>;


export type GetAccountsQuery = { __typename?: 'Query', accounts?: Array<{ __typename?: 'Account', id?: string | number | null, iban?: string | null, accountNumber?: string | null, showFullInfo?: boolean | null, oursChargesSupportedCurrencies?: Array<Currency | null> | null, externalOutboundDisabled?: boolean | null, cardTopupSupported?: boolean | null, alias?: string | null, type?: AccountType | null, status?: AccountStatus | null, standingOrdersCount: number, createdAt?: any | null, fundsType?: FundsType | null, isSafeGuarding?: boolean | null, currency?: Currency | null, swiftBIC?: string | null, nextRecalculationDate?: any | null, isPinned?: boolean | null, qrrSupported?: boolean | null, cryptoTopupSupported?: boolean | null, cryptoWithdrawalSupported?: boolean | null, balance?: { __typename?: 'AccountBalance', indicative?: number | null, available?: number | null, guaranteed?: number | null } | null, contract?: { __typename?: 'BankableEntityContractType', id: number, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null, virtualDetails?: { __typename?: 'VirtualAccountDetails', entityType?: UboType | null, companyRegistrationNumber?: string | null, dateOfBirth?: any | null, nationality?: Nationality | null, name?: string | null, companyRegistrationDate?: any | null, registeredAddress?: { __typename?: 'Address', line1?: string | null, city?: string | null, zip?: string | null, region?: string | null, country?: Country | null, additionalDetails?: string | null, countryDescription?: string | null } | null } | null, executionAction?: { __typename?: 'AccountAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'BatchPaymentActionType', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractChangeAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DocumentAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'StandingOrderActionType', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TransactionAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'WalletAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', status?: ActionSignatureStatus | null, isMine?: boolean | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | null } | null> | null, wallets?: Array<{ __typename?: 'Wallet', id?: string | number | null, address?: string | null, alias?: string | null, network?: SupportedCryptoNetwork | null, status?: WalletStatus | null, balance?: number | null, baseCurrency?: Currency | null, linkedBy?: { __typename?: 'Individual', id: number } | null, supportedCoins?: Array<{ __typename?: 'Coin', name?: string | null, chain?: string | null } | null> | null, contract?: { __typename?: 'BankableEntityContractType', id: number, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | null> | null };

export type GetAccountsCountQueryVariables = Exact<{
  parentId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  currencies?: InputMaybe<Array<InputMaybe<Currency>> | InputMaybe<Currency>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<AccountStatus>> | InputMaybe<AccountStatus>>;
  entityType?: InputMaybe<UboType>;
  fundsType?: InputMaybe<FundsType>;
}>;


export type GetAccountsCountQuery = { __typename?: 'Query', accountsCount?: number | null };

export type GetContractActiveAccountsCountQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetContractActiveAccountsCountQuery = { __typename?: 'Query', accountsCount?: number | null };

export type GetAccVbansQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<AccountStatus>> | InputMaybe<AccountStatus>>;
}>;


export type GetAccVbansQuery = { __typename?: 'Query', accounts?: Array<{ __typename?: 'Account', isVirtual?: boolean | null, iban?: string | null, id?: string | number | null, status?: AccountStatus | null } | null> | null };

export type GetContractAccountsQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<AccountStatus>> | InputMaybe<AccountStatus>>;
  isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  currencies?: InputMaybe<Array<InputMaybe<Currency>> | InputMaybe<Currency>>;
  types?: InputMaybe<Array<InputMaybe<AccountType>> | InputMaybe<AccountType>>;
  fundsType?: InputMaybe<FundsType>;
}>;


export type GetContractAccountsQuery = { __typename?: 'Query', accounts?: Array<{ __typename?: 'Account', id?: string | number | null, currency?: Currency | null, alias?: string | null, status?: AccountStatus | null, iban?: string | null, swiftBIC?: string | null, fundsType?: FundsType | null, standingOrdersCount: number, externalOutboundDisabled?: boolean | null, cardTopupSupported?: boolean | null, oursChargesSupportedCurrencies?: Array<Currency | null> | null, parentId?: string | number | null, isSafeGuarding?: boolean | null, nextRecalculationDate?: any | null, qrrSupported?: boolean | null, cryptoTopupSupported?: boolean | null, cryptoWithdrawalSupported?: boolean | null, balance?: { __typename?: 'AccountBalance', indicative?: number | null, available?: number | null, guaranteed?: number | null } | null, guaranteedAccountBeneficiary?: { __typename?: 'ContractPaymentRecipient', id: string | number, currency?: Currency | null, iban?: string | null, accountNo?: string | null } | null } | null> | null, wallets?: Array<{ __typename?: 'Wallet', id?: string | number | null, alias?: string | null, address?: string | null, network?: SupportedCryptoNetwork | null, status?: WalletStatus | null, linkedBy?: { __typename?: 'Individual', id: number } | null, supportedCoins?: Array<{ __typename?: 'Coin', name?: string | null, chain?: string | null } | null> | null, incomingTransferFee?: { __typename?: 'WalletFee', isPercentage?: boolean | null, amountPercentage?: number | null, minAmount?: number | null, fixedAmount?: number | null, currency?: Currency | null, feeCurrency?: Currency | null } | null, outgoingTransferFee?: { __typename?: 'WalletFee', isPercentage?: boolean | null, amountPercentage?: number | null, minAmount?: number | null, fixedAmount?: number | null, currency?: Currency | null, feeCurrency?: Currency | null } | null } | null> | null };

export type GetAccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id?: string | number | null, iban?: string | null, accountNumber?: string | null, showFullInfo?: boolean | null, oursChargesSupportedCurrencies?: Array<Currency | null> | null, externalOutboundDisabled?: boolean | null, cardTopupSupported?: boolean | null, standingOrdersCount: number, alias?: string | null, type?: AccountType | null, status?: AccountStatus | null, currency?: Currency | null, swiftBIC?: string | null, fundsType?: FundsType | null, nextRecalculationDate?: any | null, isSafeGuarding?: boolean | null, qrrSupported?: boolean | null, cryptoTopupSupported?: boolean | null, cryptoWithdrawalSupported?: boolean | null, balance?: { __typename?: 'AccountBalance', indicative?: number | null, available?: number | null, guaranteed?: number | null } | null, contract?: { __typename?: 'BankableEntityContractType', id: number, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, cannotSignOwnActions?: boolean | null, signatoryRight?: SignatoryRight | null, limitedAccessRight?: LimitedAccessRight | null, person?: { __typename?: 'Individual', id: number } | null } | null> | null } | null } | null };

export type GetContractTransactionsCountQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
  accountId?: InputMaybe<Scalars['ID']['input']>;
  cardId?: InputMaybe<Scalars['ID']['input']>;
  cardFilter?: InputMaybe<TransactionCardFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<TransactionType>> | InputMaybe<TransactionType>>;
  notTypes?: InputMaybe<Array<InputMaybe<TransactionType>> | InputMaybe<TransactionType>>;
  entryTypes?: InputMaybe<Array<InputMaybe<TransactionEntryType>> | InputMaybe<TransactionEntryType>>;
  statuses?: InputMaybe<Array<InputMaybe<TransactionStatus>> | InputMaybe<TransactionStatus>>;
  notStatuses?: InputMaybe<Array<InputMaybe<TransactionStatus>> | InputMaybe<TransactionStatus>>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  walletId?: InputMaybe<Scalars['String']['input']>;
  internalTransferType?: InputMaybe<InternalTransferType>;
}>;


export type GetContractTransactionsCountQuery = { __typename?: 'Query', contractTransactionsCount?: number | null };

export type GetTransactionsQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
  accountId?: InputMaybe<Scalars['ID']['input']>;
  cardId?: InputMaybe<Scalars['ID']['input']>;
  cardFilter?: InputMaybe<TransactionCardFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrderBy>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<TransactionType>> | InputMaybe<TransactionType>>;
  notTypes?: InputMaybe<Array<InputMaybe<TransactionType>> | InputMaybe<TransactionType>>;
  entryTypes?: InputMaybe<Array<InputMaybe<TransactionEntryType>> | InputMaybe<TransactionEntryType>>;
  statuses?: InputMaybe<Array<InputMaybe<TransactionStatus>> | InputMaybe<TransactionStatus>>;
  notStatuses?: InputMaybe<Array<InputMaybe<TransactionStatus>> | InputMaybe<TransactionStatus>>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  valueFrom?: InputMaybe<Scalars['Float']['input']>;
  walletId?: InputMaybe<Scalars['String']['input']>;
  internalTransferType?: InputMaybe<InternalTransferType>;
}>;


export type GetTransactionsQuery = { __typename?: 'Query', contractTransactions?: Array<{ __typename: 'CreditTransaction', id?: string | number | null, type?: TransactionType | null, isInterContract?: boolean | null, value?: number | null, currency?: string | null, entryType?: TransactionEntryType | null, balanceAfter?: number | null, executedAt?: any | null, createdAt?: any | null, status?: TransactionStatus | null, card?: { __typename?: 'CardType', id: string | number, apiMaskedCardNumber?: string | null } | null, account?: { __typename?: 'Account', id?: string | number | null, currency?: Currency | null, accountNumber?: string | null, alias?: string | null, iban?: string | null, balance?: { __typename?: 'AccountBalance', available?: number | null, indicative?: number | null, guaranteed?: number | null } | null } | null, guaranteeEvent?: { __typename?: 'GuaranteeEvent', currentGuaranteedBalance?: number | null } | null, from?: { __typename?: 'TransactionParty', accountNo?: string | null, name?: string | null, bankName?: string | null, iban?: string | null, walletAddress?: string | null } | null, directDebitExecution?: { __typename?: 'DirectDebitExecution', id: string | number } | null } | { __typename: 'DebitTransaction', id?: string | number | null, type?: TransactionType | null, isInterContract?: boolean | null, value?: number | null, payoutValue?: number | null, currency?: string | null, entryType?: TransactionEntryType | null, payoutCurrency?: string | null, clientReference?: string | null, comment?: string | null, chargeBearer?: SwiftTransferChargeBearer | null, balanceAfter?: number | null, executedAt?: any | null, createdAt?: any | null, status?: TransactionStatus | null, card?: { __typename?: 'CardType', id: string | number, apiMaskedCardNumber?: string | null } | null, account?: { __typename?: 'Account', id?: string | number | null, currency?: Currency | null, accountNumber?: string | null, alias?: string | null, fundsType?: FundsType | null, iban?: string | null, balance?: { __typename?: 'AccountBalance', available?: number | null, indicative?: number | null, guaranteed?: number | null } | null } | null, guaranteeEvent?: { __typename?: 'GuaranteeEvent', currentGuaranteedBalance?: number | null } | null, to?: { __typename?: 'TransactionParty', accountNo?: string | null, name?: string | null, bankName?: string | null, iban?: string | null, type?: SwiftTransferRecipientType | null, bankBic?: string | null, walletAddress?: string | null, address?: { __typename?: 'Address', country?: Country | null, city?: string | null, zip?: string | null, line1?: string | null } | null } | null, executionAction?: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction', id: string | number, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null, directDebitExecution?: { __typename?: 'DirectDebitExecution', id: string | number } | null, standingOrder?: { __typename?: 'StandingOrder', id: string | number } | null } | null> | null };

export type PaymentRecipientsQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaymentRecipientsQuery = { __typename?: 'Query', contractPaymentRecipients?: Array<{ __typename?: 'ContractPaymentRecipient', id: string | number, type?: SwiftTransferRecipientType | null, firstName?: string | null, lastName?: string | null, companyName?: string | null, iban?: string | null, accountNo?: string | null, currency?: Currency | null, bankBic?: string | null, bankBranchId?: string | null, bankClearingMemberId?: string | null, accountNoType?: AccountNoType | null, taxId?: string | null, phone?: string | null, alias?: string | null, commentTemplate?: string | null, pan?: string | null, bankCountry?: string | null, address?: { __typename?: 'Address', country?: Country | null, city?: string | null, zip?: string | null, line1?: string | null } | null, kyc?: { __typename?: 'PaymentTransferRecipientKyc', individual?: { __typename?: 'PaymentTransferIndividualRecipientKyc', dateOfBirth?: any | null, nationality?: Nationality | null, idType?: string | null, idNumber?: string | null, idIssueDate?: any | null, idExpiryDate?: any | null, idIssueCountry?: Country | null } | null, company?: { __typename?: 'PaymentTransferCompanyRecipientKyc', registrationNumber?: string | null, registrationType?: string | null, registrationDate?: any | null } | null } | null } | null> | null };

export type PaymentRecipientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PaymentRecipientQuery = { __typename?: 'Query', contractPaymentRecipient?: { __typename?: 'ContractPaymentRecipient', id: string | number, type?: SwiftTransferRecipientType | null, companyName?: string | null, firstName?: string | null, lastName?: string | null, accountNo?: string | null, iban?: string | null, bankName?: string | null, bankBic?: string | null, alias?: string | null, commentTemplate?: string | null, phone?: string | null, taxId?: string | null, bankClearingMemberId?: string | null, accountNoType?: AccountNoType | null, bankBranchId?: string | null, bankBranchName?: string | null, pan?: string | null, address?: { __typename?: 'Address', country?: Country | null, line1?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null, kyc?: { __typename?: 'PaymentTransferRecipientKyc', individual?: { __typename?: 'PaymentTransferIndividualRecipientKyc', dateOfBirth?: any | null, nationality?: Nationality | null, idType?: string | null, idNumber?: string | null, idIssueDate?: any | null, idExpiryDate?: any | null, idIssueCountry?: Country | null } | null, company?: { __typename?: 'PaymentTransferCompanyRecipientKyc', registrationNumber?: string | null, registrationType?: string | null, registrationDate?: any | null } | null } | null } | null };

export type GetTransactionDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTransactionDetailsQuery = { __typename?: 'Query', transaction?: { __typename?: 'CreditTransaction', id?: string | number | null, type?: TransactionType | null, entryType?: TransactionEntryType | null, value?: number | null, payoutValue?: number | null, status?: TransactionStatus | null, currency?: string | null, accountCurrency?: Currency | null, payoutCurrency?: string | null, executedAt?: any | null, valueDate?: any | null, executionType?: TransactionExecutionType | null, comment?: string | null, chargeBearer?: SwiftTransferChargeBearer | null, isLocal?: boolean | null, createdAt?: any | null, xRate?: number | null, isConfirmationAvailable?: boolean | null, priority?: TransactionPriorityType | null, clientReference?: string | null, additionalComment?: string | null, trxHash?: string | null, isInterContract?: boolean | null, feeDetail?: { __typename?: 'FeeDetail', id: string | number, feeName?: string | null } | null, cashbackDetail?: { __typename?: 'CashbackDetail', sourceTransaction?: { __typename?: 'CreditTransaction', id?: string | number | null } | { __typename?: 'DebitTransaction', id?: string | number | null } | null } | null, executionAction?: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType', initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction', initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null, directDebitExecution?: { __typename?: 'DirectDebitExecution', id: string | number, canBeDisputed: boolean, mandate: { __typename?: 'DirectDebitMandate', mandateId?: string | null }, dispute?: { __typename?: 'DirectDebitDispute', status: DirectDebitDisputeStatus, action: { __typename?: 'AccountAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'BatchPaymentActionType', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractChangeAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitDisputeAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DocumentAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'RefundPaymentRequestAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'SpendingLimitRequestAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'StandingOrderActionType', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TransactionAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'VibanNameMismatchAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'WalletAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } } | null } | null, account?: { __typename?: 'Account', id?: string | number | null, alias?: string | null, accountNumber?: string | null, iban?: string | null, isVirtual?: boolean | null, fundsType?: FundsType | null, type?: AccountType | null } | null, card?: { __typename?: 'CardType', apiMaskedCardNumber?: string | null, alias?: string | null, cardHolder?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', fullName?: string | null } | null } | null } | null, cardTransactionDetails?: { __typename?: 'CardTransactionDetails', cardholderName?: string | null, errorMessage?: string | null, expiryDate?: string | null, maskedCardNumber?: string | null } | null, from?: { __typename?: 'TransactionParty', accountNo?: string | null, name?: string | null, bankName?: string | null, iban?: string | null, bankBic?: string | null, type?: SwiftTransferRecipientType | null, walletAddress?: string | null } | null } | { __typename?: 'DebitTransaction', isInterContract?: boolean | null, id?: string | number | null, type?: TransactionType | null, entryType?: TransactionEntryType | null, value?: number | null, payoutValue?: number | null, status?: TransactionStatus | null, currency?: string | null, accountCurrency?: Currency | null, payoutCurrency?: string | null, executedAt?: any | null, valueDate?: any | null, executionType?: TransactionExecutionType | null, comment?: string | null, chargeBearer?: SwiftTransferChargeBearer | null, isLocal?: boolean | null, createdAt?: any | null, xRate?: number | null, isConfirmationAvailable?: boolean | null, priority?: TransactionPriorityType | null, clientReference?: string | null, additionalComment?: string | null, trxHash?: string | null, to?: { __typename?: 'TransactionParty', accountNo?: string | null, name?: string | null, bankName?: string | null, iban?: string | null, bankBic?: string | null, type?: SwiftTransferRecipientType | null, walletAddress?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: Country | null, countryDescription?: string | null, line1?: string | null, zip?: string | null } | null } | null, standingOrder?: { __typename?: 'StandingOrder', id: string | number, cronDescription?: string | null } | null, feeDetail?: { __typename?: 'FeeDetail', id: string | number, feeName?: string | null } | null, cashbackDetail?: { __typename?: 'CashbackDetail', sourceTransaction?: { __typename?: 'CreditTransaction', id?: string | number | null } | { __typename?: 'DebitTransaction', id?: string | number | null } | null } | null, executionAction?: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType', initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction', initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null, directDebitExecution?: { __typename?: 'DirectDebitExecution', id: string | number, canBeDisputed: boolean, mandate: { __typename?: 'DirectDebitMandate', mandateId?: string | null }, dispute?: { __typename?: 'DirectDebitDispute', status: DirectDebitDisputeStatus, action: { __typename?: 'AccountAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'BatchPaymentActionType', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractChangeAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitDisputeAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DocumentAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'RefundPaymentRequestAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'SpendingLimitRequestAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'StandingOrderActionType', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TransactionAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'VibanNameMismatchAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'WalletAction', signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, status?: ActionSignatureStatus | null, isMine?: boolean | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } } | null } | null, account?: { __typename?: 'Account', id?: string | number | null, alias?: string | null, accountNumber?: string | null, iban?: string | null, isVirtual?: boolean | null, fundsType?: FundsType | null, type?: AccountType | null } | null, card?: { __typename?: 'CardType', apiMaskedCardNumber?: string | null, alias?: string | null, cardHolder?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', fullName?: string | null } | null } | null } | null, cardTransactionDetails?: { __typename?: 'CardTransactionDetails', cardholderName?: string | null, errorMessage?: string | null, expiryDate?: string | null, maskedCardNumber?: string | null } | null } | null };

export type DownloadAccountStatementQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<AccountStatementType>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DownloadAccountStatementQuery = { __typename?: 'Query', report?: { __typename?: 'AccountStatement', result?: string | null, async?: boolean | null } | null };

export type DownloadTransactionConfirmationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DownloadTransactionConfirmationQuery = { __typename?: 'Query', report?: { __typename?: 'AccountStatement', result?: string | null, async?: boolean | null } | null };

export type DownloadAccountCancellationReturnsReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type DownloadAccountCancellationReturnsReportQuery = { __typename?: 'Query', report?: { __typename?: 'AccountStatement', result?: string | null, async?: boolean | null } | null };

export type GetContractsCountQueryVariables = Exact<{
  individualId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetContractsCountQuery = { __typename?: 'Query', contractsCount?: number | null };

export type BackOfficeNewDocsCountQueryVariables = Exact<{
  status?: InputMaybe<DocumentStatus>;
  contractId?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<DocumentStatus>> | InputMaybe<DocumentStatus>>;
}>;


export type BackOfficeNewDocsCountQuery = { __typename?: 'Query', unreadDocumentsCount?: number | null };

export type SystemReceivedDocsCountQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['Int']['input']>;
  userFilter?: InputMaybe<DocumentUserFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<DocumentType>> | InputMaybe<DocumentType>>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<DocumentStatus>> | InputMaybe<DocumentStatus>>;
}>;


export type SystemReceivedDocsCountQuery = { __typename?: 'Query', documentsCount?: number | null };

export type SystemPinnedDocsCountQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['Int']['input']>;
  userFilter?: InputMaybe<DocumentUserFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<DocumentType>> | InputMaybe<DocumentType>>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<DocumentStatus>> | InputMaybe<DocumentStatus>>;
}>;


export type SystemPinnedDocsCountQuery = { __typename?: 'Query', documentsCount?: number | null };

export type SystemReceivedDocsQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DocumentOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<DocumentType>> | InputMaybe<DocumentType>>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<DocumentStatus>> | InputMaybe<DocumentStatus>>;
}>;


export type SystemReceivedDocsQuery = { __typename?: 'Query', documentsCount?: number | null, documents?: Array<{ __typename?: 'Document', id: number, type?: DocumentType | null, fileDescription?: string | null, createdAt?: any | null, isRead?: boolean | null, firstSide?: { __typename: 'DocumentSide', url?: string | null, fileName?: string | null, mimeType?: string | null } | null, account?: { __typename?: 'Account', accountNumber?: string | null, id?: string | number | null, alias?: string | null } | null } | null> | null };

export type SystemPinnedDocsQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DocumentOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<DocumentType>> | InputMaybe<DocumentType>>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<DocumentStatus>> | InputMaybe<DocumentStatus>>;
}>;


export type SystemPinnedDocsQuery = { __typename?: 'Query', documentsCount?: number | null, documents?: Array<{ __typename?: 'Document', id: number, type?: DocumentType | null, fileDescription?: string | null, createdAt?: any | null, isRead?: boolean | null, firstSide?: { __typename: 'DocumentSide', url?: string | null, fileName?: string | null, mimeType?: string | null } | null, account?: { __typename?: 'Account', accountNumber?: string | null, id?: string | number | null, alias?: string | null } | null } | null> | null };

export type CardsCountQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  accountId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ApiCardTypes>;
  statuses?: InputMaybe<Array<InputMaybe<CardStatuses>> | InputMaybe<CardStatuses>>;
}>;


export type CardsCountQuery = { __typename?: 'Query', contractCardsCount?: number | null };

export type CardsListQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  accountId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CardsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  statuses?: InputMaybe<Array<InputMaybe<CardStatuses>> | InputMaybe<CardStatuses>>;
  type?: InputMaybe<ApiCardTypes>;
}>;


export type CardsListQuery = { __typename?: 'Query', contractCards?: Array<{ __typename?: 'CardType', id: string | number, alias?: string | null, status?: CardStatuses | null, type?: ApiCardTypes | null, updatedAt?: any | null, apiMaskedCardNumber?: string | null, createdAt?: any | null, activatedAt?: any | null, expiryDate?: any | null, isCard3dSecureActivated?: boolean | null, limitsWithUsage?: Array<{ __typename?: 'CardLimitWithUsage', limitType: CardSpendingLimitTypes, amount: number, used: number } | null> | null, account?: { __typename?: 'Account', currency?: Currency | null, id?: string | number | null } | null, cardHolder?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number, fullName?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null } | null } | null, cardRequest?: { __typename?: 'CardRequestType', executionAction?: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction', id: string | number, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, fullName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType' } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } | null } | null, freezeLog?: Array<{ __typename?: 'FreezeLog', action?: string | null, actionBy?: string | null, createdAt?: any | null } | null> | null } | null> | null };

export type GetCardSensitiveInfoQueryVariables = Exact<{
  challengeId: Scalars['String']['input'];
  code: Scalars['Int']['input'];
  cardId: Scalars['ID']['input'];
}>;


export type GetCardSensitiveInfoQuery = { __typename?: 'Query', getCardSensitiveInfo?: { __typename?: 'CardSensitiveInfoRef', url?: string | null, token?: string | null } | null };

export type GetViewCardPinUrlQueryVariables = Exact<{
  challengeId: Scalars['String']['input'];
  code: Scalars['Int']['input'];
  cardId: Scalars['ID']['input'];
}>;


export type GetViewCardPinUrlQuery = { __typename?: 'Query', viewPin?: { __typename?: 'CardSensitiveInfoRef', url?: string | null, token?: string | null } | null };

export type GetTransactionDocumentsQueryVariables = Exact<{
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  standingOrderId?: InputMaybe<Scalars['ID']['input']>;
  walletId?: InputMaybe<Scalars['ID']['input']>;
  transactionRequestId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetTransactionDocumentsQuery = { __typename?: 'Query', documents?: Array<{ __typename?: 'Document', id: number, type?: DocumentType | null, fileName?: string | null, mimeType?: string | null, createdAt?: any | null, size?: number | null, fileDescription?: string | null, firstSide?: { __typename?: 'DocumentSide', fileName?: string | null, url?: string | null, size?: number | null, mimeType?: string | null } | null, secondSide?: { __typename?: 'DocumentSide', fileName?: string | null, url?: string | null, size?: number | null, mimeType?: string | null } | null } | null> | null };

export type GetCardLimitsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
}>;


export type GetCardLimitsQuery = { __typename?: 'Query', contractCard?: { __typename?: 'CardType', alias?: string | null, account?: { __typename?: 'Account', currency?: Currency | null } | null, limitsWithUsage?: Array<{ __typename?: 'CardLimitWithUsage', limitType: CardSpendingLimitTypes, amount: number } | null> | null } | null };

export type GetCardInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
}>;


export type GetCardInfoQuery = { __typename?: 'Query', contractCard?: { __typename?: 'CardType', id: string | number, alias?: string | null, isCard3dSecureActivated?: boolean | null, type?: ApiCardTypes | null, apiMaskedCardNumber?: string | null, account?: { __typename?: 'Account', currency?: Currency | null } | null, limitsWithUsage?: Array<{ __typename?: 'CardLimitWithUsage', limitType: CardSpendingLimitTypes, amount: number } | null> | null, cardHolder?: { __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number, fullName?: string | null } | null } | null } | null };

export type GetUploadedDocsQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['Int']['input']>;
  userFilter?: InputMaybe<DocumentUserFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DocumentOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<DocumentType>> | InputMaybe<DocumentType>>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetUploadedDocsQuery = { __typename?: 'Query', documents?: Array<{ __typename?: 'Document', id: number, type?: DocumentType | null, fileDescription?: string | null, createdAt?: any | null, firstSide?: { __typename?: 'DocumentSide', url?: string | null, fileName?: string | null } | null, account?: { __typename?: 'Account', alias?: string | null, currency?: Currency | null } | null, transaction?: { __typename?: 'CreditTransaction', value?: number | null, currency?: string | null, from?: { __typename?: 'TransactionParty', name?: string | null } | null } | { __typename?: 'DebitTransaction', value?: number | null, currency?: string | null, to?: { __typename?: 'TransactionParty', name?: string | null } | null } | null, individual?: { __typename?: 'Individual', firstName?: string | null, lastName?: string | null } | null } | null> | null };

export type GetGetUploadedDocsCountQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['Int']['input']>;
  userFilter?: InputMaybe<DocumentUserFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<DocumentType>> | InputMaybe<DocumentType>>;
  creationTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetGetUploadedDocsCountQuery = { __typename?: 'Query', documentsCount?: number | null };

export type GetcontractProfileChangesCountQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
  status?: InputMaybe<Array<InputMaybe<ProfileChangeStatus>> | InputMaybe<ProfileChangeStatus>>;
}>;


export type GetcontractProfileChangesCountQuery = { __typename?: 'Query', contractProfileChangesCount?: number | null };

export type GetContractProfileChangesQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
  status?: InputMaybe<Array<InputMaybe<ProfileChangeStatus>> | InputMaybe<ProfileChangeStatus>>;
}>;


export type GetContractProfileChangesQuery = { __typename?: 'Query', contractProfileChanges?: Array<{ __typename?: 'ProfileChange', id?: number | null, status?: ProfileChangeStatus | null, changeAnswers?: { __typename?: 'ContractProfileChangeAnswers', companyName?: string | null, tradingName?: string | null, companyType?: CompanyType | null, legalEntityType?: UboLegalEntityType | null, companyRegistrationId?: string | null, companyRegistrationDate?: any | null, phone?: string | null, websites?: Array<string | null> | null, businessSector?: string | null, businessDescription?: string | null, countriesOfOperatingAndConductingBusiness?: Array<CountriesAndRegionsType | null> | null, taxId?: string | null, address?: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null, correspondenceAddress?: { __typename?: 'Address', line1?: string | null, country?: Country | null, countryDescription?: string | null, zip?: string | null, city?: string | null, additionalDetails?: string | null } | null, economicProfile?: { __typename?: 'EconomicProfile', sourceOfFunds?: Array<SourceOfFunds | null> | null, sourceOfFundsDescription?: string | null, estimateOutbound?: number | null, estimateInbound?: number | null, currencies?: Array<string | null> | null, turnover?: EconomicAverageSize | null, inboundSources?: Array<EconomicProfileInboundSource | null> | null, outboundDestinations?: Array<EconomicProfileOutboundDestination | null> | null, products?: Array<Products | null> | null, anticipatedAccountActivity?: Array<AnticipatedAccountActivities | null> | null } | null, preAssessment?: { __typename?: 'PreAssessment', regulatoryInfoName?: string | null, regulatoryInfoLicenseNumber?: string | null, paymentProviders?: string | null, conductingKYC?: string | null, conductingClientKYC?: string | null, conductPublisherContentMonitoring?: string | null, clientsYouWorkWith?: string | null, companyAnnualIncome?: string | null, incomingMonthlyTurnover?: string | null, incomingClients?: string | null, outgoingMonthlyTurnover?: string | null, outgoingClients?: string | null, currencyAndVolume?: Array<string | null> | null, contactPersonFullName?: string | null, contactPersonEmail?: string | null, contactPersonPhoneNumber?: string | null, countryOfTaxResidence?: string | null, licenseRequired?: boolean | null, licenseCountry?: string | null, uboResidencies?: Array<Array<CountriesAndRegionsType | null> | null> | null, businessRelationshipWithCompany?: string | null, businessRelationshipWithCompanyExplanation?: string | null, partnersIncoming?: Array<{ __typename?: 'PreAssessmentPartner', name?: string | null, country?: string | null, bankCountry?: string | null, businessSector?: string | null, paymentPurpose?: Array<EconomicProfileInboundOutboundSource | null> | null, paymentPurposeOther?: string | null, website?: string | null } | null> | null, partnersOutgoing?: Array<{ __typename?: 'PreAssessmentPartner', name?: string | null, country?: string | null, bankCountry?: string | null, businessSector?: string | null, paymentPurpose?: Array<EconomicProfileInboundOutboundSource | null> | null, paymentPurposeOther?: string | null, website?: string | null } | null> | null, cardPayment?: { __typename?: 'CardPaymentsAndAMP', isCardPayment?: boolean | null, transactionalCurrencies?: Array<Currency | null> | null, requiredSettlementCurrencies?: Array<Currency | null> | null, merchantWebsites?: Array<string | null> | null, cardPaymentsTransactionalDataRegion?: Array<{ __typename?: 'CardPaymentsTransactionalDataRegion', businessCategoryRegion?: BusinessRegion | null, businessCategoryPercentage?: number | null } | null> | null, totalPredictedMonthlyVolumesVisa?: { __typename?: 'TotalPredictedMonthlyVolumes', domestic?: number | null, eea?: number | null, nonEea?: number | null } | null, totalPredictedMonthlyVolumesMasterCard?: { __typename?: 'TotalPredictedMonthlyVolumes', domestic?: number | null, eea?: number | null, nonEea?: number | null } | null, ampCurrentlyInUse?: Array<{ __typename?: 'AmpInUse', ampInUseTypeCurrentlyInUse?: string | null, monthlyVolumeInEuro?: string | null } | null> | null, ampRequiredCurrentlyInUse?: Array<{ __typename?: 'AmpInUse', ampInUseTypeCurrentlyInUse?: string | null, monthlyVolumeInEuro?: string | null } | null> | null, riskManagement?: { __typename?: 'CardProcessingRiskManagement', useAffiliateForGeneratingTraffic?: boolean | null, affiliatesUsed?: Array<string | null> | null, useCredentialOnFilesBillingSalesMethod?: boolean | null, relevantCredentialOnFilesBillingSalesMethod?: RelevantCredentialOnFilesBillingSalesMethod | null, credentialDetailsExplanation?: string | null } | null, pciDssCompliance?: { __typename?: 'PciDssCompliance', integrationTypeRequired?: Array<IntegrationTypeRequired | null> | null, dssCompliance?: Array<DssCompliance | null> | null, pciProviderName?: string | null } | null, processingHistory?: { __typename?: 'CardProcessingHistory', processPaymentCardsBefore?: boolean | null, nameOfCurrentFormerProcessor?: string | null, reasonForLeavingCurrentProcessor?: string | null, periodOfTimeWithCurrentFormerProcessor?: string | null, processingHistoryStatement?: { __typename?: 'Document', id: number, type?: DocumentType | null, contractId?: string | number | null, firstSide?: { __typename?: 'DocumentSide', fileName?: string | null, url?: string | null, size?: number | null, mimeType?: string | null } | null } | null } | null } | null } | null } | { __typename?: 'ProfileChangeAnswers' } | null, supportingDocuments?: Array<{ __typename?: 'Document', id: number, type?: DocumentType | null, fileName?: string | null, mimeType?: string | null, createdAt?: any | null, size?: number | null, fileDescription?: string | null } | null> | null } | null> | null };

export type GetContractTechnicalPropertiesQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type GetContractTechnicalPropertiesQuery = { __typename?: 'Query', getContractTechnicalProperties?: { __typename?: 'ContractTechnicalDetailsType', id: string | number, contractId: string | number, paymentWebhook?: string | null, webhookSignatureKey?: string | null, createdAt?: any | null, updatedAt?: any | null } | null };

export type ContractAuthorizedPersonsQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContractAuthPersonOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<AuthorizedPersonStatuses>> | InputMaybe<AuthorizedPersonStatuses>>;
  role?: InputMaybe<AuthorizedPersonRights>;
}>;


export type ContractAuthorizedPersonsQuery = { __typename?: 'Query', contractAuthorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', id?: number | null, isAuthorizedSignatory?: boolean | null, isLimitedAccessHolder?: boolean | null, limitedAccessRight?: LimitedAccessRight | null, signatoryRight?: SignatoryRight | null, invitationDate?: any | null, cannotSignOwnActions?: boolean | null, status?: AuthorizedPersonStatuses | null, isPendingDeactivated?: boolean | null, groupSize?: number | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null, lastSeenAt?: any | null, lastLogin?: any | null, email?: string | null } | null } | null> | null };

export type ContractAuthorizedPersonsCountQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<AuthorizedPersonStatuses>> | InputMaybe<AuthorizedPersonStatuses>>;
  role?: InputMaybe<AuthorizedPersonRights>;
}>;


export type ContractAuthorizedPersonsCountQuery = { __typename?: 'Query', contractAuthorizedPersonsCount?: number | null };

export type GetBankInfoQueryVariables = Exact<{
  iban: Scalars['String']['input'];
}>;


export type GetBankInfoQuery = { __typename?: 'Query', bankInfo?: { __typename?: 'BankInfoType', bankName: string, bic: string, address?: string | null, city?: string | null, zip?: string | null, country: string, countryISO: string } | null };

export type GetApiUsersQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type GetApiUsersQuery = { __typename?: 'Query', apiUsers?: Array<{ __typename?: 'ApiUser', id: string | number, name: string, apiKey: string | number, apiSecret: string | number, allowedIps?: Array<string | null> | null, status?: ApiUserStatus | null } | null> | null };

export type GetFxMarkupQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type GetFxMarkupQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', id: number, fxMarkup?: number | null } | null };

export type GetContractRegistrationAddressQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type GetContractRegistrationAddressQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', owner: { __typename?: 'Individual' } | { __typename?: 'LegalEntity', address?: { __typename?: 'Address', country?: Country | null, city?: string | null, line1?: string | null, additionalDetails?: string | null, zip?: string | null } | null } } | null };

export type GetStaticFxRatesQueryVariables = Exact<{
  from: Currency;
}>;


export type GetStaticFxRatesQuery = { __typename?: 'Query', staticFXRates?: Array<{ __typename?: 'StaticFxRate', id: string | number, from: string, to: string, rate: number } | null> | null };

export type GetEmailAndTwoFaCategoryPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailAndTwoFaCategoryPreferencesQuery = { __typename?: 'Query', viewer?: { __typename?: 'ApiUser' } | { __typename?: 'Individual', id: number, primaryTwoFAMethod?: TwoFaMethod | null, phone?: string | null, emailCategoryPreferences?: Array<{ __typename?: 'IndividualEmailCategoryPreference', id: string | number, active: boolean, category: { __typename?: 'EmailCategory', id: string | number, name: string, description: string, mandatory: boolean } } | null> | null, availableTwoFAMethods?: Array<{ __typename?: 'IndividualTwoFAMethod', method: TwoFaMethod, isEnabled?: boolean | null, isPrimary?: boolean | null } | null> | null } | { __typename?: 'User' } | null };

export type GetTransferFxSupportedCurrenciesQueryVariables = Exact<{
  fromCurrency?: InputMaybe<Currency>;
}>;


export type GetTransferFxSupportedCurrenciesQuery = { __typename?: 'Query', getExternalTransferFXCurrencies?: Array<{ __typename?: 'TransferFXCurrency', id: string | number, name: string, currency: string, decimalPositions: string, rails: Array<string | null> } | null> | null };

export type GetReservedFxRateQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['ID']['input']>;
  from: Currency;
  to: Currency;
  forLocalPay?: InputMaybe<Scalars['Boolean']['input']>;
  forTldr?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetReservedFxRateQuery = { __typename?: 'Query', getReservedFXRate?: { __typename?: 'ReservedFxRateDetails', id: string | number, from: string, to: string, expirationTime: any, rate: number } | null };

export type GetVibanNameMismatchesQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
  statuses?: InputMaybe<Array<InputMaybe<VibanNameMismatchResolution>> | InputMaybe<VibanNameMismatchResolution>>;
  search?: InputMaybe<Scalars['String']['input']>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
}>;


export type GetVibanNameMismatchesQuery = { __typename?: 'Query', vibanNameMismatches?: Array<{ __typename?: 'VibanNameMismatch', id?: string | number | null, amount?: number | null, currency?: Currency | null, beneficiaryNameOnFile?: string | null, incomingBeneficiaryName?: string | null, reference?: string | null, createdAt?: any | null, updatedAt?: any | null, resolvedDate?: any | null, isResolved?: boolean | null, status?: VibanNameMismatchResolution | null, virtualAccount?: { __typename?: 'Account', id?: string | number | null, iban?: string | null, parentId?: string | number | null } | null } | null> | null };

export type GetVibanNameMismatchesCountQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
  statuses?: InputMaybe<Array<InputMaybe<VibanNameMismatchResolution>> | InputMaybe<VibanNameMismatchResolution>>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVibanNameMismatchesCountQuery = { __typename?: 'Query', vibanNameMismatchesCount?: number | null };

export type GetDefaultCardLimitsQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetDefaultCardLimitsQuery = { __typename?: 'Query', cardsAllowedLimitsAndMaxes?: { __typename?: 'CardAllowedLimitsType', weeklyLimitsEnabled?: boolean | null, defaults?: { __typename?: 'DefaultCardAllowedLimitsType', defaultCardDailyContactlessPurchaseLimit?: number | null, defaultCardDailyInternetPurchaseLimit?: number | null, defaultCardDailyPurchaseLimit?: number | null, defaultCardDailyWithdrawalLimit?: number | null, defaultCardMonthlyContactlessPurchaseLimit?: number | null, defaultCardMonthlyInternetPurchaseLimit?: number | null, defaultCardMonthlyPurchaseLimit?: number | null, defaultCardMonthlyWithdrawalLimit?: number | null, defaultCardTransactionContactlessPurchaseLimit?: number | null, defaultCardTransactionInternetPurchaseLimit?: number | null, defaultCardTransactionPurchaseLimit?: number | null, defaultCardTransactionWithdrawalLimit?: number | null, defaultCardWeeklyContactlessPurchaseLimit?: number | null, defaultCardWeeklyInternetPurchaseLimit?: number | null, defaultCardWeeklyPurchaseLimit?: number | null, defaultCardWeeklyWithdrawalLimit?: number | null } | null, maxes?: { __typename?: 'MaxCardAllowedLimitsType', maxCardDailyContactlessPurchaseLimit?: number | null, maxCardDailyInternetPurchaseLimit?: number | null, maxCardDailyPurchaseLimit?: number | null, maxCardDailyWithdrawalLimit?: number | null, maxCardMonthlyContactlessPurchaseLimit?: number | null, maxCardMonthlyInternetPurchaseLimit?: number | null, maxCardMonthlyPurchaseLimit?: number | null, maxCardMonthlyWithdrawalLimit?: number | null, maxCardTransactionContactlessPurchaseLimit?: number | null, maxCardTransactionInternetPurchaseLimit?: number | null, maxCardTransactionPurchaseLimit?: number | null, maxCardTransactionWithdrawalLimit?: number | null, maxCardWeeklyContactlessPurchaseLimit?: number | null, maxCardWeeklyInternetPurchaseLimit?: number | null, maxCardWeeklyPurchaseLimit?: number | null, maxCardWeeklyWithdrawalLimit?: number | null } | null } | null };

export type GetPendingPreassessmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingPreassessmentsQuery = { __typename?: 'Query', preAssessments?: Array<{ __typename?: 'LegacyPreAssessment', createdAt?: any | null, companyInfoRegisteredName?: string | null, companyInfoCountryOfRegistration?: string | null, regulatoryInfoName?: string | null, regulatoryInfoLicenseNumber?: string | null, generalQuestionsBusinessActivities?: string | null, generalQuestionsOperatingCountries?: string | null, generalQuestionsPaymentProviders?: string | null, incomingEstimatedMonthlyAmount?: string | null, incomingClients?: string | null, outgoingEstimatedMonthlyAmount?: string | null, outgoingClients?: string | null, currencyAndVolume?: Array<string | null> | null, contactPersonFullName?: string | null, contactPersonEmail?: string | null, contactPersonPhoneNumber?: string | null, companyAnnualIncome?: string | null, companyAnnualIncomeCurrency?: string | null } | null> | null };

export type GetClientsQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContractPaymentRecipientOrderByType>;
  orderDirection?: InputMaybe<OrderDirection>;
}>;


export type GetClientsQuery = { __typename?: 'Query', contractPaymentRecipients?: Array<{ __typename?: 'ContractPaymentRecipient', id: string | number, type?: SwiftTransferRecipientType | null, firstName?: string | null, lastName?: string | null, companyName?: string | null, iban?: string | null, accountNo?: string | null, bankName?: string | null, currency?: Currency | null, bankBic?: string | null, bankBranchId?: string | null, bankClearingMemberId?: string | null, accountNoType?: AccountNoType | null, taxId?: string | null, phone?: string | null, alias?: string | null, commentTemplate?: string | null } | null> | null };

export type GetClientsCountQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetClientsCountQuery = { __typename?: 'Query', contractPaymentRecipientsCount?: number | null };

export type GetContractBasicInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContractBasicInfoQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', id: number, type?: ContractType | null, isIntroducingPartner?: boolean | null, referralLink?: string | null, ownerType?: UboType | null, allowedCryptoPayments?: AllowedCryptoPayments | null, owner: { __typename?: 'Individual', fullName?: string | null } | { __typename?: 'LegalEntity', id: number, companyName?: string | null, taxId?: string | null }, missingInfoDetails?: { __typename?: 'missingInfoDetailsType', hasMissingInfo?: boolean | null, id?: string | null } | null } | null };

export type GetContractInformationRequestsQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetContractInformationRequestsQuery = { __typename?: 'Query', contractInformationRequests: Array<{ __typename?: 'ContractInformationRequest', id: string | number, type?: ContractInformationRequestType | null, status?: ContractInformationRequestStatus | null, title?: string | null, clientNote?: string | null, documentType?: DocumentType | null }> };

export type GetContractInformationRequestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContractInformationRequestQuery = { __typename?: 'Query', contractInformationRequest?: { __typename?: 'ContractInformationRequest', id: string | number, status?: ContractInformationRequestStatus | null, type?: ContractInformationRequestType | null, title?: string | null, note?: string | null, clientNote?: string | null, createdAt?: any | null, filledAt?: any | null, documentType?: DocumentType | null, rejectReason?: string | null, attachments?: Array<{ __typename?: 'DocumentSide', fileName?: string | null, mimeType?: string | null, url?: string | null } | null> | null, documents?: Array<{ __typename?: 'Document', id: number, type?: DocumentType | null, firstSide?: { __typename?: 'DocumentSide', fileName?: string | null, mimeType?: string | null, url?: string | null } | null, secondSide?: { __typename?: 'DocumentSide', fileName?: string | null, mimeType?: string | null, url?: string | null } | null } | null> | null } | null };

export type AuthPersonsVideoVerificationsQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type AuthPersonsVideoVerificationsQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, authorizedPersons?: Array<{ __typename?: 'ContractAuthorizedPersonType', person?: { __typename?: 'Individual', id: number, isVerified?: boolean | null, fullName?: string | null, appointments?: Array<{ __typename?: 'IndividualAppointment', id: string | number, status: IndividualAppointmentStatus, createdAt: any, startTime: any }> | null } | null } | null> | null } | null };

export type GetAppointmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppointmentsQuery = { __typename?: 'Query', viewer?: { __typename?: 'ApiUser' } | { __typename?: 'Individual', appointments?: Array<{ __typename?: 'IndividualAppointment', id: string | number, status: IndividualAppointmentStatus, startTime: any }> | null } | { __typename?: 'User' } | null };

export type GetBatchRecordsCountQueryVariables = Exact<{
  batchPaymentId: Scalars['ID']['input'];
}>;


export type GetBatchRecordsCountQuery = { __typename?: 'Query', batchPaymentRecordsCount?: number | null };

export type GetBatchPaymentRecordsQueryVariables = Exact<{
  batchPaymentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBatchPaymentRecordsQuery = { __typename?: 'Query', batchPaymentRecords?: Array<{ __typename?: 'BatchPaymentRecord', id?: string | number | null, amount?: number | null, currency?: string | null, beneficiaryName?: string | null, beneficiaryAccountId?: string | null, bankBic?: string | null, priority?: string | null, reference?: string | null, status?: BatchPaymentRecordStatus | null, isValid?: boolean | null, payoutAmount?: number | null, payoutCurrency?: string | null, useLocalAchPayout?: boolean | null, fixedPayoutAmount?: boolean | null, bankClearingMemberId?: string | null, bankBranchId?: string | null, bankBranchName?: string | null, purposeCode?: string | null, beneficiaryPhone?: string | null, beneficiaryEmail?: string | null, chargeBearer?: SwiftTransferChargeBearer | null } | null> | null };

export type GetIntroducerPayoutInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetIntroducerPayoutInfoQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', introducerPayoutInfo?: { __typename?: 'IntroducerPayoutInfo', qualifyingRevenue?: number | null, pending?: number | null, paid?: number | null, currency?: Currency | null, lastFetched?: any | null } | null, commissionSettings?: { __typename?: 'ContractCommissionSetting', schedule?: PayoutSchedule | null, nextPayoutDate?: any | null, payoutAccount?: { __typename?: 'Account', id?: string | number | null, iban?: string | null, alias?: string | null, currency?: Currency | null } | null, externalPayoutAccount?: { __typename?: 'ExternalPayoutAccount', name?: string | null, iban?: string | null, accountNo?: string | null, currency?: Currency | null } | null } | null } | null };

export type GetSuccessFeePayoutsQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSuccessFeePayoutsQuery = { __typename?: 'Query', successFeePayouts?: Array<{ __typename?: 'SuccessFeePayout', id?: string | null, status?: SuccessFeePayoutStatus | null, finalValue?: number | null, currency?: Currency | null, executedAt?: any | null, account?: { __typename?: 'Account', id?: string | number | null, iban?: string | null, accountNumber?: string | null, alias?: string | null } | null, to?: { __typename?: 'TransactionParty', name?: string | null, accountNo?: string | null, iban?: string | null } | null } | null> | null };

export type GetSuccessFeePayoutsCountQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSuccessFeePayoutsCountQuery = { __typename?: 'Query', successFeePayoutsCount?: number | null };

export type GetSuccessFeePayoutQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSuccessFeePayoutQuery = { __typename?: 'Query', successFeePayout?: { __typename?: 'SuccessFeePayout', id?: string | null, status?: SuccessFeePayoutStatus | null, finalValue?: number | null, currency?: Currency | null, executedAt?: any | null, account?: { __typename?: 'Account', id?: string | number | null, iban?: string | null, accountNumber?: string | null, alias?: string | null } | null, to?: { __typename?: 'TransactionParty', name?: string | null, accountNo?: string | null, iban?: string | null } | null } | null };

export type GetPayoutSuccessFeesQueryVariables = Exact<{
  successFeePayoutId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SuccessFeeOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
}>;


export type GetPayoutSuccessFeesQuery = { __typename?: 'Query', successFees?: Array<{ __typename?: 'SuccessFee', id?: string | null, contractId?: number | null, relatedSuccessFeeId?: string | null, relatedTransactionId?: number | null, name?: string | null, amountAccountCurrency?: number | null, xRate?: number | null, feeRevenueChf?: number | null, nonRecoverableRevenue?: number | null, deductions?: number | null, qualifyingRevenue?: number | null, percentage?: number | null, amount?: number | null } | null> | null };

export type GetPayoutSuccessFeesCountQueryVariables = Exact<{
  successFeePayoutId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetPayoutSuccessFeesCountQuery = { __typename?: 'Query', successFeesCount?: number | null };

export type GetStandingOrdersQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<AccountStatus>> | InputMaybe<AccountStatus>>;
  notStatuses?: InputMaybe<Array<InputMaybe<AccountStatus>> | InputMaybe<AccountStatus>>;
}>;


export type GetStandingOrdersQuery = { __typename?: 'Query', accounts?: Array<{ __typename?: 'Account', currency?: Currency | null, fundsType?: FundsType | null, standingOrders?: Array<{ __typename?: 'StandingOrder', id: string | number, cronDescription?: string | null, amount?: number | null, payoutAmount?: number | null, payoutCurrency?: Currency | null, nextExecutionAt?: any | null, deletedAt?: any | null, active?: boolean | null, account: { __typename?: 'Account', id?: string | number | null, alias?: string | null, currency?: Currency | null, iban?: string | null }, activationAction?: { __typename?: 'AccountAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'BatchPaymentActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractChangeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DocumentAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'StandingOrderActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TransactionAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'WalletAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | null, cancellationAction?: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } | null, template?: { __typename?: 'StandingOrderTransactionTemplate', beneficiary: { __typename?: 'SwiftTransferIndividualPartyDetails', name: string, bankBic?: string | null, accountNo?: string | null, iban?: string | null } } | null } | null> | null } | null> | null };

export type GetStandingOrderQueryVariables = Exact<{
  standingOrderId: Scalars['ID']['input'];
}>;


export type GetStandingOrderQuery = { __typename?: 'Query', standingOrder?: { __typename?: 'StandingOrder', id: string | number, cronDescription?: string | null, amount?: number | null, payoutAmount?: number | null, payoutCurrency?: Currency | null, createdAt?: any | null, deletedAt?: any | null, nextExecutionAt?: any | null, active?: boolean | null, lowerThreshold?: number | null, minRemainingBalance?: number | null, activationAction?: { __typename?: 'AccountAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'BatchPaymentActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractChangeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DocumentAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'StandingOrderActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TransactionAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'WalletAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | null, cancellationAction?: { __typename?: 'AccountAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'BatchPaymentActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractChangeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DocumentAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'StandingOrderActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TransactionAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'WalletAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | null, account: { __typename?: 'Account', id?: string | number | null, alias?: string | null, currency?: Currency | null, iban?: string | null }, template?: { __typename?: 'StandingOrderTransactionTemplate', useLocalPay?: boolean | null, comments: string, beneficiaryType?: SwiftTransferRecipientType | null, clientReference?: string | number | null, beneficiary: { __typename?: 'SwiftTransferIndividualPartyDetails', name: string, bankBic?: string | null, accountNo?: string | null, iban?: string | null, address: { __typename?: 'Address', country?: Country | null, city?: string | null, line1?: string | null, zip?: string | null, additionalDetails?: string | null, region?: string | null } } } | null } | null };

export type GetStandingOrderRunsQueryVariables = Exact<{
  standingOrderId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
}>;


export type GetStandingOrderRunsQuery = { __typename?: 'Query', standingOrder?: { __typename?: 'StandingOrder', id: string | number, runsCount: number, runs?: Array<{ __typename?: 'StandingOrderRun', id: string | number, reason?: string | null, createdAt?: any | null, transaction?: { __typename?: 'CreditTransaction', id?: string | number | null, value?: number | null, accountCurrency?: Currency | null, status?: TransactionStatus | null } | { __typename?: 'DebitTransaction', id?: string | number | null, value?: number | null, accountCurrency?: Currency | null, status?: TransactionStatus | null } | null }> | null } | null };

export type GetGuaranteeEventsQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetGuaranteeEventsQuery = { __typename?: 'Query', guaranteeEvents?: Array<{ __typename?: 'GuaranteeEvent', currentGuaranteedBalance?: number | null, currentBalance?: number | null, createdAt?: any | null } | null> | null };

export type GetGuaranteeEventsCountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type GetGuaranteeEventsCountQuery = { __typename?: 'Query', guaranteeEventsCount?: number | null };

export type GuaranteedWithdrawalWithinLimitsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
}>;


export type GuaranteedWithdrawalWithinLimitsQuery = { __typename?: 'Query', guaranteedWithdrawalWithinLimits?: boolean | null };

export type GetContractPaymentApprovalRatesDataQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type GetContractPaymentApprovalRatesDataQuery = { __typename?: 'Query', contractPaymentApprovalRatesData?: Array<{ __typename?: 'PaymentGraphDataType', percentage?: number | null, date?: string | null } | null> | null };

export type GetContractPaymentTopRejectionReasonsDataQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type GetContractPaymentTopRejectionReasonsDataQuery = { __typename?: 'Query', contractPaymentTopRejectionReasonsData?: Array<{ __typename?: 'PaymentRejectionReasonsDataType', count?: number | null, reason?: string | null } | null> | null };

export type GetContractPaymentsDataQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PaymentsOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  statuses?: InputMaybe<Array<InputMaybe<PaymentStatus>> | InputMaybe<PaymentStatus>>;
  methods?: InputMaybe<Array<InputMaybe<PaymentMethod>> | InputMaybe<PaymentMethod>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetContractPaymentsDataQuery = { __typename?: 'Query', payments?: Array<{ __typename?: 'PaymentType', id?: string | null, executedAt?: any | null, method?: PaymentMethod | null, status?: PaymentStatus | null, errorMessage?: string | null, serviceStatus?: string | null, serviceErrorMessage?: string | null, email?: string | null, externalId?: string | null, amount?: number | null, currency?: Currency | null, maskedCardNumber?: string | null, expiryDate?: string | null, cardholderName?: string | null } | null> | null };

export type GetContractPaymentsCountQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<PaymentStatus>> | InputMaybe<PaymentStatus>>;
  methods?: InputMaybe<Array<InputMaybe<PaymentMethod>> | InputMaybe<PaymentMethod>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetContractPaymentsCountQuery = { __typename?: 'Query', paymentsCount?: number | null };

export type GetPaymentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetPaymentQuery = { __typename?: 'Query', payment?: { __typename?: 'PaymentType', id?: string | null, executedAt?: any | null, method?: PaymentMethod | null, status?: PaymentStatus | null, errorMessage?: string | null, serviceStatus?: string | null, serviceErrorMessage?: string | null, email?: string | null, externalId?: string | null, amount?: number | null, currency?: Currency | null, maskedCardNumber?: string | null, expiryDate?: string | null, cardholderName?: string | null, street?: string | null, zip?: string | null, city?: string | null, state?: string | null, country?: Country | null, ip?: string | null, sourcePayment?: { __typename?: 'PaymentType', id?: string | null } | null, refunds?: Array<{ __typename?: 'PaymentType', id?: string | null, executedAt?: any | null, status?: PaymentStatus | null, amount?: number | null, currency?: Currency | null, externalId?: string | null } | null> | null } | null };

export type GetSettlementBalancesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSettlementBalancesQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', settlementBalance?: Array<{ __typename?: 'SettlementBalance', settlement?: number | null, locked?: number | null, currency?: Currency | null } | null> | null } | null };

export type GetContractDailyVolumeDataQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
}>;


export type GetContractDailyVolumeDataQuery = { __typename?: 'Query', contractDailyVolumeData?: { __typename?: 'PaymentDailyVolumeDataType', date?: string | null, currency?: Currency | null, totalVolume?: number | null, count?: number | null, refundVolume?: number | null, payoutVolume?: number | null, hourlyVolumes?: Array<{ __typename?: 'PaymentHourlyVolumeDataType', hour?: string | null, amount?: number | null } | null> | null } | null };

export type GetDirectDebitsQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TransactionEntryType>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<DirectDebitMandateStatus>> | InputMaybe<DirectDebitMandateStatus>>;
}>;


export type GetDirectDebitsQuery = { __typename?: 'Query', directDebitMandates: Array<{ __typename?: 'DirectDebitMandate', id: string | number, status: DirectDebitMandateStatus, creditorId?: string | null, mandateId?: string | null, type: TransactionEntryType, createdAt: any, account?: { __typename?: 'Account', id?: string | number | null, alias?: string | null, iban?: string | null, currency?: Currency | null } | null, counterpartyDetails?: { __typename?: 'DirectDebitMandateCounterparty', name: string, bic?: string | null, iban?: string | null, address?: { __typename?: 'Address', line1?: string | null, country?: Country | null } | null } | null, document?: { __typename?: 'Document', id: number, type?: DocumentType | null, expiration?: any | null, createdAt?: any | null, firstSide?: { __typename?: 'DocumentSide', fileName?: string | null, mimeType?: string | null, size?: number | null, url?: string | null } | null } | null, rejectionAction?: { __typename?: 'AccountAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'BatchPaymentActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractChangeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DocumentAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'StandingOrderActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TransactionAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'WalletAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | null, approvalAction?: { __typename?: 'AccountAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'BatchPaymentActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractChangeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DocumentAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'StandingOrderActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TransactionAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'WalletAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | null }> };

export type GetDirectDebitMandatesCountQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TransactionEntryType>;
  status?: InputMaybe<Array<InputMaybe<DirectDebitMandateStatus>> | InputMaybe<DirectDebitMandateStatus>>;
}>;


export type GetDirectDebitMandatesCountQuery = { __typename?: 'Query', directDebitMandatesCount: number };

export type GetDirectDebitQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDirectDebitQuery = { __typename?: 'Query', directDebitMandate?: { __typename?: 'DirectDebitMandate', id: string | number, status: DirectDebitMandateStatus, creditorId?: string | null, mandateId?: string | null, type: TransactionEntryType, createdAt: any, account?: { __typename?: 'Account', id?: string | number | null, alias?: string | null, iban?: string | null, currency?: Currency | null } | null, counterpartyDetails?: { __typename?: 'DirectDebitMandateCounterparty', name: string, bic?: string | null, iban?: string | null, address?: { __typename?: 'Address', line1?: string | null, country?: Country | null } | null } | null, document?: { __typename?: 'Document', id: number, type?: DocumentType | null, expiration?: any | null, createdAt?: any | null, firstSide?: { __typename?: 'DocumentSide', fileName?: string | null, mimeType?: string | null, size?: number | null, url?: string | null } | null } | null, rejectionAction?: { __typename?: 'AccountAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'BatchPaymentActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractChangeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DocumentAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'StandingOrderActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TransactionAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'WalletAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | null, approvalAction?: { __typename?: 'AccountAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'BatchPaymentActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CardIssueRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractChangeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'ContractTerminationAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'CryptoTransactionSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitDisputeAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'DocumentAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'RefundPaymentRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'SpendingLimitRequestAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'StandingOrderActionType', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TransactionAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'TwoFAOperationActionLike', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'UpdateSpendingLimitAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'VibanNameMismatchAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | { __typename?: 'WalletAction', id: string | number, initiatorName?: string | null, signedCount?: number | null, status?: ActionStatus | null, signatures?: Array<{ __typename?: 'ActionSignature', id: string | number, isMine?: boolean | null, status?: ActionSignatureStatus | null, signedAt?: any | null, signatory?: { __typename?: 'ContractAuthorizedPersonType', signatoryRight?: SignatoryRight | null, person?: { __typename?: 'Individual', id: number, firstName?: string | null, lastName?: string | null } | null } | null, action: { __typename?: 'AccountAction', id: string | number } | { __typename?: 'AddContractAuthorizedPersonRequestAction', id: string | number } | { __typename?: 'BatchPaymentActionType', id: string | number } | { __typename?: 'CardIssueRequestAction', id: string | number } | { __typename?: 'ContractAuthorizedPersonDeactivationAction', id: string | number } | { __typename?: 'ContractChangeAction', id: string | number } | { __typename?: 'ContractTerminationAction', id: string | number } | { __typename?: 'CryptoTransactionSigningAction', id: string | number } | { __typename?: 'DirectDebitAction', id: string | number } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction', id: string | number } | { __typename?: 'DirectDebitRevertRequestAction', id: string | number } | { __typename?: 'DocumentAction', id: string | number } | { __typename?: 'RefundPaymentRequestAction', id: string | number } | { __typename?: 'SpendingLimitRequestAction', id: string | number } | { __typename?: 'StandingOrderActionType', id: string | number } | { __typename?: 'TermsAndConditionsSigningAction', id: string | number } | { __typename?: 'TransactionAction', id: string | number } | { __typename?: 'TwoFAOperationActionLike', id: string | number } | { __typename?: 'UpdateSpendingLimitAction', id: string | number } | { __typename?: 'VibanNameMismatchAction', id: string | number } | { __typename?: 'WalletAction', id: string | number } } | null> | null } | null } | null };

export type GetDirectDebitExecutionsQueryVariables = Exact<{
  directDebitId?: InputMaybe<Scalars['ID']['input']>;
  accountId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TransactionEntryType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<DirectDebitExecutionStatus>;
  executionDateFrom?: InputMaybe<Scalars['Date']['input']>;
  executionDateTo?: InputMaybe<Scalars['Date']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
}>;


export type GetDirectDebitExecutionsQuery = { __typename?: 'Query', directDebitExecutions: Array<{ __typename?: 'DirectDebitExecution', id: string | number, failureReason?: string | null, createdAt?: any | null, status: DirectDebitExecutionStatus, value?: number | null, executionDate?: any | null, account: { __typename?: 'Account', currency?: Currency | null }, mandate: { __typename?: 'DirectDebitMandate', type: TransactionEntryType, counterpartyDetails?: { __typename?: 'DirectDebitMandateCounterparty', name: string } | null }, transaction?: { __typename?: 'CreditTransaction', id?: string | number | null, value?: number | null, accountCurrency?: Currency | null, status?: TransactionStatus | null } | { __typename?: 'DebitTransaction', id?: string | number | null, value?: number | null, accountCurrency?: Currency | null, status?: TransactionStatus | null } | null, batch?: { __typename?: 'DirectDebitBatchType', executionAction: { __typename?: 'AccountAction' } | { __typename?: 'AddContractAuthorizedPersonRequestAction' } | { __typename?: 'BatchPaymentActionType' } | { __typename?: 'CardIssueRequestAction' } | { __typename?: 'ContractAuthorizedPersonDeactivationAction' } | { __typename?: 'ContractChangeAction' } | { __typename?: 'ContractTerminationAction' } | { __typename?: 'CryptoTransactionSigningAction' } | { __typename?: 'DirectDebitAction' } | { __typename?: 'DirectDebitBatchRequestActionType', id: string | number } | { __typename?: 'DirectDebitDisputeAction' } | { __typename?: 'DirectDebitRevertRequestAction' } | { __typename?: 'DocumentAction' } | { __typename?: 'RefundPaymentRequestAction' } | { __typename?: 'SpendingLimitRequestAction' } | { __typename?: 'StandingOrderActionType' } | { __typename?: 'TermsAndConditionsSigningAction' } | { __typename?: 'TransactionAction' } | { __typename?: 'TwoFAOperationActionLike' } | { __typename?: 'UpdateSpendingLimitAction' } | { __typename?: 'VibanNameMismatchAction' } | { __typename?: 'WalletAction' } } | null }> };

export type GetDirectDebitExecutionsCountQueryVariables = Exact<{
  directDebitId?: InputMaybe<Scalars['ID']['input']>;
  accountId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TransactionEntryType>;
  status?: InputMaybe<DirectDebitExecutionStatus>;
  executionDateFrom?: InputMaybe<Scalars['Date']['input']>;
  executionDateTo?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetDirectDebitExecutionsCountQuery = { __typename?: 'Query', directDebitExecutionsCount: number };

export type ContractContactsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContractContactsQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', id: number, status?: ContractStatusType | null, owner: { __typename?: 'Individual' } | { __typename?: 'LegalEntity', id: number, companyName?: string | null, legalEntityType?: UboLegalEntityType | null }, contacts?: Array<{ __typename?: 'ContractContact', id: string | number, canDirectlyUpdateContactInfo?: boolean | null, isPrimary?: boolean | null, type?: ContractContactType | null, contactInfo?: { __typename?: 'ContactInfo', name?: string | null, email?: string | null, phone?: string | null } | null } | null> | null } | null };

export type GetContractContactsQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContractContactsQuery = { __typename?: 'Query', contractContacts?: Array<{ __typename?: 'ContractContact', id: string | number, canDirectlyUpdateContactInfo?: boolean | null, type?: ContractContactType | null, isPrimary?: boolean | null, contactInfo?: { __typename?: 'ContactInfo', name?: string | null, email?: string | null, phone?: string | null } | null } | null> | null };

export type GetContractContactsCountQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContractContactsCountQuery = { __typename?: 'Query', contractContactsCount?: number | null };

export type GetDirectDebitLimitsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetDirectDebitLimitsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id?: string | number | null, spendingLimits?: Array<{ __typename?: 'SpendingLimitType', interval: SpendingLimitIntervalType, amount: number, usedAmount: number, status: SpendingLimitStatusType }> | null } | null };

export type GetUbosQueryVariables = Exact<{
  type?: InputMaybe<UboType>;
}>;


export type GetUbosQuery = { __typename?: 'Query', getUbos?: Array<{ __typename?: 'UBO', id: string | number, entity?: { __typename: 'Individual', id: number, firstName?: string | null, lastName?: string | null, birthday?: any | null, nationality?: Nationality | null, isPep?: boolean | null, taxId?: string | null, email?: string | null, fullName?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: Country | null, zip?: string | null, additionalDetails?: string | null, line1?: string | null } | null } | { __typename: 'LegalEntity', id: number, companyName?: string | null, companyRegistrationId?: string | null } | null } | null> | null };

export type ContractLegalEntityOwnersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContractLegalEntityOwnersQuery = { __typename?: 'Query', contract?: { __typename?: 'BankableEntityContractType', ubos?: Array<{ __typename?: 'ContractUBO', id?: string | number | null, addedFromExistingUbo?: boolean | null, ubo?: { __typename?: 'UBO', id: string | number, entity?: { __typename?: 'Individual' } | { __typename?: 'LegalEntity', id: number, companyName?: string | null } | null } | null } | null> | null } | null };

export type GetIbanCertificationQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetIbanCertificationQuery = { __typename?: 'Query', ibanCertificate?: string | null };

export type GetTransactionForbiddenCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTransactionForbiddenCountriesQuery = { __typename?: 'Query', transactionForbiddenCountries?: Array<Country | null> | null };

export type GetContractWalletsQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetContractWalletsQuery = { __typename?: 'Query', wallets?: Array<{ __typename?: 'Wallet', id?: string | number | null, address?: string | null, alias?: string | null, network?: SupportedCryptoNetwork | null, status?: WalletStatus | null, linkedBy?: { __typename?: 'Individual', id: number } | null, supportedCoins?: Array<{ __typename?: 'Coin', name?: string | null, chain?: string | null } | null> | null } | null> | null };

export type CryptoRateQueryVariables = Exact<{
  fromCurrency: AllCurrencies;
  toCurrency: AllCurrencies;
  amount: Scalars['Float']['input'];
  network: SupportedCryptoNetwork;
}>;


export type CryptoRateQuery = { __typename?: 'Query', cryptoRate?: { __typename?: 'CryptoRate', price?: number | null, effectiveRate?: number | null, networkFee?: number | null, slippageTolerance?: Array<{ __typename?: 'SlippaceTolerance', key?: number | null, label?: string | null } | null> | null } | null };

export type GetWalletQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWalletQuery = { __typename?: 'Query', wallet?: { __typename?: 'Wallet', id?: string | number | null, address?: string | null, alias?: string | null, network?: SupportedCryptoNetwork | null, status?: WalletStatus | null, baseCurrency?: Currency | null, balance?: number | null, linkedBy?: { __typename?: 'Individual', id: number } | null, supportedCoins?: Array<{ __typename?: 'Coin', name?: string | null, chain?: string | null } | null> | null } | null };

export type GetWalletTransactionsQueryVariables = Exact<{
  walletId: Scalars['String']['input'];
  status?: InputMaybe<Array<InputMaybe<TransactionRequestStatus>> | InputMaybe<TransactionRequestStatus>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
}>;


export type GetWalletTransactionsQuery = { __typename?: 'Query', walletTransactions?: Array<{ __typename?: 'TransactionRequest', id?: string | number | null, createdAt?: any | null, amount?: number | null, currency?: AllCurrencies | null, status?: TransactionRequestStatus | null, type?: string | null, effectiveRate?: number | null, slippageTolerance?: number | null, estimatedAmount?: number | null, trxHash?: string | null, account?: { __typename?: 'Account', id?: string | number | null, name?: string | null, alias?: string | null, currency?: Currency | null, iban?: string | null } | null, wallet?: { __typename?: 'Wallet', alias?: string | null, address?: string | null, network?: SupportedCryptoNetwork | null, linkedBy?: { __typename?: 'Individual', id: number } | null } | null } | null> | null };

export type GetWalletTransactionsCountQueryVariables = Exact<{
  walletId: Scalars['String']['input'];
  status?: InputMaybe<Array<InputMaybe<TransactionRequestStatus>> | InputMaybe<TransactionRequestStatus>>;
}>;


export type GetWalletTransactionsCountQuery = { __typename?: 'Query', walletTransactionsCount?: number | null };

export type GetTransactionRequestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTransactionRequestQuery = { __typename?: 'Query', transactionRequest?: { __typename?: 'TransactionRequest', id?: string | number | null, createdAt?: any | null, amount?: number | null, currency?: AllCurrencies | null, status?: TransactionRequestStatus | null, type?: string | null, effectiveRate?: number | null, slippageTolerance?: number | null, estimatedAmount?: number | null, trxHash?: string | null, account?: { __typename?: 'Account', id?: string | number | null, name?: string | null, alias?: string | null, currency?: Currency | null, iban?: string | null } | null, wallet?: { __typename?: 'Wallet', id?: string | number | null, alias?: string | null, address?: string | null, network?: SupportedCryptoNetwork | null, status?: WalletStatus | null, linkedBy?: { __typename?: 'Individual', id: number } | null } | null } | null };

export type GetIframeUrlForCardNoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIframeUrlForCardNoQuery = { __typename?: 'Query', iframeUrlForCardNo?: { __typename?: 'CardSensitiveInfoRef', token?: string | null, url?: string | null } | null };

export type IsCardTermsSignedQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type IsCardTermsSignedQuery = { __typename?: 'Query', isProductTermsSignedOrPending?: boolean | null };

export type ContractTopUpTransactionsQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdTo?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ContractTopUpTransactionsQuery = { __typename?: 'Query', contractTransactions?: Array<{ __typename?: 'CreditTransaction', id?: string | number | null, value?: number | null } | { __typename?: 'DebitTransaction' } | null> | null };

export type OutboundPaymentCapabilitiesQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  payoutCurrency: AllCurrencies;
  destinationCountry: Country;
}>;


export type OutboundPaymentCapabilitiesQuery = { __typename?: 'Query', outboundPaymentCapabilities?: Array<PaymentCapabilities | null> | null };

export type NewFxQuotesSubscriptionVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type NewFxQuotesSubscription = { __typename?: 'Subscription', newFXQuote: { __typename?: 'FxQuote', id: string | number, bid: number, ask: number, symbol: string, quoteTime: any } };

export type TwoFaMobileProgressSubscriptionVariables = Exact<{
  challengeId: Scalars['String']['input'];
}>;


export type TwoFaMobileProgressSubscription = { __typename?: 'Subscription', twoFaMobileProgress: { __typename?: 'MobileTwoFA', status: TwoFaMobileProgressStatus, challengeId: string, code?: string | null } };

export const ClientBasicInfoFragmentDoc = gql`
    fragment ClientBasicInfo on Individual {
  firstName
  lastName
  birthday
  nationality
  phone
}
    `;
export const AddressFragmentDoc = gql`
    fragment Address on Individual {
  address {
    line1
    city
    zip
    region
    country
  }
}
    `;
export const SecondaryPhonesFragmentDoc = gql`
    fragment SecondaryPhones on Individual {
  secondaryPhones {
    secondaryPhone1
  }
}
    `;
export const SecondaryEmailsFragmentDoc = gql`
    fragment SecondaryEmails on Individual {
  secondaryEmails {
    secondaryEmail1
    secondaryEmail2
    secondaryEmail3
  }
}
    `;
export const CardPaymentsFragmentDoc = gql`
    fragment CardPayments on PreAssessment {
  cardPayment {
    isCardPayment
    cardPaymentsTransactionalDataRegion {
      businessCategoryRegion
      businessCategoryPercentage
    }
    transactionalCurrencies
    requiredSettlementCurrencies
    totalPredictedMonthlyVolumesVisa {
      domestic
      eea
      nonEea
    }
    totalPredictedMonthlyVolumesMasterCard {
      domestic
      eea
      nonEea
    }
    ampCurrentlyInUse {
      ampInUseTypeCurrentlyInUse
      monthlyVolumeInEuro
    }
    ampRequiredCurrentlyInUse {
      ampInUseTypeCurrentlyInUse
      monthlyVolumeInEuro
    }
    riskManagement {
      useAffiliateForGeneratingTraffic
      affiliatesUsed
      useCredentialOnFilesBillingSalesMethod
      relevantCredentialOnFilesBillingSalesMethod
      credentialDetailsExplanation
    }
    pciDssCompliance {
      integrationTypeRequired
      dssCompliance
      pciProviderName
    }
    processingHistory {
      processPaymentCardsBefore
      nameOfCurrentFormerProcessor
      reasonForLeavingCurrentProcessor
      periodOfTimeWithCurrentFormerProcessor
      processingHistoryStatement {
        id
        type
        contractId
        firstSide {
          fileName
          url
          size
          mimeType
        }
      }
    }
    merchantWebsites
  }
}
    `;
export const UpdateOwnPasswordDocument = gql`
    mutation updateOwnPassword($currentPassword: String!, $newPassword: String!, $challengeId: String!, $code: Int!) {
  updateOwnPassword(
    currentPassword: $currentPassword
    newPassword: $newPassword
    challengeId: $challengeId
    code: $code
  )
}
    `;
export type UpdateOwnPasswordMutationFn = Apollo.MutationFunction<UpdateOwnPasswordMutation, UpdateOwnPasswordMutationVariables>;

/**
 * __useUpdateOwnPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateOwnPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOwnPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOwnPasswordMutation, { data, loading, error }] = useUpdateOwnPasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *      challengeId: // value for 'challengeId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useUpdateOwnPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOwnPasswordMutation, UpdateOwnPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOwnPasswordMutation, UpdateOwnPasswordMutationVariables>(UpdateOwnPasswordDocument, options);
      }
export type UpdateOwnPasswordMutationHookResult = ReturnType<typeof useUpdateOwnPasswordMutation>;
export type UpdateOwnPasswordMutationResult = Apollo.MutationResult<UpdateOwnPasswordMutation>;
export type UpdateOwnPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateOwnPasswordMutation, UpdateOwnPasswordMutationVariables>;
export const ConfirmOwnEmailDocument = gql`
    mutation confirmOwnEmail($token: String!) {
  confirmOwnEmail(token: $token) {
    email
    emailConfirmed
    emailPendingChange
  }
}
    `;
export type ConfirmOwnEmailMutationFn = Apollo.MutationFunction<ConfirmOwnEmailMutation, ConfirmOwnEmailMutationVariables>;

/**
 * __useConfirmOwnEmailMutation__
 *
 * To run a mutation, you first call `useConfirmOwnEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmOwnEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmOwnEmailMutation, { data, loading, error }] = useConfirmOwnEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useConfirmOwnEmailMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmOwnEmailMutation, ConfirmOwnEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmOwnEmailMutation, ConfirmOwnEmailMutationVariables>(ConfirmOwnEmailDocument, options);
      }
export type ConfirmOwnEmailMutationHookResult = ReturnType<typeof useConfirmOwnEmailMutation>;
export type ConfirmOwnEmailMutationResult = Apollo.MutationResult<ConfirmOwnEmailMutation>;
export type ConfirmOwnEmailMutationOptions = Apollo.BaseMutationOptions<ConfirmOwnEmailMutation, ConfirmOwnEmailMutationVariables>;
export const SendSmsVerificationDocument = gql`
    mutation sendSmsVerification($phone: String!, $type: TwoFACodeDispatchMode) {
  sendSmsVerification(phone: $phone, type: $type) {
    phoneVerificationId
    timeout
    attemptsLeft
    expectedDigits
    retryAttemptsTimeout
  }
}
    `;
export type SendSmsVerificationMutationFn = Apollo.MutationFunction<SendSmsVerificationMutation, SendSmsVerificationMutationVariables>;

/**
 * __useSendSmsVerificationMutation__
 *
 * To run a mutation, you first call `useSendSmsVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSmsVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSmsVerificationMutation, { data, loading, error }] = useSendSmsVerificationMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSendSmsVerificationMutation(baseOptions?: Apollo.MutationHookOptions<SendSmsVerificationMutation, SendSmsVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSmsVerificationMutation, SendSmsVerificationMutationVariables>(SendSmsVerificationDocument, options);
      }
export type SendSmsVerificationMutationHookResult = ReturnType<typeof useSendSmsVerificationMutation>;
export type SendSmsVerificationMutationResult = Apollo.MutationResult<SendSmsVerificationMutation>;
export type SendSmsVerificationMutationOptions = Apollo.BaseMutationOptions<SendSmsVerificationMutation, SendSmsVerificationMutationVariables>;
export const VerifyPhoneDocument = gql`
    mutation verifyPhone($phoneVerificationId: Int!, $code: String!) {
  verifyPhone(phoneVerificationId: $phoneVerificationId, code: $code)
}
    `;
export type VerifyPhoneMutationFn = Apollo.MutationFunction<VerifyPhoneMutation, VerifyPhoneMutationVariables>;

/**
 * __useVerifyPhoneMutation__
 *
 * To run a mutation, you first call `useVerifyPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPhoneMutation, { data, loading, error }] = useVerifyPhoneMutation({
 *   variables: {
 *      phoneVerificationId: // value for 'phoneVerificationId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyPhoneMutation(baseOptions?: Apollo.MutationHookOptions<VerifyPhoneMutation, VerifyPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyPhoneMutation, VerifyPhoneMutationVariables>(VerifyPhoneDocument, options);
      }
export type VerifyPhoneMutationHookResult = ReturnType<typeof useVerifyPhoneMutation>;
export type VerifyPhoneMutationResult = Apollo.MutationResult<VerifyPhoneMutation>;
export type VerifyPhoneMutationOptions = Apollo.BaseMutationOptions<VerifyPhoneMutation, VerifyPhoneMutationVariables>;
export const GetSignedUrlDocument = gql`
    mutation getSignedUrl {
  getSignedUrl {
    key
    plainUrl
    signedUrl
  }
}
    `;
export type GetSignedUrlMutationFn = Apollo.MutationFunction<GetSignedUrlMutation, GetSignedUrlMutationVariables>;

/**
 * __useGetSignedUrlMutation__
 *
 * To run a mutation, you first call `useGetSignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetSignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getSignedUrlMutation, { data, loading, error }] = useGetSignedUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetSignedUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetSignedUrlMutation, GetSignedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetSignedUrlMutation, GetSignedUrlMutationVariables>(GetSignedUrlDocument, options);
      }
export type GetSignedUrlMutationHookResult = ReturnType<typeof useGetSignedUrlMutation>;
export type GetSignedUrlMutationResult = Apollo.MutationResult<GetSignedUrlMutation>;
export type GetSignedUrlMutationOptions = Apollo.BaseMutationOptions<GetSignedUrlMutation, GetSignedUrlMutationVariables>;
export const CreateContractDocument = gql`
    mutation createContract($input: BankableEntityContractInputType!, $version: Int) {
  createContract(input: $input, version: $version) {
    id
  }
}
    `;
export type CreateContractMutationFn = Apollo.MutationFunction<CreateContractMutation, CreateContractMutationVariables>;

/**
 * __useCreateContractMutation__
 *
 * To run a mutation, you first call `useCreateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractMutation, { data, loading, error }] = useCreateContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useCreateContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractMutation, CreateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContractMutation, CreateContractMutationVariables>(CreateContractDocument, options);
      }
export type CreateContractMutationHookResult = ReturnType<typeof useCreateContractMutation>;
export type CreateContractMutationResult = Apollo.MutationResult<CreateContractMutation>;
export type CreateContractMutationOptions = Apollo.BaseMutationOptions<CreateContractMutation, CreateContractMutationVariables>;
export const CreateIntroducerReferenceContractDocument = gql`
    mutation createIntroducerReferenceContract($input: BankableEntityContractInputType!) {
  createIntroducerReferenceContract(contractInput: $input) {
    id
  }
}
    `;
export type CreateIntroducerReferenceContractMutationFn = Apollo.MutationFunction<CreateIntroducerReferenceContractMutation, CreateIntroducerReferenceContractMutationVariables>;

/**
 * __useCreateIntroducerReferenceContractMutation__
 *
 * To run a mutation, you first call `useCreateIntroducerReferenceContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntroducerReferenceContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntroducerReferenceContractMutation, { data, loading, error }] = useCreateIntroducerReferenceContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIntroducerReferenceContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateIntroducerReferenceContractMutation, CreateIntroducerReferenceContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIntroducerReferenceContractMutation, CreateIntroducerReferenceContractMutationVariables>(CreateIntroducerReferenceContractDocument, options);
      }
export type CreateIntroducerReferenceContractMutationHookResult = ReturnType<typeof useCreateIntroducerReferenceContractMutation>;
export type CreateIntroducerReferenceContractMutationResult = Apollo.MutationResult<CreateIntroducerReferenceContractMutation>;
export type CreateIntroducerReferenceContractMutationOptions = Apollo.BaseMutationOptions<CreateIntroducerReferenceContractMutation, CreateIntroducerReferenceContractMutationVariables>;
export const DeleteContractDocument = gql`
    mutation deleteContract($id: ID!) {
  removeContract(id: $id)
}
    `;
export type DeleteContractMutationFn = Apollo.MutationFunction<DeleteContractMutation, DeleteContractMutationVariables>;

/**
 * __useDeleteContractMutation__
 *
 * To run a mutation, you first call `useDeleteContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractMutation, { data, loading, error }] = useDeleteContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContractMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContractMutation, DeleteContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContractMutation, DeleteContractMutationVariables>(DeleteContractDocument, options);
      }
export type DeleteContractMutationHookResult = ReturnType<typeof useDeleteContractMutation>;
export type DeleteContractMutationResult = Apollo.MutationResult<DeleteContractMutation>;
export type DeleteContractMutationOptions = Apollo.BaseMutationOptions<DeleteContractMutation, DeleteContractMutationVariables>;
export const AddContractAuthorizedPersonDocument = gql`
    mutation addContractAuthorizedPerson($contractId: ID!, $input: AddAuthorizedPersonInputType!) {
  addContractAuthorizedPerson(contractId: $contractId, input: $input) {
    id
    groupSize
    isAuthorizedSignatory
    isLimitedAccessHolder
    limitedAccessRight
    signatoryRight
    status
    person {
      id
      firstName
      lastName
      email
      birthday
      nationality
      phone
      address {
        line1
        city
        zip
        country
        countryDescription
        additionalDetails
      }
    }
  }
}
    `;
export type AddContractAuthorizedPersonMutationFn = Apollo.MutationFunction<AddContractAuthorizedPersonMutation, AddContractAuthorizedPersonMutationVariables>;

/**
 * __useAddContractAuthorizedPersonMutation__
 *
 * To run a mutation, you first call `useAddContractAuthorizedPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContractAuthorizedPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContractAuthorizedPersonMutation, { data, loading, error }] = useAddContractAuthorizedPersonMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddContractAuthorizedPersonMutation(baseOptions?: Apollo.MutationHookOptions<AddContractAuthorizedPersonMutation, AddContractAuthorizedPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContractAuthorizedPersonMutation, AddContractAuthorizedPersonMutationVariables>(AddContractAuthorizedPersonDocument, options);
      }
export type AddContractAuthorizedPersonMutationHookResult = ReturnType<typeof useAddContractAuthorizedPersonMutation>;
export type AddContractAuthorizedPersonMutationResult = Apollo.MutationResult<AddContractAuthorizedPersonMutation>;
export type AddContractAuthorizedPersonMutationOptions = Apollo.BaseMutationOptions<AddContractAuthorizedPersonMutation, AddContractAuthorizedPersonMutationVariables>;
export const AddLegalEntityDirectorDocument = gql`
    mutation addLegalEntityDirector($contractId: ID!, $role: DirectorRole!, $signingRight: DirectorSigningRights!, $person: AuthorizedPersonInputType!) {
  addLegalEntityDirector(
    input: {contractId: $contractId, role: $role, signingRight: $signingRight, naturalPerson: $person}
  ) {
    id
    role
    signingRight
    individual {
      id
      firstName
      lastName
      email
      birthday
      nationality
      phone
      address {
        line1
        city
        zip
        country
        countryDescription
        additionalDetails
      }
    }
  }
}
    `;
export type AddLegalEntityDirectorMutationFn = Apollo.MutationFunction<AddLegalEntityDirectorMutation, AddLegalEntityDirectorMutationVariables>;

/**
 * __useAddLegalEntityDirectorMutation__
 *
 * To run a mutation, you first call `useAddLegalEntityDirectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLegalEntityDirectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLegalEntityDirectorMutation, { data, loading, error }] = useAddLegalEntityDirectorMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      role: // value for 'role'
 *      signingRight: // value for 'signingRight'
 *      person: // value for 'person'
 *   },
 * });
 */
export function useAddLegalEntityDirectorMutation(baseOptions?: Apollo.MutationHookOptions<AddLegalEntityDirectorMutation, AddLegalEntityDirectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLegalEntityDirectorMutation, AddLegalEntityDirectorMutationVariables>(AddLegalEntityDirectorDocument, options);
      }
export type AddLegalEntityDirectorMutationHookResult = ReturnType<typeof useAddLegalEntityDirectorMutation>;
export type AddLegalEntityDirectorMutationResult = Apollo.MutationResult<AddLegalEntityDirectorMutation>;
export type AddLegalEntityDirectorMutationOptions = Apollo.BaseMutationOptions<AddLegalEntityDirectorMutation, AddLegalEntityDirectorMutationVariables>;
export const EditLegalEntityDirectorDocument = gql`
    mutation editLegalEntityDirector($contractId: ID!, $individualId: ID!, $legalEntityId: ID!, $naturalPerson: AuthorizedPersonInputType!, $role: DirectorRole, $signingRight: DirectorSigningRights) {
  editLegalEntityDirector(
    contractId: $contractId
    individualId: $individualId
    legalEntityId: $legalEntityId
    naturalPerson: $naturalPerson
    role: $role
    signingRight: $signingRight
  ) {
    id
    individual {
      id
      firstName
      lastName
      email
      birthday
      nationality
      phone
      address {
        line1
        city
        zip
        country
        countryDescription
        additionalDetails
      }
    }
  }
}
    `;
export type EditLegalEntityDirectorMutationFn = Apollo.MutationFunction<EditLegalEntityDirectorMutation, EditLegalEntityDirectorMutationVariables>;

/**
 * __useEditLegalEntityDirectorMutation__
 *
 * To run a mutation, you first call `useEditLegalEntityDirectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLegalEntityDirectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLegalEntityDirectorMutation, { data, loading, error }] = useEditLegalEntityDirectorMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      individualId: // value for 'individualId'
 *      legalEntityId: // value for 'legalEntityId'
 *      naturalPerson: // value for 'naturalPerson'
 *      role: // value for 'role'
 *      signingRight: // value for 'signingRight'
 *   },
 * });
 */
export function useEditLegalEntityDirectorMutation(baseOptions?: Apollo.MutationHookOptions<EditLegalEntityDirectorMutation, EditLegalEntityDirectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLegalEntityDirectorMutation, EditLegalEntityDirectorMutationVariables>(EditLegalEntityDirectorDocument, options);
      }
export type EditLegalEntityDirectorMutationHookResult = ReturnType<typeof useEditLegalEntityDirectorMutation>;
export type EditLegalEntityDirectorMutationResult = Apollo.MutationResult<EditLegalEntityDirectorMutation>;
export type EditLegalEntityDirectorMutationOptions = Apollo.BaseMutationOptions<EditLegalEntityDirectorMutation, EditLegalEntityDirectorMutationVariables>;
export const DeleteContractAuthorizedPersonDocument = gql`
    mutation deleteContractAuthorizedPerson($id: ID!) {
  removeContractAuthorizedPerson(id: $id)
}
    `;
export type DeleteContractAuthorizedPersonMutationFn = Apollo.MutationFunction<DeleteContractAuthorizedPersonMutation, DeleteContractAuthorizedPersonMutationVariables>;

/**
 * __useDeleteContractAuthorizedPersonMutation__
 *
 * To run a mutation, you first call `useDeleteContractAuthorizedPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractAuthorizedPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractAuthorizedPersonMutation, { data, loading, error }] = useDeleteContractAuthorizedPersonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContractAuthorizedPersonMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContractAuthorizedPersonMutation, DeleteContractAuthorizedPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContractAuthorizedPersonMutation, DeleteContractAuthorizedPersonMutationVariables>(DeleteContractAuthorizedPersonDocument, options);
      }
export type DeleteContractAuthorizedPersonMutationHookResult = ReturnType<typeof useDeleteContractAuthorizedPersonMutation>;
export type DeleteContractAuthorizedPersonMutationResult = Apollo.MutationResult<DeleteContractAuthorizedPersonMutation>;
export type DeleteContractAuthorizedPersonMutationOptions = Apollo.BaseMutationOptions<DeleteContractAuthorizedPersonMutation, DeleteContractAuthorizedPersonMutationVariables>;
export const RemoveLegalEntityDirectorDocument = gql`
    mutation removeLegalEntityDirector($id: ID!) {
  removeLegalEntityDirector(id: $id) {
    id
  }
}
    `;
export type RemoveLegalEntityDirectorMutationFn = Apollo.MutationFunction<RemoveLegalEntityDirectorMutation, RemoveLegalEntityDirectorMutationVariables>;

/**
 * __useRemoveLegalEntityDirectorMutation__
 *
 * To run a mutation, you first call `useRemoveLegalEntityDirectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLegalEntityDirectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLegalEntityDirectorMutation, { data, loading, error }] = useRemoveLegalEntityDirectorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveLegalEntityDirectorMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLegalEntityDirectorMutation, RemoveLegalEntityDirectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLegalEntityDirectorMutation, RemoveLegalEntityDirectorMutationVariables>(RemoveLegalEntityDirectorDocument, options);
      }
export type RemoveLegalEntityDirectorMutationHookResult = ReturnType<typeof useRemoveLegalEntityDirectorMutation>;
export type RemoveLegalEntityDirectorMutationResult = Apollo.MutationResult<RemoveLegalEntityDirectorMutation>;
export type RemoveLegalEntityDirectorMutationOptions = Apollo.BaseMutationOptions<RemoveLegalEntityDirectorMutation, RemoveLegalEntityDirectorMutationVariables>;
export const UpdateContractDetailsDocument = gql`
    mutation updateContractDetails($id: ID!, $updates: BankableEntityContractInputType!) {
  updateContract(id: $id, updates: $updates) {
    id
    status
  }
}
    `;
export type UpdateContractDetailsMutationFn = Apollo.MutationFunction<UpdateContractDetailsMutation, UpdateContractDetailsMutationVariables>;

/**
 * __useUpdateContractDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateContractDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractDetailsMutation, { data, loading, error }] = useUpdateContractDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateContractDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractDetailsMutation, UpdateContractDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractDetailsMutation, UpdateContractDetailsMutationVariables>(UpdateContractDetailsDocument, options);
      }
export type UpdateContractDetailsMutationHookResult = ReturnType<typeof useUpdateContractDetailsMutation>;
export type UpdateContractDetailsMutationResult = Apollo.MutationResult<UpdateContractDetailsMutation>;
export type UpdateContractDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateContractDetailsMutation, UpdateContractDetailsMutationVariables>;
export const CreateOwnDocumentDocument = gql`
    mutation createOwnDocument($type: DocumentType!, $fileName: String!, $plainUrl: String!, $contractId: Int!, $size: Float!, $relatedEntityId: ID, $relatedEntityType: DocumentRelatedEntityType, $fileDescription: String, $expiration: Date, $profileChangeId: ID, $contractInformationRequestId: String) {
  createOwnDocument(
    type: $type
    fileName: $fileName
    plainUrl: $plainUrl
    contractId: $contractId
    size: $size
    relatesTo: {relatedEntityId: $relatedEntityId, relatedEntityType: $relatedEntityType}
    fileDescription: $fileDescription
    expiration: $expiration
    profileChangeId: $profileChangeId
    contractInformationRequestId: $contractInformationRequestId
  ) {
    id
  }
}
    `;
export type CreateOwnDocumentMutationFn = Apollo.MutationFunction<CreateOwnDocumentMutation, CreateOwnDocumentMutationVariables>;

/**
 * __useCreateOwnDocumentMutation__
 *
 * To run a mutation, you first call `useCreateOwnDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOwnDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOwnDocumentMutation, { data, loading, error }] = useCreateOwnDocumentMutation({
 *   variables: {
 *      type: // value for 'type'
 *      fileName: // value for 'fileName'
 *      plainUrl: // value for 'plainUrl'
 *      contractId: // value for 'contractId'
 *      size: // value for 'size'
 *      relatedEntityId: // value for 'relatedEntityId'
 *      relatedEntityType: // value for 'relatedEntityType'
 *      fileDescription: // value for 'fileDescription'
 *      expiration: // value for 'expiration'
 *      profileChangeId: // value for 'profileChangeId'
 *      contractInformationRequestId: // value for 'contractInformationRequestId'
 *   },
 * });
 */
export function useCreateOwnDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateOwnDocumentMutation, CreateOwnDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOwnDocumentMutation, CreateOwnDocumentMutationVariables>(CreateOwnDocumentDocument, options);
      }
export type CreateOwnDocumentMutationHookResult = ReturnType<typeof useCreateOwnDocumentMutation>;
export type CreateOwnDocumentMutationResult = Apollo.MutationResult<CreateOwnDocumentMutation>;
export type CreateOwnDocumentMutationOptions = Apollo.BaseMutationOptions<CreateOwnDocumentMutation, CreateOwnDocumentMutationVariables>;
export const CreateOwnDocumentTwoSidedDocument = gql`
    mutation createOwnDocumentTwoSided($type: DocumentType!, $firstFileName: String!, $secondFileName: String, $firstPlainUrl: String!, $secondPlainUrl: String, $contractId: Int, $firstSize: Float!, $secondSize: Float, $relatedEntityId: ID, $relatedEntityType: DocumentRelatedEntityType, $expiration: Date) {
  createOwnDocument(
    type: $type
    firstSide: {fileName: $firstFileName, plainUrl: $firstPlainUrl, size: $firstSize}
    secondSide: {fileName: $secondFileName, plainUrl: $secondPlainUrl, size: $secondSize}
    contractId: $contractId
    relatesTo: {relatedEntityId: $relatedEntityId, relatedEntityType: $relatedEntityType}
    expiration: $expiration
  ) {
    id
  }
}
    `;
export type CreateOwnDocumentTwoSidedMutationFn = Apollo.MutationFunction<CreateOwnDocumentTwoSidedMutation, CreateOwnDocumentTwoSidedMutationVariables>;

/**
 * __useCreateOwnDocumentTwoSidedMutation__
 *
 * To run a mutation, you first call `useCreateOwnDocumentTwoSidedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOwnDocumentTwoSidedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOwnDocumentTwoSidedMutation, { data, loading, error }] = useCreateOwnDocumentTwoSidedMutation({
 *   variables: {
 *      type: // value for 'type'
 *      firstFileName: // value for 'firstFileName'
 *      secondFileName: // value for 'secondFileName'
 *      firstPlainUrl: // value for 'firstPlainUrl'
 *      secondPlainUrl: // value for 'secondPlainUrl'
 *      contractId: // value for 'contractId'
 *      firstSize: // value for 'firstSize'
 *      secondSize: // value for 'secondSize'
 *      relatedEntityId: // value for 'relatedEntityId'
 *      relatedEntityType: // value for 'relatedEntityType'
 *      expiration: // value for 'expiration'
 *   },
 * });
 */
export function useCreateOwnDocumentTwoSidedMutation(baseOptions?: Apollo.MutationHookOptions<CreateOwnDocumentTwoSidedMutation, CreateOwnDocumentTwoSidedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOwnDocumentTwoSidedMutation, CreateOwnDocumentTwoSidedMutationVariables>(CreateOwnDocumentTwoSidedDocument, options);
      }
export type CreateOwnDocumentTwoSidedMutationHookResult = ReturnType<typeof useCreateOwnDocumentTwoSidedMutation>;
export type CreateOwnDocumentTwoSidedMutationResult = Apollo.MutationResult<CreateOwnDocumentTwoSidedMutation>;
export type CreateOwnDocumentTwoSidedMutationOptions = Apollo.BaseMutationOptions<CreateOwnDocumentTwoSidedMutation, CreateOwnDocumentTwoSidedMutationVariables>;
export const RemoveDocumentDocument = gql`
    mutation removeDocument($id: Int!) {
  removeDocument(id: $id) {
    ... on Document {
      id
      type
    }
  }
}
    `;
export type RemoveDocumentMutationFn = Apollo.MutationFunction<RemoveDocumentMutation, RemoveDocumentMutationVariables>;

/**
 * __useRemoveDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDocumentMutation, { data, loading, error }] = useRemoveDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDocumentMutation, RemoveDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDocumentMutation, RemoveDocumentMutationVariables>(RemoveDocumentDocument, options);
      }
export type RemoveDocumentMutationHookResult = ReturnType<typeof useRemoveDocumentMutation>;
export type RemoveDocumentMutationResult = Apollo.MutationResult<RemoveDocumentMutation>;
export type RemoveDocumentMutationOptions = Apollo.BaseMutationOptions<RemoveDocumentMutation, RemoveDocumentMutationVariables>;
export const AddContractUboDocument = gql`
    mutation addContractUBO($id: ID!, $input: AddContractUBOInputType!) {
  addContractUbo(contractId: $id, input: $input) {
    addedFromExistingUbo
    ubo {
      id
      entity {
        ... on Individual {
          id
        }
      }
    }
    id
  }
}
    `;
export type AddContractUboMutationFn = Apollo.MutationFunction<AddContractUboMutation, AddContractUboMutationVariables>;

/**
 * __useAddContractUboMutation__
 *
 * To run a mutation, you first call `useAddContractUboMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContractUboMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContractUboMutation, { data, loading, error }] = useAddContractUboMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddContractUboMutation(baseOptions?: Apollo.MutationHookOptions<AddContractUboMutation, AddContractUboMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContractUboMutation, AddContractUboMutationVariables>(AddContractUboDocument, options);
      }
export type AddContractUboMutationHookResult = ReturnType<typeof useAddContractUboMutation>;
export type AddContractUboMutationResult = Apollo.MutationResult<AddContractUboMutation>;
export type AddContractUboMutationOptions = Apollo.BaseMutationOptions<AddContractUboMutation, AddContractUboMutationVariables>;
export const StartVideoVerificationDocument = gql`
    mutation startVideoVerification($callbackUrl: String!) {
  startVideoVerification(callbackUrl: $callbackUrl)
}
    `;
export type StartVideoVerificationMutationFn = Apollo.MutationFunction<StartVideoVerificationMutation, StartVideoVerificationMutationVariables>;

/**
 * __useStartVideoVerificationMutation__
 *
 * To run a mutation, you first call `useStartVideoVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartVideoVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startVideoVerificationMutation, { data, loading, error }] = useStartVideoVerificationMutation({
 *   variables: {
 *      callbackUrl: // value for 'callbackUrl'
 *   },
 * });
 */
export function useStartVideoVerificationMutation(baseOptions?: Apollo.MutationHookOptions<StartVideoVerificationMutation, StartVideoVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartVideoVerificationMutation, StartVideoVerificationMutationVariables>(StartVideoVerificationDocument, options);
      }
export type StartVideoVerificationMutationHookResult = ReturnType<typeof useStartVideoVerificationMutation>;
export type StartVideoVerificationMutationResult = Apollo.MutationResult<StartVideoVerificationMutation>;
export type StartVideoVerificationMutationOptions = Apollo.BaseMutationOptions<StartVideoVerificationMutation, StartVideoVerificationMutationVariables>;
export const AddUboOwnerDocument = gql`
    mutation addUboOwner($contractId: ID!, $uboId: ID!, $ubo: UBOInputType!) {
  addUboOwner(contractId: $contractId, uboId: $uboId, ubo: $ubo) {
    id
    ubo {
      id
      entity {
        ... on Individual {
          id
        }
      }
    }
  }
}
    `;
export type AddUboOwnerMutationFn = Apollo.MutationFunction<AddUboOwnerMutation, AddUboOwnerMutationVariables>;

/**
 * __useAddUboOwnerMutation__
 *
 * To run a mutation, you first call `useAddUboOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUboOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUboOwnerMutation, { data, loading, error }] = useAddUboOwnerMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      uboId: // value for 'uboId'
 *      ubo: // value for 'ubo'
 *   },
 * });
 */
export function useAddUboOwnerMutation(baseOptions?: Apollo.MutationHookOptions<AddUboOwnerMutation, AddUboOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUboOwnerMutation, AddUboOwnerMutationVariables>(AddUboOwnerDocument, options);
      }
export type AddUboOwnerMutationHookResult = ReturnType<typeof useAddUboOwnerMutation>;
export type AddUboOwnerMutationResult = Apollo.MutationResult<AddUboOwnerMutation>;
export type AddUboOwnerMutationOptions = Apollo.BaseMutationOptions<AddUboOwnerMutation, AddUboOwnerMutationVariables>;
export const UpdateUboOwnerDocument = gql`
    mutation updateUboOwner($contractId: ID!, $uboOwnerId: ID!, $ownedUboId: ID!, $ubo: UpdateUBOInputType!) {
  updateUboOwner(
    contractId: $contractId
    uboOwnerId: $uboOwnerId
    ownedUboId: $ownedUboId
    ubo: $ubo
  ) {
    id
    ubo {
      id
      entity {
        ... on Individual {
          id
        }
      }
    }
  }
}
    `;
export type UpdateUboOwnerMutationFn = Apollo.MutationFunction<UpdateUboOwnerMutation, UpdateUboOwnerMutationVariables>;

/**
 * __useUpdateUboOwnerMutation__
 *
 * To run a mutation, you first call `useUpdateUboOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUboOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUboOwnerMutation, { data, loading, error }] = useUpdateUboOwnerMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      uboOwnerId: // value for 'uboOwnerId'
 *      ownedUboId: // value for 'ownedUboId'
 *      ubo: // value for 'ubo'
 *   },
 * });
 */
export function useUpdateUboOwnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUboOwnerMutation, UpdateUboOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUboOwnerMutation, UpdateUboOwnerMutationVariables>(UpdateUboOwnerDocument, options);
      }
export type UpdateUboOwnerMutationHookResult = ReturnType<typeof useUpdateUboOwnerMutation>;
export type UpdateUboOwnerMutationResult = Apollo.MutationResult<UpdateUboOwnerMutation>;
export type UpdateUboOwnerMutationOptions = Apollo.BaseMutationOptions<UpdateUboOwnerMutation, UpdateUboOwnerMutationVariables>;
export const DeleteUboOwnerDocument = gql`
    mutation deleteUboOwner($contractId: ID!, $uboId: ID!, $uboOwnerId: ID!) {
  removeUBOOwner(contractId: $contractId, uboId: $uboId, uboOwnerId: $uboOwnerId)
}
    `;
export type DeleteUboOwnerMutationFn = Apollo.MutationFunction<DeleteUboOwnerMutation, DeleteUboOwnerMutationVariables>;

/**
 * __useDeleteUboOwnerMutation__
 *
 * To run a mutation, you first call `useDeleteUboOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUboOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUboOwnerMutation, { data, loading, error }] = useDeleteUboOwnerMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      uboId: // value for 'uboId'
 *      uboOwnerId: // value for 'uboOwnerId'
 *   },
 * });
 */
export function useDeleteUboOwnerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUboOwnerMutation, DeleteUboOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUboOwnerMutation, DeleteUboOwnerMutationVariables>(DeleteUboOwnerDocument, options);
      }
export type DeleteUboOwnerMutationHookResult = ReturnType<typeof useDeleteUboOwnerMutation>;
export type DeleteUboOwnerMutationResult = Apollo.MutationResult<DeleteUboOwnerMutation>;
export type DeleteUboOwnerMutationOptions = Apollo.BaseMutationOptions<DeleteUboOwnerMutation, DeleteUboOwnerMutationVariables>;
export const DeleteContractUboDocument = gql`
    mutation deleteContractUbo($id: ID!) {
  removeContractUbo(id: $id)
}
    `;
export type DeleteContractUboMutationFn = Apollo.MutationFunction<DeleteContractUboMutation, DeleteContractUboMutationVariables>;

/**
 * __useDeleteContractUboMutation__
 *
 * To run a mutation, you first call `useDeleteContractUboMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractUboMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractUboMutation, { data, loading, error }] = useDeleteContractUboMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContractUboMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContractUboMutation, DeleteContractUboMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContractUboMutation, DeleteContractUboMutationVariables>(DeleteContractUboDocument, options);
      }
export type DeleteContractUboMutationHookResult = ReturnType<typeof useDeleteContractUboMutation>;
export type DeleteContractUboMutationResult = Apollo.MutationResult<DeleteContractUboMutation>;
export type DeleteContractUboMutationOptions = Apollo.BaseMutationOptions<DeleteContractUboMutation, DeleteContractUboMutationVariables>;
export const UpdateContractUboDocument = gql`
    mutation updateContractUbo($contractUboId: ID!, $input: UpdateContractUBOInputType!) {
  updateContractUbo(contractUboId: $contractUboId, input: $input) {
    addedFromExistingUbo
    ubo {
      id
      entity {
        ... on Individual {
          id
        }
      }
    }
  }
}
    `;
export type UpdateContractUboMutationFn = Apollo.MutationFunction<UpdateContractUboMutation, UpdateContractUboMutationVariables>;

/**
 * __useUpdateContractUboMutation__
 *
 * To run a mutation, you first call `useUpdateContractUboMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractUboMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractUboMutation, { data, loading, error }] = useUpdateContractUboMutation({
 *   variables: {
 *      contractUboId: // value for 'contractUboId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractUboMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractUboMutation, UpdateContractUboMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractUboMutation, UpdateContractUboMutationVariables>(UpdateContractUboDocument, options);
      }
export type UpdateContractUboMutationHookResult = ReturnType<typeof useUpdateContractUboMutation>;
export type UpdateContractUboMutationResult = Apollo.MutationResult<UpdateContractUboMutation>;
export type UpdateContractUboMutationOptions = Apollo.BaseMutationOptions<UpdateContractUboMutation, UpdateContractUboMutationVariables>;
export const UpdateOwnDetailsDocument = gql`
    mutation updateOwnDetails($firstName: String, $lastName: String, $birthday: Date, $country: Country, $nationality: Nationality, $line1: String, $city: String, $zip: String, $additionalDetails: String, $phone: String, $supportingDocumentIds: [ID], $taxId: String) {
  updateOwnDetails(
    firstName: $firstName
    lastName: $lastName
    birthday: $birthday
    nationality: $nationality
    phone: $phone
    address: {country: $country, line1: $line1, city: $city, zip: $zip, additionalDetails: $additionalDetails}
    supportingDocumentIds: $supportingDocumentIds
    taxId: $taxId
  ) {
    id
    status
  }
}
    `;
export type UpdateOwnDetailsMutationFn = Apollo.MutationFunction<UpdateOwnDetailsMutation, UpdateOwnDetailsMutationVariables>;

/**
 * __useUpdateOwnDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateOwnDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOwnDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOwnDetailsMutation, { data, loading, error }] = useUpdateOwnDetailsMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      birthday: // value for 'birthday'
 *      country: // value for 'country'
 *      nationality: // value for 'nationality'
 *      line1: // value for 'line1'
 *      city: // value for 'city'
 *      zip: // value for 'zip'
 *      additionalDetails: // value for 'additionalDetails'
 *      phone: // value for 'phone'
 *      supportingDocumentIds: // value for 'supportingDocumentIds'
 *      taxId: // value for 'taxId'
 *   },
 * });
 */
export function useUpdateOwnDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOwnDetailsMutation, UpdateOwnDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOwnDetailsMutation, UpdateOwnDetailsMutationVariables>(UpdateOwnDetailsDocument, options);
      }
export type UpdateOwnDetailsMutationHookResult = ReturnType<typeof useUpdateOwnDetailsMutation>;
export type UpdateOwnDetailsMutationResult = Apollo.MutationResult<UpdateOwnDetailsMutation>;
export type UpdateOwnDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateOwnDetailsMutation, UpdateOwnDetailsMutationVariables>;
export const UpdateContractAuthPersonDocument = gql`
    mutation updateContractAuthPerson($authPersonId: ID!, $authorizationSetting: AuthorizationSettingInputType, $person: AuthorizedPersonInputType) {
  updateContractAuthorizedPerson(
    authPersonId: $authPersonId
    authorizationSetting: $authorizationSetting
    person: $person
  ) {
    id
    groupSize
    isAuthorizedSignatory
    isLimitedAccessHolder
    limitedAccessRight
    signatoryRight
    status
    person {
      id
      firstName
      lastName
      email
      birthday
      nationality
      phone
      address {
        line1
        city
        zip
        country
        countryDescription
        additionalDetails
      }
    }
  }
}
    `;
export type UpdateContractAuthPersonMutationFn = Apollo.MutationFunction<UpdateContractAuthPersonMutation, UpdateContractAuthPersonMutationVariables>;

/**
 * __useUpdateContractAuthPersonMutation__
 *
 * To run a mutation, you first call `useUpdateContractAuthPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractAuthPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractAuthPersonMutation, { data, loading, error }] = useUpdateContractAuthPersonMutation({
 *   variables: {
 *      authPersonId: // value for 'authPersonId'
 *      authorizationSetting: // value for 'authorizationSetting'
 *      person: // value for 'person'
 *   },
 * });
 */
export function useUpdateContractAuthPersonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractAuthPersonMutation, UpdateContractAuthPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractAuthPersonMutation, UpdateContractAuthPersonMutationVariables>(UpdateContractAuthPersonDocument, options);
      }
export type UpdateContractAuthPersonMutationHookResult = ReturnType<typeof useUpdateContractAuthPersonMutation>;
export type UpdateContractAuthPersonMutationResult = Apollo.MutationResult<UpdateContractAuthPersonMutation>;
export type UpdateContractAuthPersonMutationOptions = Apollo.BaseMutationOptions<UpdateContractAuthPersonMutation, UpdateContractAuthPersonMutationVariables>;
export const SubmitContractForApprovalDocument = gql`
    mutation submitContractForApproval($id: ID!) {
  submitContractForApproval(id: $id) {
    id
    status
    submittedAt
  }
}
    `;
export type SubmitContractForApprovalMutationFn = Apollo.MutationFunction<SubmitContractForApprovalMutation, SubmitContractForApprovalMutationVariables>;

/**
 * __useSubmitContractForApprovalMutation__
 *
 * To run a mutation, you first call `useSubmitContractForApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitContractForApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitContractForApprovalMutation, { data, loading, error }] = useSubmitContractForApprovalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitContractForApprovalMutation(baseOptions?: Apollo.MutationHookOptions<SubmitContractForApprovalMutation, SubmitContractForApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitContractForApprovalMutation, SubmitContractForApprovalMutationVariables>(SubmitContractForApprovalDocument, options);
      }
export type SubmitContractForApprovalMutationHookResult = ReturnType<typeof useSubmitContractForApprovalMutation>;
export type SubmitContractForApprovalMutationResult = Apollo.MutationResult<SubmitContractForApprovalMutation>;
export type SubmitContractForApprovalMutationOptions = Apollo.BaseMutationOptions<SubmitContractForApprovalMutation, SubmitContractForApprovalMutationVariables>;
export const GetActionSigningCodeDocument = gql`
    mutation getActionSigningCode($mode: TwoFACodeDispatchMode, $actionIds: [ID], $status: ActionSignatureStatus, $type: TwoFAOperationType, $fields: String) {
  getActionSigningCode: get2FACode(
    mode: $mode
    actionIds: $actionIds
    status: $status
    type: $type
    fields: $fields
  ) {
    challengeId
    reAttemptTimeout
    resendTimeout
    attemptsLeft
    phoneLastFourDigits
  }
}
    `;
export type GetActionSigningCodeMutationFn = Apollo.MutationFunction<GetActionSigningCodeMutation, GetActionSigningCodeMutationVariables>;

/**
 * __useGetActionSigningCodeMutation__
 *
 * To run a mutation, you first call `useGetActionSigningCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetActionSigningCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getActionSigningCodeMutation, { data, loading, error }] = useGetActionSigningCodeMutation({
 *   variables: {
 *      mode: // value for 'mode'
 *      actionIds: // value for 'actionIds'
 *      status: // value for 'status'
 *      type: // value for 'type'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useGetActionSigningCodeMutation(baseOptions?: Apollo.MutationHookOptions<GetActionSigningCodeMutation, GetActionSigningCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetActionSigningCodeMutation, GetActionSigningCodeMutationVariables>(GetActionSigningCodeDocument, options);
      }
export type GetActionSigningCodeMutationHookResult = ReturnType<typeof useGetActionSigningCodeMutation>;
export type GetActionSigningCodeMutationResult = Apollo.MutationResult<GetActionSigningCodeMutation>;
export type GetActionSigningCodeMutationOptions = Apollo.BaseMutationOptions<GetActionSigningCodeMutation, GetActionSigningCodeMutationVariables>;
export const SignActionWithChallengeCodeDocument = gql`
    mutation signActionWithChallengeCode($actionSignatureId: ID!, $status: ActionSignatureStatus!, $challengeId: String!, $code: String!) {
  signActionWithChallengeCode(
    actionSignatureId: $actionSignatureId
    status: $status
    challengeId: $challengeId
    code: $code
  ) {
    status
    action {
      ... on BaseAction {
        id
        executedAt
        status
        type
      }
      ... on DocumentAction {
        document {
          fileDescription
        }
      }
      ... on StandingOrderActionType {
        standingOrder {
          id
          activationAction {
            ... on BaseAction {
              id
              signatures {
                id
                isMine
                status
              }
            }
          }
        }
      }
    }
    id
  }
}
    `;
export type SignActionWithChallengeCodeMutationFn = Apollo.MutationFunction<SignActionWithChallengeCodeMutation, SignActionWithChallengeCodeMutationVariables>;

/**
 * __useSignActionWithChallengeCodeMutation__
 *
 * To run a mutation, you first call `useSignActionWithChallengeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignActionWithChallengeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signActionWithChallengeCodeMutation, { data, loading, error }] = useSignActionWithChallengeCodeMutation({
 *   variables: {
 *      actionSignatureId: // value for 'actionSignatureId'
 *      status: // value for 'status'
 *      challengeId: // value for 'challengeId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSignActionWithChallengeCodeMutation(baseOptions?: Apollo.MutationHookOptions<SignActionWithChallengeCodeMutation, SignActionWithChallengeCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignActionWithChallengeCodeMutation, SignActionWithChallengeCodeMutationVariables>(SignActionWithChallengeCodeDocument, options);
      }
export type SignActionWithChallengeCodeMutationHookResult = ReturnType<typeof useSignActionWithChallengeCodeMutation>;
export type SignActionWithChallengeCodeMutationResult = Apollo.MutationResult<SignActionWithChallengeCodeMutation>;
export type SignActionWithChallengeCodeMutationOptions = Apollo.BaseMutationOptions<SignActionWithChallengeCodeMutation, SignActionWithChallengeCodeMutationVariables>;
export const SignMultipleActionsWithChallengeCodeDocument = gql`
    mutation signMultipleActionsWithChallengeCode($actionSignatureIds: [ID]!, $status: ActionSignatureStatus!, $challengeId: String!, $code: String!) {
  signMultipleActionsWithChallengeCode(
    actionSignatureIds: $actionSignatureIds
    status: $status
    challengeId: $challengeId
    code: $code
  ) {
    failed {
      id
      value
    }
    signed {
      id
      status
    }
  }
}
    `;
export type SignMultipleActionsWithChallengeCodeMutationFn = Apollo.MutationFunction<SignMultipleActionsWithChallengeCodeMutation, SignMultipleActionsWithChallengeCodeMutationVariables>;

/**
 * __useSignMultipleActionsWithChallengeCodeMutation__
 *
 * To run a mutation, you first call `useSignMultipleActionsWithChallengeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignMultipleActionsWithChallengeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signMultipleActionsWithChallengeCodeMutation, { data, loading, error }] = useSignMultipleActionsWithChallengeCodeMutation({
 *   variables: {
 *      actionSignatureIds: // value for 'actionSignatureIds'
 *      status: // value for 'status'
 *      challengeId: // value for 'challengeId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSignMultipleActionsWithChallengeCodeMutation(baseOptions?: Apollo.MutationHookOptions<SignMultipleActionsWithChallengeCodeMutation, SignMultipleActionsWithChallengeCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignMultipleActionsWithChallengeCodeMutation, SignMultipleActionsWithChallengeCodeMutationVariables>(SignMultipleActionsWithChallengeCodeDocument, options);
      }
export type SignMultipleActionsWithChallengeCodeMutationHookResult = ReturnType<typeof useSignMultipleActionsWithChallengeCodeMutation>;
export type SignMultipleActionsWithChallengeCodeMutationResult = Apollo.MutationResult<SignMultipleActionsWithChallengeCodeMutation>;
export type SignMultipleActionsWithChallengeCodeMutationOptions = Apollo.BaseMutationOptions<SignMultipleActionsWithChallengeCodeMutation, SignMultipleActionsWithChallengeCodeMutationVariables>;
export const CreateOwnDocumentIndividualDocument = gql`
    mutation createOwnDocumentIndividual($type: DocumentType!, $fileName: String!, $plainUrl: String!, $size: Float!, $relatedEntityId: ID, $relatedEntityType: DocumentRelatedEntityType, $fileDescription: String, $expiration: Date) {
  createOwnDocument(
    type: $type
    fileName: $fileName
    plainUrl: $plainUrl
    size: $size
    relatesTo: {relatedEntityId: $relatedEntityId, relatedEntityType: $relatedEntityType}
    fileDescription: $fileDescription
    expiration: $expiration
  ) {
    id
  }
}
    `;
export type CreateOwnDocumentIndividualMutationFn = Apollo.MutationFunction<CreateOwnDocumentIndividualMutation, CreateOwnDocumentIndividualMutationVariables>;

/**
 * __useCreateOwnDocumentIndividualMutation__
 *
 * To run a mutation, you first call `useCreateOwnDocumentIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOwnDocumentIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOwnDocumentIndividualMutation, { data, loading, error }] = useCreateOwnDocumentIndividualMutation({
 *   variables: {
 *      type: // value for 'type'
 *      fileName: // value for 'fileName'
 *      plainUrl: // value for 'plainUrl'
 *      size: // value for 'size'
 *      relatedEntityId: // value for 'relatedEntityId'
 *      relatedEntityType: // value for 'relatedEntityType'
 *      fileDescription: // value for 'fileDescription'
 *      expiration: // value for 'expiration'
 *   },
 * });
 */
export function useCreateOwnDocumentIndividualMutation(baseOptions?: Apollo.MutationHookOptions<CreateOwnDocumentIndividualMutation, CreateOwnDocumentIndividualMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOwnDocumentIndividualMutation, CreateOwnDocumentIndividualMutationVariables>(CreateOwnDocumentIndividualDocument, options);
      }
export type CreateOwnDocumentIndividualMutationHookResult = ReturnType<typeof useCreateOwnDocumentIndividualMutation>;
export type CreateOwnDocumentIndividualMutationResult = Apollo.MutationResult<CreateOwnDocumentIndividualMutation>;
export type CreateOwnDocumentIndividualMutationOptions = Apollo.BaseMutationOptions<CreateOwnDocumentIndividualMutation, CreateOwnDocumentIndividualMutationVariables>;
export const UpdateOwnEmailDocument = gql`
    mutation updateOwnEmail($email: String!) {
  updateOwnEmail(email: $email) {
    id
  }
}
    `;
export type UpdateOwnEmailMutationFn = Apollo.MutationFunction<UpdateOwnEmailMutation, UpdateOwnEmailMutationVariables>;

/**
 * __useUpdateOwnEmailMutation__
 *
 * To run a mutation, you first call `useUpdateOwnEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOwnEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOwnEmailMutation, { data, loading, error }] = useUpdateOwnEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateOwnEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOwnEmailMutation, UpdateOwnEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOwnEmailMutation, UpdateOwnEmailMutationVariables>(UpdateOwnEmailDocument, options);
      }
export type UpdateOwnEmailMutationHookResult = ReturnType<typeof useUpdateOwnEmailMutation>;
export type UpdateOwnEmailMutationResult = Apollo.MutationResult<UpdateOwnEmailMutation>;
export type UpdateOwnEmailMutationOptions = Apollo.BaseMutationOptions<UpdateOwnEmailMutation, UpdateOwnEmailMutationVariables>;
export const AddAccountToOwnContractDocument = gql`
    mutation addAccountToOwnContract($currency: NewAccountCurrency!, $qrrSupported: Boolean, $contractId: ID!, $alias: String, $fundsType: FundsType, $alternativeAccountDetails: SwiftTransferIndividualPartyDetailsWithCurrencyInput) {
  addAccountToOwnContract(
    currency: $currency
    qrrSupported: $qrrSupported
    contractId: $contractId
    alias: $alias
    fundsType: $fundsType
    alternativeAccountDetails: $alternativeAccountDetails
  ) {
    id
    name
    executionAction {
      ... on AccountAction {
        id
        signatures {
          id
          isMine
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type AddAccountToOwnContractMutationFn = Apollo.MutationFunction<AddAccountToOwnContractMutation, AddAccountToOwnContractMutationVariables>;

/**
 * __useAddAccountToOwnContractMutation__
 *
 * To run a mutation, you first call `useAddAccountToOwnContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccountToOwnContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccountToOwnContractMutation, { data, loading, error }] = useAddAccountToOwnContractMutation({
 *   variables: {
 *      currency: // value for 'currency'
 *      qrrSupported: // value for 'qrrSupported'
 *      contractId: // value for 'contractId'
 *      alias: // value for 'alias'
 *      fundsType: // value for 'fundsType'
 *      alternativeAccountDetails: // value for 'alternativeAccountDetails'
 *   },
 * });
 */
export function useAddAccountToOwnContractMutation(baseOptions?: Apollo.MutationHookOptions<AddAccountToOwnContractMutation, AddAccountToOwnContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAccountToOwnContractMutation, AddAccountToOwnContractMutationVariables>(AddAccountToOwnContractDocument, options);
      }
export type AddAccountToOwnContractMutationHookResult = ReturnType<typeof useAddAccountToOwnContractMutation>;
export type AddAccountToOwnContractMutationResult = Apollo.MutationResult<AddAccountToOwnContractMutation>;
export type AddAccountToOwnContractMutationOptions = Apollo.BaseMutationOptions<AddAccountToOwnContractMutation, AddAccountToOwnContractMutationVariables>;
export const UpdateAccountAliasDocument = gql`
    mutation updateAccountAlias($accountId: ID!, $alias: String!) {
  updateAccountAlias(accountId: $accountId, alias: $alias) {
    id
  }
}
    `;
export type UpdateAccountAliasMutationFn = Apollo.MutationFunction<UpdateAccountAliasMutation, UpdateAccountAliasMutationVariables>;

/**
 * __useUpdateAccountAliasMutation__
 *
 * To run a mutation, you first call `useUpdateAccountAliasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountAliasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountAliasMutation, { data, loading, error }] = useUpdateAccountAliasMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      alias: // value for 'alias'
 *   },
 * });
 */
export function useUpdateAccountAliasMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountAliasMutation, UpdateAccountAliasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountAliasMutation, UpdateAccountAliasMutationVariables>(UpdateAccountAliasDocument, options);
      }
export type UpdateAccountAliasMutationHookResult = ReturnType<typeof useUpdateAccountAliasMutation>;
export type UpdateAccountAliasMutationResult = Apollo.MutationResult<UpdateAccountAliasMutation>;
export type UpdateAccountAliasMutationOptions = Apollo.BaseMutationOptions<UpdateAccountAliasMutation, UpdateAccountAliasMutationVariables>;
export const CreateSwiftTransferDocument = gql`
    mutation createSwiftTransfer($fromAccountNo: ID!, $name: String!, $iban: String!, $bankBic: String!, $line1: String, $city: String, $zip: String, $country: Country, $beneficiaryType: SwiftTransferRecipientType!, $amount: Float!, $comments: String!, $executionType: TransactionExecutionType!, $chargeBearer: SwiftTransferChargeBearer) {
  createSwiftTransfer(
    fromAccountNo: $fromAccountNo
    beneficiary: {name: $name, iban: $iban, bankBic: $bankBic, address: {line1: $line1, city: $city, zip: $zip, country: $country}, type: $beneficiaryType}
    beneficiaryType: $beneficiaryType
    amount: $amount
    comments: $comments
    executionType: $executionType
    chargeBearer: $chargeBearer
  ) {
    ... on Transaction {
      ... on CreditTransaction {
        id
        from {
          accountNo
          name
          bankName
          iban
        }
        executionAction {
          ... on BaseAction {
            id
            signatures {
              id
              action {
                ... on BaseAction {
                  id
                }
              }
            }
          }
        }
      }
      ... on DebitTransaction {
        id
        to {
          accountNo
          name
          bankName
          iban
        }
        executionAction {
          ... on BaseAction {
            id
            signatures {
              id
              action {
                ... on BaseAction {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type CreateSwiftTransferMutationFn = Apollo.MutationFunction<CreateSwiftTransferMutation, CreateSwiftTransferMutationVariables>;

/**
 * __useCreateSwiftTransferMutation__
 *
 * To run a mutation, you first call `useCreateSwiftTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSwiftTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSwiftTransferMutation, { data, loading, error }] = useCreateSwiftTransferMutation({
 *   variables: {
 *      fromAccountNo: // value for 'fromAccountNo'
 *      name: // value for 'name'
 *      iban: // value for 'iban'
 *      bankBic: // value for 'bankBic'
 *      line1: // value for 'line1'
 *      city: // value for 'city'
 *      zip: // value for 'zip'
 *      country: // value for 'country'
 *      beneficiaryType: // value for 'beneficiaryType'
 *      amount: // value for 'amount'
 *      comments: // value for 'comments'
 *      executionType: // value for 'executionType'
 *      chargeBearer: // value for 'chargeBearer'
 *   },
 * });
 */
export function useCreateSwiftTransferMutation(baseOptions?: Apollo.MutationHookOptions<CreateSwiftTransferMutation, CreateSwiftTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSwiftTransferMutation, CreateSwiftTransferMutationVariables>(CreateSwiftTransferDocument, options);
      }
export type CreateSwiftTransferMutationHookResult = ReturnType<typeof useCreateSwiftTransferMutation>;
export type CreateSwiftTransferMutationResult = Apollo.MutationResult<CreateSwiftTransferMutation>;
export type CreateSwiftTransferMutationOptions = Apollo.BaseMutationOptions<CreateSwiftTransferMutation, CreateSwiftTransferMutationVariables>;
export const CreateOutboundPaymentDocument = gql`
    mutation createOutboundPayment($fromAccountNo: ID!, $name: String!, $iban: String, $accountNo: String, $bankBic: String, $line1: String, $city: String, $zip: String, $country: Country, $additionalDetails: String, $beneficiaryType: SwiftTransferRecipientType!, $amount: Float!, $payoutAmount: Float, $comments: String!, $executionType: TransactionExecutionType!, $chargeBearer: SwiftTransferChargeBearer, $payoutCurrency: Currency, $quotedXRate: Float, $quotedXRateId: ID, $clientReference: ID, $purposeCode: String, $purposeCode2: String, $phone: String, $taxId: String, $bankClearingMemberId: String, $bankBranchId: String, $bankBranchName: String, $useLocalPay: Boolean, $executionDate: Date, $priority: TransactionPriorityType, $useTLDR: Boolean, $accountNoType: AccountNoType, $kyc: PaymentTransferRecipientKycInput, $pan: String, $bankCountry: Country) {
  createOutboundPayment(
    fromAccountNo: $fromAccountNo
    beneficiary: {name: $name, iban: $iban, accountNo: $accountNo, bankBic: $bankBic, phone: $phone, taxId: $taxId, bankClearingMemberId: $bankClearingMemberId, bankBranchId: $bankBranchId, bankBranchName: $bankBranchName, address: {line1: $line1, city: $city, zip: $zip, country: $country, additionalDetails: $additionalDetails}, type: $beneficiaryType, accountNoType: $accountNoType, kyc: $kyc, pan: $pan, bankCountry: $bankCountry}
    beneficiaryType: $beneficiaryType
    amount: $amount
    payoutAmount: $payoutAmount
    comments: $comments
    executionType: $executionType
    chargeBearer: $chargeBearer
    payoutCurrency: $payoutCurrency
    quotedXRate: $quotedXRate
    quotedXRateId: $quotedXRateId
    clientReference: $clientReference
    purposeCode: $purposeCode
    purposeCode2: $purposeCode2
    useLocalPay: $useLocalPay
    valueDate: $executionDate
    priority: $priority
    useTLDR: $useTLDR
  ) {
    ... on Transaction {
      ... on CreditTransaction {
        id
        from {
          accountNo
          name
          bankName
          iban
        }
        executionAction {
          ... on BaseAction {
            id
            signatures {
              id
              action {
                ... on BaseAction {
                  id
                }
              }
            }
          }
        }
      }
      ... on DebitTransaction {
        id
        to {
          accountNo
          name
          bankName
          iban
        }
        executionAction {
          ... on BaseAction {
            id
            signatures {
              id
              action {
                ... on BaseAction {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type CreateOutboundPaymentMutationFn = Apollo.MutationFunction<CreateOutboundPaymentMutation, CreateOutboundPaymentMutationVariables>;

/**
 * __useCreateOutboundPaymentMutation__
 *
 * To run a mutation, you first call `useCreateOutboundPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOutboundPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOutboundPaymentMutation, { data, loading, error }] = useCreateOutboundPaymentMutation({
 *   variables: {
 *      fromAccountNo: // value for 'fromAccountNo'
 *      name: // value for 'name'
 *      iban: // value for 'iban'
 *      accountNo: // value for 'accountNo'
 *      bankBic: // value for 'bankBic'
 *      line1: // value for 'line1'
 *      city: // value for 'city'
 *      zip: // value for 'zip'
 *      country: // value for 'country'
 *      additionalDetails: // value for 'additionalDetails'
 *      beneficiaryType: // value for 'beneficiaryType'
 *      amount: // value for 'amount'
 *      payoutAmount: // value for 'payoutAmount'
 *      comments: // value for 'comments'
 *      executionType: // value for 'executionType'
 *      chargeBearer: // value for 'chargeBearer'
 *      payoutCurrency: // value for 'payoutCurrency'
 *      quotedXRate: // value for 'quotedXRate'
 *      quotedXRateId: // value for 'quotedXRateId'
 *      clientReference: // value for 'clientReference'
 *      purposeCode: // value for 'purposeCode'
 *      purposeCode2: // value for 'purposeCode2'
 *      phone: // value for 'phone'
 *      taxId: // value for 'taxId'
 *      bankClearingMemberId: // value for 'bankClearingMemberId'
 *      bankBranchId: // value for 'bankBranchId'
 *      bankBranchName: // value for 'bankBranchName'
 *      useLocalPay: // value for 'useLocalPay'
 *      executionDate: // value for 'executionDate'
 *      priority: // value for 'priority'
 *      useTLDR: // value for 'useTLDR'
 *      accountNoType: // value for 'accountNoType'
 *      kyc: // value for 'kyc'
 *      pan: // value for 'pan'
 *      bankCountry: // value for 'bankCountry'
 *   },
 * });
 */
export function useCreateOutboundPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateOutboundPaymentMutation, CreateOutboundPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOutboundPaymentMutation, CreateOutboundPaymentMutationVariables>(CreateOutboundPaymentDocument, options);
      }
export type CreateOutboundPaymentMutationHookResult = ReturnType<typeof useCreateOutboundPaymentMutation>;
export type CreateOutboundPaymentMutationResult = Apollo.MutationResult<CreateOutboundPaymentMutation>;
export type CreateOutboundPaymentMutationOptions = Apollo.BaseMutationOptions<CreateOutboundPaymentMutation, CreateOutboundPaymentMutationVariables>;
export const CreateStandingOrderDocument = gql`
    mutation createStandingOrder($fromAccountNo: ID!, $name: String!, $iban: String, $accountNo: String, $bankBic: String!, $line1: String, $city: String, $zip: String, $country: Country, $additionalDetails: String, $beneficiaryType: SwiftTransferRecipientType!, $amount: Float!, $payoutAmount: Float, $comments: String!, $chargeBearer: SwiftTransferChargeBearer, $payoutCurrency: Currency, $clientReference: ID, $purposeCode: String, $purposeCode2: String, $phone: String, $taxId: String, $bankClearingMemberId: String, $bankBranchId: String, $bankBranchName: String, $useLocalPay: Boolean, $executionDate: String, $periodicity: StandingOrderPeriodicity, $lowerThreshold: Float, $minRemainingBalance: Float) {
  createStandingOrder(
    fromAccountNo: $fromAccountNo
    beneficiary: {name: $name, iban: $iban, accountNo: $accountNo, bankBic: $bankBic, phone: $phone, taxId: $taxId, bankClearingMemberId: $bankClearingMemberId, bankBranchId: $bankBranchId, bankBranchName: $bankBranchName, address: {line1: $line1, city: $city, zip: $zip, country: $country, additionalDetails: $additionalDetails}, type: $beneficiaryType}
    beneficiaryType: $beneficiaryType
    amount: $amount
    payoutAmount: $payoutAmount
    comments: $comments
    chargeBearer: $chargeBearer
    payoutCurrency: $payoutCurrency
    clientReference: $clientReference
    purposeCode: $purposeCode
    purposeCode2: $purposeCode2
    useLocalPay: $useLocalPay
    executionDate: $executionDate
    periodicity: $periodicity
    lowerThreshold: $lowerThreshold
    minRemainingBalance: $minRemainingBalance
  ) {
    id
    executionAction: activationAction {
      ... on BaseAction {
        id
        signatures {
          id
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type CreateStandingOrderMutationFn = Apollo.MutationFunction<CreateStandingOrderMutation, CreateStandingOrderMutationVariables>;

/**
 * __useCreateStandingOrderMutation__
 *
 * To run a mutation, you first call `useCreateStandingOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStandingOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStandingOrderMutation, { data, loading, error }] = useCreateStandingOrderMutation({
 *   variables: {
 *      fromAccountNo: // value for 'fromAccountNo'
 *      name: // value for 'name'
 *      iban: // value for 'iban'
 *      accountNo: // value for 'accountNo'
 *      bankBic: // value for 'bankBic'
 *      line1: // value for 'line1'
 *      city: // value for 'city'
 *      zip: // value for 'zip'
 *      country: // value for 'country'
 *      additionalDetails: // value for 'additionalDetails'
 *      beneficiaryType: // value for 'beneficiaryType'
 *      amount: // value for 'amount'
 *      payoutAmount: // value for 'payoutAmount'
 *      comments: // value for 'comments'
 *      chargeBearer: // value for 'chargeBearer'
 *      payoutCurrency: // value for 'payoutCurrency'
 *      clientReference: // value for 'clientReference'
 *      purposeCode: // value for 'purposeCode'
 *      purposeCode2: // value for 'purposeCode2'
 *      phone: // value for 'phone'
 *      taxId: // value for 'taxId'
 *      bankClearingMemberId: // value for 'bankClearingMemberId'
 *      bankBranchId: // value for 'bankBranchId'
 *      bankBranchName: // value for 'bankBranchName'
 *      useLocalPay: // value for 'useLocalPay'
 *      executionDate: // value for 'executionDate'
 *      periodicity: // value for 'periodicity'
 *      lowerThreshold: // value for 'lowerThreshold'
 *      minRemainingBalance: // value for 'minRemainingBalance'
 *   },
 * });
 */
export function useCreateStandingOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateStandingOrderMutation, CreateStandingOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStandingOrderMutation, CreateStandingOrderMutationVariables>(CreateStandingOrderDocument, options);
      }
export type CreateStandingOrderMutationHookResult = ReturnType<typeof useCreateStandingOrderMutation>;
export type CreateStandingOrderMutationResult = Apollo.MutationResult<CreateStandingOrderMutation>;
export type CreateStandingOrderMutationOptions = Apollo.BaseMutationOptions<CreateStandingOrderMutation, CreateStandingOrderMutationVariables>;
export const InternalTransferDocument = gql`
    mutation internalTransfer($fromAccountNo: ID!, $toAccountNo: ID!, $amount: Float!, $executionType: TransactionExecutionType!, $valueDate: Date, $comments: String!, $quotedXRate: Float, $priority: TransactionPriorityType) {
  createInternalTransfer(
    fromAccountNo: $fromAccountNo
    toAccountNo: $toAccountNo
    amount: $amount
    executionType: $executionType
    valueDate: $valueDate
    comments: $comments
    quotedXRate: $quotedXRate
    priority: $priority
  ) {
    ... on CreditTransaction {
      id
      value
      account {
        balance {
          available
        }
      }
    }
    ... on DebitTransaction {
      id
      value
      account {
        balance {
          available
        }
      }
      executionAction {
        ... on BaseAction {
          id
          totalSignatureCount
          signatures {
            id
            action {
              ... on BaseAction {
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type InternalTransferMutationFn = Apollo.MutationFunction<InternalTransferMutation, InternalTransferMutationVariables>;

/**
 * __useInternalTransferMutation__
 *
 * To run a mutation, you first call `useInternalTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInternalTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [internalTransferMutation, { data, loading, error }] = useInternalTransferMutation({
 *   variables: {
 *      fromAccountNo: // value for 'fromAccountNo'
 *      toAccountNo: // value for 'toAccountNo'
 *      amount: // value for 'amount'
 *      executionType: // value for 'executionType'
 *      valueDate: // value for 'valueDate'
 *      comments: // value for 'comments'
 *      quotedXRate: // value for 'quotedXRate'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function useInternalTransferMutation(baseOptions?: Apollo.MutationHookOptions<InternalTransferMutation, InternalTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InternalTransferMutation, InternalTransferMutationVariables>(InternalTransferDocument, options);
      }
export type InternalTransferMutationHookResult = ReturnType<typeof useInternalTransferMutation>;
export type InternalTransferMutationResult = Apollo.MutationResult<InternalTransferMutation>;
export type InternalTransferMutationOptions = Apollo.BaseMutationOptions<InternalTransferMutation, InternalTransferMutationVariables>;
export const AddContractPaymentRecipientDocument = gql`
    mutation addContractPaymentRecipient($contractId: ID!, $type: SwiftTransferRecipientType!, $firstName: String, $lastName: String, $companyName: String, $currency: Currency, $iban: String, $accountNo: String, $bankBic: String, $bankName: String!, $country: Country!, $city: String!, $zip: String!, $line1: String!, $additionalDetailsOptional: String, $alias: String, $commentTemplate: String, $phone: String, $taxId: String, $bankClearingMemberId: String, $bankBranchId: String, $bankBranchName: String, $accountNoType: AccountNoType, $bankCountry: Country) {
  addContractPaymentRecipient(
    contractId: $contractId
    recipient: {type: $type, firstName: $firstName, lastName: $lastName, companyName: $companyName, currency: $currency, iban: $iban, accountNo: $accountNo, bankBic: $bankBic, bankName: $bankName, address: {country: $country, city: $city, zip: $zip, line1: $line1, additionalDetails: $additionalDetailsOptional}, alias: $alias, commentTemplate: $commentTemplate, accountNoType: $accountNoType, bankCountry: $bankCountry}
    phone: $phone
    taxId: $taxId
    bankClearingMemberId: $bankClearingMemberId
    bankBranchId: $bankBranchId
    bankBranchName: $bankBranchName
  ) {
    id
    type
    firstName
    lastName
    companyName
    iban
    accountNo
    currency
    bankBic
    bankBranchId
    bankClearingMemberId
    accountNoType
    taxId
    phone
    address {
      country
      city
      zip
      line1
    }
    alias
    commentTemplate
    pan
    kyc {
      individual {
        dateOfBirth
        nationality
        idType
        idNumber
        idIssueDate
        idExpiryDate
        idIssueCountry
      }
      company {
        registrationNumber
        registrationType
        registrationDate
      }
    }
  }
}
    `;
export type AddContractPaymentRecipientMutationFn = Apollo.MutationFunction<AddContractPaymentRecipientMutation, AddContractPaymentRecipientMutationVariables>;

/**
 * __useAddContractPaymentRecipientMutation__
 *
 * To run a mutation, you first call `useAddContractPaymentRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContractPaymentRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContractPaymentRecipientMutation, { data, loading, error }] = useAddContractPaymentRecipientMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      type: // value for 'type'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      companyName: // value for 'companyName'
 *      currency: // value for 'currency'
 *      iban: // value for 'iban'
 *      accountNo: // value for 'accountNo'
 *      bankBic: // value for 'bankBic'
 *      bankName: // value for 'bankName'
 *      country: // value for 'country'
 *      city: // value for 'city'
 *      zip: // value for 'zip'
 *      line1: // value for 'line1'
 *      additionalDetailsOptional: // value for 'additionalDetailsOptional'
 *      alias: // value for 'alias'
 *      commentTemplate: // value for 'commentTemplate'
 *      phone: // value for 'phone'
 *      taxId: // value for 'taxId'
 *      bankClearingMemberId: // value for 'bankClearingMemberId'
 *      bankBranchId: // value for 'bankBranchId'
 *      bankBranchName: // value for 'bankBranchName'
 *      accountNoType: // value for 'accountNoType'
 *      bankCountry: // value for 'bankCountry'
 *   },
 * });
 */
export function useAddContractPaymentRecipientMutation(baseOptions?: Apollo.MutationHookOptions<AddContractPaymentRecipientMutation, AddContractPaymentRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContractPaymentRecipientMutation, AddContractPaymentRecipientMutationVariables>(AddContractPaymentRecipientDocument, options);
      }
export type AddContractPaymentRecipientMutationHookResult = ReturnType<typeof useAddContractPaymentRecipientMutation>;
export type AddContractPaymentRecipientMutationResult = Apollo.MutationResult<AddContractPaymentRecipientMutation>;
export type AddContractPaymentRecipientMutationOptions = Apollo.BaseMutationOptions<AddContractPaymentRecipientMutation, AddContractPaymentRecipientMutationVariables>;
export const UpdateContractPaymentRecipientDocument = gql`
    mutation updateContractPaymentRecipient($id: ID!, $type: SwiftTransferRecipientType!, $firstName: String, $lastName: String, $companyName: String, $currency: Currency, $iban: String, $accountNo: String, $bankBic: String, $bankName: String!, $country: Country!, $city: String!, $zip: String!, $line1: String!, $additionalDetailsOptional: String, $alias: String, $commentTemplate: String, $bankBranchName: String, $bankBranchId: String, $bankClearingMemberId: String, $taxId: String, $phone: String, $accountNoType: AccountNoType, $bankCountry: Country) {
  updateContractPaymentRecipient(
    id: $id
    input: {type: $type, firstName: $firstName, lastName: $lastName, companyName: $companyName, currency: $currency, iban: $iban, accountNo: $accountNo, bankBic: $bankBic, bankName: $bankName, address: {country: $country, city: $city, zip: $zip, line1: $line1, additionalDetails: $additionalDetailsOptional}, alias: $alias, commentTemplate: $commentTemplate, accountNoType: $accountNoType, bankCountry: $bankCountry}
    bankBranchId: $bankBranchId
    bankBranchName: $bankBranchName
    bankClearingMemberId: $bankClearingMemberId
    taxId: $taxId
    phone: $phone
  ) {
    id
  }
}
    `;
export type UpdateContractPaymentRecipientMutationFn = Apollo.MutationFunction<UpdateContractPaymentRecipientMutation, UpdateContractPaymentRecipientMutationVariables>;

/**
 * __useUpdateContractPaymentRecipientMutation__
 *
 * To run a mutation, you first call `useUpdateContractPaymentRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractPaymentRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractPaymentRecipientMutation, { data, loading, error }] = useUpdateContractPaymentRecipientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      companyName: // value for 'companyName'
 *      currency: // value for 'currency'
 *      iban: // value for 'iban'
 *      accountNo: // value for 'accountNo'
 *      bankBic: // value for 'bankBic'
 *      bankName: // value for 'bankName'
 *      country: // value for 'country'
 *      city: // value for 'city'
 *      zip: // value for 'zip'
 *      line1: // value for 'line1'
 *      additionalDetailsOptional: // value for 'additionalDetailsOptional'
 *      alias: // value for 'alias'
 *      commentTemplate: // value for 'commentTemplate'
 *      bankBranchName: // value for 'bankBranchName'
 *      bankBranchId: // value for 'bankBranchId'
 *      bankClearingMemberId: // value for 'bankClearingMemberId'
 *      taxId: // value for 'taxId'
 *      phone: // value for 'phone'
 *      accountNoType: // value for 'accountNoType'
 *      bankCountry: // value for 'bankCountry'
 *   },
 * });
 */
export function useUpdateContractPaymentRecipientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractPaymentRecipientMutation, UpdateContractPaymentRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractPaymentRecipientMutation, UpdateContractPaymentRecipientMutationVariables>(UpdateContractPaymentRecipientDocument, options);
      }
export type UpdateContractPaymentRecipientMutationHookResult = ReturnType<typeof useUpdateContractPaymentRecipientMutation>;
export type UpdateContractPaymentRecipientMutationResult = Apollo.MutationResult<UpdateContractPaymentRecipientMutation>;
export type UpdateContractPaymentRecipientMutationOptions = Apollo.BaseMutationOptions<UpdateContractPaymentRecipientMutation, UpdateContractPaymentRecipientMutationVariables>;
export const RemoveContractPaymentRecipientDocument = gql`
    mutation removeContractPaymentRecipient($id: ID!) {
  removeContractPaymentRecipient(id: $id)
}
    `;
export type RemoveContractPaymentRecipientMutationFn = Apollo.MutationFunction<RemoveContractPaymentRecipientMutation, RemoveContractPaymentRecipientMutationVariables>;

/**
 * __useRemoveContractPaymentRecipientMutation__
 *
 * To run a mutation, you first call `useRemoveContractPaymentRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContractPaymentRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContractPaymentRecipientMutation, { data, loading, error }] = useRemoveContractPaymentRecipientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveContractPaymentRecipientMutation(baseOptions?: Apollo.MutationHookOptions<RemoveContractPaymentRecipientMutation, RemoveContractPaymentRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveContractPaymentRecipientMutation, RemoveContractPaymentRecipientMutationVariables>(RemoveContractPaymentRecipientDocument, options);
      }
export type RemoveContractPaymentRecipientMutationHookResult = ReturnType<typeof useRemoveContractPaymentRecipientMutation>;
export type RemoveContractPaymentRecipientMutationResult = Apollo.MutationResult<RemoveContractPaymentRecipientMutation>;
export type RemoveContractPaymentRecipientMutationOptions = Apollo.BaseMutationOptions<RemoveContractPaymentRecipientMutation, RemoveContractPaymentRecipientMutationVariables>;
export const Get2FaCodeChangePasswordDocument = gql`
    mutation get2FACodeChangePassword($type: TwoFAOperationType) {
  get2FACode(type: $type) {
    challengeId
    resendTimeout
    attemptsLeft
    expectedDigits
    phoneLastFourDigits
  }
}
    `;
export type Get2FaCodeChangePasswordMutationFn = Apollo.MutationFunction<Get2FaCodeChangePasswordMutation, Get2FaCodeChangePasswordMutationVariables>;

/**
 * __useGet2FaCodeChangePasswordMutation__
 *
 * To run a mutation, you first call `useGet2FaCodeChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGet2FaCodeChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [get2FaCodeChangePasswordMutation, { data, loading, error }] = useGet2FaCodeChangePasswordMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGet2FaCodeChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<Get2FaCodeChangePasswordMutation, Get2FaCodeChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Get2FaCodeChangePasswordMutation, Get2FaCodeChangePasswordMutationVariables>(Get2FaCodeChangePasswordDocument, options);
      }
export type Get2FaCodeChangePasswordMutationHookResult = ReturnType<typeof useGet2FaCodeChangePasswordMutation>;
export type Get2FaCodeChangePasswordMutationResult = Apollo.MutationResult<Get2FaCodeChangePasswordMutation>;
export type Get2FaCodeChangePasswordMutationOptions = Apollo.BaseMutationOptions<Get2FaCodeChangePasswordMutation, Get2FaCodeChangePasswordMutationVariables>;
export const AddTeamMateDocument = gql`
    mutation addTeamMate($contractId: ID!, $input: AddAuthorizedPersonInputType) {
  addContractAuthorizedPersonRequest(input: $input, contractId: $contractId) {
    contractAuthPerson {
      id
      person {
        firstName
        lastName
      }
    }
    executionAction {
      ... on AddContractAuthorizedPersonRequestAction {
        id
        signatures {
          id
          action {
            ... on AddContractAuthorizedPersonRequestAction {
              id
              type
              status
            }
          }
          signatory {
            id
            isAuthorizedSignatory
            signatoryRight
          }
          isMine
          status
          signingMethod
          createdAt
          updatedAt
          signedAt
        }
      }
    }
  }
}
    `;
export type AddTeamMateMutationFn = Apollo.MutationFunction<AddTeamMateMutation, AddTeamMateMutationVariables>;

/**
 * __useAddTeamMateMutation__
 *
 * To run a mutation, you first call `useAddTeamMateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamMateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamMateMutation, { data, loading, error }] = useAddTeamMateMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTeamMateMutation(baseOptions?: Apollo.MutationHookOptions<AddTeamMateMutation, AddTeamMateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTeamMateMutation, AddTeamMateMutationVariables>(AddTeamMateDocument, options);
      }
export type AddTeamMateMutationHookResult = ReturnType<typeof useAddTeamMateMutation>;
export type AddTeamMateMutationResult = Apollo.MutationResult<AddTeamMateMutation>;
export type AddTeamMateMutationOptions = Apollo.BaseMutationOptions<AddTeamMateMutation, AddTeamMateMutationVariables>;
export const IssueCardRequestDocument = gql`
    mutation issueCardRequest($accountId: ID!, $contractAuthorizedPersonId: ID!, $type: ApiCardTypes, $limits: [CardLimitInputType], $alias: String, $deliveryAddress: AddressInput) {
  issueCardRequest(
    accountId: $accountId
    contractAuthorizedPersonId: $contractAuthorizedPersonId
    type: $type
    limits: $limits
    alias: $alias
    deliveryAddress: $deliveryAddress
  ) {
    id
    card {
      id
      alias
      cardHolder {
        person {
          id
          fullName
        }
      }
    }
    executionAction {
      ... on CardIssueRequestAction {
        id
        signatures {
          id
          action {
            ... on CardIssueRequestAction {
              id
              type
              status
            }
          }
          signatory {
            id
            isAuthorizedSignatory
            signatoryRight
          }
          isMine
          status
          signingMethod
          createdAt
          updatedAt
          signedAt
        }
      }
    }
  }
}
    `;
export type IssueCardRequestMutationFn = Apollo.MutationFunction<IssueCardRequestMutation, IssueCardRequestMutationVariables>;

/**
 * __useIssueCardRequestMutation__
 *
 * To run a mutation, you first call `useIssueCardRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueCardRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueCardRequestMutation, { data, loading, error }] = useIssueCardRequestMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      contractAuthorizedPersonId: // value for 'contractAuthorizedPersonId'
 *      type: // value for 'type'
 *      limits: // value for 'limits'
 *      alias: // value for 'alias'
 *      deliveryAddress: // value for 'deliveryAddress'
 *   },
 * });
 */
export function useIssueCardRequestMutation(baseOptions?: Apollo.MutationHookOptions<IssueCardRequestMutation, IssueCardRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueCardRequestMutation, IssueCardRequestMutationVariables>(IssueCardRequestDocument, options);
      }
export type IssueCardRequestMutationHookResult = ReturnType<typeof useIssueCardRequestMutation>;
export type IssueCardRequestMutationResult = Apollo.MutationResult<IssueCardRequestMutation>;
export type IssueCardRequestMutationOptions = Apollo.BaseMutationOptions<IssueCardRequestMutation, IssueCardRequestMutationVariables>;
export const RenameCardDocument = gql`
    mutation renameCard($alias: String, $cardId: ID!) {
  renameCard(alias: $alias, cardId: $cardId) {
    id
  }
}
    `;
export type RenameCardMutationFn = Apollo.MutationFunction<RenameCardMutation, RenameCardMutationVariables>;

/**
 * __useRenameCardMutation__
 *
 * To run a mutation, you first call `useRenameCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameCardMutation, { data, loading, error }] = useRenameCardMutation({
 *   variables: {
 *      alias: // value for 'alias'
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useRenameCardMutation(baseOptions?: Apollo.MutationHookOptions<RenameCardMutation, RenameCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameCardMutation, RenameCardMutationVariables>(RenameCardDocument, options);
      }
export type RenameCardMutationHookResult = ReturnType<typeof useRenameCardMutation>;
export type RenameCardMutationResult = Apollo.MutationResult<RenameCardMutation>;
export type RenameCardMutationOptions = Apollo.BaseMutationOptions<RenameCardMutation, RenameCardMutationVariables>;
export const FreezeCardDocument = gql`
    mutation freezeCard($cardId: ID!) {
  freezeCard(cardId: $cardId) {
    id
    status
  }
}
    `;
export type FreezeCardMutationFn = Apollo.MutationFunction<FreezeCardMutation, FreezeCardMutationVariables>;

/**
 * __useFreezeCardMutation__
 *
 * To run a mutation, you first call `useFreezeCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFreezeCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [freezeCardMutation, { data, loading, error }] = useFreezeCardMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useFreezeCardMutation(baseOptions?: Apollo.MutationHookOptions<FreezeCardMutation, FreezeCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FreezeCardMutation, FreezeCardMutationVariables>(FreezeCardDocument, options);
      }
export type FreezeCardMutationHookResult = ReturnType<typeof useFreezeCardMutation>;
export type FreezeCardMutationResult = Apollo.MutationResult<FreezeCardMutation>;
export type FreezeCardMutationOptions = Apollo.BaseMutationOptions<FreezeCardMutation, FreezeCardMutationVariables>;
export const UnFreezeCardDocument = gql`
    mutation unFreezeCard($cardId: ID!) {
  unFreezeCard(cardId: $cardId) {
    id
    status
  }
}
    `;
export type UnFreezeCardMutationFn = Apollo.MutationFunction<UnFreezeCardMutation, UnFreezeCardMutationVariables>;

/**
 * __useUnFreezeCardMutation__
 *
 * To run a mutation, you first call `useUnFreezeCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnFreezeCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unFreezeCardMutation, { data, loading, error }] = useUnFreezeCardMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useUnFreezeCardMutation(baseOptions?: Apollo.MutationHookOptions<UnFreezeCardMutation, UnFreezeCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnFreezeCardMutation, UnFreezeCardMutationVariables>(UnFreezeCardDocument, options);
      }
export type UnFreezeCardMutationHookResult = ReturnType<typeof useUnFreezeCardMutation>;
export type UnFreezeCardMutationResult = Apollo.MutationResult<UnFreezeCardMutation>;
export type UnFreezeCardMutationOptions = Apollo.BaseMutationOptions<UnFreezeCardMutation, UnFreezeCardMutationVariables>;
export const TerminateCardDocument = gql`
    mutation terminateCard($challengeId: String!, $code: Int!, $cardId: ID!) {
  terminateCard(challengeId: $challengeId, code: $code, cardId: $cardId) {
    id
    status
  }
}
    `;
export type TerminateCardMutationFn = Apollo.MutationFunction<TerminateCardMutation, TerminateCardMutationVariables>;

/**
 * __useTerminateCardMutation__
 *
 * To run a mutation, you first call `useTerminateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTerminateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [terminateCardMutation, { data, loading, error }] = useTerminateCardMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      code: // value for 'code'
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useTerminateCardMutation(baseOptions?: Apollo.MutationHookOptions<TerminateCardMutation, TerminateCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TerminateCardMutation, TerminateCardMutationVariables>(TerminateCardDocument, options);
      }
export type TerminateCardMutationHookResult = ReturnType<typeof useTerminateCardMutation>;
export type TerminateCardMutationResult = Apollo.MutationResult<TerminateCardMutation>;
export type TerminateCardMutationOptions = Apollo.BaseMutationOptions<TerminateCardMutation, TerminateCardMutationVariables>;
export const ChangeCardLimitsDocument = gql`
    mutation changeCardLimits($cardId: ID!, $limits: [CardLimitInputType]) {
  spendingLimitRequest(cardId: $cardId, limits: $limits) {
    updatedAt
    executionAction {
      ... on SpendingLimitRequestAction {
        id
        signatures {
          id
          isMine
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type ChangeCardLimitsMutationFn = Apollo.MutationFunction<ChangeCardLimitsMutation, ChangeCardLimitsMutationVariables>;

/**
 * __useChangeCardLimitsMutation__
 *
 * To run a mutation, you first call `useChangeCardLimitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCardLimitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCardLimitsMutation, { data, loading, error }] = useChangeCardLimitsMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *      limits: // value for 'limits'
 *   },
 * });
 */
export function useChangeCardLimitsMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCardLimitsMutation, ChangeCardLimitsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCardLimitsMutation, ChangeCardLimitsMutationVariables>(ChangeCardLimitsDocument, options);
      }
export type ChangeCardLimitsMutationHookResult = ReturnType<typeof useChangeCardLimitsMutation>;
export type ChangeCardLimitsMutationResult = Apollo.MutationResult<ChangeCardLimitsMutation>;
export type ChangeCardLimitsMutationOptions = Apollo.BaseMutationOptions<ChangeCardLimitsMutation, ChangeCardLimitsMutationVariables>;
export const ActivateCardDocument = gql`
    mutation activateCard($challengeId: String!, $code: ID!, $cardId: ID!, $password: ID!) {
  activateCard(
    cardId: $cardId
    code: $code
    challengeId: $challengeId
    password: $password
  ) {
    id
    status
  }
}
    `;
export type ActivateCardMutationFn = Apollo.MutationFunction<ActivateCardMutation, ActivateCardMutationVariables>;

/**
 * __useActivateCardMutation__
 *
 * To run a mutation, you first call `useActivateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateCardMutation, { data, loading, error }] = useActivateCardMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      code: // value for 'code'
 *      cardId: // value for 'cardId'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useActivateCardMutation(baseOptions?: Apollo.MutationHookOptions<ActivateCardMutation, ActivateCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateCardMutation, ActivateCardMutationVariables>(ActivateCardDocument, options);
      }
export type ActivateCardMutationHookResult = ReturnType<typeof useActivateCardMutation>;
export type ActivateCardMutationResult = Apollo.MutationResult<ActivateCardMutation>;
export type ActivateCardMutationOptions = Apollo.BaseMutationOptions<ActivateCardMutation, ActivateCardMutationVariables>;
export const ContractDetailsChangeDocument = gql`
    mutation contractDetailsChange($id: ID!, $updates: BankableEntityContractInputType!, $supportingDocumentIds: [ID], $missingInfoId: String) {
  contractChangeRequest(
    id: $id
    updates: $updates
    supportingDocumentIds: $supportingDocumentIds
    missingInfoId: $missingInfoId
  ) {
    id
    executionAction {
      ... on ContractChangeAction {
        id
        signatures {
          id
          isMine
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type ContractDetailsChangeMutationFn = Apollo.MutationFunction<ContractDetailsChangeMutation, ContractDetailsChangeMutationVariables>;

/**
 * __useContractDetailsChangeMutation__
 *
 * To run a mutation, you first call `useContractDetailsChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractDetailsChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractDetailsChangeMutation, { data, loading, error }] = useContractDetailsChangeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *      supportingDocumentIds: // value for 'supportingDocumentIds'
 *      missingInfoId: // value for 'missingInfoId'
 *   },
 * });
 */
export function useContractDetailsChangeMutation(baseOptions?: Apollo.MutationHookOptions<ContractDetailsChangeMutation, ContractDetailsChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractDetailsChangeMutation, ContractDetailsChangeMutationVariables>(ContractDetailsChangeDocument, options);
      }
export type ContractDetailsChangeMutationHookResult = ReturnType<typeof useContractDetailsChangeMutation>;
export type ContractDetailsChangeMutationResult = Apollo.MutationResult<ContractDetailsChangeMutation>;
export type ContractDetailsChangeMutationOptions = Apollo.BaseMutationOptions<ContractDetailsChangeMutation, ContractDetailsChangeMutationVariables>;
export const CreateOwnDocumentRelatedDocument = gql`
    mutation createOwnDocumentRelated($type: DocumentType!, $fileName: String!, $plainUrl: String!, $contractId: Int!, $size: Float!, $relatedAccountId: ID, $relatedStandingOrderId: ID, $relatedTransactionId: ID, $relatedIndividualId: ID, $fileDescription: String, $relatesTo: DocumentRelatedEntityInput, $relatedWalletId: String, $relatedTransactionRequestId: ID) {
  createOwnDocument(
    type: $type
    fileName: $fileName
    plainUrl: $plainUrl
    contractId: $contractId
    size: $size
    relatedAccountId: $relatedAccountId
    relatedStandingOrderId: $relatedStandingOrderId
    relatedTransactionId: $relatedTransactionId
    relatedIndividualId: $relatedIndividualId
    fileDescription: $fileDescription
    relatesTo: $relatesTo
    relatedWalletId: $relatedWalletId
    relatedTransactionRequestId: $relatedTransactionRequestId
  ) {
    id
  }
}
    `;
export type CreateOwnDocumentRelatedMutationFn = Apollo.MutationFunction<CreateOwnDocumentRelatedMutation, CreateOwnDocumentRelatedMutationVariables>;

/**
 * __useCreateOwnDocumentRelatedMutation__
 *
 * To run a mutation, you first call `useCreateOwnDocumentRelatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOwnDocumentRelatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOwnDocumentRelatedMutation, { data, loading, error }] = useCreateOwnDocumentRelatedMutation({
 *   variables: {
 *      type: // value for 'type'
 *      fileName: // value for 'fileName'
 *      plainUrl: // value for 'plainUrl'
 *      contractId: // value for 'contractId'
 *      size: // value for 'size'
 *      relatedAccountId: // value for 'relatedAccountId'
 *      relatedStandingOrderId: // value for 'relatedStandingOrderId'
 *      relatedTransactionId: // value for 'relatedTransactionId'
 *      relatedIndividualId: // value for 'relatedIndividualId'
 *      fileDescription: // value for 'fileDescription'
 *      relatesTo: // value for 'relatesTo'
 *      relatedWalletId: // value for 'relatedWalletId'
 *      relatedTransactionRequestId: // value for 'relatedTransactionRequestId'
 *   },
 * });
 */
export function useCreateOwnDocumentRelatedMutation(baseOptions?: Apollo.MutationHookOptions<CreateOwnDocumentRelatedMutation, CreateOwnDocumentRelatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOwnDocumentRelatedMutation, CreateOwnDocumentRelatedMutationVariables>(CreateOwnDocumentRelatedDocument, options);
      }
export type CreateOwnDocumentRelatedMutationHookResult = ReturnType<typeof useCreateOwnDocumentRelatedMutation>;
export type CreateOwnDocumentRelatedMutationResult = Apollo.MutationResult<CreateOwnDocumentRelatedMutation>;
export type CreateOwnDocumentRelatedMutationOptions = Apollo.BaseMutationOptions<CreateOwnDocumentRelatedMutation, CreateOwnDocumentRelatedMutationVariables>;
export const CreateCustomerSupportRequestDocument = gql`
    mutation createCustomerSupportRequest($title: String!, $contractId: ID, $details: String!, $attachmentUrls: [String], $topic: String) {
  createCustomerSupportRequest(
    title: $title
    contractId: $contractId
    details: $details
    attachmentUrls: $attachmentUrls
    topic: $topic
  )
}
    `;
export type CreateCustomerSupportRequestMutationFn = Apollo.MutationFunction<CreateCustomerSupportRequestMutation, CreateCustomerSupportRequestMutationVariables>;

/**
 * __useCreateCustomerSupportRequestMutation__
 *
 * To run a mutation, you first call `useCreateCustomerSupportRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerSupportRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerSupportRequestMutation, { data, loading, error }] = useCreateCustomerSupportRequestMutation({
 *   variables: {
 *      title: // value for 'title'
 *      contractId: // value for 'contractId'
 *      details: // value for 'details'
 *      attachmentUrls: // value for 'attachmentUrls'
 *      topic: // value for 'topic'
 *   },
 * });
 */
export function useCreateCustomerSupportRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerSupportRequestMutation, CreateCustomerSupportRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerSupportRequestMutation, CreateCustomerSupportRequestMutationVariables>(CreateCustomerSupportRequestDocument, options);
      }
export type CreateCustomerSupportRequestMutationHookResult = ReturnType<typeof useCreateCustomerSupportRequestMutation>;
export type CreateCustomerSupportRequestMutationResult = Apollo.MutationResult<CreateCustomerSupportRequestMutation>;
export type CreateCustomerSupportRequestMutationOptions = Apollo.BaseMutationOptions<CreateCustomerSupportRequestMutation, CreateCustomerSupportRequestMutationVariables>;
export const GetBatchFileUploadUrlDocument = gql`
    mutation getBatchFileUploadUrl {
  getBatchPaymentFileSignedUrl {
    key
    plainUrl
    signedUrl
  }
}
    `;
export type GetBatchFileUploadUrlMutationFn = Apollo.MutationFunction<GetBatchFileUploadUrlMutation, GetBatchFileUploadUrlMutationVariables>;

/**
 * __useGetBatchFileUploadUrlMutation__
 *
 * To run a mutation, you first call `useGetBatchFileUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetBatchFileUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getBatchFileUploadUrlMutation, { data, loading, error }] = useGetBatchFileUploadUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetBatchFileUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetBatchFileUploadUrlMutation, GetBatchFileUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetBatchFileUploadUrlMutation, GetBatchFileUploadUrlMutationVariables>(GetBatchFileUploadUrlDocument, options);
      }
export type GetBatchFileUploadUrlMutationHookResult = ReturnType<typeof useGetBatchFileUploadUrlMutation>;
export type GetBatchFileUploadUrlMutationResult = Apollo.MutationResult<GetBatchFileUploadUrlMutation>;
export type GetBatchFileUploadUrlMutationOptions = Apollo.BaseMutationOptions<GetBatchFileUploadUrlMutation, GetBatchFileUploadUrlMutationVariables>;
export const ValidateBatchFileDocument = gql`
    mutation validateBatchFile($fileUrl: String!, $accountId: ID!) {
  validateBatchPaymentFile(fileUrl: $fileUrl, accountId: $accountId) {
    valid
    currency
    calculatedTotal
    calculatedValidTotal
    count
    oversized
    paymentRecords {
      id
      amount
      currency
      beneficiaryType
      beneficiaryName
      beneficiaryAccountId
      beneficiaryAccountIdType
      bankBic
      reference
      priority
      street1
      street2
      postalCode
      city
      country
      isValid
      status
      errors
      payoutAmount
      payoutCurrency
      useLocalAchPayout
      fixedPayoutAmount
      bankClearingMemberId
      bankBranchId
      bankBranchName
      beneficiaryPhone
      beneficiaryEmail
      purposeCode
      chargeBearer
    }
  }
}
    `;
export type ValidateBatchFileMutationFn = Apollo.MutationFunction<ValidateBatchFileMutation, ValidateBatchFileMutationVariables>;

/**
 * __useValidateBatchFileMutation__
 *
 * To run a mutation, you first call `useValidateBatchFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateBatchFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateBatchFileMutation, { data, loading, error }] = useValidateBatchFileMutation({
 *   variables: {
 *      fileUrl: // value for 'fileUrl'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useValidateBatchFileMutation(baseOptions?: Apollo.MutationHookOptions<ValidateBatchFileMutation, ValidateBatchFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateBatchFileMutation, ValidateBatchFileMutationVariables>(ValidateBatchFileDocument, options);
      }
export type ValidateBatchFileMutationHookResult = ReturnType<typeof useValidateBatchFileMutation>;
export type ValidateBatchFileMutationResult = Apollo.MutationResult<ValidateBatchFileMutation>;
export type ValidateBatchFileMutationOptions = Apollo.BaseMutationOptions<ValidateBatchFileMutation, ValidateBatchFileMutationVariables>;
export const StartBatchPaymentDocument = gql`
    mutation startBatchPayment($accountId: ID!, $fileUrl: String!) {
  startBatchPayment(accountId: $accountId, fileUrl: $fileUrl) {
    id
    fileUrl
    executionAction {
      ... on BatchPaymentActionType {
        id
        signatures {
          id
          action {
            ... on BatchPaymentActionType {
              id
              type
              status
            }
          }
          signatory {
            id
            isAuthorizedSignatory
            signatoryRight
          }
          isMine
          status
          signingMethod
          createdAt
          updatedAt
          signedAt
        }
      }
    }
    status
    cancellationReason
    createdAt
    updatedAt
  }
}
    `;
export type StartBatchPaymentMutationFn = Apollo.MutationFunction<StartBatchPaymentMutation, StartBatchPaymentMutationVariables>;

/**
 * __useStartBatchPaymentMutation__
 *
 * To run a mutation, you first call `useStartBatchPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartBatchPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startBatchPaymentMutation, { data, loading, error }] = useStartBatchPaymentMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      fileUrl: // value for 'fileUrl'
 *   },
 * });
 */
export function useStartBatchPaymentMutation(baseOptions?: Apollo.MutationHookOptions<StartBatchPaymentMutation, StartBatchPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartBatchPaymentMutation, StartBatchPaymentMutationVariables>(StartBatchPaymentDocument, options);
      }
export type StartBatchPaymentMutationHookResult = ReturnType<typeof useStartBatchPaymentMutation>;
export type StartBatchPaymentMutationResult = Apollo.MutationResult<StartBatchPaymentMutation>;
export type StartBatchPaymentMutationOptions = Apollo.BaseMutationOptions<StartBatchPaymentMutation, StartBatchPaymentMutationVariables>;
export const MarkDocumentsAsReadDocument = gql`
    mutation markDocumentsAsRead($documentIds: [ID]!) {
  markDocumentsAsRead(documentIds: $documentIds)
}
    `;
export type MarkDocumentsAsReadMutationFn = Apollo.MutationFunction<MarkDocumentsAsReadMutation, MarkDocumentsAsReadMutationVariables>;

/**
 * __useMarkDocumentsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkDocumentsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDocumentsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDocumentsAsReadMutation, { data, loading, error }] = useMarkDocumentsAsReadMutation({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useMarkDocumentsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkDocumentsAsReadMutation, MarkDocumentsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkDocumentsAsReadMutation, MarkDocumentsAsReadMutationVariables>(MarkDocumentsAsReadDocument, options);
      }
export type MarkDocumentsAsReadMutationHookResult = ReturnType<typeof useMarkDocumentsAsReadMutation>;
export type MarkDocumentsAsReadMutationResult = Apollo.MutationResult<MarkDocumentsAsReadMutation>;
export type MarkDocumentsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkDocumentsAsReadMutation, MarkDocumentsAsReadMutationVariables>;
export const UpsertContractTechnicalPropertiesDocument = gql`
    mutation upsertContractTechnicalProperties($id: ID, $contractId: ID!, $paymentWebhook: String!, $webhookSignatureKey: String) {
  upsertContractTechnicalProperties(
    id: $id
    contractId: $contractId
    paymentWebhook: $paymentWebhook
    webhookSignatureKey: $webhookSignatureKey
  ) {
    id
    paymentWebhook
    webhookSignatureKey
  }
}
    `;
export type UpsertContractTechnicalPropertiesMutationFn = Apollo.MutationFunction<UpsertContractTechnicalPropertiesMutation, UpsertContractTechnicalPropertiesMutationVariables>;

/**
 * __useUpsertContractTechnicalPropertiesMutation__
 *
 * To run a mutation, you first call `useUpsertContractTechnicalPropertiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContractTechnicalPropertiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertContractTechnicalPropertiesMutation, { data, loading, error }] = useUpsertContractTechnicalPropertiesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contractId: // value for 'contractId'
 *      paymentWebhook: // value for 'paymentWebhook'
 *      webhookSignatureKey: // value for 'webhookSignatureKey'
 *   },
 * });
 */
export function useUpsertContractTechnicalPropertiesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertContractTechnicalPropertiesMutation, UpsertContractTechnicalPropertiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertContractTechnicalPropertiesMutation, UpsertContractTechnicalPropertiesMutationVariables>(UpsertContractTechnicalPropertiesDocument, options);
      }
export type UpsertContractTechnicalPropertiesMutationHookResult = ReturnType<typeof useUpsertContractTechnicalPropertiesMutation>;
export type UpsertContractTechnicalPropertiesMutationResult = Apollo.MutationResult<UpsertContractTechnicalPropertiesMutation>;
export type UpsertContractTechnicalPropertiesMutationOptions = Apollo.BaseMutationOptions<UpsertContractTechnicalPropertiesMutation, UpsertContractTechnicalPropertiesMutationVariables>;
export const CloseVirtualAccountDocument = gql`
    mutation closeVirtualAccount($accountId: ID!) {
  closeVirtualAccount(accountId: $accountId) {
    id
  }
}
    `;
export type CloseVirtualAccountMutationFn = Apollo.MutationFunction<CloseVirtualAccountMutation, CloseVirtualAccountMutationVariables>;

/**
 * __useCloseVirtualAccountMutation__
 *
 * To run a mutation, you first call `useCloseVirtualAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseVirtualAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeVirtualAccountMutation, { data, loading, error }] = useCloseVirtualAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCloseVirtualAccountMutation(baseOptions?: Apollo.MutationHookOptions<CloseVirtualAccountMutation, CloseVirtualAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseVirtualAccountMutation, CloseVirtualAccountMutationVariables>(CloseVirtualAccountDocument, options);
      }
export type CloseVirtualAccountMutationHookResult = ReturnType<typeof useCloseVirtualAccountMutation>;
export type CloseVirtualAccountMutationResult = Apollo.MutationResult<CloseVirtualAccountMutation>;
export type CloseVirtualAccountMutationOptions = Apollo.BaseMutationOptions<CloseVirtualAccountMutation, CloseVirtualAccountMutationVariables>;
export const CreateApiUserDocument = gql`
    mutation createApiUser($contractId: ID!, $code: ID!, $challengeId: ID!, $name: String!, $allowedIps: [String]!) {
  createApiUser(
    contractId: $contractId
    code: $code
    challengeId: $challengeId
    name: $name
    allowedIps: $allowedIps
  ) {
    id
    name
    apiKey
    apiSecret
    allowedIps
    status
  }
}
    `;
export type CreateApiUserMutationFn = Apollo.MutationFunction<CreateApiUserMutation, CreateApiUserMutationVariables>;

/**
 * __useCreateApiUserMutation__
 *
 * To run a mutation, you first call `useCreateApiUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiUserMutation, { data, loading, error }] = useCreateApiUserMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      code: // value for 'code'
 *      challengeId: // value for 'challengeId'
 *      name: // value for 'name'
 *      allowedIps: // value for 'allowedIps'
 *   },
 * });
 */
export function useCreateApiUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiUserMutation, CreateApiUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiUserMutation, CreateApiUserMutationVariables>(CreateApiUserDocument, options);
      }
export type CreateApiUserMutationHookResult = ReturnType<typeof useCreateApiUserMutation>;
export type CreateApiUserMutationResult = Apollo.MutationResult<CreateApiUserMutation>;
export type CreateApiUserMutationOptions = Apollo.BaseMutationOptions<CreateApiUserMutation, CreateApiUserMutationVariables>;
export const DeactivateApiUserDocument = gql`
    mutation deactivateApiUser($apiKey: ID!, $code: ID!, $challengeId: ID!) {
  deactivateApiUser(apiKey: $apiKey, code: $code, challengeId: $challengeId) {
    id
    name
    apiKey
    apiSecret
    allowedIps
    status
  }
}
    `;
export type DeactivateApiUserMutationFn = Apollo.MutationFunction<DeactivateApiUserMutation, DeactivateApiUserMutationVariables>;

/**
 * __useDeactivateApiUserMutation__
 *
 * To run a mutation, you first call `useDeactivateApiUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateApiUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateApiUserMutation, { data, loading, error }] = useDeactivateApiUserMutation({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *      code: // value for 'code'
 *      challengeId: // value for 'challengeId'
 *   },
 * });
 */
export function useDeactivateApiUserMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateApiUserMutation, DeactivateApiUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateApiUserMutation, DeactivateApiUserMutationVariables>(DeactivateApiUserDocument, options);
      }
export type DeactivateApiUserMutationHookResult = ReturnType<typeof useDeactivateApiUserMutation>;
export type DeactivateApiUserMutationResult = Apollo.MutationResult<DeactivateApiUserMutation>;
export type DeactivateApiUserMutationOptions = Apollo.BaseMutationOptions<DeactivateApiUserMutation, DeactivateApiUserMutationVariables>;
export const ResetApiUserSecretDocument = gql`
    mutation resetApiUserSecret($apiKey: ID!, $code: ID!, $challengeId: ID!) {
  resetApiUserSecret(apiKey: $apiKey, code: $code, challengeId: $challengeId)
}
    `;
export type ResetApiUserSecretMutationFn = Apollo.MutationFunction<ResetApiUserSecretMutation, ResetApiUserSecretMutationVariables>;

/**
 * __useResetApiUserSecretMutation__
 *
 * To run a mutation, you first call `useResetApiUserSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetApiUserSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetApiUserSecretMutation, { data, loading, error }] = useResetApiUserSecretMutation({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *      code: // value for 'code'
 *      challengeId: // value for 'challengeId'
 *   },
 * });
 */
export function useResetApiUserSecretMutation(baseOptions?: Apollo.MutationHookOptions<ResetApiUserSecretMutation, ResetApiUserSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetApiUserSecretMutation, ResetApiUserSecretMutationVariables>(ResetApiUserSecretDocument, options);
      }
export type ResetApiUserSecretMutationHookResult = ReturnType<typeof useResetApiUserSecretMutation>;
export type ResetApiUserSecretMutationResult = Apollo.MutationResult<ResetApiUserSecretMutation>;
export type ResetApiUserSecretMutationOptions = Apollo.BaseMutationOptions<ResetApiUserSecretMutation, ResetApiUserSecretMutationVariables>;
export const UpdateApiUserAllowedIpsDocument = gql`
    mutation updateApiUserAllowedIps($apiKey: ID!, $code: ID!, $challengeId: ID!, $allowedIps: [String]!) {
  updateApiUserAllowedIps(
    apiKey: $apiKey
    code: $code
    challengeId: $challengeId
    allowedIps: $allowedIps
  ) {
    id
    name
    apiKey
    apiSecret
    allowedIps
    status
  }
}
    `;
export type UpdateApiUserAllowedIpsMutationFn = Apollo.MutationFunction<UpdateApiUserAllowedIpsMutation, UpdateApiUserAllowedIpsMutationVariables>;

/**
 * __useUpdateApiUserAllowedIpsMutation__
 *
 * To run a mutation, you first call `useUpdateApiUserAllowedIpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApiUserAllowedIpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApiUserAllowedIpsMutation, { data, loading, error }] = useUpdateApiUserAllowedIpsMutation({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *      code: // value for 'code'
 *      challengeId: // value for 'challengeId'
 *      allowedIps: // value for 'allowedIps'
 *   },
 * });
 */
export function useUpdateApiUserAllowedIpsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApiUserAllowedIpsMutation, UpdateApiUserAllowedIpsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApiUserAllowedIpsMutation, UpdateApiUserAllowedIpsMutationVariables>(UpdateApiUserAllowedIpsDocument, options);
      }
export type UpdateApiUserAllowedIpsMutationHookResult = ReturnType<typeof useUpdateApiUserAllowedIpsMutation>;
export type UpdateApiUserAllowedIpsMutationResult = Apollo.MutationResult<UpdateApiUserAllowedIpsMutation>;
export type UpdateApiUserAllowedIpsMutationOptions = Apollo.BaseMutationOptions<UpdateApiUserAllowedIpsMutation, UpdateApiUserAllowedIpsMutationVariables>;
export const AddVirtualAccountDocument = gql`
    mutation addVirtualAccount($alias: String, $entityType: UboType, $parentId: ID!, $nationality: Nationality, $dateOfBirth: Date, $registeredAddress: AddressInput!, $companyRegistrationDate: Date, $companyRegistrationNumber: String) {
  addVirtualAccount(
    alias: $alias
    entityType: $entityType
    parentId: $parentId
    nationality: $nationality
    dateOfBirth: $dateOfBirth
    registeredAddress: $registeredAddress
    companyRegistrationDate: $companyRegistrationDate
    companyRegistrationNumber: $companyRegistrationNumber
  ) {
    parentId
    alias
    createdAt
    id
    isVirtual
    iban
    executionAction {
      ... on AccountAction {
        id
        signatures {
          id
          action {
            ... on AccountAction {
              id
              type
              status
            }
          }
          signatory {
            id
            isAuthorizedSignatory
            signatoryRight
          }
          isMine
          status
          signingMethod
          createdAt
          updatedAt
          signedAt
        }
      }
    }
  }
}
    `;
export type AddVirtualAccountMutationFn = Apollo.MutationFunction<AddVirtualAccountMutation, AddVirtualAccountMutationVariables>;

/**
 * __useAddVirtualAccountMutation__
 *
 * To run a mutation, you first call `useAddVirtualAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVirtualAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVirtualAccountMutation, { data, loading, error }] = useAddVirtualAccountMutation({
 *   variables: {
 *      alias: // value for 'alias'
 *      entityType: // value for 'entityType'
 *      parentId: // value for 'parentId'
 *      nationality: // value for 'nationality'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      registeredAddress: // value for 'registeredAddress'
 *      companyRegistrationDate: // value for 'companyRegistrationDate'
 *      companyRegistrationNumber: // value for 'companyRegistrationNumber'
 *   },
 * });
 */
export function useAddVirtualAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddVirtualAccountMutation, AddVirtualAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddVirtualAccountMutation, AddVirtualAccountMutationVariables>(AddVirtualAccountDocument, options);
      }
export type AddVirtualAccountMutationHookResult = ReturnType<typeof useAddVirtualAccountMutation>;
export type AddVirtualAccountMutationResult = Apollo.MutationResult<AddVirtualAccountMutation>;
export type AddVirtualAccountMutationOptions = Apollo.BaseMutationOptions<AddVirtualAccountMutation, AddVirtualAccountMutationVariables>;
export const UpdateIndividualEmailCategoryPreferenceDocument = gql`
    mutation UpdateIndividualEmailCategoryPreference($emailCategoryId: ID!, $active: Boolean!) {
  updateIndividualEmailCategoryPreference(
    emailCategoryId: $emailCategoryId
    active: $active
  ) {
    id
    active
    category {
      id
      name
      description
      mandatory
    }
  }
}
    `;
export type UpdateIndividualEmailCategoryPreferenceMutationFn = Apollo.MutationFunction<UpdateIndividualEmailCategoryPreferenceMutation, UpdateIndividualEmailCategoryPreferenceMutationVariables>;

/**
 * __useUpdateIndividualEmailCategoryPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateIndividualEmailCategoryPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndividualEmailCategoryPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndividualEmailCategoryPreferenceMutation, { data, loading, error }] = useUpdateIndividualEmailCategoryPreferenceMutation({
 *   variables: {
 *      emailCategoryId: // value for 'emailCategoryId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateIndividualEmailCategoryPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndividualEmailCategoryPreferenceMutation, UpdateIndividualEmailCategoryPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndividualEmailCategoryPreferenceMutation, UpdateIndividualEmailCategoryPreferenceMutationVariables>(UpdateIndividualEmailCategoryPreferenceDocument, options);
      }
export type UpdateIndividualEmailCategoryPreferenceMutationHookResult = ReturnType<typeof useUpdateIndividualEmailCategoryPreferenceMutation>;
export type UpdateIndividualEmailCategoryPreferenceMutationResult = Apollo.MutationResult<UpdateIndividualEmailCategoryPreferenceMutation>;
export type UpdateIndividualEmailCategoryPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateIndividualEmailCategoryPreferenceMutation, UpdateIndividualEmailCategoryPreferenceMutationVariables>;
export const ContractTerminationRequestDocument = gql`
    mutation contractTerminationRequest($contractId: ID!, $reason: String) {
  contractTerminationRequest(contractId: $contractId, reason: $reason) {
    ... on ContractTerminationAction {
      id
      signatures {
        id
        isMine
      }
    }
  }
}
    `;
export type ContractTerminationRequestMutationFn = Apollo.MutationFunction<ContractTerminationRequestMutation, ContractTerminationRequestMutationVariables>;

/**
 * __useContractTerminationRequestMutation__
 *
 * To run a mutation, you first call `useContractTerminationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractTerminationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractTerminationRequestMutation, { data, loading, error }] = useContractTerminationRequestMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useContractTerminationRequestMutation(baseOptions?: Apollo.MutationHookOptions<ContractTerminationRequestMutation, ContractTerminationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractTerminationRequestMutation, ContractTerminationRequestMutationVariables>(ContractTerminationRequestDocument, options);
      }
export type ContractTerminationRequestMutationHookResult = ReturnType<typeof useContractTerminationRequestMutation>;
export type ContractTerminationRequestMutationResult = Apollo.MutationResult<ContractTerminationRequestMutation>;
export type ContractTerminationRequestMutationOptions = Apollo.BaseMutationOptions<ContractTerminationRequestMutation, ContractTerminationRequestMutationVariables>;
export const StartSetupTwoFaForIndividualDocument = gql`
    mutation startSetupTwoFaForIndividual($challengeId: String!, $code: String!) {
  startSetupTwoFaForIndividual(challengeId: $challengeId, code: $code) {
    qrCode
    alternativeCode
  }
}
    `;
export type StartSetupTwoFaForIndividualMutationFn = Apollo.MutationFunction<StartSetupTwoFaForIndividualMutation, StartSetupTwoFaForIndividualMutationVariables>;

/**
 * __useStartSetupTwoFaForIndividualMutation__
 *
 * To run a mutation, you first call `useStartSetupTwoFaForIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSetupTwoFaForIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSetupTwoFaForIndividualMutation, { data, loading, error }] = useStartSetupTwoFaForIndividualMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useStartSetupTwoFaForIndividualMutation(baseOptions?: Apollo.MutationHookOptions<StartSetupTwoFaForIndividualMutation, StartSetupTwoFaForIndividualMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSetupTwoFaForIndividualMutation, StartSetupTwoFaForIndividualMutationVariables>(StartSetupTwoFaForIndividualDocument, options);
      }
export type StartSetupTwoFaForIndividualMutationHookResult = ReturnType<typeof useStartSetupTwoFaForIndividualMutation>;
export type StartSetupTwoFaForIndividualMutationResult = Apollo.MutationResult<StartSetupTwoFaForIndividualMutation>;
export type StartSetupTwoFaForIndividualMutationOptions = Apollo.BaseMutationOptions<StartSetupTwoFaForIndividualMutation, StartSetupTwoFaForIndividualMutationVariables>;
export const FinishSetupTwoFaForIndividualDocument = gql`
    mutation finishSetupTwoFaForIndividual($token: String!) {
  finishSetupTwoFaForIndividual(token: $token)
}
    `;
export type FinishSetupTwoFaForIndividualMutationFn = Apollo.MutationFunction<FinishSetupTwoFaForIndividualMutation, FinishSetupTwoFaForIndividualMutationVariables>;

/**
 * __useFinishSetupTwoFaForIndividualMutation__
 *
 * To run a mutation, you first call `useFinishSetupTwoFaForIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishSetupTwoFaForIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishSetupTwoFaForIndividualMutation, { data, loading, error }] = useFinishSetupTwoFaForIndividualMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useFinishSetupTwoFaForIndividualMutation(baseOptions?: Apollo.MutationHookOptions<FinishSetupTwoFaForIndividualMutation, FinishSetupTwoFaForIndividualMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishSetupTwoFaForIndividualMutation, FinishSetupTwoFaForIndividualMutationVariables>(FinishSetupTwoFaForIndividualDocument, options);
      }
export type FinishSetupTwoFaForIndividualMutationHookResult = ReturnType<typeof useFinishSetupTwoFaForIndividualMutation>;
export type FinishSetupTwoFaForIndividualMutationResult = Apollo.MutationResult<FinishSetupTwoFaForIndividualMutation>;
export type FinishSetupTwoFaForIndividualMutationOptions = Apollo.BaseMutationOptions<FinishSetupTwoFaForIndividualMutation, FinishSetupTwoFaForIndividualMutationVariables>;
export const ChangeIndividualPrimary2FaMethodDocument = gql`
    mutation changeIndividualPrimary2FAMethod($method: TwoFAMethod!, $challengeId: String!, $code: String!) {
  changeIndividualPrimary2FAMethod(
    method: $method
    challengeId: $challengeId
    code: $code
  ) {
    primaryTwoFAMethod
  }
}
    `;
export type ChangeIndividualPrimary2FaMethodMutationFn = Apollo.MutationFunction<ChangeIndividualPrimary2FaMethodMutation, ChangeIndividualPrimary2FaMethodMutationVariables>;

/**
 * __useChangeIndividualPrimary2FaMethodMutation__
 *
 * To run a mutation, you first call `useChangeIndividualPrimary2FaMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeIndividualPrimary2FaMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeIndividualPrimary2FaMethodMutation, { data, loading, error }] = useChangeIndividualPrimary2FaMethodMutation({
 *   variables: {
 *      method: // value for 'method'
 *      challengeId: // value for 'challengeId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useChangeIndividualPrimary2FaMethodMutation(baseOptions?: Apollo.MutationHookOptions<ChangeIndividualPrimary2FaMethodMutation, ChangeIndividualPrimary2FaMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeIndividualPrimary2FaMethodMutation, ChangeIndividualPrimary2FaMethodMutationVariables>(ChangeIndividualPrimary2FaMethodDocument, options);
      }
export type ChangeIndividualPrimary2FaMethodMutationHookResult = ReturnType<typeof useChangeIndividualPrimary2FaMethodMutation>;
export type ChangeIndividualPrimary2FaMethodMutationResult = Apollo.MutationResult<ChangeIndividualPrimary2FaMethodMutation>;
export type ChangeIndividualPrimary2FaMethodMutationOptions = Apollo.BaseMutationOptions<ChangeIndividualPrimary2FaMethodMutation, ChangeIndividualPrimary2FaMethodMutationVariables>;
export const ResolveVibanNameMismatchDocument = gql`
    mutation resolveVibanNameMismatch($vibanNameMismatchIds: [ID], $resolution: VibanNameMismatchResolution!, $authorizationCode: ID!, $challengeId: ID) {
  resolveVibanNameMismatch(
    vibanNameMismatchIds: $vibanNameMismatchIds
    resolution: $resolution
    authorizationCode: $authorizationCode
    challengeId: $challengeId
  )
}
    `;
export type ResolveVibanNameMismatchMutationFn = Apollo.MutationFunction<ResolveVibanNameMismatchMutation, ResolveVibanNameMismatchMutationVariables>;

/**
 * __useResolveVibanNameMismatchMutation__
 *
 * To run a mutation, you first call `useResolveVibanNameMismatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveVibanNameMismatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveVibanNameMismatchMutation, { data, loading, error }] = useResolveVibanNameMismatchMutation({
 *   variables: {
 *      vibanNameMismatchIds: // value for 'vibanNameMismatchIds'
 *      resolution: // value for 'resolution'
 *      authorizationCode: // value for 'authorizationCode'
 *      challengeId: // value for 'challengeId'
 *   },
 * });
 */
export function useResolveVibanNameMismatchMutation(baseOptions?: Apollo.MutationHookOptions<ResolveVibanNameMismatchMutation, ResolveVibanNameMismatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveVibanNameMismatchMutation, ResolveVibanNameMismatchMutationVariables>(ResolveVibanNameMismatchDocument, options);
      }
export type ResolveVibanNameMismatchMutationHookResult = ReturnType<typeof useResolveVibanNameMismatchMutation>;
export type ResolveVibanNameMismatchMutationResult = Apollo.MutationResult<ResolveVibanNameMismatchMutation>;
export type ResolveVibanNameMismatchMutationOptions = Apollo.BaseMutationOptions<ResolveVibanNameMismatchMutation, ResolveVibanNameMismatchMutationVariables>;
export const DeactivateUserDocument = gql`
    mutation deactivateUser($authorizedPersonId: ID!) {
  deactivateAuthorizedPersonRequest(authorizedPersonId: $authorizedPersonId) {
    id
    status
  }
}
    `;
export type DeactivateUserMutationFn = Apollo.MutationFunction<DeactivateUserMutation, DeactivateUserMutationVariables>;

/**
 * __useDeactivateUserMutation__
 *
 * To run a mutation, you first call `useDeactivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUserMutation, { data, loading, error }] = useDeactivateUserMutation({
 *   variables: {
 *      authorizedPersonId: // value for 'authorizedPersonId'
 *   },
 * });
 */
export function useDeactivateUserMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateUserMutation, DeactivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateUserMutation, DeactivateUserMutationVariables>(DeactivateUserDocument, options);
      }
export type DeactivateUserMutationHookResult = ReturnType<typeof useDeactivateUserMutation>;
export type DeactivateUserMutationResult = Apollo.MutationResult<DeactivateUserMutation>;
export type DeactivateUserMutationOptions = Apollo.BaseMutationOptions<DeactivateUserMutation, DeactivateUserMutationVariables>;
export const UpdateContractInformationRequestDocument = gql`
    mutation updateContractInformationRequest($id: ID!, $clientNote: String!, $documentIds: [ID]) {
  updateContractInformationRequestIndividual(
    id: $id
    clientNote: $clientNote
    documentIds: $documentIds
  ) {
    id
    note
    clientNote
    filledAt
    attachments {
      fileName
      url
    }
    documents {
      id
      type
      firstSide {
        fileName
        url
      }
      secondSide {
        fileName
        url
      }
    }
    status
  }
}
    `;
export type UpdateContractInformationRequestMutationFn = Apollo.MutationFunction<UpdateContractInformationRequestMutation, UpdateContractInformationRequestMutationVariables>;

/**
 * __useUpdateContractInformationRequestMutation__
 *
 * To run a mutation, you first call `useUpdateContractInformationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractInformationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractInformationRequestMutation, { data, loading, error }] = useUpdateContractInformationRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      clientNote: // value for 'clientNote'
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useUpdateContractInformationRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractInformationRequestMutation, UpdateContractInformationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractInformationRequestMutation, UpdateContractInformationRequestMutationVariables>(UpdateContractInformationRequestDocument, options);
      }
export type UpdateContractInformationRequestMutationHookResult = ReturnType<typeof useUpdateContractInformationRequestMutation>;
export type UpdateContractInformationRequestMutationResult = Apollo.MutationResult<UpdateContractInformationRequestMutation>;
export type UpdateContractInformationRequestMutationOptions = Apollo.BaseMutationOptions<UpdateContractInformationRequestMutation, UpdateContractInformationRequestMutationVariables>;
export const RequestTansferContractOwnershipDocument = gql`
    mutation requestTansferContractOwnership($contractId: ID!, $toEmail: String!, $toName: String!) {
  requestTansferContractOwnership(
    contractId: $contractId
    toEmail: $toEmail
    toName: $toName
  ) {
    id
  }
}
    `;
export type RequestTansferContractOwnershipMutationFn = Apollo.MutationFunction<RequestTansferContractOwnershipMutation, RequestTansferContractOwnershipMutationVariables>;

/**
 * __useRequestTansferContractOwnershipMutation__
 *
 * To run a mutation, you first call `useRequestTansferContractOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTansferContractOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTansferContractOwnershipMutation, { data, loading, error }] = useRequestTansferContractOwnershipMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      toEmail: // value for 'toEmail'
 *      toName: // value for 'toName'
 *   },
 * });
 */
export function useRequestTansferContractOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<RequestTansferContractOwnershipMutation, RequestTansferContractOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestTansferContractOwnershipMutation, RequestTansferContractOwnershipMutationVariables>(RequestTansferContractOwnershipDocument, options);
      }
export type RequestTansferContractOwnershipMutationHookResult = ReturnType<typeof useRequestTansferContractOwnershipMutation>;
export type RequestTansferContractOwnershipMutationResult = Apollo.MutationResult<RequestTansferContractOwnershipMutation>;
export type RequestTansferContractOwnershipMutationOptions = Apollo.BaseMutationOptions<RequestTansferContractOwnershipMutation, RequestTansferContractOwnershipMutationVariables>;
export const ProcessTransferContractOwnershipDocument = gql`
    mutation processTransferContractOwnership($contractOwnershipTransferId: String!) {
  processTransferContractOwnership(
    contractOwnershipTransferId: $contractOwnershipTransferId
    status: completed
  ) {
    id
    createdBy {
      id
      email
    }
  }
}
    `;
export type ProcessTransferContractOwnershipMutationFn = Apollo.MutationFunction<ProcessTransferContractOwnershipMutation, ProcessTransferContractOwnershipMutationVariables>;

/**
 * __useProcessTransferContractOwnershipMutation__
 *
 * To run a mutation, you first call `useProcessTransferContractOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessTransferContractOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processTransferContractOwnershipMutation, { data, loading, error }] = useProcessTransferContractOwnershipMutation({
 *   variables: {
 *      contractOwnershipTransferId: // value for 'contractOwnershipTransferId'
 *   },
 * });
 */
export function useProcessTransferContractOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<ProcessTransferContractOwnershipMutation, ProcessTransferContractOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessTransferContractOwnershipMutation, ProcessTransferContractOwnershipMutationVariables>(ProcessTransferContractOwnershipDocument, options);
      }
export type ProcessTransferContractOwnershipMutationHookResult = ReturnType<typeof useProcessTransferContractOwnershipMutation>;
export type ProcessTransferContractOwnershipMutationResult = Apollo.MutationResult<ProcessTransferContractOwnershipMutation>;
export type ProcessTransferContractOwnershipMutationOptions = Apollo.BaseMutationOptions<ProcessTransferContractOwnershipMutation, ProcessTransferContractOwnershipMutationVariables>;
export const CreateIndividualContractDocument = gql`
    mutation createIndividualContract($input: ContractInputForIndividualType!) {
  createIndividualContract(input: $input) {
    id
    status
  }
}
    `;
export type CreateIndividualContractMutationFn = Apollo.MutationFunction<CreateIndividualContractMutation, CreateIndividualContractMutationVariables>;

/**
 * __useCreateIndividualContractMutation__
 *
 * To run a mutation, you first call `useCreateIndividualContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndividualContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndividualContractMutation, { data, loading, error }] = useCreateIndividualContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIndividualContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndividualContractMutation, CreateIndividualContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndividualContractMutation, CreateIndividualContractMutationVariables>(CreateIndividualContractDocument, options);
      }
export type CreateIndividualContractMutationHookResult = ReturnType<typeof useCreateIndividualContractMutation>;
export type CreateIndividualContractMutationResult = Apollo.MutationResult<CreateIndividualContractMutation>;
export type CreateIndividualContractMutationOptions = Apollo.BaseMutationOptions<CreateIndividualContractMutation, CreateIndividualContractMutationVariables>;
export const CancelStandingOrderDocument = gql`
    mutation cancelStandingOrder($id: ID!) {
  cancelStandingOrder(id: $id) {
    id
    cancellationAction {
      ... on BaseAction {
        id
        signatures {
          id
          isMine
          status
        }
      }
    }
  }
}
    `;
export type CancelStandingOrderMutationFn = Apollo.MutationFunction<CancelStandingOrderMutation, CancelStandingOrderMutationVariables>;

/**
 * __useCancelStandingOrderMutation__
 *
 * To run a mutation, you first call `useCancelStandingOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelStandingOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelStandingOrderMutation, { data, loading, error }] = useCancelStandingOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelStandingOrderMutation(baseOptions?: Apollo.MutationHookOptions<CancelStandingOrderMutation, CancelStandingOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelStandingOrderMutation, CancelStandingOrderMutationVariables>(CancelStandingOrderDocument, options);
      }
export type CancelStandingOrderMutationHookResult = ReturnType<typeof useCancelStandingOrderMutation>;
export type CancelStandingOrderMutationResult = Apollo.MutationResult<CancelStandingOrderMutation>;
export type CancelStandingOrderMutationOptions = Apollo.BaseMutationOptions<CancelStandingOrderMutation, CancelStandingOrderMutationVariables>;
export const CancelTransactionDocument = gql`
    mutation cancelTransaction($transactionId: ID!, $reason: String!, $authorizationCode: ID) {
  cancelTransaction(
    transactionId: $transactionId
    reason: $reason
    authorizationCode: $authorizationCode
  ) {
    ... on DebitTransaction {
      id
    }
  }
}
    `;
export type CancelTransactionMutationFn = Apollo.MutationFunction<CancelTransactionMutation, CancelTransactionMutationVariables>;

/**
 * __useCancelTransactionMutation__
 *
 * To run a mutation, you first call `useCancelTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTransactionMutation, { data, loading, error }] = useCancelTransactionMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *      reason: // value for 'reason'
 *      authorizationCode: // value for 'authorizationCode'
 *   },
 * });
 */
export function useCancelTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CancelTransactionMutation, CancelTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelTransactionMutation, CancelTransactionMutationVariables>(CancelTransactionDocument, options);
      }
export type CancelTransactionMutationHookResult = ReturnType<typeof useCancelTransactionMutation>;
export type CancelTransactionMutationResult = Apollo.MutationResult<CancelTransactionMutation>;
export type CancelTransactionMutationOptions = Apollo.BaseMutationOptions<CancelTransactionMutation, CancelTransactionMutationVariables>;
export const RejectDirectDebitDocument = gql`
    mutation rejectDirectDebit($id: ID!) {
  rejectDirectDebit(id: $id) {
    id
    rejectionAction {
      ... on BaseAction {
        id
        signatures {
          id
          isMine
          status
        }
      }
    }
  }
}
    `;
export type RejectDirectDebitMutationFn = Apollo.MutationFunction<RejectDirectDebitMutation, RejectDirectDebitMutationVariables>;

/**
 * __useRejectDirectDebitMutation__
 *
 * To run a mutation, you first call `useRejectDirectDebitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectDirectDebitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectDirectDebitMutation, { data, loading, error }] = useRejectDirectDebitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRejectDirectDebitMutation(baseOptions?: Apollo.MutationHookOptions<RejectDirectDebitMutation, RejectDirectDebitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectDirectDebitMutation, RejectDirectDebitMutationVariables>(RejectDirectDebitDocument, options);
      }
export type RejectDirectDebitMutationHookResult = ReturnType<typeof useRejectDirectDebitMutation>;
export type RejectDirectDebitMutationResult = Apollo.MutationResult<RejectDirectDebitMutation>;
export type RejectDirectDebitMutationOptions = Apollo.BaseMutationOptions<RejectDirectDebitMutation, RejectDirectDebitMutationVariables>;
export const UpdateContractCommissionSettingAccountDocument = gql`
    mutation updateContractCommissionSettingAccount($contractId: ID!, $commissionPayoutAccountId: ID, $payoutAccountDetails: SwiftTransferIndividualPartyDetailsInput, $currency: Currency) {
  updateContractCommissionSettingAccount(
    contractId: $contractId
    commissionPayoutAccountId: $commissionPayoutAccountId
    payoutAccountDetails: $payoutAccountDetails
    currency: $currency
  ) {
    id
  }
}
    `;
export type UpdateContractCommissionSettingAccountMutationFn = Apollo.MutationFunction<UpdateContractCommissionSettingAccountMutation, UpdateContractCommissionSettingAccountMutationVariables>;

/**
 * __useUpdateContractCommissionSettingAccountMutation__
 *
 * To run a mutation, you first call `useUpdateContractCommissionSettingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractCommissionSettingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractCommissionSettingAccountMutation, { data, loading, error }] = useUpdateContractCommissionSettingAccountMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      commissionPayoutAccountId: // value for 'commissionPayoutAccountId'
 *      payoutAccountDetails: // value for 'payoutAccountDetails'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useUpdateContractCommissionSettingAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractCommissionSettingAccountMutation, UpdateContractCommissionSettingAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractCommissionSettingAccountMutation, UpdateContractCommissionSettingAccountMutationVariables>(UpdateContractCommissionSettingAccountDocument, options);
      }
export type UpdateContractCommissionSettingAccountMutationHookResult = ReturnType<typeof useUpdateContractCommissionSettingAccountMutation>;
export type UpdateContractCommissionSettingAccountMutationResult = Apollo.MutationResult<UpdateContractCommissionSettingAccountMutation>;
export type UpdateContractCommissionSettingAccountMutationOptions = Apollo.BaseMutationOptions<UpdateContractCommissionSettingAccountMutation, UpdateContractCommissionSettingAccountMutationVariables>;
export const ExportContractPayoutsDocument = gql`
    mutation exportContractPayouts($id: ID!) {
  exportContractPayouts(id: $id)
}
    `;
export type ExportContractPayoutsMutationFn = Apollo.MutationFunction<ExportContractPayoutsMutation, ExportContractPayoutsMutationVariables>;

/**
 * __useExportContractPayoutsMutation__
 *
 * To run a mutation, you first call `useExportContractPayoutsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportContractPayoutsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportContractPayoutsMutation, { data, loading, error }] = useExportContractPayoutsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExportContractPayoutsMutation(baseOptions?: Apollo.MutationHookOptions<ExportContractPayoutsMutation, ExportContractPayoutsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportContractPayoutsMutation, ExportContractPayoutsMutationVariables>(ExportContractPayoutsDocument, options);
      }
export type ExportContractPayoutsMutationHookResult = ReturnType<typeof useExportContractPayoutsMutation>;
export type ExportContractPayoutsMutationResult = Apollo.MutationResult<ExportContractPayoutsMutation>;
export type ExportContractPayoutsMutationOptions = Apollo.BaseMutationOptions<ExportContractPayoutsMutation, ExportContractPayoutsMutationVariables>;
export const ExportPayoutSuccessFeesDocument = gql`
    mutation exportPayoutSuccessFees($id: String!) {
  exportPayoutSuccessFees(id: $id)
}
    `;
export type ExportPayoutSuccessFeesMutationFn = Apollo.MutationFunction<ExportPayoutSuccessFeesMutation, ExportPayoutSuccessFeesMutationVariables>;

/**
 * __useExportPayoutSuccessFeesMutation__
 *
 * To run a mutation, you first call `useExportPayoutSuccessFeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportPayoutSuccessFeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportPayoutSuccessFeesMutation, { data, loading, error }] = useExportPayoutSuccessFeesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExportPayoutSuccessFeesMutation(baseOptions?: Apollo.MutationHookOptions<ExportPayoutSuccessFeesMutation, ExportPayoutSuccessFeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportPayoutSuccessFeesMutation, ExportPayoutSuccessFeesMutationVariables>(ExportPayoutSuccessFeesDocument, options);
      }
export type ExportPayoutSuccessFeesMutationHookResult = ReturnType<typeof useExportPayoutSuccessFeesMutation>;
export type ExportPayoutSuccessFeesMutationResult = Apollo.MutationResult<ExportPayoutSuccessFeesMutation>;
export type ExportPayoutSuccessFeesMutationOptions = Apollo.BaseMutationOptions<ExportPayoutSuccessFeesMutation, ExportPayoutSuccessFeesMutationVariables>;
export const UpdateAccountAlternativeAccountDetailsDocument = gql`
    mutation updateAccountAlternativeAccountDetails($accountId: ID!, $alternativeAccountDetails: SwiftTransferIndividualPartyDetailsWithCurrencyInput!) {
  updateAccountAlternativeAccountDetails(
    accountId: $accountId
    alternativeAccountDetails: $alternativeAccountDetails
  ) {
    id
    executionAction {
      ... on AccountAction {
        id
        signatures {
          id
          isMine
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type UpdateAccountAlternativeAccountDetailsMutationFn = Apollo.MutationFunction<UpdateAccountAlternativeAccountDetailsMutation, UpdateAccountAlternativeAccountDetailsMutationVariables>;

/**
 * __useUpdateAccountAlternativeAccountDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateAccountAlternativeAccountDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountAlternativeAccountDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountAlternativeAccountDetailsMutation, { data, loading, error }] = useUpdateAccountAlternativeAccountDetailsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      alternativeAccountDetails: // value for 'alternativeAccountDetails'
 *   },
 * });
 */
export function useUpdateAccountAlternativeAccountDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountAlternativeAccountDetailsMutation, UpdateAccountAlternativeAccountDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountAlternativeAccountDetailsMutation, UpdateAccountAlternativeAccountDetailsMutationVariables>(UpdateAccountAlternativeAccountDetailsDocument, options);
      }
export type UpdateAccountAlternativeAccountDetailsMutationHookResult = ReturnType<typeof useUpdateAccountAlternativeAccountDetailsMutation>;
export type UpdateAccountAlternativeAccountDetailsMutationResult = Apollo.MutationResult<UpdateAccountAlternativeAccountDetailsMutation>;
export type UpdateAccountAlternativeAccountDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateAccountAlternativeAccountDetailsMutation, UpdateAccountAlternativeAccountDetailsMutationVariables>;
export const SaveBalanceCurrencyDocument = gql`
    mutation saveBalanceCurrency($contractId: ID!, $currency: NewAccountCurrency!) {
  saveBalanceCurrency(contractId: $contractId, currency: $currency) {
    id
    balanceCurrency
  }
}
    `;
export type SaveBalanceCurrencyMutationFn = Apollo.MutationFunction<SaveBalanceCurrencyMutation, SaveBalanceCurrencyMutationVariables>;

/**
 * __useSaveBalanceCurrencyMutation__
 *
 * To run a mutation, you first call `useSaveBalanceCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBalanceCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBalanceCurrencyMutation, { data, loading, error }] = useSaveBalanceCurrencyMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useSaveBalanceCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<SaveBalanceCurrencyMutation, SaveBalanceCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBalanceCurrencyMutation, SaveBalanceCurrencyMutationVariables>(SaveBalanceCurrencyDocument, options);
      }
export type SaveBalanceCurrencyMutationHookResult = ReturnType<typeof useSaveBalanceCurrencyMutation>;
export type SaveBalanceCurrencyMutationResult = Apollo.MutationResult<SaveBalanceCurrencyMutation>;
export type SaveBalanceCurrencyMutationOptions = Apollo.BaseMutationOptions<SaveBalanceCurrencyMutation, SaveBalanceCurrencyMutationVariables>;
export const TogglePinAccountDocument = gql`
    mutation togglePinAccount($accountIds: [ID]!, $pin: Boolean!) {
  pinUnpinAccount(accountIds: $accountIds, pin: $pin)
}
    `;
export type TogglePinAccountMutationFn = Apollo.MutationFunction<TogglePinAccountMutation, TogglePinAccountMutationVariables>;

/**
 * __useTogglePinAccountMutation__
 *
 * To run a mutation, you first call `useTogglePinAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePinAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePinAccountMutation, { data, loading, error }] = useTogglePinAccountMutation({
 *   variables: {
 *      accountIds: // value for 'accountIds'
 *      pin: // value for 'pin'
 *   },
 * });
 */
export function useTogglePinAccountMutation(baseOptions?: Apollo.MutationHookOptions<TogglePinAccountMutation, TogglePinAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TogglePinAccountMutation, TogglePinAccountMutationVariables>(TogglePinAccountDocument, options);
      }
export type TogglePinAccountMutationHookResult = ReturnType<typeof useTogglePinAccountMutation>;
export type TogglePinAccountMutationResult = Apollo.MutationResult<TogglePinAccountMutation>;
export type TogglePinAccountMutationOptions = Apollo.BaseMutationOptions<TogglePinAccountMutation, TogglePinAccountMutationVariables>;
export const CreateCardTermsActionDocument = gql`
    mutation createCardTermsAction($contractId: ID!) {
  createCardTermsAction(contractId: $contractId) {
    signed
    actionId
  }
}
    `;
export type CreateCardTermsActionMutationFn = Apollo.MutationFunction<CreateCardTermsActionMutation, CreateCardTermsActionMutationVariables>;

/**
 * __useCreateCardTermsActionMutation__
 *
 * To run a mutation, you first call `useCreateCardTermsActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCardTermsActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCardTermsActionMutation, { data, loading, error }] = useCreateCardTermsActionMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useCreateCardTermsActionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCardTermsActionMutation, CreateCardTermsActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCardTermsActionMutation, CreateCardTermsActionMutationVariables>(CreateCardTermsActionDocument, options);
      }
export type CreateCardTermsActionMutationHookResult = ReturnType<typeof useCreateCardTermsActionMutation>;
export type CreateCardTermsActionMutationResult = Apollo.MutationResult<CreateCardTermsActionMutation>;
export type CreateCardTermsActionMutationOptions = Apollo.BaseMutationOptions<CreateCardTermsActionMutation, CreateCardTermsActionMutationVariables>;
export const PreapproveB2BDirectDebitMandateDocument = gql`
    mutation preapproveB2BDirectDebitMandate($mandate: B2BDirectDebitPreapprovalInput!) {
  preapproveB2BDirectDebitMandate(mandate: $mandate) {
    id
    status
    approvalAction {
      ... on DirectDebitAction {
        id
        signatures {
          id
          isMine
          status
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type PreapproveB2BDirectDebitMandateMutationFn = Apollo.MutationFunction<PreapproveB2BDirectDebitMandateMutation, PreapproveB2BDirectDebitMandateMutationVariables>;

/**
 * __usePreapproveB2BDirectDebitMandateMutation__
 *
 * To run a mutation, you first call `usePreapproveB2BDirectDebitMandateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreapproveB2BDirectDebitMandateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preapproveB2BDirectDebitMandateMutation, { data, loading, error }] = usePreapproveB2BDirectDebitMandateMutation({
 *   variables: {
 *      mandate: // value for 'mandate'
 *   },
 * });
 */
export function usePreapproveB2BDirectDebitMandateMutation(baseOptions?: Apollo.MutationHookOptions<PreapproveB2BDirectDebitMandateMutation, PreapproveB2BDirectDebitMandateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreapproveB2BDirectDebitMandateMutation, PreapproveB2BDirectDebitMandateMutationVariables>(PreapproveB2BDirectDebitMandateDocument, options);
      }
export type PreapproveB2BDirectDebitMandateMutationHookResult = ReturnType<typeof usePreapproveB2BDirectDebitMandateMutation>;
export type PreapproveB2BDirectDebitMandateMutationResult = Apollo.MutationResult<PreapproveB2BDirectDebitMandateMutation>;
export type PreapproveB2BDirectDebitMandateMutationOptions = Apollo.BaseMutationOptions<PreapproveB2BDirectDebitMandateMutation, PreapproveB2BDirectDebitMandateMutationVariables>;
export const RefundPaymentDocument = gql`
    mutation refundPayment($contractId: String!, $paymentId: String!, $amount: Float!, $externalId: String!) {
  refundPayment(
    contractId: $contractId
    paymentId: $paymentId
    amount: $amount
    externalId: $externalId
  ) {
    amount
    currency
    status
    errorMessage
    executionAction {
      ... on BaseAction {
        id
        signatures {
          id
          isMine
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type RefundPaymentMutationFn = Apollo.MutationFunction<RefundPaymentMutation, RefundPaymentMutationVariables>;

/**
 * __useRefundPaymentMutation__
 *
 * To run a mutation, you first call `useRefundPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundPaymentMutation, { data, loading, error }] = useRefundPaymentMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      paymentId: // value for 'paymentId'
 *      amount: // value for 'amount'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useRefundPaymentMutation(baseOptions?: Apollo.MutationHookOptions<RefundPaymentMutation, RefundPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundPaymentMutation, RefundPaymentMutationVariables>(RefundPaymentDocument, options);
      }
export type RefundPaymentMutationHookResult = ReturnType<typeof useRefundPaymentMutation>;
export type RefundPaymentMutationResult = Apollo.MutationResult<RefundPaymentMutation>;
export type RefundPaymentMutationOptions = Apollo.BaseMutationOptions<RefundPaymentMutation, RefundPaymentMutationVariables>;
export const DismissIndividualNoticeDocument = gql`
    mutation dismissIndividualNotice($noticeId: ID!) {
  dismissIndividualNotice(noticeId: $noticeId)
}
    `;
export type DismissIndividualNoticeMutationFn = Apollo.MutationFunction<DismissIndividualNoticeMutation, DismissIndividualNoticeMutationVariables>;

/**
 * __useDismissIndividualNoticeMutation__
 *
 * To run a mutation, you first call `useDismissIndividualNoticeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissIndividualNoticeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissIndividualNoticeMutation, { data, loading, error }] = useDismissIndividualNoticeMutation({
 *   variables: {
 *      noticeId: // value for 'noticeId'
 *   },
 * });
 */
export function useDismissIndividualNoticeMutation(baseOptions?: Apollo.MutationHookOptions<DismissIndividualNoticeMutation, DismissIndividualNoticeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissIndividualNoticeMutation, DismissIndividualNoticeMutationVariables>(DismissIndividualNoticeDocument, options);
      }
export type DismissIndividualNoticeMutationHookResult = ReturnType<typeof useDismissIndividualNoticeMutation>;
export type DismissIndividualNoticeMutationResult = Apollo.MutationResult<DismissIndividualNoticeMutation>;
export type DismissIndividualNoticeMutationOptions = Apollo.BaseMutationOptions<DismissIndividualNoticeMutation, DismissIndividualNoticeMutationVariables>;
export const UpsertContractContactDocument = gql`
    mutation upsertContractContact($id: ID, $contactInfo: ContactInfoInput, $type: ContractContactType, $isPrimary: Boolean, $contractId: ID, $contractAuthorizedPersonId: ID) {
  upsertContractContact(
    contractId: $contractId
    id: $id
    contactInfo: $contactInfo
    type: $type
    isPrimary: $isPrimary
    contractAuthorizedPersonId: $contractAuthorizedPersonId
  ) {
    id
  }
}
    `;
export type UpsertContractContactMutationFn = Apollo.MutationFunction<UpsertContractContactMutation, UpsertContractContactMutationVariables>;

/**
 * __useUpsertContractContactMutation__
 *
 * To run a mutation, you first call `useUpsertContractContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContractContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertContractContactMutation, { data, loading, error }] = useUpsertContractContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contactInfo: // value for 'contactInfo'
 *      type: // value for 'type'
 *      isPrimary: // value for 'isPrimary'
 *      contractId: // value for 'contractId'
 *      contractAuthorizedPersonId: // value for 'contractAuthorizedPersonId'
 *   },
 * });
 */
export function useUpsertContractContactMutation(baseOptions?: Apollo.MutationHookOptions<UpsertContractContactMutation, UpsertContractContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertContractContactMutation, UpsertContractContactMutationVariables>(UpsertContractContactDocument, options);
      }
export type UpsertContractContactMutationHookResult = ReturnType<typeof useUpsertContractContactMutation>;
export type UpsertContractContactMutationResult = Apollo.MutationResult<UpsertContractContactMutation>;
export type UpsertContractContactMutationOptions = Apollo.BaseMutationOptions<UpsertContractContactMutation, UpsertContractContactMutationVariables>;
export const DeleteContractContactDocument = gql`
    mutation deleteContractContact($id: ID!) {
  deleteContractContact(id: $id)
}
    `;
export type DeleteContractContactMutationFn = Apollo.MutationFunction<DeleteContractContactMutation, DeleteContractContactMutationVariables>;

/**
 * __useDeleteContractContactMutation__
 *
 * To run a mutation, you first call `useDeleteContractContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractContactMutation, { data, loading, error }] = useDeleteContractContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContractContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContractContactMutation, DeleteContractContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContractContactMutation, DeleteContractContactMutationVariables>(DeleteContractContactDocument, options);
      }
export type DeleteContractContactMutationHookResult = ReturnType<typeof useDeleteContractContactMutation>;
export type DeleteContractContactMutationResult = Apollo.MutationResult<DeleteContractContactMutation>;
export type DeleteContractContactMutationOptions = Apollo.BaseMutationOptions<DeleteContractContactMutation, DeleteContractContactMutationVariables>;
export const UpdateDirectDebitSpendingLimitsDocument = gql`
    mutation updateDirectDebitSpendingLimits($amount: Float!, $account: ID!, $interval: SpendingLimitIntervalType!) {
  updateSpendingLimit(
    account: $account
    type: sdd
    interval: $interval
    amount: $amount
  ) {
    id
    status
    interval
    executionAction {
      ... on UpdateSpendingLimitAction {
        id
        signatures {
          id
          isMine
          action {
            ... on UpdateSpendingLimitAction {
              id
              type
              status
            }
          }
        }
      }
    }
  }
}
    `;
export type UpdateDirectDebitSpendingLimitsMutationFn = Apollo.MutationFunction<UpdateDirectDebitSpendingLimitsMutation, UpdateDirectDebitSpendingLimitsMutationVariables>;

/**
 * __useUpdateDirectDebitSpendingLimitsMutation__
 *
 * To run a mutation, you first call `useUpdateDirectDebitSpendingLimitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDirectDebitSpendingLimitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDirectDebitSpendingLimitsMutation, { data, loading, error }] = useUpdateDirectDebitSpendingLimitsMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      account: // value for 'account'
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useUpdateDirectDebitSpendingLimitsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDirectDebitSpendingLimitsMutation, UpdateDirectDebitSpendingLimitsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDirectDebitSpendingLimitsMutation, UpdateDirectDebitSpendingLimitsMutationVariables>(UpdateDirectDebitSpendingLimitsDocument, options);
      }
export type UpdateDirectDebitSpendingLimitsMutationHookResult = ReturnType<typeof useUpdateDirectDebitSpendingLimitsMutation>;
export type UpdateDirectDebitSpendingLimitsMutationResult = Apollo.MutationResult<UpdateDirectDebitSpendingLimitsMutation>;
export type UpdateDirectDebitSpendingLimitsMutationOptions = Apollo.BaseMutationOptions<UpdateDirectDebitSpendingLimitsMutation, UpdateDirectDebitSpendingLimitsMutationVariables>;
export const DisputeDirectDebitDocument = gql`
    mutation disputeDirectDebit($executionId: ID!) {
  disputeDirectDebit(executionId: $executionId) {
    id
    action {
      ... on BaseAction {
        signatures {
          id
          isMine
          status
        }
      }
    }
  }
}
    `;
export type DisputeDirectDebitMutationFn = Apollo.MutationFunction<DisputeDirectDebitMutation, DisputeDirectDebitMutationVariables>;

/**
 * __useDisputeDirectDebitMutation__
 *
 * To run a mutation, you first call `useDisputeDirectDebitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisputeDirectDebitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disputeDirectDebitMutation, { data, loading, error }] = useDisputeDirectDebitMutation({
 *   variables: {
 *      executionId: // value for 'executionId'
 *   },
 * });
 */
export function useDisputeDirectDebitMutation(baseOptions?: Apollo.MutationHookOptions<DisputeDirectDebitMutation, DisputeDirectDebitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisputeDirectDebitMutation, DisputeDirectDebitMutationVariables>(DisputeDirectDebitDocument, options);
      }
export type DisputeDirectDebitMutationHookResult = ReturnType<typeof useDisputeDirectDebitMutation>;
export type DisputeDirectDebitMutationResult = Apollo.MutationResult<DisputeDirectDebitMutation>;
export type DisputeDirectDebitMutationOptions = Apollo.BaseMutationOptions<DisputeDirectDebitMutation, DisputeDirectDebitMutationVariables>;
export const AddContractExistingUboDocument = gql`
    mutation addContractExistingUbo($contractId: ID!, $uboId: ID!, $ownershipType: UboStakeType!, $shareSize: Float!) {
  addContractExistingUbo(
    contractId: $contractId
    uboId: $uboId
    ownershipType: $ownershipType
    shareSize: $shareSize
  ) {
    id
    addedFromExistingUbo
    ubo {
      id
      entity {
        ... on Individual {
          id
        }
      }
    }
  }
}
    `;
export type AddContractExistingUboMutationFn = Apollo.MutationFunction<AddContractExistingUboMutation, AddContractExistingUboMutationVariables>;

/**
 * __useAddContractExistingUboMutation__
 *
 * To run a mutation, you first call `useAddContractExistingUboMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContractExistingUboMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContractExistingUboMutation, { data, loading, error }] = useAddContractExistingUboMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      uboId: // value for 'uboId'
 *      ownershipType: // value for 'ownershipType'
 *      shareSize: // value for 'shareSize'
 *   },
 * });
 */
export function useAddContractExistingUboMutation(baseOptions?: Apollo.MutationHookOptions<AddContractExistingUboMutation, AddContractExistingUboMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContractExistingUboMutation, AddContractExistingUboMutationVariables>(AddContractExistingUboDocument, options);
      }
export type AddContractExistingUboMutationHookResult = ReturnType<typeof useAddContractExistingUboMutation>;
export type AddContractExistingUboMutationResult = Apollo.MutationResult<AddContractExistingUboMutation>;
export type AddContractExistingUboMutationOptions = Apollo.BaseMutationOptions<AddContractExistingUboMutation, AddContractExistingUboMutationVariables>;
export const CreateDirectDebitCreditMandateDocument = gql`
    mutation createDirectDebitCreditMandate($contractId: ID!, $mandate: DirectDebitMandateInput!) {
  createDirectDebitCreditMandate(mandate: $mandate, contractId: $contractId) {
    id
    status
    approvalAction {
      ... on DirectDebitAction {
        signatures {
          id
          isMine
          status
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type CreateDirectDebitCreditMandateMutationFn = Apollo.MutationFunction<CreateDirectDebitCreditMandateMutation, CreateDirectDebitCreditMandateMutationVariables>;

/**
 * __useCreateDirectDebitCreditMandateMutation__
 *
 * To run a mutation, you first call `useCreateDirectDebitCreditMandateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDirectDebitCreditMandateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDirectDebitCreditMandateMutation, { data, loading, error }] = useCreateDirectDebitCreditMandateMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      mandate: // value for 'mandate'
 *   },
 * });
 */
export function useCreateDirectDebitCreditMandateMutation(baseOptions?: Apollo.MutationHookOptions<CreateDirectDebitCreditMandateMutation, CreateDirectDebitCreditMandateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDirectDebitCreditMandateMutation, CreateDirectDebitCreditMandateMutationVariables>(CreateDirectDebitCreditMandateDocument, options);
      }
export type CreateDirectDebitCreditMandateMutationHookResult = ReturnType<typeof useCreateDirectDebitCreditMandateMutation>;
export type CreateDirectDebitCreditMandateMutationResult = Apollo.MutationResult<CreateDirectDebitCreditMandateMutation>;
export type CreateDirectDebitCreditMandateMutationOptions = Apollo.BaseMutationOptions<CreateDirectDebitCreditMandateMutation, CreateDirectDebitCreditMandateMutationVariables>;
export const ValidateDirectDebitBatchPaymentFileDocument = gql`
    mutation validateDirectDebitBatchPaymentFile($accountId: ID!, $fileUrl: String!) {
  validateDirectDebitBatchPaymentFile(accountId: $accountId, fileUrl: $fileUrl) {
    valid
    total
    validTotal
    count
    account {
      id
      currency
    }
    records {
      value
      mandate {
        id
        account {
          currency
        }
        counterpartyDetails {
          name
          iban
        }
      }
      executionDate
      isValid
      reference
      errors
    }
  }
}
    `;
export type ValidateDirectDebitBatchPaymentFileMutationFn = Apollo.MutationFunction<ValidateDirectDebitBatchPaymentFileMutation, ValidateDirectDebitBatchPaymentFileMutationVariables>;

/**
 * __useValidateDirectDebitBatchPaymentFileMutation__
 *
 * To run a mutation, you first call `useValidateDirectDebitBatchPaymentFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDirectDebitBatchPaymentFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDirectDebitBatchPaymentFileMutation, { data, loading, error }] = useValidateDirectDebitBatchPaymentFileMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      fileUrl: // value for 'fileUrl'
 *   },
 * });
 */
export function useValidateDirectDebitBatchPaymentFileMutation(baseOptions?: Apollo.MutationHookOptions<ValidateDirectDebitBatchPaymentFileMutation, ValidateDirectDebitBatchPaymentFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateDirectDebitBatchPaymentFileMutation, ValidateDirectDebitBatchPaymentFileMutationVariables>(ValidateDirectDebitBatchPaymentFileDocument, options);
      }
export type ValidateDirectDebitBatchPaymentFileMutationHookResult = ReturnType<typeof useValidateDirectDebitBatchPaymentFileMutation>;
export type ValidateDirectDebitBatchPaymentFileMutationResult = Apollo.MutationResult<ValidateDirectDebitBatchPaymentFileMutation>;
export type ValidateDirectDebitBatchPaymentFileMutationOptions = Apollo.BaseMutationOptions<ValidateDirectDebitBatchPaymentFileMutation, ValidateDirectDebitBatchPaymentFileMutationVariables>;
export const StartDirectDebitBatchRequestDocument = gql`
    mutation startDirectDebitBatchRequest($accountId: ID!, $fileUrl: String!) {
  startDirectDebitBatchRequest(accountId: $accountId, fileUrl: $fileUrl) {
    id
    fileUrl
    account {
      id
      currency
    }
    executionAction {
      ... on DirectDebitBatchRequestActionType {
        id
        signatures {
          id
          action {
            ... on BatchPaymentActionType {
              id
              type
              status
            }
          }
          signatory {
            id
            isAuthorizedSignatory
            signatoryRight
          }
          isMine
          status
          signingMethod
          createdAt
          updatedAt
          signedAt
        }
      }
    }
    status
    cancellationReason
    createdAt
  }
}
    `;
export type StartDirectDebitBatchRequestMutationFn = Apollo.MutationFunction<StartDirectDebitBatchRequestMutation, StartDirectDebitBatchRequestMutationVariables>;

/**
 * __useStartDirectDebitBatchRequestMutation__
 *
 * To run a mutation, you first call `useStartDirectDebitBatchRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartDirectDebitBatchRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startDirectDebitBatchRequestMutation, { data, loading, error }] = useStartDirectDebitBatchRequestMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      fileUrl: // value for 'fileUrl'
 *   },
 * });
 */
export function useStartDirectDebitBatchRequestMutation(baseOptions?: Apollo.MutationHookOptions<StartDirectDebitBatchRequestMutation, StartDirectDebitBatchRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartDirectDebitBatchRequestMutation, StartDirectDebitBatchRequestMutationVariables>(StartDirectDebitBatchRequestDocument, options);
      }
export type StartDirectDebitBatchRequestMutationHookResult = ReturnType<typeof useStartDirectDebitBatchRequestMutation>;
export type StartDirectDebitBatchRequestMutationResult = Apollo.MutationResult<StartDirectDebitBatchRequestMutation>;
export type StartDirectDebitBatchRequestMutationOptions = Apollo.BaseMutationOptions<StartDirectDebitBatchRequestMutation, StartDirectDebitBatchRequestMutationVariables>;
export const TopUpWithCardDocument = gql`
    mutation topUpWithCard($accountId: String!, $amount: Float!, $page: String!) {
  topUpWithCard(accountId: $accountId, amount: $amount, page: $page)
}
    `;
export type TopUpWithCardMutationFn = Apollo.MutationFunction<TopUpWithCardMutation, TopUpWithCardMutationVariables>;

/**
 * __useTopUpWithCardMutation__
 *
 * To run a mutation, you first call `useTopUpWithCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTopUpWithCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [topUpWithCardMutation, { data, loading, error }] = useTopUpWithCardMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      amount: // value for 'amount'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTopUpWithCardMutation(baseOptions?: Apollo.MutationHookOptions<TopUpWithCardMutation, TopUpWithCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TopUpWithCardMutation, TopUpWithCardMutationVariables>(TopUpWithCardDocument, options);
      }
export type TopUpWithCardMutationHookResult = ReturnType<typeof useTopUpWithCardMutation>;
export type TopUpWithCardMutationResult = Apollo.MutationResult<TopUpWithCardMutation>;
export type TopUpWithCardMutationOptions = Apollo.BaseMutationOptions<TopUpWithCardMutation, TopUpWithCardMutationVariables>;
export const SubmitContractForPreAssessmentDocument = gql`
    mutation submitContractForPreAssessment($contractId: ID!) {
  submitContractForPreAssessment(contractId: $contractId) {
    id
  }
}
    `;
export type SubmitContractForPreAssessmentMutationFn = Apollo.MutationFunction<SubmitContractForPreAssessmentMutation, SubmitContractForPreAssessmentMutationVariables>;

/**
 * __useSubmitContractForPreAssessmentMutation__
 *
 * To run a mutation, you first call `useSubmitContractForPreAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitContractForPreAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitContractForPreAssessmentMutation, { data, loading, error }] = useSubmitContractForPreAssessmentMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useSubmitContractForPreAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<SubmitContractForPreAssessmentMutation, SubmitContractForPreAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitContractForPreAssessmentMutation, SubmitContractForPreAssessmentMutationVariables>(SubmitContractForPreAssessmentDocument, options);
      }
export type SubmitContractForPreAssessmentMutationHookResult = ReturnType<typeof useSubmitContractForPreAssessmentMutation>;
export type SubmitContractForPreAssessmentMutationResult = Apollo.MutationResult<SubmitContractForPreAssessmentMutation>;
export type SubmitContractForPreAssessmentMutationOptions = Apollo.BaseMutationOptions<SubmitContractForPreAssessmentMutation, SubmitContractForPreAssessmentMutationVariables>;
export const RequestAccountClosureDocument = gql`
    mutation requestAccountClosure($accountId: ID!, $closureReasonCode: AccountClosureReason!, $closureReasonDescription: String!) {
  requestAccountClosure(
    accountId: $accountId
    closureReasonCode: $closureReasonCode
    closureReasonDescription: $closureReasonDescription
  ) {
    id
    status
    executionAction {
      ... on AccountAction {
        id
        signatures {
          id
          action {
            ... on AccountAction {
              id
              type
              status
            }
          }
          signatory {
            id
            isAuthorizedSignatory
            signatoryRight
          }
          isMine
          status
          signingMethod
          createdAt
          updatedAt
          signedAt
        }
      }
    }
    executionActions {
      ... on AccountAction {
        id
        status
        type
        signatures {
          id
          action {
            ... on AccountAction {
              id
              type
              status
            }
          }
          signatory {
            id
            isAuthorizedSignatory
            signatoryRight
          }
          isMine
          status
          signingMethod
          createdAt
          updatedAt
          signedAt
        }
      }
    }
  }
}
    `;
export type RequestAccountClosureMutationFn = Apollo.MutationFunction<RequestAccountClosureMutation, RequestAccountClosureMutationVariables>;

/**
 * __useRequestAccountClosureMutation__
 *
 * To run a mutation, you first call `useRequestAccountClosureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccountClosureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccountClosureMutation, { data, loading, error }] = useRequestAccountClosureMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      closureReasonCode: // value for 'closureReasonCode'
 *      closureReasonDescription: // value for 'closureReasonDescription'
 *   },
 * });
 */
export function useRequestAccountClosureMutation(baseOptions?: Apollo.MutationHookOptions<RequestAccountClosureMutation, RequestAccountClosureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAccountClosureMutation, RequestAccountClosureMutationVariables>(RequestAccountClosureDocument, options);
      }
export type RequestAccountClosureMutationHookResult = ReturnType<typeof useRequestAccountClosureMutation>;
export type RequestAccountClosureMutationResult = Apollo.MutationResult<RequestAccountClosureMutation>;
export type RequestAccountClosureMutationOptions = Apollo.BaseMutationOptions<RequestAccountClosureMutation, RequestAccountClosureMutationVariables>;
export const CreateWalletDocument = gql`
    mutation createWallet($contractId: ID!, $address: String!, $chainId: Int!) {
  createWallet(contractId: $contractId, address: $address, chainId: $chainId) {
    id
    address
    network
    status
    linkedBy {
      id
    }
    contract {
      id
    }
  }
}
    `;
export type CreateWalletMutationFn = Apollo.MutationFunction<CreateWalletMutation, CreateWalletMutationVariables>;

/**
 * __useCreateWalletMutation__
 *
 * To run a mutation, you first call `useCreateWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWalletMutation, { data, loading, error }] = useCreateWalletMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      address: // value for 'address'
 *      chainId: // value for 'chainId'
 *   },
 * });
 */
export function useCreateWalletMutation(baseOptions?: Apollo.MutationHookOptions<CreateWalletMutation, CreateWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWalletMutation, CreateWalletMutationVariables>(CreateWalletDocument, options);
      }
export type CreateWalletMutationHookResult = ReturnType<typeof useCreateWalletMutation>;
export type CreateWalletMutationResult = Apollo.MutationResult<CreateWalletMutation>;
export type CreateWalletMutationOptions = Apollo.BaseMutationOptions<CreateWalletMutation, CreateWalletMutationVariables>;
export const ChangeWalletStatusDocument = gql`
    mutation changeWalletStatus($walletId: ID!, $action: WalletFlowAction!, $personalSign: String, $alias: String, $baseCurrency: Currency) {
  changeWalletStatus(
    walletId: $walletId
    action: $action
    personalSign: $personalSign
    alias: $alias
    baseCurrency: $baseCurrency
  ) {
    id
    address
    network
    status
    alias
    baseCurrency
    linkedBy {
      id
    }
    executionAction {
      ... on WalletAction {
        id
        signatures {
          id
          isMine
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type ChangeWalletStatusMutationFn = Apollo.MutationFunction<ChangeWalletStatusMutation, ChangeWalletStatusMutationVariables>;

/**
 * __useChangeWalletStatusMutation__
 *
 * To run a mutation, you first call `useChangeWalletStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeWalletStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeWalletStatusMutation, { data, loading, error }] = useChangeWalletStatusMutation({
 *   variables: {
 *      walletId: // value for 'walletId'
 *      action: // value for 'action'
 *      personalSign: // value for 'personalSign'
 *      alias: // value for 'alias'
 *      baseCurrency: // value for 'baseCurrency'
 *   },
 * });
 */
export function useChangeWalletStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeWalletStatusMutation, ChangeWalletStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeWalletStatusMutation, ChangeWalletStatusMutationVariables>(ChangeWalletStatusDocument, options);
      }
export type ChangeWalletStatusMutationHookResult = ReturnType<typeof useChangeWalletStatusMutation>;
export type ChangeWalletStatusMutationResult = Apollo.MutationResult<ChangeWalletStatusMutation>;
export type ChangeWalletStatusMutationOptions = Apollo.BaseMutationOptions<ChangeWalletStatusMutation, ChangeWalletStatusMutationVariables>;
export const DisconnectCryptoWalletFromContractDocument = gql`
    mutation disconnectCryptoWalletFromContract($walletId: ID!) {
  disconnectCryptoWalletFromContract(walletId: $walletId)
}
    `;
export type DisconnectCryptoWalletFromContractMutationFn = Apollo.MutationFunction<DisconnectCryptoWalletFromContractMutation, DisconnectCryptoWalletFromContractMutationVariables>;

/**
 * __useDisconnectCryptoWalletFromContractMutation__
 *
 * To run a mutation, you first call `useDisconnectCryptoWalletFromContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectCryptoWalletFromContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectCryptoWalletFromContractMutation, { data, loading, error }] = useDisconnectCryptoWalletFromContractMutation({
 *   variables: {
 *      walletId: // value for 'walletId'
 *   },
 * });
 */
export function useDisconnectCryptoWalletFromContractMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectCryptoWalletFromContractMutation, DisconnectCryptoWalletFromContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectCryptoWalletFromContractMutation, DisconnectCryptoWalletFromContractMutationVariables>(DisconnectCryptoWalletFromContractDocument, options);
      }
export type DisconnectCryptoWalletFromContractMutationHookResult = ReturnType<typeof useDisconnectCryptoWalletFromContractMutation>;
export type DisconnectCryptoWalletFromContractMutationResult = Apollo.MutationResult<DisconnectCryptoWalletFromContractMutation>;
export type DisconnectCryptoWalletFromContractMutationOptions = Apollo.BaseMutationOptions<DisconnectCryptoWalletFromContractMutation, DisconnectCryptoWalletFromContractMutationVariables>;
export const TopUpWithCryptoDocument = gql`
    mutation topUpWithCrypto($accountId: String!, $walletId: String!, $amount: Float!, $coin: CryptoCurrency!, $rate: Float!, $slippageTolerance: Float!, $estimatedAmount: Float, $effectiveRate: Float) {
  topUpWithCrypto(
    accountId: $accountId
    walletId: $walletId
    amount: $amount
    coin: $coin
    rate: $rate
    slippageTolerance: $slippageTolerance
    estimatedAmount: $estimatedAmount
    effectiveRate: $effectiveRate
  ) {
    id
    amount
    status
  }
}
    `;
export type TopUpWithCryptoMutationFn = Apollo.MutationFunction<TopUpWithCryptoMutation, TopUpWithCryptoMutationVariables>;

/**
 * __useTopUpWithCryptoMutation__
 *
 * To run a mutation, you first call `useTopUpWithCryptoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTopUpWithCryptoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [topUpWithCryptoMutation, { data, loading, error }] = useTopUpWithCryptoMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      walletId: // value for 'walletId'
 *      amount: // value for 'amount'
 *      coin: // value for 'coin'
 *      rate: // value for 'rate'
 *      slippageTolerance: // value for 'slippageTolerance'
 *      estimatedAmount: // value for 'estimatedAmount'
 *      effectiveRate: // value for 'effectiveRate'
 *   },
 * });
 */
export function useTopUpWithCryptoMutation(baseOptions?: Apollo.MutationHookOptions<TopUpWithCryptoMutation, TopUpWithCryptoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TopUpWithCryptoMutation, TopUpWithCryptoMutationVariables>(TopUpWithCryptoDocument, options);
      }
export type TopUpWithCryptoMutationHookResult = ReturnType<typeof useTopUpWithCryptoMutation>;
export type TopUpWithCryptoMutationResult = Apollo.MutationResult<TopUpWithCryptoMutation>;
export type TopUpWithCryptoMutationOptions = Apollo.BaseMutationOptions<TopUpWithCryptoMutation, TopUpWithCryptoMutationVariables>;
export const ExecuteOutgoingCryptoDocument = gql`
    mutation executeOutgoingCrypto($transactionRequestId: ID!, $trxHash: String!) {
  executeOutgoingCrypto(
    transactionRequestId: $transactionRequestId
    trxHash: $trxHash
  ) {
    id
    amount
    status
    trxHash
  }
}
    `;
export type ExecuteOutgoingCryptoMutationFn = Apollo.MutationFunction<ExecuteOutgoingCryptoMutation, ExecuteOutgoingCryptoMutationVariables>;

/**
 * __useExecuteOutgoingCryptoMutation__
 *
 * To run a mutation, you first call `useExecuteOutgoingCryptoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteOutgoingCryptoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeOutgoingCryptoMutation, { data, loading, error }] = useExecuteOutgoingCryptoMutation({
 *   variables: {
 *      transactionRequestId: // value for 'transactionRequestId'
 *      trxHash: // value for 'trxHash'
 *   },
 * });
 */
export function useExecuteOutgoingCryptoMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteOutgoingCryptoMutation, ExecuteOutgoingCryptoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteOutgoingCryptoMutation, ExecuteOutgoingCryptoMutationVariables>(ExecuteOutgoingCryptoDocument, options);
      }
export type ExecuteOutgoingCryptoMutationHookResult = ReturnType<typeof useExecuteOutgoingCryptoMutation>;
export type ExecuteOutgoingCryptoMutationResult = Apollo.MutationResult<ExecuteOutgoingCryptoMutation>;
export type ExecuteOutgoingCryptoMutationOptions = Apollo.BaseMutationOptions<ExecuteOutgoingCryptoMutation, ExecuteOutgoingCryptoMutationVariables>;
export const SaveWalletBaseCurrencyDocument = gql`
    mutation saveWalletBaseCurrency($walletId: ID!, $baseCurrency: Currency!) {
  saveWalletBaseCurrency(walletId: $walletId, baseCurrency: $baseCurrency) {
    id
    baseCurrency
    balance
  }
}
    `;
export type SaveWalletBaseCurrencyMutationFn = Apollo.MutationFunction<SaveWalletBaseCurrencyMutation, SaveWalletBaseCurrencyMutationVariables>;

/**
 * __useSaveWalletBaseCurrencyMutation__
 *
 * To run a mutation, you first call `useSaveWalletBaseCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWalletBaseCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWalletBaseCurrencyMutation, { data, loading, error }] = useSaveWalletBaseCurrencyMutation({
 *   variables: {
 *      walletId: // value for 'walletId'
 *      baseCurrency: // value for 'baseCurrency'
 *   },
 * });
 */
export function useSaveWalletBaseCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<SaveWalletBaseCurrencyMutation, SaveWalletBaseCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveWalletBaseCurrencyMutation, SaveWalletBaseCurrencyMutationVariables>(SaveWalletBaseCurrencyDocument, options);
      }
export type SaveWalletBaseCurrencyMutationHookResult = ReturnType<typeof useSaveWalletBaseCurrencyMutation>;
export type SaveWalletBaseCurrencyMutationResult = Apollo.MutationResult<SaveWalletBaseCurrencyMutation>;
export type SaveWalletBaseCurrencyMutationOptions = Apollo.BaseMutationOptions<SaveWalletBaseCurrencyMutation, SaveWalletBaseCurrencyMutationVariables>;
export const ChangeWalletAliasDocument = gql`
    mutation changeWalletAlias($walletId: ID!, $alias: String!) {
  changeWalletAlias(walletId: $walletId, alias: $alias) {
    id
    alias
  }
}
    `;
export type ChangeWalletAliasMutationFn = Apollo.MutationFunction<ChangeWalletAliasMutation, ChangeWalletAliasMutationVariables>;

/**
 * __useChangeWalletAliasMutation__
 *
 * To run a mutation, you first call `useChangeWalletAliasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeWalletAliasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeWalletAliasMutation, { data, loading, error }] = useChangeWalletAliasMutation({
 *   variables: {
 *      walletId: // value for 'walletId'
 *      alias: // value for 'alias'
 *   },
 * });
 */
export function useChangeWalletAliasMutation(baseOptions?: Apollo.MutationHookOptions<ChangeWalletAliasMutation, ChangeWalletAliasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeWalletAliasMutation, ChangeWalletAliasMutationVariables>(ChangeWalletAliasDocument, options);
      }
export type ChangeWalletAliasMutationHookResult = ReturnType<typeof useChangeWalletAliasMutation>;
export type ChangeWalletAliasMutationResult = Apollo.MutationResult<ChangeWalletAliasMutation>;
export type ChangeWalletAliasMutationOptions = Apollo.BaseMutationOptions<ChangeWalletAliasMutation, ChangeWalletAliasMutationVariables>;
export const RejectTransactionRequestDocument = gql`
    mutation rejectTransactionRequest($transactionRequestId: ID!) {
  rejectTransactionRequest(transactionRequestId: $transactionRequestId) {
    id
    status
  }
}
    `;
export type RejectTransactionRequestMutationFn = Apollo.MutationFunction<RejectTransactionRequestMutation, RejectTransactionRequestMutationVariables>;

/**
 * __useRejectTransactionRequestMutation__
 *
 * To run a mutation, you first call `useRejectTransactionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectTransactionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectTransactionRequestMutation, { data, loading, error }] = useRejectTransactionRequestMutation({
 *   variables: {
 *      transactionRequestId: // value for 'transactionRequestId'
 *   },
 * });
 */
export function useRejectTransactionRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectTransactionRequestMutation, RejectTransactionRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectTransactionRequestMutation, RejectTransactionRequestMutationVariables>(RejectTransactionRequestDocument, options);
      }
export type RejectTransactionRequestMutationHookResult = ReturnType<typeof useRejectTransactionRequestMutation>;
export type RejectTransactionRequestMutationResult = Apollo.MutationResult<RejectTransactionRequestMutation>;
export type RejectTransactionRequestMutationOptions = Apollo.BaseMutationOptions<RejectTransactionRequestMutation, RejectTransactionRequestMutationVariables>;
export const CreateOutboundCryptoPaymentDocument = gql`
    mutation createOutboundCryptoPayment($fromAccountNo: ID!, $walletId: String!, $amount: Float!, $coin: CryptoCurrency!, $rate: Float!, $slippageTolerance: Float!, $estimatedAmount: Float, $effectiveRate: Float) {
  createOutboundCryptoPayment(
    fromAccountNo: $fromAccountNo
    walletId: $walletId
    amount: $amount
    coin: $coin
    rate: $rate
    slippageTolerance: $slippageTolerance
    estimatedAmount: $estimatedAmount
    effectiveRate: $effectiveRate
  ) {
    ... on Transaction {
      ... on DebitTransaction {
        id
        to {
          accountNo
          name
          bankName
          iban
        }
        executionAction {
          ... on BaseAction {
            id
            signatures {
              id
              action {
                ... on BaseAction {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type CreateOutboundCryptoPaymentMutationFn = Apollo.MutationFunction<CreateOutboundCryptoPaymentMutation, CreateOutboundCryptoPaymentMutationVariables>;

/**
 * __useCreateOutboundCryptoPaymentMutation__
 *
 * To run a mutation, you first call `useCreateOutboundCryptoPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOutboundCryptoPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOutboundCryptoPaymentMutation, { data, loading, error }] = useCreateOutboundCryptoPaymentMutation({
 *   variables: {
 *      fromAccountNo: // value for 'fromAccountNo'
 *      walletId: // value for 'walletId'
 *      amount: // value for 'amount'
 *      coin: // value for 'coin'
 *      rate: // value for 'rate'
 *      slippageTolerance: // value for 'slippageTolerance'
 *      estimatedAmount: // value for 'estimatedAmount'
 *      effectiveRate: // value for 'effectiveRate'
 *   },
 * });
 */
export function useCreateOutboundCryptoPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateOutboundCryptoPaymentMutation, CreateOutboundCryptoPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOutboundCryptoPaymentMutation, CreateOutboundCryptoPaymentMutationVariables>(CreateOutboundCryptoPaymentDocument, options);
      }
export type CreateOutboundCryptoPaymentMutationHookResult = ReturnType<typeof useCreateOutboundCryptoPaymentMutation>;
export type CreateOutboundCryptoPaymentMutationResult = Apollo.MutationResult<CreateOutboundCryptoPaymentMutation>;
export type CreateOutboundCryptoPaymentMutationOptions = Apollo.BaseMutationOptions<CreateOutboundCryptoPaymentMutation, CreateOutboundCryptoPaymentMutationVariables>;
export const DepositAddressDocument = gql`
    mutation depositAddress($contractId: ID!, $coin: CryptoCurrency!, $network: SupportedCryptoNetwork!, $transactionRequestId: ID) {
  cryptoDepositAddress(
    contractId: $contractId
    coin: $coin
    network: $network
    transactionRequestId: $transactionRequestId
  )
}
    `;
export type DepositAddressMutationFn = Apollo.MutationFunction<DepositAddressMutation, DepositAddressMutationVariables>;

/**
 * __useDepositAddressMutation__
 *
 * To run a mutation, you first call `useDepositAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDepositAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [depositAddressMutation, { data, loading, error }] = useDepositAddressMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      coin: // value for 'coin'
 *      network: // value for 'network'
 *      transactionRequestId: // value for 'transactionRequestId'
 *   },
 * });
 */
export function useDepositAddressMutation(baseOptions?: Apollo.MutationHookOptions<DepositAddressMutation, DepositAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DepositAddressMutation, DepositAddressMutationVariables>(DepositAddressDocument, options);
      }
export type DepositAddressMutationHookResult = ReturnType<typeof useDepositAddressMutation>;
export type DepositAddressMutationResult = Apollo.MutationResult<DepositAddressMutation>;
export type DepositAddressMutationOptions = Apollo.BaseMutationOptions<DepositAddressMutation, DepositAddressMutationVariables>;
export const ChangeCardPinDocument = gql`
    mutation changeCardPin($cardId: ID!, $challengeId: String!, $code: ID!) {
  changeCardPin(cardId: $cardId, challengeId: $challengeId, code: $code) {
    token
    url
  }
}
    `;
export type ChangeCardPinMutationFn = Apollo.MutationFunction<ChangeCardPinMutation, ChangeCardPinMutationVariables>;

/**
 * __useChangeCardPinMutation__
 *
 * To run a mutation, you first call `useChangeCardPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCardPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCardPinMutation, { data, loading, error }] = useChangeCardPinMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *      challengeId: // value for 'challengeId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useChangeCardPinMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCardPinMutation, ChangeCardPinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCardPinMutation, ChangeCardPinMutationVariables>(ChangeCardPinDocument, options);
      }
export type ChangeCardPinMutationHookResult = ReturnType<typeof useChangeCardPinMutation>;
export type ChangeCardPinMutationResult = Apollo.MutationResult<ChangeCardPinMutation>;
export type ChangeCardPinMutationOptions = Apollo.BaseMutationOptions<ChangeCardPinMutation, ChangeCardPinMutationVariables>;
export const FinishSetupMobileTwoFaForIndividualDocument = gql`
    mutation finishSetupMobileTwoFaForIndividual {
  finishSetupMobileTwoFaForIndividual
}
    `;
export type FinishSetupMobileTwoFaForIndividualMutationFn = Apollo.MutationFunction<FinishSetupMobileTwoFaForIndividualMutation, FinishSetupMobileTwoFaForIndividualMutationVariables>;

/**
 * __useFinishSetupMobileTwoFaForIndividualMutation__
 *
 * To run a mutation, you first call `useFinishSetupMobileTwoFaForIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishSetupMobileTwoFaForIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishSetupMobileTwoFaForIndividualMutation, { data, loading, error }] = useFinishSetupMobileTwoFaForIndividualMutation({
 *   variables: {
 *   },
 * });
 */
export function useFinishSetupMobileTwoFaForIndividualMutation(baseOptions?: Apollo.MutationHookOptions<FinishSetupMobileTwoFaForIndividualMutation, FinishSetupMobileTwoFaForIndividualMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishSetupMobileTwoFaForIndividualMutation, FinishSetupMobileTwoFaForIndividualMutationVariables>(FinishSetupMobileTwoFaForIndividualDocument, options);
      }
export type FinishSetupMobileTwoFaForIndividualMutationHookResult = ReturnType<typeof useFinishSetupMobileTwoFaForIndividualMutation>;
export type FinishSetupMobileTwoFaForIndividualMutationResult = Apollo.MutationResult<FinishSetupMobileTwoFaForIndividualMutation>;
export type FinishSetupMobileTwoFaForIndividualMutationOptions = Apollo.BaseMutationOptions<FinishSetupMobileTwoFaForIndividualMutation, FinishSetupMobileTwoFaForIndividualMutationVariables>;
export const GetViewerDocument = gql`
    query getViewer {
  viewer(applyPendingChanges: false) {
    ... on Individual {
      id
      ...ClientBasicInfo
      ...SecondaryPhones
      ...SecondaryEmails
      ...Address
      email
      emailPendingChange
      videoVerificationStatus
      videoVerified
      isVerified
      isPhoneVerified
      isPhoneVerificationRequired
      isEmailVerificationRequired
      isIntroducer
      requireAccount
    }
  }
}
    ${ClientBasicInfoFragmentDoc}
${SecondaryPhonesFragmentDoc}
${SecondaryEmailsFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useGetViewerQuery__
 *
 * To run a query within a React component, call `useGetViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetViewerQuery(baseOptions?: Apollo.QueryHookOptions<GetViewerQuery, GetViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetViewerQuery, GetViewerQueryVariables>(GetViewerDocument, options);
      }
export function useGetViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewerQuery, GetViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetViewerQuery, GetViewerQueryVariables>(GetViewerDocument, options);
        }
export function useGetViewerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetViewerQuery, GetViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetViewerQuery, GetViewerQueryVariables>(GetViewerDocument, options);
        }
export type GetViewerQueryHookResult = ReturnType<typeof useGetViewerQuery>;
export type GetViewerLazyQueryHookResult = ReturnType<typeof useGetViewerLazyQuery>;
export type GetViewerSuspenseQueryHookResult = ReturnType<typeof useGetViewerSuspenseQuery>;
export type GetViewerQueryResult = Apollo.QueryResult<GetViewerQuery, GetViewerQueryVariables>;
export const GetContractApplicantDocument = gql`
    query getContractApplicant($id: ID!) {
  contract(id: $id) {
    createdBy {
      id
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __useGetContractApplicantQuery__
 *
 * To run a query within a React component, call `useGetContractApplicantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractApplicantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractApplicantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContractApplicantQuery(baseOptions: Apollo.QueryHookOptions<GetContractApplicantQuery, GetContractApplicantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractApplicantQuery, GetContractApplicantQueryVariables>(GetContractApplicantDocument, options);
      }
export function useGetContractApplicantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractApplicantQuery, GetContractApplicantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractApplicantQuery, GetContractApplicantQueryVariables>(GetContractApplicantDocument, options);
        }
export function useGetContractApplicantSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractApplicantQuery, GetContractApplicantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractApplicantQuery, GetContractApplicantQueryVariables>(GetContractApplicantDocument, options);
        }
export type GetContractApplicantQueryHookResult = ReturnType<typeof useGetContractApplicantQuery>;
export type GetContractApplicantLazyQueryHookResult = ReturnType<typeof useGetContractApplicantLazyQuery>;
export type GetContractApplicantSuspenseQueryHookResult = ReturnType<typeof useGetContractApplicantSuspenseQuery>;
export type GetContractApplicantQueryResult = Apollo.QueryResult<GetContractApplicantQuery, GetContractApplicantQueryVariables>;
export const GetContractStatusDocument = gql`
    query getContractStatus($id: ID!) {
  contract(id: $id) {
    id
    status
    isSigned
    ownerType
    allowVbanCreation
    allowLocalPay
    type
    ownershipTransferInitiated
    allowedCryptoPayments
    owner {
      ... on LegalEntity {
        address {
          country
        }
      }
      ... on Individual {
        address {
          country
        }
      }
    }
  }
}
    `;

/**
 * __useGetContractStatusQuery__
 *
 * To run a query within a React component, call `useGetContractStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContractStatusQuery(baseOptions: Apollo.QueryHookOptions<GetContractStatusQuery, GetContractStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractStatusQuery, GetContractStatusQueryVariables>(GetContractStatusDocument, options);
      }
export function useGetContractStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractStatusQuery, GetContractStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractStatusQuery, GetContractStatusQueryVariables>(GetContractStatusDocument, options);
        }
export function useGetContractStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractStatusQuery, GetContractStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractStatusQuery, GetContractStatusQueryVariables>(GetContractStatusDocument, options);
        }
export type GetContractStatusQueryHookResult = ReturnType<typeof useGetContractStatusQuery>;
export type GetContractStatusLazyQueryHookResult = ReturnType<typeof useGetContractStatusLazyQuery>;
export type GetContractStatusSuspenseQueryHookResult = ReturnType<typeof useGetContractStatusSuspenseQuery>;
export type GetContractStatusQueryResult = Apollo.QueryResult<GetContractStatusQuery, GetContractStatusQueryVariables>;
export const GetContractDetailsDocument = gql`
    query getContractDetails($id: ID!) {
  contract(id: $id) {
    id
    status
    type
    directDebitCreditorId
    allowedCryptoPayments
    signatories {
      id
      isAuthorizedSignatory
      isLimitedAccessHolder
      limitedAccessRight
      signatoryRight
      status
    }
    signatoriesCount
    isIntroducingPartner
    referralLink
    authorizedPersons(limit: 1000) {
      id
      isAuthorizedSignatory
      isLimitedAccessHolder
      limitedAccessRight
      signatoryRight
      invitationDate
      cannotSignOwnActions
      status
      groupSize
      person {
        id
        firstName
        lastName
        lastSeenAt
        lastLogin
      }
    }
    ubos {
      id
      shareSize
      addedFromExistingUbo
    }
    ownerType
    owner {
      ... on LegalEntity {
        id
        companyName
        tradingName
        companyType
        legalEntityType
        companyRegistrationId
        companyRegistrationDate
        phone
        websites
        website
        businessSector
        businessDescription
        countriesOfOperatingAndConductingBusiness
        taxId
        servingIndustries
        companyClientsCountries
        address {
          line1
          country
          countryDescription
          zip
          city
          additionalDetails
        }
        correspondenceAddress {
          line1
          country
          countryDescription
          zip
          city
          additionalDetails
        }
        transactionalPartners {
          ... on TransactionalPartner {
            name
            country
          }
        }
        economicProfile {
          ... on EconomicProfile {
            sourceOfFunds
            sourceOfFundsDescription
            currencies
            turnover
            averageInbound
            averageOutbound
            estimateInbound
            estimateOutbound
            inboundSources
            inboundSourcesOther
            outboundDestinations
            outboundDestinationsOther
            anticipatedAccountActivity
            products
          }
        }
      }
    }
    preAssessment {
      ...CardPayments
      regulatoryInfoName
      regulatoryInfoLicenseNumber
      paymentProviders
      conductingKYC
      conductingClientKYC
      conductPublisherContentMonitoring
      clientsYouWorkWith
      companyAnnualIncome
      incomingMonthlyTurnover
      incomingClients
      outgoingMonthlyTurnover
      outgoingClients
      currencyAndVolume
      contactPersonFullName
      contactPersonEmail
      contactPersonPhoneNumber
      countryOfTaxResidence
      licenseRequired
      licenseCountry
      uboResidencies
      noPartnersIncomingRequired
      noPartnersOutgoingRequired
      businessRelationshipWithCompany
      businessRelationshipWithCompanyExplanation
      partnersIncoming {
        name
        country
        bankCountry
        businessSector
        paymentPurpose
        paymentPurposeOther
        website
      }
      partnersOutgoing {
        name
        country
        bankCountry
        businessSector
        paymentPurpose
        paymentPurposeOther
        website
      }
    }
  }
}
    ${CardPaymentsFragmentDoc}`;

/**
 * __useGetContractDetailsQuery__
 *
 * To run a query within a React component, call `useGetContractDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContractDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetContractDetailsQuery, GetContractDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractDetailsQuery, GetContractDetailsQueryVariables>(GetContractDetailsDocument, options);
      }
export function useGetContractDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractDetailsQuery, GetContractDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractDetailsQuery, GetContractDetailsQueryVariables>(GetContractDetailsDocument, options);
        }
export function useGetContractDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractDetailsQuery, GetContractDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractDetailsQuery, GetContractDetailsQueryVariables>(GetContractDetailsDocument, options);
        }
export type GetContractDetailsQueryHookResult = ReturnType<typeof useGetContractDetailsQuery>;
export type GetContractDetailsLazyQueryHookResult = ReturnType<typeof useGetContractDetailsLazyQuery>;
export type GetContractDetailsSuspenseQueryHookResult = ReturnType<typeof useGetContractDetailsSuspenseQuery>;
export type GetContractDetailsQueryResult = Apollo.QueryResult<GetContractDetailsQuery, GetContractDetailsQueryVariables>;
export const GetUserDataDocument = gql`
    query getUserData {
  viewer(applyPendingChanges: false) {
    ... on Individual {
      id
      taxId
      email
      firstName
      lastName
      fullName
      birthday
      nationality
      phone
      lastSeenAt
      lastLogin
      address {
        additionalDetails
        city
        country
        line1
        zip
      }
      isPhoneVerified
      isPhoneVerificationRequired
      phone
      videoVerified
      isVerified
      videoVerificationStatus
      isEmailVerificationRequired
      emailConfirmed
      birthday
      nationality
      primaryTwoFAMethod
      address {
        line1
        city
        zip
        country
        additionalDetails
      }
      company
      isIntroducer
      requireAccount
      contracts {
        id
        status
        type
        isIntroducingPartner
        individualViewerRoles
        individualViewerOnboardingRequiredChecks
        createdBy {
          id
        }
        owner {
          ... on LegalEntity {
            companyName
            address {
              line1
              city
              zip
              country
              additionalDetails
            }
          }
        }
        ownerType
        authorizedPersons(limit: 1000) {
          id
          signatoryRight
          isAuthorizedSignatory
          isLimitedAccessHolder
          cannotSignOwnActions
          limitedAccessRight
          groupSize
          status
          balanceCurrency
          person {
            id
          }
        }
        preAssessment {
          cardPayment {
            isCardPayment
          }
        }
      }
      pendingContractOwnershipTransfers {
        id
        fromIndividual {
          id
          fullName
          email
        }
        contract {
          id
          owner {
            ... on LegalEntity {
              companyName
            }
          }
        }
      }
      notices {
        id
        message
        url
        type
      }
    }
  }
}
    `;

/**
 * __useGetUserDataQuery__
 *
 * To run a query within a React component, call `useGetUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserDataQuery(baseOptions?: Apollo.QueryHookOptions<GetUserDataQuery, GetUserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDataQuery, GetUserDataQueryVariables>(GetUserDataDocument, options);
      }
export function useGetUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDataQuery, GetUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDataQuery, GetUserDataQueryVariables>(GetUserDataDocument, options);
        }
export function useGetUserDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserDataQuery, GetUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserDataQuery, GetUserDataQueryVariables>(GetUserDataDocument, options);
        }
export type GetUserDataQueryHookResult = ReturnType<typeof useGetUserDataQuery>;
export type GetUserDataLazyQueryHookResult = ReturnType<typeof useGetUserDataLazyQuery>;
export type GetUserDataSuspenseQueryHookResult = ReturnType<typeof useGetUserDataSuspenseQuery>;
export type GetUserDataQueryResult = Apollo.QueryResult<GetUserDataQuery, GetUserDataQueryVariables>;
export const GetDefaultUserDataDocument = gql`
    query getDefaultUserData {
  viewer(applyPendingChanges: true) {
    ... on Individual {
      id
      taxId
      email
      firstName
      lastName
      fullName
      birthday
      nationality
      phone
      lastSeenAt
      lastLogin
      address {
        additionalDetails
        city
        country
        line1
        zip
      }
      isPhoneVerified
      isPhoneVerificationRequired
      phone
      videoVerified
      isVerified
      videoVerificationStatus
      isEmailVerificationRequired
      emailConfirmed
      birthday
      nationality
      primaryTwoFAMethod
      address {
        line1
        city
        zip
        country
        additionalDetails
      }
      company
      isIntroducer
      requireAccount
      contracts {
        id
        status
        type
        isIntroducingPartner
        individualViewerRoles
        individualViewerOnboardingRequiredChecks
        createdBy {
          id
        }
        owner {
          ... on LegalEntity {
            companyName
            address {
              line1
              city
              zip
              country
              additionalDetails
            }
          }
        }
        ownerType
        authorizedPersons(limit: 1000) {
          id
          signatoryRight
          isAuthorizedSignatory
          isLimitedAccessHolder
          cannotSignOwnActions
          limitedAccessRight
          groupSize
          status
          balanceCurrency
          person {
            id
          }
        }
        preAssessment {
          cardPayment {
            isCardPayment
          }
        }
      }
      pendingContractOwnershipTransfers {
        id
        fromIndividual {
          id
          fullName
          email
        }
        contract {
          id
          owner {
            ... on LegalEntity {
              companyName
            }
          }
        }
      }
      notices {
        id
        message
        url
        type
      }
    }
  }
}
    `;

/**
 * __useGetDefaultUserDataQuery__
 *
 * To run a query within a React component, call `useGetDefaultUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultUserDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultUserDataQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultUserDataQuery, GetDefaultUserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultUserDataQuery, GetDefaultUserDataQueryVariables>(GetDefaultUserDataDocument, options);
      }
export function useGetDefaultUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultUserDataQuery, GetDefaultUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultUserDataQuery, GetDefaultUserDataQueryVariables>(GetDefaultUserDataDocument, options);
        }
export function useGetDefaultUserDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDefaultUserDataQuery, GetDefaultUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDefaultUserDataQuery, GetDefaultUserDataQueryVariables>(GetDefaultUserDataDocument, options);
        }
export type GetDefaultUserDataQueryHookResult = ReturnType<typeof useGetDefaultUserDataQuery>;
export type GetDefaultUserDataLazyQueryHookResult = ReturnType<typeof useGetDefaultUserDataLazyQuery>;
export type GetDefaultUserDataSuspenseQueryHookResult = ReturnType<typeof useGetDefaultUserDataSuspenseQuery>;
export type GetDefaultUserDataQueryResult = Apollo.QueryResult<GetDefaultUserDataQuery, GetDefaultUserDataQueryVariables>;
export const GetProfileChangesDocument = gql`
    query getProfileChanges {
  viewer(applyPendingChanges: false) {
    ... on Individual {
      id
      email
      phone
      lastName
      firstName
      birthday
      nationality
      taxId
      address {
        country
        city
        line1
        zip
        additionalDetails
      }
      profileChanges {
        id
        status
        answers {
          lastName
          firstName
          birthday
          nationality
          address {
            country
            city
            line1
            zip
            additionalDetails
          }
        }
        individual {
          id
          email
          phone
          lastName
          firstName
          birthday
          nationality
          taxId
          address {
            country
            city
            line1
            zip
            additionalDetails
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetProfileChangesQuery__
 *
 * To run a query within a React component, call `useGetProfileChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileChangesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProfileChangesQuery(baseOptions?: Apollo.QueryHookOptions<GetProfileChangesQuery, GetProfileChangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileChangesQuery, GetProfileChangesQueryVariables>(GetProfileChangesDocument, options);
      }
export function useGetProfileChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileChangesQuery, GetProfileChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileChangesQuery, GetProfileChangesQueryVariables>(GetProfileChangesDocument, options);
        }
export function useGetProfileChangesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProfileChangesQuery, GetProfileChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProfileChangesQuery, GetProfileChangesQueryVariables>(GetProfileChangesDocument, options);
        }
export type GetProfileChangesQueryHookResult = ReturnType<typeof useGetProfileChangesQuery>;
export type GetProfileChangesLazyQueryHookResult = ReturnType<typeof useGetProfileChangesLazyQuery>;
export type GetProfileChangesSuspenseQueryHookResult = ReturnType<typeof useGetProfileChangesSuspenseQuery>;
export type GetProfileChangesQueryResult = Apollo.QueryResult<GetProfileChangesQuery, GetProfileChangesQueryVariables>;
export const GetUserContractsDocument = gql`
    query getUserContracts {
  contracts {
    id
    status
    type
    ownerType
    activatedOn
    owner {
      ... on LegalEntity {
        id
        companyName
        legalEntityType
        legalEntityDirectors {
          id
        }
      }
      ... on Individual {
        id
        fullName
        isVerified
        isPhoneVerified
        documentsCount
      }
    }
    createdBy {
      id
    }
    authorizedPersons(limit: 1000) {
      id
      status
      isAuthorizedSignatory
      isLimitedAccessHolder
      cannotSignOwnActions
      signatoryRight
      invitationDate
      limitedAccessRight
      person {
        id
        firstName
        lastName
        registration
        lastSeenAt
        lastLogin
      }
    }
    ubos {
      id
    }
    contacts {
      id
    }
  }
}
    `;

/**
 * __useGetUserContractsQuery__
 *
 * To run a query within a React component, call `useGetUserContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserContractsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserContractsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserContractsQuery, GetUserContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserContractsQuery, GetUserContractsQueryVariables>(GetUserContractsDocument, options);
      }
export function useGetUserContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserContractsQuery, GetUserContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserContractsQuery, GetUserContractsQueryVariables>(GetUserContractsDocument, options);
        }
export function useGetUserContractsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserContractsQuery, GetUserContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserContractsQuery, GetUserContractsQueryVariables>(GetUserContractsDocument, options);
        }
export type GetUserContractsQueryHookResult = ReturnType<typeof useGetUserContractsQuery>;
export type GetUserContractsLazyQueryHookResult = ReturnType<typeof useGetUserContractsLazyQuery>;
export type GetUserContractsSuspenseQueryHookResult = ReturnType<typeof useGetUserContractsSuspenseQuery>;
export type GetUserContractsQueryResult = Apollo.QueryResult<GetUserContractsQuery, GetUserContractsQueryVariables>;
export const GetDocumentsQueryDocument = gql`
    query getDocumentsQuery($contractId: ID!) {
  contract(id: $contractId) {
    id
    ... on BankableEntityContractType {
      documents {
        ... on Document {
          id
          type
          fileName
          mimeType
          createdAt
          size
          individual {
            id
            firstName
            lastName
          }
          legalEntity {
            id
            companyName
          }
          fileDescription
          expiration
        }
      }
    }
  }
}
    `;

/**
 * __useGetDocumentsQueryQuery__
 *
 * To run a query within a React component, call `useGetDocumentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsQueryQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetDocumentsQueryQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentsQueryQuery, GetDocumentsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentsQueryQuery, GetDocumentsQueryQueryVariables>(GetDocumentsQueryDocument, options);
      }
export function useGetDocumentsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentsQueryQuery, GetDocumentsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentsQueryQuery, GetDocumentsQueryQueryVariables>(GetDocumentsQueryDocument, options);
        }
export function useGetDocumentsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentsQueryQuery, GetDocumentsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentsQueryQuery, GetDocumentsQueryQueryVariables>(GetDocumentsQueryDocument, options);
        }
export type GetDocumentsQueryQueryHookResult = ReturnType<typeof useGetDocumentsQueryQuery>;
export type GetDocumentsQueryLazyQueryHookResult = ReturnType<typeof useGetDocumentsQueryLazyQuery>;
export type GetDocumentsQuerySuspenseQueryHookResult = ReturnType<typeof useGetDocumentsQuerySuspenseQuery>;
export type GetDocumentsQueryQueryResult = Apollo.QueryResult<GetDocumentsQueryQuery, GetDocumentsQueryQueryVariables>;
export const GetAuthorizedPersonsDocument = gql`
    query getAuthorizedPersons($id: ID!) {
  contract(id: $id) {
    id
    ubos {
      id
      addedFromExistingUbo
      ubo {
        id
        entity {
          ... on Individual {
            id
            email
          }
        }
      }
    }
    authorizedPersons(limit: 1000) {
      id
      status
      isAuthorizedSignatory
      cannotSignOwnActions
      signatoryRight
      limitedAccessRight
      groupSize
      person {
        id
        firstName
        lastName
        isPhoneVerified
        videoVerified
        isVerified
        videoVerificationStatus
      }
    }
  }
}
    `;

/**
 * __useGetAuthorizedPersonsQuery__
 *
 * To run a query within a React component, call `useGetAuthorizedPersonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorizedPersonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorizedPersonsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAuthorizedPersonsQuery(baseOptions: Apollo.QueryHookOptions<GetAuthorizedPersonsQuery, GetAuthorizedPersonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthorizedPersonsQuery, GetAuthorizedPersonsQueryVariables>(GetAuthorizedPersonsDocument, options);
      }
export function useGetAuthorizedPersonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthorizedPersonsQuery, GetAuthorizedPersonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthorizedPersonsQuery, GetAuthorizedPersonsQueryVariables>(GetAuthorizedPersonsDocument, options);
        }
export function useGetAuthorizedPersonsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAuthorizedPersonsQuery, GetAuthorizedPersonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthorizedPersonsQuery, GetAuthorizedPersonsQueryVariables>(GetAuthorizedPersonsDocument, options);
        }
export type GetAuthorizedPersonsQueryHookResult = ReturnType<typeof useGetAuthorizedPersonsQuery>;
export type GetAuthorizedPersonsLazyQueryHookResult = ReturnType<typeof useGetAuthorizedPersonsLazyQuery>;
export type GetAuthorizedPersonsSuspenseQueryHookResult = ReturnType<typeof useGetAuthorizedPersonsSuspenseQuery>;
export type GetAuthorizedPersonsQueryResult = Apollo.QueryResult<GetAuthorizedPersonsQuery, GetAuthorizedPersonsQueryVariables>;
export const GetDirectorsDocument = gql`
    query getDirectors($id: ID!) {
  contract(id: $id) {
    id
    owner {
      ... on LegalEntity {
        id
        legalEntityDirectors {
          id
          role
          signingRight
          individual {
            id
            firstName
            lastName
            fullName
            email
            birthday
            nationality
            phone
            taxId
            isPep
            address {
              line1
              city
              zip
              country
              countryDescription
              additionalDetails
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDirectorsQuery__
 *
 * To run a query within a React component, call `useGetDirectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDirectorsQuery(baseOptions: Apollo.QueryHookOptions<GetDirectorsQuery, GetDirectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectorsQuery, GetDirectorsQueryVariables>(GetDirectorsDocument, options);
      }
export function useGetDirectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectorsQuery, GetDirectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectorsQuery, GetDirectorsQueryVariables>(GetDirectorsDocument, options);
        }
export function useGetDirectorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDirectorsQuery, GetDirectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDirectorsQuery, GetDirectorsQueryVariables>(GetDirectorsDocument, options);
        }
export type GetDirectorsQueryHookResult = ReturnType<typeof useGetDirectorsQuery>;
export type GetDirectorsLazyQueryHookResult = ReturnType<typeof useGetDirectorsLazyQuery>;
export type GetDirectorsSuspenseQueryHookResult = ReturnType<typeof useGetDirectorsSuspenseQuery>;
export type GetDirectorsQueryResult = Apollo.QueryResult<GetDirectorsQuery, GetDirectorsQueryVariables>;
export const GetDirectorDocument = gql`
    query getDirector($id: ID!) {
  getLegalEntityDirector(id: $id) {
    id
    role
    signingRight
    individual {
      fullName
      email
      phone
      birthday
      nationality
      address {
        country
        city
        line1
        zip
        additionalDetails
      }
    }
  }
}
    `;

/**
 * __useGetDirectorQuery__
 *
 * To run a query within a React component, call `useGetDirectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDirectorQuery(baseOptions: Apollo.QueryHookOptions<GetDirectorQuery, GetDirectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectorQuery, GetDirectorQueryVariables>(GetDirectorDocument, options);
      }
export function useGetDirectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectorQuery, GetDirectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectorQuery, GetDirectorQueryVariables>(GetDirectorDocument, options);
        }
export function useGetDirectorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDirectorQuery, GetDirectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDirectorQuery, GetDirectorQueryVariables>(GetDirectorDocument, options);
        }
export type GetDirectorQueryHookResult = ReturnType<typeof useGetDirectorQuery>;
export type GetDirectorLazyQueryHookResult = ReturnType<typeof useGetDirectorLazyQuery>;
export type GetDirectorSuspenseQueryHookResult = ReturnType<typeof useGetDirectorSuspenseQuery>;
export type GetDirectorQueryResult = Apollo.QueryResult<GetDirectorQuery, GetDirectorQueryVariables>;
export const GetContractRelatedIndividualsDocument = gql`
    query getContractRelatedIndividuals($contractId: ID!) {
  getContractRelatedIndividuals(contractId: $contractId) {
    ... on Individual {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetContractRelatedIndividualsQuery__
 *
 * To run a query within a React component, call `useGetContractRelatedIndividualsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractRelatedIndividualsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractRelatedIndividualsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetContractRelatedIndividualsQuery(baseOptions: Apollo.QueryHookOptions<GetContractRelatedIndividualsQuery, GetContractRelatedIndividualsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractRelatedIndividualsQuery, GetContractRelatedIndividualsQueryVariables>(GetContractRelatedIndividualsDocument, options);
      }
export function useGetContractRelatedIndividualsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractRelatedIndividualsQuery, GetContractRelatedIndividualsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractRelatedIndividualsQuery, GetContractRelatedIndividualsQueryVariables>(GetContractRelatedIndividualsDocument, options);
        }
export function useGetContractRelatedIndividualsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractRelatedIndividualsQuery, GetContractRelatedIndividualsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractRelatedIndividualsQuery, GetContractRelatedIndividualsQueryVariables>(GetContractRelatedIndividualsDocument, options);
        }
export type GetContractRelatedIndividualsQueryHookResult = ReturnType<typeof useGetContractRelatedIndividualsQuery>;
export type GetContractRelatedIndividualsLazyQueryHookResult = ReturnType<typeof useGetContractRelatedIndividualsLazyQuery>;
export type GetContractRelatedIndividualsSuspenseQueryHookResult = ReturnType<typeof useGetContractRelatedIndividualsSuspenseQuery>;
export type GetContractRelatedIndividualsQueryResult = Apollo.QueryResult<GetContractRelatedIndividualsQuery, GetContractRelatedIndividualsQueryVariables>;
export const GetContractLegalEntityDocument = gql`
    query getContractLegalEntity($contractId: ID!) {
  contract(id: $contractId) {
    owner {
      ... on LegalEntity {
        id
        companyName
      }
    }
  }
}
    `;

/**
 * __useGetContractLegalEntityQuery__
 *
 * To run a query within a React component, call `useGetContractLegalEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractLegalEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractLegalEntityQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetContractLegalEntityQuery(baseOptions: Apollo.QueryHookOptions<GetContractLegalEntityQuery, GetContractLegalEntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractLegalEntityQuery, GetContractLegalEntityQueryVariables>(GetContractLegalEntityDocument, options);
      }
export function useGetContractLegalEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractLegalEntityQuery, GetContractLegalEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractLegalEntityQuery, GetContractLegalEntityQueryVariables>(GetContractLegalEntityDocument, options);
        }
export function useGetContractLegalEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractLegalEntityQuery, GetContractLegalEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractLegalEntityQuery, GetContractLegalEntityQueryVariables>(GetContractLegalEntityDocument, options);
        }
export type GetContractLegalEntityQueryHookResult = ReturnType<typeof useGetContractLegalEntityQuery>;
export type GetContractLegalEntityLazyQueryHookResult = ReturnType<typeof useGetContractLegalEntityLazyQuery>;
export type GetContractLegalEntitySuspenseQueryHookResult = ReturnType<typeof useGetContractLegalEntitySuspenseQuery>;
export type GetContractLegalEntityQueryResult = Apollo.QueryResult<GetContractLegalEntityQuery, GetContractLegalEntityQueryVariables>;
export const GetAuthorizedPersonsDataDocument = gql`
    query getAuthorizedPersonsData($id: ID!) {
  contract(id: $id) {
    id
    authorizedPersons(limit: 1000) {
      id
      groupSize
      isAuthorizedSignatory
      isLimitedAccessHolder
      cannotSignOwnActions
      limitedAccessRight
      signatoryRight
      status
      person {
        id
        firstName
        lastName
        email
        birthday
        nationality
        phone
        taxId
        isPep
        address {
          line1
          city
          zip
          country
          countryDescription
          additionalDetails
        }
      }
    }
  }
}
    `;

/**
 * __useGetAuthorizedPersonsDataQuery__
 *
 * To run a query within a React component, call `useGetAuthorizedPersonsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorizedPersonsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorizedPersonsDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAuthorizedPersonsDataQuery(baseOptions: Apollo.QueryHookOptions<GetAuthorizedPersonsDataQuery, GetAuthorizedPersonsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthorizedPersonsDataQuery, GetAuthorizedPersonsDataQueryVariables>(GetAuthorizedPersonsDataDocument, options);
      }
export function useGetAuthorizedPersonsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthorizedPersonsDataQuery, GetAuthorizedPersonsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthorizedPersonsDataQuery, GetAuthorizedPersonsDataQueryVariables>(GetAuthorizedPersonsDataDocument, options);
        }
export function useGetAuthorizedPersonsDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAuthorizedPersonsDataQuery, GetAuthorizedPersonsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthorizedPersonsDataQuery, GetAuthorizedPersonsDataQueryVariables>(GetAuthorizedPersonsDataDocument, options);
        }
export type GetAuthorizedPersonsDataQueryHookResult = ReturnType<typeof useGetAuthorizedPersonsDataQuery>;
export type GetAuthorizedPersonsDataLazyQueryHookResult = ReturnType<typeof useGetAuthorizedPersonsDataLazyQuery>;
export type GetAuthorizedPersonsDataSuspenseQueryHookResult = ReturnType<typeof useGetAuthorizedPersonsDataSuspenseQuery>;
export type GetAuthorizedPersonsDataQueryResult = Apollo.QueryResult<GetAuthorizedPersonsDataQuery, GetAuthorizedPersonsDataQueryVariables>;
export const GetOwnerSizeTypeDocument = gql`
    query getOwnerSizeType($id: ID!) {
  contract(id: $id) {
    id
    status
    type
    ubos {
      id
      shareSize
      ownershipType
    }
    owner {
      ... on LegalEntity {
        id
        companyRegistrationId
        companyName
        legalEntityType
      }
      ... on Individual {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetOwnerSizeTypeQuery__
 *
 * To run a query within a React component, call `useGetOwnerSizeTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerSizeTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerSizeTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOwnerSizeTypeQuery(baseOptions: Apollo.QueryHookOptions<GetOwnerSizeTypeQuery, GetOwnerSizeTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerSizeTypeQuery, GetOwnerSizeTypeQueryVariables>(GetOwnerSizeTypeDocument, options);
      }
export function useGetOwnerSizeTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerSizeTypeQuery, GetOwnerSizeTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerSizeTypeQuery, GetOwnerSizeTypeQueryVariables>(GetOwnerSizeTypeDocument, options);
        }
export function useGetOwnerSizeTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOwnerSizeTypeQuery, GetOwnerSizeTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnerSizeTypeQuery, GetOwnerSizeTypeQueryVariables>(GetOwnerSizeTypeDocument, options);
        }
export type GetOwnerSizeTypeQueryHookResult = ReturnType<typeof useGetOwnerSizeTypeQuery>;
export type GetOwnerSizeTypeLazyQueryHookResult = ReturnType<typeof useGetOwnerSizeTypeLazyQuery>;
export type GetOwnerSizeTypeSuspenseQueryHookResult = ReturnType<typeof useGetOwnerSizeTypeSuspenseQuery>;
export type GetOwnerSizeTypeQueryResult = Apollo.QueryResult<GetOwnerSizeTypeQuery, GetOwnerSizeTypeQueryVariables>;
export const GetUbosListDocument = gql`
    query getUbosList($id: ID!) {
  contract(id: $id) {
    id
    owner {
      ... on LegalEntity {
        id
        companyName
        legalEntityType
      }
    }
    ubos {
      id
      shareSize
      ownershipType
      addedFromExistingUbo
      ubo {
        id
        ownersTotalShareSize
        entity {
          ... on Individual {
            id
            firstName
            lastName
          }
          ... on LegalEntity {
            id
            companyName
            legalEntityType
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetUbosListQuery__
 *
 * To run a query within a React component, call `useGetUbosListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUbosListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUbosListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUbosListQuery(baseOptions: Apollo.QueryHookOptions<GetUbosListQuery, GetUbosListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUbosListQuery, GetUbosListQueryVariables>(GetUbosListDocument, options);
      }
export function useGetUbosListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUbosListQuery, GetUbosListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUbosListQuery, GetUbosListQueryVariables>(GetUbosListDocument, options);
        }
export function useGetUbosListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUbosListQuery, GetUbosListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUbosListQuery, GetUbosListQueryVariables>(GetUbosListDocument, options);
        }
export type GetUbosListQueryHookResult = ReturnType<typeof useGetUbosListQuery>;
export type GetUbosListLazyQueryHookResult = ReturnType<typeof useGetUbosListLazyQuery>;
export type GetUbosListSuspenseQueryHookResult = ReturnType<typeof useGetUbosListSuspenseQuery>;
export type GetUbosListQueryResult = Apollo.QueryResult<GetUbosListQuery, GetUbosListQueryVariables>;
export const GetUboOwnersDocument = gql`
    query getUboOwners($id: ID!) {
  getUboOwners(uboId: $id) {
    id
    level
    ownedUboId
    shareSize
    ownershipType
    ubo {
      id
      ownersTotalShareSize
      entity {
        ... on Individual {
          id
          firstName
          lastName
        }
        ... on LegalEntity {
          id
          companyName
          legalEntityType
        }
      }
      ownersFlatList {
        id
        level
        ownedUboId
        shareSize
        ownershipType
        ubo {
          id
          ownersTotalShareSize
          entity {
            ... on Individual {
              id
              firstName
              lastName
            }
            ... on LegalEntity {
              id
              companyName
              legalEntityType
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetUboOwnersQuery__
 *
 * To run a query within a React component, call `useGetUboOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUboOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUboOwnersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUboOwnersQuery(baseOptions: Apollo.QueryHookOptions<GetUboOwnersQuery, GetUboOwnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUboOwnersQuery, GetUboOwnersQueryVariables>(GetUboOwnersDocument, options);
      }
export function useGetUboOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUboOwnersQuery, GetUboOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUboOwnersQuery, GetUboOwnersQueryVariables>(GetUboOwnersDocument, options);
        }
export function useGetUboOwnersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUboOwnersQuery, GetUboOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUboOwnersQuery, GetUboOwnersQueryVariables>(GetUboOwnersDocument, options);
        }
export type GetUboOwnersQueryHookResult = ReturnType<typeof useGetUboOwnersQuery>;
export type GetUboOwnersLazyQueryHookResult = ReturnType<typeof useGetUboOwnersLazyQuery>;
export type GetUboOwnersSuspenseQueryHookResult = ReturnType<typeof useGetUboOwnersSuspenseQuery>;
export type GetUboOwnersQueryResult = Apollo.QueryResult<GetUboOwnersQuery, GetUboOwnersQueryVariables>;
export const GetUboOwnersDetailsDocument = gql`
    query getUboOwnersDetails($id: ID!) {
  getUboOwners(uboId: $id) {
    id
    ownedUboId
    shareSize
    ownershipType
    ubo {
      entity {
        ... on Individual {
          id
          firstName
          lastName
          email
          phone
          birthday
          isPep
          usReportablePerson
          taxId
          address {
            country
            line1
            additionalDetails
            zip
            city
          }
          documents {
            ... on Document {
              id
              type
              expiration
              createdAt
              firstSide {
                fileName
                mimeType
                size
                url
              }
              secondSide {
                fileName
                mimeType
                size
                url
              }
            }
          }
          nationality
        }
        ... on LegalEntity {
          id
          legalEntityType
          companyName
          address {
            country
            line1
            additionalDetails
            zip
            city
          }
          companyRegistrationId
          companyRegistrationDate
        }
      }
    }
  }
}
    `;

/**
 * __useGetUboOwnersDetailsQuery__
 *
 * To run a query within a React component, call `useGetUboOwnersDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUboOwnersDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUboOwnersDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUboOwnersDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetUboOwnersDetailsQuery, GetUboOwnersDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUboOwnersDetailsQuery, GetUboOwnersDetailsQueryVariables>(GetUboOwnersDetailsDocument, options);
      }
export function useGetUboOwnersDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUboOwnersDetailsQuery, GetUboOwnersDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUboOwnersDetailsQuery, GetUboOwnersDetailsQueryVariables>(GetUboOwnersDetailsDocument, options);
        }
export function useGetUboOwnersDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUboOwnersDetailsQuery, GetUboOwnersDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUboOwnersDetailsQuery, GetUboOwnersDetailsQueryVariables>(GetUboOwnersDetailsDocument, options);
        }
export type GetUboOwnersDetailsQueryHookResult = ReturnType<typeof useGetUboOwnersDetailsQuery>;
export type GetUboOwnersDetailsLazyQueryHookResult = ReturnType<typeof useGetUboOwnersDetailsLazyQuery>;
export type GetUboOwnersDetailsSuspenseQueryHookResult = ReturnType<typeof useGetUboOwnersDetailsSuspenseQuery>;
export type GetUboOwnersDetailsQueryResult = Apollo.QueryResult<GetUboOwnersDetailsQuery, GetUboOwnersDetailsQueryVariables>;
export const GetUboDetailsDocument = gql`
    query getUboDetails($contractUboId: ID!) {
  getContractUbo(contractUboId: $contractUboId) {
    id
    shareSize
    ownershipType
    ubo {
      entity {
        ... on LegalEntity {
          id
          companyName
          legalEntityType
          address {
            country
            line1
            additionalDetails
            zip
            city
          }
          companyRegistrationId
          companyRegistrationDate
        }
        ... on Individual {
          id
          taxId
          firstName
          lastName
          birthday
          nationality
          isPep
          usReportablePerson
          address {
            country
            line1
            additionalDetails
            zip
            city
          }
          documents {
            ... on Document {
              id
              type
              expiration
              createdAt
              firstSide {
                fileName
                mimeType
                size
                url
              }
              secondSide {
                fileName
                mimeType
                size
                url
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetUboDetailsQuery__
 *
 * To run a query within a React component, call `useGetUboDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUboDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUboDetailsQuery({
 *   variables: {
 *      contractUboId: // value for 'contractUboId'
 *   },
 * });
 */
export function useGetUboDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetUboDetailsQuery, GetUboDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUboDetailsQuery, GetUboDetailsQueryVariables>(GetUboDetailsDocument, options);
      }
export function useGetUboDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUboDetailsQuery, GetUboDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUboDetailsQuery, GetUboDetailsQueryVariables>(GetUboDetailsDocument, options);
        }
export function useGetUboDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUboDetailsQuery, GetUboDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUboDetailsQuery, GetUboDetailsQueryVariables>(GetUboDetailsDocument, options);
        }
export type GetUboDetailsQueryHookResult = ReturnType<typeof useGetUboDetailsQuery>;
export type GetUboDetailsLazyQueryHookResult = ReturnType<typeof useGetUboDetailsLazyQuery>;
export type GetUboDetailsSuspenseQueryHookResult = ReturnType<typeof useGetUboDetailsSuspenseQuery>;
export type GetUboDetailsQueryResult = Apollo.QueryResult<GetUboDetailsQuery, GetUboDetailsQueryVariables>;
export const ContractIndividualOwnersDocument = gql`
    query contractIndividualOwners($id: ID!) {
  contract(id: $id) {
    ubos {
      id
      addedFromExistingUbo
      ubo {
        id
        entity {
          ... on Individual {
            id
            firstName
            lastName
            email
            birthday
            address {
              country
              line1
              additionalDetails
              zip
              city
            }
            nationality
            phone
          }
        }
      }
    }
  }
}
    `;

/**
 * __useContractIndividualOwnersQuery__
 *
 * To run a query within a React component, call `useContractIndividualOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractIndividualOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractIndividualOwnersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractIndividualOwnersQuery(baseOptions: Apollo.QueryHookOptions<ContractIndividualOwnersQuery, ContractIndividualOwnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractIndividualOwnersQuery, ContractIndividualOwnersQueryVariables>(ContractIndividualOwnersDocument, options);
      }
export function useContractIndividualOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractIndividualOwnersQuery, ContractIndividualOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractIndividualOwnersQuery, ContractIndividualOwnersQueryVariables>(ContractIndividualOwnersDocument, options);
        }
export function useContractIndividualOwnersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContractIndividualOwnersQuery, ContractIndividualOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractIndividualOwnersQuery, ContractIndividualOwnersQueryVariables>(ContractIndividualOwnersDocument, options);
        }
export type ContractIndividualOwnersQueryHookResult = ReturnType<typeof useContractIndividualOwnersQuery>;
export type ContractIndividualOwnersLazyQueryHookResult = ReturnType<typeof useContractIndividualOwnersLazyQuery>;
export type ContractIndividualOwnersSuspenseQueryHookResult = ReturnType<typeof useContractIndividualOwnersSuspenseQuery>;
export type ContractIndividualOwnersQueryResult = Apollo.QueryResult<ContractIndividualOwnersQuery, ContractIndividualOwnersQueryVariables>;
export const GetVideoVerificationStatusDocument = gql`
    query getVideoVerificationStatus {
  getVideoVerificationStatus
}
    `;

/**
 * __useGetVideoVerificationStatusQuery__
 *
 * To run a query within a React component, call `useGetVideoVerificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoVerificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoVerificationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVideoVerificationStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetVideoVerificationStatusQuery, GetVideoVerificationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoVerificationStatusQuery, GetVideoVerificationStatusQueryVariables>(GetVideoVerificationStatusDocument, options);
      }
export function useGetVideoVerificationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoVerificationStatusQuery, GetVideoVerificationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoVerificationStatusQuery, GetVideoVerificationStatusQueryVariables>(GetVideoVerificationStatusDocument, options);
        }
export function useGetVideoVerificationStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVideoVerificationStatusQuery, GetVideoVerificationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVideoVerificationStatusQuery, GetVideoVerificationStatusQueryVariables>(GetVideoVerificationStatusDocument, options);
        }
export type GetVideoVerificationStatusQueryHookResult = ReturnType<typeof useGetVideoVerificationStatusQuery>;
export type GetVideoVerificationStatusLazyQueryHookResult = ReturnType<typeof useGetVideoVerificationStatusLazyQuery>;
export type GetVideoVerificationStatusSuspenseQueryHookResult = ReturnType<typeof useGetVideoVerificationStatusSuspenseQuery>;
export type GetVideoVerificationStatusQueryResult = Apollo.QueryResult<GetVideoVerificationStatusQuery, GetVideoVerificationStatusQueryVariables>;
export const GetContractUboByUboIdDocument = gql`
    query getContractUboByUboId($contractId: ID!, $uboId: ID!) {
  getContractUboByUboId(contractId: $contractId, uboId: $uboId) {
    id
    shareSize
    ownershipType
    ubo {
      entity {
        ... on LegalEntity {
          id
          companyName
          legalEntityType
          address {
            country
            line1
            additionalDetails
            zip
            city
          }
          companyRegistrationId
          companyRegistrationDate
        }
        ... on Individual {
          id
          firstName
          lastName
          birthday
          nationality
          address {
            country
            line1
            additionalDetails
            zip
            city
          }
          documents {
            ... on Document {
              id
              type
              fileName
              mimeType
              createdAt
              size
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetContractUboByUboIdQuery__
 *
 * To run a query within a React component, call `useGetContractUboByUboIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractUboByUboIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractUboByUboIdQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      uboId: // value for 'uboId'
 *   },
 * });
 */
export function useGetContractUboByUboIdQuery(baseOptions: Apollo.QueryHookOptions<GetContractUboByUboIdQuery, GetContractUboByUboIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractUboByUboIdQuery, GetContractUboByUboIdQueryVariables>(GetContractUboByUboIdDocument, options);
      }
export function useGetContractUboByUboIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractUboByUboIdQuery, GetContractUboByUboIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractUboByUboIdQuery, GetContractUboByUboIdQueryVariables>(GetContractUboByUboIdDocument, options);
        }
export function useGetContractUboByUboIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractUboByUboIdQuery, GetContractUboByUboIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractUboByUboIdQuery, GetContractUboByUboIdQueryVariables>(GetContractUboByUboIdDocument, options);
        }
export type GetContractUboByUboIdQueryHookResult = ReturnType<typeof useGetContractUboByUboIdQuery>;
export type GetContractUboByUboIdLazyQueryHookResult = ReturnType<typeof useGetContractUboByUboIdLazyQuery>;
export type GetContractUboByUboIdSuspenseQueryHookResult = ReturnType<typeof useGetContractUboByUboIdSuspenseQuery>;
export type GetContractUboByUboIdQueryResult = Apollo.QueryResult<GetContractUboByUboIdQuery, GetContractUboByUboIdQueryVariables>;
export const GetUboDocument = gql`
    query getUbo($id: ID!) {
  getUbo(id: $id) {
    id
    entity {
      ... on LegalEntity {
        id
        companyName
        legalEntityType
        address {
          country
          line1
          additionalDetails
          zip
          city
        }
        companyRegistrationId
        companyRegistrationDate
      }
      ... on Individual {
        id
        firstName
        lastName
        birthday
        nationality
        address {
          country
          line1
          additionalDetails
          zip
          city
        }
        documents {
          ... on Document {
            id
            type
            fileName
            mimeType
            createdAt
            size
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetUboQuery__
 *
 * To run a query within a React component, call `useGetUboQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUboQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUboQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUboQuery(baseOptions: Apollo.QueryHookOptions<GetUboQuery, GetUboQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUboQuery, GetUboQueryVariables>(GetUboDocument, options);
      }
export function useGetUboLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUboQuery, GetUboQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUboQuery, GetUboQueryVariables>(GetUboDocument, options);
        }
export function useGetUboSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUboQuery, GetUboQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUboQuery, GetUboQueryVariables>(GetUboDocument, options);
        }
export type GetUboQueryHookResult = ReturnType<typeof useGetUboQuery>;
export type GetUboLazyQueryHookResult = ReturnType<typeof useGetUboLazyQuery>;
export type GetUboSuspenseQueryHookResult = ReturnType<typeof useGetUboSuspenseQuery>;
export type GetUboQueryResult = Apollo.QueryResult<GetUboQuery, GetUboQueryVariables>;
export const GetUboOwnersListDocument = gql`
    query getUboOwnersList($id: ID!) {
  getUboOwners(uboId: $id) {
    id
    shareSize
    ownershipType
    ubo {
      id
    }
  }
}
    `;

/**
 * __useGetUboOwnersListQuery__
 *
 * To run a query within a React component, call `useGetUboOwnersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUboOwnersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUboOwnersListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUboOwnersListQuery(baseOptions: Apollo.QueryHookOptions<GetUboOwnersListQuery, GetUboOwnersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUboOwnersListQuery, GetUboOwnersListQueryVariables>(GetUboOwnersListDocument, options);
      }
export function useGetUboOwnersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUboOwnersListQuery, GetUboOwnersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUboOwnersListQuery, GetUboOwnersListQueryVariables>(GetUboOwnersListDocument, options);
        }
export function useGetUboOwnersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUboOwnersListQuery, GetUboOwnersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUboOwnersListQuery, GetUboOwnersListQueryVariables>(GetUboOwnersListDocument, options);
        }
export type GetUboOwnersListQueryHookResult = ReturnType<typeof useGetUboOwnersListQuery>;
export type GetUboOwnersListLazyQueryHookResult = ReturnType<typeof useGetUboOwnersListLazyQuery>;
export type GetUboOwnersListSuspenseQueryHookResult = ReturnType<typeof useGetUboOwnersListSuspenseQuery>;
export type GetUboOwnersListQueryResult = Apollo.QueryResult<GetUboOwnersListQuery, GetUboOwnersListQueryVariables>;
export const GetActionsDocument = gql`
    query getActions($contractId: ID, $limit: Int, $offset: Int, $orderBy: ActionsOrderBy, $orderDirection: OrderDirection, $pendingFirst: Boolean, $search: String, $status: ActionStatus, $statuses: [ActionStatus], $types: [ActionType]) {
  actions(
    contractId: $contractId
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    orderDirection: $orderDirection
    pendingFirst: $pendingFirst
    search: $search
    status: $status
    statuses: $statuses
    types: $types
  ) {
    ... on BaseAction {
      id
      executedAt
      createdAt
      type
      status
      rejectionReason
      totalSignatureCount
      signedCount
      signatures {
        id
        signedAt
        status
        isMine
        signatory {
          signatoryRight
          person {
            id
            firstName
            lastName
          }
        }
        action {
          ... on BaseAction {
            id
          }
        }
      }
      contract {
        id
        status
        signatoriesCount
        authorizedPersons(limit: 1000) {
          id
          isAuthorizedSignatory
          cannotSignOwnActions
          signatoryRight
          limitedAccessRight
          person {
            id
          }
        }
      }
      ... on BatchPaymentActionType {
        id
        initiatorName
        batchPayment {
          id
          status
          account {
            id
            accountNumber
            alias
            currency
            iban
            swiftBIC
          }
          calculatedValidTotal
          paymentRecords {
            id
            amount
            currency
            beneficiaryName
            beneficiaryAccountId
            bankBic
            priority
            reference
            status
            isValid
            payoutAmount
            payoutCurrency
            useLocalAchPayout
          }
        }
      }
      ... on AddContractAuthorizedPersonRequestAction {
        newAuthorizedPerson {
          id
          isLimitedAccessHolder
          limitedAccessRight
          person {
            fullName
            firstName
            lastName
          }
        }
      }
      ... on DocumentAction {
        id
        type
        document {
          id
          type
          fileDescription
        }
      }
      ... on ContractChangeAction {
        id
        type
        contract {
          id
        }
      }
      ... on TransactionAction {
        id
        type
        executedAt
        createdAt
        status
        transaction {
          ... on BaseTransaction {
            id
            value
            currency
            account {
              id
              alias
            }
          }
          ... on DebitTransaction {
            isLocal
            to {
              name
            }
            isInterContract
          }
        }
        signatures {
          id
          isMine
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
      ... on AccountAction {
        id
        type
        signatures {
          id
          isMine
          action {
            ... on BaseAction {
              id
            }
          }
        }
        account {
          id
          alias
          currency
          accountNumber
        }
      }
      ... on StandingOrderActionType {
        id
        standingOrder {
          id
        }
      }
      ... on TermsAndConditionsSigningAction {
        contractTerm {
          term {
            id
            version
            url
          }
        }
      }
      ... on RefundPaymentRequestAction {
        refundPayment {
          paymentId
          externalId
          amount
          currency
        }
      }
      ... on UpdateSpendingLimitAction {
        spendingLimit {
          interval
          type
          amount
          account {
            iban
            alias
            currency
          }
        }
      }
      ... on DirectDebitAction {
        directDebit {
          id
          status
          creditorId
          mandateId
          account {
            id
            alias
            iban
            currency
          }
          counterpartyDetails {
            name
            bic
            iban
            address {
              line1
              country
            }
          }
          document {
            url
          }
        }
      }
      ... on CardIssueRequestAction {
        cardRequest {
          card {
            type
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetActionsQuery__
 *
 * To run a query within a React component, call `useGetActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      pendingFirst: // value for 'pendingFirst'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      statuses: // value for 'statuses'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetActionsQuery(baseOptions?: Apollo.QueryHookOptions<GetActionsQuery, GetActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionsQuery, GetActionsQueryVariables>(GetActionsDocument, options);
      }
export function useGetActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActionsQuery, GetActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionsQuery, GetActionsQueryVariables>(GetActionsDocument, options);
        }
export function useGetActionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActionsQuery, GetActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionsQuery, GetActionsQueryVariables>(GetActionsDocument, options);
        }
export type GetActionsQueryHookResult = ReturnType<typeof useGetActionsQuery>;
export type GetActionsLazyQueryHookResult = ReturnType<typeof useGetActionsLazyQuery>;
export type GetActionsSuspenseQueryHookResult = ReturnType<typeof useGetActionsSuspenseQuery>;
export type GetActionsQueryResult = Apollo.QueryResult<GetActionsQuery, GetActionsQueryVariables>;
export const GetPendingSpendingLimitActionsDocument = gql`
    query getPendingSpendingLimitActions($contractId: ID) {
  actions(
    contractId: $contractId
    status: pendingSignatures
    types: spendingLimitRequest
  ) {
    ... on SpendingLimitRequestAction {
      id
      spendingLimitRequest {
        id
        card {
          id
          currency
        }
        limits {
          limitType
          amount
        }
        oldLimits {
          limitType
          amount
        }
      }
    }
  }
}
    `;

/**
 * __useGetPendingSpendingLimitActionsQuery__
 *
 * To run a query within a React component, call `useGetPendingSpendingLimitActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingSpendingLimitActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingSpendingLimitActionsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetPendingSpendingLimitActionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingSpendingLimitActionsQuery, GetPendingSpendingLimitActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingSpendingLimitActionsQuery, GetPendingSpendingLimitActionsQueryVariables>(GetPendingSpendingLimitActionsDocument, options);
      }
export function useGetPendingSpendingLimitActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingSpendingLimitActionsQuery, GetPendingSpendingLimitActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingSpendingLimitActionsQuery, GetPendingSpendingLimitActionsQueryVariables>(GetPendingSpendingLimitActionsDocument, options);
        }
export function useGetPendingSpendingLimitActionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPendingSpendingLimitActionsQuery, GetPendingSpendingLimitActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingSpendingLimitActionsQuery, GetPendingSpendingLimitActionsQueryVariables>(GetPendingSpendingLimitActionsDocument, options);
        }
export type GetPendingSpendingLimitActionsQueryHookResult = ReturnType<typeof useGetPendingSpendingLimitActionsQuery>;
export type GetPendingSpendingLimitActionsLazyQueryHookResult = ReturnType<typeof useGetPendingSpendingLimitActionsLazyQuery>;
export type GetPendingSpendingLimitActionsSuspenseQueryHookResult = ReturnType<typeof useGetPendingSpendingLimitActionsSuspenseQuery>;
export type GetPendingSpendingLimitActionsQueryResult = Apollo.QueryResult<GetPendingSpendingLimitActionsQuery, GetPendingSpendingLimitActionsQueryVariables>;
export const GetActionsCountDocument = gql`
    query getActionsCount($contractId: ID, $search: String, $status: ActionStatus, $statuses: [ActionStatus], $types: [ActionType]) {
  actionsCount(
    contractId: $contractId
    search: $search
    status: $status
    statuses: $statuses
    types: $types
  )
}
    `;

/**
 * __useGetActionsCountQuery__
 *
 * To run a query within a React component, call `useGetActionsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionsCountQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      statuses: // value for 'statuses'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetActionsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetActionsCountQuery, GetActionsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionsCountQuery, GetActionsCountQueryVariables>(GetActionsCountDocument, options);
      }
export function useGetActionsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActionsCountQuery, GetActionsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionsCountQuery, GetActionsCountQueryVariables>(GetActionsCountDocument, options);
        }
export function useGetActionsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActionsCountQuery, GetActionsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionsCountQuery, GetActionsCountQueryVariables>(GetActionsCountDocument, options);
        }
export type GetActionsCountQueryHookResult = ReturnType<typeof useGetActionsCountQuery>;
export type GetActionsCountLazyQueryHookResult = ReturnType<typeof useGetActionsCountLazyQuery>;
export type GetActionsCountSuspenseQueryHookResult = ReturnType<typeof useGetActionsCountSuspenseQuery>;
export type GetActionsCountQueryResult = Apollo.QueryResult<GetActionsCountQuery, GetActionsCountQueryVariables>;
export const GetActionDetailsDocument = gql`
    query getActionDetails($id: ID!) {
  action(id: $id) {
    ... on BaseAction {
      id
      type
      status
      rejectionReason
      totalSignatureCount
      signedCount
      signatures {
        id
        status
        isMine
        signedAt
        signatory {
          id
          limitedAccessRight
          signatoryRight
          groupSize
          person {
            id
            firstName
            lastName
          }
        }
        action {
          ... on BaseAction {
            id
          }
        }
      }
      contract {
        id
        signatoriesCount
      }
    }
    ... on DirectDebitBatchRequestActionType {
      id
      initiatorName
      batch {
        id
        status
        account {
          id
          accountNumber
          alias
          currency
          iban
          swiftBIC
        }
        total
        records {
          id
          value
          executionDate
          mandate {
            counterpartyDetails {
              name
              iban
            }
          }
          reference
          status
        }
      }
    }
    ... on CardIssueRequestAction {
      cardRequest {
        id
        limits {
          limitType
          amount
        }
        holder {
          id
          person {
            id
            fullName
          }
        }
        card {
          id
          alias
          limitsWithUsage {
            limitType
            amount
          }
          account {
            id
            currency
          }
          type
          apiDeliveryAddress {
            additionalDetails
            city
            country
            line1
            zip
          }
        }
      }
    }
    ... on AddContractAuthorizedPersonRequestAction {
      newAuthorizedPerson {
        id
        isAuthorizedSignatory
        signatoryRight
        groupSize
        isLimitedAccessHolder
        limitedAccessRight
        person {
          id
          fullName
          firstName
          lastName
        }
      }
    }
    ... on TransactionAction {
      id
      transaction {
        ... on BaseTransaction {
          id
          account {
            id
            alias
          }
          value
          valueDate
          currency
          type
          entryType
          status
          createdAt
          updatedAt
          comment
          isLocal
          isSwift
          executionAction {
            ... on BaseAction {
              id
            }
          }
          executedAt
          executionType
          priority
        }
        ... on CreditTransaction {
          from {
            accountNo
            name
            bankName
            iban
            type
            bankBic
            address {
              line1
              country
              countryDescription
              zip
              city
              additionalDetails
            }
            walletAddress
          }
        }
        ... on DebitTransaction {
          to {
            accountNo
            name
            bankName
            iban
            type
            bankBic
            address {
              line1
              country
              countryDescription
              zip
              city
              additionalDetails
            }
            walletAddress
          }
        }
      }
    }
    ... on DocumentAction {
      document {
        id
        type
        fileDescription
        url
      }
    }
    ... on AccountAction {
      account {
        id
        iban
        name
        isVirtual
        createdAt
        currency
        virtualDetails {
          entityType
          companyRegistrationNumber
          companyRegistrationDate
          name
          dateOfBirth
          nationality
          registeredAddress {
            line1
            city
            zip
            country
            additionalDetails
          }
        }
      }
      alternativeAccountDetails {
        accountNo
        address {
          additionalDetails
          city
          country
          line1
          region
          zip
        }
        bankBic
        bankBranchId
        bankBranchName
        bankClearingMemberId
        bankName
        iban
        name
        phone
        taxId
        type
      }
    }
    ... on SpendingLimitRequestAction {
      id
      type
      status
      spendingLimitRequest {
        id
        card {
          id
          alias
          apiMaskedCardNumber
          cardHolder {
            person {
              id
              firstName
              lastName
            }
          }
          limitsWithUsage {
            limitType
            amount
          }
          account {
            id
            currency
          }
        }
        limits {
          limitType
          amount
        }
        oldLimits {
          limitType
          amount
        }
      }
    }
    ... on ContractChangeAction {
      id
      type
      status
      contract {
        owner {
          ... on LegalEntity {
            id
            companyName
            tradingName
            phone
            website
            address {
              line1
              country
              countryDescription
              zip
              city
              additionalDetails
            }
            correspondenceAddress {
              line1
              country
              countryDescription
              zip
              city
              additionalDetails
            }
          }
        }
      }
      contractChange {
        id
        status
        changeAnswers {
          ... on ContractProfileChangeAnswers {
            companyName
            tradingName
            taxId
            phone
            businessSector
            businessDescription
            websites
            countriesOfOperatingAndConductingBusiness
            transactionalPartners {
              name
              country
            }
            economicProfile {
              sourceOfFunds
              anticipatedAccountActivity
              products
              sourceOfFundsDescription
              inboundSources
              inboundSourcesOther
              estimateInbound
              estimateOutbound
              outboundDestinations
              outboundDestinationsOther
              turnover
              averageInbound
              averageOutbound
            }
            address {
              line1
              country
              countryDescription
              zip
              city
              additionalDetails
            }
            correspondenceAddress {
              line1
              country
              countryDescription
              zip
              city
              additionalDetails
            }
            preAssessment {
              ...CardPayments
              regulatoryInfoName
              regulatoryInfoLicenseNumber
              paymentProviders
              conductingKYC
              conductingClientKYC
              conductPublisherContentMonitoring
              clientsYouWorkWith
              companyAnnualIncome
              incomingMonthlyTurnover
              incomingClients
              outgoingMonthlyTurnover
              outgoingClients
              currencyAndVolume
              contactPersonFullName
              contactPersonEmail
              contactPersonPhoneNumber
              countryOfTaxResidence
              licenseRequired
              licenseCountry
              uboResidencies
              businessRelationshipWithCompany
              businessRelationshipWithCompanyExplanation
              partnersIncoming {
                name
                country
                bankCountry
                businessSector
                paymentPurpose
                paymentPurposeOther
                website
              }
              partnersOutgoing {
                name
                country
                bankCountry
                businessSector
                paymentPurpose
                paymentPurposeOther
                website
              }
            }
          }
        }
        oldMeta {
          ... on ContractProfileChangeAnswers {
            companyName
            companyType
            tradingName
            legalEntityType
            companyRegistrationId
            phone
            businessSector
            businessDescription
            countriesOfOperatingAndConductingBusiness
            websites
            address {
              line1
              zip
              city
              region
              additionalDetails
              country
            }
            taxId
            correspondenceAddress {
              line1
              zip
              city
              region
              additionalDetails
              country
              countryDescription
            }
            transactionalPartners {
              name
              country
            }
            economicProfile {
              sourceOfFunds
              anticipatedAccountActivity
              products
              sourceOfFundsDescription
              inboundSources
              inboundSourcesOther
              estimateInbound
              estimateOutbound
              outboundDestinations
              outboundDestinationsOther
              turnover
              averageInbound
              averageOutbound
            }
            preAssessment {
              ...CardPayments
              regulatoryInfoName
              regulatoryInfoLicenseNumber
              paymentProviders
              conductingKYC
              conductingClientKYC
              conductPublisherContentMonitoring
              clientsYouWorkWith
              companyAnnualIncome
              incomingMonthlyTurnover
              incomingClients
              outgoingMonthlyTurnover
              outgoingClients
              currencyAndVolume
              contactPersonFullName
              contactPersonEmail
              contactPersonPhoneNumber
              countryOfTaxResidence
              licenseRequired
              licenseCountry
              uboResidencies
              businessRelationshipWithCompany
              businessRelationshipWithCompanyExplanation
              partnersIncoming {
                name
                country
                bankCountry
                businessSector
                paymentPurpose
                paymentPurposeOther
                website
              }
              partnersOutgoing {
                name
                country
                bankCountry
                businessSector
                paymentPurpose
                paymentPurposeOther
                website
              }
            }
          }
        }
      }
    }
    ... on BatchPaymentActionType {
      id
      initiatorName
      batchPayment {
        id
        status
        account {
          id
          accountNumber
          alias
          currency
          iban
          swiftBIC
        }
        calculatedValidTotal
      }
    }
    ... on VibanNameMismatchAction {
      id
      amount
      currency
      incomingBeneficiaryName
      reference
      beneficiaryNameOnFile
      reference
      accountInfo {
        vban
        currency
      }
      senderInfo {
        accountNo
        iban
        name
        bankName
        bankBic
      }
    }
    ... on ContractAuthorizedPersonDeactivationAction {
      deactivatedAuthorizedPerson {
        signatoryRight
        isAuthorizedSignatory
        limitedAccessRight
        isLimitedAccessHolder
        id
        person {
          id
          fullName
        }
      }
    }
    ... on StandingOrderActionType {
      standingOrder {
        template {
          beneficiary {
            accountNo
            name
            iban
            type
            bankBic
            address {
              line1
              country
              countryDescription
              zip
              city
              additionalDetails
            }
          }
          useLocalPay
          comments
        }
        id
        cronDescription
        createdAt
        nextExecutionAt
        amount
        payoutAmount
        payoutCurrency
        account {
          currency
        }
      }
    }
    ... on TermsAndConditionsSigningAction {
      contractTerm {
        term {
          id
          version
          url
        }
      }
    }
    ... on RefundPaymentRequestAction {
      refundPayment {
        paymentId
        externalId
        amount
        currency
      }
    }
    ... on UpdateSpendingLimitAction {
      initiatorName
      spendingLimit {
        interval
        type
        amount
        usedAmount
        oldLimit
        createdAt
        account {
          iban
          alias
          currency
        }
      }
    }
    ... on DirectDebitAction {
      directDebit {
        id
        status
        type
        creditorId
        mandateId
        account {
          id
          alias
          iban
          currency
        }
        counterpartyDetails {
          name
          bic
          iban
          address {
            line1
            country
          }
        }
        document {
          id
          type
          expiration
          createdAt
          firstSide {
            fileName
            mimeType
            size
            url
          }
        }
        rejectionAction {
          ... on BaseAction {
            id
            initiatorName
            signedCount
            status
            signatures {
              id
              isMine
              status
              signedAt
              signatory {
                signatoryRight
                person {
                  id
                  firstName
                  lastName
                }
              }
              action {
                ... on BaseAction {
                  id
                }
              }
            }
          }
        }
        approvalAction {
          ... on BaseAction {
            id
            initiatorName
            signedCount
            status
            signatures {
              id
              isMine
              status
              signedAt
              signatory {
                signatoryRight
                person {
                  id
                  firstName
                  lastName
                }
              }
              action {
                ... on BaseAction {
                  id
                }
              }
            }
          }
        }
        createdAt
      }
    }
    ... on WalletAction {
      wallet {
        address
        network
        alias
        baseCurrency
        supportedCoins {
          name
          chain
        }
      }
    }
  }
}
    ${CardPaymentsFragmentDoc}`;

/**
 * __useGetActionDetailsQuery__
 *
 * To run a query within a React component, call `useGetActionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetActionDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetActionDetailsQuery, GetActionDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionDetailsQuery, GetActionDetailsQueryVariables>(GetActionDetailsDocument, options);
      }
export function useGetActionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActionDetailsQuery, GetActionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionDetailsQuery, GetActionDetailsQueryVariables>(GetActionDetailsDocument, options);
        }
export function useGetActionDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActionDetailsQuery, GetActionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionDetailsQuery, GetActionDetailsQueryVariables>(GetActionDetailsDocument, options);
        }
export type GetActionDetailsQueryHookResult = ReturnType<typeof useGetActionDetailsQuery>;
export type GetActionDetailsLazyQueryHookResult = ReturnType<typeof useGetActionDetailsLazyQuery>;
export type GetActionDetailsSuspenseQueryHookResult = ReturnType<typeof useGetActionDetailsSuspenseQuery>;
export type GetActionDetailsQueryResult = Apollo.QueryResult<GetActionDetailsQuery, GetActionDetailsQueryVariables>;
export const GetActionSignatureDocument = gql`
    query getActionSignature($id: ID!) {
  actionSignatureRequest(id: $id) {
    id
    status
    signatory {
      id
      limitedAccessRight
      signatoryRight
      groupSize
      person {
        id
        firstName
        lastName
      }
    }
    action {
      ... on BaseAction {
        id
        type
        status
        rejectionReason
        totalSignatureCount
        signedCount
        signatures {
          id
          status
          isMine
          signedAt
          signatory {
            id
            signatoryRight
            person {
              id
              firstName
              lastName
            }
          }
          action {
            ... on BaseAction {
              id
            }
          }
        }
        contract {
          id
          signatoriesCount
        }
      }
      ... on CardIssueRequestAction {
        cardRequest {
          id
          holder {
            id
            person {
              id
              fullName
            }
          }
          card {
            id
            alias
            limitsWithUsage {
              limitType
              amount
            }
            account {
              currency
            }
          }
        }
      }
      ... on AddContractAuthorizedPersonRequestAction {
        newAuthorizedPerson {
          id
          isAuthorizedSignatory
          signatoryRight
          groupSize
          isLimitedAccessHolder
          limitedAccessRight
          person {
            id
            fullName
            firstName
            lastName
          }
        }
      }
      ... on TransactionAction {
        id
        transaction {
          ... on BaseTransaction {
            id
            account {
              id
              alias
            }
            value
            valueDate
            currency
            type
            entryType
            status
            createdAt
            updatedAt
            comment
            isLocal
            isSwift
            executionAction {
              ... on BaseAction {
                id
              }
            }
            executedAt
            executionType
            priority
          }
          ... on CreditTransaction {
            from {
              accountNo
              name
              bankName
              iban
              type
              bankBic
              address {
                line1
                country
                countryDescription
                zip
                city
                additionalDetails
              }
              walletAddress
            }
          }
          ... on DebitTransaction {
            to {
              accountNo
              name
              bankName
              iban
              type
              bankBic
              address {
                line1
                country
                countryDescription
                zip
                city
                additionalDetails
              }
              walletAddress
            }
          }
        }
      }
      ... on DocumentAction {
        document {
          type
          fileDescription
          url
        }
      }
      ... on AccountAction {
        account {
          id
          iban
          name
          isVirtual
          currency
          virtualDetails {
            dateOfBirth
            nationality
            registeredAddress {
              line1
              city
              zip
              country
              additionalDetails
            }
          }
        }
      }
      ... on SpendingLimitRequestAction {
        id
        type
        status
        spendingLimitRequest {
          id
          card {
            id
            alias
            apiMaskedCardNumber
            cardHolder {
              person {
                id
                firstName
                lastName
              }
            }
            limitsWithUsage {
              limitType
              amount
            }
            account {
              currency
            }
          }
          limits {
            limitType
            amount
          }
        }
      }
      ... on ContractChangeAction {
        id
        type
        status
        contract {
          owner {
            ... on LegalEntity {
              companyName
              tradingName
              phone
              website
              address {
                line1
                country
                countryDescription
                zip
                city
                additionalDetails
              }
              correspondenceAddress {
                line1
                country
                countryDescription
                zip
                city
                additionalDetails
              }
            }
          }
        }
        contractChange {
          id
          status
          changeAnswers {
            ... on ContractProfileChangeAnswers {
              companyName
              tradingName
              taxId
              phone
              website
              address {
                line1
                country
                countryDescription
                zip
                city
                additionalDetails
              }
              correspondenceAddress {
                line1
                country
                countryDescription
                zip
                city
                additionalDetails
              }
            }
          }
          oldMeta {
            ... on ContractProfileChangeAnswers {
              companyName
              companyType
              legalEntityType
              companyRegistrationId
              phone
              businessSector
              businessDescription
              countriesOfOperatingAndConductingBusiness
              website
              address {
                zip
                city
                region
                additionalDetails
                country
              }
              taxId
              correspondenceAddress {
                zip
                city
                region
                additionalDetails
                country
              }
              transactionalPartners {
                name
                country
              }
              economicProfile {
                sourceOfFunds
                sourceOfFundsDescription
                currencies
                turnover
                averageInbound
                averageOutbound
                estimateInbound
                estimateOutbound
                inboundSources
                estimateOutbound
                inboundSources
                inboundSourcesOther
                outboundDestinations
                outboundDestinationsOther
              }
              tradingName
            }
          }
        }
      }
      ... on BatchPaymentActionType {
        id
        initiatorName
        batchPayment {
          id
          status
          account {
            id
            accountNumber
            alias
            currency
            iban
            swiftBIC
          }
          calculatedValidTotal
          paymentRecords {
            id
            amount
            currency
            beneficiaryName
            beneficiaryAccountId
            bankBic
            priority
            reference
            status
            isValid
            payoutAmount
            payoutCurrency
            useLocalAchPayout
          }
        }
      }
      ... on VibanNameMismatchAction {
        id
        amount
        currency
        incomingBeneficiaryName
        reference
        beneficiaryNameOnFile
        reference
        accountInfo {
          vban
          currency
        }
        senderInfo {
          accountNo
          iban
          name
          bankName
          bankBic
        }
      }
    }
  }
}
    `;

/**
 * __useGetActionSignatureQuery__
 *
 * To run a query within a React component, call `useGetActionSignatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionSignatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionSignatureQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetActionSignatureQuery(baseOptions: Apollo.QueryHookOptions<GetActionSignatureQuery, GetActionSignatureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionSignatureQuery, GetActionSignatureQueryVariables>(GetActionSignatureDocument, options);
      }
export function useGetActionSignatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActionSignatureQuery, GetActionSignatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionSignatureQuery, GetActionSignatureQueryVariables>(GetActionSignatureDocument, options);
        }
export function useGetActionSignatureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActionSignatureQuery, GetActionSignatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionSignatureQuery, GetActionSignatureQueryVariables>(GetActionSignatureDocument, options);
        }
export type GetActionSignatureQueryHookResult = ReturnType<typeof useGetActionSignatureQuery>;
export type GetActionSignatureLazyQueryHookResult = ReturnType<typeof useGetActionSignatureLazyQuery>;
export type GetActionSignatureSuspenseQueryHookResult = ReturnType<typeof useGetActionSignatureSuspenseQuery>;
export type GetActionSignatureQueryResult = Apollo.QueryResult<GetActionSignatureQuery, GetActionSignatureQueryVariables>;
export const GetContractSignRequestsDocument = gql`
    query getContractSignRequests($contractId: ID, $statuses: [ActionSignatureStatus], $limit: Int, $offset: Int, $orderBy: ActionSignatureRequestsOrderBy, $orderDirection: OrderDirection, $pendingFirst: Boolean) {
  actionSignatureRequests(
    contractId: $contractId
    statuses: $statuses
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    orderDirection: $orderDirection
    pendingFirst: $pendingFirst
    mineOnly: true
  ) {
    id
    status
    createdAt
    action {
      ... on BaseAction {
        id
        executedAt
        type
        status
        rejectionReason
        totalSignatureCount
        signedCount
        signatures {
          id
          signedAt
          status
          isMine
          signatory {
            signatoryRight
            person {
              id
              firstName
              lastName
            }
          }
          action {
            ... on BaseAction {
              id
            }
          }
        }
        contract {
          id
          status
          signatoriesCount
          authorizedPersons(limit: 1000) {
            id
            isAuthorizedSignatory
            cannotSignOwnActions
            signatoryRight
            limitedAccessRight
            person {
              id
            }
          }
        }
        ... on BatchPaymentActionType {
          id
          initiatorName
          batchPayment {
            id
            status
            account {
              id
              accountNumber
              alias
              currency
              iban
              swiftBIC
            }
            calculatedValidTotal
            paymentRecords {
              id
              amount
              currency
              beneficiaryName
              beneficiaryAccountId
              bankBic
              priority
              reference
              status
              isValid
              payoutAmount
              payoutCurrency
              useLocalAchPayout
            }
          }
        }
        ... on AddContractAuthorizedPersonRequestAction {
          newAuthorizedPerson {
            id
            isLimitedAccessHolder
            limitedAccessRight
            person {
              fullName
              firstName
              lastName
            }
          }
        }
        ... on DocumentAction {
          id
          type
          document {
            id
            type
            fileDescription
          }
        }
        ... on ContractChangeAction {
          id
          type
          contract {
            id
          }
          contractChange {
            id
            status
            changeAnswers {
              ... on ContractProfileChangeAnswers {
                taxId
              }
            }
          }
        }
        ... on TransactionAction {
          id
          type
          executedAt
          createdAt
          status
          transaction {
            ... on BaseTransaction {
              id
              value
              currency
              account {
                id
                alias
                balance {
                  indicative
                  available
                  guaranteed
                }
              }
            }
            ... on DebitTransaction {
              isLocal
              to {
                name
              }
              isInterContract
            }
          }
          signatures {
            id
            isMine
            action {
              ... on BaseAction {
                id
              }
            }
          }
        }
        ... on AccountAction {
          id
          type
          account {
            id
            alias
            currency
            accountNumber
            balance {
              available
              indicative
              guaranteed
            }
          }
        }
        ... on WalletAction {
          id
          wallet {
            address
            network
            alias
            baseCurrency
            supportedCoins {
              name
              chain
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetContractSignRequestsQuery__
 *
 * To run a query within a React component, call `useGetContractSignRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractSignRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractSignRequestsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      statuses: // value for 'statuses'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      pendingFirst: // value for 'pendingFirst'
 *   },
 * });
 */
export function useGetContractSignRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetContractSignRequestsQuery, GetContractSignRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractSignRequestsQuery, GetContractSignRequestsQueryVariables>(GetContractSignRequestsDocument, options);
      }
export function useGetContractSignRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractSignRequestsQuery, GetContractSignRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractSignRequestsQuery, GetContractSignRequestsQueryVariables>(GetContractSignRequestsDocument, options);
        }
export function useGetContractSignRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractSignRequestsQuery, GetContractSignRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractSignRequestsQuery, GetContractSignRequestsQueryVariables>(GetContractSignRequestsDocument, options);
        }
export type GetContractSignRequestsQueryHookResult = ReturnType<typeof useGetContractSignRequestsQuery>;
export type GetContractSignRequestsLazyQueryHookResult = ReturnType<typeof useGetContractSignRequestsLazyQuery>;
export type GetContractSignRequestsSuspenseQueryHookResult = ReturnType<typeof useGetContractSignRequestsSuspenseQuery>;
export type GetContractSignRequestsQueryResult = Apollo.QueryResult<GetContractSignRequestsQuery, GetContractSignRequestsQueryVariables>;
export const ActionSignatureRequestsCountDocument = gql`
    query actionSignatureRequestsCount($contractId: ID, $statuses: [ActionSignatureStatus]) {
  actionSignatureRequestsCount(
    contractId: $contractId
    statuses: $statuses
    mineOnly: true
  )
}
    `;

/**
 * __useActionSignatureRequestsCountQuery__
 *
 * To run a query within a React component, call `useActionSignatureRequestsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionSignatureRequestsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionSignatureRequestsCountQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useActionSignatureRequestsCountQuery(baseOptions?: Apollo.QueryHookOptions<ActionSignatureRequestsCountQuery, ActionSignatureRequestsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionSignatureRequestsCountQuery, ActionSignatureRequestsCountQueryVariables>(ActionSignatureRequestsCountDocument, options);
      }
export function useActionSignatureRequestsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionSignatureRequestsCountQuery, ActionSignatureRequestsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionSignatureRequestsCountQuery, ActionSignatureRequestsCountQueryVariables>(ActionSignatureRequestsCountDocument, options);
        }
export function useActionSignatureRequestsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActionSignatureRequestsCountQuery, ActionSignatureRequestsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActionSignatureRequestsCountQuery, ActionSignatureRequestsCountQueryVariables>(ActionSignatureRequestsCountDocument, options);
        }
export type ActionSignatureRequestsCountQueryHookResult = ReturnType<typeof useActionSignatureRequestsCountQuery>;
export type ActionSignatureRequestsCountLazyQueryHookResult = ReturnType<typeof useActionSignatureRequestsCountLazyQuery>;
export type ActionSignatureRequestsCountSuspenseQueryHookResult = ReturnType<typeof useActionSignatureRequestsCountSuspenseQuery>;
export type ActionSignatureRequestsCountQueryResult = Apollo.QueryResult<ActionSignatureRequestsCountQuery, ActionSignatureRequestsCountQueryVariables>;
export const GetAccountsDocument = gql`
    query getAccounts($contractId: ID, $orderBy: OrderBy, $parentId: ID, $search: String, $statuses: [AccountStatus], $orderDirection: OrderDirection, $limit: Int, $offset: Int, $currencies: [Currency], $entityType: UboType, $pinned: Boolean, $types: [AccountType], $fundsType: FundsType) {
  accounts(
    contractId: $contractId
    orderBy: $orderBy
    parentId: $parentId
    statuses: $statuses
    search: $search
    orderDirection: $orderDirection
    limit: $limit
    offset: $offset
    currencies: $currencies
    entityType: $entityType
    notStatuses: [rejected]
    pinned: $pinned
    types: $types
    fundsType: $fundsType
  ) {
    id
    iban
    accountNumber
    showFullInfo
    oursChargesSupportedCurrencies
    externalOutboundDisabled
    cardTopupSupported
    alias
    type
    status
    standingOrdersCount
    createdAt
    iban
    fundsType
    isSafeGuarding
    balance {
      indicative
      available
      guaranteed
    }
    currency
    contract {
      id
      authorizedPersons(limit: 1000) {
        id
        isAuthorizedSignatory
        cannotSignOwnActions
        signatoryRight
        limitedAccessRight
        person {
          id
        }
      }
    }
    swiftBIC
    nextRecalculationDate
    virtualDetails {
      entityType
      companyRegistrationNumber
      dateOfBirth
      nationality
      name
      companyRegistrationDate
      registeredAddress {
        line1
        city
        zip
        region
        country
        additionalDetails
        countryDescription
      }
    }
    executionAction {
      ... on BaseAction {
        id
        status
        signatures {
          status
          isMine
          signatory {
            person {
              id
            }
          }
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
    }
    isPinned
    qrrSupported
    cryptoTopupSupported
    cryptoWithdrawalSupported
  }
  wallets(contractId: $contractId) {
    id
    address
    alias
    network
    status
    linkedBy {
      id
    }
    supportedCoins {
      name
      chain
    }
    balance
    baseCurrency
    contract {
      id
      authorizedPersons(limit: 1000) {
        id
        isAuthorizedSignatory
        cannotSignOwnActions
        signatoryRight
        limitedAccessRight
        person {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountsQuery__
 *
 * To run a query within a React component, call `useGetAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      orderBy: // value for 'orderBy'
 *      parentId: // value for 'parentId'
 *      search: // value for 'search'
 *      statuses: // value for 'statuses'
 *      orderDirection: // value for 'orderDirection'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      currencies: // value for 'currencies'
 *      entityType: // value for 'entityType'
 *      pinned: // value for 'pinned'
 *      types: // value for 'types'
 *      fundsType: // value for 'fundsType'
 *   },
 * });
 */
export function useGetAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
      }
export function useGetAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
export type GetAccountsQueryHookResult = ReturnType<typeof useGetAccountsQuery>;
export type GetAccountsLazyQueryHookResult = ReturnType<typeof useGetAccountsLazyQuery>;
export type GetAccountsSuspenseQueryHookResult = ReturnType<typeof useGetAccountsSuspenseQuery>;
export type GetAccountsQueryResult = Apollo.QueryResult<GetAccountsQuery, GetAccountsQueryVariables>;
export const GetAccountsCountDocument = gql`
    query getAccountsCount($parentId: ID, $contractId: ID, $currencies: [Currency], $search: String, $statuses: [AccountStatus], $entityType: UboType, $fundsType: FundsType) {
  accountsCount(
    parentId: $parentId
    contractId: $contractId
    currencies: $currencies
    statuses: $statuses
    notStatuses: [rejected]
    search: $search
    entityType: $entityType
    fundsType: $fundsType
  )
}
    `;

/**
 * __useGetAccountsCountQuery__
 *
 * To run a query within a React component, call `useGetAccountsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsCountQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      contractId: // value for 'contractId'
 *      currencies: // value for 'currencies'
 *      search: // value for 'search'
 *      statuses: // value for 'statuses'
 *      entityType: // value for 'entityType'
 *      fundsType: // value for 'fundsType'
 *   },
 * });
 */
export function useGetAccountsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountsCountQuery, GetAccountsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountsCountQuery, GetAccountsCountQueryVariables>(GetAccountsCountDocument, options);
      }
export function useGetAccountsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsCountQuery, GetAccountsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountsCountQuery, GetAccountsCountQueryVariables>(GetAccountsCountDocument, options);
        }
export function useGetAccountsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountsCountQuery, GetAccountsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountsCountQuery, GetAccountsCountQueryVariables>(GetAccountsCountDocument, options);
        }
export type GetAccountsCountQueryHookResult = ReturnType<typeof useGetAccountsCountQuery>;
export type GetAccountsCountLazyQueryHookResult = ReturnType<typeof useGetAccountsCountLazyQuery>;
export type GetAccountsCountSuspenseQueryHookResult = ReturnType<typeof useGetAccountsCountSuspenseQuery>;
export type GetAccountsCountQueryResult = Apollo.QueryResult<GetAccountsCountQuery, GetAccountsCountQueryVariables>;
export const GetContractActiveAccountsCountDocument = gql`
    query getContractActiveAccountsCount($contractId: ID) {
  accountsCount(contractId: $contractId, statuses: [active])
}
    `;

/**
 * __useGetContractActiveAccountsCountQuery__
 *
 * To run a query within a React component, call `useGetContractActiveAccountsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractActiveAccountsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractActiveAccountsCountQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetContractActiveAccountsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetContractActiveAccountsCountQuery, GetContractActiveAccountsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractActiveAccountsCountQuery, GetContractActiveAccountsCountQueryVariables>(GetContractActiveAccountsCountDocument, options);
      }
export function useGetContractActiveAccountsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractActiveAccountsCountQuery, GetContractActiveAccountsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractActiveAccountsCountQuery, GetContractActiveAccountsCountQueryVariables>(GetContractActiveAccountsCountDocument, options);
        }
export function useGetContractActiveAccountsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractActiveAccountsCountQuery, GetContractActiveAccountsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractActiveAccountsCountQuery, GetContractActiveAccountsCountQueryVariables>(GetContractActiveAccountsCountDocument, options);
        }
export type GetContractActiveAccountsCountQueryHookResult = ReturnType<typeof useGetContractActiveAccountsCountQuery>;
export type GetContractActiveAccountsCountLazyQueryHookResult = ReturnType<typeof useGetContractActiveAccountsCountLazyQuery>;
export type GetContractActiveAccountsCountSuspenseQueryHookResult = ReturnType<typeof useGetContractActiveAccountsCountSuspenseQuery>;
export type GetContractActiveAccountsCountQueryResult = Apollo.QueryResult<GetContractActiveAccountsCountQuery, GetContractActiveAccountsCountQueryVariables>;
export const GetAccVbansDocument = gql`
    query getAccVbans($contractId: ID, $parentId: ID, $search: String, $statuses: [AccountStatus]) {
  accounts(
    contractId: $contractId
    parentId: $parentId
    statuses: $statuses
    search: $search
  ) {
    isVirtual
    iban
    id
    status
  }
}
    `;

/**
 * __useGetAccVbansQuery__
 *
 * To run a query within a React component, call `useGetAccVbansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccVbansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccVbansQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      parentId: // value for 'parentId'
 *      search: // value for 'search'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetAccVbansQuery(baseOptions?: Apollo.QueryHookOptions<GetAccVbansQuery, GetAccVbansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccVbansQuery, GetAccVbansQueryVariables>(GetAccVbansDocument, options);
      }
export function useGetAccVbansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccVbansQuery, GetAccVbansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccVbansQuery, GetAccVbansQueryVariables>(GetAccVbansDocument, options);
        }
export function useGetAccVbansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccVbansQuery, GetAccVbansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccVbansQuery, GetAccVbansQueryVariables>(GetAccVbansDocument, options);
        }
export type GetAccVbansQueryHookResult = ReturnType<typeof useGetAccVbansQuery>;
export type GetAccVbansLazyQueryHookResult = ReturnType<typeof useGetAccVbansLazyQuery>;
export type GetAccVbansSuspenseQueryHookResult = ReturnType<typeof useGetAccVbansSuspenseQuery>;
export type GetAccVbansQueryResult = Apollo.QueryResult<GetAccVbansQuery, GetAccVbansQueryVariables>;
export const GetContractAccountsDocument = gql`
    query getContractAccounts($contractId: ID, $statuses: [AccountStatus], $isVirtual: Boolean, $search: String, $currencies: [Currency], $types: [AccountType], $fundsType: FundsType) {
  accounts(
    limit: 100
    contractId: $contractId
    statuses: $statuses
    isVirtual: $isVirtual
    search: $search
    currencies: $currencies
    types: $types
    fundsType: $fundsType
  ) {
    id
    currency
    alias
    status
    iban
    swiftBIC
    fundsType
    standingOrdersCount
    balance {
      indicative
      available
      guaranteed
    }
    externalOutboundDisabled
    cardTopupSupported
    oursChargesSupportedCurrencies
    parentId
    isSafeGuarding
    nextRecalculationDate
    guaranteedAccountBeneficiary {
      id
      currency
      iban
      accountNo
    }
    qrrSupported
    cryptoTopupSupported
    cryptoWithdrawalSupported
  }
  wallets(contractId: $contractId) {
    id
    alias
    address
    network
    status
    linkedBy {
      id
    }
    supportedCoins {
      name
      chain
    }
    incomingTransferFee {
      isPercentage
      amountPercentage
      minAmount
      fixedAmount
      currency
      feeCurrency
    }
    outgoingTransferFee {
      isPercentage
      amountPercentage
      minAmount
      fixedAmount
      currency
      feeCurrency
    }
  }
}
    `;

/**
 * __useGetContractAccountsQuery__
 *
 * To run a query within a React component, call `useGetContractAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractAccountsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      statuses: // value for 'statuses'
 *      isVirtual: // value for 'isVirtual'
 *      search: // value for 'search'
 *      currencies: // value for 'currencies'
 *      types: // value for 'types'
 *      fundsType: // value for 'fundsType'
 *   },
 * });
 */
export function useGetContractAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetContractAccountsQuery, GetContractAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractAccountsQuery, GetContractAccountsQueryVariables>(GetContractAccountsDocument, options);
      }
export function useGetContractAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractAccountsQuery, GetContractAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractAccountsQuery, GetContractAccountsQueryVariables>(GetContractAccountsDocument, options);
        }
export function useGetContractAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractAccountsQuery, GetContractAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractAccountsQuery, GetContractAccountsQueryVariables>(GetContractAccountsDocument, options);
        }
export type GetContractAccountsQueryHookResult = ReturnType<typeof useGetContractAccountsQuery>;
export type GetContractAccountsLazyQueryHookResult = ReturnType<typeof useGetContractAccountsLazyQuery>;
export type GetContractAccountsSuspenseQueryHookResult = ReturnType<typeof useGetContractAccountsSuspenseQuery>;
export type GetContractAccountsQueryResult = Apollo.QueryResult<GetContractAccountsQuery, GetContractAccountsQueryVariables>;
export const GetAccountDocument = gql`
    query getAccount($id: ID!) {
  account(id: $id) {
    id
    iban
    accountNumber
    showFullInfo
    oursChargesSupportedCurrencies
    externalOutboundDisabled
    cardTopupSupported
    standingOrdersCount
    alias
    type
    status
    balance {
      indicative
      available
      guaranteed
    }
    currency
    contract {
      id
      authorizedPersons(limit: 1000) {
        id
        isAuthorizedSignatory
        cannotSignOwnActions
        signatoryRight
        limitedAccessRight
        person {
          id
        }
      }
    }
    swiftBIC
    fundsType
    nextRecalculationDate
    isSafeGuarding
    qrrSupported
    cryptoTopupSupported
    cryptoWithdrawalSupported
  }
}
    `;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export function useGetAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountSuspenseQueryHookResult = ReturnType<typeof useGetAccountSuspenseQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const GetContractTransactionsCountDocument = gql`
    query getContractTransactionsCount($contractId: ID!, $accountId: ID, $cardId: ID, $cardFilter: TransactionCardFilter, $search: String, $types: [TransactionType], $notTypes: [TransactionType], $entryTypes: [TransactionEntryType], $statuses: [TransactionStatus], $notStatuses: [TransactionStatus], $createdAtFrom: DateTime, $createdAtTo: DateTime, $walletId: String, $internalTransferType: InternalTransferType) {
  contractTransactionsCount(
    contractId: $contractId
    accountId: $accountId
    cardId: $cardId
    cardFilter: $cardFilter
    search: $search
    types: $types
    notTypes: $notTypes
    entryTypes: $entryTypes
    statuses: $statuses
    notStatuses: $notStatuses
    createdAtFrom: $createdAtFrom
    createdAtTo: $createdAtTo
    walletId: $walletId
    internalTransferType: $internalTransferType
  )
}
    `;

/**
 * __useGetContractTransactionsCountQuery__
 *
 * To run a query within a React component, call `useGetContractTransactionsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractTransactionsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractTransactionsCountQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      accountId: // value for 'accountId'
 *      cardId: // value for 'cardId'
 *      cardFilter: // value for 'cardFilter'
 *      search: // value for 'search'
 *      types: // value for 'types'
 *      notTypes: // value for 'notTypes'
 *      entryTypes: // value for 'entryTypes'
 *      statuses: // value for 'statuses'
 *      notStatuses: // value for 'notStatuses'
 *      createdAtFrom: // value for 'createdAtFrom'
 *      createdAtTo: // value for 'createdAtTo'
 *      walletId: // value for 'walletId'
 *      internalTransferType: // value for 'internalTransferType'
 *   },
 * });
 */
export function useGetContractTransactionsCountQuery(baseOptions: Apollo.QueryHookOptions<GetContractTransactionsCountQuery, GetContractTransactionsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractTransactionsCountQuery, GetContractTransactionsCountQueryVariables>(GetContractTransactionsCountDocument, options);
      }
export function useGetContractTransactionsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractTransactionsCountQuery, GetContractTransactionsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractTransactionsCountQuery, GetContractTransactionsCountQueryVariables>(GetContractTransactionsCountDocument, options);
        }
export function useGetContractTransactionsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractTransactionsCountQuery, GetContractTransactionsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractTransactionsCountQuery, GetContractTransactionsCountQueryVariables>(GetContractTransactionsCountDocument, options);
        }
export type GetContractTransactionsCountQueryHookResult = ReturnType<typeof useGetContractTransactionsCountQuery>;
export type GetContractTransactionsCountLazyQueryHookResult = ReturnType<typeof useGetContractTransactionsCountLazyQuery>;
export type GetContractTransactionsCountSuspenseQueryHookResult = ReturnType<typeof useGetContractTransactionsCountSuspenseQuery>;
export type GetContractTransactionsCountQueryResult = Apollo.QueryResult<GetContractTransactionsCountQuery, GetContractTransactionsCountQueryVariables>;
export const GetTransactionsDocument = gql`
    query getTransactions($contractId: ID!, $accountId: ID, $cardId: ID, $cardFilter: TransactionCardFilter, $limit: Int, $offset: Int, $orderBy: TransactionOrderBy, $pendingFirst: Boolean, $orderDirection: OrderDirection, $search: String, $types: [TransactionType], $notTypes: [TransactionType], $entryTypes: [TransactionEntryType], $statuses: [TransactionStatus], $notStatuses: [TransactionStatus], $createdAtFrom: DateTime, $createdAtTo: DateTime, $ids: [ID], $valueFrom: Float, $walletId: String, $internalTransferType: InternalTransferType) {
  contractTransactions(
    contractId: $contractId
    accountId: $accountId
    cardId: $cardId
    cardFilter: $cardFilter
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    pendingFirst: $pendingFirst
    orderDirection: $orderDirection
    search: $search
    types: $types
    notTypes: $notTypes
    entryTypes: $entryTypes
    statuses: $statuses
    notStatuses: $notStatuses
    createdAtFrom: $createdAtFrom
    createdAtTo: $createdAtTo
    ids: $ids
    valueFrom: $valueFrom
    walletId: $walletId
    internalTransferType: $internalTransferType
  ) {
    __typename
    ... on CreditTransaction {
      id
      type
      isInterContract
      value
      currency
      entryType
      card {
        id
        apiMaskedCardNumber
      }
      account {
        id
        balance {
          available
          indicative
          guaranteed
        }
        currency
        accountNumber
        alias
        iban
      }
      balanceAfter
      guaranteeEvent {
        currentGuaranteedBalance
      }
      executedAt
      createdAt
      status
      from {
        accountNo
        name
        bankName
        iban
        walletAddress
      }
      directDebitExecution {
        id
      }
    }
    ... on DebitTransaction {
      id
      type
      isInterContract
      value
      payoutValue
      currency
      entryType
      payoutCurrency
      clientReference
      comment
      chargeBearer
      card {
        id
        apiMaskedCardNumber
      }
      account {
        id
        balance {
          available
          indicative
          guaranteed
        }
        currency
        accountNumber
        alias
        fundsType
        iban
      }
      balanceAfter
      guaranteeEvent {
        currentGuaranteedBalance
      }
      executedAt
      createdAt
      status
      to {
        accountNo
        name
        bankName
        iban
        type
        bankBic
        address {
          country
          city
          zip
          line1
        }
        walletAddress
      }
      executionAction {
        ... on TransactionAction {
          id
          signatures {
            id
            isMine
            status
            signedAt
            action {
              ... on BaseAction {
                id
              }
            }
          }
        }
      }
      directDebitExecution {
        id
      }
      standingOrder {
        id
      }
    }
  }
}
    `;

/**
 * __useGetTransactionsQuery__
 *
 * To run a query within a React component, call `useGetTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      accountId: // value for 'accountId'
 *      cardId: // value for 'cardId'
 *      cardFilter: // value for 'cardFilter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      pendingFirst: // value for 'pendingFirst'
 *      orderDirection: // value for 'orderDirection'
 *      search: // value for 'search'
 *      types: // value for 'types'
 *      notTypes: // value for 'notTypes'
 *      entryTypes: // value for 'entryTypes'
 *      statuses: // value for 'statuses'
 *      notStatuses: // value for 'notStatuses'
 *      createdAtFrom: // value for 'createdAtFrom'
 *      createdAtTo: // value for 'createdAtTo'
 *      ids: // value for 'ids'
 *      valueFrom: // value for 'valueFrom'
 *      walletId: // value for 'walletId'
 *      internalTransferType: // value for 'internalTransferType'
 *   },
 * });
 */
export function useGetTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
      }
export function useGetTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
        }
export function useGetTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
        }
export type GetTransactionsQueryHookResult = ReturnType<typeof useGetTransactionsQuery>;
export type GetTransactionsLazyQueryHookResult = ReturnType<typeof useGetTransactionsLazyQuery>;
export type GetTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetTransactionsSuspenseQuery>;
export type GetTransactionsQueryResult = Apollo.QueryResult<GetTransactionsQuery, GetTransactionsQueryVariables>;
export const PaymentRecipientsDocument = gql`
    query paymentRecipients($contractId: ID!, $search: String) {
  contractPaymentRecipients(contractId: $contractId, search: $search) {
    id
    type
    firstName
    lastName
    companyName
    iban
    accountNo
    currency
    bankBic
    bankBranchId
    bankClearingMemberId
    accountNoType
    taxId
    phone
    address {
      country
      city
      zip
      line1
    }
    alias
    commentTemplate
    pan
    kyc {
      individual {
        dateOfBirth
        nationality
        idType
        idNumber
        idIssueDate
        idExpiryDate
        idIssueCountry
      }
      company {
        registrationNumber
        registrationType
        registrationDate
      }
    }
    bankCountry
  }
}
    `;

/**
 * __usePaymentRecipientsQuery__
 *
 * To run a query within a React component, call `usePaymentRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentRecipientsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePaymentRecipientsQuery(baseOptions: Apollo.QueryHookOptions<PaymentRecipientsQuery, PaymentRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentRecipientsQuery, PaymentRecipientsQueryVariables>(PaymentRecipientsDocument, options);
      }
export function usePaymentRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentRecipientsQuery, PaymentRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentRecipientsQuery, PaymentRecipientsQueryVariables>(PaymentRecipientsDocument, options);
        }
export function usePaymentRecipientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentRecipientsQuery, PaymentRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentRecipientsQuery, PaymentRecipientsQueryVariables>(PaymentRecipientsDocument, options);
        }
export type PaymentRecipientsQueryHookResult = ReturnType<typeof usePaymentRecipientsQuery>;
export type PaymentRecipientsLazyQueryHookResult = ReturnType<typeof usePaymentRecipientsLazyQuery>;
export type PaymentRecipientsSuspenseQueryHookResult = ReturnType<typeof usePaymentRecipientsSuspenseQuery>;
export type PaymentRecipientsQueryResult = Apollo.QueryResult<PaymentRecipientsQuery, PaymentRecipientsQueryVariables>;
export const PaymentRecipientDocument = gql`
    query paymentRecipient($id: ID!) {
  contractPaymentRecipient(id: $id) {
    id
    type
    companyName
    firstName
    lastName
    address {
      country
      line1
      zip
      city
      additionalDetails
    }
    accountNo
    iban
    bankName
    bankBic
    alias
    commentTemplate
    phone
    taxId
    bankClearingMemberId
    accountNoType
    bankBranchId
    bankBranchName
    pan
    kyc {
      individual {
        dateOfBirth
        nationality
        idType
        idNumber
        idIssueDate
        idExpiryDate
        idIssueCountry
      }
      company {
        registrationNumber
        registrationType
        registrationDate
      }
    }
  }
}
    `;

/**
 * __usePaymentRecipientQuery__
 *
 * To run a query within a React component, call `usePaymentRecipientQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentRecipientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentRecipientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentRecipientQuery(baseOptions: Apollo.QueryHookOptions<PaymentRecipientQuery, PaymentRecipientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentRecipientQuery, PaymentRecipientQueryVariables>(PaymentRecipientDocument, options);
      }
export function usePaymentRecipientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentRecipientQuery, PaymentRecipientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentRecipientQuery, PaymentRecipientQueryVariables>(PaymentRecipientDocument, options);
        }
export function usePaymentRecipientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentRecipientQuery, PaymentRecipientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentRecipientQuery, PaymentRecipientQueryVariables>(PaymentRecipientDocument, options);
        }
export type PaymentRecipientQueryHookResult = ReturnType<typeof usePaymentRecipientQuery>;
export type PaymentRecipientLazyQueryHookResult = ReturnType<typeof usePaymentRecipientLazyQuery>;
export type PaymentRecipientSuspenseQueryHookResult = ReturnType<typeof usePaymentRecipientSuspenseQuery>;
export type PaymentRecipientQueryResult = Apollo.QueryResult<PaymentRecipientQuery, PaymentRecipientQueryVariables>;
export const GetTransactionDetailsDocument = gql`
    query getTransactionDetails($id: ID!) {
  transaction(id: $id) {
    ... on BaseTransaction {
      id
      type
      entryType
      value
      payoutValue
      status
      currency
      accountCurrency
      payoutCurrency
      executedAt
      valueDate
      executionType
      comment
      chargeBearer
      isLocal
      createdAt
      xRate
      isConfirmationAvailable
      priority
      feeDetail {
        id
        feeName
      }
      clientReference
      additionalComment
      cashbackDetail {
        sourceTransaction {
          ... on BaseTransaction {
            id
          }
        }
      }
      executionAction {
        ... on BatchPaymentActionType {
          initiatorName
          signedCount
          signatures {
            id
            status
            isMine
            signedAt
            signatory {
              signatoryRight
              person {
                id
                firstName
                lastName
              }
            }
            action {
              ... on BaseAction {
                id
              }
            }
          }
        }
        ... on TransactionAction {
          initiatorName
          signedCount
          signatures {
            id
            status
            isMine
            signedAt
            signatory {
              signatoryRight
              person {
                id
                firstName
                lastName
              }
            }
            action {
              ... on BaseAction {
                id
              }
            }
          }
        }
      }
      directDebitExecution {
        id
        canBeDisputed
        mandate {
          mandateId
        }
        dispute {
          status
          action {
            ... on BaseAction {
              signedCount
              signatures {
                id
                status
                isMine
                signedAt
                signatory {
                  signatoryRight
                  person {
                    id
                    firstName
                    lastName
                  }
                }
                action {
                  ... on BaseAction {
                    id
                  }
                }
              }
            }
          }
        }
      }
      account {
        id
        alias
        accountNumber
        iban
        isVirtual
        fundsType
        type
      }
      card {
        apiMaskedCardNumber
        alias
        cardHolder {
          person {
            fullName
          }
        }
      }
      cardTransactionDetails {
        cardholderName
        errorMessage
        expiryDate
        maskedCardNumber
      }
      trxHash
      ... on CreditTransaction {
        isInterContract
        from {
          accountNo
          name
          bankName
          iban
          bankBic
          type
          walletAddress
        }
      }
      ... on DebitTransaction {
        isInterContract
        to {
          accountNo
          name
          bankName
          iban
          bankBic
          type
          address {
            city
            country
            countryDescription
            line1
            zip
          }
          walletAddress
        }
        standingOrder {
          id
          cronDescription
        }
      }
    }
  }
}
    `;

/**
 * __useGetTransactionDetailsQuery__
 *
 * To run a query within a React component, call `useGetTransactionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTransactionDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionDetailsQuery, GetTransactionDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionDetailsQuery, GetTransactionDetailsQueryVariables>(GetTransactionDetailsDocument, options);
      }
export function useGetTransactionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionDetailsQuery, GetTransactionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionDetailsQuery, GetTransactionDetailsQueryVariables>(GetTransactionDetailsDocument, options);
        }
export function useGetTransactionDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransactionDetailsQuery, GetTransactionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionDetailsQuery, GetTransactionDetailsQueryVariables>(GetTransactionDetailsDocument, options);
        }
export type GetTransactionDetailsQueryHookResult = ReturnType<typeof useGetTransactionDetailsQuery>;
export type GetTransactionDetailsLazyQueryHookResult = ReturnType<typeof useGetTransactionDetailsLazyQuery>;
export type GetTransactionDetailsSuspenseQueryHookResult = ReturnType<typeof useGetTransactionDetailsSuspenseQuery>;
export type GetTransactionDetailsQueryResult = Apollo.QueryResult<GetTransactionDetailsQuery, GetTransactionDetailsQueryVariables>;
export const DownloadAccountStatementDocument = gql`
    query downloadAccountStatement($id: ID!, $from: Date, $to: Date, $type: AccountStatementType, $transactionId: ID) {
  report: accountStatement(
    id: $id
    from: $from
    to: $to
    type: $type
    transactionId: $transactionId
  ) {
    result
    async
  }
}
    `;

/**
 * __useDownloadAccountStatementQuery__
 *
 * To run a query within a React component, call `useDownloadAccountStatementQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAccountStatementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAccountStatementQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      type: // value for 'type'
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useDownloadAccountStatementQuery(baseOptions: Apollo.QueryHookOptions<DownloadAccountStatementQuery, DownloadAccountStatementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadAccountStatementQuery, DownloadAccountStatementQueryVariables>(DownloadAccountStatementDocument, options);
      }
export function useDownloadAccountStatementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAccountStatementQuery, DownloadAccountStatementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadAccountStatementQuery, DownloadAccountStatementQueryVariables>(DownloadAccountStatementDocument, options);
        }
export function useDownloadAccountStatementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadAccountStatementQuery, DownloadAccountStatementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadAccountStatementQuery, DownloadAccountStatementQueryVariables>(DownloadAccountStatementDocument, options);
        }
export type DownloadAccountStatementQueryHookResult = ReturnType<typeof useDownloadAccountStatementQuery>;
export type DownloadAccountStatementLazyQueryHookResult = ReturnType<typeof useDownloadAccountStatementLazyQuery>;
export type DownloadAccountStatementSuspenseQueryHookResult = ReturnType<typeof useDownloadAccountStatementSuspenseQuery>;
export type DownloadAccountStatementQueryResult = Apollo.QueryResult<DownloadAccountStatementQuery, DownloadAccountStatementQueryVariables>;
export const DownloadTransactionConfirmationDocument = gql`
    query downloadTransactionConfirmation($id: ID!) {
  report: getTransactionConfirmation(id: $id) {
    result
    async
  }
}
    `;

/**
 * __useDownloadTransactionConfirmationQuery__
 *
 * To run a query within a React component, call `useDownloadTransactionConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadTransactionConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadTransactionConfirmationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadTransactionConfirmationQuery(baseOptions: Apollo.QueryHookOptions<DownloadTransactionConfirmationQuery, DownloadTransactionConfirmationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadTransactionConfirmationQuery, DownloadTransactionConfirmationQueryVariables>(DownloadTransactionConfirmationDocument, options);
      }
export function useDownloadTransactionConfirmationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadTransactionConfirmationQuery, DownloadTransactionConfirmationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadTransactionConfirmationQuery, DownloadTransactionConfirmationQueryVariables>(DownloadTransactionConfirmationDocument, options);
        }
export function useDownloadTransactionConfirmationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadTransactionConfirmationQuery, DownloadTransactionConfirmationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadTransactionConfirmationQuery, DownloadTransactionConfirmationQueryVariables>(DownloadTransactionConfirmationDocument, options);
        }
export type DownloadTransactionConfirmationQueryHookResult = ReturnType<typeof useDownloadTransactionConfirmationQuery>;
export type DownloadTransactionConfirmationLazyQueryHookResult = ReturnType<typeof useDownloadTransactionConfirmationLazyQuery>;
export type DownloadTransactionConfirmationSuspenseQueryHookResult = ReturnType<typeof useDownloadTransactionConfirmationSuspenseQuery>;
export type DownloadTransactionConfirmationQueryResult = Apollo.QueryResult<DownloadTransactionConfirmationQuery, DownloadTransactionConfirmationQueryVariables>;
export const DownloadAccountCancellationReturnsReportDocument = gql`
    query downloadAccountCancellationReturnsReport($id: ID!, $from: Date, $to: Date) {
  report: accountCancellationReturnsReport(id: $id, from: $from, to: $to) {
    result
    async
  }
}
    `;

/**
 * __useDownloadAccountCancellationReturnsReportQuery__
 *
 * To run a query within a React component, call `useDownloadAccountCancellationReturnsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAccountCancellationReturnsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAccountCancellationReturnsReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useDownloadAccountCancellationReturnsReportQuery(baseOptions: Apollo.QueryHookOptions<DownloadAccountCancellationReturnsReportQuery, DownloadAccountCancellationReturnsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadAccountCancellationReturnsReportQuery, DownloadAccountCancellationReturnsReportQueryVariables>(DownloadAccountCancellationReturnsReportDocument, options);
      }
export function useDownloadAccountCancellationReturnsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAccountCancellationReturnsReportQuery, DownloadAccountCancellationReturnsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadAccountCancellationReturnsReportQuery, DownloadAccountCancellationReturnsReportQueryVariables>(DownloadAccountCancellationReturnsReportDocument, options);
        }
export function useDownloadAccountCancellationReturnsReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadAccountCancellationReturnsReportQuery, DownloadAccountCancellationReturnsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadAccountCancellationReturnsReportQuery, DownloadAccountCancellationReturnsReportQueryVariables>(DownloadAccountCancellationReturnsReportDocument, options);
        }
export type DownloadAccountCancellationReturnsReportQueryHookResult = ReturnType<typeof useDownloadAccountCancellationReturnsReportQuery>;
export type DownloadAccountCancellationReturnsReportLazyQueryHookResult = ReturnType<typeof useDownloadAccountCancellationReturnsReportLazyQuery>;
export type DownloadAccountCancellationReturnsReportSuspenseQueryHookResult = ReturnType<typeof useDownloadAccountCancellationReturnsReportSuspenseQuery>;
export type DownloadAccountCancellationReturnsReportQueryResult = Apollo.QueryResult<DownloadAccountCancellationReturnsReportQuery, DownloadAccountCancellationReturnsReportQueryVariables>;
export const GetContractsCountDocument = gql`
    query getContractsCount($individualId: ID) {
  contractsCount(individualId: $individualId)
}
    `;

/**
 * __useGetContractsCountQuery__
 *
 * To run a query within a React component, call `useGetContractsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractsCountQuery({
 *   variables: {
 *      individualId: // value for 'individualId'
 *   },
 * });
 */
export function useGetContractsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetContractsCountQuery, GetContractsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractsCountQuery, GetContractsCountQueryVariables>(GetContractsCountDocument, options);
      }
export function useGetContractsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractsCountQuery, GetContractsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractsCountQuery, GetContractsCountQueryVariables>(GetContractsCountDocument, options);
        }
export function useGetContractsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractsCountQuery, GetContractsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractsCountQuery, GetContractsCountQueryVariables>(GetContractsCountDocument, options);
        }
export type GetContractsCountQueryHookResult = ReturnType<typeof useGetContractsCountQuery>;
export type GetContractsCountLazyQueryHookResult = ReturnType<typeof useGetContractsCountLazyQuery>;
export type GetContractsCountSuspenseQueryHookResult = ReturnType<typeof useGetContractsCountSuspenseQuery>;
export type GetContractsCountQueryResult = Apollo.QueryResult<GetContractsCountQuery, GetContractsCountQueryVariables>;
export const BackOfficeNewDocsCountDocument = gql`
    query backOfficeNewDocsCount($status: DocumentStatus, $contractId: Int, $statuses: [DocumentStatus]) {
  unreadDocumentsCount(
    status: $status
    onlyFromSystem: true
    contractId: $contractId
    statuses: $statuses
  )
}
    `;

/**
 * __useBackOfficeNewDocsCountQuery__
 *
 * To run a query within a React component, call `useBackOfficeNewDocsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackOfficeNewDocsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackOfficeNewDocsCountQuery({
 *   variables: {
 *      status: // value for 'status'
 *      contractId: // value for 'contractId'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useBackOfficeNewDocsCountQuery(baseOptions?: Apollo.QueryHookOptions<BackOfficeNewDocsCountQuery, BackOfficeNewDocsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BackOfficeNewDocsCountQuery, BackOfficeNewDocsCountQueryVariables>(BackOfficeNewDocsCountDocument, options);
      }
export function useBackOfficeNewDocsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BackOfficeNewDocsCountQuery, BackOfficeNewDocsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BackOfficeNewDocsCountQuery, BackOfficeNewDocsCountQueryVariables>(BackOfficeNewDocsCountDocument, options);
        }
export function useBackOfficeNewDocsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BackOfficeNewDocsCountQuery, BackOfficeNewDocsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BackOfficeNewDocsCountQuery, BackOfficeNewDocsCountQueryVariables>(BackOfficeNewDocsCountDocument, options);
        }
export type BackOfficeNewDocsCountQueryHookResult = ReturnType<typeof useBackOfficeNewDocsCountQuery>;
export type BackOfficeNewDocsCountLazyQueryHookResult = ReturnType<typeof useBackOfficeNewDocsCountLazyQuery>;
export type BackOfficeNewDocsCountSuspenseQueryHookResult = ReturnType<typeof useBackOfficeNewDocsCountSuspenseQuery>;
export type BackOfficeNewDocsCountQueryResult = Apollo.QueryResult<BackOfficeNewDocsCountQuery, BackOfficeNewDocsCountQueryVariables>;
export const SystemReceivedDocsCountDocument = gql`
    query systemReceivedDocsCount($contractId: Int, $userFilter: DocumentUserFilter, $search: String, $types: [DocumentType], $creationTimeFrom: DateTime, $creationTimeTo: DateTime, $statuses: [DocumentStatus]) {
  documentsCount(
    onlyFromSystem: true
    contractId: $contractId
    userFilter: $userFilter
    search: $search
    types: $types
    creationTimeFrom: $creationTimeFrom
    creationTimeTo: $creationTimeTo
    statuses: $statuses
  )
}
    `;

/**
 * __useSystemReceivedDocsCountQuery__
 *
 * To run a query within a React component, call `useSystemReceivedDocsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemReceivedDocsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemReceivedDocsCountQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      userFilter: // value for 'userFilter'
 *      search: // value for 'search'
 *      types: // value for 'types'
 *      creationTimeFrom: // value for 'creationTimeFrom'
 *      creationTimeTo: // value for 'creationTimeTo'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useSystemReceivedDocsCountQuery(baseOptions?: Apollo.QueryHookOptions<SystemReceivedDocsCountQuery, SystemReceivedDocsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemReceivedDocsCountQuery, SystemReceivedDocsCountQueryVariables>(SystemReceivedDocsCountDocument, options);
      }
export function useSystemReceivedDocsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemReceivedDocsCountQuery, SystemReceivedDocsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemReceivedDocsCountQuery, SystemReceivedDocsCountQueryVariables>(SystemReceivedDocsCountDocument, options);
        }
export function useSystemReceivedDocsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SystemReceivedDocsCountQuery, SystemReceivedDocsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SystemReceivedDocsCountQuery, SystemReceivedDocsCountQueryVariables>(SystemReceivedDocsCountDocument, options);
        }
export type SystemReceivedDocsCountQueryHookResult = ReturnType<typeof useSystemReceivedDocsCountQuery>;
export type SystemReceivedDocsCountLazyQueryHookResult = ReturnType<typeof useSystemReceivedDocsCountLazyQuery>;
export type SystemReceivedDocsCountSuspenseQueryHookResult = ReturnType<typeof useSystemReceivedDocsCountSuspenseQuery>;
export type SystemReceivedDocsCountQueryResult = Apollo.QueryResult<SystemReceivedDocsCountQuery, SystemReceivedDocsCountQueryVariables>;
export const SystemPinnedDocsCountDocument = gql`
    query systemPinnedDocsCount($contractId: Int, $userFilter: DocumentUserFilter, $search: String, $types: [DocumentType], $creationTimeFrom: DateTime, $creationTimeTo: DateTime, $statuses: [DocumentStatus]) {
  documentsCount(
    status: accepted
    onlyFromSystem: true
    contractId: $contractId
    userFilter: $userFilter
    search: $search
    types: $types
    creationTimeFrom: $creationTimeFrom
    creationTimeTo: $creationTimeTo
    pinned: true
    statuses: $statuses
  )
}
    `;

/**
 * __useSystemPinnedDocsCountQuery__
 *
 * To run a query within a React component, call `useSystemPinnedDocsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemPinnedDocsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemPinnedDocsCountQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      userFilter: // value for 'userFilter'
 *      search: // value for 'search'
 *      types: // value for 'types'
 *      creationTimeFrom: // value for 'creationTimeFrom'
 *      creationTimeTo: // value for 'creationTimeTo'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useSystemPinnedDocsCountQuery(baseOptions?: Apollo.QueryHookOptions<SystemPinnedDocsCountQuery, SystemPinnedDocsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemPinnedDocsCountQuery, SystemPinnedDocsCountQueryVariables>(SystemPinnedDocsCountDocument, options);
      }
export function useSystemPinnedDocsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemPinnedDocsCountQuery, SystemPinnedDocsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemPinnedDocsCountQuery, SystemPinnedDocsCountQueryVariables>(SystemPinnedDocsCountDocument, options);
        }
export function useSystemPinnedDocsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SystemPinnedDocsCountQuery, SystemPinnedDocsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SystemPinnedDocsCountQuery, SystemPinnedDocsCountQueryVariables>(SystemPinnedDocsCountDocument, options);
        }
export type SystemPinnedDocsCountQueryHookResult = ReturnType<typeof useSystemPinnedDocsCountQuery>;
export type SystemPinnedDocsCountLazyQueryHookResult = ReturnType<typeof useSystemPinnedDocsCountLazyQuery>;
export type SystemPinnedDocsCountSuspenseQueryHookResult = ReturnType<typeof useSystemPinnedDocsCountSuspenseQuery>;
export type SystemPinnedDocsCountQueryResult = Apollo.QueryResult<SystemPinnedDocsCountQuery, SystemPinnedDocsCountQueryVariables>;
export const SystemReceivedDocsDocument = gql`
    query systemReceivedDocs($contractId: Int, $limit: Int, $offset: Int, $orderBy: DocumentOrderBy, $orderDirection: OrderDirection, $search: String, $types: [DocumentType], $creationTimeFrom: DateTime, $creationTimeTo: DateTime, $statuses: [DocumentStatus]) {
  documents(
    onlyFromSystem: true
    contractId: $contractId
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    orderDirection: $orderDirection
    search: $search
    types: $types
    creationTimeFrom: $creationTimeFrom
    creationTimeTo: $creationTimeTo
    statuses: $statuses
  ) {
    id
    type
    fileDescription
    createdAt
    isRead
    firstSide {
      url
      fileName
      __typename
      mimeType
    }
    account {
      accountNumber
      id
      alias
    }
  }
  documentsCount(status: accepted, onlyFromSystem: true, contractId: $contractId)
}
    `;

/**
 * __useSystemReceivedDocsQuery__
 *
 * To run a query within a React component, call `useSystemReceivedDocsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemReceivedDocsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemReceivedDocsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      search: // value for 'search'
 *      types: // value for 'types'
 *      creationTimeFrom: // value for 'creationTimeFrom'
 *      creationTimeTo: // value for 'creationTimeTo'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useSystemReceivedDocsQuery(baseOptions?: Apollo.QueryHookOptions<SystemReceivedDocsQuery, SystemReceivedDocsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemReceivedDocsQuery, SystemReceivedDocsQueryVariables>(SystemReceivedDocsDocument, options);
      }
export function useSystemReceivedDocsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemReceivedDocsQuery, SystemReceivedDocsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemReceivedDocsQuery, SystemReceivedDocsQueryVariables>(SystemReceivedDocsDocument, options);
        }
export function useSystemReceivedDocsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SystemReceivedDocsQuery, SystemReceivedDocsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SystemReceivedDocsQuery, SystemReceivedDocsQueryVariables>(SystemReceivedDocsDocument, options);
        }
export type SystemReceivedDocsQueryHookResult = ReturnType<typeof useSystemReceivedDocsQuery>;
export type SystemReceivedDocsLazyQueryHookResult = ReturnType<typeof useSystemReceivedDocsLazyQuery>;
export type SystemReceivedDocsSuspenseQueryHookResult = ReturnType<typeof useSystemReceivedDocsSuspenseQuery>;
export type SystemReceivedDocsQueryResult = Apollo.QueryResult<SystemReceivedDocsQuery, SystemReceivedDocsQueryVariables>;
export const SystemPinnedDocsDocument = gql`
    query systemPinnedDocs($contractId: Int, $limit: Int, $offset: Int, $orderBy: DocumentOrderBy, $orderDirection: OrderDirection, $search: String, $types: [DocumentType], $creationTimeFrom: DateTime, $creationTimeTo: DateTime, $statuses: [DocumentStatus]) {
  documents(
    status: accepted
    onlyFromSystem: true
    contractId: $contractId
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    orderDirection: $orderDirection
    search: $search
    types: $types
    creationTimeFrom: $creationTimeFrom
    creationTimeTo: $creationTimeTo
    pinned: true
    statuses: $statuses
  ) {
    id
    type
    fileDescription
    createdAt
    isRead
    firstSide {
      url
      fileName
      __typename
      mimeType
    }
    account {
      accountNumber
      id
      alias
    }
  }
  documentsCount(status: accepted, onlyFromSystem: true, contractId: $contractId)
}
    `;

/**
 * __useSystemPinnedDocsQuery__
 *
 * To run a query within a React component, call `useSystemPinnedDocsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemPinnedDocsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemPinnedDocsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      search: // value for 'search'
 *      types: // value for 'types'
 *      creationTimeFrom: // value for 'creationTimeFrom'
 *      creationTimeTo: // value for 'creationTimeTo'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useSystemPinnedDocsQuery(baseOptions?: Apollo.QueryHookOptions<SystemPinnedDocsQuery, SystemPinnedDocsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemPinnedDocsQuery, SystemPinnedDocsQueryVariables>(SystemPinnedDocsDocument, options);
      }
export function useSystemPinnedDocsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemPinnedDocsQuery, SystemPinnedDocsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemPinnedDocsQuery, SystemPinnedDocsQueryVariables>(SystemPinnedDocsDocument, options);
        }
export function useSystemPinnedDocsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SystemPinnedDocsQuery, SystemPinnedDocsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SystemPinnedDocsQuery, SystemPinnedDocsQueryVariables>(SystemPinnedDocsDocument, options);
        }
export type SystemPinnedDocsQueryHookResult = ReturnType<typeof useSystemPinnedDocsQuery>;
export type SystemPinnedDocsLazyQueryHookResult = ReturnType<typeof useSystemPinnedDocsLazyQuery>;
export type SystemPinnedDocsSuspenseQueryHookResult = ReturnType<typeof useSystemPinnedDocsSuspenseQuery>;
export type SystemPinnedDocsQueryResult = Apollo.QueryResult<SystemPinnedDocsQuery, SystemPinnedDocsQueryVariables>;
export const CardsCountDocument = gql`
    query cardsCount($contractId: ID!, $search: String, $accountId: ID, $type: ApiCardTypes, $statuses: [CardStatuses]) {
  contractCardsCount(
    contractId: $contractId
    search: $search
    accountId: $accountId
    type: $type
    statuses: $statuses
  )
}
    `;

/**
 * __useCardsCountQuery__
 *
 * To run a query within a React component, call `useCardsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardsCountQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      search: // value for 'search'
 *      accountId: // value for 'accountId'
 *      type: // value for 'type'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useCardsCountQuery(baseOptions: Apollo.QueryHookOptions<CardsCountQuery, CardsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardsCountQuery, CardsCountQueryVariables>(CardsCountDocument, options);
      }
export function useCardsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardsCountQuery, CardsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardsCountQuery, CardsCountQueryVariables>(CardsCountDocument, options);
        }
export function useCardsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CardsCountQuery, CardsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CardsCountQuery, CardsCountQueryVariables>(CardsCountDocument, options);
        }
export type CardsCountQueryHookResult = ReturnType<typeof useCardsCountQuery>;
export type CardsCountLazyQueryHookResult = ReturnType<typeof useCardsCountLazyQuery>;
export type CardsCountSuspenseQueryHookResult = ReturnType<typeof useCardsCountSuspenseQuery>;
export type CardsCountQueryResult = Apollo.QueryResult<CardsCountQuery, CardsCountQueryVariables>;
export const CardsListDocument = gql`
    query cardsList($contractId: ID!, $search: String, $accountId: ID, $limit: Int, $offset: Int, $orderBy: CardsOrderBy, $orderDirection: OrderDirection, $statuses: [CardStatuses], $type: ApiCardTypes) {
  contractCards(
    contractId: $contractId
    search: $search
    accountId: $accountId
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    orderDirection: $orderDirection
    statuses: $statuses
    type: $type
  ) {
    id
    alias
    status
    type
    updatedAt
    apiMaskedCardNumber
    createdAt
    activatedAt
    expiryDate
    isCard3dSecureActivated
    limitsWithUsage {
      limitType
      amount
      used
    }
    account {
      currency
      id
    }
    cardHolder {
      person {
        id
        fullName
        firstName
        lastName
        phone
      }
    }
    cardRequest {
      executionAction {
        ... on CardIssueRequestAction {
          id
          status
          signatures {
            id
            isMine
            status
            signedAt
            signatory {
              signatoryRight
              person {
                id
                fullName
              }
            }
            action {
              ... on BaseAction {
                id
              }
            }
          }
        }
      }
    }
    freezeLog(limit: 10, orderBy: id, orderDirection: descending) {
      action
      actionBy
      createdAt
    }
  }
}
    `;

/**
 * __useCardsListQuery__
 *
 * To run a query within a React component, call `useCardsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardsListQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      search: // value for 'search'
 *      accountId: // value for 'accountId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      statuses: // value for 'statuses'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCardsListQuery(baseOptions: Apollo.QueryHookOptions<CardsListQuery, CardsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardsListQuery, CardsListQueryVariables>(CardsListDocument, options);
      }
export function useCardsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardsListQuery, CardsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardsListQuery, CardsListQueryVariables>(CardsListDocument, options);
        }
export function useCardsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CardsListQuery, CardsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CardsListQuery, CardsListQueryVariables>(CardsListDocument, options);
        }
export type CardsListQueryHookResult = ReturnType<typeof useCardsListQuery>;
export type CardsListLazyQueryHookResult = ReturnType<typeof useCardsListLazyQuery>;
export type CardsListSuspenseQueryHookResult = ReturnType<typeof useCardsListSuspenseQuery>;
export type CardsListQueryResult = Apollo.QueryResult<CardsListQuery, CardsListQueryVariables>;
export const GetCardSensitiveInfoDocument = gql`
    query getCardSensitiveInfo($challengeId: String!, $code: Int!, $cardId: ID!) {
  getCardSensitiveInfo: getCardSensitiveInfoV2(
    challengeId: $challengeId
    code: $code
    cardId: $cardId
  ) {
    url
    token
  }
}
    `;

/**
 * __useGetCardSensitiveInfoQuery__
 *
 * To run a query within a React component, call `useGetCardSensitiveInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardSensitiveInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardSensitiveInfoQuery({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      code: // value for 'code'
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useGetCardSensitiveInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCardSensitiveInfoQuery, GetCardSensitiveInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardSensitiveInfoQuery, GetCardSensitiveInfoQueryVariables>(GetCardSensitiveInfoDocument, options);
      }
export function useGetCardSensitiveInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardSensitiveInfoQuery, GetCardSensitiveInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardSensitiveInfoQuery, GetCardSensitiveInfoQueryVariables>(GetCardSensitiveInfoDocument, options);
        }
export function useGetCardSensitiveInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardSensitiveInfoQuery, GetCardSensitiveInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardSensitiveInfoQuery, GetCardSensitiveInfoQueryVariables>(GetCardSensitiveInfoDocument, options);
        }
export type GetCardSensitiveInfoQueryHookResult = ReturnType<typeof useGetCardSensitiveInfoQuery>;
export type GetCardSensitiveInfoLazyQueryHookResult = ReturnType<typeof useGetCardSensitiveInfoLazyQuery>;
export type GetCardSensitiveInfoSuspenseQueryHookResult = ReturnType<typeof useGetCardSensitiveInfoSuspenseQuery>;
export type GetCardSensitiveInfoQueryResult = Apollo.QueryResult<GetCardSensitiveInfoQuery, GetCardSensitiveInfoQueryVariables>;
export const GetViewCardPinUrlDocument = gql`
    query getViewCardPinUrl($challengeId: String!, $code: Int!, $cardId: ID!) {
  viewPin(cardId: $cardId, challengeId: $challengeId, code: $code) {
    url
    token
  }
}
    `;

/**
 * __useGetViewCardPinUrlQuery__
 *
 * To run a query within a React component, call `useGetViewCardPinUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewCardPinUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewCardPinUrlQuery({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      code: // value for 'code'
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useGetViewCardPinUrlQuery(baseOptions: Apollo.QueryHookOptions<GetViewCardPinUrlQuery, GetViewCardPinUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetViewCardPinUrlQuery, GetViewCardPinUrlQueryVariables>(GetViewCardPinUrlDocument, options);
      }
export function useGetViewCardPinUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewCardPinUrlQuery, GetViewCardPinUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetViewCardPinUrlQuery, GetViewCardPinUrlQueryVariables>(GetViewCardPinUrlDocument, options);
        }
export function useGetViewCardPinUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetViewCardPinUrlQuery, GetViewCardPinUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetViewCardPinUrlQuery, GetViewCardPinUrlQueryVariables>(GetViewCardPinUrlDocument, options);
        }
export type GetViewCardPinUrlQueryHookResult = ReturnType<typeof useGetViewCardPinUrlQuery>;
export type GetViewCardPinUrlLazyQueryHookResult = ReturnType<typeof useGetViewCardPinUrlLazyQuery>;
export type GetViewCardPinUrlSuspenseQueryHookResult = ReturnType<typeof useGetViewCardPinUrlSuspenseQuery>;
export type GetViewCardPinUrlQueryResult = Apollo.QueryResult<GetViewCardPinUrlQuery, GetViewCardPinUrlQueryVariables>;
export const GetTransactionDocumentsDocument = gql`
    query getTransactionDocuments($transactionId: ID, $standingOrderId: ID, $walletId: ID, $transactionRequestId: ID) {
  documents(
    transactionId: $transactionId
    standingOrderId: $standingOrderId
    walletId: $walletId
    transactionRequestId: $transactionRequestId
  ) {
    id
    type
    fileName
    mimeType
    createdAt
    size
    fileDescription
    firstSide {
      fileName
      url
      size
      mimeType
    }
    secondSide {
      fileName
      url
      size
      mimeType
    }
  }
}
    `;

/**
 * __useGetTransactionDocumentsQuery__
 *
 * To run a query within a React component, call `useGetTransactionDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionDocumentsQuery({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *      standingOrderId: // value for 'standingOrderId'
 *      walletId: // value for 'walletId'
 *      transactionRequestId: // value for 'transactionRequestId'
 *   },
 * });
 */
export function useGetTransactionDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionDocumentsQuery, GetTransactionDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionDocumentsQuery, GetTransactionDocumentsQueryVariables>(GetTransactionDocumentsDocument, options);
      }
export function useGetTransactionDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionDocumentsQuery, GetTransactionDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionDocumentsQuery, GetTransactionDocumentsQueryVariables>(GetTransactionDocumentsDocument, options);
        }
export function useGetTransactionDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransactionDocumentsQuery, GetTransactionDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionDocumentsQuery, GetTransactionDocumentsQueryVariables>(GetTransactionDocumentsDocument, options);
        }
export type GetTransactionDocumentsQueryHookResult = ReturnType<typeof useGetTransactionDocumentsQuery>;
export type GetTransactionDocumentsLazyQueryHookResult = ReturnType<typeof useGetTransactionDocumentsLazyQuery>;
export type GetTransactionDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetTransactionDocumentsSuspenseQuery>;
export type GetTransactionDocumentsQueryResult = Apollo.QueryResult<GetTransactionDocumentsQuery, GetTransactionDocumentsQueryVariables>;
export const GetCardLimitsDocument = gql`
    query getCardLimits($id: ID!, $contractId: ID!) {
  contractCard(id: $id, contractId: $contractId) {
    alias
    account {
      currency
    }
    limitsWithUsage {
      limitType
      amount
    }
  }
}
    `;

/**
 * __useGetCardLimitsQuery__
 *
 * To run a query within a React component, call `useGetCardLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardLimitsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetCardLimitsQuery(baseOptions: Apollo.QueryHookOptions<GetCardLimitsQuery, GetCardLimitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardLimitsQuery, GetCardLimitsQueryVariables>(GetCardLimitsDocument, options);
      }
export function useGetCardLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardLimitsQuery, GetCardLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardLimitsQuery, GetCardLimitsQueryVariables>(GetCardLimitsDocument, options);
        }
export function useGetCardLimitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardLimitsQuery, GetCardLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardLimitsQuery, GetCardLimitsQueryVariables>(GetCardLimitsDocument, options);
        }
export type GetCardLimitsQueryHookResult = ReturnType<typeof useGetCardLimitsQuery>;
export type GetCardLimitsLazyQueryHookResult = ReturnType<typeof useGetCardLimitsLazyQuery>;
export type GetCardLimitsSuspenseQueryHookResult = ReturnType<typeof useGetCardLimitsSuspenseQuery>;
export type GetCardLimitsQueryResult = Apollo.QueryResult<GetCardLimitsQuery, GetCardLimitsQueryVariables>;
export const GetCardInfoDocument = gql`
    query getCardInfo($id: ID!, $contractId: ID!) {
  contractCard(id: $id, contractId: $contractId) {
    id
    alias
    isCard3dSecureActivated
    type
    apiMaskedCardNumber
    account {
      currency
    }
    limitsWithUsage {
      limitType
      amount
    }
    cardHolder {
      person {
        id
        fullName
      }
    }
  }
}
    `;

/**
 * __useGetCardInfoQuery__
 *
 * To run a query within a React component, call `useGetCardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetCardInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCardInfoQuery, GetCardInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardInfoQuery, GetCardInfoQueryVariables>(GetCardInfoDocument, options);
      }
export function useGetCardInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardInfoQuery, GetCardInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardInfoQuery, GetCardInfoQueryVariables>(GetCardInfoDocument, options);
        }
export function useGetCardInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardInfoQuery, GetCardInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardInfoQuery, GetCardInfoQueryVariables>(GetCardInfoDocument, options);
        }
export type GetCardInfoQueryHookResult = ReturnType<typeof useGetCardInfoQuery>;
export type GetCardInfoLazyQueryHookResult = ReturnType<typeof useGetCardInfoLazyQuery>;
export type GetCardInfoSuspenseQueryHookResult = ReturnType<typeof useGetCardInfoSuspenseQuery>;
export type GetCardInfoQueryResult = Apollo.QueryResult<GetCardInfoQuery, GetCardInfoQueryVariables>;
export const GetUploadedDocsDocument = gql`
    query getUploadedDocs($contractId: Int, $userFilter: DocumentUserFilter, $limit: Int, $offset: Int, $orderBy: DocumentOrderBy, $orderDirection: OrderDirection, $search: String, $types: [DocumentType], $creationTimeFrom: DateTime, $creationTimeTo: DateTime) {
  documents(
    contractId: $contractId
    userFilter: $userFilter
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    orderDirection: $orderDirection
    search: $search
    types: $types
    creationTimeFrom: $creationTimeFrom
    creationTimeTo: $creationTimeTo
  ) {
    id
    type
    fileDescription
    createdAt
    firstSide {
      url
      fileName
    }
    account {
      alias
      currency
    }
    transaction {
      ... on CreditTransaction {
        value
        currency
        from {
          name
        }
      }
      ... on DebitTransaction {
        value
        currency
        to {
          name
        }
      }
    }
    individual {
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetUploadedDocsQuery__
 *
 * To run a query within a React component, call `useGetUploadedDocsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadedDocsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadedDocsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      userFilter: // value for 'userFilter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      search: // value for 'search'
 *      types: // value for 'types'
 *      creationTimeFrom: // value for 'creationTimeFrom'
 *      creationTimeTo: // value for 'creationTimeTo'
 *   },
 * });
 */
export function useGetUploadedDocsQuery(baseOptions?: Apollo.QueryHookOptions<GetUploadedDocsQuery, GetUploadedDocsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadedDocsQuery, GetUploadedDocsQueryVariables>(GetUploadedDocsDocument, options);
      }
export function useGetUploadedDocsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadedDocsQuery, GetUploadedDocsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadedDocsQuery, GetUploadedDocsQueryVariables>(GetUploadedDocsDocument, options);
        }
export function useGetUploadedDocsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUploadedDocsQuery, GetUploadedDocsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadedDocsQuery, GetUploadedDocsQueryVariables>(GetUploadedDocsDocument, options);
        }
export type GetUploadedDocsQueryHookResult = ReturnType<typeof useGetUploadedDocsQuery>;
export type GetUploadedDocsLazyQueryHookResult = ReturnType<typeof useGetUploadedDocsLazyQuery>;
export type GetUploadedDocsSuspenseQueryHookResult = ReturnType<typeof useGetUploadedDocsSuspenseQuery>;
export type GetUploadedDocsQueryResult = Apollo.QueryResult<GetUploadedDocsQuery, GetUploadedDocsQueryVariables>;
export const GetGetUploadedDocsCountDocument = gql`
    query getGetUploadedDocsCount($contractId: Int, $userFilter: DocumentUserFilter, $search: String, $types: [DocumentType], $creationTimeFrom: DateTime, $creationTimeTo: DateTime) {
  documentsCount(
    contractId: $contractId
    userFilter: $userFilter
    search: $search
    types: $types
    creationTimeFrom: $creationTimeFrom
    creationTimeTo: $creationTimeTo
  )
}
    `;

/**
 * __useGetGetUploadedDocsCountQuery__
 *
 * To run a query within a React component, call `useGetGetUploadedDocsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGetUploadedDocsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGetUploadedDocsCountQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      userFilter: // value for 'userFilter'
 *      search: // value for 'search'
 *      types: // value for 'types'
 *      creationTimeFrom: // value for 'creationTimeFrom'
 *      creationTimeTo: // value for 'creationTimeTo'
 *   },
 * });
 */
export function useGetGetUploadedDocsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetGetUploadedDocsCountQuery, GetGetUploadedDocsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGetUploadedDocsCountQuery, GetGetUploadedDocsCountQueryVariables>(GetGetUploadedDocsCountDocument, options);
      }
export function useGetGetUploadedDocsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGetUploadedDocsCountQuery, GetGetUploadedDocsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGetUploadedDocsCountQuery, GetGetUploadedDocsCountQueryVariables>(GetGetUploadedDocsCountDocument, options);
        }
export function useGetGetUploadedDocsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGetUploadedDocsCountQuery, GetGetUploadedDocsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGetUploadedDocsCountQuery, GetGetUploadedDocsCountQueryVariables>(GetGetUploadedDocsCountDocument, options);
        }
export type GetGetUploadedDocsCountQueryHookResult = ReturnType<typeof useGetGetUploadedDocsCountQuery>;
export type GetGetUploadedDocsCountLazyQueryHookResult = ReturnType<typeof useGetGetUploadedDocsCountLazyQuery>;
export type GetGetUploadedDocsCountSuspenseQueryHookResult = ReturnType<typeof useGetGetUploadedDocsCountSuspenseQuery>;
export type GetGetUploadedDocsCountQueryResult = Apollo.QueryResult<GetGetUploadedDocsCountQuery, GetGetUploadedDocsCountQueryVariables>;
export const GetcontractProfileChangesCountDocument = gql`
    query getcontractProfileChangesCount($contractId: ID!, $status: [ProfileChangeStatus]) {
  contractProfileChangesCount(contractId: $contractId, status: $status)
}
    `;

/**
 * __useGetcontractProfileChangesCountQuery__
 *
 * To run a query within a React component, call `useGetcontractProfileChangesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetcontractProfileChangesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetcontractProfileChangesCountQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetcontractProfileChangesCountQuery(baseOptions: Apollo.QueryHookOptions<GetcontractProfileChangesCountQuery, GetcontractProfileChangesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetcontractProfileChangesCountQuery, GetcontractProfileChangesCountQueryVariables>(GetcontractProfileChangesCountDocument, options);
      }
export function useGetcontractProfileChangesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetcontractProfileChangesCountQuery, GetcontractProfileChangesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetcontractProfileChangesCountQuery, GetcontractProfileChangesCountQueryVariables>(GetcontractProfileChangesCountDocument, options);
        }
export function useGetcontractProfileChangesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetcontractProfileChangesCountQuery, GetcontractProfileChangesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetcontractProfileChangesCountQuery, GetcontractProfileChangesCountQueryVariables>(GetcontractProfileChangesCountDocument, options);
        }
export type GetcontractProfileChangesCountQueryHookResult = ReturnType<typeof useGetcontractProfileChangesCountQuery>;
export type GetcontractProfileChangesCountLazyQueryHookResult = ReturnType<typeof useGetcontractProfileChangesCountLazyQuery>;
export type GetcontractProfileChangesCountSuspenseQueryHookResult = ReturnType<typeof useGetcontractProfileChangesCountSuspenseQuery>;
export type GetcontractProfileChangesCountQueryResult = Apollo.QueryResult<GetcontractProfileChangesCountQuery, GetcontractProfileChangesCountQueryVariables>;
export const GetContractProfileChangesDocument = gql`
    query getContractProfileChanges($contractId: ID!, $status: [ProfileChangeStatus]) {
  contractProfileChanges(contractId: $contractId, status: $status) {
    id
    status
    changeAnswers {
      ... on ContractProfileChangeAnswers {
        companyName
        tradingName
        companyType
        legalEntityType
        companyRegistrationId
        companyRegistrationDate
        phone
        websites
        businessSector
        businessDescription
        countriesOfOperatingAndConductingBusiness
        taxId
        address {
          line1
          country
          countryDescription
          zip
          city
          additionalDetails
        }
        correspondenceAddress {
          line1
          country
          countryDescription
          zip
          city
          additionalDetails
        }
        economicProfile {
          sourceOfFunds
          sourceOfFundsDescription
          estimateOutbound
          estimateInbound
          currencies
          turnover
          inboundSources
          outboundDestinations
          products
          anticipatedAccountActivity
        }
        preAssessment {
          ...CardPayments
          regulatoryInfoName
          regulatoryInfoLicenseNumber
          paymentProviders
          conductingKYC
          conductingClientKYC
          conductPublisherContentMonitoring
          clientsYouWorkWith
          companyAnnualIncome
          incomingMonthlyTurnover
          incomingClients
          outgoingMonthlyTurnover
          outgoingClients
          currencyAndVolume
          contactPersonFullName
          contactPersonEmail
          contactPersonPhoneNumber
          countryOfTaxResidence
          licenseRequired
          licenseCountry
          uboResidencies
          businessRelationshipWithCompany
          businessRelationshipWithCompanyExplanation
          partnersIncoming {
            name
            country
            bankCountry
            businessSector
            paymentPurpose
            paymentPurposeOther
            website
          }
          partnersOutgoing {
            name
            country
            bankCountry
            businessSector
            paymentPurpose
            paymentPurposeOther
            website
          }
        }
      }
    }
    supportingDocuments {
      id
      type
      fileName
      mimeType
      createdAt
      size
      fileDescription
    }
  }
}
    ${CardPaymentsFragmentDoc}`;

/**
 * __useGetContractProfileChangesQuery__
 *
 * To run a query within a React component, call `useGetContractProfileChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractProfileChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractProfileChangesQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetContractProfileChangesQuery(baseOptions: Apollo.QueryHookOptions<GetContractProfileChangesQuery, GetContractProfileChangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractProfileChangesQuery, GetContractProfileChangesQueryVariables>(GetContractProfileChangesDocument, options);
      }
export function useGetContractProfileChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractProfileChangesQuery, GetContractProfileChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractProfileChangesQuery, GetContractProfileChangesQueryVariables>(GetContractProfileChangesDocument, options);
        }
export function useGetContractProfileChangesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractProfileChangesQuery, GetContractProfileChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractProfileChangesQuery, GetContractProfileChangesQueryVariables>(GetContractProfileChangesDocument, options);
        }
export type GetContractProfileChangesQueryHookResult = ReturnType<typeof useGetContractProfileChangesQuery>;
export type GetContractProfileChangesLazyQueryHookResult = ReturnType<typeof useGetContractProfileChangesLazyQuery>;
export type GetContractProfileChangesSuspenseQueryHookResult = ReturnType<typeof useGetContractProfileChangesSuspenseQuery>;
export type GetContractProfileChangesQueryResult = Apollo.QueryResult<GetContractProfileChangesQuery, GetContractProfileChangesQueryVariables>;
export const GetContractTechnicalPropertiesDocument = gql`
    query getContractTechnicalProperties($contractId: ID!) {
  getContractTechnicalProperties(contractId: $contractId) {
    id
    contractId
    paymentWebhook
    webhookSignatureKey
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetContractTechnicalPropertiesQuery__
 *
 * To run a query within a React component, call `useGetContractTechnicalPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractTechnicalPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractTechnicalPropertiesQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetContractTechnicalPropertiesQuery(baseOptions: Apollo.QueryHookOptions<GetContractTechnicalPropertiesQuery, GetContractTechnicalPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractTechnicalPropertiesQuery, GetContractTechnicalPropertiesQueryVariables>(GetContractTechnicalPropertiesDocument, options);
      }
export function useGetContractTechnicalPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractTechnicalPropertiesQuery, GetContractTechnicalPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractTechnicalPropertiesQuery, GetContractTechnicalPropertiesQueryVariables>(GetContractTechnicalPropertiesDocument, options);
        }
export function useGetContractTechnicalPropertiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractTechnicalPropertiesQuery, GetContractTechnicalPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractTechnicalPropertiesQuery, GetContractTechnicalPropertiesQueryVariables>(GetContractTechnicalPropertiesDocument, options);
        }
export type GetContractTechnicalPropertiesQueryHookResult = ReturnType<typeof useGetContractTechnicalPropertiesQuery>;
export type GetContractTechnicalPropertiesLazyQueryHookResult = ReturnType<typeof useGetContractTechnicalPropertiesLazyQuery>;
export type GetContractTechnicalPropertiesSuspenseQueryHookResult = ReturnType<typeof useGetContractTechnicalPropertiesSuspenseQuery>;
export type GetContractTechnicalPropertiesQueryResult = Apollo.QueryResult<GetContractTechnicalPropertiesQuery, GetContractTechnicalPropertiesQueryVariables>;
export const ContractAuthorizedPersonsDocument = gql`
    query contractAuthorizedPersons($contractId: ID, $limit: Int, $offset: Int, $orderBy: ContractAuthPersonOrderBy, $orderDirection: OrderDirection, $search: String, $statuses: [AuthorizedPersonStatuses], $role: AuthorizedPersonRights) {
  contractAuthorizedPersons(
    contractId: $contractId
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    orderDirection: $orderDirection
    search: $search
    statuses: $statuses
    role: $role
  ) {
    id
    isAuthorizedSignatory
    isLimitedAccessHolder
    limitedAccessRight
    signatoryRight
    invitationDate
    cannotSignOwnActions
    status
    isPendingDeactivated
    groupSize
    person {
      id
      firstName
      lastName
      lastSeenAt
      lastLogin
      email
    }
  }
}
    `;

/**
 * __useContractAuthorizedPersonsQuery__
 *
 * To run a query within a React component, call `useContractAuthorizedPersonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractAuthorizedPersonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractAuthorizedPersonsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      search: // value for 'search'
 *      statuses: // value for 'statuses'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useContractAuthorizedPersonsQuery(baseOptions?: Apollo.QueryHookOptions<ContractAuthorizedPersonsQuery, ContractAuthorizedPersonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractAuthorizedPersonsQuery, ContractAuthorizedPersonsQueryVariables>(ContractAuthorizedPersonsDocument, options);
      }
export function useContractAuthorizedPersonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractAuthorizedPersonsQuery, ContractAuthorizedPersonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractAuthorizedPersonsQuery, ContractAuthorizedPersonsQueryVariables>(ContractAuthorizedPersonsDocument, options);
        }
export function useContractAuthorizedPersonsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContractAuthorizedPersonsQuery, ContractAuthorizedPersonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractAuthorizedPersonsQuery, ContractAuthorizedPersonsQueryVariables>(ContractAuthorizedPersonsDocument, options);
        }
export type ContractAuthorizedPersonsQueryHookResult = ReturnType<typeof useContractAuthorizedPersonsQuery>;
export type ContractAuthorizedPersonsLazyQueryHookResult = ReturnType<typeof useContractAuthorizedPersonsLazyQuery>;
export type ContractAuthorizedPersonsSuspenseQueryHookResult = ReturnType<typeof useContractAuthorizedPersonsSuspenseQuery>;
export type ContractAuthorizedPersonsQueryResult = Apollo.QueryResult<ContractAuthorizedPersonsQuery, ContractAuthorizedPersonsQueryVariables>;
export const ContractAuthorizedPersonsCountDocument = gql`
    query contractAuthorizedPersonsCount($contractId: ID, $search: String, $statuses: [AuthorizedPersonStatuses], $role: AuthorizedPersonRights) {
  contractAuthorizedPersonsCount(
    contractId: $contractId
    search: $search
    statuses: $statuses
    role: $role
  )
}
    `;

/**
 * __useContractAuthorizedPersonsCountQuery__
 *
 * To run a query within a React component, call `useContractAuthorizedPersonsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractAuthorizedPersonsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractAuthorizedPersonsCountQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      search: // value for 'search'
 *      statuses: // value for 'statuses'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useContractAuthorizedPersonsCountQuery(baseOptions?: Apollo.QueryHookOptions<ContractAuthorizedPersonsCountQuery, ContractAuthorizedPersonsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractAuthorizedPersonsCountQuery, ContractAuthorizedPersonsCountQueryVariables>(ContractAuthorizedPersonsCountDocument, options);
      }
export function useContractAuthorizedPersonsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractAuthorizedPersonsCountQuery, ContractAuthorizedPersonsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractAuthorizedPersonsCountQuery, ContractAuthorizedPersonsCountQueryVariables>(ContractAuthorizedPersonsCountDocument, options);
        }
export function useContractAuthorizedPersonsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContractAuthorizedPersonsCountQuery, ContractAuthorizedPersonsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractAuthorizedPersonsCountQuery, ContractAuthorizedPersonsCountQueryVariables>(ContractAuthorizedPersonsCountDocument, options);
        }
export type ContractAuthorizedPersonsCountQueryHookResult = ReturnType<typeof useContractAuthorizedPersonsCountQuery>;
export type ContractAuthorizedPersonsCountLazyQueryHookResult = ReturnType<typeof useContractAuthorizedPersonsCountLazyQuery>;
export type ContractAuthorizedPersonsCountSuspenseQueryHookResult = ReturnType<typeof useContractAuthorizedPersonsCountSuspenseQuery>;
export type ContractAuthorizedPersonsCountQueryResult = Apollo.QueryResult<ContractAuthorizedPersonsCountQuery, ContractAuthorizedPersonsCountQueryVariables>;
export const GetBankInfoDocument = gql`
    query getBankInfo($iban: String!) {
  bankInfo(iban: $iban) {
    bankName
    bic
    address
    city
    zip
    country
    countryISO
  }
}
    `;

/**
 * __useGetBankInfoQuery__
 *
 * To run a query within a React component, call `useGetBankInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankInfoQuery({
 *   variables: {
 *      iban: // value for 'iban'
 *   },
 * });
 */
export function useGetBankInfoQuery(baseOptions: Apollo.QueryHookOptions<GetBankInfoQuery, GetBankInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankInfoQuery, GetBankInfoQueryVariables>(GetBankInfoDocument, options);
      }
export function useGetBankInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankInfoQuery, GetBankInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankInfoQuery, GetBankInfoQueryVariables>(GetBankInfoDocument, options);
        }
export function useGetBankInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBankInfoQuery, GetBankInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBankInfoQuery, GetBankInfoQueryVariables>(GetBankInfoDocument, options);
        }
export type GetBankInfoQueryHookResult = ReturnType<typeof useGetBankInfoQuery>;
export type GetBankInfoLazyQueryHookResult = ReturnType<typeof useGetBankInfoLazyQuery>;
export type GetBankInfoSuspenseQueryHookResult = ReturnType<typeof useGetBankInfoSuspenseQuery>;
export type GetBankInfoQueryResult = Apollo.QueryResult<GetBankInfoQuery, GetBankInfoQueryVariables>;
export const GetApiUsersDocument = gql`
    query getApiUsers($contractId: ID!) {
  apiUsers(contractId: $contractId) {
    id
    name
    apiKey
    apiSecret
    allowedIps
    status
  }
}
    `;

/**
 * __useGetApiUsersQuery__
 *
 * To run a query within a React component, call `useGetApiUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiUsersQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetApiUsersQuery(baseOptions: Apollo.QueryHookOptions<GetApiUsersQuery, GetApiUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiUsersQuery, GetApiUsersQueryVariables>(GetApiUsersDocument, options);
      }
export function useGetApiUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiUsersQuery, GetApiUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiUsersQuery, GetApiUsersQueryVariables>(GetApiUsersDocument, options);
        }
export function useGetApiUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApiUsersQuery, GetApiUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApiUsersQuery, GetApiUsersQueryVariables>(GetApiUsersDocument, options);
        }
export type GetApiUsersQueryHookResult = ReturnType<typeof useGetApiUsersQuery>;
export type GetApiUsersLazyQueryHookResult = ReturnType<typeof useGetApiUsersLazyQuery>;
export type GetApiUsersSuspenseQueryHookResult = ReturnType<typeof useGetApiUsersSuspenseQuery>;
export type GetApiUsersQueryResult = Apollo.QueryResult<GetApiUsersQuery, GetApiUsersQueryVariables>;
export const GetFxMarkupDocument = gql`
    query getFXMarkup($contractId: ID!) {
  contract(id: $contractId) {
    id
    fxMarkup
  }
}
    `;

/**
 * __useGetFxMarkupQuery__
 *
 * To run a query within a React component, call `useGetFxMarkupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFxMarkupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFxMarkupQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetFxMarkupQuery(baseOptions: Apollo.QueryHookOptions<GetFxMarkupQuery, GetFxMarkupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFxMarkupQuery, GetFxMarkupQueryVariables>(GetFxMarkupDocument, options);
      }
export function useGetFxMarkupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFxMarkupQuery, GetFxMarkupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFxMarkupQuery, GetFxMarkupQueryVariables>(GetFxMarkupDocument, options);
        }
export function useGetFxMarkupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFxMarkupQuery, GetFxMarkupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFxMarkupQuery, GetFxMarkupQueryVariables>(GetFxMarkupDocument, options);
        }
export type GetFxMarkupQueryHookResult = ReturnType<typeof useGetFxMarkupQuery>;
export type GetFxMarkupLazyQueryHookResult = ReturnType<typeof useGetFxMarkupLazyQuery>;
export type GetFxMarkupSuspenseQueryHookResult = ReturnType<typeof useGetFxMarkupSuspenseQuery>;
export type GetFxMarkupQueryResult = Apollo.QueryResult<GetFxMarkupQuery, GetFxMarkupQueryVariables>;
export const GetContractRegistrationAddressDocument = gql`
    query getContractRegistrationAddress($contractId: ID!) {
  contract(id: $contractId) {
    owner {
      ... on LegalEntity {
        address {
          country
          city
          line1
          additionalDetails
          zip
        }
      }
    }
  }
}
    `;

/**
 * __useGetContractRegistrationAddressQuery__
 *
 * To run a query within a React component, call `useGetContractRegistrationAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractRegistrationAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractRegistrationAddressQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetContractRegistrationAddressQuery(baseOptions: Apollo.QueryHookOptions<GetContractRegistrationAddressQuery, GetContractRegistrationAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractRegistrationAddressQuery, GetContractRegistrationAddressQueryVariables>(GetContractRegistrationAddressDocument, options);
      }
export function useGetContractRegistrationAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractRegistrationAddressQuery, GetContractRegistrationAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractRegistrationAddressQuery, GetContractRegistrationAddressQueryVariables>(GetContractRegistrationAddressDocument, options);
        }
export function useGetContractRegistrationAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractRegistrationAddressQuery, GetContractRegistrationAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractRegistrationAddressQuery, GetContractRegistrationAddressQueryVariables>(GetContractRegistrationAddressDocument, options);
        }
export type GetContractRegistrationAddressQueryHookResult = ReturnType<typeof useGetContractRegistrationAddressQuery>;
export type GetContractRegistrationAddressLazyQueryHookResult = ReturnType<typeof useGetContractRegistrationAddressLazyQuery>;
export type GetContractRegistrationAddressSuspenseQueryHookResult = ReturnType<typeof useGetContractRegistrationAddressSuspenseQuery>;
export type GetContractRegistrationAddressQueryResult = Apollo.QueryResult<GetContractRegistrationAddressQuery, GetContractRegistrationAddressQueryVariables>;
export const GetStaticFxRatesDocument = gql`
    query getStaticFXRates($from: Currency!) {
  staticFXRates: getStaticFXRates(from: $from) {
    id
    from
    to
    rate
  }
}
    `;

/**
 * __useGetStaticFxRatesQuery__
 *
 * To run a query within a React component, call `useGetStaticFxRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaticFxRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaticFxRatesQuery({
 *   variables: {
 *      from: // value for 'from'
 *   },
 * });
 */
export function useGetStaticFxRatesQuery(baseOptions: Apollo.QueryHookOptions<GetStaticFxRatesQuery, GetStaticFxRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStaticFxRatesQuery, GetStaticFxRatesQueryVariables>(GetStaticFxRatesDocument, options);
      }
export function useGetStaticFxRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStaticFxRatesQuery, GetStaticFxRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStaticFxRatesQuery, GetStaticFxRatesQueryVariables>(GetStaticFxRatesDocument, options);
        }
export function useGetStaticFxRatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStaticFxRatesQuery, GetStaticFxRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStaticFxRatesQuery, GetStaticFxRatesQueryVariables>(GetStaticFxRatesDocument, options);
        }
export type GetStaticFxRatesQueryHookResult = ReturnType<typeof useGetStaticFxRatesQuery>;
export type GetStaticFxRatesLazyQueryHookResult = ReturnType<typeof useGetStaticFxRatesLazyQuery>;
export type GetStaticFxRatesSuspenseQueryHookResult = ReturnType<typeof useGetStaticFxRatesSuspenseQuery>;
export type GetStaticFxRatesQueryResult = Apollo.QueryResult<GetStaticFxRatesQuery, GetStaticFxRatesQueryVariables>;
export const GetEmailAndTwoFaCategoryPreferencesDocument = gql`
    query getEmailAndTwoFACategoryPreferences {
  viewer(applyPendingChanges: false) {
    ... on Individual {
      id
      emailCategoryPreferences {
        id
        active
        category {
          id
          name
          description
          mandatory
        }
      }
      primaryTwoFAMethod
      availableTwoFAMethods {
        method
        isEnabled
        isPrimary
      }
      phone
    }
  }
}
    `;

/**
 * __useGetEmailAndTwoFaCategoryPreferencesQuery__
 *
 * To run a query within a React component, call `useGetEmailAndTwoFaCategoryPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailAndTwoFaCategoryPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailAndTwoFaCategoryPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmailAndTwoFaCategoryPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailAndTwoFaCategoryPreferencesQuery, GetEmailAndTwoFaCategoryPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailAndTwoFaCategoryPreferencesQuery, GetEmailAndTwoFaCategoryPreferencesQueryVariables>(GetEmailAndTwoFaCategoryPreferencesDocument, options);
      }
export function useGetEmailAndTwoFaCategoryPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailAndTwoFaCategoryPreferencesQuery, GetEmailAndTwoFaCategoryPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailAndTwoFaCategoryPreferencesQuery, GetEmailAndTwoFaCategoryPreferencesQueryVariables>(GetEmailAndTwoFaCategoryPreferencesDocument, options);
        }
export function useGetEmailAndTwoFaCategoryPreferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmailAndTwoFaCategoryPreferencesQuery, GetEmailAndTwoFaCategoryPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailAndTwoFaCategoryPreferencesQuery, GetEmailAndTwoFaCategoryPreferencesQueryVariables>(GetEmailAndTwoFaCategoryPreferencesDocument, options);
        }
export type GetEmailAndTwoFaCategoryPreferencesQueryHookResult = ReturnType<typeof useGetEmailAndTwoFaCategoryPreferencesQuery>;
export type GetEmailAndTwoFaCategoryPreferencesLazyQueryHookResult = ReturnType<typeof useGetEmailAndTwoFaCategoryPreferencesLazyQuery>;
export type GetEmailAndTwoFaCategoryPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetEmailAndTwoFaCategoryPreferencesSuspenseQuery>;
export type GetEmailAndTwoFaCategoryPreferencesQueryResult = Apollo.QueryResult<GetEmailAndTwoFaCategoryPreferencesQuery, GetEmailAndTwoFaCategoryPreferencesQueryVariables>;
export const GetTransferFxSupportedCurrenciesDocument = gql`
    query getTransferFXSupportedCurrencies($fromCurrency: Currency) {
  getExternalTransferFXCurrencies(fromCurrency: $fromCurrency) {
    id
    name
    currency
    decimalPositions
    rails
  }
}
    `;

/**
 * __useGetTransferFxSupportedCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetTransferFxSupportedCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferFxSupportedCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferFxSupportedCurrenciesQuery({
 *   variables: {
 *      fromCurrency: // value for 'fromCurrency'
 *   },
 * });
 */
export function useGetTransferFxSupportedCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<GetTransferFxSupportedCurrenciesQuery, GetTransferFxSupportedCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferFxSupportedCurrenciesQuery, GetTransferFxSupportedCurrenciesQueryVariables>(GetTransferFxSupportedCurrenciesDocument, options);
      }
export function useGetTransferFxSupportedCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferFxSupportedCurrenciesQuery, GetTransferFxSupportedCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferFxSupportedCurrenciesQuery, GetTransferFxSupportedCurrenciesQueryVariables>(GetTransferFxSupportedCurrenciesDocument, options);
        }
export function useGetTransferFxSupportedCurrenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransferFxSupportedCurrenciesQuery, GetTransferFxSupportedCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransferFxSupportedCurrenciesQuery, GetTransferFxSupportedCurrenciesQueryVariables>(GetTransferFxSupportedCurrenciesDocument, options);
        }
export type GetTransferFxSupportedCurrenciesQueryHookResult = ReturnType<typeof useGetTransferFxSupportedCurrenciesQuery>;
export type GetTransferFxSupportedCurrenciesLazyQueryHookResult = ReturnType<typeof useGetTransferFxSupportedCurrenciesLazyQuery>;
export type GetTransferFxSupportedCurrenciesSuspenseQueryHookResult = ReturnType<typeof useGetTransferFxSupportedCurrenciesSuspenseQuery>;
export type GetTransferFxSupportedCurrenciesQueryResult = Apollo.QueryResult<GetTransferFxSupportedCurrenciesQuery, GetTransferFxSupportedCurrenciesQueryVariables>;
export const GetReservedFxRateDocument = gql`
    query getReservedFXRate($accountId: ID, $from: Currency!, $to: Currency!, $forLocalPay: Boolean, $forTldr: Boolean) {
  getReservedFXRate(
    accountId: $accountId
    from: $from
    to: $to
    forLocalPay: $forLocalPay
    forTldr: $forTldr
  ) {
    id
    from
    to
    expirationTime
    rate
  }
}
    `;

/**
 * __useGetReservedFxRateQuery__
 *
 * To run a query within a React component, call `useGetReservedFxRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservedFxRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservedFxRateQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      forLocalPay: // value for 'forLocalPay'
 *      forTldr: // value for 'forTldr'
 *   },
 * });
 */
export function useGetReservedFxRateQuery(baseOptions: Apollo.QueryHookOptions<GetReservedFxRateQuery, GetReservedFxRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservedFxRateQuery, GetReservedFxRateQueryVariables>(GetReservedFxRateDocument, options);
      }
export function useGetReservedFxRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservedFxRateQuery, GetReservedFxRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservedFxRateQuery, GetReservedFxRateQueryVariables>(GetReservedFxRateDocument, options);
        }
export function useGetReservedFxRateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReservedFxRateQuery, GetReservedFxRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReservedFxRateQuery, GetReservedFxRateQueryVariables>(GetReservedFxRateDocument, options);
        }
export type GetReservedFxRateQueryHookResult = ReturnType<typeof useGetReservedFxRateQuery>;
export type GetReservedFxRateLazyQueryHookResult = ReturnType<typeof useGetReservedFxRateLazyQuery>;
export type GetReservedFxRateSuspenseQueryHookResult = ReturnType<typeof useGetReservedFxRateSuspenseQuery>;
export type GetReservedFxRateQueryResult = Apollo.QueryResult<GetReservedFxRateQuery, GetReservedFxRateQueryVariables>;
export const GetVibanNameMismatchesDocument = gql`
    query getVibanNameMismatches($contractId: ID!, $statuses: [VibanNameMismatchResolution], $search: String, $pendingFirst: Boolean, $limit: Int, $offset: Int, $orderBy: OrderBy, $orderDirection: OrderDirection) {
  vibanNameMismatches(
    contractId: $contractId
    statuses: $statuses
    search: $search
    pendingFirst: $pendingFirst
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    orderDirection: $orderDirection
  ) {
    id
    amount
    currency
    beneficiaryNameOnFile
    incomingBeneficiaryName
    reference
    createdAt
    updatedAt
    resolvedDate
    isResolved
    status
    virtualAccount {
      id
      iban
      parentId
    }
  }
}
    `;

/**
 * __useGetVibanNameMismatchesQuery__
 *
 * To run a query within a React component, call `useGetVibanNameMismatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVibanNameMismatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVibanNameMismatchesQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      statuses: // value for 'statuses'
 *      search: // value for 'search'
 *      pendingFirst: // value for 'pendingFirst'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *   },
 * });
 */
export function useGetVibanNameMismatchesQuery(baseOptions: Apollo.QueryHookOptions<GetVibanNameMismatchesQuery, GetVibanNameMismatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVibanNameMismatchesQuery, GetVibanNameMismatchesQueryVariables>(GetVibanNameMismatchesDocument, options);
      }
export function useGetVibanNameMismatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVibanNameMismatchesQuery, GetVibanNameMismatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVibanNameMismatchesQuery, GetVibanNameMismatchesQueryVariables>(GetVibanNameMismatchesDocument, options);
        }
export function useGetVibanNameMismatchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVibanNameMismatchesQuery, GetVibanNameMismatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVibanNameMismatchesQuery, GetVibanNameMismatchesQueryVariables>(GetVibanNameMismatchesDocument, options);
        }
export type GetVibanNameMismatchesQueryHookResult = ReturnType<typeof useGetVibanNameMismatchesQuery>;
export type GetVibanNameMismatchesLazyQueryHookResult = ReturnType<typeof useGetVibanNameMismatchesLazyQuery>;
export type GetVibanNameMismatchesSuspenseQueryHookResult = ReturnType<typeof useGetVibanNameMismatchesSuspenseQuery>;
export type GetVibanNameMismatchesQueryResult = Apollo.QueryResult<GetVibanNameMismatchesQuery, GetVibanNameMismatchesQueryVariables>;
export const GetVibanNameMismatchesCountDocument = gql`
    query getVibanNameMismatchesCount($contractId: ID!, $statuses: [VibanNameMismatchResolution], $search: String) {
  vibanNameMismatchesCount(
    contractId: $contractId
    statuses: $statuses
    search: $search
  )
}
    `;

/**
 * __useGetVibanNameMismatchesCountQuery__
 *
 * To run a query within a React component, call `useGetVibanNameMismatchesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVibanNameMismatchesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVibanNameMismatchesCountQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      statuses: // value for 'statuses'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetVibanNameMismatchesCountQuery(baseOptions: Apollo.QueryHookOptions<GetVibanNameMismatchesCountQuery, GetVibanNameMismatchesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVibanNameMismatchesCountQuery, GetVibanNameMismatchesCountQueryVariables>(GetVibanNameMismatchesCountDocument, options);
      }
export function useGetVibanNameMismatchesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVibanNameMismatchesCountQuery, GetVibanNameMismatchesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVibanNameMismatchesCountQuery, GetVibanNameMismatchesCountQueryVariables>(GetVibanNameMismatchesCountDocument, options);
        }
export function useGetVibanNameMismatchesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVibanNameMismatchesCountQuery, GetVibanNameMismatchesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVibanNameMismatchesCountQuery, GetVibanNameMismatchesCountQueryVariables>(GetVibanNameMismatchesCountDocument, options);
        }
export type GetVibanNameMismatchesCountQueryHookResult = ReturnType<typeof useGetVibanNameMismatchesCountQuery>;
export type GetVibanNameMismatchesCountLazyQueryHookResult = ReturnType<typeof useGetVibanNameMismatchesCountLazyQuery>;
export type GetVibanNameMismatchesCountSuspenseQueryHookResult = ReturnType<typeof useGetVibanNameMismatchesCountSuspenseQuery>;
export type GetVibanNameMismatchesCountQueryResult = Apollo.QueryResult<GetVibanNameMismatchesCountQuery, GetVibanNameMismatchesCountQueryVariables>;
export const GetDefaultCardLimitsDocument = gql`
    query getDefaultCardLimits($contractId: ID) {
  cardsAllowedLimitsAndMaxes(contractId: $contractId) {
    defaults {
      defaultCardDailyContactlessPurchaseLimit
      defaultCardDailyInternetPurchaseLimit
      defaultCardDailyPurchaseLimit
      defaultCardDailyWithdrawalLimit
      defaultCardMonthlyContactlessPurchaseLimit
      defaultCardMonthlyInternetPurchaseLimit
      defaultCardMonthlyPurchaseLimit
      defaultCardMonthlyWithdrawalLimit
      defaultCardTransactionContactlessPurchaseLimit
      defaultCardTransactionInternetPurchaseLimit
      defaultCardTransactionPurchaseLimit
      defaultCardTransactionWithdrawalLimit
      defaultCardWeeklyContactlessPurchaseLimit
      defaultCardWeeklyInternetPurchaseLimit
      defaultCardWeeklyPurchaseLimit
      defaultCardWeeklyWithdrawalLimit
    }
    maxes {
      maxCardDailyContactlessPurchaseLimit
      maxCardDailyInternetPurchaseLimit
      maxCardDailyPurchaseLimit
      maxCardDailyContactlessPurchaseLimit
      maxCardDailyWithdrawalLimit
      maxCardMonthlyContactlessPurchaseLimit
      maxCardMonthlyInternetPurchaseLimit
      maxCardMonthlyPurchaseLimit
      maxCardMonthlyWithdrawalLimit
      maxCardTransactionContactlessPurchaseLimit
      maxCardTransactionInternetPurchaseLimit
      maxCardTransactionPurchaseLimit
      maxCardTransactionWithdrawalLimit
      maxCardWeeklyContactlessPurchaseLimit
      maxCardWeeklyInternetPurchaseLimit
      maxCardWeeklyPurchaseLimit
      maxCardWeeklyWithdrawalLimit
    }
    weeklyLimitsEnabled
  }
}
    `;

/**
 * __useGetDefaultCardLimitsQuery__
 *
 * To run a query within a React component, call `useGetDefaultCardLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultCardLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultCardLimitsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetDefaultCardLimitsQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultCardLimitsQuery, GetDefaultCardLimitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultCardLimitsQuery, GetDefaultCardLimitsQueryVariables>(GetDefaultCardLimitsDocument, options);
      }
export function useGetDefaultCardLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultCardLimitsQuery, GetDefaultCardLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultCardLimitsQuery, GetDefaultCardLimitsQueryVariables>(GetDefaultCardLimitsDocument, options);
        }
export function useGetDefaultCardLimitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDefaultCardLimitsQuery, GetDefaultCardLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDefaultCardLimitsQuery, GetDefaultCardLimitsQueryVariables>(GetDefaultCardLimitsDocument, options);
        }
export type GetDefaultCardLimitsQueryHookResult = ReturnType<typeof useGetDefaultCardLimitsQuery>;
export type GetDefaultCardLimitsLazyQueryHookResult = ReturnType<typeof useGetDefaultCardLimitsLazyQuery>;
export type GetDefaultCardLimitsSuspenseQueryHookResult = ReturnType<typeof useGetDefaultCardLimitsSuspenseQuery>;
export type GetDefaultCardLimitsQueryResult = Apollo.QueryResult<GetDefaultCardLimitsQuery, GetDefaultCardLimitsQueryVariables>;
export const GetPendingPreassessmentsDocument = gql`
    query getPendingPreassessments {
  preAssessments(status: new) {
    createdAt
    companyInfoRegisteredName
    companyInfoCountryOfRegistration
    regulatoryInfoName
    regulatoryInfoLicenseNumber
    generalQuestionsBusinessActivities
    generalQuestionsOperatingCountries
    generalQuestionsPaymentProviders
    incomingEstimatedMonthlyAmount
    incomingClients
    outgoingEstimatedMonthlyAmount
    outgoingClients
    currencyAndVolume
    contactPersonFullName
    contactPersonEmail
    contactPersonPhoneNumber
    companyAnnualIncome
    companyAnnualIncomeCurrency
  }
}
    `;

/**
 * __useGetPendingPreassessmentsQuery__
 *
 * To run a query within a React component, call `useGetPendingPreassessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingPreassessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingPreassessmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingPreassessmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingPreassessmentsQuery, GetPendingPreassessmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingPreassessmentsQuery, GetPendingPreassessmentsQueryVariables>(GetPendingPreassessmentsDocument, options);
      }
export function useGetPendingPreassessmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingPreassessmentsQuery, GetPendingPreassessmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingPreassessmentsQuery, GetPendingPreassessmentsQueryVariables>(GetPendingPreassessmentsDocument, options);
        }
export function useGetPendingPreassessmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPendingPreassessmentsQuery, GetPendingPreassessmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingPreassessmentsQuery, GetPendingPreassessmentsQueryVariables>(GetPendingPreassessmentsDocument, options);
        }
export type GetPendingPreassessmentsQueryHookResult = ReturnType<typeof useGetPendingPreassessmentsQuery>;
export type GetPendingPreassessmentsLazyQueryHookResult = ReturnType<typeof useGetPendingPreassessmentsLazyQuery>;
export type GetPendingPreassessmentsSuspenseQueryHookResult = ReturnType<typeof useGetPendingPreassessmentsSuspenseQuery>;
export type GetPendingPreassessmentsQueryResult = Apollo.QueryResult<GetPendingPreassessmentsQuery, GetPendingPreassessmentsQueryVariables>;
export const GetClientsDocument = gql`
    query getClients($contractId: ID!, $search: String, $limit: Int, $offset: Int, $orderBy: ContractPaymentRecipientOrderByType, $orderDirection: OrderDirection) {
  contractPaymentRecipients(
    contractId: $contractId
    search: $search
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    orderDirection: $orderDirection
  ) {
    id
    type
    firstName
    lastName
    companyName
    iban
    accountNo
    bankName
    currency
    bankBic
    bankBranchId
    bankClearingMemberId
    accountNoType
    taxId
    phone
    alias
    commentTemplate
  }
}
    `;

/**
 * __useGetClientsQuery__
 *
 * To run a query within a React component, call `useGetClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *   },
 * });
 */
export function useGetClientsQuery(baseOptions: Apollo.QueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
      }
export function useGetClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
export function useGetClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
export type GetClientsQueryHookResult = ReturnType<typeof useGetClientsQuery>;
export type GetClientsLazyQueryHookResult = ReturnType<typeof useGetClientsLazyQuery>;
export type GetClientsSuspenseQueryHookResult = ReturnType<typeof useGetClientsSuspenseQuery>;
export type GetClientsQueryResult = Apollo.QueryResult<GetClientsQuery, GetClientsQueryVariables>;
export const GetClientsCountDocument = gql`
    query getClientsCount($contractId: ID!, $search: String) {
  contractPaymentRecipientsCount(contractId: $contractId, search: $search)
}
    `;

/**
 * __useGetClientsCountQuery__
 *
 * To run a query within a React component, call `useGetClientsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsCountQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetClientsCountQuery(baseOptions: Apollo.QueryHookOptions<GetClientsCountQuery, GetClientsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsCountQuery, GetClientsCountQueryVariables>(GetClientsCountDocument, options);
      }
export function useGetClientsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsCountQuery, GetClientsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsCountQuery, GetClientsCountQueryVariables>(GetClientsCountDocument, options);
        }
export function useGetClientsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsCountQuery, GetClientsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsCountQuery, GetClientsCountQueryVariables>(GetClientsCountDocument, options);
        }
export type GetClientsCountQueryHookResult = ReturnType<typeof useGetClientsCountQuery>;
export type GetClientsCountLazyQueryHookResult = ReturnType<typeof useGetClientsCountLazyQuery>;
export type GetClientsCountSuspenseQueryHookResult = ReturnType<typeof useGetClientsCountSuspenseQuery>;
export type GetClientsCountQueryResult = Apollo.QueryResult<GetClientsCountQuery, GetClientsCountQueryVariables>;
export const GetContractBasicInfoDocument = gql`
    query getContractBasicInfo($id: ID!) {
  contract(id: $id) {
    id
    type
    isIntroducingPartner
    referralLink
    ownerType
    allowedCryptoPayments
    owner {
      ... on LegalEntity {
        id
        companyName
        taxId
      }
      ... on Individual {
        fullName
      }
    }
    missingInfoDetails {
      hasMissingInfo
      id
    }
  }
}
    `;

/**
 * __useGetContractBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetContractBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractBasicInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContractBasicInfoQuery(baseOptions: Apollo.QueryHookOptions<GetContractBasicInfoQuery, GetContractBasicInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractBasicInfoQuery, GetContractBasicInfoQueryVariables>(GetContractBasicInfoDocument, options);
      }
export function useGetContractBasicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractBasicInfoQuery, GetContractBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractBasicInfoQuery, GetContractBasicInfoQueryVariables>(GetContractBasicInfoDocument, options);
        }
export function useGetContractBasicInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractBasicInfoQuery, GetContractBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractBasicInfoQuery, GetContractBasicInfoQueryVariables>(GetContractBasicInfoDocument, options);
        }
export type GetContractBasicInfoQueryHookResult = ReturnType<typeof useGetContractBasicInfoQuery>;
export type GetContractBasicInfoLazyQueryHookResult = ReturnType<typeof useGetContractBasicInfoLazyQuery>;
export type GetContractBasicInfoSuspenseQueryHookResult = ReturnType<typeof useGetContractBasicInfoSuspenseQuery>;
export type GetContractBasicInfoQueryResult = Apollo.QueryResult<GetContractBasicInfoQuery, GetContractBasicInfoQueryVariables>;
export const GetContractInformationRequestsDocument = gql`
    query getContractInformationRequests($contractId: ID) {
  contractInformationRequests(contractId: $contractId) {
    id
    type
    status
    title
    clientNote
    documentType
  }
}
    `;

/**
 * __useGetContractInformationRequestsQuery__
 *
 * To run a query within a React component, call `useGetContractInformationRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractInformationRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractInformationRequestsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetContractInformationRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetContractInformationRequestsQuery, GetContractInformationRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractInformationRequestsQuery, GetContractInformationRequestsQueryVariables>(GetContractInformationRequestsDocument, options);
      }
export function useGetContractInformationRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractInformationRequestsQuery, GetContractInformationRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractInformationRequestsQuery, GetContractInformationRequestsQueryVariables>(GetContractInformationRequestsDocument, options);
        }
export function useGetContractInformationRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractInformationRequestsQuery, GetContractInformationRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractInformationRequestsQuery, GetContractInformationRequestsQueryVariables>(GetContractInformationRequestsDocument, options);
        }
export type GetContractInformationRequestsQueryHookResult = ReturnType<typeof useGetContractInformationRequestsQuery>;
export type GetContractInformationRequestsLazyQueryHookResult = ReturnType<typeof useGetContractInformationRequestsLazyQuery>;
export type GetContractInformationRequestsSuspenseQueryHookResult = ReturnType<typeof useGetContractInformationRequestsSuspenseQuery>;
export type GetContractInformationRequestsQueryResult = Apollo.QueryResult<GetContractInformationRequestsQuery, GetContractInformationRequestsQueryVariables>;
export const GetContractInformationRequestDocument = gql`
    query getContractInformationRequest($id: ID!) {
  contractInformationRequest(id: $id) {
    id
    status
    type
    title
    note
    clientNote
    createdAt
    filledAt
    documentType
    rejectReason
    attachments {
      fileName
      mimeType
      url
    }
    documents {
      id
      type
      firstSide {
        fileName
        mimeType
        url
      }
      secondSide {
        fileName
        mimeType
        url
      }
    }
  }
}
    `;

/**
 * __useGetContractInformationRequestQuery__
 *
 * To run a query within a React component, call `useGetContractInformationRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractInformationRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractInformationRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContractInformationRequestQuery(baseOptions: Apollo.QueryHookOptions<GetContractInformationRequestQuery, GetContractInformationRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractInformationRequestQuery, GetContractInformationRequestQueryVariables>(GetContractInformationRequestDocument, options);
      }
export function useGetContractInformationRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractInformationRequestQuery, GetContractInformationRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractInformationRequestQuery, GetContractInformationRequestQueryVariables>(GetContractInformationRequestDocument, options);
        }
export function useGetContractInformationRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractInformationRequestQuery, GetContractInformationRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractInformationRequestQuery, GetContractInformationRequestQueryVariables>(GetContractInformationRequestDocument, options);
        }
export type GetContractInformationRequestQueryHookResult = ReturnType<typeof useGetContractInformationRequestQuery>;
export type GetContractInformationRequestLazyQueryHookResult = ReturnType<typeof useGetContractInformationRequestLazyQuery>;
export type GetContractInformationRequestSuspenseQueryHookResult = ReturnType<typeof useGetContractInformationRequestSuspenseQuery>;
export type GetContractInformationRequestQueryResult = Apollo.QueryResult<GetContractInformationRequestQuery, GetContractInformationRequestQueryVariables>;
export const AuthPersonsVideoVerificationsDocument = gql`
    query authPersonsVideoVerifications($contractId: ID!) {
  contract(id: $contractId) {
    id
    status
    authorizedPersons(isSignatory: true) {
      person {
        id
        isVerified
        fullName
        appointments {
          id
          status
          createdAt
          startTime
        }
      }
    }
  }
}
    `;

/**
 * __useAuthPersonsVideoVerificationsQuery__
 *
 * To run a query within a React component, call `useAuthPersonsVideoVerificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthPersonsVideoVerificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthPersonsVideoVerificationsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useAuthPersonsVideoVerificationsQuery(baseOptions: Apollo.QueryHookOptions<AuthPersonsVideoVerificationsQuery, AuthPersonsVideoVerificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthPersonsVideoVerificationsQuery, AuthPersonsVideoVerificationsQueryVariables>(AuthPersonsVideoVerificationsDocument, options);
      }
export function useAuthPersonsVideoVerificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthPersonsVideoVerificationsQuery, AuthPersonsVideoVerificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthPersonsVideoVerificationsQuery, AuthPersonsVideoVerificationsQueryVariables>(AuthPersonsVideoVerificationsDocument, options);
        }
export function useAuthPersonsVideoVerificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthPersonsVideoVerificationsQuery, AuthPersonsVideoVerificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthPersonsVideoVerificationsQuery, AuthPersonsVideoVerificationsQueryVariables>(AuthPersonsVideoVerificationsDocument, options);
        }
export type AuthPersonsVideoVerificationsQueryHookResult = ReturnType<typeof useAuthPersonsVideoVerificationsQuery>;
export type AuthPersonsVideoVerificationsLazyQueryHookResult = ReturnType<typeof useAuthPersonsVideoVerificationsLazyQuery>;
export type AuthPersonsVideoVerificationsSuspenseQueryHookResult = ReturnType<typeof useAuthPersonsVideoVerificationsSuspenseQuery>;
export type AuthPersonsVideoVerificationsQueryResult = Apollo.QueryResult<AuthPersonsVideoVerificationsQuery, AuthPersonsVideoVerificationsQueryVariables>;
export const GetAppointmentsDocument = gql`
    query getAppointments {
  viewer {
    ... on Individual {
      appointments {
        id
        status
        startTime
      }
    }
  }
}
    `;

/**
 * __useGetAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
      }
export function useGetAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
        }
export function useGetAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
        }
export type GetAppointmentsQueryHookResult = ReturnType<typeof useGetAppointmentsQuery>;
export type GetAppointmentsLazyQueryHookResult = ReturnType<typeof useGetAppointmentsLazyQuery>;
export type GetAppointmentsSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentsSuspenseQuery>;
export type GetAppointmentsQueryResult = Apollo.QueryResult<GetAppointmentsQuery, GetAppointmentsQueryVariables>;
export const GetBatchRecordsCountDocument = gql`
    query getBatchRecordsCount($batchPaymentId: ID!) {
  batchPaymentRecordsCount(batchPaymentId: $batchPaymentId)
}
    `;

/**
 * __useGetBatchRecordsCountQuery__
 *
 * To run a query within a React component, call `useGetBatchRecordsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBatchRecordsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBatchRecordsCountQuery({
 *   variables: {
 *      batchPaymentId: // value for 'batchPaymentId'
 *   },
 * });
 */
export function useGetBatchRecordsCountQuery(baseOptions: Apollo.QueryHookOptions<GetBatchRecordsCountQuery, GetBatchRecordsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBatchRecordsCountQuery, GetBatchRecordsCountQueryVariables>(GetBatchRecordsCountDocument, options);
      }
export function useGetBatchRecordsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBatchRecordsCountQuery, GetBatchRecordsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBatchRecordsCountQuery, GetBatchRecordsCountQueryVariables>(GetBatchRecordsCountDocument, options);
        }
export function useGetBatchRecordsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBatchRecordsCountQuery, GetBatchRecordsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBatchRecordsCountQuery, GetBatchRecordsCountQueryVariables>(GetBatchRecordsCountDocument, options);
        }
export type GetBatchRecordsCountQueryHookResult = ReturnType<typeof useGetBatchRecordsCountQuery>;
export type GetBatchRecordsCountLazyQueryHookResult = ReturnType<typeof useGetBatchRecordsCountLazyQuery>;
export type GetBatchRecordsCountSuspenseQueryHookResult = ReturnType<typeof useGetBatchRecordsCountSuspenseQuery>;
export type GetBatchRecordsCountQueryResult = Apollo.QueryResult<GetBatchRecordsCountQuery, GetBatchRecordsCountQueryVariables>;
export const GetBatchPaymentRecordsDocument = gql`
    query getBatchPaymentRecords($batchPaymentId: ID!, $limit: Int, $offset: Int) {
  batchPaymentRecords(
    batchPaymentId: $batchPaymentId
    limit: $limit
    offset: $offset
  ) {
    id
    amount
    currency
    beneficiaryName
    beneficiaryAccountId
    bankBic
    priority
    reference
    status
    isValid
    payoutAmount
    payoutCurrency
    useLocalAchPayout
    fixedPayoutAmount
    bankClearingMemberId
    bankBranchId
    bankBranchName
    purposeCode
    beneficiaryPhone
    beneficiaryEmail
    chargeBearer
  }
}
    `;

/**
 * __useGetBatchPaymentRecordsQuery__
 *
 * To run a query within a React component, call `useGetBatchPaymentRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBatchPaymentRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBatchPaymentRecordsQuery({
 *   variables: {
 *      batchPaymentId: // value for 'batchPaymentId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetBatchPaymentRecordsQuery(baseOptions: Apollo.QueryHookOptions<GetBatchPaymentRecordsQuery, GetBatchPaymentRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBatchPaymentRecordsQuery, GetBatchPaymentRecordsQueryVariables>(GetBatchPaymentRecordsDocument, options);
      }
export function useGetBatchPaymentRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBatchPaymentRecordsQuery, GetBatchPaymentRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBatchPaymentRecordsQuery, GetBatchPaymentRecordsQueryVariables>(GetBatchPaymentRecordsDocument, options);
        }
export function useGetBatchPaymentRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBatchPaymentRecordsQuery, GetBatchPaymentRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBatchPaymentRecordsQuery, GetBatchPaymentRecordsQueryVariables>(GetBatchPaymentRecordsDocument, options);
        }
export type GetBatchPaymentRecordsQueryHookResult = ReturnType<typeof useGetBatchPaymentRecordsQuery>;
export type GetBatchPaymentRecordsLazyQueryHookResult = ReturnType<typeof useGetBatchPaymentRecordsLazyQuery>;
export type GetBatchPaymentRecordsSuspenseQueryHookResult = ReturnType<typeof useGetBatchPaymentRecordsSuspenseQuery>;
export type GetBatchPaymentRecordsQueryResult = Apollo.QueryResult<GetBatchPaymentRecordsQuery, GetBatchPaymentRecordsQueryVariables>;
export const GetIntroducerPayoutInfoDocument = gql`
    query getIntroducerPayoutInfo($id: ID!) {
  contract(id: $id) {
    introducerPayoutInfo {
      qualifyingRevenue
      pending
      paid
      currency
      lastFetched
    }
    commissionSettings {
      schedule
      nextPayoutDate
      payoutAccount {
        id
        iban
        alias
        currency
      }
      externalPayoutAccount {
        name
        iban
        accountNo
        currency
      }
    }
  }
}
    `;

/**
 * __useGetIntroducerPayoutInfoQuery__
 *
 * To run a query within a React component, call `useGetIntroducerPayoutInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntroducerPayoutInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntroducerPayoutInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIntroducerPayoutInfoQuery(baseOptions: Apollo.QueryHookOptions<GetIntroducerPayoutInfoQuery, GetIntroducerPayoutInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntroducerPayoutInfoQuery, GetIntroducerPayoutInfoQueryVariables>(GetIntroducerPayoutInfoDocument, options);
      }
export function useGetIntroducerPayoutInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntroducerPayoutInfoQuery, GetIntroducerPayoutInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntroducerPayoutInfoQuery, GetIntroducerPayoutInfoQueryVariables>(GetIntroducerPayoutInfoDocument, options);
        }
export function useGetIntroducerPayoutInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntroducerPayoutInfoQuery, GetIntroducerPayoutInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntroducerPayoutInfoQuery, GetIntroducerPayoutInfoQueryVariables>(GetIntroducerPayoutInfoDocument, options);
        }
export type GetIntroducerPayoutInfoQueryHookResult = ReturnType<typeof useGetIntroducerPayoutInfoQuery>;
export type GetIntroducerPayoutInfoLazyQueryHookResult = ReturnType<typeof useGetIntroducerPayoutInfoLazyQuery>;
export type GetIntroducerPayoutInfoSuspenseQueryHookResult = ReturnType<typeof useGetIntroducerPayoutInfoSuspenseQuery>;
export type GetIntroducerPayoutInfoQueryResult = Apollo.QueryResult<GetIntroducerPayoutInfoQuery, GetIntroducerPayoutInfoQueryVariables>;
export const GetSuccessFeePayoutsDocument = gql`
    query getSuccessFeePayouts($contractId: ID) {
  successFeePayouts(contractId: $contractId) {
    id
    status
    account {
      id
      iban
      accountNumber
      alias
    }
    finalValue
    currency
    executedAt
    to {
      name
      accountNo
      iban
    }
  }
}
    `;

/**
 * __useGetSuccessFeePayoutsQuery__
 *
 * To run a query within a React component, call `useGetSuccessFeePayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuccessFeePayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuccessFeePayoutsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetSuccessFeePayoutsQuery(baseOptions?: Apollo.QueryHookOptions<GetSuccessFeePayoutsQuery, GetSuccessFeePayoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuccessFeePayoutsQuery, GetSuccessFeePayoutsQueryVariables>(GetSuccessFeePayoutsDocument, options);
      }
export function useGetSuccessFeePayoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuccessFeePayoutsQuery, GetSuccessFeePayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuccessFeePayoutsQuery, GetSuccessFeePayoutsQueryVariables>(GetSuccessFeePayoutsDocument, options);
        }
export function useGetSuccessFeePayoutsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSuccessFeePayoutsQuery, GetSuccessFeePayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuccessFeePayoutsQuery, GetSuccessFeePayoutsQueryVariables>(GetSuccessFeePayoutsDocument, options);
        }
export type GetSuccessFeePayoutsQueryHookResult = ReturnType<typeof useGetSuccessFeePayoutsQuery>;
export type GetSuccessFeePayoutsLazyQueryHookResult = ReturnType<typeof useGetSuccessFeePayoutsLazyQuery>;
export type GetSuccessFeePayoutsSuspenseQueryHookResult = ReturnType<typeof useGetSuccessFeePayoutsSuspenseQuery>;
export type GetSuccessFeePayoutsQueryResult = Apollo.QueryResult<GetSuccessFeePayoutsQuery, GetSuccessFeePayoutsQueryVariables>;
export const GetSuccessFeePayoutsCountDocument = gql`
    query getSuccessFeePayoutsCount($contractId: ID) {
  successFeePayoutsCount(contractId: $contractId)
}
    `;

/**
 * __useGetSuccessFeePayoutsCountQuery__
 *
 * To run a query within a React component, call `useGetSuccessFeePayoutsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuccessFeePayoutsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuccessFeePayoutsCountQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetSuccessFeePayoutsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetSuccessFeePayoutsCountQuery, GetSuccessFeePayoutsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuccessFeePayoutsCountQuery, GetSuccessFeePayoutsCountQueryVariables>(GetSuccessFeePayoutsCountDocument, options);
      }
export function useGetSuccessFeePayoutsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuccessFeePayoutsCountQuery, GetSuccessFeePayoutsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuccessFeePayoutsCountQuery, GetSuccessFeePayoutsCountQueryVariables>(GetSuccessFeePayoutsCountDocument, options);
        }
export function useGetSuccessFeePayoutsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSuccessFeePayoutsCountQuery, GetSuccessFeePayoutsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuccessFeePayoutsCountQuery, GetSuccessFeePayoutsCountQueryVariables>(GetSuccessFeePayoutsCountDocument, options);
        }
export type GetSuccessFeePayoutsCountQueryHookResult = ReturnType<typeof useGetSuccessFeePayoutsCountQuery>;
export type GetSuccessFeePayoutsCountLazyQueryHookResult = ReturnType<typeof useGetSuccessFeePayoutsCountLazyQuery>;
export type GetSuccessFeePayoutsCountSuspenseQueryHookResult = ReturnType<typeof useGetSuccessFeePayoutsCountSuspenseQuery>;
export type GetSuccessFeePayoutsCountQueryResult = Apollo.QueryResult<GetSuccessFeePayoutsCountQuery, GetSuccessFeePayoutsCountQueryVariables>;
export const GetSuccessFeePayoutDocument = gql`
    query getSuccessFeePayout($id: String!) {
  successFeePayout(id: $id) {
    id
    status
    account {
      id
      iban
      accountNumber
      alias
    }
    finalValue
    currency
    executedAt
    to {
      name
      accountNo
      iban
    }
  }
}
    `;

/**
 * __useGetSuccessFeePayoutQuery__
 *
 * To run a query within a React component, call `useGetSuccessFeePayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuccessFeePayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuccessFeePayoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSuccessFeePayoutQuery(baseOptions: Apollo.QueryHookOptions<GetSuccessFeePayoutQuery, GetSuccessFeePayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuccessFeePayoutQuery, GetSuccessFeePayoutQueryVariables>(GetSuccessFeePayoutDocument, options);
      }
export function useGetSuccessFeePayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuccessFeePayoutQuery, GetSuccessFeePayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuccessFeePayoutQuery, GetSuccessFeePayoutQueryVariables>(GetSuccessFeePayoutDocument, options);
        }
export function useGetSuccessFeePayoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSuccessFeePayoutQuery, GetSuccessFeePayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuccessFeePayoutQuery, GetSuccessFeePayoutQueryVariables>(GetSuccessFeePayoutDocument, options);
        }
export type GetSuccessFeePayoutQueryHookResult = ReturnType<typeof useGetSuccessFeePayoutQuery>;
export type GetSuccessFeePayoutLazyQueryHookResult = ReturnType<typeof useGetSuccessFeePayoutLazyQuery>;
export type GetSuccessFeePayoutSuspenseQueryHookResult = ReturnType<typeof useGetSuccessFeePayoutSuspenseQuery>;
export type GetSuccessFeePayoutQueryResult = Apollo.QueryResult<GetSuccessFeePayoutQuery, GetSuccessFeePayoutQueryVariables>;
export const GetPayoutSuccessFeesDocument = gql`
    query getPayoutSuccessFees($successFeePayoutId: ID, $limit: Int, $offset: Int, $orderBy: SuccessFeeOrderBy, $orderDirection: OrderDirection) {
  successFees(
    successFeePayoutId: $successFeePayoutId
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    orderDirection: $orderDirection
  ) {
    id
    contractId
    relatedSuccessFeeId
    relatedTransactionId
    name
    amountAccountCurrency
    xRate
    feeRevenueChf
    nonRecoverableRevenue
    deductions
    qualifyingRevenue
    percentage
    amount
  }
}
    `;

/**
 * __useGetPayoutSuccessFeesQuery__
 *
 * To run a query within a React component, call `useGetPayoutSuccessFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutSuccessFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutSuccessFeesQuery({
 *   variables: {
 *      successFeePayoutId: // value for 'successFeePayoutId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *   },
 * });
 */
export function useGetPayoutSuccessFeesQuery(baseOptions?: Apollo.QueryHookOptions<GetPayoutSuccessFeesQuery, GetPayoutSuccessFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayoutSuccessFeesQuery, GetPayoutSuccessFeesQueryVariables>(GetPayoutSuccessFeesDocument, options);
      }
export function useGetPayoutSuccessFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayoutSuccessFeesQuery, GetPayoutSuccessFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayoutSuccessFeesQuery, GetPayoutSuccessFeesQueryVariables>(GetPayoutSuccessFeesDocument, options);
        }
export function useGetPayoutSuccessFeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPayoutSuccessFeesQuery, GetPayoutSuccessFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPayoutSuccessFeesQuery, GetPayoutSuccessFeesQueryVariables>(GetPayoutSuccessFeesDocument, options);
        }
export type GetPayoutSuccessFeesQueryHookResult = ReturnType<typeof useGetPayoutSuccessFeesQuery>;
export type GetPayoutSuccessFeesLazyQueryHookResult = ReturnType<typeof useGetPayoutSuccessFeesLazyQuery>;
export type GetPayoutSuccessFeesSuspenseQueryHookResult = ReturnType<typeof useGetPayoutSuccessFeesSuspenseQuery>;
export type GetPayoutSuccessFeesQueryResult = Apollo.QueryResult<GetPayoutSuccessFeesQuery, GetPayoutSuccessFeesQueryVariables>;
export const GetPayoutSuccessFeesCountDocument = gql`
    query getPayoutSuccessFeesCount($successFeePayoutId: ID) {
  successFeesCount(successFeePayoutId: $successFeePayoutId)
}
    `;

/**
 * __useGetPayoutSuccessFeesCountQuery__
 *
 * To run a query within a React component, call `useGetPayoutSuccessFeesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutSuccessFeesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutSuccessFeesCountQuery({
 *   variables: {
 *      successFeePayoutId: // value for 'successFeePayoutId'
 *   },
 * });
 */
export function useGetPayoutSuccessFeesCountQuery(baseOptions?: Apollo.QueryHookOptions<GetPayoutSuccessFeesCountQuery, GetPayoutSuccessFeesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayoutSuccessFeesCountQuery, GetPayoutSuccessFeesCountQueryVariables>(GetPayoutSuccessFeesCountDocument, options);
      }
export function useGetPayoutSuccessFeesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayoutSuccessFeesCountQuery, GetPayoutSuccessFeesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayoutSuccessFeesCountQuery, GetPayoutSuccessFeesCountQueryVariables>(GetPayoutSuccessFeesCountDocument, options);
        }
export function useGetPayoutSuccessFeesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPayoutSuccessFeesCountQuery, GetPayoutSuccessFeesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPayoutSuccessFeesCountQuery, GetPayoutSuccessFeesCountQueryVariables>(GetPayoutSuccessFeesCountDocument, options);
        }
export type GetPayoutSuccessFeesCountQueryHookResult = ReturnType<typeof useGetPayoutSuccessFeesCountQuery>;
export type GetPayoutSuccessFeesCountLazyQueryHookResult = ReturnType<typeof useGetPayoutSuccessFeesCountLazyQuery>;
export type GetPayoutSuccessFeesCountSuspenseQueryHookResult = ReturnType<typeof useGetPayoutSuccessFeesCountSuspenseQuery>;
export type GetPayoutSuccessFeesCountQueryResult = Apollo.QueryResult<GetPayoutSuccessFeesCountQuery, GetPayoutSuccessFeesCountQueryVariables>;
export const GetStandingOrdersDocument = gql`
    query getStandingOrders($accountId: ID, $orderBy: OrderBy, $orderDirection: OrderDirection, $contractId: ID, $statuses: [AccountStatus], $notStatuses: [AccountStatus]) {
  accounts(
    id: $accountId
    contractId: $contractId
    statuses: $statuses
    notStatuses: $notStatuses
  ) {
    currency
    fundsType
    standingOrders(orderBy: $orderBy, orderDirection: $orderDirection) {
      id
      cronDescription
      amount
      payoutAmount
      payoutCurrency
      nextExecutionAt
      deletedAt
      active
      account {
        id
        alias
        currency
        iban
      }
      activationAction {
        ... on BaseAction {
          id
          initiatorName
          signedCount
          signatures {
            id
            isMine
            status
            signedAt
            signatory {
              signatoryRight
              person {
                id
                firstName
                lastName
              }
            }
            action {
              ... on BaseAction {
                id
              }
            }
          }
        }
      }
      cancellationAction {
        ... on BaseAction {
          id
        }
      }
      template {
        beneficiary {
          name
          bankBic
          accountNo
          iban
        }
      }
    }
  }
}
    `;

/**
 * __useGetStandingOrdersQuery__
 *
 * To run a query within a React component, call `useGetStandingOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandingOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandingOrdersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      contractId: // value for 'contractId'
 *      statuses: // value for 'statuses'
 *      notStatuses: // value for 'notStatuses'
 *   },
 * });
 */
export function useGetStandingOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetStandingOrdersQuery, GetStandingOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStandingOrdersQuery, GetStandingOrdersQueryVariables>(GetStandingOrdersDocument, options);
      }
export function useGetStandingOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStandingOrdersQuery, GetStandingOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStandingOrdersQuery, GetStandingOrdersQueryVariables>(GetStandingOrdersDocument, options);
        }
export function useGetStandingOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStandingOrdersQuery, GetStandingOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStandingOrdersQuery, GetStandingOrdersQueryVariables>(GetStandingOrdersDocument, options);
        }
export type GetStandingOrdersQueryHookResult = ReturnType<typeof useGetStandingOrdersQuery>;
export type GetStandingOrdersLazyQueryHookResult = ReturnType<typeof useGetStandingOrdersLazyQuery>;
export type GetStandingOrdersSuspenseQueryHookResult = ReturnType<typeof useGetStandingOrdersSuspenseQuery>;
export type GetStandingOrdersQueryResult = Apollo.QueryResult<GetStandingOrdersQuery, GetStandingOrdersQueryVariables>;
export const GetStandingOrderDocument = gql`
    query getStandingOrder($standingOrderId: ID!) {
  standingOrder(id: $standingOrderId) {
    id
    cronDescription
    amount
    payoutAmount
    payoutCurrency
    createdAt
    deletedAt
    nextExecutionAt
    active
    lowerThreshold
    minRemainingBalance
    activationAction {
      ... on BaseAction {
        id
        initiatorName
        signedCount
        signatures {
          id
          isMine
          status
          signedAt
          signatory {
            signatoryRight
            person {
              id
              firstName
              lastName
            }
          }
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
    }
    cancellationAction {
      ... on BaseAction {
        id
        initiatorName
        signedCount
        signatures {
          id
          isMine
          status
          signedAt
          signatory {
            signatoryRight
            person {
              id
              firstName
              lastName
            }
          }
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
    }
    account {
      id
      alias
      currency
      iban
    }
    template {
      useLocalPay
      comments
      beneficiaryType
      clientReference
      beneficiary {
        name
        bankBic
        accountNo
        iban
        address {
          country
          city
          line1
          zip
          additionalDetails
          region
        }
      }
    }
  }
}
    `;

/**
 * __useGetStandingOrderQuery__
 *
 * To run a query within a React component, call `useGetStandingOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandingOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandingOrderQuery({
 *   variables: {
 *      standingOrderId: // value for 'standingOrderId'
 *   },
 * });
 */
export function useGetStandingOrderQuery(baseOptions: Apollo.QueryHookOptions<GetStandingOrderQuery, GetStandingOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStandingOrderQuery, GetStandingOrderQueryVariables>(GetStandingOrderDocument, options);
      }
export function useGetStandingOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStandingOrderQuery, GetStandingOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStandingOrderQuery, GetStandingOrderQueryVariables>(GetStandingOrderDocument, options);
        }
export function useGetStandingOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStandingOrderQuery, GetStandingOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStandingOrderQuery, GetStandingOrderQueryVariables>(GetStandingOrderDocument, options);
        }
export type GetStandingOrderQueryHookResult = ReturnType<typeof useGetStandingOrderQuery>;
export type GetStandingOrderLazyQueryHookResult = ReturnType<typeof useGetStandingOrderLazyQuery>;
export type GetStandingOrderSuspenseQueryHookResult = ReturnType<typeof useGetStandingOrderSuspenseQuery>;
export type GetStandingOrderQueryResult = Apollo.QueryResult<GetStandingOrderQuery, GetStandingOrderQueryVariables>;
export const GetStandingOrderRunsDocument = gql`
    query getStandingOrderRuns($standingOrderId: ID!, $limit: Int, $offset: Int, $orderBy: OrderBy, $orderDirection: OrderDirection) {
  standingOrder(id: $standingOrderId) {
    id
    runs(
      limit: $limit
      offset: $offset
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      id
      transaction {
        ... on BaseTransaction {
          id
          value
          accountCurrency
          status
        }
      }
      reason
      createdAt
    }
    runsCount
  }
}
    `;

/**
 * __useGetStandingOrderRunsQuery__
 *
 * To run a query within a React component, call `useGetStandingOrderRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandingOrderRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandingOrderRunsQuery({
 *   variables: {
 *      standingOrderId: // value for 'standingOrderId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *   },
 * });
 */
export function useGetStandingOrderRunsQuery(baseOptions: Apollo.QueryHookOptions<GetStandingOrderRunsQuery, GetStandingOrderRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStandingOrderRunsQuery, GetStandingOrderRunsQueryVariables>(GetStandingOrderRunsDocument, options);
      }
export function useGetStandingOrderRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStandingOrderRunsQuery, GetStandingOrderRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStandingOrderRunsQuery, GetStandingOrderRunsQueryVariables>(GetStandingOrderRunsDocument, options);
        }
export function useGetStandingOrderRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStandingOrderRunsQuery, GetStandingOrderRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStandingOrderRunsQuery, GetStandingOrderRunsQueryVariables>(GetStandingOrderRunsDocument, options);
        }
export type GetStandingOrderRunsQueryHookResult = ReturnType<typeof useGetStandingOrderRunsQuery>;
export type GetStandingOrderRunsLazyQueryHookResult = ReturnType<typeof useGetStandingOrderRunsLazyQuery>;
export type GetStandingOrderRunsSuspenseQueryHookResult = ReturnType<typeof useGetStandingOrderRunsSuspenseQuery>;
export type GetStandingOrderRunsQueryResult = Apollo.QueryResult<GetStandingOrderRunsQuery, GetStandingOrderRunsQueryVariables>;
export const GetGuaranteeEventsDocument = gql`
    query getGuaranteeEvents($accountId: String!, $limit: Int, $offset: Int) {
  guaranteeEvents(
    accountId: $accountId
    onlyNewGuarantee: true
    limit: $limit
    offset: $offset
  ) {
    currentGuaranteedBalance
    currentBalance
    createdAt
  }
}
    `;

/**
 * __useGetGuaranteeEventsQuery__
 *
 * To run a query within a React component, call `useGetGuaranteeEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuaranteeEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuaranteeEventsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetGuaranteeEventsQuery(baseOptions: Apollo.QueryHookOptions<GetGuaranteeEventsQuery, GetGuaranteeEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuaranteeEventsQuery, GetGuaranteeEventsQueryVariables>(GetGuaranteeEventsDocument, options);
      }
export function useGetGuaranteeEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuaranteeEventsQuery, GetGuaranteeEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuaranteeEventsQuery, GetGuaranteeEventsQueryVariables>(GetGuaranteeEventsDocument, options);
        }
export function useGetGuaranteeEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGuaranteeEventsQuery, GetGuaranteeEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGuaranteeEventsQuery, GetGuaranteeEventsQueryVariables>(GetGuaranteeEventsDocument, options);
        }
export type GetGuaranteeEventsQueryHookResult = ReturnType<typeof useGetGuaranteeEventsQuery>;
export type GetGuaranteeEventsLazyQueryHookResult = ReturnType<typeof useGetGuaranteeEventsLazyQuery>;
export type GetGuaranteeEventsSuspenseQueryHookResult = ReturnType<typeof useGetGuaranteeEventsSuspenseQuery>;
export type GetGuaranteeEventsQueryResult = Apollo.QueryResult<GetGuaranteeEventsQuery, GetGuaranteeEventsQueryVariables>;
export const GetGuaranteeEventsCountDocument = gql`
    query getGuaranteeEventsCount($accountId: String!) {
  guaranteeEventsCount(accountId: $accountId, onlyNewGuarantee: true)
}
    `;

/**
 * __useGetGuaranteeEventsCountQuery__
 *
 * To run a query within a React component, call `useGetGuaranteeEventsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuaranteeEventsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuaranteeEventsCountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetGuaranteeEventsCountQuery(baseOptions: Apollo.QueryHookOptions<GetGuaranteeEventsCountQuery, GetGuaranteeEventsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuaranteeEventsCountQuery, GetGuaranteeEventsCountQueryVariables>(GetGuaranteeEventsCountDocument, options);
      }
export function useGetGuaranteeEventsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuaranteeEventsCountQuery, GetGuaranteeEventsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuaranteeEventsCountQuery, GetGuaranteeEventsCountQueryVariables>(GetGuaranteeEventsCountDocument, options);
        }
export function useGetGuaranteeEventsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGuaranteeEventsCountQuery, GetGuaranteeEventsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGuaranteeEventsCountQuery, GetGuaranteeEventsCountQueryVariables>(GetGuaranteeEventsCountDocument, options);
        }
export type GetGuaranteeEventsCountQueryHookResult = ReturnType<typeof useGetGuaranteeEventsCountQuery>;
export type GetGuaranteeEventsCountLazyQueryHookResult = ReturnType<typeof useGetGuaranteeEventsCountLazyQuery>;
export type GetGuaranteeEventsCountSuspenseQueryHookResult = ReturnType<typeof useGetGuaranteeEventsCountSuspenseQuery>;
export type GetGuaranteeEventsCountQueryResult = Apollo.QueryResult<GetGuaranteeEventsCountQuery, GetGuaranteeEventsCountQueryVariables>;
export const GuaranteedWithdrawalWithinLimitsDocument = gql`
    query guaranteedWithdrawalWithinLimits($accountId: ID!, $amount: Float!) {
  guaranteedWithdrawalWithinLimits(accountId: $accountId, amount: $amount)
}
    `;

/**
 * __useGuaranteedWithdrawalWithinLimitsQuery__
 *
 * To run a query within a React component, call `useGuaranteedWithdrawalWithinLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuaranteedWithdrawalWithinLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuaranteedWithdrawalWithinLimitsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useGuaranteedWithdrawalWithinLimitsQuery(baseOptions: Apollo.QueryHookOptions<GuaranteedWithdrawalWithinLimitsQuery, GuaranteedWithdrawalWithinLimitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuaranteedWithdrawalWithinLimitsQuery, GuaranteedWithdrawalWithinLimitsQueryVariables>(GuaranteedWithdrawalWithinLimitsDocument, options);
      }
export function useGuaranteedWithdrawalWithinLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuaranteedWithdrawalWithinLimitsQuery, GuaranteedWithdrawalWithinLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuaranteedWithdrawalWithinLimitsQuery, GuaranteedWithdrawalWithinLimitsQueryVariables>(GuaranteedWithdrawalWithinLimitsDocument, options);
        }
export function useGuaranteedWithdrawalWithinLimitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GuaranteedWithdrawalWithinLimitsQuery, GuaranteedWithdrawalWithinLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GuaranteedWithdrawalWithinLimitsQuery, GuaranteedWithdrawalWithinLimitsQueryVariables>(GuaranteedWithdrawalWithinLimitsDocument, options);
        }
export type GuaranteedWithdrawalWithinLimitsQueryHookResult = ReturnType<typeof useGuaranteedWithdrawalWithinLimitsQuery>;
export type GuaranteedWithdrawalWithinLimitsLazyQueryHookResult = ReturnType<typeof useGuaranteedWithdrawalWithinLimitsLazyQuery>;
export type GuaranteedWithdrawalWithinLimitsSuspenseQueryHookResult = ReturnType<typeof useGuaranteedWithdrawalWithinLimitsSuspenseQuery>;
export type GuaranteedWithdrawalWithinLimitsQueryResult = Apollo.QueryResult<GuaranteedWithdrawalWithinLimitsQuery, GuaranteedWithdrawalWithinLimitsQueryVariables>;
export const GetContractPaymentApprovalRatesDataDocument = gql`
    query getContractPaymentApprovalRatesData($contractId: ID!) {
  contractPaymentApprovalRatesData(contractId: $contractId) {
    percentage
    date
  }
}
    `;

/**
 * __useGetContractPaymentApprovalRatesDataQuery__
 *
 * To run a query within a React component, call `useGetContractPaymentApprovalRatesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractPaymentApprovalRatesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractPaymentApprovalRatesDataQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetContractPaymentApprovalRatesDataQuery(baseOptions: Apollo.QueryHookOptions<GetContractPaymentApprovalRatesDataQuery, GetContractPaymentApprovalRatesDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractPaymentApprovalRatesDataQuery, GetContractPaymentApprovalRatesDataQueryVariables>(GetContractPaymentApprovalRatesDataDocument, options);
      }
export function useGetContractPaymentApprovalRatesDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractPaymentApprovalRatesDataQuery, GetContractPaymentApprovalRatesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractPaymentApprovalRatesDataQuery, GetContractPaymentApprovalRatesDataQueryVariables>(GetContractPaymentApprovalRatesDataDocument, options);
        }
export function useGetContractPaymentApprovalRatesDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractPaymentApprovalRatesDataQuery, GetContractPaymentApprovalRatesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractPaymentApprovalRatesDataQuery, GetContractPaymentApprovalRatesDataQueryVariables>(GetContractPaymentApprovalRatesDataDocument, options);
        }
export type GetContractPaymentApprovalRatesDataQueryHookResult = ReturnType<typeof useGetContractPaymentApprovalRatesDataQuery>;
export type GetContractPaymentApprovalRatesDataLazyQueryHookResult = ReturnType<typeof useGetContractPaymentApprovalRatesDataLazyQuery>;
export type GetContractPaymentApprovalRatesDataSuspenseQueryHookResult = ReturnType<typeof useGetContractPaymentApprovalRatesDataSuspenseQuery>;
export type GetContractPaymentApprovalRatesDataQueryResult = Apollo.QueryResult<GetContractPaymentApprovalRatesDataQuery, GetContractPaymentApprovalRatesDataQueryVariables>;
export const GetContractPaymentTopRejectionReasonsDataDocument = gql`
    query getContractPaymentTopRejectionReasonsData($contractId: ID!) {
  contractPaymentTopRejectionReasonsData(contractId: $contractId) {
    count
    reason
  }
}
    `;

/**
 * __useGetContractPaymentTopRejectionReasonsDataQuery__
 *
 * To run a query within a React component, call `useGetContractPaymentTopRejectionReasonsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractPaymentTopRejectionReasonsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractPaymentTopRejectionReasonsDataQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetContractPaymentTopRejectionReasonsDataQuery(baseOptions: Apollo.QueryHookOptions<GetContractPaymentTopRejectionReasonsDataQuery, GetContractPaymentTopRejectionReasonsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractPaymentTopRejectionReasonsDataQuery, GetContractPaymentTopRejectionReasonsDataQueryVariables>(GetContractPaymentTopRejectionReasonsDataDocument, options);
      }
export function useGetContractPaymentTopRejectionReasonsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractPaymentTopRejectionReasonsDataQuery, GetContractPaymentTopRejectionReasonsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractPaymentTopRejectionReasonsDataQuery, GetContractPaymentTopRejectionReasonsDataQueryVariables>(GetContractPaymentTopRejectionReasonsDataDocument, options);
        }
export function useGetContractPaymentTopRejectionReasonsDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractPaymentTopRejectionReasonsDataQuery, GetContractPaymentTopRejectionReasonsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractPaymentTopRejectionReasonsDataQuery, GetContractPaymentTopRejectionReasonsDataQueryVariables>(GetContractPaymentTopRejectionReasonsDataDocument, options);
        }
export type GetContractPaymentTopRejectionReasonsDataQueryHookResult = ReturnType<typeof useGetContractPaymentTopRejectionReasonsDataQuery>;
export type GetContractPaymentTopRejectionReasonsDataLazyQueryHookResult = ReturnType<typeof useGetContractPaymentTopRejectionReasonsDataLazyQuery>;
export type GetContractPaymentTopRejectionReasonsDataSuspenseQueryHookResult = ReturnType<typeof useGetContractPaymentTopRejectionReasonsDataSuspenseQuery>;
export type GetContractPaymentTopRejectionReasonsDataQueryResult = Apollo.QueryResult<GetContractPaymentTopRejectionReasonsDataQuery, GetContractPaymentTopRejectionReasonsDataQueryVariables>;
export const GetContractPaymentsDataDocument = gql`
    query getContractPaymentsData($contractId: ID, $limit: Int, $offset: Int, $orderBy: PaymentsOrderBy, $orderDirection: OrderDirection, $statuses: [PaymentStatus], $methods: [PaymentMethod], $dateFrom: DateTime, $dateTo: DateTime, $search: String) {
  payments(
    contractId: $contractId
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    orderDirection: $orderDirection
    statuses: $statuses
    methods: $methods
    dateFrom: $dateFrom
    dateTo: $dateTo
    search: $search
  ) {
    id
    executedAt
    method
    status
    errorMessage
    serviceStatus
    serviceErrorMessage
    email
    externalId
    amount
    currency
    maskedCardNumber
    expiryDate
    cardholderName
  }
}
    `;

/**
 * __useGetContractPaymentsDataQuery__
 *
 * To run a query within a React component, call `useGetContractPaymentsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractPaymentsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractPaymentsDataQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      statuses: // value for 'statuses'
 *      methods: // value for 'methods'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetContractPaymentsDataQuery(baseOptions?: Apollo.QueryHookOptions<GetContractPaymentsDataQuery, GetContractPaymentsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractPaymentsDataQuery, GetContractPaymentsDataQueryVariables>(GetContractPaymentsDataDocument, options);
      }
export function useGetContractPaymentsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractPaymentsDataQuery, GetContractPaymentsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractPaymentsDataQuery, GetContractPaymentsDataQueryVariables>(GetContractPaymentsDataDocument, options);
        }
export function useGetContractPaymentsDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractPaymentsDataQuery, GetContractPaymentsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractPaymentsDataQuery, GetContractPaymentsDataQueryVariables>(GetContractPaymentsDataDocument, options);
        }
export type GetContractPaymentsDataQueryHookResult = ReturnType<typeof useGetContractPaymentsDataQuery>;
export type GetContractPaymentsDataLazyQueryHookResult = ReturnType<typeof useGetContractPaymentsDataLazyQuery>;
export type GetContractPaymentsDataSuspenseQueryHookResult = ReturnType<typeof useGetContractPaymentsDataSuspenseQuery>;
export type GetContractPaymentsDataQueryResult = Apollo.QueryResult<GetContractPaymentsDataQuery, GetContractPaymentsDataQueryVariables>;
export const GetContractPaymentsCountDocument = gql`
    query getContractPaymentsCount($contractId: ID, $statuses: [PaymentStatus], $methods: [PaymentMethod], $dateFrom: DateTime, $dateTo: DateTime, $search: String) {
  paymentsCount(
    contractId: $contractId
    statuses: $statuses
    methods: $methods
    dateFrom: $dateFrom
    dateTo: $dateTo
    search: $search
  )
}
    `;

/**
 * __useGetContractPaymentsCountQuery__
 *
 * To run a query within a React component, call `useGetContractPaymentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractPaymentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractPaymentsCountQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      statuses: // value for 'statuses'
 *      methods: // value for 'methods'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetContractPaymentsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetContractPaymentsCountQuery, GetContractPaymentsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractPaymentsCountQuery, GetContractPaymentsCountQueryVariables>(GetContractPaymentsCountDocument, options);
      }
export function useGetContractPaymentsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractPaymentsCountQuery, GetContractPaymentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractPaymentsCountQuery, GetContractPaymentsCountQueryVariables>(GetContractPaymentsCountDocument, options);
        }
export function useGetContractPaymentsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractPaymentsCountQuery, GetContractPaymentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractPaymentsCountQuery, GetContractPaymentsCountQueryVariables>(GetContractPaymentsCountDocument, options);
        }
export type GetContractPaymentsCountQueryHookResult = ReturnType<typeof useGetContractPaymentsCountQuery>;
export type GetContractPaymentsCountLazyQueryHookResult = ReturnType<typeof useGetContractPaymentsCountLazyQuery>;
export type GetContractPaymentsCountSuspenseQueryHookResult = ReturnType<typeof useGetContractPaymentsCountSuspenseQuery>;
export type GetContractPaymentsCountQueryResult = Apollo.QueryResult<GetContractPaymentsCountQuery, GetContractPaymentsCountQueryVariables>;
export const GetPaymentDocument = gql`
    query getPayment($id: String!) {
  payment(id: $id) {
    id
    executedAt
    method
    status
    errorMessage
    serviceStatus
    serviceErrorMessage
    email
    externalId
    amount
    currency
    maskedCardNumber
    expiryDate
    cardholderName
    street
    zip
    city
    state
    country
    ip
    sourcePayment {
      id
    }
    refunds {
      id
      executedAt
      status
      amount
      currency
      externalId
    }
  }
}
    `;

/**
 * __useGetPaymentQuery__
 *
 * To run a query within a React component, call `useGetPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
      }
export function useGetPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
        }
export function useGetPaymentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
        }
export type GetPaymentQueryHookResult = ReturnType<typeof useGetPaymentQuery>;
export type GetPaymentLazyQueryHookResult = ReturnType<typeof useGetPaymentLazyQuery>;
export type GetPaymentSuspenseQueryHookResult = ReturnType<typeof useGetPaymentSuspenseQuery>;
export type GetPaymentQueryResult = Apollo.QueryResult<GetPaymentQuery, GetPaymentQueryVariables>;
export const GetSettlementBalancesDocument = gql`
    query getSettlementBalances($id: ID!) {
  contract(id: $id) {
    settlementBalance {
      settlement
      locked
      currency
    }
  }
}
    `;

/**
 * __useGetSettlementBalancesQuery__
 *
 * To run a query within a React component, call `useGetSettlementBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettlementBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettlementBalancesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSettlementBalancesQuery(baseOptions: Apollo.QueryHookOptions<GetSettlementBalancesQuery, GetSettlementBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettlementBalancesQuery, GetSettlementBalancesQueryVariables>(GetSettlementBalancesDocument, options);
      }
export function useGetSettlementBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettlementBalancesQuery, GetSettlementBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettlementBalancesQuery, GetSettlementBalancesQueryVariables>(GetSettlementBalancesDocument, options);
        }
export function useGetSettlementBalancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSettlementBalancesQuery, GetSettlementBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSettlementBalancesQuery, GetSettlementBalancesQueryVariables>(GetSettlementBalancesDocument, options);
        }
export type GetSettlementBalancesQueryHookResult = ReturnType<typeof useGetSettlementBalancesQuery>;
export type GetSettlementBalancesLazyQueryHookResult = ReturnType<typeof useGetSettlementBalancesLazyQuery>;
export type GetSettlementBalancesSuspenseQueryHookResult = ReturnType<typeof useGetSettlementBalancesSuspenseQuery>;
export type GetSettlementBalancesQueryResult = Apollo.QueryResult<GetSettlementBalancesQuery, GetSettlementBalancesQueryVariables>;
export const GetContractDailyVolumeDataDocument = gql`
    query getContractDailyVolumeData($contractId: ID!, $dateFrom: DateTime!, $dateTo: DateTime!) {
  contractDailyVolumeData(
    contractId: $contractId
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    date
    currency
    totalVolume
    count
    refundVolume
    payoutVolume
    hourlyVolumes {
      hour
      amount
    }
  }
}
    `;

/**
 * __useGetContractDailyVolumeDataQuery__
 *
 * To run a query within a React component, call `useGetContractDailyVolumeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractDailyVolumeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractDailyVolumeDataQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetContractDailyVolumeDataQuery(baseOptions: Apollo.QueryHookOptions<GetContractDailyVolumeDataQuery, GetContractDailyVolumeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractDailyVolumeDataQuery, GetContractDailyVolumeDataQueryVariables>(GetContractDailyVolumeDataDocument, options);
      }
export function useGetContractDailyVolumeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractDailyVolumeDataQuery, GetContractDailyVolumeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractDailyVolumeDataQuery, GetContractDailyVolumeDataQueryVariables>(GetContractDailyVolumeDataDocument, options);
        }
export function useGetContractDailyVolumeDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractDailyVolumeDataQuery, GetContractDailyVolumeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractDailyVolumeDataQuery, GetContractDailyVolumeDataQueryVariables>(GetContractDailyVolumeDataDocument, options);
        }
export type GetContractDailyVolumeDataQueryHookResult = ReturnType<typeof useGetContractDailyVolumeDataQuery>;
export type GetContractDailyVolumeDataLazyQueryHookResult = ReturnType<typeof useGetContractDailyVolumeDataLazyQuery>;
export type GetContractDailyVolumeDataSuspenseQueryHookResult = ReturnType<typeof useGetContractDailyVolumeDataSuspenseQuery>;
export type GetContractDailyVolumeDataQueryResult = Apollo.QueryResult<GetContractDailyVolumeDataQuery, GetContractDailyVolumeDataQueryVariables>;
export const GetDirectDebitsDocument = gql`
    query getDirectDebits($accountId: ID, $contractId: ID, $type: TransactionEntryType, $orderBy: OrderBy, $orderDirection: OrderDirection, $limit: Int, $offset: Int, $status: [DirectDebitMandateStatus]) {
  directDebitMandates(
    accountId: $accountId
    contractId: $contractId
    type: $type
    orderBy: $orderBy
    orderDirection: $orderDirection
    limit: $limit
    offset: $offset
    status: $status
  ) {
    id
    status
    creditorId
    mandateId
    type
    account {
      id
      alias
      iban
      currency
    }
    counterpartyDetails {
      name
      bic
      iban
      address {
        line1
        country
      }
    }
    document {
      id
      type
      expiration
      createdAt
      firstSide {
        fileName
        mimeType
        size
        url
      }
    }
    rejectionAction {
      ... on BaseAction {
        id
        initiatorName
        signedCount
        status
        signatures {
          id
          isMine
          status
          signedAt
          signatory {
            signatoryRight
            person {
              id
              firstName
              lastName
            }
          }
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
    }
    approvalAction {
      ... on BaseAction {
        id
        initiatorName
        signedCount
        status
        signatures {
          id
          isMine
          status
          signedAt
          signatory {
            signatoryRight
            person {
              id
              firstName
              lastName
            }
          }
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
    }
    createdAt
  }
}
    `;

/**
 * __useGetDirectDebitsQuery__
 *
 * To run a query within a React component, call `useGetDirectDebitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectDebitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectDebitsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      contractId: // value for 'contractId'
 *      type: // value for 'type'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetDirectDebitsQuery(baseOptions?: Apollo.QueryHookOptions<GetDirectDebitsQuery, GetDirectDebitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectDebitsQuery, GetDirectDebitsQueryVariables>(GetDirectDebitsDocument, options);
      }
export function useGetDirectDebitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectDebitsQuery, GetDirectDebitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectDebitsQuery, GetDirectDebitsQueryVariables>(GetDirectDebitsDocument, options);
        }
export function useGetDirectDebitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDirectDebitsQuery, GetDirectDebitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDirectDebitsQuery, GetDirectDebitsQueryVariables>(GetDirectDebitsDocument, options);
        }
export type GetDirectDebitsQueryHookResult = ReturnType<typeof useGetDirectDebitsQuery>;
export type GetDirectDebitsLazyQueryHookResult = ReturnType<typeof useGetDirectDebitsLazyQuery>;
export type GetDirectDebitsSuspenseQueryHookResult = ReturnType<typeof useGetDirectDebitsSuspenseQuery>;
export type GetDirectDebitsQueryResult = Apollo.QueryResult<GetDirectDebitsQuery, GetDirectDebitsQueryVariables>;
export const GetDirectDebitMandatesCountDocument = gql`
    query getDirectDebitMandatesCount($accountId: ID, $contractId: ID, $type: TransactionEntryType, $status: [DirectDebitMandateStatus]) {
  directDebitMandatesCount(
    accountId: $accountId
    contractId: $contractId
    type: $type
    status: $status
  )
}
    `;

/**
 * __useGetDirectDebitMandatesCountQuery__
 *
 * To run a query within a React component, call `useGetDirectDebitMandatesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectDebitMandatesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectDebitMandatesCountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      contractId: // value for 'contractId'
 *      type: // value for 'type'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetDirectDebitMandatesCountQuery(baseOptions?: Apollo.QueryHookOptions<GetDirectDebitMandatesCountQuery, GetDirectDebitMandatesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectDebitMandatesCountQuery, GetDirectDebitMandatesCountQueryVariables>(GetDirectDebitMandatesCountDocument, options);
      }
export function useGetDirectDebitMandatesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectDebitMandatesCountQuery, GetDirectDebitMandatesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectDebitMandatesCountQuery, GetDirectDebitMandatesCountQueryVariables>(GetDirectDebitMandatesCountDocument, options);
        }
export function useGetDirectDebitMandatesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDirectDebitMandatesCountQuery, GetDirectDebitMandatesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDirectDebitMandatesCountQuery, GetDirectDebitMandatesCountQueryVariables>(GetDirectDebitMandatesCountDocument, options);
        }
export type GetDirectDebitMandatesCountQueryHookResult = ReturnType<typeof useGetDirectDebitMandatesCountQuery>;
export type GetDirectDebitMandatesCountLazyQueryHookResult = ReturnType<typeof useGetDirectDebitMandatesCountLazyQuery>;
export type GetDirectDebitMandatesCountSuspenseQueryHookResult = ReturnType<typeof useGetDirectDebitMandatesCountSuspenseQuery>;
export type GetDirectDebitMandatesCountQueryResult = Apollo.QueryResult<GetDirectDebitMandatesCountQuery, GetDirectDebitMandatesCountQueryVariables>;
export const GetDirectDebitDocument = gql`
    query getDirectDebit($id: ID!) {
  directDebitMandate(id: $id) {
    id
    status
    creditorId
    mandateId
    type
    account {
      id
      alias
      iban
      currency
    }
    counterpartyDetails {
      name
      bic
      iban
      address {
        line1
        country
      }
    }
    document {
      id
      type
      expiration
      createdAt
      firstSide {
        fileName
        mimeType
        size
        url
      }
    }
    rejectionAction {
      ... on BaseAction {
        id
        initiatorName
        signedCount
        status
        signatures {
          id
          isMine
          status
          signedAt
          signatory {
            signatoryRight
            person {
              id
              firstName
              lastName
            }
          }
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
    }
    approvalAction {
      ... on BaseAction {
        id
        initiatorName
        signedCount
        status
        signatures {
          id
          isMine
          status
          signedAt
          signatory {
            signatoryRight
            person {
              id
              firstName
              lastName
            }
          }
          action {
            ... on BaseAction {
              id
            }
          }
        }
      }
    }
    createdAt
  }
}
    `;

/**
 * __useGetDirectDebitQuery__
 *
 * To run a query within a React component, call `useGetDirectDebitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectDebitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectDebitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDirectDebitQuery(baseOptions: Apollo.QueryHookOptions<GetDirectDebitQuery, GetDirectDebitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectDebitQuery, GetDirectDebitQueryVariables>(GetDirectDebitDocument, options);
      }
export function useGetDirectDebitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectDebitQuery, GetDirectDebitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectDebitQuery, GetDirectDebitQueryVariables>(GetDirectDebitDocument, options);
        }
export function useGetDirectDebitSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDirectDebitQuery, GetDirectDebitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDirectDebitQuery, GetDirectDebitQueryVariables>(GetDirectDebitDocument, options);
        }
export type GetDirectDebitQueryHookResult = ReturnType<typeof useGetDirectDebitQuery>;
export type GetDirectDebitLazyQueryHookResult = ReturnType<typeof useGetDirectDebitLazyQuery>;
export type GetDirectDebitSuspenseQueryHookResult = ReturnType<typeof useGetDirectDebitSuspenseQuery>;
export type GetDirectDebitQueryResult = Apollo.QueryResult<GetDirectDebitQuery, GetDirectDebitQueryVariables>;
export const GetDirectDebitExecutionsDocument = gql`
    query getDirectDebitExecutions($directDebitId: ID, $accountId: ID, $type: TransactionEntryType, $limit: Int, $offset: Int, $status: DirectDebitExecutionStatus, $executionDateFrom: Date, $executionDateTo: Date, $orderBy: OrderBy, $orderDirection: OrderDirection) {
  directDebitExecutions(
    limit: $limit
    offset: $offset
    directDebitMandateId: $directDebitId
    accountId: $accountId
    type: $type
    orderBy: $orderBy
    orderDirection: $orderDirection
    status: $status
    executionDateFrom: $executionDateFrom
    executionDateTo: $executionDateTo
  ) {
    id
    failureReason
    createdAt
    status
    value
    executionDate
    account {
      currency
    }
    mandate {
      type
      counterpartyDetails {
        name
      }
    }
    transaction {
      ... on BaseTransaction {
        id
        value
        accountCurrency
        status
      }
    }
    batch {
      executionAction {
        ... on DirectDebitBatchRequestActionType {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetDirectDebitExecutionsQuery__
 *
 * To run a query within a React component, call `useGetDirectDebitExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectDebitExecutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectDebitExecutionsQuery({
 *   variables: {
 *      directDebitId: // value for 'directDebitId'
 *      accountId: // value for 'accountId'
 *      type: // value for 'type'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *      executionDateFrom: // value for 'executionDateFrom'
 *      executionDateTo: // value for 'executionDateTo'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *   },
 * });
 */
export function useGetDirectDebitExecutionsQuery(baseOptions?: Apollo.QueryHookOptions<GetDirectDebitExecutionsQuery, GetDirectDebitExecutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectDebitExecutionsQuery, GetDirectDebitExecutionsQueryVariables>(GetDirectDebitExecutionsDocument, options);
      }
export function useGetDirectDebitExecutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectDebitExecutionsQuery, GetDirectDebitExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectDebitExecutionsQuery, GetDirectDebitExecutionsQueryVariables>(GetDirectDebitExecutionsDocument, options);
        }
export function useGetDirectDebitExecutionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDirectDebitExecutionsQuery, GetDirectDebitExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDirectDebitExecutionsQuery, GetDirectDebitExecutionsQueryVariables>(GetDirectDebitExecutionsDocument, options);
        }
export type GetDirectDebitExecutionsQueryHookResult = ReturnType<typeof useGetDirectDebitExecutionsQuery>;
export type GetDirectDebitExecutionsLazyQueryHookResult = ReturnType<typeof useGetDirectDebitExecutionsLazyQuery>;
export type GetDirectDebitExecutionsSuspenseQueryHookResult = ReturnType<typeof useGetDirectDebitExecutionsSuspenseQuery>;
export type GetDirectDebitExecutionsQueryResult = Apollo.QueryResult<GetDirectDebitExecutionsQuery, GetDirectDebitExecutionsQueryVariables>;
export const GetDirectDebitExecutionsCountDocument = gql`
    query getDirectDebitExecutionsCount($directDebitId: ID, $accountId: ID, $type: TransactionEntryType, $status: DirectDebitExecutionStatus, $executionDateFrom: Date, $executionDateTo: Date) {
  directDebitExecutionsCount(
    directDebitMandateId: $directDebitId
    accountId: $accountId
    type: $type
    status: $status
    executionDateFrom: $executionDateFrom
    executionDateTo: $executionDateTo
  )
}
    `;

/**
 * __useGetDirectDebitExecutionsCountQuery__
 *
 * To run a query within a React component, call `useGetDirectDebitExecutionsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectDebitExecutionsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectDebitExecutionsCountQuery({
 *   variables: {
 *      directDebitId: // value for 'directDebitId'
 *      accountId: // value for 'accountId'
 *      type: // value for 'type'
 *      status: // value for 'status'
 *      executionDateFrom: // value for 'executionDateFrom'
 *      executionDateTo: // value for 'executionDateTo'
 *   },
 * });
 */
export function useGetDirectDebitExecutionsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetDirectDebitExecutionsCountQuery, GetDirectDebitExecutionsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectDebitExecutionsCountQuery, GetDirectDebitExecutionsCountQueryVariables>(GetDirectDebitExecutionsCountDocument, options);
      }
export function useGetDirectDebitExecutionsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectDebitExecutionsCountQuery, GetDirectDebitExecutionsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectDebitExecutionsCountQuery, GetDirectDebitExecutionsCountQueryVariables>(GetDirectDebitExecutionsCountDocument, options);
        }
export function useGetDirectDebitExecutionsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDirectDebitExecutionsCountQuery, GetDirectDebitExecutionsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDirectDebitExecutionsCountQuery, GetDirectDebitExecutionsCountQueryVariables>(GetDirectDebitExecutionsCountDocument, options);
        }
export type GetDirectDebitExecutionsCountQueryHookResult = ReturnType<typeof useGetDirectDebitExecutionsCountQuery>;
export type GetDirectDebitExecutionsCountLazyQueryHookResult = ReturnType<typeof useGetDirectDebitExecutionsCountLazyQuery>;
export type GetDirectDebitExecutionsCountSuspenseQueryHookResult = ReturnType<typeof useGetDirectDebitExecutionsCountSuspenseQuery>;
export type GetDirectDebitExecutionsCountQueryResult = Apollo.QueryResult<GetDirectDebitExecutionsCountQuery, GetDirectDebitExecutionsCountQueryVariables>;
export const ContractContactsDocument = gql`
    query contractContacts($id: ID!) {
  contract(id: $id) {
    id
    status
    owner {
      ... on LegalEntity {
        id
        companyName
        legalEntityType
      }
    }
    contacts {
      id
      canDirectlyUpdateContactInfo
      contactInfo {
        name
        email
        phone
      }
      isPrimary
      type
    }
  }
}
    `;

/**
 * __useContractContactsQuery__
 *
 * To run a query within a React component, call `useContractContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractContactsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractContactsQuery(baseOptions: Apollo.QueryHookOptions<ContractContactsQuery, ContractContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractContactsQuery, ContractContactsQueryVariables>(ContractContactsDocument, options);
      }
export function useContractContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractContactsQuery, ContractContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractContactsQuery, ContractContactsQueryVariables>(ContractContactsDocument, options);
        }
export function useContractContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContractContactsQuery, ContractContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractContactsQuery, ContractContactsQueryVariables>(ContractContactsDocument, options);
        }
export type ContractContactsQueryHookResult = ReturnType<typeof useContractContactsQuery>;
export type ContractContactsLazyQueryHookResult = ReturnType<typeof useContractContactsLazyQuery>;
export type ContractContactsSuspenseQueryHookResult = ReturnType<typeof useContractContactsSuspenseQuery>;
export type ContractContactsQueryResult = Apollo.QueryResult<ContractContactsQuery, ContractContactsQueryVariables>;
export const GetContractContactsDocument = gql`
    query getContractContacts($contractId: ID, $search: String, $limit: Int, $offset: Int, $isPrimary: Boolean) {
  contractContacts(
    contractId: $contractId
    search: $search
    limit: $limit
    offset: $offset
    isPrimary: $isPrimary
    orderBy: createdAt
    orderDirection: descending
  ) {
    id
    canDirectlyUpdateContactInfo
    contactInfo {
      name
      email
      phone
    }
    type
    isPrimary
  }
}
    `;

/**
 * __useGetContractContactsQuery__
 *
 * To run a query within a React component, call `useGetContractContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractContactsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      isPrimary: // value for 'isPrimary'
 *   },
 * });
 */
export function useGetContractContactsQuery(baseOptions?: Apollo.QueryHookOptions<GetContractContactsQuery, GetContractContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractContactsQuery, GetContractContactsQueryVariables>(GetContractContactsDocument, options);
      }
export function useGetContractContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractContactsQuery, GetContractContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractContactsQuery, GetContractContactsQueryVariables>(GetContractContactsDocument, options);
        }
export function useGetContractContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractContactsQuery, GetContractContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractContactsQuery, GetContractContactsQueryVariables>(GetContractContactsDocument, options);
        }
export type GetContractContactsQueryHookResult = ReturnType<typeof useGetContractContactsQuery>;
export type GetContractContactsLazyQueryHookResult = ReturnType<typeof useGetContractContactsLazyQuery>;
export type GetContractContactsSuspenseQueryHookResult = ReturnType<typeof useGetContractContactsSuspenseQuery>;
export type GetContractContactsQueryResult = Apollo.QueryResult<GetContractContactsQuery, GetContractContactsQueryVariables>;
export const GetContractContactsCountDocument = gql`
    query getContractContactsCount($contractId: ID, $search: String, $isPrimary: Boolean) {
  contractContactsCount(
    contractId: $contractId
    search: $search
    isPrimary: $isPrimary
  )
}
    `;

/**
 * __useGetContractContactsCountQuery__
 *
 * To run a query within a React component, call `useGetContractContactsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractContactsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractContactsCountQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      search: // value for 'search'
 *      isPrimary: // value for 'isPrimary'
 *   },
 * });
 */
export function useGetContractContactsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetContractContactsCountQuery, GetContractContactsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractContactsCountQuery, GetContractContactsCountQueryVariables>(GetContractContactsCountDocument, options);
      }
export function useGetContractContactsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractContactsCountQuery, GetContractContactsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractContactsCountQuery, GetContractContactsCountQueryVariables>(GetContractContactsCountDocument, options);
        }
export function useGetContractContactsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractContactsCountQuery, GetContractContactsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractContactsCountQuery, GetContractContactsCountQueryVariables>(GetContractContactsCountDocument, options);
        }
export type GetContractContactsCountQueryHookResult = ReturnType<typeof useGetContractContactsCountQuery>;
export type GetContractContactsCountLazyQueryHookResult = ReturnType<typeof useGetContractContactsCountLazyQuery>;
export type GetContractContactsCountSuspenseQueryHookResult = ReturnType<typeof useGetContractContactsCountSuspenseQuery>;
export type GetContractContactsCountQueryResult = Apollo.QueryResult<GetContractContactsCountQuery, GetContractContactsCountQueryVariables>;
export const GetDirectDebitLimitsDocument = gql`
    query getDirectDebitLimits($accountId: ID!) {
  account(id: $accountId) {
    id
    spendingLimits(type: sdd, status: [pending, active]) {
      interval
      amount
      usedAmount
      status
    }
  }
}
    `;

/**
 * __useGetDirectDebitLimitsQuery__
 *
 * To run a query within a React component, call `useGetDirectDebitLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectDebitLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectDebitLimitsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetDirectDebitLimitsQuery(baseOptions: Apollo.QueryHookOptions<GetDirectDebitLimitsQuery, GetDirectDebitLimitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectDebitLimitsQuery, GetDirectDebitLimitsQueryVariables>(GetDirectDebitLimitsDocument, options);
      }
export function useGetDirectDebitLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectDebitLimitsQuery, GetDirectDebitLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectDebitLimitsQuery, GetDirectDebitLimitsQueryVariables>(GetDirectDebitLimitsDocument, options);
        }
export function useGetDirectDebitLimitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDirectDebitLimitsQuery, GetDirectDebitLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDirectDebitLimitsQuery, GetDirectDebitLimitsQueryVariables>(GetDirectDebitLimitsDocument, options);
        }
export type GetDirectDebitLimitsQueryHookResult = ReturnType<typeof useGetDirectDebitLimitsQuery>;
export type GetDirectDebitLimitsLazyQueryHookResult = ReturnType<typeof useGetDirectDebitLimitsLazyQuery>;
export type GetDirectDebitLimitsSuspenseQueryHookResult = ReturnType<typeof useGetDirectDebitLimitsSuspenseQuery>;
export type GetDirectDebitLimitsQueryResult = Apollo.QueryResult<GetDirectDebitLimitsQuery, GetDirectDebitLimitsQueryVariables>;
export const GetUbosDocument = gql`
    query getUbos($type: UboType) {
  getUbos(type: $type) {
    id
    entity {
      __typename
      ... on LegalEntity {
        id
        companyName
        companyRegistrationId
      }
      ... on Individual {
        id
        firstName
        lastName
        address {
          city
          country
          zip
          additionalDetails
          line1
        }
        birthday
        nationality
        isPep
        taxId
        email
        fullName
      }
    }
  }
}
    `;

/**
 * __useGetUbosQuery__
 *
 * To run a query within a React component, call `useGetUbosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUbosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUbosQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetUbosQuery(baseOptions?: Apollo.QueryHookOptions<GetUbosQuery, GetUbosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUbosQuery, GetUbosQueryVariables>(GetUbosDocument, options);
      }
export function useGetUbosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUbosQuery, GetUbosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUbosQuery, GetUbosQueryVariables>(GetUbosDocument, options);
        }
export function useGetUbosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUbosQuery, GetUbosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUbosQuery, GetUbosQueryVariables>(GetUbosDocument, options);
        }
export type GetUbosQueryHookResult = ReturnType<typeof useGetUbosQuery>;
export type GetUbosLazyQueryHookResult = ReturnType<typeof useGetUbosLazyQuery>;
export type GetUbosSuspenseQueryHookResult = ReturnType<typeof useGetUbosSuspenseQuery>;
export type GetUbosQueryResult = Apollo.QueryResult<GetUbosQuery, GetUbosQueryVariables>;
export const ContractLegalEntityOwnersDocument = gql`
    query contractLegalEntityOwners($id: ID!) {
  contract(id: $id) {
    ubos {
      id
      addedFromExistingUbo
      ubo {
        id
        entity {
          ... on LegalEntity {
            id
            companyName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useContractLegalEntityOwnersQuery__
 *
 * To run a query within a React component, call `useContractLegalEntityOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractLegalEntityOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractLegalEntityOwnersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractLegalEntityOwnersQuery(baseOptions: Apollo.QueryHookOptions<ContractLegalEntityOwnersQuery, ContractLegalEntityOwnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractLegalEntityOwnersQuery, ContractLegalEntityOwnersQueryVariables>(ContractLegalEntityOwnersDocument, options);
      }
export function useContractLegalEntityOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractLegalEntityOwnersQuery, ContractLegalEntityOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractLegalEntityOwnersQuery, ContractLegalEntityOwnersQueryVariables>(ContractLegalEntityOwnersDocument, options);
        }
export function useContractLegalEntityOwnersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContractLegalEntityOwnersQuery, ContractLegalEntityOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractLegalEntityOwnersQuery, ContractLegalEntityOwnersQueryVariables>(ContractLegalEntityOwnersDocument, options);
        }
export type ContractLegalEntityOwnersQueryHookResult = ReturnType<typeof useContractLegalEntityOwnersQuery>;
export type ContractLegalEntityOwnersLazyQueryHookResult = ReturnType<typeof useContractLegalEntityOwnersLazyQuery>;
export type ContractLegalEntityOwnersSuspenseQueryHookResult = ReturnType<typeof useContractLegalEntityOwnersSuspenseQuery>;
export type ContractLegalEntityOwnersQueryResult = Apollo.QueryResult<ContractLegalEntityOwnersQuery, ContractLegalEntityOwnersQueryVariables>;
export const GetIbanCertificationDocument = gql`
    query getIbanCertification($accountId: ID!) {
  ibanCertificate(accountId: $accountId)
}
    `;

/**
 * __useGetIbanCertificationQuery__
 *
 * To run a query within a React component, call `useGetIbanCertificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIbanCertificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIbanCertificationQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetIbanCertificationQuery(baseOptions: Apollo.QueryHookOptions<GetIbanCertificationQuery, GetIbanCertificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIbanCertificationQuery, GetIbanCertificationQueryVariables>(GetIbanCertificationDocument, options);
      }
export function useGetIbanCertificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIbanCertificationQuery, GetIbanCertificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIbanCertificationQuery, GetIbanCertificationQueryVariables>(GetIbanCertificationDocument, options);
        }
export function useGetIbanCertificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIbanCertificationQuery, GetIbanCertificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIbanCertificationQuery, GetIbanCertificationQueryVariables>(GetIbanCertificationDocument, options);
        }
export type GetIbanCertificationQueryHookResult = ReturnType<typeof useGetIbanCertificationQuery>;
export type GetIbanCertificationLazyQueryHookResult = ReturnType<typeof useGetIbanCertificationLazyQuery>;
export type GetIbanCertificationSuspenseQueryHookResult = ReturnType<typeof useGetIbanCertificationSuspenseQuery>;
export type GetIbanCertificationQueryResult = Apollo.QueryResult<GetIbanCertificationQuery, GetIbanCertificationQueryVariables>;
export const GetTransactionForbiddenCountriesDocument = gql`
    query getTransactionForbiddenCountries {
  transactionForbiddenCountries
}
    `;

/**
 * __useGetTransactionForbiddenCountriesQuery__
 *
 * To run a query within a React component, call `useGetTransactionForbiddenCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionForbiddenCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionForbiddenCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTransactionForbiddenCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionForbiddenCountriesQuery, GetTransactionForbiddenCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionForbiddenCountriesQuery, GetTransactionForbiddenCountriesQueryVariables>(GetTransactionForbiddenCountriesDocument, options);
      }
export function useGetTransactionForbiddenCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionForbiddenCountriesQuery, GetTransactionForbiddenCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionForbiddenCountriesQuery, GetTransactionForbiddenCountriesQueryVariables>(GetTransactionForbiddenCountriesDocument, options);
        }
export function useGetTransactionForbiddenCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransactionForbiddenCountriesQuery, GetTransactionForbiddenCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionForbiddenCountriesQuery, GetTransactionForbiddenCountriesQueryVariables>(GetTransactionForbiddenCountriesDocument, options);
        }
export type GetTransactionForbiddenCountriesQueryHookResult = ReturnType<typeof useGetTransactionForbiddenCountriesQuery>;
export type GetTransactionForbiddenCountriesLazyQueryHookResult = ReturnType<typeof useGetTransactionForbiddenCountriesLazyQuery>;
export type GetTransactionForbiddenCountriesSuspenseQueryHookResult = ReturnType<typeof useGetTransactionForbiddenCountriesSuspenseQuery>;
export type GetTransactionForbiddenCountriesQueryResult = Apollo.QueryResult<GetTransactionForbiddenCountriesQuery, GetTransactionForbiddenCountriesQueryVariables>;
export const GetContractWalletsDocument = gql`
    query getContractWallets($contractId: ID) {
  wallets(contractId: $contractId) {
    id
    address
    alias
    network
    status
    linkedBy {
      id
    }
    supportedCoins {
      name
      chain
    }
  }
}
    `;

/**
 * __useGetContractWalletsQuery__
 *
 * To run a query within a React component, call `useGetContractWalletsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractWalletsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractWalletsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetContractWalletsQuery(baseOptions?: Apollo.QueryHookOptions<GetContractWalletsQuery, GetContractWalletsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractWalletsQuery, GetContractWalletsQueryVariables>(GetContractWalletsDocument, options);
      }
export function useGetContractWalletsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractWalletsQuery, GetContractWalletsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractWalletsQuery, GetContractWalletsQueryVariables>(GetContractWalletsDocument, options);
        }
export function useGetContractWalletsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractWalletsQuery, GetContractWalletsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractWalletsQuery, GetContractWalletsQueryVariables>(GetContractWalletsDocument, options);
        }
export type GetContractWalletsQueryHookResult = ReturnType<typeof useGetContractWalletsQuery>;
export type GetContractWalletsLazyQueryHookResult = ReturnType<typeof useGetContractWalletsLazyQuery>;
export type GetContractWalletsSuspenseQueryHookResult = ReturnType<typeof useGetContractWalletsSuspenseQuery>;
export type GetContractWalletsQueryResult = Apollo.QueryResult<GetContractWalletsQuery, GetContractWalletsQueryVariables>;
export const CryptoRateDocument = gql`
    query cryptoRate($fromCurrency: AllCurrencies!, $toCurrency: AllCurrencies!, $amount: Float!, $network: SupportedCryptoNetwork!) {
  cryptoRate(
    fromCurrency: $fromCurrency
    toCurrency: $toCurrency
    amount: $amount
    network: $network
  ) {
    price
    effectiveRate
    networkFee
    slippageTolerance {
      key
      label
    }
  }
}
    `;

/**
 * __useCryptoRateQuery__
 *
 * To run a query within a React component, call `useCryptoRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCryptoRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCryptoRateQuery({
 *   variables: {
 *      fromCurrency: // value for 'fromCurrency'
 *      toCurrency: // value for 'toCurrency'
 *      amount: // value for 'amount'
 *      network: // value for 'network'
 *   },
 * });
 */
export function useCryptoRateQuery(baseOptions: Apollo.QueryHookOptions<CryptoRateQuery, CryptoRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CryptoRateQuery, CryptoRateQueryVariables>(CryptoRateDocument, options);
      }
export function useCryptoRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CryptoRateQuery, CryptoRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CryptoRateQuery, CryptoRateQueryVariables>(CryptoRateDocument, options);
        }
export function useCryptoRateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CryptoRateQuery, CryptoRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CryptoRateQuery, CryptoRateQueryVariables>(CryptoRateDocument, options);
        }
export type CryptoRateQueryHookResult = ReturnType<typeof useCryptoRateQuery>;
export type CryptoRateLazyQueryHookResult = ReturnType<typeof useCryptoRateLazyQuery>;
export type CryptoRateSuspenseQueryHookResult = ReturnType<typeof useCryptoRateSuspenseQuery>;
export type CryptoRateQueryResult = Apollo.QueryResult<CryptoRateQuery, CryptoRateQueryVariables>;
export const GetWalletDocument = gql`
    query getWallet($id: ID!) {
  wallet(id: $id) {
    id
    address
    alias
    network
    status
    baseCurrency
    linkedBy {
      id
    }
    supportedCoins {
      name
      chain
    }
    balance
    baseCurrency
  }
}
    `;

/**
 * __useGetWalletQuery__
 *
 * To run a query within a React component, call `useGetWalletQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWalletQuery(baseOptions: Apollo.QueryHookOptions<GetWalletQuery, GetWalletQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWalletQuery, GetWalletQueryVariables>(GetWalletDocument, options);
      }
export function useGetWalletLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWalletQuery, GetWalletQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWalletQuery, GetWalletQueryVariables>(GetWalletDocument, options);
        }
export function useGetWalletSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWalletQuery, GetWalletQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWalletQuery, GetWalletQueryVariables>(GetWalletDocument, options);
        }
export type GetWalletQueryHookResult = ReturnType<typeof useGetWalletQuery>;
export type GetWalletLazyQueryHookResult = ReturnType<typeof useGetWalletLazyQuery>;
export type GetWalletSuspenseQueryHookResult = ReturnType<typeof useGetWalletSuspenseQuery>;
export type GetWalletQueryResult = Apollo.QueryResult<GetWalletQuery, GetWalletQueryVariables>;
export const GetWalletTransactionsDocument = gql`
    query getWalletTransactions($walletId: String!, $status: [TransactionRequestStatus], $limit: Int, $offset: Int, $orderBy: OrderBy, $orderDirection: OrderDirection) {
  walletTransactions(
    walletId: $walletId
    status: $status
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    orderDirection: $orderDirection
  ) {
    id
    createdAt
    account {
      id
      name
      alias
      currency
      iban
    }
    wallet {
      alias
      address
      network
      linkedBy {
        id
      }
    }
    amount
    currency
    status
    type
    effectiveRate
    slippageTolerance
    estimatedAmount
    trxHash
  }
}
    `;

/**
 * __useGetWalletTransactionsQuery__
 *
 * To run a query within a React component, call `useGetWalletTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletTransactionsQuery({
 *   variables: {
 *      walletId: // value for 'walletId'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *   },
 * });
 */
export function useGetWalletTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetWalletTransactionsQuery, GetWalletTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWalletTransactionsQuery, GetWalletTransactionsQueryVariables>(GetWalletTransactionsDocument, options);
      }
export function useGetWalletTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWalletTransactionsQuery, GetWalletTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWalletTransactionsQuery, GetWalletTransactionsQueryVariables>(GetWalletTransactionsDocument, options);
        }
export function useGetWalletTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWalletTransactionsQuery, GetWalletTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWalletTransactionsQuery, GetWalletTransactionsQueryVariables>(GetWalletTransactionsDocument, options);
        }
export type GetWalletTransactionsQueryHookResult = ReturnType<typeof useGetWalletTransactionsQuery>;
export type GetWalletTransactionsLazyQueryHookResult = ReturnType<typeof useGetWalletTransactionsLazyQuery>;
export type GetWalletTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetWalletTransactionsSuspenseQuery>;
export type GetWalletTransactionsQueryResult = Apollo.QueryResult<GetWalletTransactionsQuery, GetWalletTransactionsQueryVariables>;
export const GetWalletTransactionsCountDocument = gql`
    query getWalletTransactionsCount($walletId: String!, $status: [TransactionRequestStatus]) {
  walletTransactionsCount(walletId: $walletId, status: $status)
}
    `;

/**
 * __useGetWalletTransactionsCountQuery__
 *
 * To run a query within a React component, call `useGetWalletTransactionsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletTransactionsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletTransactionsCountQuery({
 *   variables: {
 *      walletId: // value for 'walletId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetWalletTransactionsCountQuery(baseOptions: Apollo.QueryHookOptions<GetWalletTransactionsCountQuery, GetWalletTransactionsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWalletTransactionsCountQuery, GetWalletTransactionsCountQueryVariables>(GetWalletTransactionsCountDocument, options);
      }
export function useGetWalletTransactionsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWalletTransactionsCountQuery, GetWalletTransactionsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWalletTransactionsCountQuery, GetWalletTransactionsCountQueryVariables>(GetWalletTransactionsCountDocument, options);
        }
export function useGetWalletTransactionsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWalletTransactionsCountQuery, GetWalletTransactionsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWalletTransactionsCountQuery, GetWalletTransactionsCountQueryVariables>(GetWalletTransactionsCountDocument, options);
        }
export type GetWalletTransactionsCountQueryHookResult = ReturnType<typeof useGetWalletTransactionsCountQuery>;
export type GetWalletTransactionsCountLazyQueryHookResult = ReturnType<typeof useGetWalletTransactionsCountLazyQuery>;
export type GetWalletTransactionsCountSuspenseQueryHookResult = ReturnType<typeof useGetWalletTransactionsCountSuspenseQuery>;
export type GetWalletTransactionsCountQueryResult = Apollo.QueryResult<GetWalletTransactionsCountQuery, GetWalletTransactionsCountQueryVariables>;
export const GetTransactionRequestDocument = gql`
    query getTransactionRequest($id: ID!) {
  transactionRequest(id: $id) {
    id
    createdAt
    account {
      id
      name
      alias
      currency
      iban
    }
    wallet {
      id
      alias
      address
      network
      status
      linkedBy {
        id
      }
    }
    amount
    currency
    status
    type
    effectiveRate
    slippageTolerance
    estimatedAmount
    trxHash
  }
}
    `;

/**
 * __useGetTransactionRequestQuery__
 *
 * To run a query within a React component, call `useGetTransactionRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTransactionRequestQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionRequestQuery, GetTransactionRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionRequestQuery, GetTransactionRequestQueryVariables>(GetTransactionRequestDocument, options);
      }
export function useGetTransactionRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionRequestQuery, GetTransactionRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionRequestQuery, GetTransactionRequestQueryVariables>(GetTransactionRequestDocument, options);
        }
export function useGetTransactionRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransactionRequestQuery, GetTransactionRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionRequestQuery, GetTransactionRequestQueryVariables>(GetTransactionRequestDocument, options);
        }
export type GetTransactionRequestQueryHookResult = ReturnType<typeof useGetTransactionRequestQuery>;
export type GetTransactionRequestLazyQueryHookResult = ReturnType<typeof useGetTransactionRequestLazyQuery>;
export type GetTransactionRequestSuspenseQueryHookResult = ReturnType<typeof useGetTransactionRequestSuspenseQuery>;
export type GetTransactionRequestQueryResult = Apollo.QueryResult<GetTransactionRequestQuery, GetTransactionRequestQueryVariables>;
export const GetIframeUrlForCardNoDocument = gql`
    query getIframeUrlForCardNo {
  iframeUrlForCardNo {
    token
    url
  }
}
    `;

/**
 * __useGetIframeUrlForCardNoQuery__
 *
 * To run a query within a React component, call `useGetIframeUrlForCardNoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIframeUrlForCardNoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIframeUrlForCardNoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIframeUrlForCardNoQuery(baseOptions?: Apollo.QueryHookOptions<GetIframeUrlForCardNoQuery, GetIframeUrlForCardNoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIframeUrlForCardNoQuery, GetIframeUrlForCardNoQueryVariables>(GetIframeUrlForCardNoDocument, options);
      }
export function useGetIframeUrlForCardNoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIframeUrlForCardNoQuery, GetIframeUrlForCardNoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIframeUrlForCardNoQuery, GetIframeUrlForCardNoQueryVariables>(GetIframeUrlForCardNoDocument, options);
        }
export function useGetIframeUrlForCardNoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIframeUrlForCardNoQuery, GetIframeUrlForCardNoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIframeUrlForCardNoQuery, GetIframeUrlForCardNoQueryVariables>(GetIframeUrlForCardNoDocument, options);
        }
export type GetIframeUrlForCardNoQueryHookResult = ReturnType<typeof useGetIframeUrlForCardNoQuery>;
export type GetIframeUrlForCardNoLazyQueryHookResult = ReturnType<typeof useGetIframeUrlForCardNoLazyQuery>;
export type GetIframeUrlForCardNoSuspenseQueryHookResult = ReturnType<typeof useGetIframeUrlForCardNoSuspenseQuery>;
export type GetIframeUrlForCardNoQueryResult = Apollo.QueryResult<GetIframeUrlForCardNoQuery, GetIframeUrlForCardNoQueryVariables>;
export const IsCardTermsSignedDocument = gql`
    query isCardTermsSigned($contractId: ID!) {
  isProductTermsSignedOrPending(contractId: $contractId, productKey: "cards")
}
    `;

/**
 * __useIsCardTermsSignedQuery__
 *
 * To run a query within a React component, call `useIsCardTermsSignedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCardTermsSignedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCardTermsSignedQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useIsCardTermsSignedQuery(baseOptions: Apollo.QueryHookOptions<IsCardTermsSignedQuery, IsCardTermsSignedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsCardTermsSignedQuery, IsCardTermsSignedQueryVariables>(IsCardTermsSignedDocument, options);
      }
export function useIsCardTermsSignedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsCardTermsSignedQuery, IsCardTermsSignedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsCardTermsSignedQuery, IsCardTermsSignedQueryVariables>(IsCardTermsSignedDocument, options);
        }
export function useIsCardTermsSignedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsCardTermsSignedQuery, IsCardTermsSignedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsCardTermsSignedQuery, IsCardTermsSignedQueryVariables>(IsCardTermsSignedDocument, options);
        }
export type IsCardTermsSignedQueryHookResult = ReturnType<typeof useIsCardTermsSignedQuery>;
export type IsCardTermsSignedLazyQueryHookResult = ReturnType<typeof useIsCardTermsSignedLazyQuery>;
export type IsCardTermsSignedSuspenseQueryHookResult = ReturnType<typeof useIsCardTermsSignedSuspenseQuery>;
export type IsCardTermsSignedQueryResult = Apollo.QueryResult<IsCardTermsSignedQuery, IsCardTermsSignedQueryVariables>;
export const ContractTopUpTransactionsDocument = gql`
    query contractTopUpTransactions($contractId: ID!, $createdFrom: DateTime, $createdTo: DateTime) {
  contractTransactions(
    contractId: $contractId
    createdAtFrom: $createdFrom
    createdAtTo: $createdTo
    paymentRails: [cardTopUp]
    statuses: [completed, completedManually]
  ) {
    ... on CreditTransaction {
      id
      value
    }
  }
}
    `;

/**
 * __useContractTopUpTransactionsQuery__
 *
 * To run a query within a React component, call `useContractTopUpTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractTopUpTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractTopUpTransactionsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      createdFrom: // value for 'createdFrom'
 *      createdTo: // value for 'createdTo'
 *   },
 * });
 */
export function useContractTopUpTransactionsQuery(baseOptions: Apollo.QueryHookOptions<ContractTopUpTransactionsQuery, ContractTopUpTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractTopUpTransactionsQuery, ContractTopUpTransactionsQueryVariables>(ContractTopUpTransactionsDocument, options);
      }
export function useContractTopUpTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractTopUpTransactionsQuery, ContractTopUpTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractTopUpTransactionsQuery, ContractTopUpTransactionsQueryVariables>(ContractTopUpTransactionsDocument, options);
        }
export function useContractTopUpTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContractTopUpTransactionsQuery, ContractTopUpTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractTopUpTransactionsQuery, ContractTopUpTransactionsQueryVariables>(ContractTopUpTransactionsDocument, options);
        }
export type ContractTopUpTransactionsQueryHookResult = ReturnType<typeof useContractTopUpTransactionsQuery>;
export type ContractTopUpTransactionsLazyQueryHookResult = ReturnType<typeof useContractTopUpTransactionsLazyQuery>;
export type ContractTopUpTransactionsSuspenseQueryHookResult = ReturnType<typeof useContractTopUpTransactionsSuspenseQuery>;
export type ContractTopUpTransactionsQueryResult = Apollo.QueryResult<ContractTopUpTransactionsQuery, ContractTopUpTransactionsQueryVariables>;
export const OutboundPaymentCapabilitiesDocument = gql`
    query outboundPaymentCapabilities($accountId: ID!, $payoutCurrency: AllCurrencies!, $destinationCountry: Country!) {
  outboundPaymentCapabilities(
    accountId: $accountId
    payoutCurrency: $payoutCurrency
    destinationCountry: $destinationCountry
  )
}
    `;

/**
 * __useOutboundPaymentCapabilitiesQuery__
 *
 * To run a query within a React component, call `useOutboundPaymentCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutboundPaymentCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutboundPaymentCapabilitiesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      payoutCurrency: // value for 'payoutCurrency'
 *      destinationCountry: // value for 'destinationCountry'
 *   },
 * });
 */
export function useOutboundPaymentCapabilitiesQuery(baseOptions: Apollo.QueryHookOptions<OutboundPaymentCapabilitiesQuery, OutboundPaymentCapabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutboundPaymentCapabilitiesQuery, OutboundPaymentCapabilitiesQueryVariables>(OutboundPaymentCapabilitiesDocument, options);
      }
export function useOutboundPaymentCapabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutboundPaymentCapabilitiesQuery, OutboundPaymentCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutboundPaymentCapabilitiesQuery, OutboundPaymentCapabilitiesQueryVariables>(OutboundPaymentCapabilitiesDocument, options);
        }
export function useOutboundPaymentCapabilitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OutboundPaymentCapabilitiesQuery, OutboundPaymentCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OutboundPaymentCapabilitiesQuery, OutboundPaymentCapabilitiesQueryVariables>(OutboundPaymentCapabilitiesDocument, options);
        }
export type OutboundPaymentCapabilitiesQueryHookResult = ReturnType<typeof useOutboundPaymentCapabilitiesQuery>;
export type OutboundPaymentCapabilitiesLazyQueryHookResult = ReturnType<typeof useOutboundPaymentCapabilitiesLazyQuery>;
export type OutboundPaymentCapabilitiesSuspenseQueryHookResult = ReturnType<typeof useOutboundPaymentCapabilitiesSuspenseQuery>;
export type OutboundPaymentCapabilitiesQueryResult = Apollo.QueryResult<OutboundPaymentCapabilitiesQuery, OutboundPaymentCapabilitiesQueryVariables>;
export const NewFxQuotesDocument = gql`
    subscription newFXQuotes($contractId: ID!) {
  newFXQuote(contractId: $contractId) {
    id
    bid
    ask
    symbol
    quoteTime
  }
}
    `;

/**
 * __useNewFxQuotesSubscription__
 *
 * To run a query within a React component, call `useNewFxQuotesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewFxQuotesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewFxQuotesSubscription({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useNewFxQuotesSubscription(baseOptions: Apollo.SubscriptionHookOptions<NewFxQuotesSubscription, NewFxQuotesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewFxQuotesSubscription, NewFxQuotesSubscriptionVariables>(NewFxQuotesDocument, options);
      }
export type NewFxQuotesSubscriptionHookResult = ReturnType<typeof useNewFxQuotesSubscription>;
export type NewFxQuotesSubscriptionResult = Apollo.SubscriptionResult<NewFxQuotesSubscription>;
export const TwoFaMobileProgressDocument = gql`
    subscription twoFaMobileProgress($challengeId: String!) {
  twoFaMobileProgress(challengeId: $challengeId) {
    status
    challengeId
    code
  }
}
    `;

/**
 * __useTwoFaMobileProgressSubscription__
 *
 * To run a query within a React component, call `useTwoFaMobileProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTwoFaMobileProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTwoFaMobileProgressSubscription({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *   },
 * });
 */
export function useTwoFaMobileProgressSubscription(baseOptions: Apollo.SubscriptionHookOptions<TwoFaMobileProgressSubscription, TwoFaMobileProgressSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TwoFaMobileProgressSubscription, TwoFaMobileProgressSubscriptionVariables>(TwoFaMobileProgressDocument, options);
      }
export type TwoFaMobileProgressSubscriptionHookResult = ReturnType<typeof useTwoFaMobileProgressSubscription>;
export type TwoFaMobileProgressSubscriptionResult = Apollo.SubscriptionResult<TwoFaMobileProgressSubscription>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Action": [
      "AccountAction",
      "AddContractAuthorizedPersonRequestAction",
      "BatchPaymentActionType",
      "CardIssueRequestAction",
      "ContractAuthorizedPersonDeactivationAction",
      "ContractChangeAction",
      "ContractTerminationAction",
      "CryptoTransactionSigningAction",
      "DirectDebitAction",
      "DirectDebitBatchRequestActionType",
      "DirectDebitDisputeAction",
      "DirectDebitRevertRequestAction",
      "DocumentAction",
      "RefundPaymentRequestAction",
      "SpendingLimitRequestAction",
      "StandingOrderActionType",
      "TermsAndConditionsSigningAction",
      "TransactionAction",
      "TwoFAOperationActionLike",
      "UpdateSpendingLimitAction",
      "VibanNameMismatchAction",
      "WalletAction"
    ],
    "ActionInitiator": [
      "ApiUser",
      "Individual",
      "User"
    ],
    "ActivityLog": [
      "AccountCheckLog",
      "AccountLog",
      "ActionLog",
      "AgentLog",
      "ComplianceLog",
      "ContractLog",
      "DiffLog",
      "FeeGroupLog",
      "GenericLog",
      "KycStatusLog",
      "LedgerLog",
      "LedgerTransactionLog",
      "Note",
      "TransactionLog",
      "UnderMonitoringLog",
      "UserActionLog",
      "WithReasonLog"
    ],
    "ApprovalRequest": [
      "AccountClosureFundRemittanceApprovalRequest",
      "AccountManualBookingApprovalRequest",
      "CardAdjustmentTransactionRequestRequest",
      "FeeReversalRequest",
      "VoidTransactionRequest"
    ],
    "BaseAction": [
      "AccountAction",
      "AddContractAuthorizedPersonRequestAction",
      "BatchPaymentActionType",
      "CardIssueRequestAction",
      "ContractAuthorizedPersonDeactivationAction",
      "ContractChangeAction",
      "ContractTerminationAction",
      "CryptoTransactionSigningAction",
      "DirectDebitAction",
      "DirectDebitBatchRequestActionType",
      "DirectDebitDisputeAction",
      "DirectDebitRevertRequestAction",
      "DocumentAction",
      "RefundPaymentRequestAction",
      "SpendingLimitRequestAction",
      "StandingOrderActionType",
      "TermsAndConditionsSigningAction",
      "TransactionAction",
      "TwoFAOperationActionLike",
      "UpdateSpendingLimitAction",
      "VibanNameMismatchAction",
      "WalletAction"
    ],
    "BaseApprovalRequest": [
      "AccountClosureFundRemittanceApprovalRequest",
      "AccountManualBookingApprovalRequest",
      "CardAdjustmentTransactionRequestRequest",
      "FeeReversalRequest",
      "VoidTransactionRequest"
    ],
    "BaseLogInterface": [
      "AccountCheckLog",
      "AccountLog",
      "ActionLog",
      "AgentLog",
      "ComplianceLog",
      "ContractLog",
      "DiffLog",
      "FeeGroupLog",
      "GenericLog",
      "KycStatusLog",
      "LedgerLog",
      "LedgerTransactionLog",
      "Note",
      "TransactionLog",
      "UnderMonitoringLog",
      "UserActionLog",
      "WithReasonLog"
    ],
    "BaseTransaction": [
      "CreditTransaction",
      "DebitTransaction"
    ],
    "LegalEntityOrIndividual": [
      "Individual",
      "LegalEntity"
    ],
    "ProfileChangeAnswer": [
      "ContractProfileChangeAnswers",
      "ProfileChangeAnswers"
    ],
    "Transaction": [
      "CreditTransaction",
      "DebitTransaction"
    ],
    "UserOrIndividual": [
      "Individual",
      "User"
    ],
    "Viewer": [
      "ApiUser",
      "Individual",
      "User"
    ]
  }
};
      export default result;
    